/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  GeoJSONCoordinates: any;
  GeoJSONScalar: any;
  Highlight: any;
  ReferenceJSON: any;
  _int4: any;
  _varchar: any;
  bigint: any;
  geography: any;
  geometry: any;
  json: any;
  jsonb: any;
  smallint: any;
  timestamp: any;
  timestamptz: any;
  uuid: any;
};

export type AlternativeName = {
  __typename?: 'AlternativeName';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type Avatar = Node & {
  __typename?: 'Avatar';
  /** The ID of an object */
  id: Scalars['ID'];
  url?: Maybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type CrossrefReferences = Node & {
  __typename?: 'CrossrefReferences';
  csl_json?: Maybe<Scalars['ReferenceJSON']>;
  /** The ID of an object */
  id: Scalars['ID'];
};

/** A connection to a list of items. */
export type CrossrefReferencesConnection = {
  __typename?: 'CrossrefReferencesConnection';
  /** A total number of search results returned. */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CrossrefReferencesEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CrossrefReferencesEdge = {
  __typename?: 'CrossrefReferencesEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CrossrefReferences>;
};

export type DataSource = {
  __typename?: 'DataSource';
  icon_small?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_external?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  tooltip?: Maybe<Scalars['String']>;
};

export type Entry = Node & {
  __typename?: 'Entry';
  alternative_names?: Maybe<Array<Maybe<AlternativeName>>>;
  contributors?: Maybe<Array<Maybe<User>>>;
  created_by?: Maybe<User>;
  data_source?: Maybe<DataSource>;
  description?: Maybe<Scalars['String']>;
  entry_source?: Maybe<Scalars['Int']>;
  expert_source?: Maybe<User>;
  external_url?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  poll_type: Scalars['String'];
  region?: Maybe<Region>;
  secondary_source?: Maybe<Scalars['String']>;
  supervised_by?: Maybe<User>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  year_from?: Maybe<Scalars['Int']>;
  year_to?: Maybe<Scalars['Int']>;
};

/** A connection to a list of items. */
export type EntryConnection = {
  __typename?: 'EntryConnection';
  /** A total number of search results returned. */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EntryEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EntryEdge = {
  __typename?: 'EntryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Entry>;
};

export type EntrySearchHit = {
  __typename?: 'EntrySearchHit';
  alternative_names?: Maybe<Array<Maybe<AlternativeName>>>;
  contributors?: Maybe<Array<Maybe<User>>>;
  created_by?: Maybe<User>;
  data_source?: Maybe<DataSource>;
  description?: Maybe<Scalars['String']>;
  entry?: Maybe<Polls_Entity>;
  entry_source?: Maybe<Scalars['Int']>;
  expert_source?: Maybe<User>;
  external_url?: Maybe<Scalars['String']>;
  highlight: Scalars['Highlight'];
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  poll_type: Scalars['String'];
  region?: Maybe<Region>;
  secondary_source?: Maybe<Scalars['String']>;
  supervised_by?: Maybe<User>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  year_from?: Maybe<Scalars['Int']>;
  year_to?: Maybe<Scalars['Int']>;
};

export type EntrySearchResult = {
  __typename?: 'EntrySearchResult';
  hits?: Maybe<Array<EntrySearchHit>>;
  total: Scalars['Int'];
};

export type GeoJson = {
  __typename?: 'GeoJSON';
  coordinates: Scalars['GeoJSONCoordinates'];
  type: GeoJsonGeometryType;
};

export enum GeoJsonGeometryType {
  MultiPolygon = 'MultiPolygon',
  Polygon = 'Polygon'
}

export type GeoJsonInput = {
  coordinates: Scalars['GeoJSONCoordinates'];
  type: GeoJsonGeometryType;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** An object with an ID */
export type Node = {
  /** The id of the object. */
  id: Scalars['ID'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PollDiff = {
  __typename?: 'PollDiff';
  /** The list of deleted questions. */
  deleted_questions?: Maybe<Array<PollDiffQuestionWithPath>>;
  /** The list of new questions. */
  new_questions?: Maybe<Array<PollDiffQuestionWithPath>>;
  /** The current poll. */
  poll: PollDiffPoll;
  /** The previous poll. */
  prev_poll: PollDiffPoll;
  /** The list of updated questions. */
  updated_questions?: Maybe<Array<PollDiffUpdatedQuestion>>;
};

export type PollDiffPlainQuestion = {
  __typename?: 'PollDiffPlainQuestion';
  /** The description of the question. */
  description?: Maybe<Scalars['String']>;
  /** The ID of the question. */
  id: Scalars['Int'];
  /** The name of the question. */
  name: Scalars['String'];
};

export type PollDiffPoll = {
  __typename?: 'PollDiffPoll';
  /** The ID of the poll. */
  id: Scalars['Int'];
  /** The name of the poll. */
  name: Scalars['String'];
};

export type PollDiffQuestionPathSegment = {
  __typename?: 'PollDiffQuestionPathSegment';
  id: Scalars['Int'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type PollDiffQuestionWithPath = {
  __typename?: 'PollDiffQuestionWithPath';
  /** The description of the question. */
  description?: Maybe<Scalars['String']>;
  /** The ID of the question. */
  id: Scalars['Int'];
  /** The name of the question. */
  name: Scalars['String'];
  /** The path of the question in the poll. */
  path?: Maybe<Array<PollDiffQuestionPathSegment>>;
};

export type PollDiffUpdatedQuestion = {
  __typename?: 'PollDiffUpdatedQuestion';
  /** The description of the question. */
  description?: Maybe<Scalars['String']>;
  /** The ID of the question. */
  id: Scalars['Int'];
  /** The name of the question. */
  name: Scalars['String'];
  /** The path of the question in the poll. */
  path?: Maybe<Array<PollDiffQuestionPathSegment>>;
  previous: PollDiffPlainQuestion;
};

export type PollDraft = {
  __typename?: 'PollDraft';
  created_at: Scalars['String'];
  id: Scalars['ID'];
  payload: Scalars['Int'];
  updated_at?: Maybe<Scalars['String']>;
  user_id: Scalars['ID'];
};

export type QuestionSearchHit = {
  __typename?: 'QuestionSearchHit';
  description?: Maybe<Scalars['String']>;
  highlight: Scalars['Highlight'];
  id: Scalars['Int'];
  name: Scalars['String'];
  poll: QuestionSearchHitPoll;
  question?: Maybe<Polls_Question>;
};

export type QuestionSearchHitPoll = {
  __typename?: 'QuestionSearchHitPoll';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type QuestionSearchResult = {
  __typename?: 'QuestionSearchResult';
  hits?: Maybe<Array<QuestionSearchHit>>;
  total: Scalars['Int'];
};

export type References = Node & {
  __typename?: 'References';
  csl_json?: Maybe<Scalars['ReferenceJSON']>;
  highlight?: Maybe<Scalars['Highlight']>;
  /** The ID of an object */
  id: Scalars['ID'];
};

/** A connection to a list of items. */
export type ReferencesConnection = {
  __typename?: 'ReferencesConnection';
  /** A total number of search results returned. */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReferencesEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ReferencesEdge = {
  __typename?: 'ReferencesEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<References>;
};

export type Region = {
  __typename?: 'Region';
  description?: Maybe<Scalars['String']>;
  geometry?: Maybe<GeoJson>;
  id: Scalars['Int'];
  name: Scalars['String'];
  tags?: Maybe<Array<Maybe<Tag>>>;
};

/** A connection to a list of items. */
export type RegionConnection = {
  __typename?: 'RegionConnection';
  /** A total number of search results returned. */
  count: Scalars['Int'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RegionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RegionEdge = {
  __typename?: 'RegionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Region>;
};

export type RegionSearchHit = {
  __typename?: 'RegionSearchHit';
  description?: Maybe<Scalars['String']>;
  geometry?: Maybe<Scalars['GeoJSONScalar']>;
  highlight: Scalars['Highlight'];
  id: Scalars['Int'];
  name: Scalars['String'];
  tags?: Maybe<Array<Maybe<Tag>>>;
};

export type RegionSearchResult = {
  __typename?: 'RegionSearchResult';
  hits?: Maybe<Array<RegionSearchHit>>;
  total: Scalars['Int'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type UpgradeEntryPollSuccessResponse = {
  __typename?: 'UpgradeEntryPollSuccessResponse';
  /** The ID of the next entry. */
  next_entry_id: Scalars['Int'];
};

export type User = Node & {
  __typename?: 'User';
  /** The ID of an object */
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  username: Scalars['String'];
};

/** Boolean expression to compare columns of type "_int4". All fields are combined with logical 'AND'. */
export type _Int4_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_int4']>;
  _gt?: InputMaybe<Scalars['_int4']>;
  _gte?: InputMaybe<Scalars['_int4']>;
  _in?: InputMaybe<Array<Scalars['_int4']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_int4']>;
  _lte?: InputMaybe<Scalars['_int4']>;
  _neq?: InputMaybe<Scalars['_int4']>;
  _nin?: InputMaybe<Array<Scalars['_int4']>>;
};

/** Boolean expression to compare columns of type "_varchar". All fields are combined with logical 'AND'. */
export type _Varchar_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_varchar']>;
  _gt?: InputMaybe<Scalars['_varchar']>;
  _gte?: InputMaybe<Scalars['_varchar']>;
  _in?: InputMaybe<Array<Scalars['_varchar']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_varchar']>;
  _lte?: InputMaybe<Scalars['_varchar']>;
  _neq?: InputMaybe<Scalars['_varchar']>;
  _nin?: InputMaybe<Array<Scalars['_varchar']>>;
};

/** columns and relationships of "accounts_expert" */
export type Accounts_Expert = {
  __typename?: 'accounts_expert';
  approved: Scalars['Boolean'];
  confirmed_agreement: Scalars['Boolean'];
  editor_id?: Maybe<Scalars['Int']>;
  editor_type_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  entries_sourced: Array<Polls_Entity>;
  /** An aggregate relationship */
  entries_sourced_aggregate: Polls_Entity_Aggregate;
  /** An array relationship */
  entry_summary: Array<Accounts_Expertentriessummary>;
  /** An aggregate relationship */
  entry_summary_aggregate: Accounts_Expertentriessummary_Aggregate;
  id: Scalars['Int'];
  invisible: Scalars['Boolean'];
  /** An object relationship */
  managingeditor?: Maybe<Accounts_Managingeditor>;
  /** An object relationship */
  regionaleditor?: Maybe<Accounts_Regionaleditor>;
  /** An object relationship */
  user: Auth_User;
  user_id: Scalars['Int'];
};


/** columns and relationships of "accounts_expert" */
export type Accounts_ExpertEntries_SourcedArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Order_By>>;
  where?: InputMaybe<Polls_Entity_Bool_Exp>;
};


/** columns and relationships of "accounts_expert" */
export type Accounts_ExpertEntries_Sourced_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Order_By>>;
  where?: InputMaybe<Polls_Entity_Bool_Exp>;
};


/** columns and relationships of "accounts_expert" */
export type Accounts_ExpertEntry_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Expertentriessummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Expertentriessummary_Order_By>>;
  where?: InputMaybe<Accounts_Expertentriessummary_Bool_Exp>;
};


/** columns and relationships of "accounts_expert" */
export type Accounts_ExpertEntry_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Expertentriessummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Expertentriessummary_Order_By>>;
  where?: InputMaybe<Accounts_Expertentriessummary_Bool_Exp>;
};

/** aggregated selection of "accounts_expert" */
export type Accounts_Expert_Aggregate = {
  __typename?: 'accounts_expert_aggregate';
  aggregate?: Maybe<Accounts_Expert_Aggregate_Fields>;
  nodes: Array<Accounts_Expert>;
};

/** aggregate fields of "accounts_expert" */
export type Accounts_Expert_Aggregate_Fields = {
  __typename?: 'accounts_expert_aggregate_fields';
  avg?: Maybe<Accounts_Expert_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Accounts_Expert_Max_Fields>;
  min?: Maybe<Accounts_Expert_Min_Fields>;
  stddev?: Maybe<Accounts_Expert_Stddev_Fields>;
  stddev_pop?: Maybe<Accounts_Expert_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Accounts_Expert_Stddev_Samp_Fields>;
  sum?: Maybe<Accounts_Expert_Sum_Fields>;
  var_pop?: Maybe<Accounts_Expert_Var_Pop_Fields>;
  var_samp?: Maybe<Accounts_Expert_Var_Samp_Fields>;
  variance?: Maybe<Accounts_Expert_Variance_Fields>;
};


/** aggregate fields of "accounts_expert" */
export type Accounts_Expert_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Accounts_Expert_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Accounts_Expert_Avg_Fields = {
  __typename?: 'accounts_expert_avg_fields';
  editor_id?: Maybe<Scalars['Float']>;
  editor_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "accounts_expert". All fields are combined with a logical 'AND'. */
export type Accounts_Expert_Bool_Exp = {
  _and?: InputMaybe<Array<Accounts_Expert_Bool_Exp>>;
  _not?: InputMaybe<Accounts_Expert_Bool_Exp>;
  _or?: InputMaybe<Array<Accounts_Expert_Bool_Exp>>;
  approved?: InputMaybe<Boolean_Comparison_Exp>;
  confirmed_agreement?: InputMaybe<Boolean_Comparison_Exp>;
  editor_id?: InputMaybe<Int_Comparison_Exp>;
  editor_type_id?: InputMaybe<Int_Comparison_Exp>;
  entries_sourced?: InputMaybe<Polls_Entity_Bool_Exp>;
  entry_summary?: InputMaybe<Accounts_Expertentriessummary_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  invisible?: InputMaybe<Boolean_Comparison_Exp>;
  managingeditor?: InputMaybe<Accounts_Managingeditor_Bool_Exp>;
  regionaleditor?: InputMaybe<Accounts_Regionaleditor_Bool_Exp>;
  user?: InputMaybe<Auth_User_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "accounts_expert" */
export enum Accounts_Expert_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountsExpertPkey = 'accounts_expert_pkey',
  /** unique or primary key constraint on columns "user_id" */
  AccountsExpertUserIdKey = 'accounts_expert_user_id_key'
}

/** input type for incrementing numeric columns in table "accounts_expert" */
export type Accounts_Expert_Inc_Input = {
  editor_id?: InputMaybe<Scalars['Int']>;
  editor_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "accounts_expert" */
export type Accounts_Expert_Insert_Input = {
  approved?: InputMaybe<Scalars['Boolean']>;
  confirmed_agreement?: InputMaybe<Scalars['Boolean']>;
  editor_id?: InputMaybe<Scalars['Int']>;
  editor_type_id?: InputMaybe<Scalars['Int']>;
  entries_sourced?: InputMaybe<Polls_Entity_Arr_Rel_Insert_Input>;
  entry_summary?: InputMaybe<Accounts_Expertentriessummary_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  invisible?: InputMaybe<Scalars['Boolean']>;
  managingeditor?: InputMaybe<Accounts_Managingeditor_Obj_Rel_Insert_Input>;
  regionaleditor?: InputMaybe<Accounts_Regionaleditor_Obj_Rel_Insert_Input>;
  user?: InputMaybe<Auth_User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Accounts_Expert_Max_Fields = {
  __typename?: 'accounts_expert_max_fields';
  editor_id?: Maybe<Scalars['Int']>;
  editor_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Accounts_Expert_Min_Fields = {
  __typename?: 'accounts_expert_min_fields';
  editor_id?: Maybe<Scalars['Int']>;
  editor_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "accounts_expert" */
export type Accounts_Expert_Mutation_Response = {
  __typename?: 'accounts_expert_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Accounts_Expert>;
};

/** input type for inserting object relation for remote table "accounts_expert" */
export type Accounts_Expert_Obj_Rel_Insert_Input = {
  data: Accounts_Expert_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Accounts_Expert_On_Conflict>;
};

/** on_conflict condition type for table "accounts_expert" */
export type Accounts_Expert_On_Conflict = {
  constraint: Accounts_Expert_Constraint;
  update_columns?: Array<Accounts_Expert_Update_Column>;
  where?: InputMaybe<Accounts_Expert_Bool_Exp>;
};

/** Ordering options when selecting data from "accounts_expert". */
export type Accounts_Expert_Order_By = {
  approved?: InputMaybe<Order_By>;
  confirmed_agreement?: InputMaybe<Order_By>;
  editor_id?: InputMaybe<Order_By>;
  editor_type_id?: InputMaybe<Order_By>;
  entries_sourced_aggregate?: InputMaybe<Polls_Entity_Aggregate_Order_By>;
  entry_summary_aggregate?: InputMaybe<Accounts_Expertentriessummary_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  invisible?: InputMaybe<Order_By>;
  managingeditor?: InputMaybe<Accounts_Managingeditor_Order_By>;
  regionaleditor?: InputMaybe<Accounts_Regionaleditor_Order_By>;
  user?: InputMaybe<Auth_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: accounts_expert */
export type Accounts_Expert_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "accounts_expert" */
export enum Accounts_Expert_Select_Column {
  /** column name */
  Approved = 'approved',
  /** column name */
  ConfirmedAgreement = 'confirmed_agreement',
  /** column name */
  EditorId = 'editor_id',
  /** column name */
  EditorTypeId = 'editor_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Invisible = 'invisible',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "accounts_expert" */
export type Accounts_Expert_Set_Input = {
  approved?: InputMaybe<Scalars['Boolean']>;
  confirmed_agreement?: InputMaybe<Scalars['Boolean']>;
  editor_id?: InputMaybe<Scalars['Int']>;
  editor_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  invisible?: InputMaybe<Scalars['Boolean']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Accounts_Expert_Stddev_Fields = {
  __typename?: 'accounts_expert_stddev_fields';
  editor_id?: Maybe<Scalars['Float']>;
  editor_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Accounts_Expert_Stddev_Pop_Fields = {
  __typename?: 'accounts_expert_stddev_pop_fields';
  editor_id?: Maybe<Scalars['Float']>;
  editor_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Accounts_Expert_Stddev_Samp_Fields = {
  __typename?: 'accounts_expert_stddev_samp_fields';
  editor_id?: Maybe<Scalars['Float']>;
  editor_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Accounts_Expert_Sum_Fields = {
  __typename?: 'accounts_expert_sum_fields';
  editor_id?: Maybe<Scalars['Int']>;
  editor_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "accounts_expert" */
export enum Accounts_Expert_Update_Column {
  /** column name */
  Approved = 'approved',
  /** column name */
  ConfirmedAgreement = 'confirmed_agreement',
  /** column name */
  EditorId = 'editor_id',
  /** column name */
  EditorTypeId = 'editor_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Invisible = 'invisible',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type Accounts_Expert_Var_Pop_Fields = {
  __typename?: 'accounts_expert_var_pop_fields';
  editor_id?: Maybe<Scalars['Float']>;
  editor_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Accounts_Expert_Var_Samp_Fields = {
  __typename?: 'accounts_expert_var_samp_fields';
  editor_id?: Maybe<Scalars['Float']>;
  editor_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Accounts_Expert_Variance_Fields = {
  __typename?: 'accounts_expert_variance_fields';
  editor_id?: Maybe<Scalars['Float']>;
  editor_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "accounts_expertentriessummary" */
export type Accounts_Expertentriessummary = {
  __typename?: 'accounts_expertentriessummary';
  contributed_entries?: Maybe<Scalars['_int4']>;
  /** An object relationship */
  expert?: Maybe<Accounts_Expert>;
  expert_id?: Maybe<Scalars['Int']>;
  related_entries_count?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "accounts_expertentriessummary" */
export type Accounts_Expertentriessummary_Aggregate = {
  __typename?: 'accounts_expertentriessummary_aggregate';
  aggregate?: Maybe<Accounts_Expertentriessummary_Aggregate_Fields>;
  nodes: Array<Accounts_Expertentriessummary>;
};

/** aggregate fields of "accounts_expertentriessummary" */
export type Accounts_Expertentriessummary_Aggregate_Fields = {
  __typename?: 'accounts_expertentriessummary_aggregate_fields';
  avg?: Maybe<Accounts_Expertentriessummary_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Accounts_Expertentriessummary_Max_Fields>;
  min?: Maybe<Accounts_Expertentriessummary_Min_Fields>;
  stddev?: Maybe<Accounts_Expertentriessummary_Stddev_Fields>;
  stddev_pop?: Maybe<Accounts_Expertentriessummary_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Accounts_Expertentriessummary_Stddev_Samp_Fields>;
  sum?: Maybe<Accounts_Expertentriessummary_Sum_Fields>;
  var_pop?: Maybe<Accounts_Expertentriessummary_Var_Pop_Fields>;
  var_samp?: Maybe<Accounts_Expertentriessummary_Var_Samp_Fields>;
  variance?: Maybe<Accounts_Expertentriessummary_Variance_Fields>;
};


/** aggregate fields of "accounts_expertentriessummary" */
export type Accounts_Expertentriessummary_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Accounts_Expertentriessummary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "accounts_expertentriessummary" */
export type Accounts_Expertentriessummary_Aggregate_Order_By = {
  avg?: InputMaybe<Accounts_Expertentriessummary_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Accounts_Expertentriessummary_Max_Order_By>;
  min?: InputMaybe<Accounts_Expertentriessummary_Min_Order_By>;
  stddev?: InputMaybe<Accounts_Expertentriessummary_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Accounts_Expertentriessummary_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Accounts_Expertentriessummary_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Accounts_Expertentriessummary_Sum_Order_By>;
  var_pop?: InputMaybe<Accounts_Expertentriessummary_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Accounts_Expertentriessummary_Var_Samp_Order_By>;
  variance?: InputMaybe<Accounts_Expertentriessummary_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "accounts_expertentriessummary" */
export type Accounts_Expertentriessummary_Arr_Rel_Insert_Input = {
  data: Array<Accounts_Expertentriessummary_Insert_Input>;
};

/** aggregate avg on columns */
export type Accounts_Expertentriessummary_Avg_Fields = {
  __typename?: 'accounts_expertentriessummary_avg_fields';
  expert_id?: Maybe<Scalars['Float']>;
  related_entries_count?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "accounts_expertentriessummary" */
export type Accounts_Expertentriessummary_Avg_Order_By = {
  expert_id?: InputMaybe<Order_By>;
  related_entries_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "accounts_expertentriessummary". All fields are combined with a logical 'AND'. */
export type Accounts_Expertentriessummary_Bool_Exp = {
  _and?: InputMaybe<Array<Accounts_Expertentriessummary_Bool_Exp>>;
  _not?: InputMaybe<Accounts_Expertentriessummary_Bool_Exp>;
  _or?: InputMaybe<Array<Accounts_Expertentriessummary_Bool_Exp>>;
  contributed_entries?: InputMaybe<_Int4_Comparison_Exp>;
  expert?: InputMaybe<Accounts_Expert_Bool_Exp>;
  expert_id?: InputMaybe<Int_Comparison_Exp>;
  related_entries_count?: InputMaybe<Bigint_Comparison_Exp>;
};

/** input type for inserting data into table "accounts_expertentriessummary" */
export type Accounts_Expertentriessummary_Insert_Input = {
  contributed_entries?: InputMaybe<Scalars['_int4']>;
  expert?: InputMaybe<Accounts_Expert_Obj_Rel_Insert_Input>;
  expert_id?: InputMaybe<Scalars['Int']>;
  related_entries_count?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Accounts_Expertentriessummary_Max_Fields = {
  __typename?: 'accounts_expertentriessummary_max_fields';
  expert_id?: Maybe<Scalars['Int']>;
  related_entries_count?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "accounts_expertentriessummary" */
export type Accounts_Expertentriessummary_Max_Order_By = {
  expert_id?: InputMaybe<Order_By>;
  related_entries_count?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Accounts_Expertentriessummary_Min_Fields = {
  __typename?: 'accounts_expertentriessummary_min_fields';
  expert_id?: Maybe<Scalars['Int']>;
  related_entries_count?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "accounts_expertentriessummary" */
export type Accounts_Expertentriessummary_Min_Order_By = {
  expert_id?: InputMaybe<Order_By>;
  related_entries_count?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "accounts_expertentriessummary". */
export type Accounts_Expertentriessummary_Order_By = {
  contributed_entries?: InputMaybe<Order_By>;
  expert?: InputMaybe<Accounts_Expert_Order_By>;
  expert_id?: InputMaybe<Order_By>;
  related_entries_count?: InputMaybe<Order_By>;
};

/** select columns of table "accounts_expertentriessummary" */
export enum Accounts_Expertentriessummary_Select_Column {
  /** column name */
  ContributedEntries = 'contributed_entries',
  /** column name */
  ExpertId = 'expert_id',
  /** column name */
  RelatedEntriesCount = 'related_entries_count'
}

/** aggregate stddev on columns */
export type Accounts_Expertentriessummary_Stddev_Fields = {
  __typename?: 'accounts_expertentriessummary_stddev_fields';
  expert_id?: Maybe<Scalars['Float']>;
  related_entries_count?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "accounts_expertentriessummary" */
export type Accounts_Expertentriessummary_Stddev_Order_By = {
  expert_id?: InputMaybe<Order_By>;
  related_entries_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Accounts_Expertentriessummary_Stddev_Pop_Fields = {
  __typename?: 'accounts_expertentriessummary_stddev_pop_fields';
  expert_id?: Maybe<Scalars['Float']>;
  related_entries_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "accounts_expertentriessummary" */
export type Accounts_Expertentriessummary_Stddev_Pop_Order_By = {
  expert_id?: InputMaybe<Order_By>;
  related_entries_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Accounts_Expertentriessummary_Stddev_Samp_Fields = {
  __typename?: 'accounts_expertentriessummary_stddev_samp_fields';
  expert_id?: Maybe<Scalars['Float']>;
  related_entries_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "accounts_expertentriessummary" */
export type Accounts_Expertentriessummary_Stddev_Samp_Order_By = {
  expert_id?: InputMaybe<Order_By>;
  related_entries_count?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Accounts_Expertentriessummary_Sum_Fields = {
  __typename?: 'accounts_expertentriessummary_sum_fields';
  expert_id?: Maybe<Scalars['Int']>;
  related_entries_count?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "accounts_expertentriessummary" */
export type Accounts_Expertentriessummary_Sum_Order_By = {
  expert_id?: InputMaybe<Order_By>;
  related_entries_count?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Accounts_Expertentriessummary_Var_Pop_Fields = {
  __typename?: 'accounts_expertentriessummary_var_pop_fields';
  expert_id?: Maybe<Scalars['Float']>;
  related_entries_count?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "accounts_expertentriessummary" */
export type Accounts_Expertentriessummary_Var_Pop_Order_By = {
  expert_id?: InputMaybe<Order_By>;
  related_entries_count?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Accounts_Expertentriessummary_Var_Samp_Fields = {
  __typename?: 'accounts_expertentriessummary_var_samp_fields';
  expert_id?: Maybe<Scalars['Float']>;
  related_entries_count?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "accounts_expertentriessummary" */
export type Accounts_Expertentriessummary_Var_Samp_Order_By = {
  expert_id?: InputMaybe<Order_By>;
  related_entries_count?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Accounts_Expertentriessummary_Variance_Fields = {
  __typename?: 'accounts_expertentriessummary_variance_fields';
  expert_id?: Maybe<Scalars['Float']>;
  related_entries_count?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "accounts_expertentriessummary" */
export type Accounts_Expertentriessummary_Variance_Order_By = {
  expert_id?: InputMaybe<Order_By>;
  related_entries_count?: InputMaybe<Order_By>;
};

/** columns and relationships of "accounts_managingeditor" */
export type Accounts_Managingeditor = {
  __typename?: 'accounts_managingeditor';
  editor_email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object relationship */
  user: Auth_User;
  user_id: Scalars['Int'];
};

/** aggregated selection of "accounts_managingeditor" */
export type Accounts_Managingeditor_Aggregate = {
  __typename?: 'accounts_managingeditor_aggregate';
  aggregate?: Maybe<Accounts_Managingeditor_Aggregate_Fields>;
  nodes: Array<Accounts_Managingeditor>;
};

/** aggregate fields of "accounts_managingeditor" */
export type Accounts_Managingeditor_Aggregate_Fields = {
  __typename?: 'accounts_managingeditor_aggregate_fields';
  avg?: Maybe<Accounts_Managingeditor_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Accounts_Managingeditor_Max_Fields>;
  min?: Maybe<Accounts_Managingeditor_Min_Fields>;
  stddev?: Maybe<Accounts_Managingeditor_Stddev_Fields>;
  stddev_pop?: Maybe<Accounts_Managingeditor_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Accounts_Managingeditor_Stddev_Samp_Fields>;
  sum?: Maybe<Accounts_Managingeditor_Sum_Fields>;
  var_pop?: Maybe<Accounts_Managingeditor_Var_Pop_Fields>;
  var_samp?: Maybe<Accounts_Managingeditor_Var_Samp_Fields>;
  variance?: Maybe<Accounts_Managingeditor_Variance_Fields>;
};


/** aggregate fields of "accounts_managingeditor" */
export type Accounts_Managingeditor_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Accounts_Managingeditor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Accounts_Managingeditor_Avg_Fields = {
  __typename?: 'accounts_managingeditor_avg_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "accounts_managingeditor". All fields are combined with a logical 'AND'. */
export type Accounts_Managingeditor_Bool_Exp = {
  _and?: InputMaybe<Array<Accounts_Managingeditor_Bool_Exp>>;
  _not?: InputMaybe<Accounts_Managingeditor_Bool_Exp>;
  _or?: InputMaybe<Array<Accounts_Managingeditor_Bool_Exp>>;
  editor_email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<Auth_User_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "accounts_managingeditor" */
export enum Accounts_Managingeditor_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountsManagingeditorPkey = 'accounts_managingeditor_pkey',
  /** unique or primary key constraint on columns "user_id" */
  AccountsManagingeditorUserIdKey = 'accounts_managingeditor_user_id_key'
}

/** input type for incrementing numeric columns in table "accounts_managingeditor" */
export type Accounts_Managingeditor_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "accounts_managingeditor" */
export type Accounts_Managingeditor_Insert_Input = {
  editor_email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<Auth_User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Accounts_Managingeditor_Max_Fields = {
  __typename?: 'accounts_managingeditor_max_fields';
  editor_email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Accounts_Managingeditor_Min_Fields = {
  __typename?: 'accounts_managingeditor_min_fields';
  editor_email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "accounts_managingeditor" */
export type Accounts_Managingeditor_Mutation_Response = {
  __typename?: 'accounts_managingeditor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Accounts_Managingeditor>;
};

/** input type for inserting object relation for remote table "accounts_managingeditor" */
export type Accounts_Managingeditor_Obj_Rel_Insert_Input = {
  data: Accounts_Managingeditor_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Accounts_Managingeditor_On_Conflict>;
};

/** on_conflict condition type for table "accounts_managingeditor" */
export type Accounts_Managingeditor_On_Conflict = {
  constraint: Accounts_Managingeditor_Constraint;
  update_columns?: Array<Accounts_Managingeditor_Update_Column>;
  where?: InputMaybe<Accounts_Managingeditor_Bool_Exp>;
};

/** Ordering options when selecting data from "accounts_managingeditor". */
export type Accounts_Managingeditor_Order_By = {
  editor_email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user?: InputMaybe<Auth_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: accounts_managingeditor */
export type Accounts_Managingeditor_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "accounts_managingeditor" */
export enum Accounts_Managingeditor_Select_Column {
  /** column name */
  EditorEmail = 'editor_email',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "accounts_managingeditor" */
export type Accounts_Managingeditor_Set_Input = {
  editor_email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Accounts_Managingeditor_Stddev_Fields = {
  __typename?: 'accounts_managingeditor_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Accounts_Managingeditor_Stddev_Pop_Fields = {
  __typename?: 'accounts_managingeditor_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Accounts_Managingeditor_Stddev_Samp_Fields = {
  __typename?: 'accounts_managingeditor_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Accounts_Managingeditor_Sum_Fields = {
  __typename?: 'accounts_managingeditor_sum_fields';
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "accounts_managingeditor" */
export enum Accounts_Managingeditor_Update_Column {
  /** column name */
  EditorEmail = 'editor_email',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type Accounts_Managingeditor_Var_Pop_Fields = {
  __typename?: 'accounts_managingeditor_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Accounts_Managingeditor_Var_Samp_Fields = {
  __typename?: 'accounts_managingeditor_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Accounts_Managingeditor_Variance_Fields = {
  __typename?: 'accounts_managingeditor_variance_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "accounts_profile" */
export type Accounts_Profile = {
  __typename?: 'accounts_profile';
  approved_attachments_conditions: Scalars['Boolean'];
  area_of_research?: Maybe<Scalars['String']>;
  biography?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  email_verified?: Maybe<Scalars['Boolean']>;
  graduation?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image?: Maybe<Scalars['String']>;
  institution?: Maybe<Scalars['String']>;
  interests?: Maybe<Scalars['_varchar']>;
  language: Scalars['String'];
  location?: Maybe<Scalars['String']>;
  occupation?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  type: Scalars['smallint'];
  /** An object relationship */
  user: Auth_User;
  user_id: Scalars['Int'];
  websites?: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "accounts_profile" */
export type Accounts_ProfileWebsitesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "accounts_profile" */
export type Accounts_Profile_Aggregate = {
  __typename?: 'accounts_profile_aggregate';
  aggregate?: Maybe<Accounts_Profile_Aggregate_Fields>;
  nodes: Array<Accounts_Profile>;
};

/** aggregate fields of "accounts_profile" */
export type Accounts_Profile_Aggregate_Fields = {
  __typename?: 'accounts_profile_aggregate_fields';
  avg?: Maybe<Accounts_Profile_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Accounts_Profile_Max_Fields>;
  min?: Maybe<Accounts_Profile_Min_Fields>;
  stddev?: Maybe<Accounts_Profile_Stddev_Fields>;
  stddev_pop?: Maybe<Accounts_Profile_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Accounts_Profile_Stddev_Samp_Fields>;
  sum?: Maybe<Accounts_Profile_Sum_Fields>;
  var_pop?: Maybe<Accounts_Profile_Var_Pop_Fields>;
  var_samp?: Maybe<Accounts_Profile_Var_Samp_Fields>;
  variance?: Maybe<Accounts_Profile_Variance_Fields>;
};


/** aggregate fields of "accounts_profile" */
export type Accounts_Profile_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Accounts_Profile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Accounts_Profile_Append_Input = {
  websites?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Accounts_Profile_Avg_Fields = {
  __typename?: 'accounts_profile_avg_fields';
  id?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "accounts_profile". All fields are combined with a logical 'AND'. */
export type Accounts_Profile_Bool_Exp = {
  _and?: InputMaybe<Array<Accounts_Profile_Bool_Exp>>;
  _not?: InputMaybe<Accounts_Profile_Bool_Exp>;
  _or?: InputMaybe<Array<Accounts_Profile_Bool_Exp>>;
  approved_attachments_conditions?: InputMaybe<Boolean_Comparison_Exp>;
  area_of_research?: InputMaybe<String_Comparison_Exp>;
  biography?: InputMaybe<String_Comparison_Exp>;
  department?: InputMaybe<String_Comparison_Exp>;
  email_verified?: InputMaybe<Boolean_Comparison_Exp>;
  graduation?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image?: InputMaybe<String_Comparison_Exp>;
  institution?: InputMaybe<String_Comparison_Exp>;
  interests?: InputMaybe<_Varchar_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  occupation?: InputMaybe<String_Comparison_Exp>;
  position?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Smallint_Comparison_Exp>;
  user?: InputMaybe<Auth_User_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  websites?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "accounts_profile" */
export enum Accounts_Profile_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountsProfilePkey = 'accounts_profile_pkey',
  /** unique or primary key constraint on columns "user_id" */
  AccountsProfileUserIdKey = 'accounts_profile_user_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Accounts_Profile_Delete_At_Path_Input = {
  websites?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Accounts_Profile_Delete_Elem_Input = {
  websites?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Accounts_Profile_Delete_Key_Input = {
  websites?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "accounts_profile" */
export type Accounts_Profile_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['smallint']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "accounts_profile" */
export type Accounts_Profile_Insert_Input = {
  approved_attachments_conditions?: InputMaybe<Scalars['Boolean']>;
  area_of_research?: InputMaybe<Scalars['String']>;
  biography?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  email_verified?: InputMaybe<Scalars['Boolean']>;
  graduation?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  institution?: InputMaybe<Scalars['String']>;
  interests?: InputMaybe<Scalars['_varchar']>;
  language?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  occupation?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['smallint']>;
  user?: InputMaybe<Auth_User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
  websites?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type Accounts_Profile_Max_Fields = {
  __typename?: 'accounts_profile_max_fields';
  area_of_research?: Maybe<Scalars['String']>;
  biography?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  graduation?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  institution?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  occupation?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['smallint']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Accounts_Profile_Min_Fields = {
  __typename?: 'accounts_profile_min_fields';
  area_of_research?: Maybe<Scalars['String']>;
  biography?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  graduation?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  institution?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  occupation?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['smallint']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "accounts_profile" */
export type Accounts_Profile_Mutation_Response = {
  __typename?: 'accounts_profile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Accounts_Profile>;
};

/** input type for inserting object relation for remote table "accounts_profile" */
export type Accounts_Profile_Obj_Rel_Insert_Input = {
  data: Accounts_Profile_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Accounts_Profile_On_Conflict>;
};

/** on_conflict condition type for table "accounts_profile" */
export type Accounts_Profile_On_Conflict = {
  constraint: Accounts_Profile_Constraint;
  update_columns?: Array<Accounts_Profile_Update_Column>;
  where?: InputMaybe<Accounts_Profile_Bool_Exp>;
};

/** Ordering options when selecting data from "accounts_profile". */
export type Accounts_Profile_Order_By = {
  approved_attachments_conditions?: InputMaybe<Order_By>;
  area_of_research?: InputMaybe<Order_By>;
  biography?: InputMaybe<Order_By>;
  department?: InputMaybe<Order_By>;
  email_verified?: InputMaybe<Order_By>;
  graduation?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  institution?: InputMaybe<Order_By>;
  interests?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  occupation?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Auth_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
  websites?: InputMaybe<Order_By>;
};

/** primary key columns input for table: accounts_profile */
export type Accounts_Profile_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Accounts_Profile_Prepend_Input = {
  websites?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "accounts_profile" */
export enum Accounts_Profile_Select_Column {
  /** column name */
  ApprovedAttachmentsConditions = 'approved_attachments_conditions',
  /** column name */
  AreaOfResearch = 'area_of_research',
  /** column name */
  Biography = 'biography',
  /** column name */
  Department = 'department',
  /** column name */
  EmailVerified = 'email_verified',
  /** column name */
  Graduation = 'graduation',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Institution = 'institution',
  /** column name */
  Interests = 'interests',
  /** column name */
  Language = 'language',
  /** column name */
  Location = 'location',
  /** column name */
  Occupation = 'occupation',
  /** column name */
  Position = 'position',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Websites = 'websites'
}

/** input type for updating data in table "accounts_profile" */
export type Accounts_Profile_Set_Input = {
  approved_attachments_conditions?: InputMaybe<Scalars['Boolean']>;
  area_of_research?: InputMaybe<Scalars['String']>;
  biography?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  email_verified?: InputMaybe<Scalars['Boolean']>;
  graduation?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  institution?: InputMaybe<Scalars['String']>;
  interests?: InputMaybe<Scalars['_varchar']>;
  language?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  occupation?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['smallint']>;
  user_id?: InputMaybe<Scalars['Int']>;
  websites?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type Accounts_Profile_Stddev_Fields = {
  __typename?: 'accounts_profile_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Accounts_Profile_Stddev_Pop_Fields = {
  __typename?: 'accounts_profile_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Accounts_Profile_Stddev_Samp_Fields = {
  __typename?: 'accounts_profile_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Accounts_Profile_Sum_Fields = {
  __typename?: 'accounts_profile_sum_fields';
  id?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['smallint']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "accounts_profile" */
export enum Accounts_Profile_Update_Column {
  /** column name */
  ApprovedAttachmentsConditions = 'approved_attachments_conditions',
  /** column name */
  AreaOfResearch = 'area_of_research',
  /** column name */
  Biography = 'biography',
  /** column name */
  Department = 'department',
  /** column name */
  EmailVerified = 'email_verified',
  /** column name */
  Graduation = 'graduation',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Institution = 'institution',
  /** column name */
  Interests = 'interests',
  /** column name */
  Language = 'language',
  /** column name */
  Location = 'location',
  /** column name */
  Occupation = 'occupation',
  /** column name */
  Position = 'position',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Websites = 'websites'
}

/** aggregate var_pop on columns */
export type Accounts_Profile_Var_Pop_Fields = {
  __typename?: 'accounts_profile_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Accounts_Profile_Var_Samp_Fields = {
  __typename?: 'accounts_profile_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Accounts_Profile_Variance_Fields = {
  __typename?: 'accounts_profile_variance_fields';
  id?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "accounts_regionaleditor" */
export type Accounts_Regionaleditor = {
  __typename?: 'accounts_regionaleditor';
  editor_email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_external: Scalars['Boolean'];
  /** An object relationship */
  region: Gis_Regions_Gis_Region;
  region_id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  /** An object relationship */
  user: Auth_User;
  user_id: Scalars['Int'];
};

/** aggregated selection of "accounts_regionaleditor" */
export type Accounts_Regionaleditor_Aggregate = {
  __typename?: 'accounts_regionaleditor_aggregate';
  aggregate?: Maybe<Accounts_Regionaleditor_Aggregate_Fields>;
  nodes: Array<Accounts_Regionaleditor>;
};

/** aggregate fields of "accounts_regionaleditor" */
export type Accounts_Regionaleditor_Aggregate_Fields = {
  __typename?: 'accounts_regionaleditor_aggregate_fields';
  avg?: Maybe<Accounts_Regionaleditor_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Accounts_Regionaleditor_Max_Fields>;
  min?: Maybe<Accounts_Regionaleditor_Min_Fields>;
  stddev?: Maybe<Accounts_Regionaleditor_Stddev_Fields>;
  stddev_pop?: Maybe<Accounts_Regionaleditor_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Accounts_Regionaleditor_Stddev_Samp_Fields>;
  sum?: Maybe<Accounts_Regionaleditor_Sum_Fields>;
  var_pop?: Maybe<Accounts_Regionaleditor_Var_Pop_Fields>;
  var_samp?: Maybe<Accounts_Regionaleditor_Var_Samp_Fields>;
  variance?: Maybe<Accounts_Regionaleditor_Variance_Fields>;
};


/** aggregate fields of "accounts_regionaleditor" */
export type Accounts_Regionaleditor_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Accounts_Regionaleditor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Accounts_Regionaleditor_Avg_Fields = {
  __typename?: 'accounts_regionaleditor_avg_fields';
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "accounts_regionaleditor". All fields are combined with a logical 'AND'. */
export type Accounts_Regionaleditor_Bool_Exp = {
  _and?: InputMaybe<Array<Accounts_Regionaleditor_Bool_Exp>>;
  _not?: InputMaybe<Accounts_Regionaleditor_Bool_Exp>;
  _or?: InputMaybe<Array<Accounts_Regionaleditor_Bool_Exp>>;
  editor_email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_external?: InputMaybe<Boolean_Comparison_Exp>;
  region?: InputMaybe<Gis_Regions_Gis_Region_Bool_Exp>;
  region_id?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Auth_User_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "accounts_regionaleditor" */
export enum Accounts_Regionaleditor_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountsRegionaleditorPkey = 'accounts_regionaleditor_pkey',
  /** unique or primary key constraint on columns "user_id" */
  AccountsRegionaleditorUserIdKey = 'accounts_regionaleditor_user_id_key'
}

/** input type for incrementing numeric columns in table "accounts_regionaleditor" */
export type Accounts_Regionaleditor_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "accounts_regionaleditor" */
export type Accounts_Regionaleditor_Insert_Input = {
  editor_email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_external?: InputMaybe<Scalars['Boolean']>;
  region?: InputMaybe<Gis_Regions_Gis_Region_Obj_Rel_Insert_Input>;
  region_id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Auth_User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Accounts_Regionaleditor_Max_Fields = {
  __typename?: 'accounts_regionaleditor_max_fields';
  editor_email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  region_id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Accounts_Regionaleditor_Min_Fields = {
  __typename?: 'accounts_regionaleditor_min_fields';
  editor_email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  region_id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "accounts_regionaleditor" */
export type Accounts_Regionaleditor_Mutation_Response = {
  __typename?: 'accounts_regionaleditor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Accounts_Regionaleditor>;
};

/** input type for inserting object relation for remote table "accounts_regionaleditor" */
export type Accounts_Regionaleditor_Obj_Rel_Insert_Input = {
  data: Accounts_Regionaleditor_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Accounts_Regionaleditor_On_Conflict>;
};

/** on_conflict condition type for table "accounts_regionaleditor" */
export type Accounts_Regionaleditor_On_Conflict = {
  constraint: Accounts_Regionaleditor_Constraint;
  update_columns?: Array<Accounts_Regionaleditor_Update_Column>;
  where?: InputMaybe<Accounts_Regionaleditor_Bool_Exp>;
};

/** Ordering options when selecting data from "accounts_regionaleditor". */
export type Accounts_Regionaleditor_Order_By = {
  editor_email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_external?: InputMaybe<Order_By>;
  region?: InputMaybe<Gis_Regions_Gis_Region_Order_By>;
  region_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  user?: InputMaybe<Auth_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: accounts_regionaleditor */
export type Accounts_Regionaleditor_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "accounts_regionaleditor" */
export enum Accounts_Regionaleditor_Select_Column {
  /** column name */
  EditorEmail = 'editor_email',
  /** column name */
  Id = 'id',
  /** column name */
  IsExternal = 'is_external',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Title = 'title',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "accounts_regionaleditor" */
export type Accounts_Regionaleditor_Set_Input = {
  editor_email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_external?: InputMaybe<Scalars['Boolean']>;
  region_id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Accounts_Regionaleditor_Stddev_Fields = {
  __typename?: 'accounts_regionaleditor_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Accounts_Regionaleditor_Stddev_Pop_Fields = {
  __typename?: 'accounts_regionaleditor_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Accounts_Regionaleditor_Stddev_Samp_Fields = {
  __typename?: 'accounts_regionaleditor_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Accounts_Regionaleditor_Sum_Fields = {
  __typename?: 'accounts_regionaleditor_sum_fields';
  id?: Maybe<Scalars['Int']>;
  region_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "accounts_regionaleditor" */
export enum Accounts_Regionaleditor_Update_Column {
  /** column name */
  EditorEmail = 'editor_email',
  /** column name */
  Id = 'id',
  /** column name */
  IsExternal = 'is_external',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Title = 'title',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type Accounts_Regionaleditor_Var_Pop_Fields = {
  __typename?: 'accounts_regionaleditor_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Accounts_Regionaleditor_Var_Samp_Fields = {
  __typename?: 'accounts_regionaleditor_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Accounts_Regionaleditor_Variance_Fields = {
  __typename?: 'accounts_regionaleditor_variance_fields';
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "accounts_regionaleditorcategory" */
export type Accounts_Regionaleditorcategory = {
  __typename?: 'accounts_regionaleditorcategory';
  id: Scalars['Int'];
  order: Scalars['Int'];
  /** An array relationship */
  regional_editors: Array<Accounts_Regionaleditorcategory_Editors>;
  /** An aggregate relationship */
  regional_editors_aggregate: Accounts_Regionaleditorcategory_Editors_Aggregate;
  title?: Maybe<Scalars['String']>;
  title_en?: Maybe<Scalars['String']>;
  title_es?: Maybe<Scalars['String']>;
  title_fr?: Maybe<Scalars['String']>;
  title_ja?: Maybe<Scalars['String']>;
  title_zh_hans?: Maybe<Scalars['String']>;
  title_zh_hant?: Maybe<Scalars['String']>;
};


/** columns and relationships of "accounts_regionaleditorcategory" */
export type Accounts_RegionaleditorcategoryRegional_EditorsArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Regionaleditorcategory_Editors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Regionaleditorcategory_Editors_Order_By>>;
  where?: InputMaybe<Accounts_Regionaleditorcategory_Editors_Bool_Exp>;
};


/** columns and relationships of "accounts_regionaleditorcategory" */
export type Accounts_RegionaleditorcategoryRegional_Editors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Regionaleditorcategory_Editors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Regionaleditorcategory_Editors_Order_By>>;
  where?: InputMaybe<Accounts_Regionaleditorcategory_Editors_Bool_Exp>;
};

/** aggregated selection of "accounts_regionaleditorcategory" */
export type Accounts_Regionaleditorcategory_Aggregate = {
  __typename?: 'accounts_regionaleditorcategory_aggregate';
  aggregate?: Maybe<Accounts_Regionaleditorcategory_Aggregate_Fields>;
  nodes: Array<Accounts_Regionaleditorcategory>;
};

/** aggregate fields of "accounts_regionaleditorcategory" */
export type Accounts_Regionaleditorcategory_Aggregate_Fields = {
  __typename?: 'accounts_regionaleditorcategory_aggregate_fields';
  avg?: Maybe<Accounts_Regionaleditorcategory_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Accounts_Regionaleditorcategory_Max_Fields>;
  min?: Maybe<Accounts_Regionaleditorcategory_Min_Fields>;
  stddev?: Maybe<Accounts_Regionaleditorcategory_Stddev_Fields>;
  stddev_pop?: Maybe<Accounts_Regionaleditorcategory_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Accounts_Regionaleditorcategory_Stddev_Samp_Fields>;
  sum?: Maybe<Accounts_Regionaleditorcategory_Sum_Fields>;
  var_pop?: Maybe<Accounts_Regionaleditorcategory_Var_Pop_Fields>;
  var_samp?: Maybe<Accounts_Regionaleditorcategory_Var_Samp_Fields>;
  variance?: Maybe<Accounts_Regionaleditorcategory_Variance_Fields>;
};


/** aggregate fields of "accounts_regionaleditorcategory" */
export type Accounts_Regionaleditorcategory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Accounts_Regionaleditorcategory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Accounts_Regionaleditorcategory_Avg_Fields = {
  __typename?: 'accounts_regionaleditorcategory_avg_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "accounts_regionaleditorcategory". All fields are combined with a logical 'AND'. */
export type Accounts_Regionaleditorcategory_Bool_Exp = {
  _and?: InputMaybe<Array<Accounts_Regionaleditorcategory_Bool_Exp>>;
  _not?: InputMaybe<Accounts_Regionaleditorcategory_Bool_Exp>;
  _or?: InputMaybe<Array<Accounts_Regionaleditorcategory_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  regional_editors?: InputMaybe<Accounts_Regionaleditorcategory_Editors_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  title_en?: InputMaybe<String_Comparison_Exp>;
  title_es?: InputMaybe<String_Comparison_Exp>;
  title_fr?: InputMaybe<String_Comparison_Exp>;
  title_ja?: InputMaybe<String_Comparison_Exp>;
  title_zh_hans?: InputMaybe<String_Comparison_Exp>;
  title_zh_hant?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "accounts_regionaleditorcategory" */
export enum Accounts_Regionaleditorcategory_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountsRegionaleditorcategoryPkey = 'accounts_regionaleditorcategory_pkey'
}

/** columns and relationships of "accounts_regionaleditorcategory_editors" */
export type Accounts_Regionaleditorcategory_Editors = {
  __typename?: 'accounts_regionaleditorcategory_editors';
  /** An object relationship */
  category: Accounts_Regionaleditorcategory;
  id: Scalars['Int'];
  /** An object relationship */
  regional_editor: Accounts_Regionaleditor;
  regionaleditor_id: Scalars['Int'];
  regionaleditorcategory_id: Scalars['Int'];
  sort_value: Scalars['Int'];
};

/** aggregated selection of "accounts_regionaleditorcategory_editors" */
export type Accounts_Regionaleditorcategory_Editors_Aggregate = {
  __typename?: 'accounts_regionaleditorcategory_editors_aggregate';
  aggregate?: Maybe<Accounts_Regionaleditorcategory_Editors_Aggregate_Fields>;
  nodes: Array<Accounts_Regionaleditorcategory_Editors>;
};

/** aggregate fields of "accounts_regionaleditorcategory_editors" */
export type Accounts_Regionaleditorcategory_Editors_Aggregate_Fields = {
  __typename?: 'accounts_regionaleditorcategory_editors_aggregate_fields';
  avg?: Maybe<Accounts_Regionaleditorcategory_Editors_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Accounts_Regionaleditorcategory_Editors_Max_Fields>;
  min?: Maybe<Accounts_Regionaleditorcategory_Editors_Min_Fields>;
  stddev?: Maybe<Accounts_Regionaleditorcategory_Editors_Stddev_Fields>;
  stddev_pop?: Maybe<Accounts_Regionaleditorcategory_Editors_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Accounts_Regionaleditorcategory_Editors_Stddev_Samp_Fields>;
  sum?: Maybe<Accounts_Regionaleditorcategory_Editors_Sum_Fields>;
  var_pop?: Maybe<Accounts_Regionaleditorcategory_Editors_Var_Pop_Fields>;
  var_samp?: Maybe<Accounts_Regionaleditorcategory_Editors_Var_Samp_Fields>;
  variance?: Maybe<Accounts_Regionaleditorcategory_Editors_Variance_Fields>;
};


/** aggregate fields of "accounts_regionaleditorcategory_editors" */
export type Accounts_Regionaleditorcategory_Editors_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Accounts_Regionaleditorcategory_Editors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "accounts_regionaleditorcategory_editors" */
export type Accounts_Regionaleditorcategory_Editors_Aggregate_Order_By = {
  avg?: InputMaybe<Accounts_Regionaleditorcategory_Editors_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Accounts_Regionaleditorcategory_Editors_Max_Order_By>;
  min?: InputMaybe<Accounts_Regionaleditorcategory_Editors_Min_Order_By>;
  stddev?: InputMaybe<Accounts_Regionaleditorcategory_Editors_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Accounts_Regionaleditorcategory_Editors_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Accounts_Regionaleditorcategory_Editors_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Accounts_Regionaleditorcategory_Editors_Sum_Order_By>;
  var_pop?: InputMaybe<Accounts_Regionaleditorcategory_Editors_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Accounts_Regionaleditorcategory_Editors_Var_Samp_Order_By>;
  variance?: InputMaybe<Accounts_Regionaleditorcategory_Editors_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "accounts_regionaleditorcategory_editors" */
export type Accounts_Regionaleditorcategory_Editors_Arr_Rel_Insert_Input = {
  data: Array<Accounts_Regionaleditorcategory_Editors_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Accounts_Regionaleditorcategory_Editors_On_Conflict>;
};

/** aggregate avg on columns */
export type Accounts_Regionaleditorcategory_Editors_Avg_Fields = {
  __typename?: 'accounts_regionaleditorcategory_editors_avg_fields';
  id?: Maybe<Scalars['Float']>;
  regionaleditor_id?: Maybe<Scalars['Float']>;
  regionaleditorcategory_id?: Maybe<Scalars['Float']>;
  sort_value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "accounts_regionaleditorcategory_editors" */
export type Accounts_Regionaleditorcategory_Editors_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  regionaleditor_id?: InputMaybe<Order_By>;
  regionaleditorcategory_id?: InputMaybe<Order_By>;
  sort_value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "accounts_regionaleditorcategory_editors". All fields are combined with a logical 'AND'. */
export type Accounts_Regionaleditorcategory_Editors_Bool_Exp = {
  _and?: InputMaybe<Array<Accounts_Regionaleditorcategory_Editors_Bool_Exp>>;
  _not?: InputMaybe<Accounts_Regionaleditorcategory_Editors_Bool_Exp>;
  _or?: InputMaybe<Array<Accounts_Regionaleditorcategory_Editors_Bool_Exp>>;
  category?: InputMaybe<Accounts_Regionaleditorcategory_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  regional_editor?: InputMaybe<Accounts_Regionaleditor_Bool_Exp>;
  regionaleditor_id?: InputMaybe<Int_Comparison_Exp>;
  regionaleditorcategory_id?: InputMaybe<Int_Comparison_Exp>;
  sort_value?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "accounts_regionaleditorcategory_editors" */
export enum Accounts_Regionaleditorcategory_Editors_Constraint {
  /** unique or primary key constraint on columns "regionaleditorcategory_id", "regionaleditor_id" */
  AccountsRegionaleditorcategoRegionaleditorcategoryIdRegKey = 'accounts_regionaleditorcatego_regionaleditorcategory_id_reg_key',
  /** unique or primary key constraint on columns "id" */
  AccountsRegionaleditorcategoryEditorsPkey = 'accounts_regionaleditorcategory_editors_pkey'
}

/** input type for incrementing numeric columns in table "accounts_regionaleditorcategory_editors" */
export type Accounts_Regionaleditorcategory_Editors_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  regionaleditor_id?: InputMaybe<Scalars['Int']>;
  regionaleditorcategory_id?: InputMaybe<Scalars['Int']>;
  sort_value?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "accounts_regionaleditorcategory_editors" */
export type Accounts_Regionaleditorcategory_Editors_Insert_Input = {
  category?: InputMaybe<Accounts_Regionaleditorcategory_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  regional_editor?: InputMaybe<Accounts_Regionaleditor_Obj_Rel_Insert_Input>;
  regionaleditor_id?: InputMaybe<Scalars['Int']>;
  regionaleditorcategory_id?: InputMaybe<Scalars['Int']>;
  sort_value?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Accounts_Regionaleditorcategory_Editors_Max_Fields = {
  __typename?: 'accounts_regionaleditorcategory_editors_max_fields';
  id?: Maybe<Scalars['Int']>;
  regionaleditor_id?: Maybe<Scalars['Int']>;
  regionaleditorcategory_id?: Maybe<Scalars['Int']>;
  sort_value?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "accounts_regionaleditorcategory_editors" */
export type Accounts_Regionaleditorcategory_Editors_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  regionaleditor_id?: InputMaybe<Order_By>;
  regionaleditorcategory_id?: InputMaybe<Order_By>;
  sort_value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Accounts_Regionaleditorcategory_Editors_Min_Fields = {
  __typename?: 'accounts_regionaleditorcategory_editors_min_fields';
  id?: Maybe<Scalars['Int']>;
  regionaleditor_id?: Maybe<Scalars['Int']>;
  regionaleditorcategory_id?: Maybe<Scalars['Int']>;
  sort_value?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "accounts_regionaleditorcategory_editors" */
export type Accounts_Regionaleditorcategory_Editors_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  regionaleditor_id?: InputMaybe<Order_By>;
  regionaleditorcategory_id?: InputMaybe<Order_By>;
  sort_value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "accounts_regionaleditorcategory_editors" */
export type Accounts_Regionaleditorcategory_Editors_Mutation_Response = {
  __typename?: 'accounts_regionaleditorcategory_editors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Accounts_Regionaleditorcategory_Editors>;
};

/** on_conflict condition type for table "accounts_regionaleditorcategory_editors" */
export type Accounts_Regionaleditorcategory_Editors_On_Conflict = {
  constraint: Accounts_Regionaleditorcategory_Editors_Constraint;
  update_columns?: Array<Accounts_Regionaleditorcategory_Editors_Update_Column>;
  where?: InputMaybe<Accounts_Regionaleditorcategory_Editors_Bool_Exp>;
};

/** Ordering options when selecting data from "accounts_regionaleditorcategory_editors". */
export type Accounts_Regionaleditorcategory_Editors_Order_By = {
  category?: InputMaybe<Accounts_Regionaleditorcategory_Order_By>;
  id?: InputMaybe<Order_By>;
  regional_editor?: InputMaybe<Accounts_Regionaleditor_Order_By>;
  regionaleditor_id?: InputMaybe<Order_By>;
  regionaleditorcategory_id?: InputMaybe<Order_By>;
  sort_value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: accounts_regionaleditorcategory_editors */
export type Accounts_Regionaleditorcategory_Editors_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "accounts_regionaleditorcategory_editors" */
export enum Accounts_Regionaleditorcategory_Editors_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  RegionaleditorId = 'regionaleditor_id',
  /** column name */
  RegionaleditorcategoryId = 'regionaleditorcategory_id',
  /** column name */
  SortValue = 'sort_value'
}

/** input type for updating data in table "accounts_regionaleditorcategory_editors" */
export type Accounts_Regionaleditorcategory_Editors_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  regionaleditor_id?: InputMaybe<Scalars['Int']>;
  regionaleditorcategory_id?: InputMaybe<Scalars['Int']>;
  sort_value?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Accounts_Regionaleditorcategory_Editors_Stddev_Fields = {
  __typename?: 'accounts_regionaleditorcategory_editors_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  regionaleditor_id?: Maybe<Scalars['Float']>;
  regionaleditorcategory_id?: Maybe<Scalars['Float']>;
  sort_value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "accounts_regionaleditorcategory_editors" */
export type Accounts_Regionaleditorcategory_Editors_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  regionaleditor_id?: InputMaybe<Order_By>;
  regionaleditorcategory_id?: InputMaybe<Order_By>;
  sort_value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Accounts_Regionaleditorcategory_Editors_Stddev_Pop_Fields = {
  __typename?: 'accounts_regionaleditorcategory_editors_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  regionaleditor_id?: Maybe<Scalars['Float']>;
  regionaleditorcategory_id?: Maybe<Scalars['Float']>;
  sort_value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "accounts_regionaleditorcategory_editors" */
export type Accounts_Regionaleditorcategory_Editors_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  regionaleditor_id?: InputMaybe<Order_By>;
  regionaleditorcategory_id?: InputMaybe<Order_By>;
  sort_value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Accounts_Regionaleditorcategory_Editors_Stddev_Samp_Fields = {
  __typename?: 'accounts_regionaleditorcategory_editors_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  regionaleditor_id?: Maybe<Scalars['Float']>;
  regionaleditorcategory_id?: Maybe<Scalars['Float']>;
  sort_value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "accounts_regionaleditorcategory_editors" */
export type Accounts_Regionaleditorcategory_Editors_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  regionaleditor_id?: InputMaybe<Order_By>;
  regionaleditorcategory_id?: InputMaybe<Order_By>;
  sort_value?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Accounts_Regionaleditorcategory_Editors_Sum_Fields = {
  __typename?: 'accounts_regionaleditorcategory_editors_sum_fields';
  id?: Maybe<Scalars['Int']>;
  regionaleditor_id?: Maybe<Scalars['Int']>;
  regionaleditorcategory_id?: Maybe<Scalars['Int']>;
  sort_value?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "accounts_regionaleditorcategory_editors" */
export type Accounts_Regionaleditorcategory_Editors_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  regionaleditor_id?: InputMaybe<Order_By>;
  regionaleditorcategory_id?: InputMaybe<Order_By>;
  sort_value?: InputMaybe<Order_By>;
};

/** update columns of table "accounts_regionaleditorcategory_editors" */
export enum Accounts_Regionaleditorcategory_Editors_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  RegionaleditorId = 'regionaleditor_id',
  /** column name */
  RegionaleditorcategoryId = 'regionaleditorcategory_id',
  /** column name */
  SortValue = 'sort_value'
}

/** aggregate var_pop on columns */
export type Accounts_Regionaleditorcategory_Editors_Var_Pop_Fields = {
  __typename?: 'accounts_regionaleditorcategory_editors_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  regionaleditor_id?: Maybe<Scalars['Float']>;
  regionaleditorcategory_id?: Maybe<Scalars['Float']>;
  sort_value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "accounts_regionaleditorcategory_editors" */
export type Accounts_Regionaleditorcategory_Editors_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  regionaleditor_id?: InputMaybe<Order_By>;
  regionaleditorcategory_id?: InputMaybe<Order_By>;
  sort_value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Accounts_Regionaleditorcategory_Editors_Var_Samp_Fields = {
  __typename?: 'accounts_regionaleditorcategory_editors_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  regionaleditor_id?: Maybe<Scalars['Float']>;
  regionaleditorcategory_id?: Maybe<Scalars['Float']>;
  sort_value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "accounts_regionaleditorcategory_editors" */
export type Accounts_Regionaleditorcategory_Editors_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  regionaleditor_id?: InputMaybe<Order_By>;
  regionaleditorcategory_id?: InputMaybe<Order_By>;
  sort_value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Accounts_Regionaleditorcategory_Editors_Variance_Fields = {
  __typename?: 'accounts_regionaleditorcategory_editors_variance_fields';
  id?: Maybe<Scalars['Float']>;
  regionaleditor_id?: Maybe<Scalars['Float']>;
  regionaleditorcategory_id?: Maybe<Scalars['Float']>;
  sort_value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "accounts_regionaleditorcategory_editors" */
export type Accounts_Regionaleditorcategory_Editors_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  regionaleditor_id?: InputMaybe<Order_By>;
  regionaleditorcategory_id?: InputMaybe<Order_By>;
  sort_value?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "accounts_regionaleditorcategory" */
export type Accounts_Regionaleditorcategory_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "accounts_regionaleditorcategory" */
export type Accounts_Regionaleditorcategory_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  regional_editors?: InputMaybe<Accounts_Regionaleditorcategory_Editors_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']>;
  title_en?: InputMaybe<Scalars['String']>;
  title_es?: InputMaybe<Scalars['String']>;
  title_fr?: InputMaybe<Scalars['String']>;
  title_ja?: InputMaybe<Scalars['String']>;
  title_zh_hans?: InputMaybe<Scalars['String']>;
  title_zh_hant?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Accounts_Regionaleditorcategory_Max_Fields = {
  __typename?: 'accounts_regionaleditorcategory_max_fields';
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  title_en?: Maybe<Scalars['String']>;
  title_es?: Maybe<Scalars['String']>;
  title_fr?: Maybe<Scalars['String']>;
  title_ja?: Maybe<Scalars['String']>;
  title_zh_hans?: Maybe<Scalars['String']>;
  title_zh_hant?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Accounts_Regionaleditorcategory_Min_Fields = {
  __typename?: 'accounts_regionaleditorcategory_min_fields';
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  title_en?: Maybe<Scalars['String']>;
  title_es?: Maybe<Scalars['String']>;
  title_fr?: Maybe<Scalars['String']>;
  title_ja?: Maybe<Scalars['String']>;
  title_zh_hans?: Maybe<Scalars['String']>;
  title_zh_hant?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "accounts_regionaleditorcategory" */
export type Accounts_Regionaleditorcategory_Mutation_Response = {
  __typename?: 'accounts_regionaleditorcategory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Accounts_Regionaleditorcategory>;
};

/** input type for inserting object relation for remote table "accounts_regionaleditorcategory" */
export type Accounts_Regionaleditorcategory_Obj_Rel_Insert_Input = {
  data: Accounts_Regionaleditorcategory_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Accounts_Regionaleditorcategory_On_Conflict>;
};

/** on_conflict condition type for table "accounts_regionaleditorcategory" */
export type Accounts_Regionaleditorcategory_On_Conflict = {
  constraint: Accounts_Regionaleditorcategory_Constraint;
  update_columns?: Array<Accounts_Regionaleditorcategory_Update_Column>;
  where?: InputMaybe<Accounts_Regionaleditorcategory_Bool_Exp>;
};

/** Ordering options when selecting data from "accounts_regionaleditorcategory". */
export type Accounts_Regionaleditorcategory_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  regional_editors_aggregate?: InputMaybe<Accounts_Regionaleditorcategory_Editors_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  title_en?: InputMaybe<Order_By>;
  title_es?: InputMaybe<Order_By>;
  title_fr?: InputMaybe<Order_By>;
  title_ja?: InputMaybe<Order_By>;
  title_zh_hans?: InputMaybe<Order_By>;
  title_zh_hant?: InputMaybe<Order_By>;
};

/** primary key columns input for table: accounts_regionaleditorcategory */
export type Accounts_Regionaleditorcategory_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "accounts_regionaleditorcategory" */
export enum Accounts_Regionaleditorcategory_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  Title = 'title',
  /** column name */
  TitleEn = 'title_en',
  /** column name */
  TitleEs = 'title_es',
  /** column name */
  TitleFr = 'title_fr',
  /** column name */
  TitleJa = 'title_ja',
  /** column name */
  TitleZhHans = 'title_zh_hans',
  /** column name */
  TitleZhHant = 'title_zh_hant'
}

/** input type for updating data in table "accounts_regionaleditorcategory" */
export type Accounts_Regionaleditorcategory_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  title_en?: InputMaybe<Scalars['String']>;
  title_es?: InputMaybe<Scalars['String']>;
  title_fr?: InputMaybe<Scalars['String']>;
  title_ja?: InputMaybe<Scalars['String']>;
  title_zh_hans?: InputMaybe<Scalars['String']>;
  title_zh_hant?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Accounts_Regionaleditorcategory_Stddev_Fields = {
  __typename?: 'accounts_regionaleditorcategory_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Accounts_Regionaleditorcategory_Stddev_Pop_Fields = {
  __typename?: 'accounts_regionaleditorcategory_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Accounts_Regionaleditorcategory_Stddev_Samp_Fields = {
  __typename?: 'accounts_regionaleditorcategory_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Accounts_Regionaleditorcategory_Sum_Fields = {
  __typename?: 'accounts_regionaleditorcategory_sum_fields';
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
};

/** update columns of table "accounts_regionaleditorcategory" */
export enum Accounts_Regionaleditorcategory_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  Title = 'title',
  /** column name */
  TitleEn = 'title_en',
  /** column name */
  TitleEs = 'title_es',
  /** column name */
  TitleFr = 'title_fr',
  /** column name */
  TitleJa = 'title_ja',
  /** column name */
  TitleZhHans = 'title_zh_hans',
  /** column name */
  TitleZhHant = 'title_zh_hant'
}

/** aggregate var_pop on columns */
export type Accounts_Regionaleditorcategory_Var_Pop_Fields = {
  __typename?: 'accounts_regionaleditorcategory_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Accounts_Regionaleditorcategory_Var_Samp_Fields = {
  __typename?: 'accounts_regionaleditorcategory_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Accounts_Regionaleditorcategory_Variance_Fields = {
  __typename?: 'accounts_regionaleditorcategory_variance_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "accounts_translator" */
export type Accounts_Translator = {
  __typename?: 'accounts_translator';
  id: Scalars['Int'];
  /** An object relationship */
  user: Auth_User;
  user_id: Scalars['Int'];
};

/** aggregated selection of "accounts_translator" */
export type Accounts_Translator_Aggregate = {
  __typename?: 'accounts_translator_aggregate';
  aggregate?: Maybe<Accounts_Translator_Aggregate_Fields>;
  nodes: Array<Accounts_Translator>;
};

/** aggregate fields of "accounts_translator" */
export type Accounts_Translator_Aggregate_Fields = {
  __typename?: 'accounts_translator_aggregate_fields';
  avg?: Maybe<Accounts_Translator_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Accounts_Translator_Max_Fields>;
  min?: Maybe<Accounts_Translator_Min_Fields>;
  stddev?: Maybe<Accounts_Translator_Stddev_Fields>;
  stddev_pop?: Maybe<Accounts_Translator_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Accounts_Translator_Stddev_Samp_Fields>;
  sum?: Maybe<Accounts_Translator_Sum_Fields>;
  var_pop?: Maybe<Accounts_Translator_Var_Pop_Fields>;
  var_samp?: Maybe<Accounts_Translator_Var_Samp_Fields>;
  variance?: Maybe<Accounts_Translator_Variance_Fields>;
};


/** aggregate fields of "accounts_translator" */
export type Accounts_Translator_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Accounts_Translator_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Accounts_Translator_Avg_Fields = {
  __typename?: 'accounts_translator_avg_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "accounts_translator". All fields are combined with a logical 'AND'. */
export type Accounts_Translator_Bool_Exp = {
  _and?: InputMaybe<Array<Accounts_Translator_Bool_Exp>>;
  _not?: InputMaybe<Accounts_Translator_Bool_Exp>;
  _or?: InputMaybe<Array<Accounts_Translator_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<Auth_User_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "accounts_translator" */
export enum Accounts_Translator_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountsTranslatorPkey = 'accounts_translator_pkey'
}

/** input type for incrementing numeric columns in table "accounts_translator" */
export type Accounts_Translator_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "accounts_translator" */
export type Accounts_Translator_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<Auth_User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Accounts_Translator_Max_Fields = {
  __typename?: 'accounts_translator_max_fields';
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Accounts_Translator_Min_Fields = {
  __typename?: 'accounts_translator_min_fields';
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "accounts_translator" */
export type Accounts_Translator_Mutation_Response = {
  __typename?: 'accounts_translator_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Accounts_Translator>;
};

/** on_conflict condition type for table "accounts_translator" */
export type Accounts_Translator_On_Conflict = {
  constraint: Accounts_Translator_Constraint;
  update_columns?: Array<Accounts_Translator_Update_Column>;
  where?: InputMaybe<Accounts_Translator_Bool_Exp>;
};

/** Ordering options when selecting data from "accounts_translator". */
export type Accounts_Translator_Order_By = {
  id?: InputMaybe<Order_By>;
  user?: InputMaybe<Auth_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: accounts_translator */
export type Accounts_Translator_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "accounts_translator" */
export enum Accounts_Translator_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "accounts_translator" */
export type Accounts_Translator_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Accounts_Translator_Stddev_Fields = {
  __typename?: 'accounts_translator_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Accounts_Translator_Stddev_Pop_Fields = {
  __typename?: 'accounts_translator_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Accounts_Translator_Stddev_Samp_Fields = {
  __typename?: 'accounts_translator_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Accounts_Translator_Sum_Fields = {
  __typename?: 'accounts_translator_sum_fields';
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "accounts_translator" */
export enum Accounts_Translator_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type Accounts_Translator_Var_Pop_Fields = {
  __typename?: 'accounts_translator_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Accounts_Translator_Var_Samp_Fields = {
  __typename?: 'accounts_translator_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Accounts_Translator_Variance_Fields = {
  __typename?: 'accounts_translator_variance_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "analyze_user_query" */
export type Analyze_User_Query = {
  __typename?: 'analyze_user_query';
  created_at?: Maybe<Scalars['timestamp']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  payload: Scalars['jsonb'];
  published?: Maybe<Scalars['Boolean']>;
  target_timestamp: Scalars['timestamptz'];
  /** An object relationship */
  user: Auth_User;
  user_id: Scalars['Int'];
};


/** columns and relationships of "analyze_user_query" */
export type Analyze_User_QueryPayloadArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "analyze_user_query" */
export type Analyze_User_Query_Aggregate = {
  __typename?: 'analyze_user_query_aggregate';
  aggregate?: Maybe<Analyze_User_Query_Aggregate_Fields>;
  nodes: Array<Analyze_User_Query>;
};

/** aggregate fields of "analyze_user_query" */
export type Analyze_User_Query_Aggregate_Fields = {
  __typename?: 'analyze_user_query_aggregate_fields';
  avg?: Maybe<Analyze_User_Query_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Analyze_User_Query_Max_Fields>;
  min?: Maybe<Analyze_User_Query_Min_Fields>;
  stddev?: Maybe<Analyze_User_Query_Stddev_Fields>;
  stddev_pop?: Maybe<Analyze_User_Query_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Analyze_User_Query_Stddev_Samp_Fields>;
  sum?: Maybe<Analyze_User_Query_Sum_Fields>;
  var_pop?: Maybe<Analyze_User_Query_Var_Pop_Fields>;
  var_samp?: Maybe<Analyze_User_Query_Var_Samp_Fields>;
  variance?: Maybe<Analyze_User_Query_Variance_Fields>;
};


/** aggregate fields of "analyze_user_query" */
export type Analyze_User_Query_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Analyze_User_Query_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Analyze_User_Query_Append_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Analyze_User_Query_Avg_Fields = {
  __typename?: 'analyze_user_query_avg_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "analyze_user_query". All fields are combined with a logical 'AND'. */
export type Analyze_User_Query_Bool_Exp = {
  _and?: InputMaybe<Array<Analyze_User_Query_Bool_Exp>>;
  _not?: InputMaybe<Analyze_User_Query_Bool_Exp>;
  _or?: InputMaybe<Array<Analyze_User_Query_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  published?: InputMaybe<Boolean_Comparison_Exp>;
  target_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Auth_User_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "analyze_user_query" */
export enum Analyze_User_Query_Constraint {
  /** unique or primary key constraint on columns "id" */
  AnalyzeUserQueryPkey = 'analyze_user_query_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Analyze_User_Query_Delete_At_Path_Input = {
  payload?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Analyze_User_Query_Delete_Elem_Input = {
  payload?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Analyze_User_Query_Delete_Key_Input = {
  payload?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "analyze_user_query" */
export type Analyze_User_Query_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "analyze_user_query" */
export type Analyze_User_Query_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  published?: InputMaybe<Scalars['Boolean']>;
  target_timestamp?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Auth_User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Analyze_User_Query_Max_Fields = {
  __typename?: 'analyze_user_query_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  target_timestamp?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Analyze_User_Query_Min_Fields = {
  __typename?: 'analyze_user_query_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  target_timestamp?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "analyze_user_query" */
export type Analyze_User_Query_Mutation_Response = {
  __typename?: 'analyze_user_query_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Analyze_User_Query>;
};

/** on_conflict condition type for table "analyze_user_query" */
export type Analyze_User_Query_On_Conflict = {
  constraint: Analyze_User_Query_Constraint;
  update_columns?: Array<Analyze_User_Query_Update_Column>;
  where?: InputMaybe<Analyze_User_Query_Bool_Exp>;
};

/** Ordering options when selecting data from "analyze_user_query". */
export type Analyze_User_Query_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  target_timestamp?: InputMaybe<Order_By>;
  user?: InputMaybe<Auth_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: analyze_user_query */
export type Analyze_User_Query_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Analyze_User_Query_Prepend_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "analyze_user_query" */
export enum Analyze_User_Query_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Payload = 'payload',
  /** column name */
  Published = 'published',
  /** column name */
  TargetTimestamp = 'target_timestamp',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "analyze_user_query" */
export type Analyze_User_Query_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  published?: InputMaybe<Scalars['Boolean']>;
  target_timestamp?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Analyze_User_Query_Stddev_Fields = {
  __typename?: 'analyze_user_query_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Analyze_User_Query_Stddev_Pop_Fields = {
  __typename?: 'analyze_user_query_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Analyze_User_Query_Stddev_Samp_Fields = {
  __typename?: 'analyze_user_query_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Analyze_User_Query_Sum_Fields = {
  __typename?: 'analyze_user_query_sum_fields';
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "analyze_user_query" */
export enum Analyze_User_Query_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Payload = 'payload',
  /** column name */
  Published = 'published',
  /** column name */
  TargetTimestamp = 'target_timestamp',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type Analyze_User_Query_Var_Pop_Fields = {
  __typename?: 'analyze_user_query_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Analyze_User_Query_Var_Samp_Fields = {
  __typename?: 'analyze_user_query_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Analyze_User_Query_Variance_Fields = {
  __typename?: 'analyze_user_query_variance_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "auth_user" */
export type Auth_User = {
  __typename?: 'auth_user';
  date_joined: Scalars['timestamptz'];
  email: Scalars['String'];
  /** An array relationship */
  entries: Array<Polls_Entity>;
  /** An aggregate relationship */
  entries_aggregate: Polls_Entity_Aggregate;
  /** An object relationship */
  expert?: Maybe<Accounts_Expert>;
  first_name: Scalars['String'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  is_staff: Scalars['Boolean'];
  is_superuser: Scalars['Boolean'];
  last_login?: Maybe<Scalars['timestamptz']>;
  last_name: Scalars['String'];
  /** An object relationship */
  managing_editor?: Maybe<Accounts_Managingeditor>;
  password: Scalars['String'];
  /** An object relationship */
  profile?: Maybe<Accounts_Profile>;
  /** An object relationship */
  regional_editor?: Maybe<Accounts_Regionaleditor>;
  username: Scalars['String'];
};


/** columns and relationships of "auth_user" */
export type Auth_UserEntriesArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Order_By>>;
  where?: InputMaybe<Polls_Entity_Bool_Exp>;
};


/** columns and relationships of "auth_user" */
export type Auth_UserEntries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Order_By>>;
  where?: InputMaybe<Polls_Entity_Bool_Exp>;
};

/** aggregated selection of "auth_user" */
export type Auth_User_Aggregate = {
  __typename?: 'auth_user_aggregate';
  aggregate?: Maybe<Auth_User_Aggregate_Fields>;
  nodes: Array<Auth_User>;
};

/** aggregate fields of "auth_user" */
export type Auth_User_Aggregate_Fields = {
  __typename?: 'auth_user_aggregate_fields';
  avg?: Maybe<Auth_User_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Auth_User_Max_Fields>;
  min?: Maybe<Auth_User_Min_Fields>;
  stddev?: Maybe<Auth_User_Stddev_Fields>;
  stddev_pop?: Maybe<Auth_User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Auth_User_Stddev_Samp_Fields>;
  sum?: Maybe<Auth_User_Sum_Fields>;
  var_pop?: Maybe<Auth_User_Var_Pop_Fields>;
  var_samp?: Maybe<Auth_User_Var_Samp_Fields>;
  variance?: Maybe<Auth_User_Variance_Fields>;
};


/** aggregate fields of "auth_user" */
export type Auth_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Auth_User_Avg_Fields = {
  __typename?: 'auth_user_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "auth_user". All fields are combined with a logical 'AND'. */
export type Auth_User_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_User_Bool_Exp>>;
  _not?: InputMaybe<Auth_User_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_User_Bool_Exp>>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  entries?: InputMaybe<Polls_Entity_Bool_Exp>;
  expert?: InputMaybe<Accounts_Expert_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  managing_editor?: InputMaybe<Accounts_Managingeditor_Bool_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  profile?: InputMaybe<Accounts_Profile_Bool_Exp>;
  regional_editor?: InputMaybe<Accounts_Regionaleditor_Bool_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth_user" */
export enum Auth_User_Constraint {
  /** unique or primary key constraint on columns "id" */
  AuthUserPkey = 'auth_user_pkey',
  /** unique or primary key constraint on columns "username" */
  AuthUserUsernameKey = 'auth_user_username_key'
}

/** input type for incrementing numeric columns in table "auth_user" */
export type Auth_User_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "auth_user" */
export type Auth_User_Insert_Input = {
  date_joined?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  entries?: InputMaybe<Polls_Entity_Arr_Rel_Insert_Input>;
  expert?: InputMaybe<Accounts_Expert_Obj_Rel_Insert_Input>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_staff?: InputMaybe<Scalars['Boolean']>;
  is_superuser?: InputMaybe<Scalars['Boolean']>;
  last_login?: InputMaybe<Scalars['timestamptz']>;
  last_name?: InputMaybe<Scalars['String']>;
  managing_editor?: InputMaybe<Accounts_Managingeditor_Obj_Rel_Insert_Input>;
  password?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<Accounts_Profile_Obj_Rel_Insert_Input>;
  regional_editor?: InputMaybe<Accounts_Regionaleditor_Obj_Rel_Insert_Input>;
  username?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Auth_User_Max_Fields = {
  __typename?: 'auth_user_max_fields';
  date_joined?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_login?: Maybe<Scalars['timestamptz']>;
  last_name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Auth_User_Min_Fields = {
  __typename?: 'auth_user_min_fields';
  date_joined?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_login?: Maybe<Scalars['timestamptz']>;
  last_name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "auth_user" */
export type Auth_User_Mutation_Response = {
  __typename?: 'auth_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_User>;
};

/** input type for inserting object relation for remote table "auth_user" */
export type Auth_User_Obj_Rel_Insert_Input = {
  data: Auth_User_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Auth_User_On_Conflict>;
};

/** on_conflict condition type for table "auth_user" */
export type Auth_User_On_Conflict = {
  constraint: Auth_User_Constraint;
  update_columns?: Array<Auth_User_Update_Column>;
  where?: InputMaybe<Auth_User_Bool_Exp>;
};

/** Ordering options when selecting data from "auth_user". */
export type Auth_User_Order_By = {
  date_joined?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  entries_aggregate?: InputMaybe<Polls_Entity_Aggregate_Order_By>;
  expert?: InputMaybe<Accounts_Expert_Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_staff?: InputMaybe<Order_By>;
  is_superuser?: InputMaybe<Order_By>;
  last_login?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  managing_editor?: InputMaybe<Accounts_Managingeditor_Order_By>;
  password?: InputMaybe<Order_By>;
  profile?: InputMaybe<Accounts_Profile_Order_By>;
  regional_editor?: InputMaybe<Accounts_Regionaleditor_Order_By>;
  username?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth_user */
export type Auth_User_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "auth_user" */
export enum Auth_User_Select_Column {
  /** column name */
  DateJoined = 'date_joined',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsStaff = 'is_staff',
  /** column name */
  IsSuperuser = 'is_superuser',
  /** column name */
  LastLogin = 'last_login',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Password = 'password',
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "auth_user" */
export type Auth_User_Set_Input = {
  date_joined?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_staff?: InputMaybe<Scalars['Boolean']>;
  is_superuser?: InputMaybe<Scalars['Boolean']>;
  last_login?: InputMaybe<Scalars['timestamptz']>;
  last_name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Auth_User_Stddev_Fields = {
  __typename?: 'auth_user_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Auth_User_Stddev_Pop_Fields = {
  __typename?: 'auth_user_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Auth_User_Stddev_Samp_Fields = {
  __typename?: 'auth_user_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Auth_User_Sum_Fields = {
  __typename?: 'auth_user_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "auth_user" */
export enum Auth_User_Update_Column {
  /** column name */
  DateJoined = 'date_joined',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsStaff = 'is_staff',
  /** column name */
  IsSuperuser = 'is_superuser',
  /** column name */
  LastLogin = 'last_login',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Password = 'password',
  /** column name */
  Username = 'username'
}

/** aggregate var_pop on columns */
export type Auth_User_Var_Pop_Fields = {
  __typename?: 'auth_user_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Auth_User_Var_Samp_Fields = {
  __typename?: 'auth_user_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Auth_User_Variance_Fields = {
  __typename?: 'auth_user_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

export type Geography_Cast_Exp = {
  geometry?: InputMaybe<Geometry_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type Geography_Comparison_Exp = {
  _cast?: InputMaybe<Geography_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geography']>;
  _gt?: InputMaybe<Scalars['geography']>;
  _gte?: InputMaybe<Scalars['geography']>;
  _in?: InputMaybe<Array<Scalars['geography']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['geography']>;
  _lte?: InputMaybe<Scalars['geography']>;
  _neq?: InputMaybe<Scalars['geography']>;
  _nin?: InputMaybe<Array<Scalars['geography']>>;
  /** is the column within a given distance from the given geography value */
  _st_d_within?: InputMaybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _st_intersects?: InputMaybe<Scalars['geography']>;
};

export type Geometry_Cast_Exp = {
  geography?: InputMaybe<Geography_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type Geometry_Comparison_Exp = {
  _cast?: InputMaybe<Geometry_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geometry']>;
  _gt?: InputMaybe<Scalars['geometry']>;
  _gte?: InputMaybe<Scalars['geometry']>;
  _in?: InputMaybe<Array<Scalars['geometry']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['geometry']>;
  _lte?: InputMaybe<Scalars['geometry']>;
  _neq?: InputMaybe<Scalars['geometry']>;
  _nin?: InputMaybe<Array<Scalars['geometry']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st_3d_d_within?: InputMaybe<St_D_Within_Input>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st_3d_intersects?: InputMaybe<Scalars['geometry']>;
  /** does the column contain the given geometry value */
  _st_contains?: InputMaybe<Scalars['geometry']>;
  /** does the column cross the given geometry value */
  _st_crosses?: InputMaybe<Scalars['geometry']>;
  /** is the column within a given distance from the given geometry value */
  _st_d_within?: InputMaybe<St_D_Within_Input>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _st_equals?: InputMaybe<Scalars['geometry']>;
  /** does the column spatially intersect the given geometry value */
  _st_intersects?: InputMaybe<Scalars['geometry']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _st_overlaps?: InputMaybe<Scalars['geometry']>;
  /** does the column have atleast one point in common with the given geometry value */
  _st_touches?: InputMaybe<Scalars['geometry']>;
  /** is the column contained in the given geometry value */
  _st_within?: InputMaybe<Scalars['geometry']>;
};

/** columns and relationships of "gis_regions_gis_region" */
export type Gis_Regions_Gis_Region = {
  __typename?: 'gis_regions_gis_region';
  additional_info?: Maybe<Scalars['String']>;
  /** An array relationship */
  base_answer_sets: Array<Polls_Baseanswerset>;
  /** An aggregate relationship */
  base_answer_sets_aggregate: Polls_Baseanswerset_Aggregate;
  completed: Scalars['Boolean'];
  created_by_id: Scalars['Int'];
  date_created?: Maybe<Scalars['timestamptz']>;
  date_modified?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  description_en?: Maybe<Scalars['String']>;
  description_es?: Maybe<Scalars['String']>;
  description_fr?: Maybe<Scalars['String']>;
  description_ja?: Maybe<Scalars['String']>;
  description_zh_hans?: Maybe<Scalars['String']>;
  description_zh_hant?: Maybe<Scalars['String']>;
  /** An array relationship */
  entries: Array<Polls_Entity>;
  /** An aggregate relationship */
  entries_aggregate: Polls_Entity_Aggregate;
  geom?: Maybe<Scalars['geometry']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  /** An array relationship */
  tags: Array<Gis_Regions_Gis_Region_Tags>;
  /** An aggregate relationship */
  tags_aggregate: Gis_Regions_Gis_Region_Tags_Aggregate;
};


/** columns and relationships of "gis_regions_gis_region" */
export type Gis_Regions_Gis_RegionBase_Answer_SetsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Baseanswerset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Baseanswerset_Order_By>>;
  where?: InputMaybe<Polls_Baseanswerset_Bool_Exp>;
};


/** columns and relationships of "gis_regions_gis_region" */
export type Gis_Regions_Gis_RegionBase_Answer_Sets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Baseanswerset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Baseanswerset_Order_By>>;
  where?: InputMaybe<Polls_Baseanswerset_Bool_Exp>;
};


/** columns and relationships of "gis_regions_gis_region" */
export type Gis_Regions_Gis_RegionEntriesArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Order_By>>;
  where?: InputMaybe<Polls_Entity_Bool_Exp>;
};


/** columns and relationships of "gis_regions_gis_region" */
export type Gis_Regions_Gis_RegionEntries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Order_By>>;
  where?: InputMaybe<Polls_Entity_Bool_Exp>;
};


/** columns and relationships of "gis_regions_gis_region" */
export type Gis_Regions_Gis_RegionTagsArgs = {
  distinct_on?: InputMaybe<Array<Gis_Regions_Gis_Region_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gis_Regions_Gis_Region_Tags_Order_By>>;
  where?: InputMaybe<Gis_Regions_Gis_Region_Tags_Bool_Exp>;
};


/** columns and relationships of "gis_regions_gis_region" */
export type Gis_Regions_Gis_RegionTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gis_Regions_Gis_Region_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gis_Regions_Gis_Region_Tags_Order_By>>;
  where?: InputMaybe<Gis_Regions_Gis_Region_Tags_Bool_Exp>;
};

/** aggregated selection of "gis_regions_gis_region" */
export type Gis_Regions_Gis_Region_Aggregate = {
  __typename?: 'gis_regions_gis_region_aggregate';
  aggregate?: Maybe<Gis_Regions_Gis_Region_Aggregate_Fields>;
  nodes: Array<Gis_Regions_Gis_Region>;
};

/** aggregate fields of "gis_regions_gis_region" */
export type Gis_Regions_Gis_Region_Aggregate_Fields = {
  __typename?: 'gis_regions_gis_region_aggregate_fields';
  avg?: Maybe<Gis_Regions_Gis_Region_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Gis_Regions_Gis_Region_Max_Fields>;
  min?: Maybe<Gis_Regions_Gis_Region_Min_Fields>;
  stddev?: Maybe<Gis_Regions_Gis_Region_Stddev_Fields>;
  stddev_pop?: Maybe<Gis_Regions_Gis_Region_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Gis_Regions_Gis_Region_Stddev_Samp_Fields>;
  sum?: Maybe<Gis_Regions_Gis_Region_Sum_Fields>;
  var_pop?: Maybe<Gis_Regions_Gis_Region_Var_Pop_Fields>;
  var_samp?: Maybe<Gis_Regions_Gis_Region_Var_Samp_Fields>;
  variance?: Maybe<Gis_Regions_Gis_Region_Variance_Fields>;
};


/** aggregate fields of "gis_regions_gis_region" */
export type Gis_Regions_Gis_Region_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gis_Regions_Gis_Region_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Gis_Regions_Gis_Region_Avg_Fields = {
  __typename?: 'gis_regions_gis_region_avg_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "gis_regions_gis_region". All fields are combined with a logical 'AND'. */
export type Gis_Regions_Gis_Region_Bool_Exp = {
  _and?: InputMaybe<Array<Gis_Regions_Gis_Region_Bool_Exp>>;
  _not?: InputMaybe<Gis_Regions_Gis_Region_Bool_Exp>;
  _or?: InputMaybe<Array<Gis_Regions_Gis_Region_Bool_Exp>>;
  additional_info?: InputMaybe<String_Comparison_Exp>;
  base_answer_sets?: InputMaybe<Polls_Baseanswerset_Bool_Exp>;
  completed?: InputMaybe<Boolean_Comparison_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  date_created?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  description_en?: InputMaybe<String_Comparison_Exp>;
  description_es?: InputMaybe<String_Comparison_Exp>;
  description_fr?: InputMaybe<String_Comparison_Exp>;
  description_ja?: InputMaybe<String_Comparison_Exp>;
  description_zh_hans?: InputMaybe<String_Comparison_Exp>;
  description_zh_hant?: InputMaybe<String_Comparison_Exp>;
  entries?: InputMaybe<Polls_Entity_Bool_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  name_en?: InputMaybe<String_Comparison_Exp>;
  name_es?: InputMaybe<String_Comparison_Exp>;
  name_fr?: InputMaybe<String_Comparison_Exp>;
  name_ja?: InputMaybe<String_Comparison_Exp>;
  name_zh_hans?: InputMaybe<String_Comparison_Exp>;
  name_zh_hant?: InputMaybe<String_Comparison_Exp>;
  tags?: InputMaybe<Gis_Regions_Gis_Region_Tags_Bool_Exp>;
};

/** unique or primary key constraints on table "gis_regions_gis_region" */
export enum Gis_Regions_Gis_Region_Constraint {
  /** unique or primary key constraint on columns "name_en" */
  GisRegionsGisRegionNameEnKey = 'gis_regions_gis_region_name_en_key',
  /** unique or primary key constraint on columns "name_es" */
  GisRegionsGisRegionNameEsKey = 'gis_regions_gis_region_name_es_key',
  /** unique or primary key constraint on columns "name_fr" */
  GisRegionsGisRegionNameFrKey = 'gis_regions_gis_region_name_fr_key',
  /** unique or primary key constraint on columns "name_ja" */
  GisRegionsGisRegionNameJaKey = 'gis_regions_gis_region_name_ja_key',
  /** unique or primary key constraint on columns "name" */
  GisRegionsGisRegionNameUniq = 'gis_regions_gis_region_name_uniq',
  /** unique or primary key constraint on columns "name_zh_hans" */
  GisRegionsGisRegionNameZhHansKey = 'gis_regions_gis_region_name_zh_hans_key',
  /** unique or primary key constraint on columns "name_zh_hant" */
  GisRegionsGisRegionNameZhHantKey = 'gis_regions_gis_region_name_zh_hant_key',
  /** unique or primary key constraint on columns "id" */
  GisRegionsGisRegionPkey = 'gis_regions_gis_region_pkey'
}

/** input type for incrementing numeric columns in table "gis_regions_gis_region" */
export type Gis_Regions_Gis_Region_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "gis_regions_gis_region" */
export type Gis_Regions_Gis_Region_Insert_Input = {
  additional_info?: InputMaybe<Scalars['String']>;
  base_answer_sets?: InputMaybe<Polls_Baseanswerset_Arr_Rel_Insert_Input>;
  completed?: InputMaybe<Scalars['Boolean']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_modified?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  description_en?: InputMaybe<Scalars['String']>;
  description_es?: InputMaybe<Scalars['String']>;
  description_fr?: InputMaybe<Scalars['String']>;
  description_ja?: InputMaybe<Scalars['String']>;
  description_zh_hans?: InputMaybe<Scalars['String']>;
  description_zh_hant?: InputMaybe<Scalars['String']>;
  entries?: InputMaybe<Polls_Entity_Arr_Rel_Insert_Input>;
  geom?: InputMaybe<Scalars['geometry']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Gis_Regions_Gis_Region_Tags_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Gis_Regions_Gis_Region_Max_Fields = {
  __typename?: 'gis_regions_gis_region_max_fields';
  additional_info?: Maybe<Scalars['String']>;
  created_by_id?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['timestamptz']>;
  date_modified?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  description_en?: Maybe<Scalars['String']>;
  description_es?: Maybe<Scalars['String']>;
  description_fr?: Maybe<Scalars['String']>;
  description_ja?: Maybe<Scalars['String']>;
  description_zh_hans?: Maybe<Scalars['String']>;
  description_zh_hant?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Gis_Regions_Gis_Region_Min_Fields = {
  __typename?: 'gis_regions_gis_region_min_fields';
  additional_info?: Maybe<Scalars['String']>;
  created_by_id?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['timestamptz']>;
  date_modified?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  description_en?: Maybe<Scalars['String']>;
  description_es?: Maybe<Scalars['String']>;
  description_fr?: Maybe<Scalars['String']>;
  description_ja?: Maybe<Scalars['String']>;
  description_zh_hans?: Maybe<Scalars['String']>;
  description_zh_hant?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "gis_regions_gis_region" */
export type Gis_Regions_Gis_Region_Mutation_Response = {
  __typename?: 'gis_regions_gis_region_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Gis_Regions_Gis_Region>;
};

/** input type for inserting object relation for remote table "gis_regions_gis_region" */
export type Gis_Regions_Gis_Region_Obj_Rel_Insert_Input = {
  data: Gis_Regions_Gis_Region_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Gis_Regions_Gis_Region_On_Conflict>;
};

/** on_conflict condition type for table "gis_regions_gis_region" */
export type Gis_Regions_Gis_Region_On_Conflict = {
  constraint: Gis_Regions_Gis_Region_Constraint;
  update_columns?: Array<Gis_Regions_Gis_Region_Update_Column>;
  where?: InputMaybe<Gis_Regions_Gis_Region_Bool_Exp>;
};

/** Ordering options when selecting data from "gis_regions_gis_region". */
export type Gis_Regions_Gis_Region_Order_By = {
  additional_info?: InputMaybe<Order_By>;
  base_answer_sets_aggregate?: InputMaybe<Polls_Baseanswerset_Aggregate_Order_By>;
  completed?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  date_created?: InputMaybe<Order_By>;
  date_modified?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  description_en?: InputMaybe<Order_By>;
  description_es?: InputMaybe<Order_By>;
  description_fr?: InputMaybe<Order_By>;
  description_ja?: InputMaybe<Order_By>;
  description_zh_hans?: InputMaybe<Order_By>;
  description_zh_hant?: InputMaybe<Order_By>;
  entries_aggregate?: InputMaybe<Polls_Entity_Aggregate_Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  tags_aggregate?: InputMaybe<Gis_Regions_Gis_Region_Tags_Aggregate_Order_By>;
};

/** primary key columns input for table: gis_regions_gis_region */
export type Gis_Regions_Gis_Region_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "gis_regions_gis_region" */
export enum Gis_Regions_Gis_Region_Select_Column {
  /** column name */
  AdditionalInfo = 'additional_info',
  /** column name */
  Completed = 'completed',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateModified = 'date_modified',
  /** column name */
  Description = 'description',
  /** column name */
  DescriptionEn = 'description_en',
  /** column name */
  DescriptionEs = 'description_es',
  /** column name */
  DescriptionFr = 'description_fr',
  /** column name */
  DescriptionJa = 'description_ja',
  /** column name */
  DescriptionZhHans = 'description_zh_hans',
  /** column name */
  DescriptionZhHant = 'description_zh_hant',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant'
}

/** input type for updating data in table "gis_regions_gis_region" */
export type Gis_Regions_Gis_Region_Set_Input = {
  additional_info?: InputMaybe<Scalars['String']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_modified?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  description_en?: InputMaybe<Scalars['String']>;
  description_es?: InputMaybe<Scalars['String']>;
  description_fr?: InputMaybe<Scalars['String']>;
  description_ja?: InputMaybe<Scalars['String']>;
  description_zh_hans?: InputMaybe<Scalars['String']>;
  description_zh_hant?: InputMaybe<Scalars['String']>;
  geom?: InputMaybe<Scalars['geometry']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Gis_Regions_Gis_Region_Stddev_Fields = {
  __typename?: 'gis_regions_gis_region_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Gis_Regions_Gis_Region_Stddev_Pop_Fields = {
  __typename?: 'gis_regions_gis_region_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Gis_Regions_Gis_Region_Stddev_Samp_Fields = {
  __typename?: 'gis_regions_gis_region_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Gis_Regions_Gis_Region_Sum_Fields = {
  __typename?: 'gis_regions_gis_region_sum_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "gis_regions_gis_region_tags" */
export type Gis_Regions_Gis_Region_Tags = {
  __typename?: 'gis_regions_gis_region_tags';
  gis_tag_id: Scalars['Int'];
  id: Scalars['Int'];
  region_id: Scalars['Int'];
  /** An object relationship */
  tag: Gis_Regions_Gis_Tag;
};

/** aggregated selection of "gis_regions_gis_region_tags" */
export type Gis_Regions_Gis_Region_Tags_Aggregate = {
  __typename?: 'gis_regions_gis_region_tags_aggregate';
  aggregate?: Maybe<Gis_Regions_Gis_Region_Tags_Aggregate_Fields>;
  nodes: Array<Gis_Regions_Gis_Region_Tags>;
};

/** aggregate fields of "gis_regions_gis_region_tags" */
export type Gis_Regions_Gis_Region_Tags_Aggregate_Fields = {
  __typename?: 'gis_regions_gis_region_tags_aggregate_fields';
  avg?: Maybe<Gis_Regions_Gis_Region_Tags_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Gis_Regions_Gis_Region_Tags_Max_Fields>;
  min?: Maybe<Gis_Regions_Gis_Region_Tags_Min_Fields>;
  stddev?: Maybe<Gis_Regions_Gis_Region_Tags_Stddev_Fields>;
  stddev_pop?: Maybe<Gis_Regions_Gis_Region_Tags_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Gis_Regions_Gis_Region_Tags_Stddev_Samp_Fields>;
  sum?: Maybe<Gis_Regions_Gis_Region_Tags_Sum_Fields>;
  var_pop?: Maybe<Gis_Regions_Gis_Region_Tags_Var_Pop_Fields>;
  var_samp?: Maybe<Gis_Regions_Gis_Region_Tags_Var_Samp_Fields>;
  variance?: Maybe<Gis_Regions_Gis_Region_Tags_Variance_Fields>;
};


/** aggregate fields of "gis_regions_gis_region_tags" */
export type Gis_Regions_Gis_Region_Tags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gis_Regions_Gis_Region_Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "gis_regions_gis_region_tags" */
export type Gis_Regions_Gis_Region_Tags_Aggregate_Order_By = {
  avg?: InputMaybe<Gis_Regions_Gis_Region_Tags_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gis_Regions_Gis_Region_Tags_Max_Order_By>;
  min?: InputMaybe<Gis_Regions_Gis_Region_Tags_Min_Order_By>;
  stddev?: InputMaybe<Gis_Regions_Gis_Region_Tags_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Gis_Regions_Gis_Region_Tags_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Gis_Regions_Gis_Region_Tags_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Gis_Regions_Gis_Region_Tags_Sum_Order_By>;
  var_pop?: InputMaybe<Gis_Regions_Gis_Region_Tags_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Gis_Regions_Gis_Region_Tags_Var_Samp_Order_By>;
  variance?: InputMaybe<Gis_Regions_Gis_Region_Tags_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "gis_regions_gis_region_tags" */
export type Gis_Regions_Gis_Region_Tags_Arr_Rel_Insert_Input = {
  data: Array<Gis_Regions_Gis_Region_Tags_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Gis_Regions_Gis_Region_Tags_On_Conflict>;
};

/** aggregate avg on columns */
export type Gis_Regions_Gis_Region_Tags_Avg_Fields = {
  __typename?: 'gis_regions_gis_region_tags_avg_fields';
  gis_tag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "gis_regions_gis_region_tags" */
export type Gis_Regions_Gis_Region_Tags_Avg_Order_By = {
  gis_tag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "gis_regions_gis_region_tags". All fields are combined with a logical 'AND'. */
export type Gis_Regions_Gis_Region_Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Gis_Regions_Gis_Region_Tags_Bool_Exp>>;
  _not?: InputMaybe<Gis_Regions_Gis_Region_Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Gis_Regions_Gis_Region_Tags_Bool_Exp>>;
  gis_tag_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  region_id?: InputMaybe<Int_Comparison_Exp>;
  tag?: InputMaybe<Gis_Regions_Gis_Tag_Bool_Exp>;
};

/** unique or primary key constraints on table "gis_regions_gis_region_tags" */
export enum Gis_Regions_Gis_Region_Tags_Constraint {
  /** unique or primary key constraint on columns "gis_tag_id", "region_id" */
  GisRegionsGisRegionTagsGisRegionId_12ef358eUniq = 'gis_regions_gis_region_tags_gis_region_id_12ef358e_uniq',
  /** unique or primary key constraint on columns "id" */
  GisRegionsGisRegionTagsPkey = 'gis_regions_gis_region_tags_pkey'
}

/** input type for incrementing numeric columns in table "gis_regions_gis_region_tags" */
export type Gis_Regions_Gis_Region_Tags_Inc_Input = {
  gis_tag_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "gis_regions_gis_region_tags" */
export type Gis_Regions_Gis_Region_Tags_Insert_Input = {
  gis_tag_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Gis_Regions_Gis_Tag_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Gis_Regions_Gis_Region_Tags_Max_Fields = {
  __typename?: 'gis_regions_gis_region_tags_max_fields';
  gis_tag_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  region_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "gis_regions_gis_region_tags" */
export type Gis_Regions_Gis_Region_Tags_Max_Order_By = {
  gis_tag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Gis_Regions_Gis_Region_Tags_Min_Fields = {
  __typename?: 'gis_regions_gis_region_tags_min_fields';
  gis_tag_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  region_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "gis_regions_gis_region_tags" */
export type Gis_Regions_Gis_Region_Tags_Min_Order_By = {
  gis_tag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "gis_regions_gis_region_tags" */
export type Gis_Regions_Gis_Region_Tags_Mutation_Response = {
  __typename?: 'gis_regions_gis_region_tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Gis_Regions_Gis_Region_Tags>;
};

/** on_conflict condition type for table "gis_regions_gis_region_tags" */
export type Gis_Regions_Gis_Region_Tags_On_Conflict = {
  constraint: Gis_Regions_Gis_Region_Tags_Constraint;
  update_columns?: Array<Gis_Regions_Gis_Region_Tags_Update_Column>;
  where?: InputMaybe<Gis_Regions_Gis_Region_Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "gis_regions_gis_region_tags". */
export type Gis_Regions_Gis_Region_Tags_Order_By = {
  gis_tag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Gis_Regions_Gis_Tag_Order_By>;
};

/** primary key columns input for table: gis_regions_gis_region_tags */
export type Gis_Regions_Gis_Region_Tags_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "gis_regions_gis_region_tags" */
export enum Gis_Regions_Gis_Region_Tags_Select_Column {
  /** column name */
  GisTagId = 'gis_tag_id',
  /** column name */
  Id = 'id',
  /** column name */
  RegionId = 'region_id'
}

/** input type for updating data in table "gis_regions_gis_region_tags" */
export type Gis_Regions_Gis_Region_Tags_Set_Input = {
  gis_tag_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Gis_Regions_Gis_Region_Tags_Stddev_Fields = {
  __typename?: 'gis_regions_gis_region_tags_stddev_fields';
  gis_tag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "gis_regions_gis_region_tags" */
export type Gis_Regions_Gis_Region_Tags_Stddev_Order_By = {
  gis_tag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Gis_Regions_Gis_Region_Tags_Stddev_Pop_Fields = {
  __typename?: 'gis_regions_gis_region_tags_stddev_pop_fields';
  gis_tag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "gis_regions_gis_region_tags" */
export type Gis_Regions_Gis_Region_Tags_Stddev_Pop_Order_By = {
  gis_tag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Gis_Regions_Gis_Region_Tags_Stddev_Samp_Fields = {
  __typename?: 'gis_regions_gis_region_tags_stddev_samp_fields';
  gis_tag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "gis_regions_gis_region_tags" */
export type Gis_Regions_Gis_Region_Tags_Stddev_Samp_Order_By = {
  gis_tag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Gis_Regions_Gis_Region_Tags_Sum_Fields = {
  __typename?: 'gis_regions_gis_region_tags_sum_fields';
  gis_tag_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  region_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "gis_regions_gis_region_tags" */
export type Gis_Regions_Gis_Region_Tags_Sum_Order_By = {
  gis_tag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
};

/** update columns of table "gis_regions_gis_region_tags" */
export enum Gis_Regions_Gis_Region_Tags_Update_Column {
  /** column name */
  GisTagId = 'gis_tag_id',
  /** column name */
  Id = 'id',
  /** column name */
  RegionId = 'region_id'
}

/** aggregate var_pop on columns */
export type Gis_Regions_Gis_Region_Tags_Var_Pop_Fields = {
  __typename?: 'gis_regions_gis_region_tags_var_pop_fields';
  gis_tag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "gis_regions_gis_region_tags" */
export type Gis_Regions_Gis_Region_Tags_Var_Pop_Order_By = {
  gis_tag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Gis_Regions_Gis_Region_Tags_Var_Samp_Fields = {
  __typename?: 'gis_regions_gis_region_tags_var_samp_fields';
  gis_tag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "gis_regions_gis_region_tags" */
export type Gis_Regions_Gis_Region_Tags_Var_Samp_Order_By = {
  gis_tag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Gis_Regions_Gis_Region_Tags_Variance_Fields = {
  __typename?: 'gis_regions_gis_region_tags_variance_fields';
  gis_tag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "gis_regions_gis_region_tags" */
export type Gis_Regions_Gis_Region_Tags_Variance_Order_By = {
  gis_tag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
};

/** update columns of table "gis_regions_gis_region" */
export enum Gis_Regions_Gis_Region_Update_Column {
  /** column name */
  AdditionalInfo = 'additional_info',
  /** column name */
  Completed = 'completed',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateModified = 'date_modified',
  /** column name */
  Description = 'description',
  /** column name */
  DescriptionEn = 'description_en',
  /** column name */
  DescriptionEs = 'description_es',
  /** column name */
  DescriptionFr = 'description_fr',
  /** column name */
  DescriptionJa = 'description_ja',
  /** column name */
  DescriptionZhHans = 'description_zh_hans',
  /** column name */
  DescriptionZhHant = 'description_zh_hant',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant'
}

/** aggregate var_pop on columns */
export type Gis_Regions_Gis_Region_Var_Pop_Fields = {
  __typename?: 'gis_regions_gis_region_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Gis_Regions_Gis_Region_Var_Samp_Fields = {
  __typename?: 'gis_regions_gis_region_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Gis_Regions_Gis_Region_Variance_Fields = {
  __typename?: 'gis_regions_gis_region_variance_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "gis_regions_gis_tag" */
export type Gis_Regions_Gis_Tag = {
  __typename?: 'gis_regions_gis_tag';
  approved: Scalars['Boolean'];
  /** An array relationship */
  children: Array<Gis_Regions_Gis_Tag>;
  /** An aggregate relationship */
  children_aggregate: Gis_Regions_Gis_Tag_Aggregate;
  created: Scalars['timestamptz'];
  created_by_id: Scalars['Int'];
  id: Scalars['Int'];
  level: Scalars['Int'];
  name: Scalars['String'];
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  /** An object relationship */
  parent?: Maybe<Gis_Regions_Gis_Tag>;
  parent_tag_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  /** An array relationship */
  regions: Array<Gis_Regions_Gis_Region_Tags>;
  /** An aggregate relationship */
  regions_aggregate: Gis_Regions_Gis_Region_Tags_Aggregate;
};


/** columns and relationships of "gis_regions_gis_tag" */
export type Gis_Regions_Gis_TagChildrenArgs = {
  distinct_on?: InputMaybe<Array<Gis_Regions_Gis_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gis_Regions_Gis_Tag_Order_By>>;
  where?: InputMaybe<Gis_Regions_Gis_Tag_Bool_Exp>;
};


/** columns and relationships of "gis_regions_gis_tag" */
export type Gis_Regions_Gis_TagChildren_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gis_Regions_Gis_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gis_Regions_Gis_Tag_Order_By>>;
  where?: InputMaybe<Gis_Regions_Gis_Tag_Bool_Exp>;
};


/** columns and relationships of "gis_regions_gis_tag" */
export type Gis_Regions_Gis_TagRegionsArgs = {
  distinct_on?: InputMaybe<Array<Gis_Regions_Gis_Region_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gis_Regions_Gis_Region_Tags_Order_By>>;
  where?: InputMaybe<Gis_Regions_Gis_Region_Tags_Bool_Exp>;
};


/** columns and relationships of "gis_regions_gis_tag" */
export type Gis_Regions_Gis_TagRegions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gis_Regions_Gis_Region_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gis_Regions_Gis_Region_Tags_Order_By>>;
  where?: InputMaybe<Gis_Regions_Gis_Region_Tags_Bool_Exp>;
};

/** aggregated selection of "gis_regions_gis_tag" */
export type Gis_Regions_Gis_Tag_Aggregate = {
  __typename?: 'gis_regions_gis_tag_aggregate';
  aggregate?: Maybe<Gis_Regions_Gis_Tag_Aggregate_Fields>;
  nodes: Array<Gis_Regions_Gis_Tag>;
};

/** aggregate fields of "gis_regions_gis_tag" */
export type Gis_Regions_Gis_Tag_Aggregate_Fields = {
  __typename?: 'gis_regions_gis_tag_aggregate_fields';
  avg?: Maybe<Gis_Regions_Gis_Tag_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Gis_Regions_Gis_Tag_Max_Fields>;
  min?: Maybe<Gis_Regions_Gis_Tag_Min_Fields>;
  stddev?: Maybe<Gis_Regions_Gis_Tag_Stddev_Fields>;
  stddev_pop?: Maybe<Gis_Regions_Gis_Tag_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Gis_Regions_Gis_Tag_Stddev_Samp_Fields>;
  sum?: Maybe<Gis_Regions_Gis_Tag_Sum_Fields>;
  var_pop?: Maybe<Gis_Regions_Gis_Tag_Var_Pop_Fields>;
  var_samp?: Maybe<Gis_Regions_Gis_Tag_Var_Samp_Fields>;
  variance?: Maybe<Gis_Regions_Gis_Tag_Variance_Fields>;
};


/** aggregate fields of "gis_regions_gis_tag" */
export type Gis_Regions_Gis_Tag_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gis_Regions_Gis_Tag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "gis_regions_gis_tag" */
export type Gis_Regions_Gis_Tag_Aggregate_Order_By = {
  avg?: InputMaybe<Gis_Regions_Gis_Tag_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gis_Regions_Gis_Tag_Max_Order_By>;
  min?: InputMaybe<Gis_Regions_Gis_Tag_Min_Order_By>;
  stddev?: InputMaybe<Gis_Regions_Gis_Tag_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Gis_Regions_Gis_Tag_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Gis_Regions_Gis_Tag_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Gis_Regions_Gis_Tag_Sum_Order_By>;
  var_pop?: InputMaybe<Gis_Regions_Gis_Tag_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Gis_Regions_Gis_Tag_Var_Samp_Order_By>;
  variance?: InputMaybe<Gis_Regions_Gis_Tag_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "gis_regions_gis_tag" */
export type Gis_Regions_Gis_Tag_Arr_Rel_Insert_Input = {
  data: Array<Gis_Regions_Gis_Tag_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Gis_Regions_Gis_Tag_On_Conflict>;
};

/** aggregate avg on columns */
export type Gis_Regions_Gis_Tag_Avg_Fields = {
  __typename?: 'gis_regions_gis_tag_avg_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  level?: Maybe<Scalars['Float']>;
  parent_tag_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "gis_regions_gis_tag" */
export type Gis_Regions_Gis_Tag_Avg_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  parent_tag_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "gis_regions_gis_tag". All fields are combined with a logical 'AND'. */
export type Gis_Regions_Gis_Tag_Bool_Exp = {
  _and?: InputMaybe<Array<Gis_Regions_Gis_Tag_Bool_Exp>>;
  _not?: InputMaybe<Gis_Regions_Gis_Tag_Bool_Exp>;
  _or?: InputMaybe<Array<Gis_Regions_Gis_Tag_Bool_Exp>>;
  approved?: InputMaybe<Boolean_Comparison_Exp>;
  children?: InputMaybe<Gis_Regions_Gis_Tag_Bool_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  level?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  name_en?: InputMaybe<String_Comparison_Exp>;
  name_es?: InputMaybe<String_Comparison_Exp>;
  name_fr?: InputMaybe<String_Comparison_Exp>;
  name_ja?: InputMaybe<String_Comparison_Exp>;
  name_zh_hans?: InputMaybe<String_Comparison_Exp>;
  name_zh_hant?: InputMaybe<String_Comparison_Exp>;
  parent?: InputMaybe<Gis_Regions_Gis_Tag_Bool_Exp>;
  parent_tag_id?: InputMaybe<Int_Comparison_Exp>;
  path?: InputMaybe<String_Comparison_Exp>;
  regions?: InputMaybe<Gis_Regions_Gis_Region_Tags_Bool_Exp>;
};

/** unique or primary key constraints on table "gis_regions_gis_tag" */
export enum Gis_Regions_Gis_Tag_Constraint {
  /** unique or primary key constraint on columns "id" */
  GisRegionsGisTagPkey = 'gis_regions_gis_tag_pkey'
}

/** input type for incrementing numeric columns in table "gis_regions_gis_tag" */
export type Gis_Regions_Gis_Tag_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<Scalars['Int']>;
  parent_tag_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "gis_regions_gis_tag" */
export type Gis_Regions_Gis_Tag_Insert_Input = {
  approved?: InputMaybe<Scalars['Boolean']>;
  children?: InputMaybe<Gis_Regions_Gis_Tag_Arr_Rel_Insert_Input>;
  created?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<Gis_Regions_Gis_Tag_Obj_Rel_Insert_Input>;
  parent_tag_id?: InputMaybe<Scalars['Int']>;
  path?: InputMaybe<Scalars['String']>;
  regions?: InputMaybe<Gis_Regions_Gis_Region_Tags_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Gis_Regions_Gis_Tag_Max_Fields = {
  __typename?: 'gis_regions_gis_tag_max_fields';
  created?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  parent_tag_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "gis_regions_gis_tag" */
export type Gis_Regions_Gis_Tag_Max_Order_By = {
  created?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  parent_tag_id?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Gis_Regions_Gis_Tag_Min_Fields = {
  __typename?: 'gis_regions_gis_tag_min_fields';
  created?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  parent_tag_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "gis_regions_gis_tag" */
export type Gis_Regions_Gis_Tag_Min_Order_By = {
  created?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  parent_tag_id?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "gis_regions_gis_tag" */
export type Gis_Regions_Gis_Tag_Mutation_Response = {
  __typename?: 'gis_regions_gis_tag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Gis_Regions_Gis_Tag>;
};

/** input type for inserting object relation for remote table "gis_regions_gis_tag" */
export type Gis_Regions_Gis_Tag_Obj_Rel_Insert_Input = {
  data: Gis_Regions_Gis_Tag_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Gis_Regions_Gis_Tag_On_Conflict>;
};

/** on_conflict condition type for table "gis_regions_gis_tag" */
export type Gis_Regions_Gis_Tag_On_Conflict = {
  constraint: Gis_Regions_Gis_Tag_Constraint;
  update_columns?: Array<Gis_Regions_Gis_Tag_Update_Column>;
  where?: InputMaybe<Gis_Regions_Gis_Tag_Bool_Exp>;
};

/** Ordering options when selecting data from "gis_regions_gis_tag". */
export type Gis_Regions_Gis_Tag_Order_By = {
  approved?: InputMaybe<Order_By>;
  children_aggregate?: InputMaybe<Gis_Regions_Gis_Tag_Aggregate_Order_By>;
  created?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  parent?: InputMaybe<Gis_Regions_Gis_Tag_Order_By>;
  parent_tag_id?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  regions_aggregate?: InputMaybe<Gis_Regions_Gis_Region_Tags_Aggregate_Order_By>;
};

/** primary key columns input for table: gis_regions_gis_tag */
export type Gis_Regions_Gis_Tag_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "gis_regions_gis_tag" */
export enum Gis_Regions_Gis_Tag_Select_Column {
  /** column name */
  Approved = 'approved',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant',
  /** column name */
  ParentTagId = 'parent_tag_id',
  /** column name */
  Path = 'path'
}

/** input type for updating data in table "gis_regions_gis_tag" */
export type Gis_Regions_Gis_Tag_Set_Input = {
  approved?: InputMaybe<Scalars['Boolean']>;
  created?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
  parent_tag_id?: InputMaybe<Scalars['Int']>;
  path?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Gis_Regions_Gis_Tag_Stddev_Fields = {
  __typename?: 'gis_regions_gis_tag_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  level?: Maybe<Scalars['Float']>;
  parent_tag_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "gis_regions_gis_tag" */
export type Gis_Regions_Gis_Tag_Stddev_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  parent_tag_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Gis_Regions_Gis_Tag_Stddev_Pop_Fields = {
  __typename?: 'gis_regions_gis_tag_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  level?: Maybe<Scalars['Float']>;
  parent_tag_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "gis_regions_gis_tag" */
export type Gis_Regions_Gis_Tag_Stddev_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  parent_tag_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Gis_Regions_Gis_Tag_Stddev_Samp_Fields = {
  __typename?: 'gis_regions_gis_tag_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  level?: Maybe<Scalars['Float']>;
  parent_tag_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "gis_regions_gis_tag" */
export type Gis_Regions_Gis_Tag_Stddev_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  parent_tag_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Gis_Regions_Gis_Tag_Sum_Fields = {
  __typename?: 'gis_regions_gis_tag_sum_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['Int']>;
  parent_tag_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "gis_regions_gis_tag" */
export type Gis_Regions_Gis_Tag_Sum_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  parent_tag_id?: InputMaybe<Order_By>;
};

/** update columns of table "gis_regions_gis_tag" */
export enum Gis_Regions_Gis_Tag_Update_Column {
  /** column name */
  Approved = 'approved',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant',
  /** column name */
  ParentTagId = 'parent_tag_id',
  /** column name */
  Path = 'path'
}

/** aggregate var_pop on columns */
export type Gis_Regions_Gis_Tag_Var_Pop_Fields = {
  __typename?: 'gis_regions_gis_tag_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  level?: Maybe<Scalars['Float']>;
  parent_tag_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "gis_regions_gis_tag" */
export type Gis_Regions_Gis_Tag_Var_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  parent_tag_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Gis_Regions_Gis_Tag_Var_Samp_Fields = {
  __typename?: 'gis_regions_gis_tag_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  level?: Maybe<Scalars['Float']>;
  parent_tag_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "gis_regions_gis_tag" */
export type Gis_Regions_Gis_Tag_Var_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  parent_tag_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Gis_Regions_Gis_Tag_Variance_Fields = {
  __typename?: 'gis_regions_gis_tag_variance_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  level?: Maybe<Scalars['Float']>;
  parent_tag_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "gis_regions_gis_tag" */
export type Gis_Regions_Gis_Tag_Variance_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  parent_tag_id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']>;
  _gt?: InputMaybe<Scalars['json']>;
  _gte?: InputMaybe<Scalars['json']>;
  _in?: InputMaybe<Array<Scalars['json']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['json']>;
  _lte?: InputMaybe<Scalars['json']>;
  _neq?: InputMaybe<Scalars['json']>;
  _nin?: InputMaybe<Array<Scalars['json']>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "accounts_expert" */
  delete_accounts_expert?: Maybe<Accounts_Expert_Mutation_Response>;
  /** delete single row from the table: "accounts_expert" */
  delete_accounts_expert_by_pk?: Maybe<Accounts_Expert>;
  /** delete data from the table: "accounts_managingeditor" */
  delete_accounts_managingeditor?: Maybe<Accounts_Managingeditor_Mutation_Response>;
  /** delete single row from the table: "accounts_managingeditor" */
  delete_accounts_managingeditor_by_pk?: Maybe<Accounts_Managingeditor>;
  /** delete data from the table: "accounts_profile" */
  delete_accounts_profile?: Maybe<Accounts_Profile_Mutation_Response>;
  /** delete single row from the table: "accounts_profile" */
  delete_accounts_profile_by_pk?: Maybe<Accounts_Profile>;
  /** delete data from the table: "accounts_regionaleditor" */
  delete_accounts_regionaleditor?: Maybe<Accounts_Regionaleditor_Mutation_Response>;
  /** delete single row from the table: "accounts_regionaleditor" */
  delete_accounts_regionaleditor_by_pk?: Maybe<Accounts_Regionaleditor>;
  /** delete data from the table: "accounts_regionaleditorcategory" */
  delete_accounts_regionaleditorcategory?: Maybe<Accounts_Regionaleditorcategory_Mutation_Response>;
  /** delete single row from the table: "accounts_regionaleditorcategory" */
  delete_accounts_regionaleditorcategory_by_pk?: Maybe<Accounts_Regionaleditorcategory>;
  /** delete data from the table: "accounts_regionaleditorcategory_editors" */
  delete_accounts_regionaleditorcategory_editors?: Maybe<Accounts_Regionaleditorcategory_Editors_Mutation_Response>;
  /** delete single row from the table: "accounts_regionaleditorcategory_editors" */
  delete_accounts_regionaleditorcategory_editors_by_pk?: Maybe<Accounts_Regionaleditorcategory_Editors>;
  /** delete data from the table: "accounts_translator" */
  delete_accounts_translator?: Maybe<Accounts_Translator_Mutation_Response>;
  /** delete single row from the table: "accounts_translator" */
  delete_accounts_translator_by_pk?: Maybe<Accounts_Translator>;
  /** delete data from the table: "analyze_user_query" */
  delete_analyze_user_query?: Maybe<Analyze_User_Query_Mutation_Response>;
  /** delete single row from the table: "analyze_user_query" */
  delete_analyze_user_query_by_pk?: Maybe<Analyze_User_Query>;
  /** delete data from the table: "auth_user" */
  delete_auth_user?: Maybe<Auth_User_Mutation_Response>;
  /** delete single row from the table: "auth_user" */
  delete_auth_user_by_pk?: Maybe<Auth_User>;
  /** delete data from the table: "gis_regions_gis_region" */
  delete_gis_regions_gis_region?: Maybe<Gis_Regions_Gis_Region_Mutation_Response>;
  /** delete single row from the table: "gis_regions_gis_region" */
  delete_gis_regions_gis_region_by_pk?: Maybe<Gis_Regions_Gis_Region>;
  /** delete data from the table: "gis_regions_gis_region_tags" */
  delete_gis_regions_gis_region_tags?: Maybe<Gis_Regions_Gis_Region_Tags_Mutation_Response>;
  /** delete single row from the table: "gis_regions_gis_region_tags" */
  delete_gis_regions_gis_region_tags_by_pk?: Maybe<Gis_Regions_Gis_Region_Tags>;
  /** delete data from the table: "gis_regions_gis_tag" */
  delete_gis_regions_gis_tag?: Maybe<Gis_Regions_Gis_Tag_Mutation_Response>;
  /** delete single row from the table: "gis_regions_gis_tag" */
  delete_gis_regions_gis_tag_by_pk?: Maybe<Gis_Regions_Gis_Tag>;
  /** delete data from the table: "poll_drafts" */
  delete_poll_drafts?: Maybe<Poll_Drafts_Mutation_Response>;
  /** delete single row from the table: "poll_drafts" */
  delete_poll_drafts_by_pk?: Maybe<Poll_Drafts>;
  /** delete data from the table: "polls_answer" */
  delete_polls_answer?: Maybe<Polls_Answer_Mutation_Response>;
  /** delete single row from the table: "polls_answer" */
  delete_polls_answer_by_pk?: Maybe<Polls_Answer>;
  /** delete data from the table: "polls_answer_set_attachment" */
  delete_polls_answer_set_attachment?: Maybe<Polls_Answer_Set_Attachment_Mutation_Response>;
  /** delete single row from the table: "polls_answer_set_attachment" */
  delete_polls_answer_set_attachment_by_pk?: Maybe<Polls_Answer_Set_Attachment>;
  /** delete data from the table: "polls_answerset" */
  delete_polls_answerset?: Maybe<Polls_Answerset_Mutation_Response>;
  /** delete single row from the table: "polls_answerset" */
  delete_polls_answerset_by_pk?: Maybe<Polls_Answerset>;
  /** delete data from the table: "polls_answersetattachment" */
  delete_polls_answersetattachment?: Maybe<Polls_Answersetattachment_Mutation_Response>;
  /** delete single row from the table: "polls_answersetattachment" */
  delete_polls_answersetattachment_by_pk?: Maybe<Polls_Answersetattachment>;
  /** delete data from the table: "polls_baseanswerset" */
  delete_polls_baseanswerset?: Maybe<Polls_Baseanswerset_Mutation_Response>;
  /** delete data from the table: "polls_baseanswerset_branches" */
  delete_polls_baseanswerset_branches?: Maybe<Polls_Baseanswerset_Branches_Mutation_Response>;
  /** delete single row from the table: "polls_baseanswerset_branches" */
  delete_polls_baseanswerset_branches_by_pk?: Maybe<Polls_Baseanswerset_Branches>;
  /** delete single row from the table: "polls_baseanswerset" */
  delete_polls_baseanswerset_by_pk?: Maybe<Polls_Baseanswerset>;
  /** delete data from the table: "polls_basesource" */
  delete_polls_basesource?: Maybe<Polls_Basesource_Mutation_Response>;
  /** delete single row from the table: "polls_basesource" */
  delete_polls_basesource_by_pk?: Maybe<Polls_Basesource>;
  /** delete data from the table: "polls_branch" */
  delete_polls_branch?: Maybe<Polls_Branch_Mutation_Response>;
  /** delete single row from the table: "polls_branch" */
  delete_polls_branch_by_pk?: Maybe<Polls_Branch>;
  /** delete data from the table: "polls_branchingquestion" */
  delete_polls_branchingquestion?: Maybe<Polls_Branchingquestion_Mutation_Response>;
  /** delete single row from the table: "polls_branchingquestion" */
  delete_polls_branchingquestion_by_pk?: Maybe<Polls_Branchingquestion>;
  /** delete data from the table: "polls_category" */
  delete_polls_category?: Maybe<Polls_Category_Mutation_Response>;
  /** delete single row from the table: "polls_category" */
  delete_polls_category_by_pk?: Maybe<Polls_Category>;
  /** delete data from the table: "polls_categoryprogress" */
  delete_polls_categoryprogress?: Maybe<Polls_Categoryprogress_Mutation_Response>;
  /** delete single row from the table: "polls_categoryprogress" */
  delete_polls_categoryprogress_by_pk?: Maybe<Polls_Categoryprogress>;
  /** delete data from the table: "polls_comment" */
  delete_polls_comment?: Maybe<Polls_Comment_Mutation_Response>;
  /** delete single row from the table: "polls_comment" */
  delete_polls_comment_by_pk?: Maybe<Polls_Comment>;
  /** delete data from the table: "polls_datasource" */
  delete_polls_datasource?: Maybe<Polls_Datasource_Mutation_Response>;
  /** delete single row from the table: "polls_datasource" */
  delete_polls_datasource_by_pk?: Maybe<Polls_Datasource>;
  /** delete data from the table: "polls_entity" */
  delete_polls_entity?: Maybe<Polls_Entity_Mutation_Response>;
  /** delete data from the table: "polls_entity_alt_names" */
  delete_polls_entity_alt_names?: Maybe<Polls_Entity_Alt_Names_Mutation_Response>;
  /** delete single row from the table: "polls_entity_alt_names" */
  delete_polls_entity_alt_names_by_pk?: Maybe<Polls_Entity_Alt_Names>;
  /** delete single row from the table: "polls_entity" */
  delete_polls_entity_by_pk?: Maybe<Polls_Entity>;
  /** delete data from the table: "polls_entity_tags" */
  delete_polls_entity_tags?: Maybe<Polls_Entity_Tags_Mutation_Response>;
  /** delete single row from the table: "polls_entity_tags" */
  delete_polls_entity_tags_by_pk?: Maybe<Polls_Entity_Tags>;
  /** delete data from the table: "polls_entityname" */
  delete_polls_entityname?: Maybe<Polls_Entityname_Mutation_Response>;
  /** delete single row from the table: "polls_entityname" */
  delete_polls_entityname_by_pk?: Maybe<Polls_Entityname>;
  /** delete data from the table: "polls_entitytag" */
  delete_polls_entitytag?: Maybe<Polls_Entitytag_Mutation_Response>;
  /** delete single row from the table: "polls_entitytag" */
  delete_polls_entitytag_by_pk?: Maybe<Polls_Entitytag>;
  /** delete data from the table: "polls_entry_attachment" */
  delete_polls_entry_attachment?: Maybe<Polls_Entry_Attachment_Mutation_Response>;
  /** delete single row from the table: "polls_entry_attachment" */
  delete_polls_entry_attachment_by_pk?: Maybe<Polls_Entry_Attachment>;
  /** delete data from the table: "polls_entryattachment" */
  delete_polls_entryattachment?: Maybe<Polls_Entryattachment_Mutation_Response>;
  /** delete single row from the table: "polls_entryattachment" */
  delete_polls_entryattachment_by_pk?: Maybe<Polls_Entryattachment>;
  /** delete data from the table: "polls_entryreference" */
  delete_polls_entryreference?: Maybe<Polls_Entryreference_Mutation_Response>;
  /** delete single row from the table: "polls_entryreference" */
  delete_polls_entryreference_by_pk?: Maybe<Polls_Entryreference>;
  /** delete data from the table: "polls_entrytaggroup" */
  delete_polls_entrytaggroup?: Maybe<Polls_Entrytaggroup_Mutation_Response>;
  /** delete single row from the table: "polls_entrytaggroup" */
  delete_polls_entrytaggroup_by_pk?: Maybe<Polls_Entrytaggroup>;
  /** delete data from the table: "polls_group" */
  delete_polls_group?: Maybe<Polls_Group_Mutation_Response>;
  /** delete single row from the table: "polls_group" */
  delete_polls_group_by_pk?: Maybe<Polls_Group>;
  /** delete data from the table: "polls_poll" */
  delete_polls_poll?: Maybe<Polls_Poll_Mutation_Response>;
  /** delete single row from the table: "polls_poll" */
  delete_polls_poll_by_pk?: Maybe<Polls_Poll>;
  /** delete data from the table: "polls_poll_optional_entry_tag_groups" */
  delete_polls_poll_optional_entry_tag_groups?: Maybe<Polls_Poll_Optional_Entry_Tag_Groups_Mutation_Response>;
  /** delete single row from the table: "polls_poll_optional_entry_tag_groups" */
  delete_polls_poll_optional_entry_tag_groups_by_pk?: Maybe<Polls_Poll_Optional_Entry_Tag_Groups>;
  /** delete data from the table: "polls_poll_required_entry_tag_groups" */
  delete_polls_poll_required_entry_tag_groups?: Maybe<Polls_Poll_Required_Entry_Tag_Groups_Mutation_Response>;
  /** delete single row from the table: "polls_poll_required_entry_tag_groups" */
  delete_polls_poll_required_entry_tag_groups_by_pk?: Maybe<Polls_Poll_Required_Entry_Tag_Groups>;
  /** delete data from the table: "polls_pollprogress" */
  delete_polls_pollprogress?: Maybe<Polls_Pollprogress_Mutation_Response>;
  /** delete single row from the table: "polls_pollprogress" */
  delete_polls_pollprogress_by_pk?: Maybe<Polls_Pollprogress>;
  /** delete data from the table: "polls_pollprogress_considered_answer_sets" */
  delete_polls_pollprogress_considered_answer_sets?: Maybe<Polls_Pollprogress_Considered_Answer_Sets_Mutation_Response>;
  /** delete single row from the table: "polls_pollprogress_considered_answer_sets" */
  delete_polls_pollprogress_considered_answer_sets_by_pk?: Maybe<Polls_Pollprogress_Considered_Answer_Sets>;
  /** delete data from the table: "polls_question" */
  delete_polls_question?: Maybe<Polls_Question_Mutation_Response>;
  /** delete single row from the table: "polls_question" */
  delete_polls_question_by_pk?: Maybe<Polls_Question>;
  /** delete data from the table: "polls_questionrelation" */
  delete_polls_questionrelation?: Maybe<Polls_Questionrelation_Mutation_Response>;
  /** delete single row from the table: "polls_questionrelation" */
  delete_polls_questionrelation_by_pk?: Maybe<Polls_Questionrelation>;
  /** delete data from the table: "polls_searchrequest" */
  delete_polls_searchrequest?: Maybe<Polls_Searchrequest_Mutation_Response>;
  /** delete single row from the table: "polls_searchrequest" */
  delete_polls_searchrequest_by_pk?: Maybe<Polls_Searchrequest>;
  /** delete data from the table: "polls_secondarysource" */
  delete_polls_secondarysource?: Maybe<Polls_Secondarysource_Mutation_Response>;
  /** delete single row from the table: "polls_secondarysource" */
  delete_polls_secondarysource_by_pk?: Maybe<Polls_Secondarysource>;
  /** delete data from the table: "polls_templateanswer" */
  delete_polls_templateanswer?: Maybe<Polls_Templateanswer_Mutation_Response>;
  /** delete single row from the table: "polls_templateanswer" */
  delete_polls_templateanswer_by_pk?: Maybe<Polls_Templateanswer>;
  /** delete data from the table: "polls_templateanswerset" */
  delete_polls_templateanswerset?: Maybe<Polls_Templateanswerset_Mutation_Response>;
  /** delete single row from the table: "polls_templateanswerset" */
  delete_polls_templateanswerset_by_pk?: Maybe<Polls_Templateanswerset>;
  /** delete data from the table: "user_file" */
  delete_user_file?: Maybe<User_File_Mutation_Response>;
  /** delete single row from the table: "user_file" */
  delete_user_file_by_pk?: Maybe<User_File>;
  disable_poll: Scalars['Boolean'];
  enable_poll: Scalars['Boolean'];
  /** insert data into the table: "accounts_expert" */
  insert_accounts_expert?: Maybe<Accounts_Expert_Mutation_Response>;
  /** insert a single row into the table: "accounts_expert" */
  insert_accounts_expert_one?: Maybe<Accounts_Expert>;
  /** insert data into the table: "accounts_managingeditor" */
  insert_accounts_managingeditor?: Maybe<Accounts_Managingeditor_Mutation_Response>;
  /** insert a single row into the table: "accounts_managingeditor" */
  insert_accounts_managingeditor_one?: Maybe<Accounts_Managingeditor>;
  /** insert data into the table: "accounts_profile" */
  insert_accounts_profile?: Maybe<Accounts_Profile_Mutation_Response>;
  /** insert a single row into the table: "accounts_profile" */
  insert_accounts_profile_one?: Maybe<Accounts_Profile>;
  /** insert data into the table: "accounts_regionaleditor" */
  insert_accounts_regionaleditor?: Maybe<Accounts_Regionaleditor_Mutation_Response>;
  /** insert a single row into the table: "accounts_regionaleditor" */
  insert_accounts_regionaleditor_one?: Maybe<Accounts_Regionaleditor>;
  /** insert data into the table: "accounts_regionaleditorcategory" */
  insert_accounts_regionaleditorcategory?: Maybe<Accounts_Regionaleditorcategory_Mutation_Response>;
  /** insert data into the table: "accounts_regionaleditorcategory_editors" */
  insert_accounts_regionaleditorcategory_editors?: Maybe<Accounts_Regionaleditorcategory_Editors_Mutation_Response>;
  /** insert a single row into the table: "accounts_regionaleditorcategory_editors" */
  insert_accounts_regionaleditorcategory_editors_one?: Maybe<Accounts_Regionaleditorcategory_Editors>;
  /** insert a single row into the table: "accounts_regionaleditorcategory" */
  insert_accounts_regionaleditorcategory_one?: Maybe<Accounts_Regionaleditorcategory>;
  /** insert data into the table: "accounts_translator" */
  insert_accounts_translator?: Maybe<Accounts_Translator_Mutation_Response>;
  /** insert a single row into the table: "accounts_translator" */
  insert_accounts_translator_one?: Maybe<Accounts_Translator>;
  /** insert data into the table: "analyze_user_query" */
  insert_analyze_user_query?: Maybe<Analyze_User_Query_Mutation_Response>;
  /** insert a single row into the table: "analyze_user_query" */
  insert_analyze_user_query_one?: Maybe<Analyze_User_Query>;
  /** insert data into the table: "auth_user" */
  insert_auth_user?: Maybe<Auth_User_Mutation_Response>;
  /** insert a single row into the table: "auth_user" */
  insert_auth_user_one?: Maybe<Auth_User>;
  /** insert data into the table: "gis_regions_gis_region" */
  insert_gis_regions_gis_region?: Maybe<Gis_Regions_Gis_Region_Mutation_Response>;
  /** insert a single row into the table: "gis_regions_gis_region" */
  insert_gis_regions_gis_region_one?: Maybe<Gis_Regions_Gis_Region>;
  /** insert data into the table: "gis_regions_gis_region_tags" */
  insert_gis_regions_gis_region_tags?: Maybe<Gis_Regions_Gis_Region_Tags_Mutation_Response>;
  /** insert a single row into the table: "gis_regions_gis_region_tags" */
  insert_gis_regions_gis_region_tags_one?: Maybe<Gis_Regions_Gis_Region_Tags>;
  /** insert data into the table: "gis_regions_gis_tag" */
  insert_gis_regions_gis_tag?: Maybe<Gis_Regions_Gis_Tag_Mutation_Response>;
  /** insert a single row into the table: "gis_regions_gis_tag" */
  insert_gis_regions_gis_tag_one?: Maybe<Gis_Regions_Gis_Tag>;
  /** insert data into the table: "poll_drafts" */
  insert_poll_drafts?: Maybe<Poll_Drafts_Mutation_Response>;
  /** insert a single row into the table: "poll_drafts" */
  insert_poll_drafts_one?: Maybe<Poll_Drafts>;
  /** insert data into the table: "polls_answer" */
  insert_polls_answer?: Maybe<Polls_Answer_Mutation_Response>;
  /** insert a single row into the table: "polls_answer" */
  insert_polls_answer_one?: Maybe<Polls_Answer>;
  /** insert data into the table: "polls_answer_set_attachment" */
  insert_polls_answer_set_attachment?: Maybe<Polls_Answer_Set_Attachment_Mutation_Response>;
  /** insert a single row into the table: "polls_answer_set_attachment" */
  insert_polls_answer_set_attachment_one?: Maybe<Polls_Answer_Set_Attachment>;
  /** insert data into the table: "polls_answerset" */
  insert_polls_answerset?: Maybe<Polls_Answerset_Mutation_Response>;
  /** insert a single row into the table: "polls_answerset" */
  insert_polls_answerset_one?: Maybe<Polls_Answerset>;
  /** insert data into the table: "polls_answersetattachment" */
  insert_polls_answersetattachment?: Maybe<Polls_Answersetattachment_Mutation_Response>;
  /** insert a single row into the table: "polls_answersetattachment" */
  insert_polls_answersetattachment_one?: Maybe<Polls_Answersetattachment>;
  /** insert data into the table: "polls_baseanswerset" */
  insert_polls_baseanswerset?: Maybe<Polls_Baseanswerset_Mutation_Response>;
  /** insert data into the table: "polls_baseanswerset_branches" */
  insert_polls_baseanswerset_branches?: Maybe<Polls_Baseanswerset_Branches_Mutation_Response>;
  /** insert a single row into the table: "polls_baseanswerset_branches" */
  insert_polls_baseanswerset_branches_one?: Maybe<Polls_Baseanswerset_Branches>;
  /** insert a single row into the table: "polls_baseanswerset" */
  insert_polls_baseanswerset_one?: Maybe<Polls_Baseanswerset>;
  /** insert data into the table: "polls_basesource" */
  insert_polls_basesource?: Maybe<Polls_Basesource_Mutation_Response>;
  /** insert a single row into the table: "polls_basesource" */
  insert_polls_basesource_one?: Maybe<Polls_Basesource>;
  /** insert data into the table: "polls_branch" */
  insert_polls_branch?: Maybe<Polls_Branch_Mutation_Response>;
  /** insert a single row into the table: "polls_branch" */
  insert_polls_branch_one?: Maybe<Polls_Branch>;
  /** insert data into the table: "polls_branchingquestion" */
  insert_polls_branchingquestion?: Maybe<Polls_Branchingquestion_Mutation_Response>;
  /** insert a single row into the table: "polls_branchingquestion" */
  insert_polls_branchingquestion_one?: Maybe<Polls_Branchingquestion>;
  /** insert data into the table: "polls_category" */
  insert_polls_category?: Maybe<Polls_Category_Mutation_Response>;
  /** insert a single row into the table: "polls_category" */
  insert_polls_category_one?: Maybe<Polls_Category>;
  /** insert data into the table: "polls_categoryprogress" */
  insert_polls_categoryprogress?: Maybe<Polls_Categoryprogress_Mutation_Response>;
  /** insert a single row into the table: "polls_categoryprogress" */
  insert_polls_categoryprogress_one?: Maybe<Polls_Categoryprogress>;
  /** insert data into the table: "polls_comment" */
  insert_polls_comment?: Maybe<Polls_Comment_Mutation_Response>;
  /** insert a single row into the table: "polls_comment" */
  insert_polls_comment_one?: Maybe<Polls_Comment>;
  /** insert data into the table: "polls_datasource" */
  insert_polls_datasource?: Maybe<Polls_Datasource_Mutation_Response>;
  /** insert a single row into the table: "polls_datasource" */
  insert_polls_datasource_one?: Maybe<Polls_Datasource>;
  /** insert data into the table: "polls_entity" */
  insert_polls_entity?: Maybe<Polls_Entity_Mutation_Response>;
  /** insert data into the table: "polls_entity_alt_names" */
  insert_polls_entity_alt_names?: Maybe<Polls_Entity_Alt_Names_Mutation_Response>;
  /** insert a single row into the table: "polls_entity_alt_names" */
  insert_polls_entity_alt_names_one?: Maybe<Polls_Entity_Alt_Names>;
  /** insert a single row into the table: "polls_entity" */
  insert_polls_entity_one?: Maybe<Polls_Entity>;
  /** insert data into the table: "polls_entity_tags" */
  insert_polls_entity_tags?: Maybe<Polls_Entity_Tags_Mutation_Response>;
  /** insert a single row into the table: "polls_entity_tags" */
  insert_polls_entity_tags_one?: Maybe<Polls_Entity_Tags>;
  /** insert data into the table: "polls_entityname" */
  insert_polls_entityname?: Maybe<Polls_Entityname_Mutation_Response>;
  /** insert a single row into the table: "polls_entityname" */
  insert_polls_entityname_one?: Maybe<Polls_Entityname>;
  /** insert data into the table: "polls_entitytag" */
  insert_polls_entitytag?: Maybe<Polls_Entitytag_Mutation_Response>;
  /** insert a single row into the table: "polls_entitytag" */
  insert_polls_entitytag_one?: Maybe<Polls_Entitytag>;
  /** insert data into the table: "polls_entry_attachment" */
  insert_polls_entry_attachment?: Maybe<Polls_Entry_Attachment_Mutation_Response>;
  /** insert a single row into the table: "polls_entry_attachment" */
  insert_polls_entry_attachment_one?: Maybe<Polls_Entry_Attachment>;
  /** insert data into the table: "polls_entryattachment" */
  insert_polls_entryattachment?: Maybe<Polls_Entryattachment_Mutation_Response>;
  /** insert a single row into the table: "polls_entryattachment" */
  insert_polls_entryattachment_one?: Maybe<Polls_Entryattachment>;
  /** insert data into the table: "polls_entryreference" */
  insert_polls_entryreference?: Maybe<Polls_Entryreference_Mutation_Response>;
  /** insert a single row into the table: "polls_entryreference" */
  insert_polls_entryreference_one?: Maybe<Polls_Entryreference>;
  /** insert data into the table: "polls_entrytaggroup" */
  insert_polls_entrytaggroup?: Maybe<Polls_Entrytaggroup_Mutation_Response>;
  /** insert a single row into the table: "polls_entrytaggroup" */
  insert_polls_entrytaggroup_one?: Maybe<Polls_Entrytaggroup>;
  /** insert data into the table: "polls_group" */
  insert_polls_group?: Maybe<Polls_Group_Mutation_Response>;
  /** insert a single row into the table: "polls_group" */
  insert_polls_group_one?: Maybe<Polls_Group>;
  /** insert data into the table: "polls_poll" */
  insert_polls_poll?: Maybe<Polls_Poll_Mutation_Response>;
  /** insert a single row into the table: "polls_poll" */
  insert_polls_poll_one?: Maybe<Polls_Poll>;
  /** insert data into the table: "polls_poll_optional_entry_tag_groups" */
  insert_polls_poll_optional_entry_tag_groups?: Maybe<Polls_Poll_Optional_Entry_Tag_Groups_Mutation_Response>;
  /** insert a single row into the table: "polls_poll_optional_entry_tag_groups" */
  insert_polls_poll_optional_entry_tag_groups_one?: Maybe<Polls_Poll_Optional_Entry_Tag_Groups>;
  /** insert data into the table: "polls_poll_required_entry_tag_groups" */
  insert_polls_poll_required_entry_tag_groups?: Maybe<Polls_Poll_Required_Entry_Tag_Groups_Mutation_Response>;
  /** insert a single row into the table: "polls_poll_required_entry_tag_groups" */
  insert_polls_poll_required_entry_tag_groups_one?: Maybe<Polls_Poll_Required_Entry_Tag_Groups>;
  /** insert data into the table: "polls_pollprogress" */
  insert_polls_pollprogress?: Maybe<Polls_Pollprogress_Mutation_Response>;
  /** insert data into the table: "polls_pollprogress_considered_answer_sets" */
  insert_polls_pollprogress_considered_answer_sets?: Maybe<Polls_Pollprogress_Considered_Answer_Sets_Mutation_Response>;
  /** insert a single row into the table: "polls_pollprogress_considered_answer_sets" */
  insert_polls_pollprogress_considered_answer_sets_one?: Maybe<Polls_Pollprogress_Considered_Answer_Sets>;
  /** insert a single row into the table: "polls_pollprogress" */
  insert_polls_pollprogress_one?: Maybe<Polls_Pollprogress>;
  /** insert data into the table: "polls_question" */
  insert_polls_question?: Maybe<Polls_Question_Mutation_Response>;
  /** insert a single row into the table: "polls_question" */
  insert_polls_question_one?: Maybe<Polls_Question>;
  /** insert data into the table: "polls_questionrelation" */
  insert_polls_questionrelation?: Maybe<Polls_Questionrelation_Mutation_Response>;
  /** insert a single row into the table: "polls_questionrelation" */
  insert_polls_questionrelation_one?: Maybe<Polls_Questionrelation>;
  /** insert data into the table: "polls_searchrequest" */
  insert_polls_searchrequest?: Maybe<Polls_Searchrequest_Mutation_Response>;
  /** insert a single row into the table: "polls_searchrequest" */
  insert_polls_searchrequest_one?: Maybe<Polls_Searchrequest>;
  /** insert data into the table: "polls_secondarysource" */
  insert_polls_secondarysource?: Maybe<Polls_Secondarysource_Mutation_Response>;
  /** insert a single row into the table: "polls_secondarysource" */
  insert_polls_secondarysource_one?: Maybe<Polls_Secondarysource>;
  /** insert data into the table: "polls_templateanswer" */
  insert_polls_templateanswer?: Maybe<Polls_Templateanswer_Mutation_Response>;
  /** insert a single row into the table: "polls_templateanswer" */
  insert_polls_templateanswer_one?: Maybe<Polls_Templateanswer>;
  /** insert data into the table: "polls_templateanswerset" */
  insert_polls_templateanswerset?: Maybe<Polls_Templateanswerset_Mutation_Response>;
  /** insert a single row into the table: "polls_templateanswerset" */
  insert_polls_templateanswerset_one?: Maybe<Polls_Templateanswerset>;
  /** insert data into the table: "user_file" */
  insert_user_file?: Maybe<User_File_Mutation_Response>;
  /** insert a single row into the table: "user_file" */
  insert_user_file_one?: Maybe<User_File>;
  publish_poll_draft: Scalars['Int'];
  setSessionLanguage: Scalars['String'];
  /** update data of the table: "accounts_expert" */
  update_accounts_expert?: Maybe<Accounts_Expert_Mutation_Response>;
  /** update single row of the table: "accounts_expert" */
  update_accounts_expert_by_pk?: Maybe<Accounts_Expert>;
  /** update data of the table: "accounts_managingeditor" */
  update_accounts_managingeditor?: Maybe<Accounts_Managingeditor_Mutation_Response>;
  /** update single row of the table: "accounts_managingeditor" */
  update_accounts_managingeditor_by_pk?: Maybe<Accounts_Managingeditor>;
  /** update data of the table: "accounts_profile" */
  update_accounts_profile?: Maybe<Accounts_Profile_Mutation_Response>;
  /** update single row of the table: "accounts_profile" */
  update_accounts_profile_by_pk?: Maybe<Accounts_Profile>;
  /** update data of the table: "accounts_regionaleditor" */
  update_accounts_regionaleditor?: Maybe<Accounts_Regionaleditor_Mutation_Response>;
  /** update single row of the table: "accounts_regionaleditor" */
  update_accounts_regionaleditor_by_pk?: Maybe<Accounts_Regionaleditor>;
  /** update data of the table: "accounts_regionaleditorcategory" */
  update_accounts_regionaleditorcategory?: Maybe<Accounts_Regionaleditorcategory_Mutation_Response>;
  /** update single row of the table: "accounts_regionaleditorcategory" */
  update_accounts_regionaleditorcategory_by_pk?: Maybe<Accounts_Regionaleditorcategory>;
  /** update data of the table: "accounts_regionaleditorcategory_editors" */
  update_accounts_regionaleditorcategory_editors?: Maybe<Accounts_Regionaleditorcategory_Editors_Mutation_Response>;
  /** update single row of the table: "accounts_regionaleditorcategory_editors" */
  update_accounts_regionaleditorcategory_editors_by_pk?: Maybe<Accounts_Regionaleditorcategory_Editors>;
  /** update data of the table: "accounts_translator" */
  update_accounts_translator?: Maybe<Accounts_Translator_Mutation_Response>;
  /** update single row of the table: "accounts_translator" */
  update_accounts_translator_by_pk?: Maybe<Accounts_Translator>;
  /** update data of the table: "analyze_user_query" */
  update_analyze_user_query?: Maybe<Analyze_User_Query_Mutation_Response>;
  /** update single row of the table: "analyze_user_query" */
  update_analyze_user_query_by_pk?: Maybe<Analyze_User_Query>;
  /** update data of the table: "auth_user" */
  update_auth_user?: Maybe<Auth_User_Mutation_Response>;
  /** update single row of the table: "auth_user" */
  update_auth_user_by_pk?: Maybe<Auth_User>;
  /** update data of the table: "gis_regions_gis_region" */
  update_gis_regions_gis_region?: Maybe<Gis_Regions_Gis_Region_Mutation_Response>;
  /** update single row of the table: "gis_regions_gis_region" */
  update_gis_regions_gis_region_by_pk?: Maybe<Gis_Regions_Gis_Region>;
  /** update data of the table: "gis_regions_gis_region_tags" */
  update_gis_regions_gis_region_tags?: Maybe<Gis_Regions_Gis_Region_Tags_Mutation_Response>;
  /** update single row of the table: "gis_regions_gis_region_tags" */
  update_gis_regions_gis_region_tags_by_pk?: Maybe<Gis_Regions_Gis_Region_Tags>;
  /** update data of the table: "gis_regions_gis_tag" */
  update_gis_regions_gis_tag?: Maybe<Gis_Regions_Gis_Tag_Mutation_Response>;
  /** update single row of the table: "gis_regions_gis_tag" */
  update_gis_regions_gis_tag_by_pk?: Maybe<Gis_Regions_Gis_Tag>;
  /** update data of the table: "poll_drafts" */
  update_poll_drafts?: Maybe<Poll_Drafts_Mutation_Response>;
  /** update single row of the table: "poll_drafts" */
  update_poll_drafts_by_pk?: Maybe<Poll_Drafts>;
  /** update data of the table: "polls_answer" */
  update_polls_answer?: Maybe<Polls_Answer_Mutation_Response>;
  /** update single row of the table: "polls_answer" */
  update_polls_answer_by_pk?: Maybe<Polls_Answer>;
  /** update data of the table: "polls_answer_set_attachment" */
  update_polls_answer_set_attachment?: Maybe<Polls_Answer_Set_Attachment_Mutation_Response>;
  /** update single row of the table: "polls_answer_set_attachment" */
  update_polls_answer_set_attachment_by_pk?: Maybe<Polls_Answer_Set_Attachment>;
  /** update data of the table: "polls_answerset" */
  update_polls_answerset?: Maybe<Polls_Answerset_Mutation_Response>;
  /** update single row of the table: "polls_answerset" */
  update_polls_answerset_by_pk?: Maybe<Polls_Answerset>;
  /** update data of the table: "polls_answersetattachment" */
  update_polls_answersetattachment?: Maybe<Polls_Answersetattachment_Mutation_Response>;
  /** update single row of the table: "polls_answersetattachment" */
  update_polls_answersetattachment_by_pk?: Maybe<Polls_Answersetattachment>;
  /** update data of the table: "polls_baseanswerset" */
  update_polls_baseanswerset?: Maybe<Polls_Baseanswerset_Mutation_Response>;
  /** update data of the table: "polls_baseanswerset_branches" */
  update_polls_baseanswerset_branches?: Maybe<Polls_Baseanswerset_Branches_Mutation_Response>;
  /** update single row of the table: "polls_baseanswerset_branches" */
  update_polls_baseanswerset_branches_by_pk?: Maybe<Polls_Baseanswerset_Branches>;
  /** update single row of the table: "polls_baseanswerset" */
  update_polls_baseanswerset_by_pk?: Maybe<Polls_Baseanswerset>;
  /** update data of the table: "polls_basesource" */
  update_polls_basesource?: Maybe<Polls_Basesource_Mutation_Response>;
  /** update single row of the table: "polls_basesource" */
  update_polls_basesource_by_pk?: Maybe<Polls_Basesource>;
  /** update data of the table: "polls_branch" */
  update_polls_branch?: Maybe<Polls_Branch_Mutation_Response>;
  /** update single row of the table: "polls_branch" */
  update_polls_branch_by_pk?: Maybe<Polls_Branch>;
  /** update data of the table: "polls_branchingquestion" */
  update_polls_branchingquestion?: Maybe<Polls_Branchingquestion_Mutation_Response>;
  /** update single row of the table: "polls_branchingquestion" */
  update_polls_branchingquestion_by_pk?: Maybe<Polls_Branchingquestion>;
  /** update data of the table: "polls_category" */
  update_polls_category?: Maybe<Polls_Category_Mutation_Response>;
  /** update single row of the table: "polls_category" */
  update_polls_category_by_pk?: Maybe<Polls_Category>;
  /** update data of the table: "polls_categoryprogress" */
  update_polls_categoryprogress?: Maybe<Polls_Categoryprogress_Mutation_Response>;
  /** update single row of the table: "polls_categoryprogress" */
  update_polls_categoryprogress_by_pk?: Maybe<Polls_Categoryprogress>;
  /** update data of the table: "polls_comment" */
  update_polls_comment?: Maybe<Polls_Comment_Mutation_Response>;
  /** update single row of the table: "polls_comment" */
  update_polls_comment_by_pk?: Maybe<Polls_Comment>;
  /** update data of the table: "polls_datasource" */
  update_polls_datasource?: Maybe<Polls_Datasource_Mutation_Response>;
  /** update single row of the table: "polls_datasource" */
  update_polls_datasource_by_pk?: Maybe<Polls_Datasource>;
  /** update data of the table: "polls_entity" */
  update_polls_entity?: Maybe<Polls_Entity_Mutation_Response>;
  /** update data of the table: "polls_entity_alt_names" */
  update_polls_entity_alt_names?: Maybe<Polls_Entity_Alt_Names_Mutation_Response>;
  /** update single row of the table: "polls_entity_alt_names" */
  update_polls_entity_alt_names_by_pk?: Maybe<Polls_Entity_Alt_Names>;
  /** update single row of the table: "polls_entity" */
  update_polls_entity_by_pk?: Maybe<Polls_Entity>;
  /** update data of the table: "polls_entity_tags" */
  update_polls_entity_tags?: Maybe<Polls_Entity_Tags_Mutation_Response>;
  /** update single row of the table: "polls_entity_tags" */
  update_polls_entity_tags_by_pk?: Maybe<Polls_Entity_Tags>;
  /** update data of the table: "polls_entityname" */
  update_polls_entityname?: Maybe<Polls_Entityname_Mutation_Response>;
  /** update single row of the table: "polls_entityname" */
  update_polls_entityname_by_pk?: Maybe<Polls_Entityname>;
  /** update data of the table: "polls_entitytag" */
  update_polls_entitytag?: Maybe<Polls_Entitytag_Mutation_Response>;
  /** update single row of the table: "polls_entitytag" */
  update_polls_entitytag_by_pk?: Maybe<Polls_Entitytag>;
  /** update data of the table: "polls_entry_attachment" */
  update_polls_entry_attachment?: Maybe<Polls_Entry_Attachment_Mutation_Response>;
  /** update single row of the table: "polls_entry_attachment" */
  update_polls_entry_attachment_by_pk?: Maybe<Polls_Entry_Attachment>;
  /** update data of the table: "polls_entryattachment" */
  update_polls_entryattachment?: Maybe<Polls_Entryattachment_Mutation_Response>;
  /** update single row of the table: "polls_entryattachment" */
  update_polls_entryattachment_by_pk?: Maybe<Polls_Entryattachment>;
  /** update data of the table: "polls_entryreference" */
  update_polls_entryreference?: Maybe<Polls_Entryreference_Mutation_Response>;
  /** update single row of the table: "polls_entryreference" */
  update_polls_entryreference_by_pk?: Maybe<Polls_Entryreference>;
  /** update data of the table: "polls_entrytaggroup" */
  update_polls_entrytaggroup?: Maybe<Polls_Entrytaggroup_Mutation_Response>;
  /** update single row of the table: "polls_entrytaggroup" */
  update_polls_entrytaggroup_by_pk?: Maybe<Polls_Entrytaggroup>;
  /** update data of the table: "polls_group" */
  update_polls_group?: Maybe<Polls_Group_Mutation_Response>;
  /** update single row of the table: "polls_group" */
  update_polls_group_by_pk?: Maybe<Polls_Group>;
  /** update data of the table: "polls_poll" */
  update_polls_poll?: Maybe<Polls_Poll_Mutation_Response>;
  /** update single row of the table: "polls_poll" */
  update_polls_poll_by_pk?: Maybe<Polls_Poll>;
  /** update data of the table: "polls_poll_optional_entry_tag_groups" */
  update_polls_poll_optional_entry_tag_groups?: Maybe<Polls_Poll_Optional_Entry_Tag_Groups_Mutation_Response>;
  /** update single row of the table: "polls_poll_optional_entry_tag_groups" */
  update_polls_poll_optional_entry_tag_groups_by_pk?: Maybe<Polls_Poll_Optional_Entry_Tag_Groups>;
  /** update data of the table: "polls_poll_required_entry_tag_groups" */
  update_polls_poll_required_entry_tag_groups?: Maybe<Polls_Poll_Required_Entry_Tag_Groups_Mutation_Response>;
  /** update single row of the table: "polls_poll_required_entry_tag_groups" */
  update_polls_poll_required_entry_tag_groups_by_pk?: Maybe<Polls_Poll_Required_Entry_Tag_Groups>;
  /** update data of the table: "polls_pollprogress" */
  update_polls_pollprogress?: Maybe<Polls_Pollprogress_Mutation_Response>;
  /** update single row of the table: "polls_pollprogress" */
  update_polls_pollprogress_by_pk?: Maybe<Polls_Pollprogress>;
  /** update data of the table: "polls_pollprogress_considered_answer_sets" */
  update_polls_pollprogress_considered_answer_sets?: Maybe<Polls_Pollprogress_Considered_Answer_Sets_Mutation_Response>;
  /** update single row of the table: "polls_pollprogress_considered_answer_sets" */
  update_polls_pollprogress_considered_answer_sets_by_pk?: Maybe<Polls_Pollprogress_Considered_Answer_Sets>;
  /** update data of the table: "polls_question" */
  update_polls_question?: Maybe<Polls_Question_Mutation_Response>;
  /** update single row of the table: "polls_question" */
  update_polls_question_by_pk?: Maybe<Polls_Question>;
  /** update data of the table: "polls_questionrelation" */
  update_polls_questionrelation?: Maybe<Polls_Questionrelation_Mutation_Response>;
  /** update single row of the table: "polls_questionrelation" */
  update_polls_questionrelation_by_pk?: Maybe<Polls_Questionrelation>;
  /** update data of the table: "polls_searchrequest" */
  update_polls_searchrequest?: Maybe<Polls_Searchrequest_Mutation_Response>;
  /** update single row of the table: "polls_searchrequest" */
  update_polls_searchrequest_by_pk?: Maybe<Polls_Searchrequest>;
  /** update data of the table: "polls_secondarysource" */
  update_polls_secondarysource?: Maybe<Polls_Secondarysource_Mutation_Response>;
  /** update single row of the table: "polls_secondarysource" */
  update_polls_secondarysource_by_pk?: Maybe<Polls_Secondarysource>;
  /** update data of the table: "polls_templateanswer" */
  update_polls_templateanswer?: Maybe<Polls_Templateanswer_Mutation_Response>;
  /** update single row of the table: "polls_templateanswer" */
  update_polls_templateanswer_by_pk?: Maybe<Polls_Templateanswer>;
  /** update data of the table: "polls_templateanswerset" */
  update_polls_templateanswerset?: Maybe<Polls_Templateanswerset_Mutation_Response>;
  /** update single row of the table: "polls_templateanswerset" */
  update_polls_templateanswerset_by_pk?: Maybe<Polls_Templateanswerset>;
  /** update data of the table: "user_file" */
  update_user_file?: Maybe<User_File_Mutation_Response>;
  /** update single row of the table: "user_file" */
  update_user_file_by_pk?: Maybe<User_File>;
  upgrade_entry_poll: UpgradeEntryPollSuccessResponse;
};


/** mutation root */
export type Mutation_RootDelete_Accounts_ExpertArgs = {
  where: Accounts_Expert_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Accounts_Expert_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Accounts_ManagingeditorArgs = {
  where: Accounts_Managingeditor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Accounts_Managingeditor_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Accounts_ProfileArgs = {
  where: Accounts_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Accounts_Profile_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Accounts_RegionaleditorArgs = {
  where: Accounts_Regionaleditor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Accounts_Regionaleditor_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Accounts_RegionaleditorcategoryArgs = {
  where: Accounts_Regionaleditorcategory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Accounts_Regionaleditorcategory_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Accounts_Regionaleditorcategory_EditorsArgs = {
  where: Accounts_Regionaleditorcategory_Editors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Accounts_Regionaleditorcategory_Editors_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Accounts_TranslatorArgs = {
  where: Accounts_Translator_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Accounts_Translator_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Analyze_User_QueryArgs = {
  where: Analyze_User_Query_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Analyze_User_Query_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Auth_UserArgs = {
  where: Auth_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Auth_User_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Gis_Regions_Gis_RegionArgs = {
  where: Gis_Regions_Gis_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Gis_Regions_Gis_Region_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Gis_Regions_Gis_Region_TagsArgs = {
  where: Gis_Regions_Gis_Region_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Gis_Regions_Gis_Region_Tags_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Gis_Regions_Gis_TagArgs = {
  where: Gis_Regions_Gis_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Gis_Regions_Gis_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Poll_DraftsArgs = {
  where: Poll_Drafts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Poll_Drafts_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_AnswerArgs = {
  where: Polls_Answer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Answer_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_Answer_Set_AttachmentArgs = {
  where: Polls_Answer_Set_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Answer_Set_Attachment_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_AnswersetArgs = {
  where: Polls_Answerset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Answerset_By_PkArgs = {
  baseanswerset_ptr_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_AnswersetattachmentArgs = {
  where: Polls_Answersetattachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Answersetattachment_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_BaseanswersetArgs = {
  where: Polls_Baseanswerset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Baseanswerset_BranchesArgs = {
  where: Polls_Baseanswerset_Branches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Baseanswerset_Branches_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_Baseanswerset_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_BasesourceArgs = {
  where: Polls_Basesource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Basesource_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_BranchArgs = {
  where: Polls_Branch_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Branch_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_BranchingquestionArgs = {
  where: Polls_Branchingquestion_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Branchingquestion_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_CategoryArgs = {
  where: Polls_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Category_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_CategoryprogressArgs = {
  where: Polls_Categoryprogress_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Categoryprogress_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_CommentArgs = {
  where: Polls_Comment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Comment_By_PkArgs = {
  baseanswerset_ptr_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_DatasourceArgs = {
  where: Polls_Datasource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Datasource_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_EntityArgs = {
  where: Polls_Entity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Entity_Alt_NamesArgs = {
  where: Polls_Entity_Alt_Names_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Entity_Alt_Names_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_Entity_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_Entity_TagsArgs = {
  where: Polls_Entity_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Entity_Tags_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_EntitynameArgs = {
  where: Polls_Entityname_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Entityname_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_EntitytagArgs = {
  where: Polls_Entitytag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Entitytag_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_Entry_AttachmentArgs = {
  where: Polls_Entry_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Entry_Attachment_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_EntryattachmentArgs = {
  where: Polls_Entryattachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Entryattachment_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_EntryreferenceArgs = {
  where: Polls_Entryreference_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Entryreference_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_EntrytaggroupArgs = {
  where: Polls_Entrytaggroup_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Entrytaggroup_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_GroupArgs = {
  where: Polls_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Group_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_PollArgs = {
  where: Polls_Poll_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Poll_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_Poll_Optional_Entry_Tag_GroupsArgs = {
  where: Polls_Poll_Optional_Entry_Tag_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Poll_Optional_Entry_Tag_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_Poll_Required_Entry_Tag_GroupsArgs = {
  where: Polls_Poll_Required_Entry_Tag_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Poll_Required_Entry_Tag_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_PollprogressArgs = {
  where: Polls_Pollprogress_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Pollprogress_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_Pollprogress_Considered_Answer_SetsArgs = {
  where: Polls_Pollprogress_Considered_Answer_Sets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Pollprogress_Considered_Answer_Sets_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_QuestionArgs = {
  where: Polls_Question_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Question_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_QuestionrelationArgs = {
  where: Polls_Questionrelation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Questionrelation_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_SearchrequestArgs = {
  where: Polls_Searchrequest_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Searchrequest_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_SecondarysourceArgs = {
  where: Polls_Secondarysource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Secondarysource_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_TemplateanswerArgs = {
  where: Polls_Templateanswer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Templateanswer_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Polls_TemplateanswersetArgs = {
  where: Polls_Templateanswerset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polls_Templateanswerset_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_FileArgs = {
  where: User_File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_File_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDisable_PollArgs = {
  poll_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootEnable_PollArgs = {
  poll_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootInsert_Accounts_ExpertArgs = {
  objects: Array<Accounts_Expert_Insert_Input>;
  on_conflict?: InputMaybe<Accounts_Expert_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Accounts_Expert_OneArgs = {
  object: Accounts_Expert_Insert_Input;
  on_conflict?: InputMaybe<Accounts_Expert_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Accounts_ManagingeditorArgs = {
  objects: Array<Accounts_Managingeditor_Insert_Input>;
  on_conflict?: InputMaybe<Accounts_Managingeditor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Accounts_Managingeditor_OneArgs = {
  object: Accounts_Managingeditor_Insert_Input;
  on_conflict?: InputMaybe<Accounts_Managingeditor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Accounts_ProfileArgs = {
  objects: Array<Accounts_Profile_Insert_Input>;
  on_conflict?: InputMaybe<Accounts_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Accounts_Profile_OneArgs = {
  object: Accounts_Profile_Insert_Input;
  on_conflict?: InputMaybe<Accounts_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Accounts_RegionaleditorArgs = {
  objects: Array<Accounts_Regionaleditor_Insert_Input>;
  on_conflict?: InputMaybe<Accounts_Regionaleditor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Accounts_Regionaleditor_OneArgs = {
  object: Accounts_Regionaleditor_Insert_Input;
  on_conflict?: InputMaybe<Accounts_Regionaleditor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Accounts_RegionaleditorcategoryArgs = {
  objects: Array<Accounts_Regionaleditorcategory_Insert_Input>;
  on_conflict?: InputMaybe<Accounts_Regionaleditorcategory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Accounts_Regionaleditorcategory_EditorsArgs = {
  objects: Array<Accounts_Regionaleditorcategory_Editors_Insert_Input>;
  on_conflict?: InputMaybe<Accounts_Regionaleditorcategory_Editors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Accounts_Regionaleditorcategory_Editors_OneArgs = {
  object: Accounts_Regionaleditorcategory_Editors_Insert_Input;
  on_conflict?: InputMaybe<Accounts_Regionaleditorcategory_Editors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Accounts_Regionaleditorcategory_OneArgs = {
  object: Accounts_Regionaleditorcategory_Insert_Input;
  on_conflict?: InputMaybe<Accounts_Regionaleditorcategory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Accounts_TranslatorArgs = {
  objects: Array<Accounts_Translator_Insert_Input>;
  on_conflict?: InputMaybe<Accounts_Translator_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Accounts_Translator_OneArgs = {
  object: Accounts_Translator_Insert_Input;
  on_conflict?: InputMaybe<Accounts_Translator_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Analyze_User_QueryArgs = {
  objects: Array<Analyze_User_Query_Insert_Input>;
  on_conflict?: InputMaybe<Analyze_User_Query_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Analyze_User_Query_OneArgs = {
  object: Analyze_User_Query_Insert_Input;
  on_conflict?: InputMaybe<Analyze_User_Query_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_UserArgs = {
  objects: Array<Auth_User_Insert_Input>;
  on_conflict?: InputMaybe<Auth_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_User_OneArgs = {
  object: Auth_User_Insert_Input;
  on_conflict?: InputMaybe<Auth_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gis_Regions_Gis_RegionArgs = {
  objects: Array<Gis_Regions_Gis_Region_Insert_Input>;
  on_conflict?: InputMaybe<Gis_Regions_Gis_Region_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gis_Regions_Gis_Region_OneArgs = {
  object: Gis_Regions_Gis_Region_Insert_Input;
  on_conflict?: InputMaybe<Gis_Regions_Gis_Region_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gis_Regions_Gis_Region_TagsArgs = {
  objects: Array<Gis_Regions_Gis_Region_Tags_Insert_Input>;
  on_conflict?: InputMaybe<Gis_Regions_Gis_Region_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gis_Regions_Gis_Region_Tags_OneArgs = {
  object: Gis_Regions_Gis_Region_Tags_Insert_Input;
  on_conflict?: InputMaybe<Gis_Regions_Gis_Region_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gis_Regions_Gis_TagArgs = {
  objects: Array<Gis_Regions_Gis_Tag_Insert_Input>;
  on_conflict?: InputMaybe<Gis_Regions_Gis_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gis_Regions_Gis_Tag_OneArgs = {
  object: Gis_Regions_Gis_Tag_Insert_Input;
  on_conflict?: InputMaybe<Gis_Regions_Gis_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Poll_DraftsArgs = {
  objects: Array<Poll_Drafts_Insert_Input>;
  on_conflict?: InputMaybe<Poll_Drafts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Poll_Drafts_OneArgs = {
  object: Poll_Drafts_Insert_Input;
  on_conflict?: InputMaybe<Poll_Drafts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_AnswerArgs = {
  objects: Array<Polls_Answer_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Answer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Answer_OneArgs = {
  object: Polls_Answer_Insert_Input;
  on_conflict?: InputMaybe<Polls_Answer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Answer_Set_AttachmentArgs = {
  objects: Array<Polls_Answer_Set_Attachment_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Answer_Set_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Answer_Set_Attachment_OneArgs = {
  object: Polls_Answer_Set_Attachment_Insert_Input;
  on_conflict?: InputMaybe<Polls_Answer_Set_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_AnswersetArgs = {
  objects: Array<Polls_Answerset_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Answerset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Answerset_OneArgs = {
  object: Polls_Answerset_Insert_Input;
  on_conflict?: InputMaybe<Polls_Answerset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_AnswersetattachmentArgs = {
  objects: Array<Polls_Answersetattachment_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Answersetattachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Answersetattachment_OneArgs = {
  object: Polls_Answersetattachment_Insert_Input;
  on_conflict?: InputMaybe<Polls_Answersetattachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_BaseanswersetArgs = {
  objects: Array<Polls_Baseanswerset_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Baseanswerset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Baseanswerset_BranchesArgs = {
  objects: Array<Polls_Baseanswerset_Branches_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Baseanswerset_Branches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Baseanswerset_Branches_OneArgs = {
  object: Polls_Baseanswerset_Branches_Insert_Input;
  on_conflict?: InputMaybe<Polls_Baseanswerset_Branches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Baseanswerset_OneArgs = {
  object: Polls_Baseanswerset_Insert_Input;
  on_conflict?: InputMaybe<Polls_Baseanswerset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_BasesourceArgs = {
  objects: Array<Polls_Basesource_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Basesource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Basesource_OneArgs = {
  object: Polls_Basesource_Insert_Input;
  on_conflict?: InputMaybe<Polls_Basesource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_BranchArgs = {
  objects: Array<Polls_Branch_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Branch_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Branch_OneArgs = {
  object: Polls_Branch_Insert_Input;
  on_conflict?: InputMaybe<Polls_Branch_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_BranchingquestionArgs = {
  objects: Array<Polls_Branchingquestion_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Branchingquestion_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Branchingquestion_OneArgs = {
  object: Polls_Branchingquestion_Insert_Input;
  on_conflict?: InputMaybe<Polls_Branchingquestion_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_CategoryArgs = {
  objects: Array<Polls_Category_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Category_OneArgs = {
  object: Polls_Category_Insert_Input;
  on_conflict?: InputMaybe<Polls_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_CategoryprogressArgs = {
  objects: Array<Polls_Categoryprogress_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Categoryprogress_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Categoryprogress_OneArgs = {
  object: Polls_Categoryprogress_Insert_Input;
  on_conflict?: InputMaybe<Polls_Categoryprogress_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_CommentArgs = {
  objects: Array<Polls_Comment_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Comment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Comment_OneArgs = {
  object: Polls_Comment_Insert_Input;
  on_conflict?: InputMaybe<Polls_Comment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_DatasourceArgs = {
  objects: Array<Polls_Datasource_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Datasource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Datasource_OneArgs = {
  object: Polls_Datasource_Insert_Input;
  on_conflict?: InputMaybe<Polls_Datasource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_EntityArgs = {
  objects: Array<Polls_Entity_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Entity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Entity_Alt_NamesArgs = {
  objects: Array<Polls_Entity_Alt_Names_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Entity_Alt_Names_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Entity_Alt_Names_OneArgs = {
  object: Polls_Entity_Alt_Names_Insert_Input;
  on_conflict?: InputMaybe<Polls_Entity_Alt_Names_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Entity_OneArgs = {
  object: Polls_Entity_Insert_Input;
  on_conflict?: InputMaybe<Polls_Entity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Entity_TagsArgs = {
  objects: Array<Polls_Entity_Tags_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Entity_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Entity_Tags_OneArgs = {
  object: Polls_Entity_Tags_Insert_Input;
  on_conflict?: InputMaybe<Polls_Entity_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_EntitynameArgs = {
  objects: Array<Polls_Entityname_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Entityname_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Entityname_OneArgs = {
  object: Polls_Entityname_Insert_Input;
  on_conflict?: InputMaybe<Polls_Entityname_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_EntitytagArgs = {
  objects: Array<Polls_Entitytag_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Entitytag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Entitytag_OneArgs = {
  object: Polls_Entitytag_Insert_Input;
  on_conflict?: InputMaybe<Polls_Entitytag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Entry_AttachmentArgs = {
  objects: Array<Polls_Entry_Attachment_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Entry_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Entry_Attachment_OneArgs = {
  object: Polls_Entry_Attachment_Insert_Input;
  on_conflict?: InputMaybe<Polls_Entry_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_EntryattachmentArgs = {
  objects: Array<Polls_Entryattachment_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Entryattachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Entryattachment_OneArgs = {
  object: Polls_Entryattachment_Insert_Input;
  on_conflict?: InputMaybe<Polls_Entryattachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_EntryreferenceArgs = {
  objects: Array<Polls_Entryreference_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Entryreference_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Entryreference_OneArgs = {
  object: Polls_Entryreference_Insert_Input;
  on_conflict?: InputMaybe<Polls_Entryreference_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_EntrytaggroupArgs = {
  objects: Array<Polls_Entrytaggroup_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Entrytaggroup_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Entrytaggroup_OneArgs = {
  object: Polls_Entrytaggroup_Insert_Input;
  on_conflict?: InputMaybe<Polls_Entrytaggroup_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_GroupArgs = {
  objects: Array<Polls_Group_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Group_OneArgs = {
  object: Polls_Group_Insert_Input;
  on_conflict?: InputMaybe<Polls_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_PollArgs = {
  objects: Array<Polls_Poll_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Poll_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Poll_OneArgs = {
  object: Polls_Poll_Insert_Input;
  on_conflict?: InputMaybe<Polls_Poll_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Poll_Optional_Entry_Tag_GroupsArgs = {
  objects: Array<Polls_Poll_Optional_Entry_Tag_Groups_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Poll_Optional_Entry_Tag_Groups_OneArgs = {
  object: Polls_Poll_Optional_Entry_Tag_Groups_Insert_Input;
  on_conflict?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Poll_Required_Entry_Tag_GroupsArgs = {
  objects: Array<Polls_Poll_Required_Entry_Tag_Groups_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Poll_Required_Entry_Tag_Groups_OneArgs = {
  object: Polls_Poll_Required_Entry_Tag_Groups_Insert_Input;
  on_conflict?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_PollprogressArgs = {
  objects: Array<Polls_Pollprogress_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Pollprogress_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Pollprogress_Considered_Answer_SetsArgs = {
  objects: Array<Polls_Pollprogress_Considered_Answer_Sets_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Pollprogress_Considered_Answer_Sets_OneArgs = {
  object: Polls_Pollprogress_Considered_Answer_Sets_Insert_Input;
  on_conflict?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Pollprogress_OneArgs = {
  object: Polls_Pollprogress_Insert_Input;
  on_conflict?: InputMaybe<Polls_Pollprogress_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_QuestionArgs = {
  objects: Array<Polls_Question_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Question_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Question_OneArgs = {
  object: Polls_Question_Insert_Input;
  on_conflict?: InputMaybe<Polls_Question_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_QuestionrelationArgs = {
  objects: Array<Polls_Questionrelation_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Questionrelation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Questionrelation_OneArgs = {
  object: Polls_Questionrelation_Insert_Input;
  on_conflict?: InputMaybe<Polls_Questionrelation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_SearchrequestArgs = {
  objects: Array<Polls_Searchrequest_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Searchrequest_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Searchrequest_OneArgs = {
  object: Polls_Searchrequest_Insert_Input;
  on_conflict?: InputMaybe<Polls_Searchrequest_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_SecondarysourceArgs = {
  objects: Array<Polls_Secondarysource_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Secondarysource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Secondarysource_OneArgs = {
  object: Polls_Secondarysource_Insert_Input;
  on_conflict?: InputMaybe<Polls_Secondarysource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_TemplateanswerArgs = {
  objects: Array<Polls_Templateanswer_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Templateanswer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Templateanswer_OneArgs = {
  object: Polls_Templateanswer_Insert_Input;
  on_conflict?: InputMaybe<Polls_Templateanswer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_TemplateanswersetArgs = {
  objects: Array<Polls_Templateanswerset_Insert_Input>;
  on_conflict?: InputMaybe<Polls_Templateanswerset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polls_Templateanswerset_OneArgs = {
  object: Polls_Templateanswerset_Insert_Input;
  on_conflict?: InputMaybe<Polls_Templateanswerset_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_FileArgs = {
  objects: Array<User_File_Insert_Input>;
  on_conflict?: InputMaybe<User_File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_File_OneArgs = {
  object: User_File_Insert_Input;
  on_conflict?: InputMaybe<User_File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootPublish_Poll_DraftArgs = {
  draft_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootSetSessionLanguageArgs = {
  language: Scalars['String'];
};


/** mutation root */
export type Mutation_RootUpdate_Accounts_ExpertArgs = {
  _inc?: InputMaybe<Accounts_Expert_Inc_Input>;
  _set?: InputMaybe<Accounts_Expert_Set_Input>;
  where: Accounts_Expert_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Accounts_Expert_By_PkArgs = {
  _inc?: InputMaybe<Accounts_Expert_Inc_Input>;
  _set?: InputMaybe<Accounts_Expert_Set_Input>;
  pk_columns: Accounts_Expert_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Accounts_ManagingeditorArgs = {
  _inc?: InputMaybe<Accounts_Managingeditor_Inc_Input>;
  _set?: InputMaybe<Accounts_Managingeditor_Set_Input>;
  where: Accounts_Managingeditor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Accounts_Managingeditor_By_PkArgs = {
  _inc?: InputMaybe<Accounts_Managingeditor_Inc_Input>;
  _set?: InputMaybe<Accounts_Managingeditor_Set_Input>;
  pk_columns: Accounts_Managingeditor_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Accounts_ProfileArgs = {
  _append?: InputMaybe<Accounts_Profile_Append_Input>;
  _delete_at_path?: InputMaybe<Accounts_Profile_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Accounts_Profile_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Accounts_Profile_Delete_Key_Input>;
  _inc?: InputMaybe<Accounts_Profile_Inc_Input>;
  _prepend?: InputMaybe<Accounts_Profile_Prepend_Input>;
  _set?: InputMaybe<Accounts_Profile_Set_Input>;
  where: Accounts_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Accounts_Profile_By_PkArgs = {
  _append?: InputMaybe<Accounts_Profile_Append_Input>;
  _delete_at_path?: InputMaybe<Accounts_Profile_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Accounts_Profile_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Accounts_Profile_Delete_Key_Input>;
  _inc?: InputMaybe<Accounts_Profile_Inc_Input>;
  _prepend?: InputMaybe<Accounts_Profile_Prepend_Input>;
  _set?: InputMaybe<Accounts_Profile_Set_Input>;
  pk_columns: Accounts_Profile_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Accounts_RegionaleditorArgs = {
  _inc?: InputMaybe<Accounts_Regionaleditor_Inc_Input>;
  _set?: InputMaybe<Accounts_Regionaleditor_Set_Input>;
  where: Accounts_Regionaleditor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Accounts_Regionaleditor_By_PkArgs = {
  _inc?: InputMaybe<Accounts_Regionaleditor_Inc_Input>;
  _set?: InputMaybe<Accounts_Regionaleditor_Set_Input>;
  pk_columns: Accounts_Regionaleditor_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Accounts_RegionaleditorcategoryArgs = {
  _inc?: InputMaybe<Accounts_Regionaleditorcategory_Inc_Input>;
  _set?: InputMaybe<Accounts_Regionaleditorcategory_Set_Input>;
  where: Accounts_Regionaleditorcategory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Accounts_Regionaleditorcategory_By_PkArgs = {
  _inc?: InputMaybe<Accounts_Regionaleditorcategory_Inc_Input>;
  _set?: InputMaybe<Accounts_Regionaleditorcategory_Set_Input>;
  pk_columns: Accounts_Regionaleditorcategory_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Accounts_Regionaleditorcategory_EditorsArgs = {
  _inc?: InputMaybe<Accounts_Regionaleditorcategory_Editors_Inc_Input>;
  _set?: InputMaybe<Accounts_Regionaleditorcategory_Editors_Set_Input>;
  where: Accounts_Regionaleditorcategory_Editors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Accounts_Regionaleditorcategory_Editors_By_PkArgs = {
  _inc?: InputMaybe<Accounts_Regionaleditorcategory_Editors_Inc_Input>;
  _set?: InputMaybe<Accounts_Regionaleditorcategory_Editors_Set_Input>;
  pk_columns: Accounts_Regionaleditorcategory_Editors_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Accounts_TranslatorArgs = {
  _inc?: InputMaybe<Accounts_Translator_Inc_Input>;
  _set?: InputMaybe<Accounts_Translator_Set_Input>;
  where: Accounts_Translator_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Accounts_Translator_By_PkArgs = {
  _inc?: InputMaybe<Accounts_Translator_Inc_Input>;
  _set?: InputMaybe<Accounts_Translator_Set_Input>;
  pk_columns: Accounts_Translator_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Analyze_User_QueryArgs = {
  _append?: InputMaybe<Analyze_User_Query_Append_Input>;
  _delete_at_path?: InputMaybe<Analyze_User_Query_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Analyze_User_Query_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Analyze_User_Query_Delete_Key_Input>;
  _inc?: InputMaybe<Analyze_User_Query_Inc_Input>;
  _prepend?: InputMaybe<Analyze_User_Query_Prepend_Input>;
  _set?: InputMaybe<Analyze_User_Query_Set_Input>;
  where: Analyze_User_Query_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Analyze_User_Query_By_PkArgs = {
  _append?: InputMaybe<Analyze_User_Query_Append_Input>;
  _delete_at_path?: InputMaybe<Analyze_User_Query_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Analyze_User_Query_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Analyze_User_Query_Delete_Key_Input>;
  _inc?: InputMaybe<Analyze_User_Query_Inc_Input>;
  _prepend?: InputMaybe<Analyze_User_Query_Prepend_Input>;
  _set?: InputMaybe<Analyze_User_Query_Set_Input>;
  pk_columns: Analyze_User_Query_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_UserArgs = {
  _inc?: InputMaybe<Auth_User_Inc_Input>;
  _set?: InputMaybe<Auth_User_Set_Input>;
  where: Auth_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_User_By_PkArgs = {
  _inc?: InputMaybe<Auth_User_Inc_Input>;
  _set?: InputMaybe<Auth_User_Set_Input>;
  pk_columns: Auth_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Gis_Regions_Gis_RegionArgs = {
  _inc?: InputMaybe<Gis_Regions_Gis_Region_Inc_Input>;
  _set?: InputMaybe<Gis_Regions_Gis_Region_Set_Input>;
  where: Gis_Regions_Gis_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Gis_Regions_Gis_Region_By_PkArgs = {
  _inc?: InputMaybe<Gis_Regions_Gis_Region_Inc_Input>;
  _set?: InputMaybe<Gis_Regions_Gis_Region_Set_Input>;
  pk_columns: Gis_Regions_Gis_Region_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Gis_Regions_Gis_Region_TagsArgs = {
  _inc?: InputMaybe<Gis_Regions_Gis_Region_Tags_Inc_Input>;
  _set?: InputMaybe<Gis_Regions_Gis_Region_Tags_Set_Input>;
  where: Gis_Regions_Gis_Region_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Gis_Regions_Gis_Region_Tags_By_PkArgs = {
  _inc?: InputMaybe<Gis_Regions_Gis_Region_Tags_Inc_Input>;
  _set?: InputMaybe<Gis_Regions_Gis_Region_Tags_Set_Input>;
  pk_columns: Gis_Regions_Gis_Region_Tags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Gis_Regions_Gis_TagArgs = {
  _inc?: InputMaybe<Gis_Regions_Gis_Tag_Inc_Input>;
  _set?: InputMaybe<Gis_Regions_Gis_Tag_Set_Input>;
  where: Gis_Regions_Gis_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Gis_Regions_Gis_Tag_By_PkArgs = {
  _inc?: InputMaybe<Gis_Regions_Gis_Tag_Inc_Input>;
  _set?: InputMaybe<Gis_Regions_Gis_Tag_Set_Input>;
  pk_columns: Gis_Regions_Gis_Tag_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Poll_DraftsArgs = {
  _append?: InputMaybe<Poll_Drafts_Append_Input>;
  _delete_at_path?: InputMaybe<Poll_Drafts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Poll_Drafts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Poll_Drafts_Delete_Key_Input>;
  _inc?: InputMaybe<Poll_Drafts_Inc_Input>;
  _prepend?: InputMaybe<Poll_Drafts_Prepend_Input>;
  _set?: InputMaybe<Poll_Drafts_Set_Input>;
  where: Poll_Drafts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Poll_Drafts_By_PkArgs = {
  _append?: InputMaybe<Poll_Drafts_Append_Input>;
  _delete_at_path?: InputMaybe<Poll_Drafts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Poll_Drafts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Poll_Drafts_Delete_Key_Input>;
  _inc?: InputMaybe<Poll_Drafts_Inc_Input>;
  _prepend?: InputMaybe<Poll_Drafts_Prepend_Input>;
  _set?: InputMaybe<Poll_Drafts_Set_Input>;
  pk_columns: Poll_Drafts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_AnswerArgs = {
  _inc?: InputMaybe<Polls_Answer_Inc_Input>;
  _set?: InputMaybe<Polls_Answer_Set_Input>;
  where: Polls_Answer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Answer_By_PkArgs = {
  _inc?: InputMaybe<Polls_Answer_Inc_Input>;
  _set?: InputMaybe<Polls_Answer_Set_Input>;
  pk_columns: Polls_Answer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Answer_Set_AttachmentArgs = {
  _inc?: InputMaybe<Polls_Answer_Set_Attachment_Inc_Input>;
  _set?: InputMaybe<Polls_Answer_Set_Attachment_Set_Input>;
  where: Polls_Answer_Set_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Answer_Set_Attachment_By_PkArgs = {
  _inc?: InputMaybe<Polls_Answer_Set_Attachment_Inc_Input>;
  _set?: InputMaybe<Polls_Answer_Set_Attachment_Set_Input>;
  pk_columns: Polls_Answer_Set_Attachment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_AnswersetArgs = {
  _inc?: InputMaybe<Polls_Answerset_Inc_Input>;
  _set?: InputMaybe<Polls_Answerset_Set_Input>;
  where: Polls_Answerset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Answerset_By_PkArgs = {
  _inc?: InputMaybe<Polls_Answerset_Inc_Input>;
  _set?: InputMaybe<Polls_Answerset_Set_Input>;
  pk_columns: Polls_Answerset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_AnswersetattachmentArgs = {
  _inc?: InputMaybe<Polls_Answersetattachment_Inc_Input>;
  _set?: InputMaybe<Polls_Answersetattachment_Set_Input>;
  where: Polls_Answersetattachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Answersetattachment_By_PkArgs = {
  _inc?: InputMaybe<Polls_Answersetattachment_Inc_Input>;
  _set?: InputMaybe<Polls_Answersetattachment_Set_Input>;
  pk_columns: Polls_Answersetattachment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_BaseanswersetArgs = {
  _inc?: InputMaybe<Polls_Baseanswerset_Inc_Input>;
  _set?: InputMaybe<Polls_Baseanswerset_Set_Input>;
  where: Polls_Baseanswerset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Baseanswerset_BranchesArgs = {
  _inc?: InputMaybe<Polls_Baseanswerset_Branches_Inc_Input>;
  _set?: InputMaybe<Polls_Baseanswerset_Branches_Set_Input>;
  where: Polls_Baseanswerset_Branches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Baseanswerset_Branches_By_PkArgs = {
  _inc?: InputMaybe<Polls_Baseanswerset_Branches_Inc_Input>;
  _set?: InputMaybe<Polls_Baseanswerset_Branches_Set_Input>;
  pk_columns: Polls_Baseanswerset_Branches_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Baseanswerset_By_PkArgs = {
  _inc?: InputMaybe<Polls_Baseanswerset_Inc_Input>;
  _set?: InputMaybe<Polls_Baseanswerset_Set_Input>;
  pk_columns: Polls_Baseanswerset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_BasesourceArgs = {
  _append?: InputMaybe<Polls_Basesource_Append_Input>;
  _delete_at_path?: InputMaybe<Polls_Basesource_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Polls_Basesource_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Polls_Basesource_Delete_Key_Input>;
  _inc?: InputMaybe<Polls_Basesource_Inc_Input>;
  _prepend?: InputMaybe<Polls_Basesource_Prepend_Input>;
  _set?: InputMaybe<Polls_Basesource_Set_Input>;
  where: Polls_Basesource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Basesource_By_PkArgs = {
  _append?: InputMaybe<Polls_Basesource_Append_Input>;
  _delete_at_path?: InputMaybe<Polls_Basesource_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Polls_Basesource_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Polls_Basesource_Delete_Key_Input>;
  _inc?: InputMaybe<Polls_Basesource_Inc_Input>;
  _prepend?: InputMaybe<Polls_Basesource_Prepend_Input>;
  _set?: InputMaybe<Polls_Basesource_Set_Input>;
  pk_columns: Polls_Basesource_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_BranchArgs = {
  _inc?: InputMaybe<Polls_Branch_Inc_Input>;
  _set?: InputMaybe<Polls_Branch_Set_Input>;
  where: Polls_Branch_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Branch_By_PkArgs = {
  _inc?: InputMaybe<Polls_Branch_Inc_Input>;
  _set?: InputMaybe<Polls_Branch_Set_Input>;
  pk_columns: Polls_Branch_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_BranchingquestionArgs = {
  _inc?: InputMaybe<Polls_Branchingquestion_Inc_Input>;
  _set?: InputMaybe<Polls_Branchingquestion_Set_Input>;
  where: Polls_Branchingquestion_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Branchingquestion_By_PkArgs = {
  _inc?: InputMaybe<Polls_Branchingquestion_Inc_Input>;
  _set?: InputMaybe<Polls_Branchingquestion_Set_Input>;
  pk_columns: Polls_Branchingquestion_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_CategoryArgs = {
  _inc?: InputMaybe<Polls_Category_Inc_Input>;
  _set?: InputMaybe<Polls_Category_Set_Input>;
  where: Polls_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Category_By_PkArgs = {
  _inc?: InputMaybe<Polls_Category_Inc_Input>;
  _set?: InputMaybe<Polls_Category_Set_Input>;
  pk_columns: Polls_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_CategoryprogressArgs = {
  _inc?: InputMaybe<Polls_Categoryprogress_Inc_Input>;
  _set?: InputMaybe<Polls_Categoryprogress_Set_Input>;
  where: Polls_Categoryprogress_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Categoryprogress_By_PkArgs = {
  _inc?: InputMaybe<Polls_Categoryprogress_Inc_Input>;
  _set?: InputMaybe<Polls_Categoryprogress_Set_Input>;
  pk_columns: Polls_Categoryprogress_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_CommentArgs = {
  _inc?: InputMaybe<Polls_Comment_Inc_Input>;
  _set?: InputMaybe<Polls_Comment_Set_Input>;
  where: Polls_Comment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Comment_By_PkArgs = {
  _inc?: InputMaybe<Polls_Comment_Inc_Input>;
  _set?: InputMaybe<Polls_Comment_Set_Input>;
  pk_columns: Polls_Comment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_DatasourceArgs = {
  _inc?: InputMaybe<Polls_Datasource_Inc_Input>;
  _set?: InputMaybe<Polls_Datasource_Set_Input>;
  where: Polls_Datasource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Datasource_By_PkArgs = {
  _inc?: InputMaybe<Polls_Datasource_Inc_Input>;
  _set?: InputMaybe<Polls_Datasource_Set_Input>;
  pk_columns: Polls_Datasource_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_EntityArgs = {
  _inc?: InputMaybe<Polls_Entity_Inc_Input>;
  _set?: InputMaybe<Polls_Entity_Set_Input>;
  where: Polls_Entity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Entity_Alt_NamesArgs = {
  _inc?: InputMaybe<Polls_Entity_Alt_Names_Inc_Input>;
  _set?: InputMaybe<Polls_Entity_Alt_Names_Set_Input>;
  where: Polls_Entity_Alt_Names_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Entity_Alt_Names_By_PkArgs = {
  _inc?: InputMaybe<Polls_Entity_Alt_Names_Inc_Input>;
  _set?: InputMaybe<Polls_Entity_Alt_Names_Set_Input>;
  pk_columns: Polls_Entity_Alt_Names_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Entity_By_PkArgs = {
  _inc?: InputMaybe<Polls_Entity_Inc_Input>;
  _set?: InputMaybe<Polls_Entity_Set_Input>;
  pk_columns: Polls_Entity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Entity_TagsArgs = {
  _inc?: InputMaybe<Polls_Entity_Tags_Inc_Input>;
  _set?: InputMaybe<Polls_Entity_Tags_Set_Input>;
  where: Polls_Entity_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Entity_Tags_By_PkArgs = {
  _inc?: InputMaybe<Polls_Entity_Tags_Inc_Input>;
  _set?: InputMaybe<Polls_Entity_Tags_Set_Input>;
  pk_columns: Polls_Entity_Tags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_EntitynameArgs = {
  _inc?: InputMaybe<Polls_Entityname_Inc_Input>;
  _set?: InputMaybe<Polls_Entityname_Set_Input>;
  where: Polls_Entityname_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Entityname_By_PkArgs = {
  _inc?: InputMaybe<Polls_Entityname_Inc_Input>;
  _set?: InputMaybe<Polls_Entityname_Set_Input>;
  pk_columns: Polls_Entityname_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_EntitytagArgs = {
  _inc?: InputMaybe<Polls_Entitytag_Inc_Input>;
  _set?: InputMaybe<Polls_Entitytag_Set_Input>;
  where: Polls_Entitytag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Entitytag_By_PkArgs = {
  _inc?: InputMaybe<Polls_Entitytag_Inc_Input>;
  _set?: InputMaybe<Polls_Entitytag_Set_Input>;
  pk_columns: Polls_Entitytag_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Entry_AttachmentArgs = {
  _inc?: InputMaybe<Polls_Entry_Attachment_Inc_Input>;
  _set?: InputMaybe<Polls_Entry_Attachment_Set_Input>;
  where: Polls_Entry_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Entry_Attachment_By_PkArgs = {
  _inc?: InputMaybe<Polls_Entry_Attachment_Inc_Input>;
  _set?: InputMaybe<Polls_Entry_Attachment_Set_Input>;
  pk_columns: Polls_Entry_Attachment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_EntryattachmentArgs = {
  _inc?: InputMaybe<Polls_Entryattachment_Inc_Input>;
  _set?: InputMaybe<Polls_Entryattachment_Set_Input>;
  where: Polls_Entryattachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Entryattachment_By_PkArgs = {
  _inc?: InputMaybe<Polls_Entryattachment_Inc_Input>;
  _set?: InputMaybe<Polls_Entryattachment_Set_Input>;
  pk_columns: Polls_Entryattachment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_EntryreferenceArgs = {
  _inc?: InputMaybe<Polls_Entryreference_Inc_Input>;
  _set?: InputMaybe<Polls_Entryreference_Set_Input>;
  where: Polls_Entryreference_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Entryreference_By_PkArgs = {
  _inc?: InputMaybe<Polls_Entryreference_Inc_Input>;
  _set?: InputMaybe<Polls_Entryreference_Set_Input>;
  pk_columns: Polls_Entryreference_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_EntrytaggroupArgs = {
  _inc?: InputMaybe<Polls_Entrytaggroup_Inc_Input>;
  _set?: InputMaybe<Polls_Entrytaggroup_Set_Input>;
  where: Polls_Entrytaggroup_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Entrytaggroup_By_PkArgs = {
  _inc?: InputMaybe<Polls_Entrytaggroup_Inc_Input>;
  _set?: InputMaybe<Polls_Entrytaggroup_Set_Input>;
  pk_columns: Polls_Entrytaggroup_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_GroupArgs = {
  _inc?: InputMaybe<Polls_Group_Inc_Input>;
  _set?: InputMaybe<Polls_Group_Set_Input>;
  where: Polls_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Group_By_PkArgs = {
  _inc?: InputMaybe<Polls_Group_Inc_Input>;
  _set?: InputMaybe<Polls_Group_Set_Input>;
  pk_columns: Polls_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_PollArgs = {
  _inc?: InputMaybe<Polls_Poll_Inc_Input>;
  _set?: InputMaybe<Polls_Poll_Set_Input>;
  where: Polls_Poll_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Poll_By_PkArgs = {
  _inc?: InputMaybe<Polls_Poll_Inc_Input>;
  _set?: InputMaybe<Polls_Poll_Set_Input>;
  pk_columns: Polls_Poll_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Poll_Optional_Entry_Tag_GroupsArgs = {
  _inc?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_Inc_Input>;
  _set?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_Set_Input>;
  where: Polls_Poll_Optional_Entry_Tag_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Poll_Optional_Entry_Tag_Groups_By_PkArgs = {
  _inc?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_Inc_Input>;
  _set?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_Set_Input>;
  pk_columns: Polls_Poll_Optional_Entry_Tag_Groups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Poll_Required_Entry_Tag_GroupsArgs = {
  _inc?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_Inc_Input>;
  _set?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_Set_Input>;
  where: Polls_Poll_Required_Entry_Tag_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Poll_Required_Entry_Tag_Groups_By_PkArgs = {
  _inc?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_Inc_Input>;
  _set?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_Set_Input>;
  pk_columns: Polls_Poll_Required_Entry_Tag_Groups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_PollprogressArgs = {
  _inc?: InputMaybe<Polls_Pollprogress_Inc_Input>;
  _set?: InputMaybe<Polls_Pollprogress_Set_Input>;
  where: Polls_Pollprogress_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Pollprogress_By_PkArgs = {
  _inc?: InputMaybe<Polls_Pollprogress_Inc_Input>;
  _set?: InputMaybe<Polls_Pollprogress_Set_Input>;
  pk_columns: Polls_Pollprogress_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Pollprogress_Considered_Answer_SetsArgs = {
  _inc?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_Inc_Input>;
  _set?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_Set_Input>;
  where: Polls_Pollprogress_Considered_Answer_Sets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Pollprogress_Considered_Answer_Sets_By_PkArgs = {
  _inc?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_Inc_Input>;
  _set?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_Set_Input>;
  pk_columns: Polls_Pollprogress_Considered_Answer_Sets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_QuestionArgs = {
  _inc?: InputMaybe<Polls_Question_Inc_Input>;
  _set?: InputMaybe<Polls_Question_Set_Input>;
  where: Polls_Question_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Question_By_PkArgs = {
  _inc?: InputMaybe<Polls_Question_Inc_Input>;
  _set?: InputMaybe<Polls_Question_Set_Input>;
  pk_columns: Polls_Question_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_QuestionrelationArgs = {
  _inc?: InputMaybe<Polls_Questionrelation_Inc_Input>;
  _set?: InputMaybe<Polls_Questionrelation_Set_Input>;
  where: Polls_Questionrelation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Questionrelation_By_PkArgs = {
  _inc?: InputMaybe<Polls_Questionrelation_Inc_Input>;
  _set?: InputMaybe<Polls_Questionrelation_Set_Input>;
  pk_columns: Polls_Questionrelation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_SearchrequestArgs = {
  _inc?: InputMaybe<Polls_Searchrequest_Inc_Input>;
  _set?: InputMaybe<Polls_Searchrequest_Set_Input>;
  where: Polls_Searchrequest_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Searchrequest_By_PkArgs = {
  _inc?: InputMaybe<Polls_Searchrequest_Inc_Input>;
  _set?: InputMaybe<Polls_Searchrequest_Set_Input>;
  pk_columns: Polls_Searchrequest_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_SecondarysourceArgs = {
  _inc?: InputMaybe<Polls_Secondarysource_Inc_Input>;
  _set?: InputMaybe<Polls_Secondarysource_Set_Input>;
  where: Polls_Secondarysource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Secondarysource_By_PkArgs = {
  _inc?: InputMaybe<Polls_Secondarysource_Inc_Input>;
  _set?: InputMaybe<Polls_Secondarysource_Set_Input>;
  pk_columns: Polls_Secondarysource_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_TemplateanswerArgs = {
  _inc?: InputMaybe<Polls_Templateanswer_Inc_Input>;
  _set?: InputMaybe<Polls_Templateanswer_Set_Input>;
  where: Polls_Templateanswer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Templateanswer_By_PkArgs = {
  _inc?: InputMaybe<Polls_Templateanswer_Inc_Input>;
  _set?: InputMaybe<Polls_Templateanswer_Set_Input>;
  pk_columns: Polls_Templateanswer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_TemplateanswersetArgs = {
  _inc?: InputMaybe<Polls_Templateanswerset_Inc_Input>;
  _set?: InputMaybe<Polls_Templateanswerset_Set_Input>;
  where: Polls_Templateanswerset_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polls_Templateanswerset_By_PkArgs = {
  _inc?: InputMaybe<Polls_Templateanswerset_Inc_Input>;
  _set?: InputMaybe<Polls_Templateanswerset_Set_Input>;
  pk_columns: Polls_Templateanswerset_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_FileArgs = {
  _append?: InputMaybe<User_File_Append_Input>;
  _delete_at_path?: InputMaybe<User_File_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_File_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_File_Delete_Key_Input>;
  _inc?: InputMaybe<User_File_Inc_Input>;
  _prepend?: InputMaybe<User_File_Prepend_Input>;
  _set?: InputMaybe<User_File_Set_Input>;
  where: User_File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_File_By_PkArgs = {
  _append?: InputMaybe<User_File_Append_Input>;
  _delete_at_path?: InputMaybe<User_File_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_File_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_File_Delete_Key_Input>;
  _inc?: InputMaybe<User_File_Inc_Input>;
  _prepend?: InputMaybe<User_File_Prepend_Input>;
  _set?: InputMaybe<User_File_Set_Input>;
  pk_columns: User_File_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpgrade_Entry_PollArgs = {
  entry_id: Scalars['Int'];
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "poll_drafts" */
export type Poll_Drafts = {
  __typename?: 'poll_drafts';
  created_at?: Maybe<Scalars['timestamp']>;
  id: Scalars['Int'];
  payload?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  previous_poll?: Maybe<Polls_Poll>;
  previous_poll_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  /** An object relationship */
  user: Auth_User;
  user_id: Scalars['Int'];
};


/** columns and relationships of "poll_drafts" */
export type Poll_DraftsPayloadArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "poll_drafts" */
export type Poll_Drafts_Aggregate = {
  __typename?: 'poll_drafts_aggregate';
  aggregate?: Maybe<Poll_Drafts_Aggregate_Fields>;
  nodes: Array<Poll_Drafts>;
};

/** aggregate fields of "poll_drafts" */
export type Poll_Drafts_Aggregate_Fields = {
  __typename?: 'poll_drafts_aggregate_fields';
  avg?: Maybe<Poll_Drafts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Poll_Drafts_Max_Fields>;
  min?: Maybe<Poll_Drafts_Min_Fields>;
  stddev?: Maybe<Poll_Drafts_Stddev_Fields>;
  stddev_pop?: Maybe<Poll_Drafts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Poll_Drafts_Stddev_Samp_Fields>;
  sum?: Maybe<Poll_Drafts_Sum_Fields>;
  var_pop?: Maybe<Poll_Drafts_Var_Pop_Fields>;
  var_samp?: Maybe<Poll_Drafts_Var_Samp_Fields>;
  variance?: Maybe<Poll_Drafts_Variance_Fields>;
};


/** aggregate fields of "poll_drafts" */
export type Poll_Drafts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Poll_Drafts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Poll_Drafts_Append_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Poll_Drafts_Avg_Fields = {
  __typename?: 'poll_drafts_avg_fields';
  id?: Maybe<Scalars['Float']>;
  previous_poll_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "poll_drafts". All fields are combined with a logical 'AND'. */
export type Poll_Drafts_Bool_Exp = {
  _and?: InputMaybe<Array<Poll_Drafts_Bool_Exp>>;
  _not?: InputMaybe<Poll_Drafts_Bool_Exp>;
  _or?: InputMaybe<Array<Poll_Drafts_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  previous_poll?: InputMaybe<Polls_Poll_Bool_Exp>;
  previous_poll_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Auth_User_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "poll_drafts" */
export enum Poll_Drafts_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollDraftsPkey = 'poll_drafts_pkey',
  /** unique or primary key constraint on columns "previous_poll_id" */
  PollDraftsPreviousPollIdKey = 'poll_drafts_previous_poll_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Poll_Drafts_Delete_At_Path_Input = {
  payload?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Poll_Drafts_Delete_Elem_Input = {
  payload?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Poll_Drafts_Delete_Key_Input = {
  payload?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "poll_drafts" */
export type Poll_Drafts_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  previous_poll_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "poll_drafts" */
export type Poll_Drafts_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['Int']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  previous_poll?: InputMaybe<Polls_Poll_Obj_Rel_Insert_Input>;
  previous_poll_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  user?: InputMaybe<Auth_User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Poll_Drafts_Max_Fields = {
  __typename?: 'poll_drafts_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['Int']>;
  previous_poll_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Poll_Drafts_Min_Fields = {
  __typename?: 'poll_drafts_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['Int']>;
  previous_poll_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "poll_drafts" */
export type Poll_Drafts_Mutation_Response = {
  __typename?: 'poll_drafts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Poll_Drafts>;
};

/** input type for inserting object relation for remote table "poll_drafts" */
export type Poll_Drafts_Obj_Rel_Insert_Input = {
  data: Poll_Drafts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Poll_Drafts_On_Conflict>;
};

/** on_conflict condition type for table "poll_drafts" */
export type Poll_Drafts_On_Conflict = {
  constraint: Poll_Drafts_Constraint;
  update_columns?: Array<Poll_Drafts_Update_Column>;
  where?: InputMaybe<Poll_Drafts_Bool_Exp>;
};

/** Ordering options when selecting data from "poll_drafts". */
export type Poll_Drafts_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  previous_poll?: InputMaybe<Polls_Poll_Order_By>;
  previous_poll_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Auth_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: poll_drafts */
export type Poll_Drafts_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Poll_Drafts_Prepend_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "poll_drafts" */
export enum Poll_Drafts_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  PreviousPollId = 'previous_poll_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "poll_drafts" */
export type Poll_Drafts_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['Int']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  previous_poll_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Poll_Drafts_Stddev_Fields = {
  __typename?: 'poll_drafts_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  previous_poll_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Poll_Drafts_Stddev_Pop_Fields = {
  __typename?: 'poll_drafts_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  previous_poll_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Poll_Drafts_Stddev_Samp_Fields = {
  __typename?: 'poll_drafts_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  previous_poll_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Poll_Drafts_Sum_Fields = {
  __typename?: 'poll_drafts_sum_fields';
  id?: Maybe<Scalars['Int']>;
  previous_poll_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "poll_drafts" */
export enum Poll_Drafts_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  PreviousPollId = 'previous_poll_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type Poll_Drafts_Var_Pop_Fields = {
  __typename?: 'poll_drafts_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  previous_poll_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Poll_Drafts_Var_Samp_Fields = {
  __typename?: 'poll_drafts_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  previous_poll_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Poll_Drafts_Variance_Fields = {
  __typename?: 'poll_drafts_variance_fields';
  id?: Maybe<Scalars['Float']>;
  previous_poll_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "polls_answer" */
export type Polls_Answer = {
  __typename?: 'polls_answer';
  /** An object relationship */
  base_answer_set: Polls_Baseanswerset;
  base_answer_set_id: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  previous_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  template_answer: Polls_Templateanswer;
  template_answer_id: Scalars['Int'];
  text_input?: Maybe<Scalars['String']>;
  text_input_type?: Maybe<Scalars['smallint']>;
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
  value: Scalars['Int'];
};

/** aggregated selection of "polls_answer" */
export type Polls_Answer_Aggregate = {
  __typename?: 'polls_answer_aggregate';
  aggregate?: Maybe<Polls_Answer_Aggregate_Fields>;
  nodes: Array<Polls_Answer>;
};

/** aggregate fields of "polls_answer" */
export type Polls_Answer_Aggregate_Fields = {
  __typename?: 'polls_answer_aggregate_fields';
  avg?: Maybe<Polls_Answer_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Answer_Max_Fields>;
  min?: Maybe<Polls_Answer_Min_Fields>;
  stddev?: Maybe<Polls_Answer_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Answer_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Answer_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Answer_Sum_Fields>;
  var_pop?: Maybe<Polls_Answer_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Answer_Var_Samp_Fields>;
  variance?: Maybe<Polls_Answer_Variance_Fields>;
};


/** aggregate fields of "polls_answer" */
export type Polls_Answer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Answer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "polls_answer" */
export type Polls_Answer_Aggregate_Order_By = {
  avg?: InputMaybe<Polls_Answer_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Polls_Answer_Max_Order_By>;
  min?: InputMaybe<Polls_Answer_Min_Order_By>;
  stddev?: InputMaybe<Polls_Answer_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Polls_Answer_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Polls_Answer_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Polls_Answer_Sum_Order_By>;
  var_pop?: InputMaybe<Polls_Answer_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Polls_Answer_Var_Samp_Order_By>;
  variance?: InputMaybe<Polls_Answer_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "polls_answer" */
export type Polls_Answer_Arr_Rel_Insert_Input = {
  data: Array<Polls_Answer_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Answer_On_Conflict>;
};

/** aggregate avg on columns */
export type Polls_Answer_Avg_Fields = {
  __typename?: 'polls_answer_avg_fields';
  base_answer_set_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  template_answer_id?: Maybe<Scalars['Float']>;
  text_input_type?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "polls_answer" */
export type Polls_Answer_Avg_Order_By = {
  base_answer_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_id?: InputMaybe<Order_By>;
  text_input_type?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "polls_answer". All fields are combined with a logical 'AND'. */
export type Polls_Answer_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Answer_Bool_Exp>>;
  _not?: InputMaybe<Polls_Answer_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Answer_Bool_Exp>>;
  base_answer_set?: InputMaybe<Polls_Baseanswerset_Bool_Exp>;
  base_answer_set_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  name_en?: InputMaybe<String_Comparison_Exp>;
  name_es?: InputMaybe<String_Comparison_Exp>;
  name_fr?: InputMaybe<String_Comparison_Exp>;
  name_ja?: InputMaybe<String_Comparison_Exp>;
  name_zh_hans?: InputMaybe<String_Comparison_Exp>;
  name_zh_hant?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  previous_id?: InputMaybe<Int_Comparison_Exp>;
  template_answer?: InputMaybe<Polls_Templateanswer_Bool_Exp>;
  template_answer_id?: InputMaybe<Int_Comparison_Exp>;
  text_input?: InputMaybe<String_Comparison_Exp>;
  text_input_type?: InputMaybe<Smallint_Comparison_Exp>;
  tooltip?: InputMaybe<String_Comparison_Exp>;
  tooltip_en?: InputMaybe<String_Comparison_Exp>;
  tooltip_es?: InputMaybe<String_Comparison_Exp>;
  tooltip_fr?: InputMaybe<String_Comparison_Exp>;
  tooltip_ja?: InputMaybe<String_Comparison_Exp>;
  tooltip_zh_hans?: InputMaybe<String_Comparison_Exp>;
  tooltip_zh_hant?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_answer" */
export enum Polls_Answer_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollsAnswerPkey = 'polls_answer_pkey'
}

/** input type for incrementing numeric columns in table "polls_answer" */
export type Polls_Answer_Inc_Input = {
  base_answer_set_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  previous_id?: InputMaybe<Scalars['Int']>;
  template_answer_id?: InputMaybe<Scalars['Int']>;
  text_input_type?: InputMaybe<Scalars['smallint']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_answer" */
export type Polls_Answer_Insert_Input = {
  base_answer_set?: InputMaybe<Polls_Baseanswerset_Obj_Rel_Insert_Input>;
  base_answer_set_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  previous_id?: InputMaybe<Scalars['Int']>;
  template_answer?: InputMaybe<Polls_Templateanswer_Obj_Rel_Insert_Input>;
  template_answer_id?: InputMaybe<Scalars['Int']>;
  text_input?: InputMaybe<Scalars['String']>;
  text_input_type?: InputMaybe<Scalars['smallint']>;
  tooltip?: InputMaybe<Scalars['String']>;
  tooltip_en?: InputMaybe<Scalars['String']>;
  tooltip_es?: InputMaybe<Scalars['String']>;
  tooltip_fr?: InputMaybe<Scalars['String']>;
  tooltip_ja?: InputMaybe<Scalars['String']>;
  tooltip_zh_hans?: InputMaybe<Scalars['String']>;
  tooltip_zh_hant?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Polls_Answer_Max_Fields = {
  __typename?: 'polls_answer_max_fields';
  base_answer_set_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
  template_answer_id?: Maybe<Scalars['Int']>;
  text_input?: Maybe<Scalars['String']>;
  text_input_type?: Maybe<Scalars['smallint']>;
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "polls_answer" */
export type Polls_Answer_Max_Order_By = {
  base_answer_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_id?: InputMaybe<Order_By>;
  text_input?: InputMaybe<Order_By>;
  text_input_type?: InputMaybe<Order_By>;
  tooltip?: InputMaybe<Order_By>;
  tooltip_en?: InputMaybe<Order_By>;
  tooltip_es?: InputMaybe<Order_By>;
  tooltip_fr?: InputMaybe<Order_By>;
  tooltip_ja?: InputMaybe<Order_By>;
  tooltip_zh_hans?: InputMaybe<Order_By>;
  tooltip_zh_hant?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Polls_Answer_Min_Fields = {
  __typename?: 'polls_answer_min_fields';
  base_answer_set_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
  template_answer_id?: Maybe<Scalars['Int']>;
  text_input?: Maybe<Scalars['String']>;
  text_input_type?: Maybe<Scalars['smallint']>;
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "polls_answer" */
export type Polls_Answer_Min_Order_By = {
  base_answer_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_id?: InputMaybe<Order_By>;
  text_input?: InputMaybe<Order_By>;
  text_input_type?: InputMaybe<Order_By>;
  tooltip?: InputMaybe<Order_By>;
  tooltip_en?: InputMaybe<Order_By>;
  tooltip_es?: InputMaybe<Order_By>;
  tooltip_fr?: InputMaybe<Order_By>;
  tooltip_ja?: InputMaybe<Order_By>;
  tooltip_zh_hans?: InputMaybe<Order_By>;
  tooltip_zh_hant?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "polls_answer" */
export type Polls_Answer_Mutation_Response = {
  __typename?: 'polls_answer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Answer>;
};

/** on_conflict condition type for table "polls_answer" */
export type Polls_Answer_On_Conflict = {
  constraint: Polls_Answer_Constraint;
  update_columns?: Array<Polls_Answer_Update_Column>;
  where?: InputMaybe<Polls_Answer_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_answer". */
export type Polls_Answer_Order_By = {
  base_answer_set?: InputMaybe<Polls_Baseanswerset_Order_By>;
  base_answer_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer?: InputMaybe<Polls_Templateanswer_Order_By>;
  template_answer_id?: InputMaybe<Order_By>;
  text_input?: InputMaybe<Order_By>;
  text_input_type?: InputMaybe<Order_By>;
  tooltip?: InputMaybe<Order_By>;
  tooltip_en?: InputMaybe<Order_By>;
  tooltip_es?: InputMaybe<Order_By>;
  tooltip_fr?: InputMaybe<Order_By>;
  tooltip_ja?: InputMaybe<Order_By>;
  tooltip_zh_hans?: InputMaybe<Order_By>;
  tooltip_zh_hant?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_answer */
export type Polls_Answer_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_answer" */
export enum Polls_Answer_Select_Column {
  /** column name */
  BaseAnswerSetId = 'base_answer_set_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant',
  /** column name */
  Order = 'order',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  TemplateAnswerId = 'template_answer_id',
  /** column name */
  TextInput = 'text_input',
  /** column name */
  TextInputType = 'text_input_type',
  /** column name */
  Tooltip = 'tooltip',
  /** column name */
  TooltipEn = 'tooltip_en',
  /** column name */
  TooltipEs = 'tooltip_es',
  /** column name */
  TooltipFr = 'tooltip_fr',
  /** column name */
  TooltipJa = 'tooltip_ja',
  /** column name */
  TooltipZhHans = 'tooltip_zh_hans',
  /** column name */
  TooltipZhHant = 'tooltip_zh_hant',
  /** column name */
  Value = 'value'
}

/** columns and relationships of "polls_answer_set_attachment" */
export type Polls_Answer_Set_Attachment = {
  __typename?: 'polls_answer_set_attachment';
  /** An object relationship */
  answer_set: Polls_Answerset;
  answer_set_id: Scalars['Int'];
  date_created: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  file: User_File;
  file_id: Scalars['uuid'];
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
};

/** aggregated selection of "polls_answer_set_attachment" */
export type Polls_Answer_Set_Attachment_Aggregate = {
  __typename?: 'polls_answer_set_attachment_aggregate';
  aggregate?: Maybe<Polls_Answer_Set_Attachment_Aggregate_Fields>;
  nodes: Array<Polls_Answer_Set_Attachment>;
};

/** aggregate fields of "polls_answer_set_attachment" */
export type Polls_Answer_Set_Attachment_Aggregate_Fields = {
  __typename?: 'polls_answer_set_attachment_aggregate_fields';
  avg?: Maybe<Polls_Answer_Set_Attachment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Answer_Set_Attachment_Max_Fields>;
  min?: Maybe<Polls_Answer_Set_Attachment_Min_Fields>;
  stddev?: Maybe<Polls_Answer_Set_Attachment_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Answer_Set_Attachment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Answer_Set_Attachment_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Answer_Set_Attachment_Sum_Fields>;
  var_pop?: Maybe<Polls_Answer_Set_Attachment_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Answer_Set_Attachment_Var_Samp_Fields>;
  variance?: Maybe<Polls_Answer_Set_Attachment_Variance_Fields>;
};


/** aggregate fields of "polls_answer_set_attachment" */
export type Polls_Answer_Set_Attachment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Answer_Set_Attachment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "polls_answer_set_attachment" */
export type Polls_Answer_Set_Attachment_Aggregate_Order_By = {
  avg?: InputMaybe<Polls_Answer_Set_Attachment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Polls_Answer_Set_Attachment_Max_Order_By>;
  min?: InputMaybe<Polls_Answer_Set_Attachment_Min_Order_By>;
  stddev?: InputMaybe<Polls_Answer_Set_Attachment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Polls_Answer_Set_Attachment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Polls_Answer_Set_Attachment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Polls_Answer_Set_Attachment_Sum_Order_By>;
  var_pop?: InputMaybe<Polls_Answer_Set_Attachment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Polls_Answer_Set_Attachment_Var_Samp_Order_By>;
  variance?: InputMaybe<Polls_Answer_Set_Attachment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "polls_answer_set_attachment" */
export type Polls_Answer_Set_Attachment_Arr_Rel_Insert_Input = {
  data: Array<Polls_Answer_Set_Attachment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Answer_Set_Attachment_On_Conflict>;
};

/** aggregate avg on columns */
export type Polls_Answer_Set_Attachment_Avg_Fields = {
  __typename?: 'polls_answer_set_attachment_avg_fields';
  answer_set_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "polls_answer_set_attachment" */
export type Polls_Answer_Set_Attachment_Avg_Order_By = {
  answer_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "polls_answer_set_attachment". All fields are combined with a logical 'AND'. */
export type Polls_Answer_Set_Attachment_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Answer_Set_Attachment_Bool_Exp>>;
  _not?: InputMaybe<Polls_Answer_Set_Attachment_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Answer_Set_Attachment_Bool_Exp>>;
  answer_set?: InputMaybe<Polls_Answerset_Bool_Exp>;
  answer_set_id?: InputMaybe<Int_Comparison_Exp>;
  date_created?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  file?: InputMaybe<User_File_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_answer_set_attachment" */
export enum Polls_Answer_Set_Attachment_Constraint {
  /** unique or primary key constraint on columns "file_id", "answer_set_id" */
  PollsAnswerSetAttachmentAnswerSetIdFileIdIdx = 'polls_answer_set_attachment_answer_set_id_file_id_idx',
  /** unique or primary key constraint on columns "file_id", "answer_set_id" */
  PollsAnswerSetAttachmentAnswerSetIdFileIdUnique = 'polls_answer_set_attachment_answer_set_id_file_id_unique',
  /** unique or primary key constraint on columns "id" */
  PollsAnswerSetAttachmentPkey = 'polls_answer_set_attachment_pkey'
}

/** input type for incrementing numeric columns in table "polls_answer_set_attachment" */
export type Polls_Answer_Set_Attachment_Inc_Input = {
  answer_set_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_answer_set_attachment" */
export type Polls_Answer_Set_Attachment_Insert_Input = {
  answer_set?: InputMaybe<Polls_Answerset_Obj_Rel_Insert_Input>;
  answer_set_id?: InputMaybe<Scalars['Int']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<User_File_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Polls_Answer_Set_Attachment_Max_Fields = {
  __typename?: 'polls_answer_set_attachment_max_fields';
  answer_set_id?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  file_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "polls_answer_set_attachment" */
export type Polls_Answer_Set_Attachment_Max_Order_By = {
  answer_set_id?: InputMaybe<Order_By>;
  date_created?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Polls_Answer_Set_Attachment_Min_Fields = {
  __typename?: 'polls_answer_set_attachment_min_fields';
  answer_set_id?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  file_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "polls_answer_set_attachment" */
export type Polls_Answer_Set_Attachment_Min_Order_By = {
  answer_set_id?: InputMaybe<Order_By>;
  date_created?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "polls_answer_set_attachment" */
export type Polls_Answer_Set_Attachment_Mutation_Response = {
  __typename?: 'polls_answer_set_attachment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Answer_Set_Attachment>;
};

/** on_conflict condition type for table "polls_answer_set_attachment" */
export type Polls_Answer_Set_Attachment_On_Conflict = {
  constraint: Polls_Answer_Set_Attachment_Constraint;
  update_columns?: Array<Polls_Answer_Set_Attachment_Update_Column>;
  where?: InputMaybe<Polls_Answer_Set_Attachment_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_answer_set_attachment". */
export type Polls_Answer_Set_Attachment_Order_By = {
  answer_set?: InputMaybe<Polls_Answerset_Order_By>;
  answer_set_id?: InputMaybe<Order_By>;
  date_created?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  file?: InputMaybe<User_File_Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_answer_set_attachment */
export type Polls_Answer_Set_Attachment_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_answer_set_attachment" */
export enum Polls_Answer_Set_Attachment_Select_Column {
  /** column name */
  AnswerSetId = 'answer_set_id',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  Description = 'description',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "polls_answer_set_attachment" */
export type Polls_Answer_Set_Attachment_Set_Input = {
  answer_set_id?: InputMaybe<Scalars['Int']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Polls_Answer_Set_Attachment_Stddev_Fields = {
  __typename?: 'polls_answer_set_attachment_stddev_fields';
  answer_set_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "polls_answer_set_attachment" */
export type Polls_Answer_Set_Attachment_Stddev_Order_By = {
  answer_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Polls_Answer_Set_Attachment_Stddev_Pop_Fields = {
  __typename?: 'polls_answer_set_attachment_stddev_pop_fields';
  answer_set_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "polls_answer_set_attachment" */
export type Polls_Answer_Set_Attachment_Stddev_Pop_Order_By = {
  answer_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Polls_Answer_Set_Attachment_Stddev_Samp_Fields = {
  __typename?: 'polls_answer_set_attachment_stddev_samp_fields';
  answer_set_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "polls_answer_set_attachment" */
export type Polls_Answer_Set_Attachment_Stddev_Samp_Order_By = {
  answer_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Polls_Answer_Set_Attachment_Sum_Fields = {
  __typename?: 'polls_answer_set_attachment_sum_fields';
  answer_set_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "polls_answer_set_attachment" */
export type Polls_Answer_Set_Attachment_Sum_Order_By = {
  answer_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "polls_answer_set_attachment" */
export enum Polls_Answer_Set_Attachment_Update_Column {
  /** column name */
  AnswerSetId = 'answer_set_id',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  Description = 'description',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title'
}

/** aggregate var_pop on columns */
export type Polls_Answer_Set_Attachment_Var_Pop_Fields = {
  __typename?: 'polls_answer_set_attachment_var_pop_fields';
  answer_set_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "polls_answer_set_attachment" */
export type Polls_Answer_Set_Attachment_Var_Pop_Order_By = {
  answer_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Polls_Answer_Set_Attachment_Var_Samp_Fields = {
  __typename?: 'polls_answer_set_attachment_var_samp_fields';
  answer_set_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "polls_answer_set_attachment" */
export type Polls_Answer_Set_Attachment_Var_Samp_Order_By = {
  answer_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Polls_Answer_Set_Attachment_Variance_Fields = {
  __typename?: 'polls_answer_set_attachment_variance_fields';
  answer_set_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "polls_answer_set_attachment" */
export type Polls_Answer_Set_Attachment_Variance_Order_By = {
  answer_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** input type for updating data in table "polls_answer" */
export type Polls_Answer_Set_Input = {
  base_answer_set_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  previous_id?: InputMaybe<Scalars['Int']>;
  template_answer_id?: InputMaybe<Scalars['Int']>;
  text_input?: InputMaybe<Scalars['String']>;
  text_input_type?: InputMaybe<Scalars['smallint']>;
  tooltip?: InputMaybe<Scalars['String']>;
  tooltip_en?: InputMaybe<Scalars['String']>;
  tooltip_es?: InputMaybe<Scalars['String']>;
  tooltip_fr?: InputMaybe<Scalars['String']>;
  tooltip_ja?: InputMaybe<Scalars['String']>;
  tooltip_zh_hans?: InputMaybe<Scalars['String']>;
  tooltip_zh_hant?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Polls_Answer_Stddev_Fields = {
  __typename?: 'polls_answer_stddev_fields';
  base_answer_set_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  template_answer_id?: Maybe<Scalars['Float']>;
  text_input_type?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "polls_answer" */
export type Polls_Answer_Stddev_Order_By = {
  base_answer_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_id?: InputMaybe<Order_By>;
  text_input_type?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Polls_Answer_Stddev_Pop_Fields = {
  __typename?: 'polls_answer_stddev_pop_fields';
  base_answer_set_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  template_answer_id?: Maybe<Scalars['Float']>;
  text_input_type?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "polls_answer" */
export type Polls_Answer_Stddev_Pop_Order_By = {
  base_answer_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_id?: InputMaybe<Order_By>;
  text_input_type?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Polls_Answer_Stddev_Samp_Fields = {
  __typename?: 'polls_answer_stddev_samp_fields';
  base_answer_set_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  template_answer_id?: Maybe<Scalars['Float']>;
  text_input_type?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "polls_answer" */
export type Polls_Answer_Stddev_Samp_Order_By = {
  base_answer_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_id?: InputMaybe<Order_By>;
  text_input_type?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Polls_Answer_Sum_Fields = {
  __typename?: 'polls_answer_sum_fields';
  base_answer_set_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
  template_answer_id?: Maybe<Scalars['Int']>;
  text_input_type?: Maybe<Scalars['smallint']>;
  value?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "polls_answer" */
export type Polls_Answer_Sum_Order_By = {
  base_answer_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_id?: InputMaybe<Order_By>;
  text_input_type?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** update columns of table "polls_answer" */
export enum Polls_Answer_Update_Column {
  /** column name */
  BaseAnswerSetId = 'base_answer_set_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant',
  /** column name */
  Order = 'order',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  TemplateAnswerId = 'template_answer_id',
  /** column name */
  TextInput = 'text_input',
  /** column name */
  TextInputType = 'text_input_type',
  /** column name */
  Tooltip = 'tooltip',
  /** column name */
  TooltipEn = 'tooltip_en',
  /** column name */
  TooltipEs = 'tooltip_es',
  /** column name */
  TooltipFr = 'tooltip_fr',
  /** column name */
  TooltipJa = 'tooltip_ja',
  /** column name */
  TooltipZhHans = 'tooltip_zh_hans',
  /** column name */
  TooltipZhHant = 'tooltip_zh_hant',
  /** column name */
  Value = 'value'
}

/** aggregate var_pop on columns */
export type Polls_Answer_Var_Pop_Fields = {
  __typename?: 'polls_answer_var_pop_fields';
  base_answer_set_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  template_answer_id?: Maybe<Scalars['Float']>;
  text_input_type?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "polls_answer" */
export type Polls_Answer_Var_Pop_Order_By = {
  base_answer_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_id?: InputMaybe<Order_By>;
  text_input_type?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Polls_Answer_Var_Samp_Fields = {
  __typename?: 'polls_answer_var_samp_fields';
  base_answer_set_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  template_answer_id?: Maybe<Scalars['Float']>;
  text_input_type?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "polls_answer" */
export type Polls_Answer_Var_Samp_Order_By = {
  base_answer_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_id?: InputMaybe<Order_By>;
  text_input_type?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Polls_Answer_Variance_Fields = {
  __typename?: 'polls_answer_variance_fields';
  base_answer_set_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  template_answer_id?: Maybe<Scalars['Float']>;
  text_input_type?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "polls_answer" */
export type Polls_Answer_Variance_Order_By = {
  base_answer_set_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_id?: InputMaybe<Order_By>;
  text_input_type?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "polls_answerset" */
export type Polls_Answerset = {
  __typename?: 'polls_answerset';
  /** An array relationship */
  attachments: Array<Polls_Answer_Set_Attachment>;
  /** An aggregate relationship */
  attachments_aggregate: Polls_Answer_Set_Attachment_Aggregate;
  /** An object relationship */
  base_answer_set: Polls_Baseanswerset;
  baseanswerset_ptr_id: Scalars['Int'];
  date_published?: Maybe<Scalars['timestamptz']>;
  parent_answerset_id?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
  published: Scalars['Boolean'];
};


/** columns and relationships of "polls_answerset" */
export type Polls_AnswersetAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Answer_Set_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answer_Set_Attachment_Order_By>>;
  where?: InputMaybe<Polls_Answer_Set_Attachment_Bool_Exp>;
};


/** columns and relationships of "polls_answerset" */
export type Polls_AnswersetAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Answer_Set_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answer_Set_Attachment_Order_By>>;
  where?: InputMaybe<Polls_Answer_Set_Attachment_Bool_Exp>;
};

/** aggregated selection of "polls_answerset" */
export type Polls_Answerset_Aggregate = {
  __typename?: 'polls_answerset_aggregate';
  aggregate?: Maybe<Polls_Answerset_Aggregate_Fields>;
  nodes: Array<Polls_Answerset>;
};

/** aggregate fields of "polls_answerset" */
export type Polls_Answerset_Aggregate_Fields = {
  __typename?: 'polls_answerset_aggregate_fields';
  avg?: Maybe<Polls_Answerset_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Answerset_Max_Fields>;
  min?: Maybe<Polls_Answerset_Min_Fields>;
  stddev?: Maybe<Polls_Answerset_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Answerset_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Answerset_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Answerset_Sum_Fields>;
  var_pop?: Maybe<Polls_Answerset_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Answerset_Var_Samp_Fields>;
  variance?: Maybe<Polls_Answerset_Variance_Fields>;
};


/** aggregate fields of "polls_answerset" */
export type Polls_Answerset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Answerset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "polls_answerset" */
export type Polls_Answerset_Aggregate_Order_By = {
  avg?: InputMaybe<Polls_Answerset_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Polls_Answerset_Max_Order_By>;
  min?: InputMaybe<Polls_Answerset_Min_Order_By>;
  stddev?: InputMaybe<Polls_Answerset_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Polls_Answerset_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Polls_Answerset_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Polls_Answerset_Sum_Order_By>;
  var_pop?: InputMaybe<Polls_Answerset_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Polls_Answerset_Var_Samp_Order_By>;
  variance?: InputMaybe<Polls_Answerset_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "polls_answerset" */
export type Polls_Answerset_Arr_Rel_Insert_Input = {
  data: Array<Polls_Answerset_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Answerset_On_Conflict>;
};

/** aggregate avg on columns */
export type Polls_Answerset_Avg_Fields = {
  __typename?: 'polls_answerset_avg_fields';
  baseanswerset_ptr_id?: Maybe<Scalars['Float']>;
  parent_answerset_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "polls_answerset" */
export type Polls_Answerset_Avg_Order_By = {
  baseanswerset_ptr_id?: InputMaybe<Order_By>;
  parent_answerset_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "polls_answerset". All fields are combined with a logical 'AND'. */
export type Polls_Answerset_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Answerset_Bool_Exp>>;
  _not?: InputMaybe<Polls_Answerset_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Answerset_Bool_Exp>>;
  attachments?: InputMaybe<Polls_Answer_Set_Attachment_Bool_Exp>;
  base_answer_set?: InputMaybe<Polls_Baseanswerset_Bool_Exp>;
  baseanswerset_ptr_id?: InputMaybe<Int_Comparison_Exp>;
  date_published?: InputMaybe<Timestamptz_Comparison_Exp>;
  parent_answerset_id?: InputMaybe<Int_Comparison_Exp>;
  previous_id?: InputMaybe<Int_Comparison_Exp>;
  published?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_answerset" */
export enum Polls_Answerset_Constraint {
  /** unique or primary key constraint on columns "baseanswerset_ptr_id" */
  PollsAnswersetBaseanswersetPtrId_86af4888Pk = 'polls_answerset_baseanswerset_ptr_id_86af4888_pk'
}

/** input type for incrementing numeric columns in table "polls_answerset" */
export type Polls_Answerset_Inc_Input = {
  baseanswerset_ptr_id?: InputMaybe<Scalars['Int']>;
  parent_answerset_id?: InputMaybe<Scalars['Int']>;
  previous_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_answerset" */
export type Polls_Answerset_Insert_Input = {
  attachments?: InputMaybe<Polls_Answer_Set_Attachment_Arr_Rel_Insert_Input>;
  base_answer_set?: InputMaybe<Polls_Baseanswerset_Obj_Rel_Insert_Input>;
  baseanswerset_ptr_id?: InputMaybe<Scalars['Int']>;
  date_published?: InputMaybe<Scalars['timestamptz']>;
  parent_answerset_id?: InputMaybe<Scalars['Int']>;
  previous_id?: InputMaybe<Scalars['Int']>;
  published?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Polls_Answerset_Max_Fields = {
  __typename?: 'polls_answerset_max_fields';
  baseanswerset_ptr_id?: Maybe<Scalars['Int']>;
  date_published?: Maybe<Scalars['timestamptz']>;
  parent_answerset_id?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "polls_answerset" */
export type Polls_Answerset_Max_Order_By = {
  baseanswerset_ptr_id?: InputMaybe<Order_By>;
  date_published?: InputMaybe<Order_By>;
  parent_answerset_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Polls_Answerset_Min_Fields = {
  __typename?: 'polls_answerset_min_fields';
  baseanswerset_ptr_id?: Maybe<Scalars['Int']>;
  date_published?: Maybe<Scalars['timestamptz']>;
  parent_answerset_id?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "polls_answerset" */
export type Polls_Answerset_Min_Order_By = {
  baseanswerset_ptr_id?: InputMaybe<Order_By>;
  date_published?: InputMaybe<Order_By>;
  parent_answerset_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "polls_answerset" */
export type Polls_Answerset_Mutation_Response = {
  __typename?: 'polls_answerset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Answerset>;
};

/** input type for inserting object relation for remote table "polls_answerset" */
export type Polls_Answerset_Obj_Rel_Insert_Input = {
  data: Polls_Answerset_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Answerset_On_Conflict>;
};

/** on_conflict condition type for table "polls_answerset" */
export type Polls_Answerset_On_Conflict = {
  constraint: Polls_Answerset_Constraint;
  update_columns?: Array<Polls_Answerset_Update_Column>;
  where?: InputMaybe<Polls_Answerset_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_answerset". */
export type Polls_Answerset_Order_By = {
  attachments_aggregate?: InputMaybe<Polls_Answer_Set_Attachment_Aggregate_Order_By>;
  base_answer_set?: InputMaybe<Polls_Baseanswerset_Order_By>;
  baseanswerset_ptr_id?: InputMaybe<Order_By>;
  date_published?: InputMaybe<Order_By>;
  parent_answerset_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_answerset */
export type Polls_Answerset_Pk_Columns_Input = {
  baseanswerset_ptr_id: Scalars['Int'];
};

/** select columns of table "polls_answerset" */
export enum Polls_Answerset_Select_Column {
  /** column name */
  BaseanswersetPtrId = 'baseanswerset_ptr_id',
  /** column name */
  DatePublished = 'date_published',
  /** column name */
  ParentAnswersetId = 'parent_answerset_id',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  Published = 'published'
}

/** input type for updating data in table "polls_answerset" */
export type Polls_Answerset_Set_Input = {
  baseanswerset_ptr_id?: InputMaybe<Scalars['Int']>;
  date_published?: InputMaybe<Scalars['timestamptz']>;
  parent_answerset_id?: InputMaybe<Scalars['Int']>;
  previous_id?: InputMaybe<Scalars['Int']>;
  published?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Polls_Answerset_Stddev_Fields = {
  __typename?: 'polls_answerset_stddev_fields';
  baseanswerset_ptr_id?: Maybe<Scalars['Float']>;
  parent_answerset_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "polls_answerset" */
export type Polls_Answerset_Stddev_Order_By = {
  baseanswerset_ptr_id?: InputMaybe<Order_By>;
  parent_answerset_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Polls_Answerset_Stddev_Pop_Fields = {
  __typename?: 'polls_answerset_stddev_pop_fields';
  baseanswerset_ptr_id?: Maybe<Scalars['Float']>;
  parent_answerset_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "polls_answerset" */
export type Polls_Answerset_Stddev_Pop_Order_By = {
  baseanswerset_ptr_id?: InputMaybe<Order_By>;
  parent_answerset_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Polls_Answerset_Stddev_Samp_Fields = {
  __typename?: 'polls_answerset_stddev_samp_fields';
  baseanswerset_ptr_id?: Maybe<Scalars['Float']>;
  parent_answerset_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "polls_answerset" */
export type Polls_Answerset_Stddev_Samp_Order_By = {
  baseanswerset_ptr_id?: InputMaybe<Order_By>;
  parent_answerset_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Polls_Answerset_Sum_Fields = {
  __typename?: 'polls_answerset_sum_fields';
  baseanswerset_ptr_id?: Maybe<Scalars['Int']>;
  parent_answerset_id?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "polls_answerset" */
export type Polls_Answerset_Sum_Order_By = {
  baseanswerset_ptr_id?: InputMaybe<Order_By>;
  parent_answerset_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** update columns of table "polls_answerset" */
export enum Polls_Answerset_Update_Column {
  /** column name */
  BaseanswersetPtrId = 'baseanswerset_ptr_id',
  /** column name */
  DatePublished = 'date_published',
  /** column name */
  ParentAnswersetId = 'parent_answerset_id',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  Published = 'published'
}

/** aggregate var_pop on columns */
export type Polls_Answerset_Var_Pop_Fields = {
  __typename?: 'polls_answerset_var_pop_fields';
  baseanswerset_ptr_id?: Maybe<Scalars['Float']>;
  parent_answerset_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "polls_answerset" */
export type Polls_Answerset_Var_Pop_Order_By = {
  baseanswerset_ptr_id?: InputMaybe<Order_By>;
  parent_answerset_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Polls_Answerset_Var_Samp_Fields = {
  __typename?: 'polls_answerset_var_samp_fields';
  baseanswerset_ptr_id?: Maybe<Scalars['Float']>;
  parent_answerset_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "polls_answerset" */
export type Polls_Answerset_Var_Samp_Order_By = {
  baseanswerset_ptr_id?: InputMaybe<Order_By>;
  parent_answerset_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Polls_Answerset_Variance_Fields = {
  __typename?: 'polls_answerset_variance_fields';
  baseanswerset_ptr_id?: Maybe<Scalars['Float']>;
  parent_answerset_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "polls_answerset" */
export type Polls_Answerset_Variance_Order_By = {
  baseanswerset_ptr_id?: InputMaybe<Order_By>;
  parent_answerset_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "polls_answersetattachment" */
export type Polls_Answersetattachment = {
  __typename?: 'polls_answersetattachment';
  answerset_id: Scalars['Int'];
  /** An object relationship */
  baseanswerset?: Maybe<Polls_Baseanswerset>;
  content_type: Scalars['String'];
  date_created: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  preview_url?: Maybe<Scalars['String']>;
  size: Scalars['Int'];
  title: Scalars['String'];
  url: Scalars['String'];
};

/** aggregated selection of "polls_answersetattachment" */
export type Polls_Answersetattachment_Aggregate = {
  __typename?: 'polls_answersetattachment_aggregate';
  aggregate?: Maybe<Polls_Answersetattachment_Aggregate_Fields>;
  nodes: Array<Polls_Answersetattachment>;
};

/** aggregate fields of "polls_answersetattachment" */
export type Polls_Answersetattachment_Aggregate_Fields = {
  __typename?: 'polls_answersetattachment_aggregate_fields';
  avg?: Maybe<Polls_Answersetattachment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Answersetattachment_Max_Fields>;
  min?: Maybe<Polls_Answersetattachment_Min_Fields>;
  stddev?: Maybe<Polls_Answersetattachment_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Answersetattachment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Answersetattachment_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Answersetattachment_Sum_Fields>;
  var_pop?: Maybe<Polls_Answersetattachment_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Answersetattachment_Var_Samp_Fields>;
  variance?: Maybe<Polls_Answersetattachment_Variance_Fields>;
};


/** aggregate fields of "polls_answersetattachment" */
export type Polls_Answersetattachment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Answersetattachment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Polls_Answersetattachment_Avg_Fields = {
  __typename?: 'polls_answersetattachment_avg_fields';
  answerset_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "polls_answersetattachment". All fields are combined with a logical 'AND'. */
export type Polls_Answersetattachment_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Answersetattachment_Bool_Exp>>;
  _not?: InputMaybe<Polls_Answersetattachment_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Answersetattachment_Bool_Exp>>;
  answerset_id?: InputMaybe<Int_Comparison_Exp>;
  baseanswerset?: InputMaybe<Polls_Baseanswerset_Bool_Exp>;
  content_type?: InputMaybe<String_Comparison_Exp>;
  date_created?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  preview_url?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_answersetattachment" */
export enum Polls_Answersetattachment_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollsAnswersetattachmentPkey = 'polls_answersetattachment_pkey'
}

/** input type for incrementing numeric columns in table "polls_answersetattachment" */
export type Polls_Answersetattachment_Inc_Input = {
  answerset_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_answersetattachment" */
export type Polls_Answersetattachment_Insert_Input = {
  answerset_id?: InputMaybe<Scalars['Int']>;
  baseanswerset?: InputMaybe<Polls_Baseanswerset_Obj_Rel_Insert_Input>;
  content_type?: InputMaybe<Scalars['String']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  preview_url?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Polls_Answersetattachment_Max_Fields = {
  __typename?: 'polls_answersetattachment_max_fields';
  answerset_id?: Maybe<Scalars['Int']>;
  content_type?: Maybe<Scalars['String']>;
  date_created?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  preview_url?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Polls_Answersetattachment_Min_Fields = {
  __typename?: 'polls_answersetattachment_min_fields';
  answerset_id?: Maybe<Scalars['Int']>;
  content_type?: Maybe<Scalars['String']>;
  date_created?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  preview_url?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "polls_answersetattachment" */
export type Polls_Answersetattachment_Mutation_Response = {
  __typename?: 'polls_answersetattachment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Answersetattachment>;
};

/** on_conflict condition type for table "polls_answersetattachment" */
export type Polls_Answersetattachment_On_Conflict = {
  constraint: Polls_Answersetattachment_Constraint;
  update_columns?: Array<Polls_Answersetattachment_Update_Column>;
  where?: InputMaybe<Polls_Answersetattachment_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_answersetattachment". */
export type Polls_Answersetattachment_Order_By = {
  answerset_id?: InputMaybe<Order_By>;
  baseanswerset?: InputMaybe<Polls_Baseanswerset_Order_By>;
  content_type?: InputMaybe<Order_By>;
  date_created?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  preview_url?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_answersetattachment */
export type Polls_Answersetattachment_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_answersetattachment" */
export enum Polls_Answersetattachment_Select_Column {
  /** column name */
  AnswersetId = 'answerset_id',
  /** column name */
  ContentType = 'content_type',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  PreviewUrl = 'preview_url',
  /** column name */
  Size = 'size',
  /** column name */
  Title = 'title',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "polls_answersetattachment" */
export type Polls_Answersetattachment_Set_Input = {
  answerset_id?: InputMaybe<Scalars['Int']>;
  content_type?: InputMaybe<Scalars['String']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  preview_url?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Polls_Answersetattachment_Stddev_Fields = {
  __typename?: 'polls_answersetattachment_stddev_fields';
  answerset_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Polls_Answersetattachment_Stddev_Pop_Fields = {
  __typename?: 'polls_answersetattachment_stddev_pop_fields';
  answerset_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Polls_Answersetattachment_Stddev_Samp_Fields = {
  __typename?: 'polls_answersetattachment_stddev_samp_fields';
  answerset_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Polls_Answersetattachment_Sum_Fields = {
  __typename?: 'polls_answersetattachment_sum_fields';
  answerset_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
};

/** update columns of table "polls_answersetattachment" */
export enum Polls_Answersetattachment_Update_Column {
  /** column name */
  AnswersetId = 'answerset_id',
  /** column name */
  ContentType = 'content_type',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  PreviewUrl = 'preview_url',
  /** column name */
  Size = 'size',
  /** column name */
  Title = 'title',
  /** column name */
  Url = 'url'
}

/** aggregate var_pop on columns */
export type Polls_Answersetattachment_Var_Pop_Fields = {
  __typename?: 'polls_answersetattachment_var_pop_fields';
  answerset_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Polls_Answersetattachment_Var_Samp_Fields = {
  __typename?: 'polls_answersetattachment_var_samp_fields';
  answerset_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Polls_Answersetattachment_Variance_Fields = {
  __typename?: 'polls_answersetattachment_variance_fields';
  answerset_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "polls_baseanswerset" */
export type Polls_Baseanswerset = {
  __typename?: 'polls_baseanswerset';
  /** An array relationship */
  answer_sets: Array<Polls_Answerset>;
  /** An aggregate relationship */
  answer_sets_aggregate: Polls_Answerset_Aggregate;
  /** An array relationship */
  answers: Array<Polls_Answer>;
  /** An aggregate relationship */
  answers_aggregate: Polls_Answer_Aggregate;
  /** An array relationship */
  branches: Array<Polls_Baseanswerset_Branches>;
  /** An aggregate relationship */
  branches_aggregate: Polls_Baseanswerset_Branches_Aggregate;
  /** An object relationship */
  comment?: Maybe<Polls_Comment>;
  date_created: Scalars['timestamptz'];
  date_modified: Scalars['timestamptz'];
  /** An object relationship */
  entry: Polls_Entity;
  entry_id: Scalars['Int'];
  /** An object relationship */
  expert: Accounts_Expert;
  expert_id: Scalars['Int'];
  history_parent_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  /** An object relationship */
  poll: Polls_Poll;
  poll_id: Scalars['Int'];
  /** An object relationship */
  question: Polls_Question;
  question_id: Scalars['Int'];
  /** An object relationship */
  region: Gis_Regions_Gis_Region;
  region_id: Scalars['Int'];
  year_from?: Maybe<Scalars['Int']>;
  year_to?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "polls_baseanswerset" */
export type Polls_BaseanswersetAnswer_SetsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Answerset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answerset_Order_By>>;
  where?: InputMaybe<Polls_Answerset_Bool_Exp>;
};


/** columns and relationships of "polls_baseanswerset" */
export type Polls_BaseanswersetAnswer_Sets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Answerset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answerset_Order_By>>;
  where?: InputMaybe<Polls_Answerset_Bool_Exp>;
};


/** columns and relationships of "polls_baseanswerset" */
export type Polls_BaseanswersetAnswersArgs = {
  distinct_on?: InputMaybe<Array<Polls_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answer_Order_By>>;
  where?: InputMaybe<Polls_Answer_Bool_Exp>;
};


/** columns and relationships of "polls_baseanswerset" */
export type Polls_BaseanswersetAnswers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answer_Order_By>>;
  where?: InputMaybe<Polls_Answer_Bool_Exp>;
};


/** columns and relationships of "polls_baseanswerset" */
export type Polls_BaseanswersetBranchesArgs = {
  distinct_on?: InputMaybe<Array<Polls_Baseanswerset_Branches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Baseanswerset_Branches_Order_By>>;
  where?: InputMaybe<Polls_Baseanswerset_Branches_Bool_Exp>;
};


/** columns and relationships of "polls_baseanswerset" */
export type Polls_BaseanswersetBranches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Baseanswerset_Branches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Baseanswerset_Branches_Order_By>>;
  where?: InputMaybe<Polls_Baseanswerset_Branches_Bool_Exp>;
};

/** aggregated selection of "polls_baseanswerset" */
export type Polls_Baseanswerset_Aggregate = {
  __typename?: 'polls_baseanswerset_aggregate';
  aggregate?: Maybe<Polls_Baseanswerset_Aggregate_Fields>;
  nodes: Array<Polls_Baseanswerset>;
};

/** aggregate fields of "polls_baseanswerset" */
export type Polls_Baseanswerset_Aggregate_Fields = {
  __typename?: 'polls_baseanswerset_aggregate_fields';
  avg?: Maybe<Polls_Baseanswerset_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Baseanswerset_Max_Fields>;
  min?: Maybe<Polls_Baseanswerset_Min_Fields>;
  stddev?: Maybe<Polls_Baseanswerset_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Baseanswerset_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Baseanswerset_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Baseanswerset_Sum_Fields>;
  var_pop?: Maybe<Polls_Baseanswerset_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Baseanswerset_Var_Samp_Fields>;
  variance?: Maybe<Polls_Baseanswerset_Variance_Fields>;
};


/** aggregate fields of "polls_baseanswerset" */
export type Polls_Baseanswerset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Baseanswerset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "polls_baseanswerset" */
export type Polls_Baseanswerset_Aggregate_Order_By = {
  avg?: InputMaybe<Polls_Baseanswerset_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Polls_Baseanswerset_Max_Order_By>;
  min?: InputMaybe<Polls_Baseanswerset_Min_Order_By>;
  stddev?: InputMaybe<Polls_Baseanswerset_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Polls_Baseanswerset_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Polls_Baseanswerset_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Polls_Baseanswerset_Sum_Order_By>;
  var_pop?: InputMaybe<Polls_Baseanswerset_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Polls_Baseanswerset_Var_Samp_Order_By>;
  variance?: InputMaybe<Polls_Baseanswerset_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "polls_baseanswerset" */
export type Polls_Baseanswerset_Arr_Rel_Insert_Input = {
  data: Array<Polls_Baseanswerset_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Baseanswerset_On_Conflict>;
};

/** aggregate avg on columns */
export type Polls_Baseanswerset_Avg_Fields = {
  __typename?: 'polls_baseanswerset_avg_fields';
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  history_parent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  year_from?: Maybe<Scalars['Float']>;
  year_to?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "polls_baseanswerset" */
export type Polls_Baseanswerset_Avg_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  expert_id?: InputMaybe<Order_By>;
  history_parent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  year_from?: InputMaybe<Order_By>;
  year_to?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "polls_baseanswerset". All fields are combined with a logical 'AND'. */
export type Polls_Baseanswerset_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Baseanswerset_Bool_Exp>>;
  _not?: InputMaybe<Polls_Baseanswerset_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Baseanswerset_Bool_Exp>>;
  answer_sets?: InputMaybe<Polls_Answerset_Bool_Exp>;
  answers?: InputMaybe<Polls_Answer_Bool_Exp>;
  branches?: InputMaybe<Polls_Baseanswerset_Branches_Bool_Exp>;
  comment?: InputMaybe<Polls_Comment_Bool_Exp>;
  date_created?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  entry?: InputMaybe<Polls_Entity_Bool_Exp>;
  entry_id?: InputMaybe<Int_Comparison_Exp>;
  expert?: InputMaybe<Accounts_Expert_Bool_Exp>;
  expert_id?: InputMaybe<Int_Comparison_Exp>;
  history_parent_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  poll?: InputMaybe<Polls_Poll_Bool_Exp>;
  poll_id?: InputMaybe<Int_Comparison_Exp>;
  question?: InputMaybe<Polls_Question_Bool_Exp>;
  question_id?: InputMaybe<Int_Comparison_Exp>;
  region?: InputMaybe<Gis_Regions_Gis_Region_Bool_Exp>;
  region_id?: InputMaybe<Int_Comparison_Exp>;
  year_from?: InputMaybe<Int_Comparison_Exp>;
  year_to?: InputMaybe<Int_Comparison_Exp>;
};

/** columns and relationships of "polls_baseanswerset_branches" */
export type Polls_Baseanswerset_Branches = {
  __typename?: 'polls_baseanswerset_branches';
  baseanswerset_id: Scalars['Int'];
  /** An object relationship */
  branch: Polls_Branch;
  branch_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "polls_baseanswerset_branches" */
export type Polls_Baseanswerset_Branches_Aggregate = {
  __typename?: 'polls_baseanswerset_branches_aggregate';
  aggregate?: Maybe<Polls_Baseanswerset_Branches_Aggregate_Fields>;
  nodes: Array<Polls_Baseanswerset_Branches>;
};

/** aggregate fields of "polls_baseanswerset_branches" */
export type Polls_Baseanswerset_Branches_Aggregate_Fields = {
  __typename?: 'polls_baseanswerset_branches_aggregate_fields';
  avg?: Maybe<Polls_Baseanswerset_Branches_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Baseanswerset_Branches_Max_Fields>;
  min?: Maybe<Polls_Baseanswerset_Branches_Min_Fields>;
  stddev?: Maybe<Polls_Baseanswerset_Branches_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Baseanswerset_Branches_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Baseanswerset_Branches_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Baseanswerset_Branches_Sum_Fields>;
  var_pop?: Maybe<Polls_Baseanswerset_Branches_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Baseanswerset_Branches_Var_Samp_Fields>;
  variance?: Maybe<Polls_Baseanswerset_Branches_Variance_Fields>;
};


/** aggregate fields of "polls_baseanswerset_branches" */
export type Polls_Baseanswerset_Branches_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Baseanswerset_Branches_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "polls_baseanswerset_branches" */
export type Polls_Baseanswerset_Branches_Aggregate_Order_By = {
  avg?: InputMaybe<Polls_Baseanswerset_Branches_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Polls_Baseanswerset_Branches_Max_Order_By>;
  min?: InputMaybe<Polls_Baseanswerset_Branches_Min_Order_By>;
  stddev?: InputMaybe<Polls_Baseanswerset_Branches_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Polls_Baseanswerset_Branches_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Polls_Baseanswerset_Branches_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Polls_Baseanswerset_Branches_Sum_Order_By>;
  var_pop?: InputMaybe<Polls_Baseanswerset_Branches_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Polls_Baseanswerset_Branches_Var_Samp_Order_By>;
  variance?: InputMaybe<Polls_Baseanswerset_Branches_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "polls_baseanswerset_branches" */
export type Polls_Baseanswerset_Branches_Arr_Rel_Insert_Input = {
  data: Array<Polls_Baseanswerset_Branches_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Baseanswerset_Branches_On_Conflict>;
};

/** aggregate avg on columns */
export type Polls_Baseanswerset_Branches_Avg_Fields = {
  __typename?: 'polls_baseanswerset_branches_avg_fields';
  baseanswerset_id?: Maybe<Scalars['Float']>;
  branch_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "polls_baseanswerset_branches" */
export type Polls_Baseanswerset_Branches_Avg_Order_By = {
  baseanswerset_id?: InputMaybe<Order_By>;
  branch_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "polls_baseanswerset_branches". All fields are combined with a logical 'AND'. */
export type Polls_Baseanswerset_Branches_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Baseanswerset_Branches_Bool_Exp>>;
  _not?: InputMaybe<Polls_Baseanswerset_Branches_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Baseanswerset_Branches_Bool_Exp>>;
  baseanswerset_id?: InputMaybe<Int_Comparison_Exp>;
  branch?: InputMaybe<Polls_Branch_Bool_Exp>;
  branch_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_baseanswerset_branches" */
export enum Polls_Baseanswerset_Branches_Constraint {
  /** unique or primary key constraint on columns "branch_id", "baseanswerset_id" */
  PollsBaseanswersetBranBaseanswersetIdBranch_562f4153Uniq = 'polls_baseanswerset_bran_baseanswerset_id_branch__562f4153_uniq',
  /** unique or primary key constraint on columns "id" */
  PollsBaseanswersetBranchesPkey = 'polls_baseanswerset_branches_pkey'
}

/** input type for incrementing numeric columns in table "polls_baseanswerset_branches" */
export type Polls_Baseanswerset_Branches_Inc_Input = {
  baseanswerset_id?: InputMaybe<Scalars['Int']>;
  branch_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_baseanswerset_branches" */
export type Polls_Baseanswerset_Branches_Insert_Input = {
  baseanswerset_id?: InputMaybe<Scalars['Int']>;
  branch?: InputMaybe<Polls_Branch_Obj_Rel_Insert_Input>;
  branch_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Polls_Baseanswerset_Branches_Max_Fields = {
  __typename?: 'polls_baseanswerset_branches_max_fields';
  baseanswerset_id?: Maybe<Scalars['Int']>;
  branch_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "polls_baseanswerset_branches" */
export type Polls_Baseanswerset_Branches_Max_Order_By = {
  baseanswerset_id?: InputMaybe<Order_By>;
  branch_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Polls_Baseanswerset_Branches_Min_Fields = {
  __typename?: 'polls_baseanswerset_branches_min_fields';
  baseanswerset_id?: Maybe<Scalars['Int']>;
  branch_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "polls_baseanswerset_branches" */
export type Polls_Baseanswerset_Branches_Min_Order_By = {
  baseanswerset_id?: InputMaybe<Order_By>;
  branch_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "polls_baseanswerset_branches" */
export type Polls_Baseanswerset_Branches_Mutation_Response = {
  __typename?: 'polls_baseanswerset_branches_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Baseanswerset_Branches>;
};

/** on_conflict condition type for table "polls_baseanswerset_branches" */
export type Polls_Baseanswerset_Branches_On_Conflict = {
  constraint: Polls_Baseanswerset_Branches_Constraint;
  update_columns?: Array<Polls_Baseanswerset_Branches_Update_Column>;
  where?: InputMaybe<Polls_Baseanswerset_Branches_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_baseanswerset_branches". */
export type Polls_Baseanswerset_Branches_Order_By = {
  baseanswerset_id?: InputMaybe<Order_By>;
  branch?: InputMaybe<Polls_Branch_Order_By>;
  branch_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_baseanswerset_branches */
export type Polls_Baseanswerset_Branches_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_baseanswerset_branches" */
export enum Polls_Baseanswerset_Branches_Select_Column {
  /** column name */
  BaseanswersetId = 'baseanswerset_id',
  /** column name */
  BranchId = 'branch_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "polls_baseanswerset_branches" */
export type Polls_Baseanswerset_Branches_Set_Input = {
  baseanswerset_id?: InputMaybe<Scalars['Int']>;
  branch_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Polls_Baseanswerset_Branches_Stddev_Fields = {
  __typename?: 'polls_baseanswerset_branches_stddev_fields';
  baseanswerset_id?: Maybe<Scalars['Float']>;
  branch_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "polls_baseanswerset_branches" */
export type Polls_Baseanswerset_Branches_Stddev_Order_By = {
  baseanswerset_id?: InputMaybe<Order_By>;
  branch_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Polls_Baseanswerset_Branches_Stddev_Pop_Fields = {
  __typename?: 'polls_baseanswerset_branches_stddev_pop_fields';
  baseanswerset_id?: Maybe<Scalars['Float']>;
  branch_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "polls_baseanswerset_branches" */
export type Polls_Baseanswerset_Branches_Stddev_Pop_Order_By = {
  baseanswerset_id?: InputMaybe<Order_By>;
  branch_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Polls_Baseanswerset_Branches_Stddev_Samp_Fields = {
  __typename?: 'polls_baseanswerset_branches_stddev_samp_fields';
  baseanswerset_id?: Maybe<Scalars['Float']>;
  branch_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "polls_baseanswerset_branches" */
export type Polls_Baseanswerset_Branches_Stddev_Samp_Order_By = {
  baseanswerset_id?: InputMaybe<Order_By>;
  branch_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Polls_Baseanswerset_Branches_Sum_Fields = {
  __typename?: 'polls_baseanswerset_branches_sum_fields';
  baseanswerset_id?: Maybe<Scalars['Int']>;
  branch_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "polls_baseanswerset_branches" */
export type Polls_Baseanswerset_Branches_Sum_Order_By = {
  baseanswerset_id?: InputMaybe<Order_By>;
  branch_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "polls_baseanswerset_branches" */
export enum Polls_Baseanswerset_Branches_Update_Column {
  /** column name */
  BaseanswersetId = 'baseanswerset_id',
  /** column name */
  BranchId = 'branch_id',
  /** column name */
  Id = 'id'
}

/** aggregate var_pop on columns */
export type Polls_Baseanswerset_Branches_Var_Pop_Fields = {
  __typename?: 'polls_baseanswerset_branches_var_pop_fields';
  baseanswerset_id?: Maybe<Scalars['Float']>;
  branch_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "polls_baseanswerset_branches" */
export type Polls_Baseanswerset_Branches_Var_Pop_Order_By = {
  baseanswerset_id?: InputMaybe<Order_By>;
  branch_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Polls_Baseanswerset_Branches_Var_Samp_Fields = {
  __typename?: 'polls_baseanswerset_branches_var_samp_fields';
  baseanswerset_id?: Maybe<Scalars['Float']>;
  branch_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "polls_baseanswerset_branches" */
export type Polls_Baseanswerset_Branches_Var_Samp_Order_By = {
  baseanswerset_id?: InputMaybe<Order_By>;
  branch_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Polls_Baseanswerset_Branches_Variance_Fields = {
  __typename?: 'polls_baseanswerset_branches_variance_fields';
  baseanswerset_id?: Maybe<Scalars['Float']>;
  branch_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "polls_baseanswerset_branches" */
export type Polls_Baseanswerset_Branches_Variance_Order_By = {
  baseanswerset_id?: InputMaybe<Order_By>;
  branch_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "polls_baseanswerset" */
export enum Polls_Baseanswerset_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollsBaseanswersetPkey = 'polls_baseanswerset_pkey'
}

/** input type for incrementing numeric columns in table "polls_baseanswerset" */
export type Polls_Baseanswerset_Inc_Input = {
  entry_id?: InputMaybe<Scalars['Int']>;
  expert_id?: InputMaybe<Scalars['Int']>;
  history_parent_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  poll_id?: InputMaybe<Scalars['Int']>;
  question_id?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['Int']>;
  year_from?: InputMaybe<Scalars['Int']>;
  year_to?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_baseanswerset" */
export type Polls_Baseanswerset_Insert_Input = {
  answer_sets?: InputMaybe<Polls_Answerset_Arr_Rel_Insert_Input>;
  answers?: InputMaybe<Polls_Answer_Arr_Rel_Insert_Input>;
  branches?: InputMaybe<Polls_Baseanswerset_Branches_Arr_Rel_Insert_Input>;
  comment?: InputMaybe<Polls_Comment_Obj_Rel_Insert_Input>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_modified?: InputMaybe<Scalars['timestamptz']>;
  entry?: InputMaybe<Polls_Entity_Obj_Rel_Insert_Input>;
  entry_id?: InputMaybe<Scalars['Int']>;
  expert?: InputMaybe<Accounts_Expert_Obj_Rel_Insert_Input>;
  expert_id?: InputMaybe<Scalars['Int']>;
  history_parent_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  poll?: InputMaybe<Polls_Poll_Obj_Rel_Insert_Input>;
  poll_id?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Polls_Question_Obj_Rel_Insert_Input>;
  question_id?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<Gis_Regions_Gis_Region_Obj_Rel_Insert_Input>;
  region_id?: InputMaybe<Scalars['Int']>;
  year_from?: InputMaybe<Scalars['Int']>;
  year_to?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Polls_Baseanswerset_Max_Fields = {
  __typename?: 'polls_baseanswerset_max_fields';
  date_created?: Maybe<Scalars['timestamptz']>;
  date_modified?: Maybe<Scalars['timestamptz']>;
  entry_id?: Maybe<Scalars['Int']>;
  expert_id?: Maybe<Scalars['Int']>;
  history_parent_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  poll_id?: Maybe<Scalars['Int']>;
  question_id?: Maybe<Scalars['Int']>;
  region_id?: Maybe<Scalars['Int']>;
  year_from?: Maybe<Scalars['Int']>;
  year_to?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "polls_baseanswerset" */
export type Polls_Baseanswerset_Max_Order_By = {
  date_created?: InputMaybe<Order_By>;
  date_modified?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  expert_id?: InputMaybe<Order_By>;
  history_parent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  year_from?: InputMaybe<Order_By>;
  year_to?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Polls_Baseanswerset_Min_Fields = {
  __typename?: 'polls_baseanswerset_min_fields';
  date_created?: Maybe<Scalars['timestamptz']>;
  date_modified?: Maybe<Scalars['timestamptz']>;
  entry_id?: Maybe<Scalars['Int']>;
  expert_id?: Maybe<Scalars['Int']>;
  history_parent_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  poll_id?: Maybe<Scalars['Int']>;
  question_id?: Maybe<Scalars['Int']>;
  region_id?: Maybe<Scalars['Int']>;
  year_from?: Maybe<Scalars['Int']>;
  year_to?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "polls_baseanswerset" */
export type Polls_Baseanswerset_Min_Order_By = {
  date_created?: InputMaybe<Order_By>;
  date_modified?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  expert_id?: InputMaybe<Order_By>;
  history_parent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  year_from?: InputMaybe<Order_By>;
  year_to?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "polls_baseanswerset" */
export type Polls_Baseanswerset_Mutation_Response = {
  __typename?: 'polls_baseanswerset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Baseanswerset>;
};

/** input type for inserting object relation for remote table "polls_baseanswerset" */
export type Polls_Baseanswerset_Obj_Rel_Insert_Input = {
  data: Polls_Baseanswerset_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Baseanswerset_On_Conflict>;
};

/** on_conflict condition type for table "polls_baseanswerset" */
export type Polls_Baseanswerset_On_Conflict = {
  constraint: Polls_Baseanswerset_Constraint;
  update_columns?: Array<Polls_Baseanswerset_Update_Column>;
  where?: InputMaybe<Polls_Baseanswerset_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_baseanswerset". */
export type Polls_Baseanswerset_Order_By = {
  answer_sets_aggregate?: InputMaybe<Polls_Answerset_Aggregate_Order_By>;
  answers_aggregate?: InputMaybe<Polls_Answer_Aggregate_Order_By>;
  branches_aggregate?: InputMaybe<Polls_Baseanswerset_Branches_Aggregate_Order_By>;
  comment?: InputMaybe<Polls_Comment_Order_By>;
  date_created?: InputMaybe<Order_By>;
  date_modified?: InputMaybe<Order_By>;
  entry?: InputMaybe<Polls_Entity_Order_By>;
  entry_id?: InputMaybe<Order_By>;
  expert?: InputMaybe<Accounts_Expert_Order_By>;
  expert_id?: InputMaybe<Order_By>;
  history_parent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  poll?: InputMaybe<Polls_Poll_Order_By>;
  poll_id?: InputMaybe<Order_By>;
  question?: InputMaybe<Polls_Question_Order_By>;
  question_id?: InputMaybe<Order_By>;
  region?: InputMaybe<Gis_Regions_Gis_Region_Order_By>;
  region_id?: InputMaybe<Order_By>;
  year_from?: InputMaybe<Order_By>;
  year_to?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_baseanswerset */
export type Polls_Baseanswerset_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_baseanswerset" */
export enum Polls_Baseanswerset_Select_Column {
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateModified = 'date_modified',
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  ExpertId = 'expert_id',
  /** column name */
  HistoryParentId = 'history_parent_id',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  PollId = 'poll_id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  YearFrom = 'year_from',
  /** column name */
  YearTo = 'year_to'
}

/** input type for updating data in table "polls_baseanswerset" */
export type Polls_Baseanswerset_Set_Input = {
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_modified?: InputMaybe<Scalars['timestamptz']>;
  entry_id?: InputMaybe<Scalars['Int']>;
  expert_id?: InputMaybe<Scalars['Int']>;
  history_parent_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  poll_id?: InputMaybe<Scalars['Int']>;
  question_id?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['Int']>;
  year_from?: InputMaybe<Scalars['Int']>;
  year_to?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Polls_Baseanswerset_Stddev_Fields = {
  __typename?: 'polls_baseanswerset_stddev_fields';
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  history_parent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  year_from?: Maybe<Scalars['Float']>;
  year_to?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "polls_baseanswerset" */
export type Polls_Baseanswerset_Stddev_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  expert_id?: InputMaybe<Order_By>;
  history_parent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  year_from?: InputMaybe<Order_By>;
  year_to?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Polls_Baseanswerset_Stddev_Pop_Fields = {
  __typename?: 'polls_baseanswerset_stddev_pop_fields';
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  history_parent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  year_from?: Maybe<Scalars['Float']>;
  year_to?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "polls_baseanswerset" */
export type Polls_Baseanswerset_Stddev_Pop_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  expert_id?: InputMaybe<Order_By>;
  history_parent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  year_from?: InputMaybe<Order_By>;
  year_to?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Polls_Baseanswerset_Stddev_Samp_Fields = {
  __typename?: 'polls_baseanswerset_stddev_samp_fields';
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  history_parent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  year_from?: Maybe<Scalars['Float']>;
  year_to?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "polls_baseanswerset" */
export type Polls_Baseanswerset_Stddev_Samp_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  expert_id?: InputMaybe<Order_By>;
  history_parent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  year_from?: InputMaybe<Order_By>;
  year_to?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Polls_Baseanswerset_Sum_Fields = {
  __typename?: 'polls_baseanswerset_sum_fields';
  entry_id?: Maybe<Scalars['Int']>;
  expert_id?: Maybe<Scalars['Int']>;
  history_parent_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  poll_id?: Maybe<Scalars['Int']>;
  question_id?: Maybe<Scalars['Int']>;
  region_id?: Maybe<Scalars['Int']>;
  year_from?: Maybe<Scalars['Int']>;
  year_to?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "polls_baseanswerset" */
export type Polls_Baseanswerset_Sum_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  expert_id?: InputMaybe<Order_By>;
  history_parent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  year_from?: InputMaybe<Order_By>;
  year_to?: InputMaybe<Order_By>;
};

/** update columns of table "polls_baseanswerset" */
export enum Polls_Baseanswerset_Update_Column {
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateModified = 'date_modified',
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  ExpertId = 'expert_id',
  /** column name */
  HistoryParentId = 'history_parent_id',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  PollId = 'poll_id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  YearFrom = 'year_from',
  /** column name */
  YearTo = 'year_to'
}

/** aggregate var_pop on columns */
export type Polls_Baseanswerset_Var_Pop_Fields = {
  __typename?: 'polls_baseanswerset_var_pop_fields';
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  history_parent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  year_from?: Maybe<Scalars['Float']>;
  year_to?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "polls_baseanswerset" */
export type Polls_Baseanswerset_Var_Pop_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  expert_id?: InputMaybe<Order_By>;
  history_parent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  year_from?: InputMaybe<Order_By>;
  year_to?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Polls_Baseanswerset_Var_Samp_Fields = {
  __typename?: 'polls_baseanswerset_var_samp_fields';
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  history_parent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  year_from?: Maybe<Scalars['Float']>;
  year_to?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "polls_baseanswerset" */
export type Polls_Baseanswerset_Var_Samp_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  expert_id?: InputMaybe<Order_By>;
  history_parent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  year_from?: InputMaybe<Order_By>;
  year_to?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Polls_Baseanswerset_Variance_Fields = {
  __typename?: 'polls_baseanswerset_variance_fields';
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  history_parent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  year_from?: Maybe<Scalars['Float']>;
  year_to?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "polls_baseanswerset" */
export type Polls_Baseanswerset_Variance_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  expert_id?: InputMaybe<Order_By>;
  history_parent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  year_from?: InputMaybe<Order_By>;
  year_to?: InputMaybe<Order_By>;
};

/** columns and relationships of "polls_basesource" */
export type Polls_Basesource = {
  __typename?: 'polls_basesource';
  created_at?: Maybe<Scalars['timestamptz']>;
  csl_json: Scalars['jsonb'];
  id: Scalars['Int'];
  uniq_hash: Scalars['String'];
};


/** columns and relationships of "polls_basesource" */
export type Polls_BasesourceCsl_JsonArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "polls_basesource" */
export type Polls_Basesource_Aggregate = {
  __typename?: 'polls_basesource_aggregate';
  aggregate?: Maybe<Polls_Basesource_Aggregate_Fields>;
  nodes: Array<Polls_Basesource>;
};

/** aggregate fields of "polls_basesource" */
export type Polls_Basesource_Aggregate_Fields = {
  __typename?: 'polls_basesource_aggregate_fields';
  avg?: Maybe<Polls_Basesource_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Basesource_Max_Fields>;
  min?: Maybe<Polls_Basesource_Min_Fields>;
  stddev?: Maybe<Polls_Basesource_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Basesource_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Basesource_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Basesource_Sum_Fields>;
  var_pop?: Maybe<Polls_Basesource_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Basesource_Var_Samp_Fields>;
  variance?: Maybe<Polls_Basesource_Variance_Fields>;
};


/** aggregate fields of "polls_basesource" */
export type Polls_Basesource_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Basesource_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Polls_Basesource_Append_Input = {
  csl_json?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Polls_Basesource_Avg_Fields = {
  __typename?: 'polls_basesource_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "polls_basesource". All fields are combined with a logical 'AND'. */
export type Polls_Basesource_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Basesource_Bool_Exp>>;
  _not?: InputMaybe<Polls_Basesource_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Basesource_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  csl_json?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  uniq_hash?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_basesource" */
export enum Polls_Basesource_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollsBasesourcePkey = 'polls_basesource_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Polls_Basesource_Delete_At_Path_Input = {
  csl_json?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Polls_Basesource_Delete_Elem_Input = {
  csl_json?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Polls_Basesource_Delete_Key_Input = {
  csl_json?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "polls_basesource" */
export type Polls_Basesource_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_basesource" */
export type Polls_Basesource_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  csl_json?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  uniq_hash?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Polls_Basesource_Max_Fields = {
  __typename?: 'polls_basesource_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  uniq_hash?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Polls_Basesource_Min_Fields = {
  __typename?: 'polls_basesource_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  uniq_hash?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "polls_basesource" */
export type Polls_Basesource_Mutation_Response = {
  __typename?: 'polls_basesource_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Basesource>;
};

/** on_conflict condition type for table "polls_basesource" */
export type Polls_Basesource_On_Conflict = {
  constraint: Polls_Basesource_Constraint;
  update_columns?: Array<Polls_Basesource_Update_Column>;
  where?: InputMaybe<Polls_Basesource_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_basesource". */
export type Polls_Basesource_Order_By = {
  created_at?: InputMaybe<Order_By>;
  csl_json?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uniq_hash?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_basesource */
export type Polls_Basesource_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Polls_Basesource_Prepend_Input = {
  csl_json?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "polls_basesource" */
export enum Polls_Basesource_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CslJson = 'csl_json',
  /** column name */
  Id = 'id',
  /** column name */
  UniqHash = 'uniq_hash'
}

/** input type for updating data in table "polls_basesource" */
export type Polls_Basesource_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  csl_json?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  uniq_hash?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Polls_Basesource_Stddev_Fields = {
  __typename?: 'polls_basesource_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Polls_Basesource_Stddev_Pop_Fields = {
  __typename?: 'polls_basesource_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Polls_Basesource_Stddev_Samp_Fields = {
  __typename?: 'polls_basesource_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Polls_Basesource_Sum_Fields = {
  __typename?: 'polls_basesource_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "polls_basesource" */
export enum Polls_Basesource_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CslJson = 'csl_json',
  /** column name */
  Id = 'id',
  /** column name */
  UniqHash = 'uniq_hash'
}

/** aggregate var_pop on columns */
export type Polls_Basesource_Var_Pop_Fields = {
  __typename?: 'polls_basesource_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Polls_Basesource_Var_Samp_Fields = {
  __typename?: 'polls_basesource_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Polls_Basesource_Variance_Fields = {
  __typename?: 'polls_basesource_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "polls_branch" */
export type Polls_Branch = {
  __typename?: 'polls_branch';
  /** An object relationship */
  branching_question?: Maybe<Polls_Branchingquestion>;
  branching_question_id?: Maybe<Scalars['Int']>;
  date_created: Scalars['timestamptz'];
  date_modified: Scalars['timestamptz'];
  id: Scalars['Int'];
  name: Scalars['String'];
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  /** An object relationship */
  previous?: Maybe<Polls_Branch>;
  previous_id?: Maybe<Scalars['Int']>;
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
  translated_name?: Maybe<Scalars['String']>;
  translated_tooltip?: Maybe<Scalars['String']>;
};


/** columns and relationships of "polls_branch" */
export type Polls_BranchTranslated_NameArgs = {
  args: Translated_Name_Polls_Branch_Args;
};


/** columns and relationships of "polls_branch" */
export type Polls_BranchTranslated_TooltipArgs = {
  args: Translated_Tooltip_Polls_Branch_Args;
};

/** aggregated selection of "polls_branch" */
export type Polls_Branch_Aggregate = {
  __typename?: 'polls_branch_aggregate';
  aggregate?: Maybe<Polls_Branch_Aggregate_Fields>;
  nodes: Array<Polls_Branch>;
};

/** aggregate fields of "polls_branch" */
export type Polls_Branch_Aggregate_Fields = {
  __typename?: 'polls_branch_aggregate_fields';
  avg?: Maybe<Polls_Branch_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Branch_Max_Fields>;
  min?: Maybe<Polls_Branch_Min_Fields>;
  stddev?: Maybe<Polls_Branch_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Branch_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Branch_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Branch_Sum_Fields>;
  var_pop?: Maybe<Polls_Branch_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Branch_Var_Samp_Fields>;
  variance?: Maybe<Polls_Branch_Variance_Fields>;
};


/** aggregate fields of "polls_branch" */
export type Polls_Branch_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Branch_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "polls_branch" */
export type Polls_Branch_Aggregate_Order_By = {
  avg?: InputMaybe<Polls_Branch_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Polls_Branch_Max_Order_By>;
  min?: InputMaybe<Polls_Branch_Min_Order_By>;
  stddev?: InputMaybe<Polls_Branch_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Polls_Branch_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Polls_Branch_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Polls_Branch_Sum_Order_By>;
  var_pop?: InputMaybe<Polls_Branch_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Polls_Branch_Var_Samp_Order_By>;
  variance?: InputMaybe<Polls_Branch_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "polls_branch" */
export type Polls_Branch_Arr_Rel_Insert_Input = {
  data: Array<Polls_Branch_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Branch_On_Conflict>;
};

/** aggregate avg on columns */
export type Polls_Branch_Avg_Fields = {
  __typename?: 'polls_branch_avg_fields';
  branching_question_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "polls_branch" */
export type Polls_Branch_Avg_Order_By = {
  branching_question_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "polls_branch". All fields are combined with a logical 'AND'. */
export type Polls_Branch_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Branch_Bool_Exp>>;
  _not?: InputMaybe<Polls_Branch_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Branch_Bool_Exp>>;
  branching_question?: InputMaybe<Polls_Branchingquestion_Bool_Exp>;
  branching_question_id?: InputMaybe<Int_Comparison_Exp>;
  date_created?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  name_en?: InputMaybe<String_Comparison_Exp>;
  name_es?: InputMaybe<String_Comparison_Exp>;
  name_fr?: InputMaybe<String_Comparison_Exp>;
  name_ja?: InputMaybe<String_Comparison_Exp>;
  name_zh_hans?: InputMaybe<String_Comparison_Exp>;
  name_zh_hant?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  previous?: InputMaybe<Polls_Branch_Bool_Exp>;
  previous_id?: InputMaybe<Int_Comparison_Exp>;
  tooltip?: InputMaybe<String_Comparison_Exp>;
  tooltip_en?: InputMaybe<String_Comparison_Exp>;
  tooltip_es?: InputMaybe<String_Comparison_Exp>;
  tooltip_fr?: InputMaybe<String_Comparison_Exp>;
  tooltip_ja?: InputMaybe<String_Comparison_Exp>;
  tooltip_zh_hans?: InputMaybe<String_Comparison_Exp>;
  tooltip_zh_hant?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_branch" */
export enum Polls_Branch_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollsBranchPkey = 'polls_branch_pkey'
}

/** input type for incrementing numeric columns in table "polls_branch" */
export type Polls_Branch_Inc_Input = {
  branching_question_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  previous_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_branch" */
export type Polls_Branch_Insert_Input = {
  branching_question?: InputMaybe<Polls_Branchingquestion_Obj_Rel_Insert_Input>;
  branching_question_id?: InputMaybe<Scalars['Int']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_modified?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  previous?: InputMaybe<Polls_Branch_Obj_Rel_Insert_Input>;
  previous_id?: InputMaybe<Scalars['Int']>;
  tooltip?: InputMaybe<Scalars['String']>;
  tooltip_en?: InputMaybe<Scalars['String']>;
  tooltip_es?: InputMaybe<Scalars['String']>;
  tooltip_fr?: InputMaybe<Scalars['String']>;
  tooltip_ja?: InputMaybe<Scalars['String']>;
  tooltip_zh_hans?: InputMaybe<Scalars['String']>;
  tooltip_zh_hant?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Polls_Branch_Max_Fields = {
  __typename?: 'polls_branch_max_fields';
  branching_question_id?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['timestamptz']>;
  date_modified?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "polls_branch" */
export type Polls_Branch_Max_Order_By = {
  branching_question_id?: InputMaybe<Order_By>;
  date_created?: InputMaybe<Order_By>;
  date_modified?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  tooltip?: InputMaybe<Order_By>;
  tooltip_en?: InputMaybe<Order_By>;
  tooltip_es?: InputMaybe<Order_By>;
  tooltip_fr?: InputMaybe<Order_By>;
  tooltip_ja?: InputMaybe<Order_By>;
  tooltip_zh_hans?: InputMaybe<Order_By>;
  tooltip_zh_hant?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Polls_Branch_Min_Fields = {
  __typename?: 'polls_branch_min_fields';
  branching_question_id?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['timestamptz']>;
  date_modified?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "polls_branch" */
export type Polls_Branch_Min_Order_By = {
  branching_question_id?: InputMaybe<Order_By>;
  date_created?: InputMaybe<Order_By>;
  date_modified?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  tooltip?: InputMaybe<Order_By>;
  tooltip_en?: InputMaybe<Order_By>;
  tooltip_es?: InputMaybe<Order_By>;
  tooltip_fr?: InputMaybe<Order_By>;
  tooltip_ja?: InputMaybe<Order_By>;
  tooltip_zh_hans?: InputMaybe<Order_By>;
  tooltip_zh_hant?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "polls_branch" */
export type Polls_Branch_Mutation_Response = {
  __typename?: 'polls_branch_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Branch>;
};

/** input type for inserting object relation for remote table "polls_branch" */
export type Polls_Branch_Obj_Rel_Insert_Input = {
  data: Polls_Branch_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Branch_On_Conflict>;
};

/** on_conflict condition type for table "polls_branch" */
export type Polls_Branch_On_Conflict = {
  constraint: Polls_Branch_Constraint;
  update_columns?: Array<Polls_Branch_Update_Column>;
  where?: InputMaybe<Polls_Branch_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_branch". */
export type Polls_Branch_Order_By = {
  branching_question?: InputMaybe<Polls_Branchingquestion_Order_By>;
  branching_question_id?: InputMaybe<Order_By>;
  date_created?: InputMaybe<Order_By>;
  date_modified?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous?: InputMaybe<Polls_Branch_Order_By>;
  previous_id?: InputMaybe<Order_By>;
  tooltip?: InputMaybe<Order_By>;
  tooltip_en?: InputMaybe<Order_By>;
  tooltip_es?: InputMaybe<Order_By>;
  tooltip_fr?: InputMaybe<Order_By>;
  tooltip_ja?: InputMaybe<Order_By>;
  tooltip_zh_hans?: InputMaybe<Order_By>;
  tooltip_zh_hant?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_branch */
export type Polls_Branch_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_branch" */
export enum Polls_Branch_Select_Column {
  /** column name */
  BranchingQuestionId = 'branching_question_id',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateModified = 'date_modified',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant',
  /** column name */
  Order = 'order',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  Tooltip = 'tooltip',
  /** column name */
  TooltipEn = 'tooltip_en',
  /** column name */
  TooltipEs = 'tooltip_es',
  /** column name */
  TooltipFr = 'tooltip_fr',
  /** column name */
  TooltipJa = 'tooltip_ja',
  /** column name */
  TooltipZhHans = 'tooltip_zh_hans',
  /** column name */
  TooltipZhHant = 'tooltip_zh_hant'
}

/** input type for updating data in table "polls_branch" */
export type Polls_Branch_Set_Input = {
  branching_question_id?: InputMaybe<Scalars['Int']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_modified?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  previous_id?: InputMaybe<Scalars['Int']>;
  tooltip?: InputMaybe<Scalars['String']>;
  tooltip_en?: InputMaybe<Scalars['String']>;
  tooltip_es?: InputMaybe<Scalars['String']>;
  tooltip_fr?: InputMaybe<Scalars['String']>;
  tooltip_ja?: InputMaybe<Scalars['String']>;
  tooltip_zh_hans?: InputMaybe<Scalars['String']>;
  tooltip_zh_hant?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Polls_Branch_Stddev_Fields = {
  __typename?: 'polls_branch_stddev_fields';
  branching_question_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "polls_branch" */
export type Polls_Branch_Stddev_Order_By = {
  branching_question_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Polls_Branch_Stddev_Pop_Fields = {
  __typename?: 'polls_branch_stddev_pop_fields';
  branching_question_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "polls_branch" */
export type Polls_Branch_Stddev_Pop_Order_By = {
  branching_question_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Polls_Branch_Stddev_Samp_Fields = {
  __typename?: 'polls_branch_stddev_samp_fields';
  branching_question_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "polls_branch" */
export type Polls_Branch_Stddev_Samp_Order_By = {
  branching_question_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Polls_Branch_Sum_Fields = {
  __typename?: 'polls_branch_sum_fields';
  branching_question_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "polls_branch" */
export type Polls_Branch_Sum_Order_By = {
  branching_question_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** update columns of table "polls_branch" */
export enum Polls_Branch_Update_Column {
  /** column name */
  BranchingQuestionId = 'branching_question_id',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateModified = 'date_modified',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant',
  /** column name */
  Order = 'order',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  Tooltip = 'tooltip',
  /** column name */
  TooltipEn = 'tooltip_en',
  /** column name */
  TooltipEs = 'tooltip_es',
  /** column name */
  TooltipFr = 'tooltip_fr',
  /** column name */
  TooltipJa = 'tooltip_ja',
  /** column name */
  TooltipZhHans = 'tooltip_zh_hans',
  /** column name */
  TooltipZhHant = 'tooltip_zh_hant'
}

/** aggregate var_pop on columns */
export type Polls_Branch_Var_Pop_Fields = {
  __typename?: 'polls_branch_var_pop_fields';
  branching_question_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "polls_branch" */
export type Polls_Branch_Var_Pop_Order_By = {
  branching_question_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Polls_Branch_Var_Samp_Fields = {
  __typename?: 'polls_branch_var_samp_fields';
  branching_question_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "polls_branch" */
export type Polls_Branch_Var_Samp_Order_By = {
  branching_question_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Polls_Branch_Variance_Fields = {
  __typename?: 'polls_branch_variance_fields';
  branching_question_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "polls_branch" */
export type Polls_Branch_Variance_Order_By = {
  branching_question_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "polls_branchingquestion" */
export type Polls_Branchingquestion = {
  __typename?: 'polls_branchingquestion';
  /** An array relationship */
  branches: Array<Polls_Branch>;
  /** An aggregate relationship */
  branches_aggregate: Polls_Branch_Aggregate;
  id: Scalars['Int'];
  name: Scalars['String'];
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  poll_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  previous?: Maybe<Polls_Branchingquestion>;
  previous_id?: Maybe<Scalars['Int']>;
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
  translated_name?: Maybe<Scalars['String']>;
};


/** columns and relationships of "polls_branchingquestion" */
export type Polls_BranchingquestionBranchesArgs = {
  distinct_on?: InputMaybe<Array<Polls_Branch_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Branch_Order_By>>;
  where?: InputMaybe<Polls_Branch_Bool_Exp>;
};


/** columns and relationships of "polls_branchingquestion" */
export type Polls_BranchingquestionBranches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Branch_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Branch_Order_By>>;
  where?: InputMaybe<Polls_Branch_Bool_Exp>;
};


/** columns and relationships of "polls_branchingquestion" */
export type Polls_BranchingquestionTranslated_NameArgs = {
  args: Translated_Name_Polls_Branchingquestion_Args;
};

/** aggregated selection of "polls_branchingquestion" */
export type Polls_Branchingquestion_Aggregate = {
  __typename?: 'polls_branchingquestion_aggregate';
  aggregate?: Maybe<Polls_Branchingquestion_Aggregate_Fields>;
  nodes: Array<Polls_Branchingquestion>;
};

/** aggregate fields of "polls_branchingquestion" */
export type Polls_Branchingquestion_Aggregate_Fields = {
  __typename?: 'polls_branchingquestion_aggregate_fields';
  avg?: Maybe<Polls_Branchingquestion_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Branchingquestion_Max_Fields>;
  min?: Maybe<Polls_Branchingquestion_Min_Fields>;
  stddev?: Maybe<Polls_Branchingquestion_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Branchingquestion_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Branchingquestion_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Branchingquestion_Sum_Fields>;
  var_pop?: Maybe<Polls_Branchingquestion_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Branchingquestion_Var_Samp_Fields>;
  variance?: Maybe<Polls_Branchingquestion_Variance_Fields>;
};


/** aggregate fields of "polls_branchingquestion" */
export type Polls_Branchingquestion_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Branchingquestion_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "polls_branchingquestion" */
export type Polls_Branchingquestion_Aggregate_Order_By = {
  avg?: InputMaybe<Polls_Branchingquestion_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Polls_Branchingquestion_Max_Order_By>;
  min?: InputMaybe<Polls_Branchingquestion_Min_Order_By>;
  stddev?: InputMaybe<Polls_Branchingquestion_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Polls_Branchingquestion_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Polls_Branchingquestion_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Polls_Branchingquestion_Sum_Order_By>;
  var_pop?: InputMaybe<Polls_Branchingquestion_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Polls_Branchingquestion_Var_Samp_Order_By>;
  variance?: InputMaybe<Polls_Branchingquestion_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "polls_branchingquestion" */
export type Polls_Branchingquestion_Arr_Rel_Insert_Input = {
  data: Array<Polls_Branchingquestion_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Branchingquestion_On_Conflict>;
};

/** aggregate avg on columns */
export type Polls_Branchingquestion_Avg_Fields = {
  __typename?: 'polls_branchingquestion_avg_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "polls_branchingquestion" */
export type Polls_Branchingquestion_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "polls_branchingquestion". All fields are combined with a logical 'AND'. */
export type Polls_Branchingquestion_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Branchingquestion_Bool_Exp>>;
  _not?: InputMaybe<Polls_Branchingquestion_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Branchingquestion_Bool_Exp>>;
  branches?: InputMaybe<Polls_Branch_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  name_en?: InputMaybe<String_Comparison_Exp>;
  name_es?: InputMaybe<String_Comparison_Exp>;
  name_fr?: InputMaybe<String_Comparison_Exp>;
  name_ja?: InputMaybe<String_Comparison_Exp>;
  name_zh_hans?: InputMaybe<String_Comparison_Exp>;
  name_zh_hant?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  poll_id?: InputMaybe<Int_Comparison_Exp>;
  previous?: InputMaybe<Polls_Branchingquestion_Bool_Exp>;
  previous_id?: InputMaybe<Int_Comparison_Exp>;
  tooltip?: InputMaybe<String_Comparison_Exp>;
  tooltip_en?: InputMaybe<String_Comparison_Exp>;
  tooltip_es?: InputMaybe<String_Comparison_Exp>;
  tooltip_fr?: InputMaybe<String_Comparison_Exp>;
  tooltip_ja?: InputMaybe<String_Comparison_Exp>;
  tooltip_zh_hans?: InputMaybe<String_Comparison_Exp>;
  tooltip_zh_hant?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_branchingquestion" */
export enum Polls_Branchingquestion_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollsBranchingquestionPkey = 'polls_branchingquestion_pkey'
}

/** input type for incrementing numeric columns in table "polls_branchingquestion" */
export type Polls_Branchingquestion_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  poll_id?: InputMaybe<Scalars['Int']>;
  previous_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_branchingquestion" */
export type Polls_Branchingquestion_Insert_Input = {
  branches?: InputMaybe<Polls_Branch_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  poll_id?: InputMaybe<Scalars['Int']>;
  previous?: InputMaybe<Polls_Branchingquestion_Obj_Rel_Insert_Input>;
  previous_id?: InputMaybe<Scalars['Int']>;
  tooltip?: InputMaybe<Scalars['String']>;
  tooltip_en?: InputMaybe<Scalars['String']>;
  tooltip_es?: InputMaybe<Scalars['String']>;
  tooltip_fr?: InputMaybe<Scalars['String']>;
  tooltip_ja?: InputMaybe<Scalars['String']>;
  tooltip_zh_hans?: InputMaybe<Scalars['String']>;
  tooltip_zh_hant?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Polls_Branchingquestion_Max_Fields = {
  __typename?: 'polls_branchingquestion_max_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  poll_id?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "polls_branchingquestion" */
export type Polls_Branchingquestion_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  tooltip?: InputMaybe<Order_By>;
  tooltip_en?: InputMaybe<Order_By>;
  tooltip_es?: InputMaybe<Order_By>;
  tooltip_fr?: InputMaybe<Order_By>;
  tooltip_ja?: InputMaybe<Order_By>;
  tooltip_zh_hans?: InputMaybe<Order_By>;
  tooltip_zh_hant?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Polls_Branchingquestion_Min_Fields = {
  __typename?: 'polls_branchingquestion_min_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  poll_id?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "polls_branchingquestion" */
export type Polls_Branchingquestion_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  tooltip?: InputMaybe<Order_By>;
  tooltip_en?: InputMaybe<Order_By>;
  tooltip_es?: InputMaybe<Order_By>;
  tooltip_fr?: InputMaybe<Order_By>;
  tooltip_ja?: InputMaybe<Order_By>;
  tooltip_zh_hans?: InputMaybe<Order_By>;
  tooltip_zh_hant?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "polls_branchingquestion" */
export type Polls_Branchingquestion_Mutation_Response = {
  __typename?: 'polls_branchingquestion_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Branchingquestion>;
};

/** input type for inserting object relation for remote table "polls_branchingquestion" */
export type Polls_Branchingquestion_Obj_Rel_Insert_Input = {
  data: Polls_Branchingquestion_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Branchingquestion_On_Conflict>;
};

/** on_conflict condition type for table "polls_branchingquestion" */
export type Polls_Branchingquestion_On_Conflict = {
  constraint: Polls_Branchingquestion_Constraint;
  update_columns?: Array<Polls_Branchingquestion_Update_Column>;
  where?: InputMaybe<Polls_Branchingquestion_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_branchingquestion". */
export type Polls_Branchingquestion_Order_By = {
  branches_aggregate?: InputMaybe<Polls_Branch_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous?: InputMaybe<Polls_Branchingquestion_Order_By>;
  previous_id?: InputMaybe<Order_By>;
  tooltip?: InputMaybe<Order_By>;
  tooltip_en?: InputMaybe<Order_By>;
  tooltip_es?: InputMaybe<Order_By>;
  tooltip_fr?: InputMaybe<Order_By>;
  tooltip_ja?: InputMaybe<Order_By>;
  tooltip_zh_hans?: InputMaybe<Order_By>;
  tooltip_zh_hant?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_branchingquestion */
export type Polls_Branchingquestion_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_branchingquestion" */
export enum Polls_Branchingquestion_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant',
  /** column name */
  Order = 'order',
  /** column name */
  PollId = 'poll_id',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  Tooltip = 'tooltip',
  /** column name */
  TooltipEn = 'tooltip_en',
  /** column name */
  TooltipEs = 'tooltip_es',
  /** column name */
  TooltipFr = 'tooltip_fr',
  /** column name */
  TooltipJa = 'tooltip_ja',
  /** column name */
  TooltipZhHans = 'tooltip_zh_hans',
  /** column name */
  TooltipZhHant = 'tooltip_zh_hant'
}

/** input type for updating data in table "polls_branchingquestion" */
export type Polls_Branchingquestion_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  poll_id?: InputMaybe<Scalars['Int']>;
  previous_id?: InputMaybe<Scalars['Int']>;
  tooltip?: InputMaybe<Scalars['String']>;
  tooltip_en?: InputMaybe<Scalars['String']>;
  tooltip_es?: InputMaybe<Scalars['String']>;
  tooltip_fr?: InputMaybe<Scalars['String']>;
  tooltip_ja?: InputMaybe<Scalars['String']>;
  tooltip_zh_hans?: InputMaybe<Scalars['String']>;
  tooltip_zh_hant?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Polls_Branchingquestion_Stddev_Fields = {
  __typename?: 'polls_branchingquestion_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "polls_branchingquestion" */
export type Polls_Branchingquestion_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Polls_Branchingquestion_Stddev_Pop_Fields = {
  __typename?: 'polls_branchingquestion_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "polls_branchingquestion" */
export type Polls_Branchingquestion_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Polls_Branchingquestion_Stddev_Samp_Fields = {
  __typename?: 'polls_branchingquestion_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "polls_branchingquestion" */
export type Polls_Branchingquestion_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Polls_Branchingquestion_Sum_Fields = {
  __typename?: 'polls_branchingquestion_sum_fields';
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  poll_id?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "polls_branchingquestion" */
export type Polls_Branchingquestion_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** update columns of table "polls_branchingquestion" */
export enum Polls_Branchingquestion_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant',
  /** column name */
  Order = 'order',
  /** column name */
  PollId = 'poll_id',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  Tooltip = 'tooltip',
  /** column name */
  TooltipEn = 'tooltip_en',
  /** column name */
  TooltipEs = 'tooltip_es',
  /** column name */
  TooltipFr = 'tooltip_fr',
  /** column name */
  TooltipJa = 'tooltip_ja',
  /** column name */
  TooltipZhHans = 'tooltip_zh_hans',
  /** column name */
  TooltipZhHant = 'tooltip_zh_hant'
}

/** aggregate var_pop on columns */
export type Polls_Branchingquestion_Var_Pop_Fields = {
  __typename?: 'polls_branchingquestion_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "polls_branchingquestion" */
export type Polls_Branchingquestion_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Polls_Branchingquestion_Var_Samp_Fields = {
  __typename?: 'polls_branchingquestion_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "polls_branchingquestion" */
export type Polls_Branchingquestion_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Polls_Branchingquestion_Variance_Fields = {
  __typename?: 'polls_branchingquestion_variance_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "polls_branchingquestion" */
export type Polls_Branchingquestion_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "polls_category" */
export type Polls_Category = {
  __typename?: 'polls_category';
  /** An array relationship */
  groups: Array<Polls_Group>;
  /** An aggregate relationship */
  groups_aggregate: Polls_Group_Aggregate;
  id: Scalars['Int'];
  name: Scalars['String'];
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  poll_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  previous?: Maybe<Polls_Category>;
  previous_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  questions: Array<Polls_Question>;
  /** An aggregate relationship */
  questions_aggregate: Polls_Question_Aggregate;
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
  translated_name?: Maybe<Scalars['String']>;
  translation_progress?: Maybe<Scalars['json']>;
};


/** columns and relationships of "polls_category" */
export type Polls_CategoryGroupsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Group_Order_By>>;
  where?: InputMaybe<Polls_Group_Bool_Exp>;
};


/** columns and relationships of "polls_category" */
export type Polls_CategoryGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Group_Order_By>>;
  where?: InputMaybe<Polls_Group_Bool_Exp>;
};


/** columns and relationships of "polls_category" */
export type Polls_CategoryQuestionsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Question_Order_By>>;
  where?: InputMaybe<Polls_Question_Bool_Exp>;
};


/** columns and relationships of "polls_category" */
export type Polls_CategoryQuestions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Question_Order_By>>;
  where?: InputMaybe<Polls_Question_Bool_Exp>;
};


/** columns and relationships of "polls_category" */
export type Polls_CategoryTranslated_NameArgs = {
  args: Translated_Name_Polls_Category_Args;
};


/** columns and relationships of "polls_category" */
export type Polls_CategoryTranslation_ProgressArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "polls_category" */
export type Polls_Category_Aggregate = {
  __typename?: 'polls_category_aggregate';
  aggregate?: Maybe<Polls_Category_Aggregate_Fields>;
  nodes: Array<Polls_Category>;
};

/** aggregate fields of "polls_category" */
export type Polls_Category_Aggregate_Fields = {
  __typename?: 'polls_category_aggregate_fields';
  avg?: Maybe<Polls_Category_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Category_Max_Fields>;
  min?: Maybe<Polls_Category_Min_Fields>;
  stddev?: Maybe<Polls_Category_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Category_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Category_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Category_Sum_Fields>;
  var_pop?: Maybe<Polls_Category_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Category_Var_Samp_Fields>;
  variance?: Maybe<Polls_Category_Variance_Fields>;
};


/** aggregate fields of "polls_category" */
export type Polls_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "polls_category" */
export type Polls_Category_Aggregate_Order_By = {
  avg?: InputMaybe<Polls_Category_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Polls_Category_Max_Order_By>;
  min?: InputMaybe<Polls_Category_Min_Order_By>;
  stddev?: InputMaybe<Polls_Category_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Polls_Category_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Polls_Category_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Polls_Category_Sum_Order_By>;
  var_pop?: InputMaybe<Polls_Category_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Polls_Category_Var_Samp_Order_By>;
  variance?: InputMaybe<Polls_Category_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "polls_category" */
export type Polls_Category_Arr_Rel_Insert_Input = {
  data: Array<Polls_Category_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Category_On_Conflict>;
};

/** aggregate avg on columns */
export type Polls_Category_Avg_Fields = {
  __typename?: 'polls_category_avg_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "polls_category" */
export type Polls_Category_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "polls_category". All fields are combined with a logical 'AND'. */
export type Polls_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Category_Bool_Exp>>;
  _not?: InputMaybe<Polls_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Category_Bool_Exp>>;
  groups?: InputMaybe<Polls_Group_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  name_en?: InputMaybe<String_Comparison_Exp>;
  name_es?: InputMaybe<String_Comparison_Exp>;
  name_fr?: InputMaybe<String_Comparison_Exp>;
  name_ja?: InputMaybe<String_Comparison_Exp>;
  name_zh_hans?: InputMaybe<String_Comparison_Exp>;
  name_zh_hant?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  poll_id?: InputMaybe<Int_Comparison_Exp>;
  previous?: InputMaybe<Polls_Category_Bool_Exp>;
  previous_id?: InputMaybe<Int_Comparison_Exp>;
  questions?: InputMaybe<Polls_Question_Bool_Exp>;
  tooltip?: InputMaybe<String_Comparison_Exp>;
  tooltip_en?: InputMaybe<String_Comparison_Exp>;
  tooltip_es?: InputMaybe<String_Comparison_Exp>;
  tooltip_fr?: InputMaybe<String_Comparison_Exp>;
  tooltip_ja?: InputMaybe<String_Comparison_Exp>;
  tooltip_zh_hans?: InputMaybe<String_Comparison_Exp>;
  tooltip_zh_hant?: InputMaybe<String_Comparison_Exp>;
  translation_progress?: InputMaybe<Json_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_category" */
export enum Polls_Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollsCategoryPkey = 'polls_category_pkey'
}

/** input type for incrementing numeric columns in table "polls_category" */
export type Polls_Category_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  poll_id?: InputMaybe<Scalars['Int']>;
  previous_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_category" */
export type Polls_Category_Insert_Input = {
  groups?: InputMaybe<Polls_Group_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  poll_id?: InputMaybe<Scalars['Int']>;
  previous?: InputMaybe<Polls_Category_Obj_Rel_Insert_Input>;
  previous_id?: InputMaybe<Scalars['Int']>;
  questions?: InputMaybe<Polls_Question_Arr_Rel_Insert_Input>;
  tooltip?: InputMaybe<Scalars['String']>;
  tooltip_en?: InputMaybe<Scalars['String']>;
  tooltip_es?: InputMaybe<Scalars['String']>;
  tooltip_fr?: InputMaybe<Scalars['String']>;
  tooltip_ja?: InputMaybe<Scalars['String']>;
  tooltip_zh_hans?: InputMaybe<Scalars['String']>;
  tooltip_zh_hant?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Polls_Category_Max_Fields = {
  __typename?: 'polls_category_max_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  poll_id?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "polls_category" */
export type Polls_Category_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  tooltip?: InputMaybe<Order_By>;
  tooltip_en?: InputMaybe<Order_By>;
  tooltip_es?: InputMaybe<Order_By>;
  tooltip_fr?: InputMaybe<Order_By>;
  tooltip_ja?: InputMaybe<Order_By>;
  tooltip_zh_hans?: InputMaybe<Order_By>;
  tooltip_zh_hant?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Polls_Category_Min_Fields = {
  __typename?: 'polls_category_min_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  poll_id?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "polls_category" */
export type Polls_Category_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  tooltip?: InputMaybe<Order_By>;
  tooltip_en?: InputMaybe<Order_By>;
  tooltip_es?: InputMaybe<Order_By>;
  tooltip_fr?: InputMaybe<Order_By>;
  tooltip_ja?: InputMaybe<Order_By>;
  tooltip_zh_hans?: InputMaybe<Order_By>;
  tooltip_zh_hant?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "polls_category" */
export type Polls_Category_Mutation_Response = {
  __typename?: 'polls_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Category>;
};

/** input type for inserting object relation for remote table "polls_category" */
export type Polls_Category_Obj_Rel_Insert_Input = {
  data: Polls_Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Category_On_Conflict>;
};

/** on_conflict condition type for table "polls_category" */
export type Polls_Category_On_Conflict = {
  constraint: Polls_Category_Constraint;
  update_columns?: Array<Polls_Category_Update_Column>;
  where?: InputMaybe<Polls_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_category". */
export type Polls_Category_Order_By = {
  groups_aggregate?: InputMaybe<Polls_Group_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous?: InputMaybe<Polls_Category_Order_By>;
  previous_id?: InputMaybe<Order_By>;
  questions_aggregate?: InputMaybe<Polls_Question_Aggregate_Order_By>;
  tooltip?: InputMaybe<Order_By>;
  tooltip_en?: InputMaybe<Order_By>;
  tooltip_es?: InputMaybe<Order_By>;
  tooltip_fr?: InputMaybe<Order_By>;
  tooltip_ja?: InputMaybe<Order_By>;
  tooltip_zh_hans?: InputMaybe<Order_By>;
  tooltip_zh_hant?: InputMaybe<Order_By>;
  translation_progress?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_category */
export type Polls_Category_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_category" */
export enum Polls_Category_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant',
  /** column name */
  Order = 'order',
  /** column name */
  PollId = 'poll_id',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  Tooltip = 'tooltip',
  /** column name */
  TooltipEn = 'tooltip_en',
  /** column name */
  TooltipEs = 'tooltip_es',
  /** column name */
  TooltipFr = 'tooltip_fr',
  /** column name */
  TooltipJa = 'tooltip_ja',
  /** column name */
  TooltipZhHans = 'tooltip_zh_hans',
  /** column name */
  TooltipZhHant = 'tooltip_zh_hant'
}

/** input type for updating data in table "polls_category" */
export type Polls_Category_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  poll_id?: InputMaybe<Scalars['Int']>;
  previous_id?: InputMaybe<Scalars['Int']>;
  tooltip?: InputMaybe<Scalars['String']>;
  tooltip_en?: InputMaybe<Scalars['String']>;
  tooltip_es?: InputMaybe<Scalars['String']>;
  tooltip_fr?: InputMaybe<Scalars['String']>;
  tooltip_ja?: InputMaybe<Scalars['String']>;
  tooltip_zh_hans?: InputMaybe<Scalars['String']>;
  tooltip_zh_hant?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Polls_Category_Stddev_Fields = {
  __typename?: 'polls_category_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "polls_category" */
export type Polls_Category_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Polls_Category_Stddev_Pop_Fields = {
  __typename?: 'polls_category_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "polls_category" */
export type Polls_Category_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Polls_Category_Stddev_Samp_Fields = {
  __typename?: 'polls_category_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "polls_category" */
export type Polls_Category_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Polls_Category_Sum_Fields = {
  __typename?: 'polls_category_sum_fields';
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  poll_id?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "polls_category" */
export type Polls_Category_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** update columns of table "polls_category" */
export enum Polls_Category_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant',
  /** column name */
  Order = 'order',
  /** column name */
  PollId = 'poll_id',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  Tooltip = 'tooltip',
  /** column name */
  TooltipEn = 'tooltip_en',
  /** column name */
  TooltipEs = 'tooltip_es',
  /** column name */
  TooltipFr = 'tooltip_fr',
  /** column name */
  TooltipJa = 'tooltip_ja',
  /** column name */
  TooltipZhHans = 'tooltip_zh_hans',
  /** column name */
  TooltipZhHant = 'tooltip_zh_hant'
}

/** aggregate var_pop on columns */
export type Polls_Category_Var_Pop_Fields = {
  __typename?: 'polls_category_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "polls_category" */
export type Polls_Category_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Polls_Category_Var_Samp_Fields = {
  __typename?: 'polls_category_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "polls_category" */
export type Polls_Category_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Polls_Category_Variance_Fields = {
  __typename?: 'polls_category_variance_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "polls_category" */
export type Polls_Category_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "polls_categoryprogress" */
export type Polls_Categoryprogress = {
  __typename?: 'polls_categoryprogress';
  additional_answered: Scalars['Int'];
  additional_total: Scalars['Int'];
  answered: Scalars['Int'];
  /** An object relationship */
  category: Polls_Category;
  category_id: Scalars['Int'];
  draft: Scalars['Int'];
  id: Scalars['Int'];
  poll_progress_id: Scalars['Int'];
  published: Scalars['Int'];
  total: Scalars['Int'];
};

/** aggregated selection of "polls_categoryprogress" */
export type Polls_Categoryprogress_Aggregate = {
  __typename?: 'polls_categoryprogress_aggregate';
  aggregate?: Maybe<Polls_Categoryprogress_Aggregate_Fields>;
  nodes: Array<Polls_Categoryprogress>;
};

/** aggregate fields of "polls_categoryprogress" */
export type Polls_Categoryprogress_Aggregate_Fields = {
  __typename?: 'polls_categoryprogress_aggregate_fields';
  avg?: Maybe<Polls_Categoryprogress_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Categoryprogress_Max_Fields>;
  min?: Maybe<Polls_Categoryprogress_Min_Fields>;
  stddev?: Maybe<Polls_Categoryprogress_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Categoryprogress_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Categoryprogress_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Categoryprogress_Sum_Fields>;
  var_pop?: Maybe<Polls_Categoryprogress_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Categoryprogress_Var_Samp_Fields>;
  variance?: Maybe<Polls_Categoryprogress_Variance_Fields>;
};


/** aggregate fields of "polls_categoryprogress" */
export type Polls_Categoryprogress_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Categoryprogress_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "polls_categoryprogress" */
export type Polls_Categoryprogress_Aggregate_Order_By = {
  avg?: InputMaybe<Polls_Categoryprogress_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Polls_Categoryprogress_Max_Order_By>;
  min?: InputMaybe<Polls_Categoryprogress_Min_Order_By>;
  stddev?: InputMaybe<Polls_Categoryprogress_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Polls_Categoryprogress_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Polls_Categoryprogress_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Polls_Categoryprogress_Sum_Order_By>;
  var_pop?: InputMaybe<Polls_Categoryprogress_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Polls_Categoryprogress_Var_Samp_Order_By>;
  variance?: InputMaybe<Polls_Categoryprogress_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "polls_categoryprogress" */
export type Polls_Categoryprogress_Arr_Rel_Insert_Input = {
  data: Array<Polls_Categoryprogress_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Categoryprogress_On_Conflict>;
};

/** aggregate avg on columns */
export type Polls_Categoryprogress_Avg_Fields = {
  __typename?: 'polls_categoryprogress_avg_fields';
  additional_answered?: Maybe<Scalars['Float']>;
  additional_total?: Maybe<Scalars['Float']>;
  answered?: Maybe<Scalars['Float']>;
  category_id?: Maybe<Scalars['Float']>;
  draft?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_progress_id?: Maybe<Scalars['Float']>;
  published?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "polls_categoryprogress" */
export type Polls_Categoryprogress_Avg_Order_By = {
  additional_answered?: InputMaybe<Order_By>;
  additional_total?: InputMaybe<Order_By>;
  answered?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  draft?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_progress_id?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "polls_categoryprogress". All fields are combined with a logical 'AND'. */
export type Polls_Categoryprogress_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Categoryprogress_Bool_Exp>>;
  _not?: InputMaybe<Polls_Categoryprogress_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Categoryprogress_Bool_Exp>>;
  additional_answered?: InputMaybe<Int_Comparison_Exp>;
  additional_total?: InputMaybe<Int_Comparison_Exp>;
  answered?: InputMaybe<Int_Comparison_Exp>;
  category?: InputMaybe<Polls_Category_Bool_Exp>;
  category_id?: InputMaybe<Int_Comparison_Exp>;
  draft?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  poll_progress_id?: InputMaybe<Int_Comparison_Exp>;
  published?: InputMaybe<Int_Comparison_Exp>;
  total?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_categoryprogress" */
export enum Polls_Categoryprogress_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollsCategoryprogressPkey = 'polls_categoryprogress_pkey'
}

/** input type for incrementing numeric columns in table "polls_categoryprogress" */
export type Polls_Categoryprogress_Inc_Input = {
  additional_answered?: InputMaybe<Scalars['Int']>;
  additional_total?: InputMaybe<Scalars['Int']>;
  answered?: InputMaybe<Scalars['Int']>;
  category_id?: InputMaybe<Scalars['Int']>;
  draft?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  poll_progress_id?: InputMaybe<Scalars['Int']>;
  published?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_categoryprogress" */
export type Polls_Categoryprogress_Insert_Input = {
  additional_answered?: InputMaybe<Scalars['Int']>;
  additional_total?: InputMaybe<Scalars['Int']>;
  answered?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Polls_Category_Obj_Rel_Insert_Input>;
  category_id?: InputMaybe<Scalars['Int']>;
  draft?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  poll_progress_id?: InputMaybe<Scalars['Int']>;
  published?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Polls_Categoryprogress_Max_Fields = {
  __typename?: 'polls_categoryprogress_max_fields';
  additional_answered?: Maybe<Scalars['Int']>;
  additional_total?: Maybe<Scalars['Int']>;
  answered?: Maybe<Scalars['Int']>;
  category_id?: Maybe<Scalars['Int']>;
  draft?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  poll_progress_id?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "polls_categoryprogress" */
export type Polls_Categoryprogress_Max_Order_By = {
  additional_answered?: InputMaybe<Order_By>;
  additional_total?: InputMaybe<Order_By>;
  answered?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  draft?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_progress_id?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Polls_Categoryprogress_Min_Fields = {
  __typename?: 'polls_categoryprogress_min_fields';
  additional_answered?: Maybe<Scalars['Int']>;
  additional_total?: Maybe<Scalars['Int']>;
  answered?: Maybe<Scalars['Int']>;
  category_id?: Maybe<Scalars['Int']>;
  draft?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  poll_progress_id?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "polls_categoryprogress" */
export type Polls_Categoryprogress_Min_Order_By = {
  additional_answered?: InputMaybe<Order_By>;
  additional_total?: InputMaybe<Order_By>;
  answered?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  draft?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_progress_id?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "polls_categoryprogress" */
export type Polls_Categoryprogress_Mutation_Response = {
  __typename?: 'polls_categoryprogress_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Categoryprogress>;
};

/** on_conflict condition type for table "polls_categoryprogress" */
export type Polls_Categoryprogress_On_Conflict = {
  constraint: Polls_Categoryprogress_Constraint;
  update_columns?: Array<Polls_Categoryprogress_Update_Column>;
  where?: InputMaybe<Polls_Categoryprogress_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_categoryprogress". */
export type Polls_Categoryprogress_Order_By = {
  additional_answered?: InputMaybe<Order_By>;
  additional_total?: InputMaybe<Order_By>;
  answered?: InputMaybe<Order_By>;
  category?: InputMaybe<Polls_Category_Order_By>;
  category_id?: InputMaybe<Order_By>;
  draft?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_progress_id?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_categoryprogress */
export type Polls_Categoryprogress_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_categoryprogress" */
export enum Polls_Categoryprogress_Select_Column {
  /** column name */
  AdditionalAnswered = 'additional_answered',
  /** column name */
  AdditionalTotal = 'additional_total',
  /** column name */
  Answered = 'answered',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Draft = 'draft',
  /** column name */
  Id = 'id',
  /** column name */
  PollProgressId = 'poll_progress_id',
  /** column name */
  Published = 'published',
  /** column name */
  Total = 'total'
}

/** input type for updating data in table "polls_categoryprogress" */
export type Polls_Categoryprogress_Set_Input = {
  additional_answered?: InputMaybe<Scalars['Int']>;
  additional_total?: InputMaybe<Scalars['Int']>;
  answered?: InputMaybe<Scalars['Int']>;
  category_id?: InputMaybe<Scalars['Int']>;
  draft?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  poll_progress_id?: InputMaybe<Scalars['Int']>;
  published?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Polls_Categoryprogress_Stddev_Fields = {
  __typename?: 'polls_categoryprogress_stddev_fields';
  additional_answered?: Maybe<Scalars['Float']>;
  additional_total?: Maybe<Scalars['Float']>;
  answered?: Maybe<Scalars['Float']>;
  category_id?: Maybe<Scalars['Float']>;
  draft?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_progress_id?: Maybe<Scalars['Float']>;
  published?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "polls_categoryprogress" */
export type Polls_Categoryprogress_Stddev_Order_By = {
  additional_answered?: InputMaybe<Order_By>;
  additional_total?: InputMaybe<Order_By>;
  answered?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  draft?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_progress_id?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Polls_Categoryprogress_Stddev_Pop_Fields = {
  __typename?: 'polls_categoryprogress_stddev_pop_fields';
  additional_answered?: Maybe<Scalars['Float']>;
  additional_total?: Maybe<Scalars['Float']>;
  answered?: Maybe<Scalars['Float']>;
  category_id?: Maybe<Scalars['Float']>;
  draft?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_progress_id?: Maybe<Scalars['Float']>;
  published?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "polls_categoryprogress" */
export type Polls_Categoryprogress_Stddev_Pop_Order_By = {
  additional_answered?: InputMaybe<Order_By>;
  additional_total?: InputMaybe<Order_By>;
  answered?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  draft?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_progress_id?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Polls_Categoryprogress_Stddev_Samp_Fields = {
  __typename?: 'polls_categoryprogress_stddev_samp_fields';
  additional_answered?: Maybe<Scalars['Float']>;
  additional_total?: Maybe<Scalars['Float']>;
  answered?: Maybe<Scalars['Float']>;
  category_id?: Maybe<Scalars['Float']>;
  draft?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_progress_id?: Maybe<Scalars['Float']>;
  published?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "polls_categoryprogress" */
export type Polls_Categoryprogress_Stddev_Samp_Order_By = {
  additional_answered?: InputMaybe<Order_By>;
  additional_total?: InputMaybe<Order_By>;
  answered?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  draft?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_progress_id?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Polls_Categoryprogress_Sum_Fields = {
  __typename?: 'polls_categoryprogress_sum_fields';
  additional_answered?: Maybe<Scalars['Int']>;
  additional_total?: Maybe<Scalars['Int']>;
  answered?: Maybe<Scalars['Int']>;
  category_id?: Maybe<Scalars['Int']>;
  draft?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  poll_progress_id?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "polls_categoryprogress" */
export type Polls_Categoryprogress_Sum_Order_By = {
  additional_answered?: InputMaybe<Order_By>;
  additional_total?: InputMaybe<Order_By>;
  answered?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  draft?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_progress_id?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** update columns of table "polls_categoryprogress" */
export enum Polls_Categoryprogress_Update_Column {
  /** column name */
  AdditionalAnswered = 'additional_answered',
  /** column name */
  AdditionalTotal = 'additional_total',
  /** column name */
  Answered = 'answered',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Draft = 'draft',
  /** column name */
  Id = 'id',
  /** column name */
  PollProgressId = 'poll_progress_id',
  /** column name */
  Published = 'published',
  /** column name */
  Total = 'total'
}

/** aggregate var_pop on columns */
export type Polls_Categoryprogress_Var_Pop_Fields = {
  __typename?: 'polls_categoryprogress_var_pop_fields';
  additional_answered?: Maybe<Scalars['Float']>;
  additional_total?: Maybe<Scalars['Float']>;
  answered?: Maybe<Scalars['Float']>;
  category_id?: Maybe<Scalars['Float']>;
  draft?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_progress_id?: Maybe<Scalars['Float']>;
  published?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "polls_categoryprogress" */
export type Polls_Categoryprogress_Var_Pop_Order_By = {
  additional_answered?: InputMaybe<Order_By>;
  additional_total?: InputMaybe<Order_By>;
  answered?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  draft?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_progress_id?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Polls_Categoryprogress_Var_Samp_Fields = {
  __typename?: 'polls_categoryprogress_var_samp_fields';
  additional_answered?: Maybe<Scalars['Float']>;
  additional_total?: Maybe<Scalars['Float']>;
  answered?: Maybe<Scalars['Float']>;
  category_id?: Maybe<Scalars['Float']>;
  draft?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_progress_id?: Maybe<Scalars['Float']>;
  published?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "polls_categoryprogress" */
export type Polls_Categoryprogress_Var_Samp_Order_By = {
  additional_answered?: InputMaybe<Order_By>;
  additional_total?: InputMaybe<Order_By>;
  answered?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  draft?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_progress_id?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Polls_Categoryprogress_Variance_Fields = {
  __typename?: 'polls_categoryprogress_variance_fields';
  additional_answered?: Maybe<Scalars['Float']>;
  additional_total?: Maybe<Scalars['Float']>;
  answered?: Maybe<Scalars['Float']>;
  category_id?: Maybe<Scalars['Float']>;
  draft?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_progress_id?: Maybe<Scalars['Float']>;
  published?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "polls_categoryprogress" */
export type Polls_Categoryprogress_Variance_Order_By = {
  additional_answered?: InputMaybe<Order_By>;
  additional_total?: InputMaybe<Order_By>;
  answered?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  draft?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_progress_id?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** columns and relationships of "polls_comment" */
export type Polls_Comment = {
  __typename?: 'polls_comment';
  /** An object relationship */
  base_answer_set: Polls_Baseanswerset;
  baseanswerset_ptr_id: Scalars['Int'];
  comment_type: Scalars['smallint'];
  /** An object relationship */
  original_answer_set?: Maybe<Polls_Answerset>;
  original_answer_set_id: Scalars['Int'];
};

/** aggregated selection of "polls_comment" */
export type Polls_Comment_Aggregate = {
  __typename?: 'polls_comment_aggregate';
  aggregate?: Maybe<Polls_Comment_Aggregate_Fields>;
  nodes: Array<Polls_Comment>;
};

/** aggregate fields of "polls_comment" */
export type Polls_Comment_Aggregate_Fields = {
  __typename?: 'polls_comment_aggregate_fields';
  avg?: Maybe<Polls_Comment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Comment_Max_Fields>;
  min?: Maybe<Polls_Comment_Min_Fields>;
  stddev?: Maybe<Polls_Comment_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Comment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Comment_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Comment_Sum_Fields>;
  var_pop?: Maybe<Polls_Comment_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Comment_Var_Samp_Fields>;
  variance?: Maybe<Polls_Comment_Variance_Fields>;
};


/** aggregate fields of "polls_comment" */
export type Polls_Comment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Comment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Polls_Comment_Avg_Fields = {
  __typename?: 'polls_comment_avg_fields';
  baseanswerset_ptr_id?: Maybe<Scalars['Float']>;
  comment_type?: Maybe<Scalars['Float']>;
  original_answer_set_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "polls_comment". All fields are combined with a logical 'AND'. */
export type Polls_Comment_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Comment_Bool_Exp>>;
  _not?: InputMaybe<Polls_Comment_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Comment_Bool_Exp>>;
  base_answer_set?: InputMaybe<Polls_Baseanswerset_Bool_Exp>;
  baseanswerset_ptr_id?: InputMaybe<Int_Comparison_Exp>;
  comment_type?: InputMaybe<Smallint_Comparison_Exp>;
  original_answer_set?: InputMaybe<Polls_Answerset_Bool_Exp>;
  original_answer_set_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_comment" */
export enum Polls_Comment_Constraint {
  /** unique or primary key constraint on columns "baseanswerset_ptr_id" */
  PollsCommentBaseanswersetPtrId_38964409Pk = 'polls_comment_baseanswerset_ptr_id_38964409_pk'
}

/** input type for incrementing numeric columns in table "polls_comment" */
export type Polls_Comment_Inc_Input = {
  baseanswerset_ptr_id?: InputMaybe<Scalars['Int']>;
  comment_type?: InputMaybe<Scalars['smallint']>;
  original_answer_set_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_comment" */
export type Polls_Comment_Insert_Input = {
  base_answer_set?: InputMaybe<Polls_Baseanswerset_Obj_Rel_Insert_Input>;
  baseanswerset_ptr_id?: InputMaybe<Scalars['Int']>;
  comment_type?: InputMaybe<Scalars['smallint']>;
  original_answer_set?: InputMaybe<Polls_Answerset_Obj_Rel_Insert_Input>;
  original_answer_set_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Polls_Comment_Max_Fields = {
  __typename?: 'polls_comment_max_fields';
  baseanswerset_ptr_id?: Maybe<Scalars['Int']>;
  comment_type?: Maybe<Scalars['smallint']>;
  original_answer_set_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Polls_Comment_Min_Fields = {
  __typename?: 'polls_comment_min_fields';
  baseanswerset_ptr_id?: Maybe<Scalars['Int']>;
  comment_type?: Maybe<Scalars['smallint']>;
  original_answer_set_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "polls_comment" */
export type Polls_Comment_Mutation_Response = {
  __typename?: 'polls_comment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Comment>;
};

/** input type for inserting object relation for remote table "polls_comment" */
export type Polls_Comment_Obj_Rel_Insert_Input = {
  data: Polls_Comment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Comment_On_Conflict>;
};

/** on_conflict condition type for table "polls_comment" */
export type Polls_Comment_On_Conflict = {
  constraint: Polls_Comment_Constraint;
  update_columns?: Array<Polls_Comment_Update_Column>;
  where?: InputMaybe<Polls_Comment_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_comment". */
export type Polls_Comment_Order_By = {
  base_answer_set?: InputMaybe<Polls_Baseanswerset_Order_By>;
  baseanswerset_ptr_id?: InputMaybe<Order_By>;
  comment_type?: InputMaybe<Order_By>;
  original_answer_set?: InputMaybe<Polls_Answerset_Order_By>;
  original_answer_set_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_comment */
export type Polls_Comment_Pk_Columns_Input = {
  baseanswerset_ptr_id: Scalars['Int'];
};

/** select columns of table "polls_comment" */
export enum Polls_Comment_Select_Column {
  /** column name */
  BaseanswersetPtrId = 'baseanswerset_ptr_id',
  /** column name */
  CommentType = 'comment_type',
  /** column name */
  OriginalAnswerSetId = 'original_answer_set_id'
}

/** input type for updating data in table "polls_comment" */
export type Polls_Comment_Set_Input = {
  baseanswerset_ptr_id?: InputMaybe<Scalars['Int']>;
  comment_type?: InputMaybe<Scalars['smallint']>;
  original_answer_set_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Polls_Comment_Stddev_Fields = {
  __typename?: 'polls_comment_stddev_fields';
  baseanswerset_ptr_id?: Maybe<Scalars['Float']>;
  comment_type?: Maybe<Scalars['Float']>;
  original_answer_set_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Polls_Comment_Stddev_Pop_Fields = {
  __typename?: 'polls_comment_stddev_pop_fields';
  baseanswerset_ptr_id?: Maybe<Scalars['Float']>;
  comment_type?: Maybe<Scalars['Float']>;
  original_answer_set_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Polls_Comment_Stddev_Samp_Fields = {
  __typename?: 'polls_comment_stddev_samp_fields';
  baseanswerset_ptr_id?: Maybe<Scalars['Float']>;
  comment_type?: Maybe<Scalars['Float']>;
  original_answer_set_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Polls_Comment_Sum_Fields = {
  __typename?: 'polls_comment_sum_fields';
  baseanswerset_ptr_id?: Maybe<Scalars['Int']>;
  comment_type?: Maybe<Scalars['smallint']>;
  original_answer_set_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "polls_comment" */
export enum Polls_Comment_Update_Column {
  /** column name */
  BaseanswersetPtrId = 'baseanswerset_ptr_id',
  /** column name */
  CommentType = 'comment_type',
  /** column name */
  OriginalAnswerSetId = 'original_answer_set_id'
}

/** aggregate var_pop on columns */
export type Polls_Comment_Var_Pop_Fields = {
  __typename?: 'polls_comment_var_pop_fields';
  baseanswerset_ptr_id?: Maybe<Scalars['Float']>;
  comment_type?: Maybe<Scalars['Float']>;
  original_answer_set_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Polls_Comment_Var_Samp_Fields = {
  __typename?: 'polls_comment_var_samp_fields';
  baseanswerset_ptr_id?: Maybe<Scalars['Float']>;
  comment_type?: Maybe<Scalars['Float']>;
  original_answer_set_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Polls_Comment_Variance_Fields = {
  __typename?: 'polls_comment_variance_fields';
  baseanswerset_ptr_id?: Maybe<Scalars['Float']>;
  comment_type?: Maybe<Scalars['Float']>;
  original_answer_set_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "polls_datasource" */
export type Polls_Datasource = {
  __typename?: 'polls_datasource';
  color?: Maybe<Scalars['String']>;
  /** An array relationship */
  entities: Array<Polls_Entity>;
  /** An aggregate relationship */
  entities_aggregate: Polls_Entity_Aggregate;
  external_url_title?: Maybe<Scalars['String']>;
  external_url_title_en?: Maybe<Scalars['String']>;
  external_url_title_es?: Maybe<Scalars['String']>;
  external_url_title_fr?: Maybe<Scalars['String']>;
  external_url_title_ja?: Maybe<Scalars['String']>;
  external_url_title_zh_hans?: Maybe<Scalars['String']>;
  external_url_title_zh_hant?: Maybe<Scalars['String']>;
  icon_big?: Maybe<Scalars['String']>;
  icon_big_dark?: Maybe<Scalars['String']>;
  icon_small?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_external: Scalars['Boolean'];
  name: Scalars['String'];
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
};


/** columns and relationships of "polls_datasource" */
export type Polls_DatasourceEntitiesArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Order_By>>;
  where?: InputMaybe<Polls_Entity_Bool_Exp>;
};


/** columns and relationships of "polls_datasource" */
export type Polls_DatasourceEntities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Order_By>>;
  where?: InputMaybe<Polls_Entity_Bool_Exp>;
};

/** aggregated selection of "polls_datasource" */
export type Polls_Datasource_Aggregate = {
  __typename?: 'polls_datasource_aggregate';
  aggregate?: Maybe<Polls_Datasource_Aggregate_Fields>;
  nodes: Array<Polls_Datasource>;
};

/** aggregate fields of "polls_datasource" */
export type Polls_Datasource_Aggregate_Fields = {
  __typename?: 'polls_datasource_aggregate_fields';
  avg?: Maybe<Polls_Datasource_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Datasource_Max_Fields>;
  min?: Maybe<Polls_Datasource_Min_Fields>;
  stddev?: Maybe<Polls_Datasource_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Datasource_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Datasource_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Datasource_Sum_Fields>;
  var_pop?: Maybe<Polls_Datasource_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Datasource_Var_Samp_Fields>;
  variance?: Maybe<Polls_Datasource_Variance_Fields>;
};


/** aggregate fields of "polls_datasource" */
export type Polls_Datasource_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Datasource_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Polls_Datasource_Avg_Fields = {
  __typename?: 'polls_datasource_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "polls_datasource". All fields are combined with a logical 'AND'. */
export type Polls_Datasource_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Datasource_Bool_Exp>>;
  _not?: InputMaybe<Polls_Datasource_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Datasource_Bool_Exp>>;
  color?: InputMaybe<String_Comparison_Exp>;
  entities?: InputMaybe<Polls_Entity_Bool_Exp>;
  external_url_title?: InputMaybe<String_Comparison_Exp>;
  external_url_title_en?: InputMaybe<String_Comparison_Exp>;
  external_url_title_es?: InputMaybe<String_Comparison_Exp>;
  external_url_title_fr?: InputMaybe<String_Comparison_Exp>;
  external_url_title_ja?: InputMaybe<String_Comparison_Exp>;
  external_url_title_zh_hans?: InputMaybe<String_Comparison_Exp>;
  external_url_title_zh_hant?: InputMaybe<String_Comparison_Exp>;
  icon_big?: InputMaybe<String_Comparison_Exp>;
  icon_big_dark?: InputMaybe<String_Comparison_Exp>;
  icon_small?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_external?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  name_en?: InputMaybe<String_Comparison_Exp>;
  name_es?: InputMaybe<String_Comparison_Exp>;
  name_fr?: InputMaybe<String_Comparison_Exp>;
  name_ja?: InputMaybe<String_Comparison_Exp>;
  name_zh_hans?: InputMaybe<String_Comparison_Exp>;
  name_zh_hant?: InputMaybe<String_Comparison_Exp>;
  tooltip?: InputMaybe<String_Comparison_Exp>;
  tooltip_en?: InputMaybe<String_Comparison_Exp>;
  tooltip_es?: InputMaybe<String_Comparison_Exp>;
  tooltip_fr?: InputMaybe<String_Comparison_Exp>;
  tooltip_ja?: InputMaybe<String_Comparison_Exp>;
  tooltip_zh_hans?: InputMaybe<String_Comparison_Exp>;
  tooltip_zh_hant?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_datasource" */
export enum Polls_Datasource_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollsDatasourcePkey = 'polls_datasource_pkey'
}

/** input type for incrementing numeric columns in table "polls_datasource" */
export type Polls_Datasource_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_datasource" */
export type Polls_Datasource_Insert_Input = {
  color?: InputMaybe<Scalars['String']>;
  entities?: InputMaybe<Polls_Entity_Arr_Rel_Insert_Input>;
  external_url_title?: InputMaybe<Scalars['String']>;
  external_url_title_en?: InputMaybe<Scalars['String']>;
  external_url_title_es?: InputMaybe<Scalars['String']>;
  external_url_title_fr?: InputMaybe<Scalars['String']>;
  external_url_title_ja?: InputMaybe<Scalars['String']>;
  external_url_title_zh_hans?: InputMaybe<Scalars['String']>;
  external_url_title_zh_hant?: InputMaybe<Scalars['String']>;
  icon_big?: InputMaybe<Scalars['String']>;
  icon_big_dark?: InputMaybe<Scalars['String']>;
  icon_small?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_external?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
  tooltip?: InputMaybe<Scalars['String']>;
  tooltip_en?: InputMaybe<Scalars['String']>;
  tooltip_es?: InputMaybe<Scalars['String']>;
  tooltip_fr?: InputMaybe<Scalars['String']>;
  tooltip_ja?: InputMaybe<Scalars['String']>;
  tooltip_zh_hans?: InputMaybe<Scalars['String']>;
  tooltip_zh_hant?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Polls_Datasource_Max_Fields = {
  __typename?: 'polls_datasource_max_fields';
  color?: Maybe<Scalars['String']>;
  external_url_title?: Maybe<Scalars['String']>;
  external_url_title_en?: Maybe<Scalars['String']>;
  external_url_title_es?: Maybe<Scalars['String']>;
  external_url_title_fr?: Maybe<Scalars['String']>;
  external_url_title_ja?: Maybe<Scalars['String']>;
  external_url_title_zh_hans?: Maybe<Scalars['String']>;
  external_url_title_zh_hant?: Maybe<Scalars['String']>;
  icon_big?: Maybe<Scalars['String']>;
  icon_big_dark?: Maybe<Scalars['String']>;
  icon_small?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Polls_Datasource_Min_Fields = {
  __typename?: 'polls_datasource_min_fields';
  color?: Maybe<Scalars['String']>;
  external_url_title?: Maybe<Scalars['String']>;
  external_url_title_en?: Maybe<Scalars['String']>;
  external_url_title_es?: Maybe<Scalars['String']>;
  external_url_title_fr?: Maybe<Scalars['String']>;
  external_url_title_ja?: Maybe<Scalars['String']>;
  external_url_title_zh_hans?: Maybe<Scalars['String']>;
  external_url_title_zh_hant?: Maybe<Scalars['String']>;
  icon_big?: Maybe<Scalars['String']>;
  icon_big_dark?: Maybe<Scalars['String']>;
  icon_small?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "polls_datasource" */
export type Polls_Datasource_Mutation_Response = {
  __typename?: 'polls_datasource_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Datasource>;
};

/** input type for inserting object relation for remote table "polls_datasource" */
export type Polls_Datasource_Obj_Rel_Insert_Input = {
  data: Polls_Datasource_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Datasource_On_Conflict>;
};

/** on_conflict condition type for table "polls_datasource" */
export type Polls_Datasource_On_Conflict = {
  constraint: Polls_Datasource_Constraint;
  update_columns?: Array<Polls_Datasource_Update_Column>;
  where?: InputMaybe<Polls_Datasource_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_datasource". */
export type Polls_Datasource_Order_By = {
  color?: InputMaybe<Order_By>;
  entities_aggregate?: InputMaybe<Polls_Entity_Aggregate_Order_By>;
  external_url_title?: InputMaybe<Order_By>;
  external_url_title_en?: InputMaybe<Order_By>;
  external_url_title_es?: InputMaybe<Order_By>;
  external_url_title_fr?: InputMaybe<Order_By>;
  external_url_title_ja?: InputMaybe<Order_By>;
  external_url_title_zh_hans?: InputMaybe<Order_By>;
  external_url_title_zh_hant?: InputMaybe<Order_By>;
  icon_big?: InputMaybe<Order_By>;
  icon_big_dark?: InputMaybe<Order_By>;
  icon_small?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_external?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  tooltip?: InputMaybe<Order_By>;
  tooltip_en?: InputMaybe<Order_By>;
  tooltip_es?: InputMaybe<Order_By>;
  tooltip_fr?: InputMaybe<Order_By>;
  tooltip_ja?: InputMaybe<Order_By>;
  tooltip_zh_hans?: InputMaybe<Order_By>;
  tooltip_zh_hant?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_datasource */
export type Polls_Datasource_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_datasource" */
export enum Polls_Datasource_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  ExternalUrlTitle = 'external_url_title',
  /** column name */
  ExternalUrlTitleEn = 'external_url_title_en',
  /** column name */
  ExternalUrlTitleEs = 'external_url_title_es',
  /** column name */
  ExternalUrlTitleFr = 'external_url_title_fr',
  /** column name */
  ExternalUrlTitleJa = 'external_url_title_ja',
  /** column name */
  ExternalUrlTitleZhHans = 'external_url_title_zh_hans',
  /** column name */
  ExternalUrlTitleZhHant = 'external_url_title_zh_hant',
  /** column name */
  IconBig = 'icon_big',
  /** column name */
  IconBigDark = 'icon_big_dark',
  /** column name */
  IconSmall = 'icon_small',
  /** column name */
  Id = 'id',
  /** column name */
  IsExternal = 'is_external',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant',
  /** column name */
  Tooltip = 'tooltip',
  /** column name */
  TooltipEn = 'tooltip_en',
  /** column name */
  TooltipEs = 'tooltip_es',
  /** column name */
  TooltipFr = 'tooltip_fr',
  /** column name */
  TooltipJa = 'tooltip_ja',
  /** column name */
  TooltipZhHans = 'tooltip_zh_hans',
  /** column name */
  TooltipZhHant = 'tooltip_zh_hant'
}

/** input type for updating data in table "polls_datasource" */
export type Polls_Datasource_Set_Input = {
  color?: InputMaybe<Scalars['String']>;
  external_url_title?: InputMaybe<Scalars['String']>;
  external_url_title_en?: InputMaybe<Scalars['String']>;
  external_url_title_es?: InputMaybe<Scalars['String']>;
  external_url_title_fr?: InputMaybe<Scalars['String']>;
  external_url_title_ja?: InputMaybe<Scalars['String']>;
  external_url_title_zh_hans?: InputMaybe<Scalars['String']>;
  external_url_title_zh_hant?: InputMaybe<Scalars['String']>;
  icon_big?: InputMaybe<Scalars['String']>;
  icon_big_dark?: InputMaybe<Scalars['String']>;
  icon_small?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_external?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
  tooltip?: InputMaybe<Scalars['String']>;
  tooltip_en?: InputMaybe<Scalars['String']>;
  tooltip_es?: InputMaybe<Scalars['String']>;
  tooltip_fr?: InputMaybe<Scalars['String']>;
  tooltip_ja?: InputMaybe<Scalars['String']>;
  tooltip_zh_hans?: InputMaybe<Scalars['String']>;
  tooltip_zh_hant?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Polls_Datasource_Stddev_Fields = {
  __typename?: 'polls_datasource_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Polls_Datasource_Stddev_Pop_Fields = {
  __typename?: 'polls_datasource_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Polls_Datasource_Stddev_Samp_Fields = {
  __typename?: 'polls_datasource_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Polls_Datasource_Sum_Fields = {
  __typename?: 'polls_datasource_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "polls_datasource" */
export enum Polls_Datasource_Update_Column {
  /** column name */
  Color = 'color',
  /** column name */
  ExternalUrlTitle = 'external_url_title',
  /** column name */
  ExternalUrlTitleEn = 'external_url_title_en',
  /** column name */
  ExternalUrlTitleEs = 'external_url_title_es',
  /** column name */
  ExternalUrlTitleFr = 'external_url_title_fr',
  /** column name */
  ExternalUrlTitleJa = 'external_url_title_ja',
  /** column name */
  ExternalUrlTitleZhHans = 'external_url_title_zh_hans',
  /** column name */
  ExternalUrlTitleZhHant = 'external_url_title_zh_hant',
  /** column name */
  IconBig = 'icon_big',
  /** column name */
  IconBigDark = 'icon_big_dark',
  /** column name */
  IconSmall = 'icon_small',
  /** column name */
  Id = 'id',
  /** column name */
  IsExternal = 'is_external',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant',
  /** column name */
  Tooltip = 'tooltip',
  /** column name */
  TooltipEn = 'tooltip_en',
  /** column name */
  TooltipEs = 'tooltip_es',
  /** column name */
  TooltipFr = 'tooltip_fr',
  /** column name */
  TooltipJa = 'tooltip_ja',
  /** column name */
  TooltipZhHans = 'tooltip_zh_hans',
  /** column name */
  TooltipZhHant = 'tooltip_zh_hant'
}

/** aggregate var_pop on columns */
export type Polls_Datasource_Var_Pop_Fields = {
  __typename?: 'polls_datasource_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Polls_Datasource_Var_Samp_Fields = {
  __typename?: 'polls_datasource_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Polls_Datasource_Variance_Fields = {
  __typename?: 'polls_datasource_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "polls_entity" */
export type Polls_Entity = {
  __typename?: 'polls_entity';
  /** An array relationship */
  alt_names: Array<Polls_Entity_Alt_Names>;
  /** An aggregate relationship */
  alt_names_aggregate: Polls_Entity_Alt_Names_Aggregate;
  archived?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  base_answer_sets: Array<Polls_Baseanswerset>;
  /** An aggregate relationship */
  base_answer_sets_aggregate: Polls_Baseanswerset_Aggregate;
  created_by_id: Scalars['Int'];
  /** An object relationship */
  data_source: Polls_Datasource;
  data_source_id: Scalars['Int'];
  date_created: Scalars['timestamptz'];
  date_modified: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  description_en?: Maybe<Scalars['String']>;
  description_es?: Maybe<Scalars['String']>;
  description_fr?: Maybe<Scalars['String']>;
  description_ja?: Maybe<Scalars['String']>;
  description_zh_hans?: Maybe<Scalars['String']>;
  description_zh_hant?: Maybe<Scalars['String']>;
  entry_draft_hash?: Maybe<Scalars['String']>;
  entry_hash?: Maybe<Scalars['String']>;
  entry_source: Scalars['Int'];
  /** An object relationship */
  expert_source?: Maybe<Accounts_Expert>;
  expert_source_id?: Maybe<Scalars['Int']>;
  external_url?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object relationship */
  name: Polls_Entityname;
  name_id: Scalars['Int'];
  /** An object relationship */
  next?: Maybe<Polls_Entity>;
  /** An object relationship */
  poll: Polls_Poll;
  poll_id: Scalars['Int'];
  /** An object relationship */
  previous?: Maybe<Polls_Entity>;
  previous_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  progress: Array<Polls_Pollprogress>;
  /** An aggregate relationship */
  progress_aggregate: Polls_Pollprogress_Aggregate;
  /** An object relationship */
  region: Gis_Regions_Gis_Region;
  region_id: Scalars['Int'];
  /** An object relationship */
  secondary_source?: Maybe<Polls_Secondarysource>;
  secondary_source_id?: Maybe<Scalars['Int']>;
  supervised_by_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  supervisor?: Maybe<Accounts_Expert>;
  /** An array relationship */
  tags: Array<Polls_Entity_Tags>;
  /** An aggregate relationship */
  tags_aggregate: Polls_Entity_Tags_Aggregate;
  /** An object relationship */
  user: Auth_User;
  year_from: Scalars['Int'];
  year_to: Scalars['Int'];
};


/** columns and relationships of "polls_entity" */
export type Polls_EntityAlt_NamesArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Alt_Names_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Alt_Names_Order_By>>;
  where?: InputMaybe<Polls_Entity_Alt_Names_Bool_Exp>;
};


/** columns and relationships of "polls_entity" */
export type Polls_EntityAlt_Names_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Alt_Names_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Alt_Names_Order_By>>;
  where?: InputMaybe<Polls_Entity_Alt_Names_Bool_Exp>;
};


/** columns and relationships of "polls_entity" */
export type Polls_EntityBase_Answer_SetsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Baseanswerset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Baseanswerset_Order_By>>;
  where?: InputMaybe<Polls_Baseanswerset_Bool_Exp>;
};


/** columns and relationships of "polls_entity" */
export type Polls_EntityBase_Answer_Sets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Baseanswerset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Baseanswerset_Order_By>>;
  where?: InputMaybe<Polls_Baseanswerset_Bool_Exp>;
};


/** columns and relationships of "polls_entity" */
export type Polls_EntityProgressArgs = {
  distinct_on?: InputMaybe<Array<Polls_Pollprogress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Pollprogress_Order_By>>;
  where?: InputMaybe<Polls_Pollprogress_Bool_Exp>;
};


/** columns and relationships of "polls_entity" */
export type Polls_EntityProgress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Pollprogress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Pollprogress_Order_By>>;
  where?: InputMaybe<Polls_Pollprogress_Bool_Exp>;
};


/** columns and relationships of "polls_entity" */
export type Polls_EntityTagsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Tags_Order_By>>;
  where?: InputMaybe<Polls_Entity_Tags_Bool_Exp>;
};


/** columns and relationships of "polls_entity" */
export type Polls_EntityTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Tags_Order_By>>;
  where?: InputMaybe<Polls_Entity_Tags_Bool_Exp>;
};

/** aggregated selection of "polls_entity" */
export type Polls_Entity_Aggregate = {
  __typename?: 'polls_entity_aggregate';
  aggregate?: Maybe<Polls_Entity_Aggregate_Fields>;
  nodes: Array<Polls_Entity>;
};

/** aggregate fields of "polls_entity" */
export type Polls_Entity_Aggregate_Fields = {
  __typename?: 'polls_entity_aggregate_fields';
  avg?: Maybe<Polls_Entity_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Entity_Max_Fields>;
  min?: Maybe<Polls_Entity_Min_Fields>;
  stddev?: Maybe<Polls_Entity_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Entity_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Entity_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Entity_Sum_Fields>;
  var_pop?: Maybe<Polls_Entity_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Entity_Var_Samp_Fields>;
  variance?: Maybe<Polls_Entity_Variance_Fields>;
};


/** aggregate fields of "polls_entity" */
export type Polls_Entity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Entity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "polls_entity" */
export type Polls_Entity_Aggregate_Order_By = {
  avg?: InputMaybe<Polls_Entity_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Polls_Entity_Max_Order_By>;
  min?: InputMaybe<Polls_Entity_Min_Order_By>;
  stddev?: InputMaybe<Polls_Entity_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Polls_Entity_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Polls_Entity_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Polls_Entity_Sum_Order_By>;
  var_pop?: InputMaybe<Polls_Entity_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Polls_Entity_Var_Samp_Order_By>;
  variance?: InputMaybe<Polls_Entity_Variance_Order_By>;
};

/** columns and relationships of "polls_entity_alt_names" */
export type Polls_Entity_Alt_Names = {
  __typename?: 'polls_entity_alt_names';
  /** An object relationship */
  entry: Polls_Entity;
  entry_id: Scalars['Int'];
  entryname_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  name: Polls_Entityname;
};

/** aggregated selection of "polls_entity_alt_names" */
export type Polls_Entity_Alt_Names_Aggregate = {
  __typename?: 'polls_entity_alt_names_aggregate';
  aggregate?: Maybe<Polls_Entity_Alt_Names_Aggregate_Fields>;
  nodes: Array<Polls_Entity_Alt_Names>;
};

/** aggregate fields of "polls_entity_alt_names" */
export type Polls_Entity_Alt_Names_Aggregate_Fields = {
  __typename?: 'polls_entity_alt_names_aggregate_fields';
  avg?: Maybe<Polls_Entity_Alt_Names_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Entity_Alt_Names_Max_Fields>;
  min?: Maybe<Polls_Entity_Alt_Names_Min_Fields>;
  stddev?: Maybe<Polls_Entity_Alt_Names_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Entity_Alt_Names_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Entity_Alt_Names_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Entity_Alt_Names_Sum_Fields>;
  var_pop?: Maybe<Polls_Entity_Alt_Names_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Entity_Alt_Names_Var_Samp_Fields>;
  variance?: Maybe<Polls_Entity_Alt_Names_Variance_Fields>;
};


/** aggregate fields of "polls_entity_alt_names" */
export type Polls_Entity_Alt_Names_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Entity_Alt_Names_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "polls_entity_alt_names" */
export type Polls_Entity_Alt_Names_Aggregate_Order_By = {
  avg?: InputMaybe<Polls_Entity_Alt_Names_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Polls_Entity_Alt_Names_Max_Order_By>;
  min?: InputMaybe<Polls_Entity_Alt_Names_Min_Order_By>;
  stddev?: InputMaybe<Polls_Entity_Alt_Names_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Polls_Entity_Alt_Names_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Polls_Entity_Alt_Names_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Polls_Entity_Alt_Names_Sum_Order_By>;
  var_pop?: InputMaybe<Polls_Entity_Alt_Names_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Polls_Entity_Alt_Names_Var_Samp_Order_By>;
  variance?: InputMaybe<Polls_Entity_Alt_Names_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "polls_entity_alt_names" */
export type Polls_Entity_Alt_Names_Arr_Rel_Insert_Input = {
  data: Array<Polls_Entity_Alt_Names_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Entity_Alt_Names_On_Conflict>;
};

/** aggregate avg on columns */
export type Polls_Entity_Alt_Names_Avg_Fields = {
  __typename?: 'polls_entity_alt_names_avg_fields';
  entry_id?: Maybe<Scalars['Float']>;
  entryname_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "polls_entity_alt_names" */
export type Polls_Entity_Alt_Names_Avg_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  entryname_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "polls_entity_alt_names". All fields are combined with a logical 'AND'. */
export type Polls_Entity_Alt_Names_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Entity_Alt_Names_Bool_Exp>>;
  _not?: InputMaybe<Polls_Entity_Alt_Names_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Entity_Alt_Names_Bool_Exp>>;
  entry?: InputMaybe<Polls_Entity_Bool_Exp>;
  entry_id?: InputMaybe<Int_Comparison_Exp>;
  entryname_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<Polls_Entityname_Bool_Exp>;
};

/** unique or primary key constraints on table "polls_entity_alt_names" */
export enum Polls_Entity_Alt_Names_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollsEntityAltNamesPkey = 'polls_entity_alt_names_pkey',
  /** unique or primary key constraint on columns "entry_id", "entryname_id" */
  PollsReligionAltNamesReligionIdReligionnameIdKey = 'polls_religion_alt_names_religion_id_religionname_id_key'
}

/** input type for incrementing numeric columns in table "polls_entity_alt_names" */
export type Polls_Entity_Alt_Names_Inc_Input = {
  entry_id?: InputMaybe<Scalars['Int']>;
  entryname_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_entity_alt_names" */
export type Polls_Entity_Alt_Names_Insert_Input = {
  entry?: InputMaybe<Polls_Entity_Obj_Rel_Insert_Input>;
  entry_id?: InputMaybe<Scalars['Int']>;
  entryname_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Polls_Entityname_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Polls_Entity_Alt_Names_Max_Fields = {
  __typename?: 'polls_entity_alt_names_max_fields';
  entry_id?: Maybe<Scalars['Int']>;
  entryname_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "polls_entity_alt_names" */
export type Polls_Entity_Alt_Names_Max_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  entryname_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Polls_Entity_Alt_Names_Min_Fields = {
  __typename?: 'polls_entity_alt_names_min_fields';
  entry_id?: Maybe<Scalars['Int']>;
  entryname_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "polls_entity_alt_names" */
export type Polls_Entity_Alt_Names_Min_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  entryname_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "polls_entity_alt_names" */
export type Polls_Entity_Alt_Names_Mutation_Response = {
  __typename?: 'polls_entity_alt_names_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Entity_Alt_Names>;
};

/** on_conflict condition type for table "polls_entity_alt_names" */
export type Polls_Entity_Alt_Names_On_Conflict = {
  constraint: Polls_Entity_Alt_Names_Constraint;
  update_columns?: Array<Polls_Entity_Alt_Names_Update_Column>;
  where?: InputMaybe<Polls_Entity_Alt_Names_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_entity_alt_names". */
export type Polls_Entity_Alt_Names_Order_By = {
  entry?: InputMaybe<Polls_Entity_Order_By>;
  entry_id?: InputMaybe<Order_By>;
  entryname_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Polls_Entityname_Order_By>;
};

/** primary key columns input for table: polls_entity_alt_names */
export type Polls_Entity_Alt_Names_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_entity_alt_names" */
export enum Polls_Entity_Alt_Names_Select_Column {
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  EntrynameId = 'entryname_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "polls_entity_alt_names" */
export type Polls_Entity_Alt_Names_Set_Input = {
  entry_id?: InputMaybe<Scalars['Int']>;
  entryname_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Polls_Entity_Alt_Names_Stddev_Fields = {
  __typename?: 'polls_entity_alt_names_stddev_fields';
  entry_id?: Maybe<Scalars['Float']>;
  entryname_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "polls_entity_alt_names" */
export type Polls_Entity_Alt_Names_Stddev_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  entryname_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Polls_Entity_Alt_Names_Stddev_Pop_Fields = {
  __typename?: 'polls_entity_alt_names_stddev_pop_fields';
  entry_id?: Maybe<Scalars['Float']>;
  entryname_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "polls_entity_alt_names" */
export type Polls_Entity_Alt_Names_Stddev_Pop_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  entryname_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Polls_Entity_Alt_Names_Stddev_Samp_Fields = {
  __typename?: 'polls_entity_alt_names_stddev_samp_fields';
  entry_id?: Maybe<Scalars['Float']>;
  entryname_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "polls_entity_alt_names" */
export type Polls_Entity_Alt_Names_Stddev_Samp_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  entryname_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Polls_Entity_Alt_Names_Sum_Fields = {
  __typename?: 'polls_entity_alt_names_sum_fields';
  entry_id?: Maybe<Scalars['Int']>;
  entryname_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "polls_entity_alt_names" */
export type Polls_Entity_Alt_Names_Sum_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  entryname_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "polls_entity_alt_names" */
export enum Polls_Entity_Alt_Names_Update_Column {
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  EntrynameId = 'entryname_id',
  /** column name */
  Id = 'id'
}

/** aggregate var_pop on columns */
export type Polls_Entity_Alt_Names_Var_Pop_Fields = {
  __typename?: 'polls_entity_alt_names_var_pop_fields';
  entry_id?: Maybe<Scalars['Float']>;
  entryname_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "polls_entity_alt_names" */
export type Polls_Entity_Alt_Names_Var_Pop_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  entryname_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Polls_Entity_Alt_Names_Var_Samp_Fields = {
  __typename?: 'polls_entity_alt_names_var_samp_fields';
  entry_id?: Maybe<Scalars['Float']>;
  entryname_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "polls_entity_alt_names" */
export type Polls_Entity_Alt_Names_Var_Samp_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  entryname_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Polls_Entity_Alt_Names_Variance_Fields = {
  __typename?: 'polls_entity_alt_names_variance_fields';
  entry_id?: Maybe<Scalars['Float']>;
  entryname_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "polls_entity_alt_names" */
export type Polls_Entity_Alt_Names_Variance_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  entryname_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** input type for inserting array relation for remote table "polls_entity" */
export type Polls_Entity_Arr_Rel_Insert_Input = {
  data: Array<Polls_Entity_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Entity_On_Conflict>;
};

/** aggregate avg on columns */
export type Polls_Entity_Avg_Fields = {
  __typename?: 'polls_entity_avg_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  data_source_id?: Maybe<Scalars['Float']>;
  entry_source?: Maybe<Scalars['Float']>;
  expert_source_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  name_id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  secondary_source_id?: Maybe<Scalars['Float']>;
  supervised_by_id?: Maybe<Scalars['Float']>;
  year_from?: Maybe<Scalars['Float']>;
  year_to?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "polls_entity" */
export type Polls_Entity_Avg_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  data_source_id?: InputMaybe<Order_By>;
  entry_source?: InputMaybe<Order_By>;
  expert_source_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  secondary_source_id?: InputMaybe<Order_By>;
  supervised_by_id?: InputMaybe<Order_By>;
  year_from?: InputMaybe<Order_By>;
  year_to?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "polls_entity". All fields are combined with a logical 'AND'. */
export type Polls_Entity_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Entity_Bool_Exp>>;
  _not?: InputMaybe<Polls_Entity_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Entity_Bool_Exp>>;
  alt_names?: InputMaybe<Polls_Entity_Alt_Names_Bool_Exp>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  base_answer_sets?: InputMaybe<Polls_Baseanswerset_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  data_source?: InputMaybe<Polls_Datasource_Bool_Exp>;
  data_source_id?: InputMaybe<Int_Comparison_Exp>;
  date_created?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  description_en?: InputMaybe<String_Comparison_Exp>;
  description_es?: InputMaybe<String_Comparison_Exp>;
  description_fr?: InputMaybe<String_Comparison_Exp>;
  description_ja?: InputMaybe<String_Comparison_Exp>;
  description_zh_hans?: InputMaybe<String_Comparison_Exp>;
  description_zh_hant?: InputMaybe<String_Comparison_Exp>;
  entry_draft_hash?: InputMaybe<String_Comparison_Exp>;
  entry_hash?: InputMaybe<String_Comparison_Exp>;
  entry_source?: InputMaybe<Int_Comparison_Exp>;
  expert_source?: InputMaybe<Accounts_Expert_Bool_Exp>;
  expert_source_id?: InputMaybe<Int_Comparison_Exp>;
  external_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<Polls_Entityname_Bool_Exp>;
  name_id?: InputMaybe<Int_Comparison_Exp>;
  next?: InputMaybe<Polls_Entity_Bool_Exp>;
  poll?: InputMaybe<Polls_Poll_Bool_Exp>;
  poll_id?: InputMaybe<Int_Comparison_Exp>;
  previous?: InputMaybe<Polls_Entity_Bool_Exp>;
  previous_id?: InputMaybe<Int_Comparison_Exp>;
  progress?: InputMaybe<Polls_Pollprogress_Bool_Exp>;
  region?: InputMaybe<Gis_Regions_Gis_Region_Bool_Exp>;
  region_id?: InputMaybe<Int_Comparison_Exp>;
  secondary_source?: InputMaybe<Polls_Secondarysource_Bool_Exp>;
  secondary_source_id?: InputMaybe<Int_Comparison_Exp>;
  supervised_by_id?: InputMaybe<Int_Comparison_Exp>;
  supervisor?: InputMaybe<Accounts_Expert_Bool_Exp>;
  tags?: InputMaybe<Polls_Entity_Tags_Bool_Exp>;
  user?: InputMaybe<Auth_User_Bool_Exp>;
  year_from?: InputMaybe<Int_Comparison_Exp>;
  year_to?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_entity" */
export enum Polls_Entity_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollsEntityPkey = 'polls_entity_pkey'
}

/** input type for incrementing numeric columns in table "polls_entity" */
export type Polls_Entity_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['Int']>;
  data_source_id?: InputMaybe<Scalars['Int']>;
  entry_source?: InputMaybe<Scalars['Int']>;
  expert_source_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name_id?: InputMaybe<Scalars['Int']>;
  poll_id?: InputMaybe<Scalars['Int']>;
  previous_id?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['Int']>;
  secondary_source_id?: InputMaybe<Scalars['Int']>;
  supervised_by_id?: InputMaybe<Scalars['Int']>;
  year_from?: InputMaybe<Scalars['Int']>;
  year_to?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_entity" */
export type Polls_Entity_Insert_Input = {
  alt_names?: InputMaybe<Polls_Entity_Alt_Names_Arr_Rel_Insert_Input>;
  archived?: InputMaybe<Scalars['Boolean']>;
  base_answer_sets?: InputMaybe<Polls_Baseanswerset_Arr_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  data_source?: InputMaybe<Polls_Datasource_Obj_Rel_Insert_Input>;
  data_source_id?: InputMaybe<Scalars['Int']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_modified?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  description_en?: InputMaybe<Scalars['String']>;
  description_es?: InputMaybe<Scalars['String']>;
  description_fr?: InputMaybe<Scalars['String']>;
  description_ja?: InputMaybe<Scalars['String']>;
  description_zh_hans?: InputMaybe<Scalars['String']>;
  description_zh_hant?: InputMaybe<Scalars['String']>;
  entry_draft_hash?: InputMaybe<Scalars['String']>;
  entry_hash?: InputMaybe<Scalars['String']>;
  entry_source?: InputMaybe<Scalars['Int']>;
  expert_source?: InputMaybe<Accounts_Expert_Obj_Rel_Insert_Input>;
  expert_source_id?: InputMaybe<Scalars['Int']>;
  external_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Polls_Entityname_Obj_Rel_Insert_Input>;
  name_id?: InputMaybe<Scalars['Int']>;
  next?: InputMaybe<Polls_Entity_Obj_Rel_Insert_Input>;
  poll?: InputMaybe<Polls_Poll_Obj_Rel_Insert_Input>;
  poll_id?: InputMaybe<Scalars['Int']>;
  previous?: InputMaybe<Polls_Entity_Obj_Rel_Insert_Input>;
  previous_id?: InputMaybe<Scalars['Int']>;
  progress?: InputMaybe<Polls_Pollprogress_Arr_Rel_Insert_Input>;
  region?: InputMaybe<Gis_Regions_Gis_Region_Obj_Rel_Insert_Input>;
  region_id?: InputMaybe<Scalars['Int']>;
  secondary_source?: InputMaybe<Polls_Secondarysource_Obj_Rel_Insert_Input>;
  secondary_source_id?: InputMaybe<Scalars['Int']>;
  supervised_by_id?: InputMaybe<Scalars['Int']>;
  supervisor?: InputMaybe<Accounts_Expert_Obj_Rel_Insert_Input>;
  tags?: InputMaybe<Polls_Entity_Tags_Arr_Rel_Insert_Input>;
  user?: InputMaybe<Auth_User_Obj_Rel_Insert_Input>;
  year_from?: InputMaybe<Scalars['Int']>;
  year_to?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Polls_Entity_Max_Fields = {
  __typename?: 'polls_entity_max_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  data_source_id?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['timestamptz']>;
  date_modified?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  description_en?: Maybe<Scalars['String']>;
  description_es?: Maybe<Scalars['String']>;
  description_fr?: Maybe<Scalars['String']>;
  description_ja?: Maybe<Scalars['String']>;
  description_zh_hans?: Maybe<Scalars['String']>;
  description_zh_hant?: Maybe<Scalars['String']>;
  entry_draft_hash?: Maybe<Scalars['String']>;
  entry_hash?: Maybe<Scalars['String']>;
  entry_source?: Maybe<Scalars['Int']>;
  expert_source_id?: Maybe<Scalars['Int']>;
  external_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name_id?: Maybe<Scalars['Int']>;
  poll_id?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
  region_id?: Maybe<Scalars['Int']>;
  secondary_source_id?: Maybe<Scalars['Int']>;
  supervised_by_id?: Maybe<Scalars['Int']>;
  year_from?: Maybe<Scalars['Int']>;
  year_to?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "polls_entity" */
export type Polls_Entity_Max_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  data_source_id?: InputMaybe<Order_By>;
  date_created?: InputMaybe<Order_By>;
  date_modified?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  description_en?: InputMaybe<Order_By>;
  description_es?: InputMaybe<Order_By>;
  description_fr?: InputMaybe<Order_By>;
  description_ja?: InputMaybe<Order_By>;
  description_zh_hans?: InputMaybe<Order_By>;
  description_zh_hant?: InputMaybe<Order_By>;
  entry_draft_hash?: InputMaybe<Order_By>;
  entry_hash?: InputMaybe<Order_By>;
  entry_source?: InputMaybe<Order_By>;
  expert_source_id?: InputMaybe<Order_By>;
  external_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  secondary_source_id?: InputMaybe<Order_By>;
  supervised_by_id?: InputMaybe<Order_By>;
  year_from?: InputMaybe<Order_By>;
  year_to?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Polls_Entity_Min_Fields = {
  __typename?: 'polls_entity_min_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  data_source_id?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['timestamptz']>;
  date_modified?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  description_en?: Maybe<Scalars['String']>;
  description_es?: Maybe<Scalars['String']>;
  description_fr?: Maybe<Scalars['String']>;
  description_ja?: Maybe<Scalars['String']>;
  description_zh_hans?: Maybe<Scalars['String']>;
  description_zh_hant?: Maybe<Scalars['String']>;
  entry_draft_hash?: Maybe<Scalars['String']>;
  entry_hash?: Maybe<Scalars['String']>;
  entry_source?: Maybe<Scalars['Int']>;
  expert_source_id?: Maybe<Scalars['Int']>;
  external_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name_id?: Maybe<Scalars['Int']>;
  poll_id?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
  region_id?: Maybe<Scalars['Int']>;
  secondary_source_id?: Maybe<Scalars['Int']>;
  supervised_by_id?: Maybe<Scalars['Int']>;
  year_from?: Maybe<Scalars['Int']>;
  year_to?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "polls_entity" */
export type Polls_Entity_Min_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  data_source_id?: InputMaybe<Order_By>;
  date_created?: InputMaybe<Order_By>;
  date_modified?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  description_en?: InputMaybe<Order_By>;
  description_es?: InputMaybe<Order_By>;
  description_fr?: InputMaybe<Order_By>;
  description_ja?: InputMaybe<Order_By>;
  description_zh_hans?: InputMaybe<Order_By>;
  description_zh_hant?: InputMaybe<Order_By>;
  entry_draft_hash?: InputMaybe<Order_By>;
  entry_hash?: InputMaybe<Order_By>;
  entry_source?: InputMaybe<Order_By>;
  expert_source_id?: InputMaybe<Order_By>;
  external_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  secondary_source_id?: InputMaybe<Order_By>;
  supervised_by_id?: InputMaybe<Order_By>;
  year_from?: InputMaybe<Order_By>;
  year_to?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "polls_entity" */
export type Polls_Entity_Mutation_Response = {
  __typename?: 'polls_entity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Entity>;
};

/** input type for inserting object relation for remote table "polls_entity" */
export type Polls_Entity_Obj_Rel_Insert_Input = {
  data: Polls_Entity_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Entity_On_Conflict>;
};

/** on_conflict condition type for table "polls_entity" */
export type Polls_Entity_On_Conflict = {
  constraint: Polls_Entity_Constraint;
  update_columns?: Array<Polls_Entity_Update_Column>;
  where?: InputMaybe<Polls_Entity_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_entity". */
export type Polls_Entity_Order_By = {
  alt_names_aggregate?: InputMaybe<Polls_Entity_Alt_Names_Aggregate_Order_By>;
  archived?: InputMaybe<Order_By>;
  base_answer_sets_aggregate?: InputMaybe<Polls_Baseanswerset_Aggregate_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  data_source?: InputMaybe<Polls_Datasource_Order_By>;
  data_source_id?: InputMaybe<Order_By>;
  date_created?: InputMaybe<Order_By>;
  date_modified?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  description_en?: InputMaybe<Order_By>;
  description_es?: InputMaybe<Order_By>;
  description_fr?: InputMaybe<Order_By>;
  description_ja?: InputMaybe<Order_By>;
  description_zh_hans?: InputMaybe<Order_By>;
  description_zh_hant?: InputMaybe<Order_By>;
  entry_draft_hash?: InputMaybe<Order_By>;
  entry_hash?: InputMaybe<Order_By>;
  entry_source?: InputMaybe<Order_By>;
  expert_source?: InputMaybe<Accounts_Expert_Order_By>;
  expert_source_id?: InputMaybe<Order_By>;
  external_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Polls_Entityname_Order_By>;
  name_id?: InputMaybe<Order_By>;
  next?: InputMaybe<Polls_Entity_Order_By>;
  poll?: InputMaybe<Polls_Poll_Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous?: InputMaybe<Polls_Entity_Order_By>;
  previous_id?: InputMaybe<Order_By>;
  progress_aggregate?: InputMaybe<Polls_Pollprogress_Aggregate_Order_By>;
  region?: InputMaybe<Gis_Regions_Gis_Region_Order_By>;
  region_id?: InputMaybe<Order_By>;
  secondary_source?: InputMaybe<Polls_Secondarysource_Order_By>;
  secondary_source_id?: InputMaybe<Order_By>;
  supervised_by_id?: InputMaybe<Order_By>;
  supervisor?: InputMaybe<Accounts_Expert_Order_By>;
  tags_aggregate?: InputMaybe<Polls_Entity_Tags_Aggregate_Order_By>;
  user?: InputMaybe<Auth_User_Order_By>;
  year_from?: InputMaybe<Order_By>;
  year_to?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_entity */
export type Polls_Entity_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_entity" */
export enum Polls_Entity_Select_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DataSourceId = 'data_source_id',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateModified = 'date_modified',
  /** column name */
  Description = 'description',
  /** column name */
  DescriptionEn = 'description_en',
  /** column name */
  DescriptionEs = 'description_es',
  /** column name */
  DescriptionFr = 'description_fr',
  /** column name */
  DescriptionJa = 'description_ja',
  /** column name */
  DescriptionZhHans = 'description_zh_hans',
  /** column name */
  DescriptionZhHant = 'description_zh_hant',
  /** column name */
  EntryDraftHash = 'entry_draft_hash',
  /** column name */
  EntryHash = 'entry_hash',
  /** column name */
  EntrySource = 'entry_source',
  /** column name */
  ExpertSourceId = 'expert_source_id',
  /** column name */
  ExternalUrl = 'external_url',
  /** column name */
  Id = 'id',
  /** column name */
  NameId = 'name_id',
  /** column name */
  PollId = 'poll_id',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  SecondarySourceId = 'secondary_source_id',
  /** column name */
  SupervisedById = 'supervised_by_id',
  /** column name */
  YearFrom = 'year_from',
  /** column name */
  YearTo = 'year_to'
}

/** input type for updating data in table "polls_entity" */
export type Polls_Entity_Set_Input = {
  archived?: InputMaybe<Scalars['Boolean']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  data_source_id?: InputMaybe<Scalars['Int']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_modified?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  description_en?: InputMaybe<Scalars['String']>;
  description_es?: InputMaybe<Scalars['String']>;
  description_fr?: InputMaybe<Scalars['String']>;
  description_ja?: InputMaybe<Scalars['String']>;
  description_zh_hans?: InputMaybe<Scalars['String']>;
  description_zh_hant?: InputMaybe<Scalars['String']>;
  entry_draft_hash?: InputMaybe<Scalars['String']>;
  entry_hash?: InputMaybe<Scalars['String']>;
  entry_source?: InputMaybe<Scalars['Int']>;
  expert_source_id?: InputMaybe<Scalars['Int']>;
  external_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name_id?: InputMaybe<Scalars['Int']>;
  poll_id?: InputMaybe<Scalars['Int']>;
  previous_id?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['Int']>;
  secondary_source_id?: InputMaybe<Scalars['Int']>;
  supervised_by_id?: InputMaybe<Scalars['Int']>;
  year_from?: InputMaybe<Scalars['Int']>;
  year_to?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Polls_Entity_Stddev_Fields = {
  __typename?: 'polls_entity_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  data_source_id?: Maybe<Scalars['Float']>;
  entry_source?: Maybe<Scalars['Float']>;
  expert_source_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  name_id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  secondary_source_id?: Maybe<Scalars['Float']>;
  supervised_by_id?: Maybe<Scalars['Float']>;
  year_from?: Maybe<Scalars['Float']>;
  year_to?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "polls_entity" */
export type Polls_Entity_Stddev_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  data_source_id?: InputMaybe<Order_By>;
  entry_source?: InputMaybe<Order_By>;
  expert_source_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  secondary_source_id?: InputMaybe<Order_By>;
  supervised_by_id?: InputMaybe<Order_By>;
  year_from?: InputMaybe<Order_By>;
  year_to?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Polls_Entity_Stddev_Pop_Fields = {
  __typename?: 'polls_entity_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  data_source_id?: Maybe<Scalars['Float']>;
  entry_source?: Maybe<Scalars['Float']>;
  expert_source_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  name_id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  secondary_source_id?: Maybe<Scalars['Float']>;
  supervised_by_id?: Maybe<Scalars['Float']>;
  year_from?: Maybe<Scalars['Float']>;
  year_to?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "polls_entity" */
export type Polls_Entity_Stddev_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  data_source_id?: InputMaybe<Order_By>;
  entry_source?: InputMaybe<Order_By>;
  expert_source_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  secondary_source_id?: InputMaybe<Order_By>;
  supervised_by_id?: InputMaybe<Order_By>;
  year_from?: InputMaybe<Order_By>;
  year_to?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Polls_Entity_Stddev_Samp_Fields = {
  __typename?: 'polls_entity_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  data_source_id?: Maybe<Scalars['Float']>;
  entry_source?: Maybe<Scalars['Float']>;
  expert_source_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  name_id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  secondary_source_id?: Maybe<Scalars['Float']>;
  supervised_by_id?: Maybe<Scalars['Float']>;
  year_from?: Maybe<Scalars['Float']>;
  year_to?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "polls_entity" */
export type Polls_Entity_Stddev_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  data_source_id?: InputMaybe<Order_By>;
  entry_source?: InputMaybe<Order_By>;
  expert_source_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  secondary_source_id?: InputMaybe<Order_By>;
  supervised_by_id?: InputMaybe<Order_By>;
  year_from?: InputMaybe<Order_By>;
  year_to?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Polls_Entity_Sum_Fields = {
  __typename?: 'polls_entity_sum_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  data_source_id?: Maybe<Scalars['Int']>;
  entry_source?: Maybe<Scalars['Int']>;
  expert_source_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name_id?: Maybe<Scalars['Int']>;
  poll_id?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
  region_id?: Maybe<Scalars['Int']>;
  secondary_source_id?: Maybe<Scalars['Int']>;
  supervised_by_id?: Maybe<Scalars['Int']>;
  year_from?: Maybe<Scalars['Int']>;
  year_to?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "polls_entity" */
export type Polls_Entity_Sum_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  data_source_id?: InputMaybe<Order_By>;
  entry_source?: InputMaybe<Order_By>;
  expert_source_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  secondary_source_id?: InputMaybe<Order_By>;
  supervised_by_id?: InputMaybe<Order_By>;
  year_from?: InputMaybe<Order_By>;
  year_to?: InputMaybe<Order_By>;
};

/** columns and relationships of "polls_entity_tags" */
export type Polls_Entity_Tags = {
  __typename?: 'polls_entity_tags';
  /** An object relationship */
  entry: Polls_Entity;
  entry_id: Scalars['Int'];
  entrytag_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  tag: Polls_Entitytag;
};

/** aggregated selection of "polls_entity_tags" */
export type Polls_Entity_Tags_Aggregate = {
  __typename?: 'polls_entity_tags_aggregate';
  aggregate?: Maybe<Polls_Entity_Tags_Aggregate_Fields>;
  nodes: Array<Polls_Entity_Tags>;
};

/** aggregate fields of "polls_entity_tags" */
export type Polls_Entity_Tags_Aggregate_Fields = {
  __typename?: 'polls_entity_tags_aggregate_fields';
  avg?: Maybe<Polls_Entity_Tags_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Entity_Tags_Max_Fields>;
  min?: Maybe<Polls_Entity_Tags_Min_Fields>;
  stddev?: Maybe<Polls_Entity_Tags_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Entity_Tags_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Entity_Tags_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Entity_Tags_Sum_Fields>;
  var_pop?: Maybe<Polls_Entity_Tags_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Entity_Tags_Var_Samp_Fields>;
  variance?: Maybe<Polls_Entity_Tags_Variance_Fields>;
};


/** aggregate fields of "polls_entity_tags" */
export type Polls_Entity_Tags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Entity_Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "polls_entity_tags" */
export type Polls_Entity_Tags_Aggregate_Order_By = {
  avg?: InputMaybe<Polls_Entity_Tags_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Polls_Entity_Tags_Max_Order_By>;
  min?: InputMaybe<Polls_Entity_Tags_Min_Order_By>;
  stddev?: InputMaybe<Polls_Entity_Tags_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Polls_Entity_Tags_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Polls_Entity_Tags_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Polls_Entity_Tags_Sum_Order_By>;
  var_pop?: InputMaybe<Polls_Entity_Tags_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Polls_Entity_Tags_Var_Samp_Order_By>;
  variance?: InputMaybe<Polls_Entity_Tags_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "polls_entity_tags" */
export type Polls_Entity_Tags_Arr_Rel_Insert_Input = {
  data: Array<Polls_Entity_Tags_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Entity_Tags_On_Conflict>;
};

/** aggregate avg on columns */
export type Polls_Entity_Tags_Avg_Fields = {
  __typename?: 'polls_entity_tags_avg_fields';
  entry_id?: Maybe<Scalars['Float']>;
  entrytag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "polls_entity_tags" */
export type Polls_Entity_Tags_Avg_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  entrytag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "polls_entity_tags". All fields are combined with a logical 'AND'. */
export type Polls_Entity_Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Entity_Tags_Bool_Exp>>;
  _not?: InputMaybe<Polls_Entity_Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Entity_Tags_Bool_Exp>>;
  entry?: InputMaybe<Polls_Entity_Bool_Exp>;
  entry_id?: InputMaybe<Int_Comparison_Exp>;
  entrytag_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  tag?: InputMaybe<Polls_Entitytag_Bool_Exp>;
};

/** unique or primary key constraints on table "polls_entity_tags" */
export enum Polls_Entity_Tags_Constraint {
  /** unique or primary key constraint on columns "entry_id", "entrytag_id" */
  PollsEntityTagsEntityId_4f589e4cUniq = 'polls_entity_tags_entity_id_4f589e4c_uniq',
  /** unique or primary key constraint on columns "id" */
  PollsEntityTagsPkey = 'polls_entity_tags_pkey'
}

/** input type for incrementing numeric columns in table "polls_entity_tags" */
export type Polls_Entity_Tags_Inc_Input = {
  entry_id?: InputMaybe<Scalars['Int']>;
  entrytag_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_entity_tags" */
export type Polls_Entity_Tags_Insert_Input = {
  entry?: InputMaybe<Polls_Entity_Obj_Rel_Insert_Input>;
  entry_id?: InputMaybe<Scalars['Int']>;
  entrytag_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Polls_Entitytag_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Polls_Entity_Tags_Max_Fields = {
  __typename?: 'polls_entity_tags_max_fields';
  entry_id?: Maybe<Scalars['Int']>;
  entrytag_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "polls_entity_tags" */
export type Polls_Entity_Tags_Max_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  entrytag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Polls_Entity_Tags_Min_Fields = {
  __typename?: 'polls_entity_tags_min_fields';
  entry_id?: Maybe<Scalars['Int']>;
  entrytag_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "polls_entity_tags" */
export type Polls_Entity_Tags_Min_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  entrytag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "polls_entity_tags" */
export type Polls_Entity_Tags_Mutation_Response = {
  __typename?: 'polls_entity_tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Entity_Tags>;
};

/** on_conflict condition type for table "polls_entity_tags" */
export type Polls_Entity_Tags_On_Conflict = {
  constraint: Polls_Entity_Tags_Constraint;
  update_columns?: Array<Polls_Entity_Tags_Update_Column>;
  where?: InputMaybe<Polls_Entity_Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_entity_tags". */
export type Polls_Entity_Tags_Order_By = {
  entry?: InputMaybe<Polls_Entity_Order_By>;
  entry_id?: InputMaybe<Order_By>;
  entrytag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Polls_Entitytag_Order_By>;
};

/** primary key columns input for table: polls_entity_tags */
export type Polls_Entity_Tags_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_entity_tags" */
export enum Polls_Entity_Tags_Select_Column {
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  EntrytagId = 'entrytag_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "polls_entity_tags" */
export type Polls_Entity_Tags_Set_Input = {
  entry_id?: InputMaybe<Scalars['Int']>;
  entrytag_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Polls_Entity_Tags_Stddev_Fields = {
  __typename?: 'polls_entity_tags_stddev_fields';
  entry_id?: Maybe<Scalars['Float']>;
  entrytag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "polls_entity_tags" */
export type Polls_Entity_Tags_Stddev_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  entrytag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Polls_Entity_Tags_Stddev_Pop_Fields = {
  __typename?: 'polls_entity_tags_stddev_pop_fields';
  entry_id?: Maybe<Scalars['Float']>;
  entrytag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "polls_entity_tags" */
export type Polls_Entity_Tags_Stddev_Pop_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  entrytag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Polls_Entity_Tags_Stddev_Samp_Fields = {
  __typename?: 'polls_entity_tags_stddev_samp_fields';
  entry_id?: Maybe<Scalars['Float']>;
  entrytag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "polls_entity_tags" */
export type Polls_Entity_Tags_Stddev_Samp_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  entrytag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Polls_Entity_Tags_Sum_Fields = {
  __typename?: 'polls_entity_tags_sum_fields';
  entry_id?: Maybe<Scalars['Int']>;
  entrytag_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "polls_entity_tags" */
export type Polls_Entity_Tags_Sum_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  entrytag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "polls_entity_tags" */
export enum Polls_Entity_Tags_Update_Column {
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  EntrytagId = 'entrytag_id',
  /** column name */
  Id = 'id'
}

/** aggregate var_pop on columns */
export type Polls_Entity_Tags_Var_Pop_Fields = {
  __typename?: 'polls_entity_tags_var_pop_fields';
  entry_id?: Maybe<Scalars['Float']>;
  entrytag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "polls_entity_tags" */
export type Polls_Entity_Tags_Var_Pop_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  entrytag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Polls_Entity_Tags_Var_Samp_Fields = {
  __typename?: 'polls_entity_tags_var_samp_fields';
  entry_id?: Maybe<Scalars['Float']>;
  entrytag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "polls_entity_tags" */
export type Polls_Entity_Tags_Var_Samp_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  entrytag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Polls_Entity_Tags_Variance_Fields = {
  __typename?: 'polls_entity_tags_variance_fields';
  entry_id?: Maybe<Scalars['Float']>;
  entrytag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "polls_entity_tags" */
export type Polls_Entity_Tags_Variance_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  entrytag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "polls_entity" */
export enum Polls_Entity_Update_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DataSourceId = 'data_source_id',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateModified = 'date_modified',
  /** column name */
  Description = 'description',
  /** column name */
  DescriptionEn = 'description_en',
  /** column name */
  DescriptionEs = 'description_es',
  /** column name */
  DescriptionFr = 'description_fr',
  /** column name */
  DescriptionJa = 'description_ja',
  /** column name */
  DescriptionZhHans = 'description_zh_hans',
  /** column name */
  DescriptionZhHant = 'description_zh_hant',
  /** column name */
  EntryDraftHash = 'entry_draft_hash',
  /** column name */
  EntryHash = 'entry_hash',
  /** column name */
  EntrySource = 'entry_source',
  /** column name */
  ExpertSourceId = 'expert_source_id',
  /** column name */
  ExternalUrl = 'external_url',
  /** column name */
  Id = 'id',
  /** column name */
  NameId = 'name_id',
  /** column name */
  PollId = 'poll_id',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  SecondarySourceId = 'secondary_source_id',
  /** column name */
  SupervisedById = 'supervised_by_id',
  /** column name */
  YearFrom = 'year_from',
  /** column name */
  YearTo = 'year_to'
}

/** aggregate var_pop on columns */
export type Polls_Entity_Var_Pop_Fields = {
  __typename?: 'polls_entity_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  data_source_id?: Maybe<Scalars['Float']>;
  entry_source?: Maybe<Scalars['Float']>;
  expert_source_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  name_id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  secondary_source_id?: Maybe<Scalars['Float']>;
  supervised_by_id?: Maybe<Scalars['Float']>;
  year_from?: Maybe<Scalars['Float']>;
  year_to?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "polls_entity" */
export type Polls_Entity_Var_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  data_source_id?: InputMaybe<Order_By>;
  entry_source?: InputMaybe<Order_By>;
  expert_source_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  secondary_source_id?: InputMaybe<Order_By>;
  supervised_by_id?: InputMaybe<Order_By>;
  year_from?: InputMaybe<Order_By>;
  year_to?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Polls_Entity_Var_Samp_Fields = {
  __typename?: 'polls_entity_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  data_source_id?: Maybe<Scalars['Float']>;
  entry_source?: Maybe<Scalars['Float']>;
  expert_source_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  name_id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  secondary_source_id?: Maybe<Scalars['Float']>;
  supervised_by_id?: Maybe<Scalars['Float']>;
  year_from?: Maybe<Scalars['Float']>;
  year_to?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "polls_entity" */
export type Polls_Entity_Var_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  data_source_id?: InputMaybe<Order_By>;
  entry_source?: InputMaybe<Order_By>;
  expert_source_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  secondary_source_id?: InputMaybe<Order_By>;
  supervised_by_id?: InputMaybe<Order_By>;
  year_from?: InputMaybe<Order_By>;
  year_to?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Polls_Entity_Variance_Fields = {
  __typename?: 'polls_entity_variance_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  data_source_id?: Maybe<Scalars['Float']>;
  entry_source?: Maybe<Scalars['Float']>;
  expert_source_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  name_id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  secondary_source_id?: Maybe<Scalars['Float']>;
  supervised_by_id?: Maybe<Scalars['Float']>;
  year_from?: Maybe<Scalars['Float']>;
  year_to?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "polls_entity" */
export type Polls_Entity_Variance_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  data_source_id?: InputMaybe<Order_By>;
  entry_source?: InputMaybe<Order_By>;
  expert_source_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  secondary_source_id?: InputMaybe<Order_By>;
  supervised_by_id?: InputMaybe<Order_By>;
  year_from?: InputMaybe<Order_By>;
  year_to?: InputMaybe<Order_By>;
};

/** columns and relationships of "polls_entityname" */
export type Polls_Entityname = {
  __typename?: 'polls_entityname';
  /** An array relationship */
  entities: Array<Polls_Entity>;
  /** An aggregate relationship */
  entities_aggregate: Polls_Entity_Aggregate;
  id: Scalars['Int'];
  name: Scalars['String'];
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
};


/** columns and relationships of "polls_entityname" */
export type Polls_EntitynameEntitiesArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Order_By>>;
  where?: InputMaybe<Polls_Entity_Bool_Exp>;
};


/** columns and relationships of "polls_entityname" */
export type Polls_EntitynameEntities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Order_By>>;
  where?: InputMaybe<Polls_Entity_Bool_Exp>;
};

/** aggregated selection of "polls_entityname" */
export type Polls_Entityname_Aggregate = {
  __typename?: 'polls_entityname_aggregate';
  aggregate?: Maybe<Polls_Entityname_Aggregate_Fields>;
  nodes: Array<Polls_Entityname>;
};

/** aggregate fields of "polls_entityname" */
export type Polls_Entityname_Aggregate_Fields = {
  __typename?: 'polls_entityname_aggregate_fields';
  avg?: Maybe<Polls_Entityname_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Entityname_Max_Fields>;
  min?: Maybe<Polls_Entityname_Min_Fields>;
  stddev?: Maybe<Polls_Entityname_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Entityname_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Entityname_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Entityname_Sum_Fields>;
  var_pop?: Maybe<Polls_Entityname_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Entityname_Var_Samp_Fields>;
  variance?: Maybe<Polls_Entityname_Variance_Fields>;
};


/** aggregate fields of "polls_entityname" */
export type Polls_Entityname_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Entityname_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Polls_Entityname_Avg_Fields = {
  __typename?: 'polls_entityname_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "polls_entityname". All fields are combined with a logical 'AND'. */
export type Polls_Entityname_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Entityname_Bool_Exp>>;
  _not?: InputMaybe<Polls_Entityname_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Entityname_Bool_Exp>>;
  entities?: InputMaybe<Polls_Entity_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  name_en?: InputMaybe<String_Comparison_Exp>;
  name_es?: InputMaybe<String_Comparison_Exp>;
  name_fr?: InputMaybe<String_Comparison_Exp>;
  name_ja?: InputMaybe<String_Comparison_Exp>;
  name_zh_hans?: InputMaybe<String_Comparison_Exp>;
  name_zh_hant?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_entityname" */
export enum Polls_Entityname_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollsEntitynamePkey = 'polls_entityname_pkey'
}

/** input type for incrementing numeric columns in table "polls_entityname" */
export type Polls_Entityname_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_entityname" */
export type Polls_Entityname_Insert_Input = {
  entities?: InputMaybe<Polls_Entity_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Polls_Entityname_Max_Fields = {
  __typename?: 'polls_entityname_max_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Polls_Entityname_Min_Fields = {
  __typename?: 'polls_entityname_min_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "polls_entityname" */
export type Polls_Entityname_Mutation_Response = {
  __typename?: 'polls_entityname_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Entityname>;
};

/** input type for inserting object relation for remote table "polls_entityname" */
export type Polls_Entityname_Obj_Rel_Insert_Input = {
  data: Polls_Entityname_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Entityname_On_Conflict>;
};

/** on_conflict condition type for table "polls_entityname" */
export type Polls_Entityname_On_Conflict = {
  constraint: Polls_Entityname_Constraint;
  update_columns?: Array<Polls_Entityname_Update_Column>;
  where?: InputMaybe<Polls_Entityname_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_entityname". */
export type Polls_Entityname_Order_By = {
  entities_aggregate?: InputMaybe<Polls_Entity_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_entityname */
export type Polls_Entityname_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_entityname" */
export enum Polls_Entityname_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant'
}

/** input type for updating data in table "polls_entityname" */
export type Polls_Entityname_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Polls_Entityname_Stddev_Fields = {
  __typename?: 'polls_entityname_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Polls_Entityname_Stddev_Pop_Fields = {
  __typename?: 'polls_entityname_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Polls_Entityname_Stddev_Samp_Fields = {
  __typename?: 'polls_entityname_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Polls_Entityname_Sum_Fields = {
  __typename?: 'polls_entityname_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "polls_entityname" */
export enum Polls_Entityname_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant'
}

/** aggregate var_pop on columns */
export type Polls_Entityname_Var_Pop_Fields = {
  __typename?: 'polls_entityname_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Polls_Entityname_Var_Samp_Fields = {
  __typename?: 'polls_entityname_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Polls_Entityname_Variance_Fields = {
  __typename?: 'polls_entityname_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "polls_entitytag" */
export type Polls_Entitytag = {
  __typename?: 'polls_entitytag';
  approved: Scalars['Boolean'];
  created: Scalars['timestamptz'];
  created_by_id: Scalars['Int'];
  /** An array relationship */
  entries: Array<Polls_Entity_Tags>;
  /** An aggregate relationship */
  entries_aggregate: Polls_Entity_Tags_Aggregate;
  entry_tag_group_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  language: Scalars['String'];
  level: Scalars['Int'];
  name: Scalars['String'];
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  parent_tag_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  /** An object relationship */
  tag_group?: Maybe<Polls_Entrytaggroup>;
};


/** columns and relationships of "polls_entitytag" */
export type Polls_EntitytagEntriesArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Tags_Order_By>>;
  where?: InputMaybe<Polls_Entity_Tags_Bool_Exp>;
};


/** columns and relationships of "polls_entitytag" */
export type Polls_EntitytagEntries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Tags_Order_By>>;
  where?: InputMaybe<Polls_Entity_Tags_Bool_Exp>;
};

/** aggregated selection of "polls_entitytag" */
export type Polls_Entitytag_Aggregate = {
  __typename?: 'polls_entitytag_aggregate';
  aggregate?: Maybe<Polls_Entitytag_Aggregate_Fields>;
  nodes: Array<Polls_Entitytag>;
};

/** aggregate fields of "polls_entitytag" */
export type Polls_Entitytag_Aggregate_Fields = {
  __typename?: 'polls_entitytag_aggregate_fields';
  avg?: Maybe<Polls_Entitytag_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Entitytag_Max_Fields>;
  min?: Maybe<Polls_Entitytag_Min_Fields>;
  stddev?: Maybe<Polls_Entitytag_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Entitytag_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Entitytag_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Entitytag_Sum_Fields>;
  var_pop?: Maybe<Polls_Entitytag_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Entitytag_Var_Samp_Fields>;
  variance?: Maybe<Polls_Entitytag_Variance_Fields>;
};


/** aggregate fields of "polls_entitytag" */
export type Polls_Entitytag_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Entitytag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "polls_entitytag" */
export type Polls_Entitytag_Aggregate_Order_By = {
  avg?: InputMaybe<Polls_Entitytag_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Polls_Entitytag_Max_Order_By>;
  min?: InputMaybe<Polls_Entitytag_Min_Order_By>;
  stddev?: InputMaybe<Polls_Entitytag_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Polls_Entitytag_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Polls_Entitytag_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Polls_Entitytag_Sum_Order_By>;
  var_pop?: InputMaybe<Polls_Entitytag_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Polls_Entitytag_Var_Samp_Order_By>;
  variance?: InputMaybe<Polls_Entitytag_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "polls_entitytag" */
export type Polls_Entitytag_Arr_Rel_Insert_Input = {
  data: Array<Polls_Entitytag_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Entitytag_On_Conflict>;
};

/** aggregate avg on columns */
export type Polls_Entitytag_Avg_Fields = {
  __typename?: 'polls_entitytag_avg_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  entry_tag_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  level?: Maybe<Scalars['Float']>;
  parent_tag_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "polls_entitytag" */
export type Polls_Entitytag_Avg_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  entry_tag_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  parent_tag_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "polls_entitytag". All fields are combined with a logical 'AND'. */
export type Polls_Entitytag_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Entitytag_Bool_Exp>>;
  _not?: InputMaybe<Polls_Entitytag_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Entitytag_Bool_Exp>>;
  approved?: InputMaybe<Boolean_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  entries?: InputMaybe<Polls_Entity_Tags_Bool_Exp>;
  entry_tag_group_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  level?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  name_en?: InputMaybe<String_Comparison_Exp>;
  name_es?: InputMaybe<String_Comparison_Exp>;
  name_fr?: InputMaybe<String_Comparison_Exp>;
  name_ja?: InputMaybe<String_Comparison_Exp>;
  name_zh_hans?: InputMaybe<String_Comparison_Exp>;
  name_zh_hant?: InputMaybe<String_Comparison_Exp>;
  parent_tag_id?: InputMaybe<Int_Comparison_Exp>;
  path?: InputMaybe<String_Comparison_Exp>;
  tag_group?: InputMaybe<Polls_Entrytaggroup_Bool_Exp>;
};

/** unique or primary key constraints on table "polls_entitytag" */
export enum Polls_Entitytag_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollsEntitytagPkey = 'polls_entitytag_pkey'
}

/** input type for incrementing numeric columns in table "polls_entitytag" */
export type Polls_Entitytag_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['Int']>;
  entry_tag_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<Scalars['Int']>;
  parent_tag_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_entitytag" */
export type Polls_Entitytag_Insert_Input = {
  approved?: InputMaybe<Scalars['Boolean']>;
  created?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  entries?: InputMaybe<Polls_Entity_Tags_Arr_Rel_Insert_Input>;
  entry_tag_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  language?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
  parent_tag_id?: InputMaybe<Scalars['Int']>;
  path?: InputMaybe<Scalars['String']>;
  tag_group?: InputMaybe<Polls_Entrytaggroup_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Polls_Entitytag_Max_Fields = {
  __typename?: 'polls_entitytag_max_fields';
  created?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  entry_tag_group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  language?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  parent_tag_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "polls_entitytag" */
export type Polls_Entitytag_Max_Order_By = {
  created?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  entry_tag_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  parent_tag_id?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Polls_Entitytag_Min_Fields = {
  __typename?: 'polls_entitytag_min_fields';
  created?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  entry_tag_group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  language?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  parent_tag_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "polls_entitytag" */
export type Polls_Entitytag_Min_Order_By = {
  created?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  entry_tag_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  parent_tag_id?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "polls_entitytag" */
export type Polls_Entitytag_Mutation_Response = {
  __typename?: 'polls_entitytag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Entitytag>;
};

/** input type for inserting object relation for remote table "polls_entitytag" */
export type Polls_Entitytag_Obj_Rel_Insert_Input = {
  data: Polls_Entitytag_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Entitytag_On_Conflict>;
};

/** on_conflict condition type for table "polls_entitytag" */
export type Polls_Entitytag_On_Conflict = {
  constraint: Polls_Entitytag_Constraint;
  update_columns?: Array<Polls_Entitytag_Update_Column>;
  where?: InputMaybe<Polls_Entitytag_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_entitytag". */
export type Polls_Entitytag_Order_By = {
  approved?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  entries_aggregate?: InputMaybe<Polls_Entity_Tags_Aggregate_Order_By>;
  entry_tag_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  parent_tag_id?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  tag_group?: InputMaybe<Polls_Entrytaggroup_Order_By>;
};

/** primary key columns input for table: polls_entitytag */
export type Polls_Entitytag_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_entitytag" */
export enum Polls_Entitytag_Select_Column {
  /** column name */
  Approved = 'approved',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  EntryTagGroupId = 'entry_tag_group_id',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  Level = 'level',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant',
  /** column name */
  ParentTagId = 'parent_tag_id',
  /** column name */
  Path = 'path'
}

/** input type for updating data in table "polls_entitytag" */
export type Polls_Entitytag_Set_Input = {
  approved?: InputMaybe<Scalars['Boolean']>;
  created?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  entry_tag_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  language?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
  parent_tag_id?: InputMaybe<Scalars['Int']>;
  path?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Polls_Entitytag_Stddev_Fields = {
  __typename?: 'polls_entitytag_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  entry_tag_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  level?: Maybe<Scalars['Float']>;
  parent_tag_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "polls_entitytag" */
export type Polls_Entitytag_Stddev_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  entry_tag_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  parent_tag_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Polls_Entitytag_Stddev_Pop_Fields = {
  __typename?: 'polls_entitytag_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  entry_tag_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  level?: Maybe<Scalars['Float']>;
  parent_tag_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "polls_entitytag" */
export type Polls_Entitytag_Stddev_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  entry_tag_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  parent_tag_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Polls_Entitytag_Stddev_Samp_Fields = {
  __typename?: 'polls_entitytag_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  entry_tag_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  level?: Maybe<Scalars['Float']>;
  parent_tag_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "polls_entitytag" */
export type Polls_Entitytag_Stddev_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  entry_tag_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  parent_tag_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Polls_Entitytag_Sum_Fields = {
  __typename?: 'polls_entitytag_sum_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  entry_tag_group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['Int']>;
  parent_tag_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "polls_entitytag" */
export type Polls_Entitytag_Sum_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  entry_tag_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  parent_tag_id?: InputMaybe<Order_By>;
};

/** update columns of table "polls_entitytag" */
export enum Polls_Entitytag_Update_Column {
  /** column name */
  Approved = 'approved',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  EntryTagGroupId = 'entry_tag_group_id',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  Level = 'level',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant',
  /** column name */
  ParentTagId = 'parent_tag_id',
  /** column name */
  Path = 'path'
}

/** aggregate var_pop on columns */
export type Polls_Entitytag_Var_Pop_Fields = {
  __typename?: 'polls_entitytag_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  entry_tag_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  level?: Maybe<Scalars['Float']>;
  parent_tag_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "polls_entitytag" */
export type Polls_Entitytag_Var_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  entry_tag_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  parent_tag_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Polls_Entitytag_Var_Samp_Fields = {
  __typename?: 'polls_entitytag_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  entry_tag_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  level?: Maybe<Scalars['Float']>;
  parent_tag_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "polls_entitytag" */
export type Polls_Entitytag_Var_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  entry_tag_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  parent_tag_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Polls_Entitytag_Variance_Fields = {
  __typename?: 'polls_entitytag_variance_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  entry_tag_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  level?: Maybe<Scalars['Float']>;
  parent_tag_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "polls_entitytag" */
export type Polls_Entitytag_Variance_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  entry_tag_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  parent_tag_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "polls_entry_attachment" */
export type Polls_Entry_Attachment = {
  __typename?: 'polls_entry_attachment';
  date_created: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  entry: Polls_Entity;
  entry_id: Scalars['Int'];
  /** An object relationship */
  file: User_File;
  file_id: Scalars['uuid'];
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
};

/** aggregated selection of "polls_entry_attachment" */
export type Polls_Entry_Attachment_Aggregate = {
  __typename?: 'polls_entry_attachment_aggregate';
  aggregate?: Maybe<Polls_Entry_Attachment_Aggregate_Fields>;
  nodes: Array<Polls_Entry_Attachment>;
};

/** aggregate fields of "polls_entry_attachment" */
export type Polls_Entry_Attachment_Aggregate_Fields = {
  __typename?: 'polls_entry_attachment_aggregate_fields';
  avg?: Maybe<Polls_Entry_Attachment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Entry_Attachment_Max_Fields>;
  min?: Maybe<Polls_Entry_Attachment_Min_Fields>;
  stddev?: Maybe<Polls_Entry_Attachment_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Entry_Attachment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Entry_Attachment_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Entry_Attachment_Sum_Fields>;
  var_pop?: Maybe<Polls_Entry_Attachment_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Entry_Attachment_Var_Samp_Fields>;
  variance?: Maybe<Polls_Entry_Attachment_Variance_Fields>;
};


/** aggregate fields of "polls_entry_attachment" */
export type Polls_Entry_Attachment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Entry_Attachment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "polls_entry_attachment" */
export type Polls_Entry_Attachment_Aggregate_Order_By = {
  avg?: InputMaybe<Polls_Entry_Attachment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Polls_Entry_Attachment_Max_Order_By>;
  min?: InputMaybe<Polls_Entry_Attachment_Min_Order_By>;
  stddev?: InputMaybe<Polls_Entry_Attachment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Polls_Entry_Attachment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Polls_Entry_Attachment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Polls_Entry_Attachment_Sum_Order_By>;
  var_pop?: InputMaybe<Polls_Entry_Attachment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Polls_Entry_Attachment_Var_Samp_Order_By>;
  variance?: InputMaybe<Polls_Entry_Attachment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "polls_entry_attachment" */
export type Polls_Entry_Attachment_Arr_Rel_Insert_Input = {
  data: Array<Polls_Entry_Attachment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Entry_Attachment_On_Conflict>;
};

/** aggregate avg on columns */
export type Polls_Entry_Attachment_Avg_Fields = {
  __typename?: 'polls_entry_attachment_avg_fields';
  entry_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "polls_entry_attachment" */
export type Polls_Entry_Attachment_Avg_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "polls_entry_attachment". All fields are combined with a logical 'AND'. */
export type Polls_Entry_Attachment_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Entry_Attachment_Bool_Exp>>;
  _not?: InputMaybe<Polls_Entry_Attachment_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Entry_Attachment_Bool_Exp>>;
  date_created?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  entry?: InputMaybe<Polls_Entity_Bool_Exp>;
  entry_id?: InputMaybe<Int_Comparison_Exp>;
  file?: InputMaybe<User_File_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_entry_attachment" */
export enum Polls_Entry_Attachment_Constraint {
  /** unique or primary key constraint on columns "file_id", "entry_id" */
  PollsEntryAttachmentEntryIdFileIdIdx = 'polls_entry_attachment_entry_id_file_id_idx',
  /** unique or primary key constraint on columns "file_id", "entry_id" */
  PollsEntryAttachmentEntryIdFileIdUnique = 'polls_entry_attachment_entry_id_file_id_unique',
  /** unique or primary key constraint on columns "id" */
  PollsEntryAttachmentPkey = 'polls_entry_attachment_pkey'
}

/** input type for incrementing numeric columns in table "polls_entry_attachment" */
export type Polls_Entry_Attachment_Inc_Input = {
  entry_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_entry_attachment" */
export type Polls_Entry_Attachment_Insert_Input = {
  date_created?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  entry?: InputMaybe<Polls_Entity_Obj_Rel_Insert_Input>;
  entry_id?: InputMaybe<Scalars['Int']>;
  file?: InputMaybe<User_File_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Polls_Entry_Attachment_Max_Fields = {
  __typename?: 'polls_entry_attachment_max_fields';
  date_created?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  entry_id?: Maybe<Scalars['Int']>;
  file_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "polls_entry_attachment" */
export type Polls_Entry_Attachment_Max_Order_By = {
  date_created?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Polls_Entry_Attachment_Min_Fields = {
  __typename?: 'polls_entry_attachment_min_fields';
  date_created?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  entry_id?: Maybe<Scalars['Int']>;
  file_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "polls_entry_attachment" */
export type Polls_Entry_Attachment_Min_Order_By = {
  date_created?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "polls_entry_attachment" */
export type Polls_Entry_Attachment_Mutation_Response = {
  __typename?: 'polls_entry_attachment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Entry_Attachment>;
};

/** on_conflict condition type for table "polls_entry_attachment" */
export type Polls_Entry_Attachment_On_Conflict = {
  constraint: Polls_Entry_Attachment_Constraint;
  update_columns?: Array<Polls_Entry_Attachment_Update_Column>;
  where?: InputMaybe<Polls_Entry_Attachment_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_entry_attachment". */
export type Polls_Entry_Attachment_Order_By = {
  date_created?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  entry?: InputMaybe<Polls_Entity_Order_By>;
  entry_id?: InputMaybe<Order_By>;
  file?: InputMaybe<User_File_Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_entry_attachment */
export type Polls_Entry_Attachment_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_entry_attachment" */
export enum Polls_Entry_Attachment_Select_Column {
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  Description = 'description',
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "polls_entry_attachment" */
export type Polls_Entry_Attachment_Set_Input = {
  date_created?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  entry_id?: InputMaybe<Scalars['Int']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Polls_Entry_Attachment_Stddev_Fields = {
  __typename?: 'polls_entry_attachment_stddev_fields';
  entry_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "polls_entry_attachment" */
export type Polls_Entry_Attachment_Stddev_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Polls_Entry_Attachment_Stddev_Pop_Fields = {
  __typename?: 'polls_entry_attachment_stddev_pop_fields';
  entry_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "polls_entry_attachment" */
export type Polls_Entry_Attachment_Stddev_Pop_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Polls_Entry_Attachment_Stddev_Samp_Fields = {
  __typename?: 'polls_entry_attachment_stddev_samp_fields';
  entry_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "polls_entry_attachment" */
export type Polls_Entry_Attachment_Stddev_Samp_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Polls_Entry_Attachment_Sum_Fields = {
  __typename?: 'polls_entry_attachment_sum_fields';
  entry_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "polls_entry_attachment" */
export type Polls_Entry_Attachment_Sum_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "polls_entry_attachment" */
export enum Polls_Entry_Attachment_Update_Column {
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  Description = 'description',
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title'
}

/** aggregate var_pop on columns */
export type Polls_Entry_Attachment_Var_Pop_Fields = {
  __typename?: 'polls_entry_attachment_var_pop_fields';
  entry_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "polls_entry_attachment" */
export type Polls_Entry_Attachment_Var_Pop_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Polls_Entry_Attachment_Var_Samp_Fields = {
  __typename?: 'polls_entry_attachment_var_samp_fields';
  entry_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "polls_entry_attachment" */
export type Polls_Entry_Attachment_Var_Samp_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Polls_Entry_Attachment_Variance_Fields = {
  __typename?: 'polls_entry_attachment_variance_fields';
  entry_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "polls_entry_attachment" */
export type Polls_Entry_Attachment_Variance_Order_By = {
  entry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "polls_entryattachment" */
export type Polls_Entryattachment = {
  __typename?: 'polls_entryattachment';
  content_type: Scalars['String'];
  date_created: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  entry: Polls_Entity;
  entry_id: Scalars['Int'];
  /** An object relationship */
  expert: Accounts_Expert;
  expert_id: Scalars['Int'];
  id: Scalars['Int'];
  preview_url?: Maybe<Scalars['String']>;
  size: Scalars['Int'];
  title: Scalars['String'];
  url: Scalars['String'];
};

/** aggregated selection of "polls_entryattachment" */
export type Polls_Entryattachment_Aggregate = {
  __typename?: 'polls_entryattachment_aggregate';
  aggregate?: Maybe<Polls_Entryattachment_Aggregate_Fields>;
  nodes: Array<Polls_Entryattachment>;
};

/** aggregate fields of "polls_entryattachment" */
export type Polls_Entryattachment_Aggregate_Fields = {
  __typename?: 'polls_entryattachment_aggregate_fields';
  avg?: Maybe<Polls_Entryattachment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Entryattachment_Max_Fields>;
  min?: Maybe<Polls_Entryattachment_Min_Fields>;
  stddev?: Maybe<Polls_Entryattachment_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Entryattachment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Entryattachment_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Entryattachment_Sum_Fields>;
  var_pop?: Maybe<Polls_Entryattachment_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Entryattachment_Var_Samp_Fields>;
  variance?: Maybe<Polls_Entryattachment_Variance_Fields>;
};


/** aggregate fields of "polls_entryattachment" */
export type Polls_Entryattachment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Entryattachment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Polls_Entryattachment_Avg_Fields = {
  __typename?: 'polls_entryattachment_avg_fields';
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "polls_entryattachment". All fields are combined with a logical 'AND'. */
export type Polls_Entryattachment_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Entryattachment_Bool_Exp>>;
  _not?: InputMaybe<Polls_Entryattachment_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Entryattachment_Bool_Exp>>;
  content_type?: InputMaybe<String_Comparison_Exp>;
  date_created?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  entry?: InputMaybe<Polls_Entity_Bool_Exp>;
  entry_id?: InputMaybe<Int_Comparison_Exp>;
  expert?: InputMaybe<Accounts_Expert_Bool_Exp>;
  expert_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  preview_url?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_entryattachment" */
export enum Polls_Entryattachment_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollsEntryattachmentPkey = 'polls_entryattachment_pkey'
}

/** input type for incrementing numeric columns in table "polls_entryattachment" */
export type Polls_Entryattachment_Inc_Input = {
  entry_id?: InputMaybe<Scalars['Int']>;
  expert_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_entryattachment" */
export type Polls_Entryattachment_Insert_Input = {
  content_type?: InputMaybe<Scalars['String']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  entry?: InputMaybe<Polls_Entity_Obj_Rel_Insert_Input>;
  entry_id?: InputMaybe<Scalars['Int']>;
  expert?: InputMaybe<Accounts_Expert_Obj_Rel_Insert_Input>;
  expert_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  preview_url?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Polls_Entryattachment_Max_Fields = {
  __typename?: 'polls_entryattachment_max_fields';
  content_type?: Maybe<Scalars['String']>;
  date_created?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  entry_id?: Maybe<Scalars['Int']>;
  expert_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  preview_url?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Polls_Entryattachment_Min_Fields = {
  __typename?: 'polls_entryattachment_min_fields';
  content_type?: Maybe<Scalars['String']>;
  date_created?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  entry_id?: Maybe<Scalars['Int']>;
  expert_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  preview_url?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "polls_entryattachment" */
export type Polls_Entryattachment_Mutation_Response = {
  __typename?: 'polls_entryattachment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Entryattachment>;
};

/** on_conflict condition type for table "polls_entryattachment" */
export type Polls_Entryattachment_On_Conflict = {
  constraint: Polls_Entryattachment_Constraint;
  update_columns?: Array<Polls_Entryattachment_Update_Column>;
  where?: InputMaybe<Polls_Entryattachment_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_entryattachment". */
export type Polls_Entryattachment_Order_By = {
  content_type?: InputMaybe<Order_By>;
  date_created?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  entry?: InputMaybe<Polls_Entity_Order_By>;
  entry_id?: InputMaybe<Order_By>;
  expert?: InputMaybe<Accounts_Expert_Order_By>;
  expert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  preview_url?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_entryattachment */
export type Polls_Entryattachment_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_entryattachment" */
export enum Polls_Entryattachment_Select_Column {
  /** column name */
  ContentType = 'content_type',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  Description = 'description',
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  ExpertId = 'expert_id',
  /** column name */
  Id = 'id',
  /** column name */
  PreviewUrl = 'preview_url',
  /** column name */
  Size = 'size',
  /** column name */
  Title = 'title',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "polls_entryattachment" */
export type Polls_Entryattachment_Set_Input = {
  content_type?: InputMaybe<Scalars['String']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  entry_id?: InputMaybe<Scalars['Int']>;
  expert_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  preview_url?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Polls_Entryattachment_Stddev_Fields = {
  __typename?: 'polls_entryattachment_stddev_fields';
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Polls_Entryattachment_Stddev_Pop_Fields = {
  __typename?: 'polls_entryattachment_stddev_pop_fields';
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Polls_Entryattachment_Stddev_Samp_Fields = {
  __typename?: 'polls_entryattachment_stddev_samp_fields';
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Polls_Entryattachment_Sum_Fields = {
  __typename?: 'polls_entryattachment_sum_fields';
  entry_id?: Maybe<Scalars['Int']>;
  expert_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
};

/** update columns of table "polls_entryattachment" */
export enum Polls_Entryattachment_Update_Column {
  /** column name */
  ContentType = 'content_type',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  Description = 'description',
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  ExpertId = 'expert_id',
  /** column name */
  Id = 'id',
  /** column name */
  PreviewUrl = 'preview_url',
  /** column name */
  Size = 'size',
  /** column name */
  Title = 'title',
  /** column name */
  Url = 'url'
}

/** aggregate var_pop on columns */
export type Polls_Entryattachment_Var_Pop_Fields = {
  __typename?: 'polls_entryattachment_var_pop_fields';
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Polls_Entryattachment_Var_Samp_Fields = {
  __typename?: 'polls_entryattachment_var_samp_fields';
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Polls_Entryattachment_Variance_Fields = {
  __typename?: 'polls_entryattachment_variance_fields';
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "polls_entryreference" */
export type Polls_Entryreference = {
  __typename?: 'polls_entryreference';
  base_source_id: Scalars['Int'];
  created_at?: Maybe<Scalars['timestamptz']>;
  entry_id: Scalars['Int'];
  expert_id: Scalars['Int'];
  id: Scalars['Int'];
  priority: Scalars['Int'];
};

/** aggregated selection of "polls_entryreference" */
export type Polls_Entryreference_Aggregate = {
  __typename?: 'polls_entryreference_aggregate';
  aggregate?: Maybe<Polls_Entryreference_Aggregate_Fields>;
  nodes: Array<Polls_Entryreference>;
};

/** aggregate fields of "polls_entryreference" */
export type Polls_Entryreference_Aggregate_Fields = {
  __typename?: 'polls_entryreference_aggregate_fields';
  avg?: Maybe<Polls_Entryreference_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Entryreference_Max_Fields>;
  min?: Maybe<Polls_Entryreference_Min_Fields>;
  stddev?: Maybe<Polls_Entryreference_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Entryreference_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Entryreference_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Entryreference_Sum_Fields>;
  var_pop?: Maybe<Polls_Entryreference_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Entryreference_Var_Samp_Fields>;
  variance?: Maybe<Polls_Entryreference_Variance_Fields>;
};


/** aggregate fields of "polls_entryreference" */
export type Polls_Entryreference_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Entryreference_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Polls_Entryreference_Avg_Fields = {
  __typename?: 'polls_entryreference_avg_fields';
  base_source_id?: Maybe<Scalars['Float']>;
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "polls_entryreference". All fields are combined with a logical 'AND'. */
export type Polls_Entryreference_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Entryreference_Bool_Exp>>;
  _not?: InputMaybe<Polls_Entryreference_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Entryreference_Bool_Exp>>;
  base_source_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  entry_id?: InputMaybe<Int_Comparison_Exp>;
  expert_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  priority?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_entryreference" */
export enum Polls_Entryreference_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollsEntryreferencePkey = 'polls_entryreference_pkey'
}

/** input type for incrementing numeric columns in table "polls_entryreference" */
export type Polls_Entryreference_Inc_Input = {
  base_source_id?: InputMaybe<Scalars['Int']>;
  entry_id?: InputMaybe<Scalars['Int']>;
  expert_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  priority?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_entryreference" */
export type Polls_Entryreference_Insert_Input = {
  base_source_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  entry_id?: InputMaybe<Scalars['Int']>;
  expert_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  priority?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Polls_Entryreference_Max_Fields = {
  __typename?: 'polls_entryreference_max_fields';
  base_source_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  entry_id?: Maybe<Scalars['Int']>;
  expert_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  priority?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Polls_Entryreference_Min_Fields = {
  __typename?: 'polls_entryreference_min_fields';
  base_source_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  entry_id?: Maybe<Scalars['Int']>;
  expert_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  priority?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "polls_entryreference" */
export type Polls_Entryreference_Mutation_Response = {
  __typename?: 'polls_entryreference_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Entryreference>;
};

/** on_conflict condition type for table "polls_entryreference" */
export type Polls_Entryreference_On_Conflict = {
  constraint: Polls_Entryreference_Constraint;
  update_columns?: Array<Polls_Entryreference_Update_Column>;
  where?: InputMaybe<Polls_Entryreference_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_entryreference". */
export type Polls_Entryreference_Order_By = {
  base_source_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  expert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_entryreference */
export type Polls_Entryreference_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_entryreference" */
export enum Polls_Entryreference_Select_Column {
  /** column name */
  BaseSourceId = 'base_source_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  ExpertId = 'expert_id',
  /** column name */
  Id = 'id',
  /** column name */
  Priority = 'priority'
}

/** input type for updating data in table "polls_entryreference" */
export type Polls_Entryreference_Set_Input = {
  base_source_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  entry_id?: InputMaybe<Scalars['Int']>;
  expert_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  priority?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Polls_Entryreference_Stddev_Fields = {
  __typename?: 'polls_entryreference_stddev_fields';
  base_source_id?: Maybe<Scalars['Float']>;
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Polls_Entryreference_Stddev_Pop_Fields = {
  __typename?: 'polls_entryreference_stddev_pop_fields';
  base_source_id?: Maybe<Scalars['Float']>;
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Polls_Entryreference_Stddev_Samp_Fields = {
  __typename?: 'polls_entryreference_stddev_samp_fields';
  base_source_id?: Maybe<Scalars['Float']>;
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Polls_Entryreference_Sum_Fields = {
  __typename?: 'polls_entryreference_sum_fields';
  base_source_id?: Maybe<Scalars['Int']>;
  entry_id?: Maybe<Scalars['Int']>;
  expert_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  priority?: Maybe<Scalars['Int']>;
};

/** update columns of table "polls_entryreference" */
export enum Polls_Entryreference_Update_Column {
  /** column name */
  BaseSourceId = 'base_source_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  ExpertId = 'expert_id',
  /** column name */
  Id = 'id',
  /** column name */
  Priority = 'priority'
}

/** aggregate var_pop on columns */
export type Polls_Entryreference_Var_Pop_Fields = {
  __typename?: 'polls_entryreference_var_pop_fields';
  base_source_id?: Maybe<Scalars['Float']>;
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Polls_Entryreference_Var_Samp_Fields = {
  __typename?: 'polls_entryreference_var_samp_fields';
  base_source_id?: Maybe<Scalars['Float']>;
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Polls_Entryreference_Variance_Fields = {
  __typename?: 'polls_entryreference_variance_fields';
  base_source_id?: Maybe<Scalars['Float']>;
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "polls_entrytaggroup" */
export type Polls_Entrytaggroup = {
  __typename?: 'polls_entrytaggroup';
  created_by_id: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  /** An array relationship */
  tags: Array<Polls_Entitytag>;
  /** An aggregate relationship */
  tags_aggregate: Polls_Entitytag_Aggregate;
};


/** columns and relationships of "polls_entrytaggroup" */
export type Polls_EntrytaggroupTagsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entitytag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entitytag_Order_By>>;
  where?: InputMaybe<Polls_Entitytag_Bool_Exp>;
};


/** columns and relationships of "polls_entrytaggroup" */
export type Polls_EntrytaggroupTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entitytag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entitytag_Order_By>>;
  where?: InputMaybe<Polls_Entitytag_Bool_Exp>;
};

/** aggregated selection of "polls_entrytaggroup" */
export type Polls_Entrytaggroup_Aggregate = {
  __typename?: 'polls_entrytaggroup_aggregate';
  aggregate?: Maybe<Polls_Entrytaggroup_Aggregate_Fields>;
  nodes: Array<Polls_Entrytaggroup>;
};

/** aggregate fields of "polls_entrytaggroup" */
export type Polls_Entrytaggroup_Aggregate_Fields = {
  __typename?: 'polls_entrytaggroup_aggregate_fields';
  avg?: Maybe<Polls_Entrytaggroup_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Entrytaggroup_Max_Fields>;
  min?: Maybe<Polls_Entrytaggroup_Min_Fields>;
  stddev?: Maybe<Polls_Entrytaggroup_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Entrytaggroup_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Entrytaggroup_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Entrytaggroup_Sum_Fields>;
  var_pop?: Maybe<Polls_Entrytaggroup_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Entrytaggroup_Var_Samp_Fields>;
  variance?: Maybe<Polls_Entrytaggroup_Variance_Fields>;
};


/** aggregate fields of "polls_entrytaggroup" */
export type Polls_Entrytaggroup_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Entrytaggroup_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Polls_Entrytaggroup_Avg_Fields = {
  __typename?: 'polls_entrytaggroup_avg_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "polls_entrytaggroup". All fields are combined with a logical 'AND'. */
export type Polls_Entrytaggroup_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Entrytaggroup_Bool_Exp>>;
  _not?: InputMaybe<Polls_Entrytaggroup_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Entrytaggroup_Bool_Exp>>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  name_en?: InputMaybe<String_Comparison_Exp>;
  name_es?: InputMaybe<String_Comparison_Exp>;
  name_fr?: InputMaybe<String_Comparison_Exp>;
  name_ja?: InputMaybe<String_Comparison_Exp>;
  name_zh_hans?: InputMaybe<String_Comparison_Exp>;
  name_zh_hant?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  tags?: InputMaybe<Polls_Entitytag_Bool_Exp>;
};

/** unique or primary key constraints on table "polls_entrytaggroup" */
export enum Polls_Entrytaggroup_Constraint {
  /** unique or primary key constraint on columns "name" */
  PollsEntrytaggroupNameA4ed836aUniq = 'polls_entrytaggroup_name_a4ed836a_uniq',
  /** unique or primary key constraint on columns "name_en" */
  PollsEntrytaggroupNameEnFddbbd18Uniq = 'polls_entrytaggroup_name_en_fddbbd18_uniq',
  /** unique or primary key constraint on columns "name_es" */
  PollsEntrytaggroupNameEsKey = 'polls_entrytaggroup_name_es_key',
  /** unique or primary key constraint on columns "name_fr" */
  PollsEntrytaggroupNameFrAdd0677dUniq = 'polls_entrytaggroup_name_fr_add0677d_uniq',
  /** unique or primary key constraint on columns "name_ja" */
  PollsEntrytaggroupNameJa_5e8e657fUniq = 'polls_entrytaggroup_name_ja_5e8e657f_uniq',
  /** unique or primary key constraint on columns "name_zh_hans" */
  PollsEntrytaggroupNameZhHansEe6ed9f8Uniq = 'polls_entrytaggroup_name_zh_hans_ee6ed9f8_uniq',
  /** unique or primary key constraint on columns "name_zh_hant" */
  PollsEntrytaggroupNameZhHant_198e91d6Uniq = 'polls_entrytaggroup_name_zh_hant_198e91d6_uniq',
  /** unique or primary key constraint on columns "id" */
  PollsEntrytaggroupPkey = 'polls_entrytaggroup_pkey'
}

/** input type for incrementing numeric columns in table "polls_entrytaggroup" */
export type Polls_Entrytaggroup_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_entrytaggroup" */
export type Polls_Entrytaggroup_Insert_Input = {
  created_by_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Polls_Entitytag_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Polls_Entrytaggroup_Max_Fields = {
  __typename?: 'polls_entrytaggroup_max_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Polls_Entrytaggroup_Min_Fields = {
  __typename?: 'polls_entrytaggroup_min_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "polls_entrytaggroup" */
export type Polls_Entrytaggroup_Mutation_Response = {
  __typename?: 'polls_entrytaggroup_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Entrytaggroup>;
};

/** input type for inserting object relation for remote table "polls_entrytaggroup" */
export type Polls_Entrytaggroup_Obj_Rel_Insert_Input = {
  data: Polls_Entrytaggroup_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Entrytaggroup_On_Conflict>;
};

/** on_conflict condition type for table "polls_entrytaggroup" */
export type Polls_Entrytaggroup_On_Conflict = {
  constraint: Polls_Entrytaggroup_Constraint;
  update_columns?: Array<Polls_Entrytaggroup_Update_Column>;
  where?: InputMaybe<Polls_Entrytaggroup_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_entrytaggroup". */
export type Polls_Entrytaggroup_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  tags_aggregate?: InputMaybe<Polls_Entitytag_Aggregate_Order_By>;
};

/** primary key columns input for table: polls_entrytaggroup */
export type Polls_Entrytaggroup_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_entrytaggroup" */
export enum Polls_Entrytaggroup_Select_Column {
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant',
  /** column name */
  Order = 'order'
}

/** input type for updating data in table "polls_entrytaggroup" */
export type Polls_Entrytaggroup_Set_Input = {
  created_by_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Polls_Entrytaggroup_Stddev_Fields = {
  __typename?: 'polls_entrytaggroup_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Polls_Entrytaggroup_Stddev_Pop_Fields = {
  __typename?: 'polls_entrytaggroup_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Polls_Entrytaggroup_Stddev_Samp_Fields = {
  __typename?: 'polls_entrytaggroup_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Polls_Entrytaggroup_Sum_Fields = {
  __typename?: 'polls_entrytaggroup_sum_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
};

/** update columns of table "polls_entrytaggroup" */
export enum Polls_Entrytaggroup_Update_Column {
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant',
  /** column name */
  Order = 'order'
}

/** aggregate var_pop on columns */
export type Polls_Entrytaggroup_Var_Pop_Fields = {
  __typename?: 'polls_entrytaggroup_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Polls_Entrytaggroup_Var_Samp_Fields = {
  __typename?: 'polls_entrytaggroup_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Polls_Entrytaggroup_Variance_Fields = {
  __typename?: 'polls_entrytaggroup_variance_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "polls_group" */
export type Polls_Group = {
  __typename?: 'polls_group';
  /** A computed field, executes function "get_group_ancestors" */
  ancestors?: Maybe<Array<Polls_Group>>;
  category_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  groups: Array<Polls_Group>;
  /** An aggregate relationship */
  groups_aggregate: Polls_Group_Aggregate;
  id: Scalars['Int'];
  name: Scalars['String'];
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  /** An object relationship */
  parent_group?: Maybe<Polls_Group>;
  parent_id?: Maybe<Scalars['Int']>;
  poll_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  previous?: Maybe<Polls_Group>;
  previous_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  questions: Array<Polls_Question>;
  /** An aggregate relationship */
  questions_aggregate: Polls_Question_Aggregate;
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
  translated_name?: Maybe<Scalars['String']>;
  translation_progress?: Maybe<Scalars['json']>;
};


/** columns and relationships of "polls_group" */
export type Polls_GroupAncestorsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Group_Order_By>>;
  where?: InputMaybe<Polls_Group_Bool_Exp>;
};


/** columns and relationships of "polls_group" */
export type Polls_GroupGroupsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Group_Order_By>>;
  where?: InputMaybe<Polls_Group_Bool_Exp>;
};


/** columns and relationships of "polls_group" */
export type Polls_GroupGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Group_Order_By>>;
  where?: InputMaybe<Polls_Group_Bool_Exp>;
};


/** columns and relationships of "polls_group" */
export type Polls_GroupQuestionsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Question_Order_By>>;
  where?: InputMaybe<Polls_Question_Bool_Exp>;
};


/** columns and relationships of "polls_group" */
export type Polls_GroupQuestions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Question_Order_By>>;
  where?: InputMaybe<Polls_Question_Bool_Exp>;
};


/** columns and relationships of "polls_group" */
export type Polls_GroupTranslated_NameArgs = {
  args: Translated_Name_Polls_Group_Args;
};


/** columns and relationships of "polls_group" */
export type Polls_GroupTranslation_ProgressArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "polls_group" */
export type Polls_Group_Aggregate = {
  __typename?: 'polls_group_aggregate';
  aggregate?: Maybe<Polls_Group_Aggregate_Fields>;
  nodes: Array<Polls_Group>;
};

/** aggregate fields of "polls_group" */
export type Polls_Group_Aggregate_Fields = {
  __typename?: 'polls_group_aggregate_fields';
  avg?: Maybe<Polls_Group_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Group_Max_Fields>;
  min?: Maybe<Polls_Group_Min_Fields>;
  stddev?: Maybe<Polls_Group_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Group_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Group_Sum_Fields>;
  var_pop?: Maybe<Polls_Group_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Group_Var_Samp_Fields>;
  variance?: Maybe<Polls_Group_Variance_Fields>;
};


/** aggregate fields of "polls_group" */
export type Polls_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "polls_group" */
export type Polls_Group_Aggregate_Order_By = {
  avg?: InputMaybe<Polls_Group_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Polls_Group_Max_Order_By>;
  min?: InputMaybe<Polls_Group_Min_Order_By>;
  stddev?: InputMaybe<Polls_Group_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Polls_Group_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Polls_Group_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Polls_Group_Sum_Order_By>;
  var_pop?: InputMaybe<Polls_Group_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Polls_Group_Var_Samp_Order_By>;
  variance?: InputMaybe<Polls_Group_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "polls_group" */
export type Polls_Group_Arr_Rel_Insert_Input = {
  data: Array<Polls_Group_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Group_On_Conflict>;
};

/** aggregate avg on columns */
export type Polls_Group_Avg_Fields = {
  __typename?: 'polls_group_avg_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  parent_id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "polls_group" */
export type Polls_Group_Avg_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "polls_group". All fields are combined with a logical 'AND'. */
export type Polls_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Group_Bool_Exp>>;
  _not?: InputMaybe<Polls_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Group_Bool_Exp>>;
  ancestors?: InputMaybe<Polls_Group_Bool_Exp>;
  category_id?: InputMaybe<Int_Comparison_Exp>;
  groups?: InputMaybe<Polls_Group_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  name_en?: InputMaybe<String_Comparison_Exp>;
  name_es?: InputMaybe<String_Comparison_Exp>;
  name_fr?: InputMaybe<String_Comparison_Exp>;
  name_ja?: InputMaybe<String_Comparison_Exp>;
  name_zh_hans?: InputMaybe<String_Comparison_Exp>;
  name_zh_hant?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  parent_group?: InputMaybe<Polls_Group_Bool_Exp>;
  parent_id?: InputMaybe<Int_Comparison_Exp>;
  poll_id?: InputMaybe<Int_Comparison_Exp>;
  previous?: InputMaybe<Polls_Group_Bool_Exp>;
  previous_id?: InputMaybe<Int_Comparison_Exp>;
  questions?: InputMaybe<Polls_Question_Bool_Exp>;
  tooltip?: InputMaybe<String_Comparison_Exp>;
  tooltip_en?: InputMaybe<String_Comparison_Exp>;
  tooltip_es?: InputMaybe<String_Comparison_Exp>;
  tooltip_fr?: InputMaybe<String_Comparison_Exp>;
  tooltip_ja?: InputMaybe<String_Comparison_Exp>;
  tooltip_zh_hans?: InputMaybe<String_Comparison_Exp>;
  tooltip_zh_hant?: InputMaybe<String_Comparison_Exp>;
  translation_progress?: InputMaybe<Json_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_group" */
export enum Polls_Group_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollsGroupPkey = 'polls_group_pkey'
}

/** input type for incrementing numeric columns in table "polls_group" */
export type Polls_Group_Inc_Input = {
  category_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  parent_id?: InputMaybe<Scalars['Int']>;
  poll_id?: InputMaybe<Scalars['Int']>;
  previous_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_group" */
export type Polls_Group_Insert_Input = {
  category_id?: InputMaybe<Scalars['Int']>;
  groups?: InputMaybe<Polls_Group_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parent_group?: InputMaybe<Polls_Group_Obj_Rel_Insert_Input>;
  parent_id?: InputMaybe<Scalars['Int']>;
  poll_id?: InputMaybe<Scalars['Int']>;
  previous?: InputMaybe<Polls_Group_Obj_Rel_Insert_Input>;
  previous_id?: InputMaybe<Scalars['Int']>;
  questions?: InputMaybe<Polls_Question_Arr_Rel_Insert_Input>;
  tooltip?: InputMaybe<Scalars['String']>;
  tooltip_en?: InputMaybe<Scalars['String']>;
  tooltip_es?: InputMaybe<Scalars['String']>;
  tooltip_fr?: InputMaybe<Scalars['String']>;
  tooltip_ja?: InputMaybe<Scalars['String']>;
  tooltip_zh_hans?: InputMaybe<Scalars['String']>;
  tooltip_zh_hant?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Polls_Group_Max_Fields = {
  __typename?: 'polls_group_max_fields';
  category_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  parent_id?: Maybe<Scalars['Int']>;
  poll_id?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "polls_group" */
export type Polls_Group_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  tooltip?: InputMaybe<Order_By>;
  tooltip_en?: InputMaybe<Order_By>;
  tooltip_es?: InputMaybe<Order_By>;
  tooltip_fr?: InputMaybe<Order_By>;
  tooltip_ja?: InputMaybe<Order_By>;
  tooltip_zh_hans?: InputMaybe<Order_By>;
  tooltip_zh_hant?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Polls_Group_Min_Fields = {
  __typename?: 'polls_group_min_fields';
  category_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  parent_id?: Maybe<Scalars['Int']>;
  poll_id?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "polls_group" */
export type Polls_Group_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  tooltip?: InputMaybe<Order_By>;
  tooltip_en?: InputMaybe<Order_By>;
  tooltip_es?: InputMaybe<Order_By>;
  tooltip_fr?: InputMaybe<Order_By>;
  tooltip_ja?: InputMaybe<Order_By>;
  tooltip_zh_hans?: InputMaybe<Order_By>;
  tooltip_zh_hant?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "polls_group" */
export type Polls_Group_Mutation_Response = {
  __typename?: 'polls_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Group>;
};

/** input type for inserting object relation for remote table "polls_group" */
export type Polls_Group_Obj_Rel_Insert_Input = {
  data: Polls_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Group_On_Conflict>;
};

/** on_conflict condition type for table "polls_group" */
export type Polls_Group_On_Conflict = {
  constraint: Polls_Group_Constraint;
  update_columns?: Array<Polls_Group_Update_Column>;
  where?: InputMaybe<Polls_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_group". */
export type Polls_Group_Order_By = {
  ancestors_aggregate?: InputMaybe<Polls_Group_Aggregate_Order_By>;
  category_id?: InputMaybe<Order_By>;
  groups_aggregate?: InputMaybe<Polls_Group_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_group?: InputMaybe<Polls_Group_Order_By>;
  parent_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous?: InputMaybe<Polls_Group_Order_By>;
  previous_id?: InputMaybe<Order_By>;
  questions_aggregate?: InputMaybe<Polls_Question_Aggregate_Order_By>;
  tooltip?: InputMaybe<Order_By>;
  tooltip_en?: InputMaybe<Order_By>;
  tooltip_es?: InputMaybe<Order_By>;
  tooltip_fr?: InputMaybe<Order_By>;
  tooltip_ja?: InputMaybe<Order_By>;
  tooltip_zh_hans?: InputMaybe<Order_By>;
  tooltip_zh_hant?: InputMaybe<Order_By>;
  translation_progress?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_group */
export type Polls_Group_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_group" */
export enum Polls_Group_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant',
  /** column name */
  Order = 'order',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  PollId = 'poll_id',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  Tooltip = 'tooltip',
  /** column name */
  TooltipEn = 'tooltip_en',
  /** column name */
  TooltipEs = 'tooltip_es',
  /** column name */
  TooltipFr = 'tooltip_fr',
  /** column name */
  TooltipJa = 'tooltip_ja',
  /** column name */
  TooltipZhHans = 'tooltip_zh_hans',
  /** column name */
  TooltipZhHant = 'tooltip_zh_hant'
}

/** input type for updating data in table "polls_group" */
export type Polls_Group_Set_Input = {
  category_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parent_id?: InputMaybe<Scalars['Int']>;
  poll_id?: InputMaybe<Scalars['Int']>;
  previous_id?: InputMaybe<Scalars['Int']>;
  tooltip?: InputMaybe<Scalars['String']>;
  tooltip_en?: InputMaybe<Scalars['String']>;
  tooltip_es?: InputMaybe<Scalars['String']>;
  tooltip_fr?: InputMaybe<Scalars['String']>;
  tooltip_ja?: InputMaybe<Scalars['String']>;
  tooltip_zh_hans?: InputMaybe<Scalars['String']>;
  tooltip_zh_hant?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Polls_Group_Stddev_Fields = {
  __typename?: 'polls_group_stddev_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  parent_id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "polls_group" */
export type Polls_Group_Stddev_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Polls_Group_Stddev_Pop_Fields = {
  __typename?: 'polls_group_stddev_pop_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  parent_id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "polls_group" */
export type Polls_Group_Stddev_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Polls_Group_Stddev_Samp_Fields = {
  __typename?: 'polls_group_stddev_samp_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  parent_id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "polls_group" */
export type Polls_Group_Stddev_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Polls_Group_Sum_Fields = {
  __typename?: 'polls_group_sum_fields';
  category_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  parent_id?: Maybe<Scalars['Int']>;
  poll_id?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "polls_group" */
export type Polls_Group_Sum_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** update columns of table "polls_group" */
export enum Polls_Group_Update_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant',
  /** column name */
  Order = 'order',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  PollId = 'poll_id',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  Tooltip = 'tooltip',
  /** column name */
  TooltipEn = 'tooltip_en',
  /** column name */
  TooltipEs = 'tooltip_es',
  /** column name */
  TooltipFr = 'tooltip_fr',
  /** column name */
  TooltipJa = 'tooltip_ja',
  /** column name */
  TooltipZhHans = 'tooltip_zh_hans',
  /** column name */
  TooltipZhHant = 'tooltip_zh_hant'
}

/** aggregate var_pop on columns */
export type Polls_Group_Var_Pop_Fields = {
  __typename?: 'polls_group_var_pop_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  parent_id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "polls_group" */
export type Polls_Group_Var_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Polls_Group_Var_Samp_Fields = {
  __typename?: 'polls_group_var_samp_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  parent_id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "polls_group" */
export type Polls_Group_Var_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Polls_Group_Variance_Fields = {
  __typename?: 'polls_group_variance_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  parent_id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "polls_group" */
export type Polls_Group_Variance_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "polls_poll" */
export type Polls_Poll = {
  __typename?: 'polls_poll';
  /** An array relationship */
  branching_questions: Array<Polls_Branchingquestion>;
  /** An aggregate relationship */
  branching_questions_aggregate: Polls_Branchingquestion_Aggregate;
  /** An array relationship */
  categories: Array<Polls_Category>;
  /** An aggregate relationship */
  categories_aggregate: Polls_Category_Aggregate;
  /** An object relationship */
  created_by: Auth_User;
  created_by_id: Scalars['Int'];
  date_created: Scalars['timestamptz'];
  date_modified: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  description_en?: Maybe<Scalars['String']>;
  description_es?: Maybe<Scalars['String']>;
  description_fr?: Maybe<Scalars['String']>;
  description_ja?: Maybe<Scalars['String']>;
  description_zh_hans?: Maybe<Scalars['String']>;
  description_zh_hant?: Maybe<Scalars['String']>;
  /** An array relationship */
  entries: Array<Polls_Entity>;
  /** An aggregate relationship */
  entries_aggregate: Polls_Entity_Aggregate;
  id: Scalars['Int'];
  is_disabled: Scalars['Boolean'];
  is_external: Scalars['Boolean'];
  name: Scalars['String'];
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  /** An object relationship */
  next?: Maybe<Polls_Poll>;
  /** An object relationship */
  next_draft?: Maybe<Poll_Drafts>;
  /** An array relationship */
  optional_entry_tag_groups: Array<Polls_Poll_Optional_Entry_Tag_Groups>;
  /** An aggregate relationship */
  optional_entry_tag_groups_aggregate: Polls_Poll_Optional_Entry_Tag_Groups_Aggregate;
  /** An object relationship */
  previous?: Maybe<Polls_Poll>;
  previous_id?: Maybe<Scalars['Int']>;
  primary_language: Scalars['String'];
  published?: Maybe<Scalars['Boolean']>;
  release_notes?: Maybe<Scalars['String']>;
  /** An array relationship */
  required_entry_tag_groups: Array<Polls_Poll_Required_Entry_Tag_Groups>;
  /** An aggregate relationship */
  required_entry_tag_groups_aggregate: Polls_Poll_Required_Entry_Tag_Groups_Aggregate;
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
  translated_description?: Maybe<Scalars['String']>;
  translated_name?: Maybe<Scalars['String']>;
  translation_progress?: Maybe<Scalars['json']>;
  type: Scalars['String'];
};


/** columns and relationships of "polls_poll" */
export type Polls_PollBranching_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Branchingquestion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Branchingquestion_Order_By>>;
  where?: InputMaybe<Polls_Branchingquestion_Bool_Exp>;
};


/** columns and relationships of "polls_poll" */
export type Polls_PollBranching_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Branchingquestion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Branchingquestion_Order_By>>;
  where?: InputMaybe<Polls_Branchingquestion_Bool_Exp>;
};


/** columns and relationships of "polls_poll" */
export type Polls_PollCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Polls_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Category_Order_By>>;
  where?: InputMaybe<Polls_Category_Bool_Exp>;
};


/** columns and relationships of "polls_poll" */
export type Polls_PollCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Category_Order_By>>;
  where?: InputMaybe<Polls_Category_Bool_Exp>;
};


/** columns and relationships of "polls_poll" */
export type Polls_PollEntriesArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Order_By>>;
  where?: InputMaybe<Polls_Entity_Bool_Exp>;
};


/** columns and relationships of "polls_poll" */
export type Polls_PollEntries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Order_By>>;
  where?: InputMaybe<Polls_Entity_Bool_Exp>;
};


/** columns and relationships of "polls_poll" */
export type Polls_PollOptional_Entry_Tag_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Poll_Optional_Entry_Tag_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Poll_Optional_Entry_Tag_Groups_Order_By>>;
  where?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_Bool_Exp>;
};


/** columns and relationships of "polls_poll" */
export type Polls_PollOptional_Entry_Tag_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Poll_Optional_Entry_Tag_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Poll_Optional_Entry_Tag_Groups_Order_By>>;
  where?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_Bool_Exp>;
};


/** columns and relationships of "polls_poll" */
export type Polls_PollRequired_Entry_Tag_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Poll_Required_Entry_Tag_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Poll_Required_Entry_Tag_Groups_Order_By>>;
  where?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_Bool_Exp>;
};


/** columns and relationships of "polls_poll" */
export type Polls_PollRequired_Entry_Tag_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Poll_Required_Entry_Tag_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Poll_Required_Entry_Tag_Groups_Order_By>>;
  where?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_Bool_Exp>;
};


/** columns and relationships of "polls_poll" */
export type Polls_PollTranslated_DescriptionArgs = {
  args: Translated_Description_Polls_Poll_Args;
};


/** columns and relationships of "polls_poll" */
export type Polls_PollTranslated_NameArgs = {
  args: Translated_Name_Polls_Poll_Args;
};


/** columns and relationships of "polls_poll" */
export type Polls_PollTranslation_ProgressArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "polls_poll" */
export type Polls_Poll_Aggregate = {
  __typename?: 'polls_poll_aggregate';
  aggregate?: Maybe<Polls_Poll_Aggregate_Fields>;
  nodes: Array<Polls_Poll>;
};

/** aggregate fields of "polls_poll" */
export type Polls_Poll_Aggregate_Fields = {
  __typename?: 'polls_poll_aggregate_fields';
  avg?: Maybe<Polls_Poll_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Poll_Max_Fields>;
  min?: Maybe<Polls_Poll_Min_Fields>;
  stddev?: Maybe<Polls_Poll_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Poll_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Poll_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Poll_Sum_Fields>;
  var_pop?: Maybe<Polls_Poll_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Poll_Var_Samp_Fields>;
  variance?: Maybe<Polls_Poll_Variance_Fields>;
};


/** aggregate fields of "polls_poll" */
export type Polls_Poll_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Poll_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Polls_Poll_Avg_Fields = {
  __typename?: 'polls_poll_avg_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "polls_poll". All fields are combined with a logical 'AND'. */
export type Polls_Poll_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Poll_Bool_Exp>>;
  _not?: InputMaybe<Polls_Poll_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Poll_Bool_Exp>>;
  branching_questions?: InputMaybe<Polls_Branchingquestion_Bool_Exp>;
  categories?: InputMaybe<Polls_Category_Bool_Exp>;
  created_by?: InputMaybe<Auth_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  date_created?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  description_en?: InputMaybe<String_Comparison_Exp>;
  description_es?: InputMaybe<String_Comparison_Exp>;
  description_fr?: InputMaybe<String_Comparison_Exp>;
  description_ja?: InputMaybe<String_Comparison_Exp>;
  description_zh_hans?: InputMaybe<String_Comparison_Exp>;
  description_zh_hant?: InputMaybe<String_Comparison_Exp>;
  entries?: InputMaybe<Polls_Entity_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_disabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_external?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  name_en?: InputMaybe<String_Comparison_Exp>;
  name_es?: InputMaybe<String_Comparison_Exp>;
  name_fr?: InputMaybe<String_Comparison_Exp>;
  name_ja?: InputMaybe<String_Comparison_Exp>;
  name_zh_hans?: InputMaybe<String_Comparison_Exp>;
  name_zh_hant?: InputMaybe<String_Comparison_Exp>;
  next?: InputMaybe<Polls_Poll_Bool_Exp>;
  next_draft?: InputMaybe<Poll_Drafts_Bool_Exp>;
  optional_entry_tag_groups?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_Bool_Exp>;
  previous?: InputMaybe<Polls_Poll_Bool_Exp>;
  previous_id?: InputMaybe<Int_Comparison_Exp>;
  primary_language?: InputMaybe<String_Comparison_Exp>;
  published?: InputMaybe<Boolean_Comparison_Exp>;
  release_notes?: InputMaybe<String_Comparison_Exp>;
  required_entry_tag_groups?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_Bool_Exp>;
  tooltip?: InputMaybe<String_Comparison_Exp>;
  tooltip_en?: InputMaybe<String_Comparison_Exp>;
  tooltip_es?: InputMaybe<String_Comparison_Exp>;
  tooltip_fr?: InputMaybe<String_Comparison_Exp>;
  tooltip_ja?: InputMaybe<String_Comparison_Exp>;
  tooltip_zh_hans?: InputMaybe<String_Comparison_Exp>;
  tooltip_zh_hant?: InputMaybe<String_Comparison_Exp>;
  translation_progress?: InputMaybe<Json_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_poll" */
export enum Polls_Poll_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollsPollPkey = 'polls_poll_pkey'
}

/** input type for incrementing numeric columns in table "polls_poll" */
export type Polls_Poll_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  previous_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_poll" */
export type Polls_Poll_Insert_Input = {
  branching_questions?: InputMaybe<Polls_Branchingquestion_Arr_Rel_Insert_Input>;
  categories?: InputMaybe<Polls_Category_Arr_Rel_Insert_Input>;
  created_by?: InputMaybe<Auth_User_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_modified?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  description_en?: InputMaybe<Scalars['String']>;
  description_es?: InputMaybe<Scalars['String']>;
  description_fr?: InputMaybe<Scalars['String']>;
  description_ja?: InputMaybe<Scalars['String']>;
  description_zh_hans?: InputMaybe<Scalars['String']>;
  description_zh_hant?: InputMaybe<Scalars['String']>;
  entries?: InputMaybe<Polls_Entity_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  is_disabled?: InputMaybe<Scalars['Boolean']>;
  is_external?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
  next?: InputMaybe<Polls_Poll_Obj_Rel_Insert_Input>;
  next_draft?: InputMaybe<Poll_Drafts_Obj_Rel_Insert_Input>;
  optional_entry_tag_groups?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_Arr_Rel_Insert_Input>;
  previous?: InputMaybe<Polls_Poll_Obj_Rel_Insert_Input>;
  previous_id?: InputMaybe<Scalars['Int']>;
  primary_language?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  release_notes?: InputMaybe<Scalars['String']>;
  required_entry_tag_groups?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_Arr_Rel_Insert_Input>;
  tooltip?: InputMaybe<Scalars['String']>;
  tooltip_en?: InputMaybe<Scalars['String']>;
  tooltip_es?: InputMaybe<Scalars['String']>;
  tooltip_fr?: InputMaybe<Scalars['String']>;
  tooltip_ja?: InputMaybe<Scalars['String']>;
  tooltip_zh_hans?: InputMaybe<Scalars['String']>;
  tooltip_zh_hant?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Polls_Poll_Max_Fields = {
  __typename?: 'polls_poll_max_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['timestamptz']>;
  date_modified?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  description_en?: Maybe<Scalars['String']>;
  description_es?: Maybe<Scalars['String']>;
  description_fr?: Maybe<Scalars['String']>;
  description_ja?: Maybe<Scalars['String']>;
  description_zh_hans?: Maybe<Scalars['String']>;
  description_zh_hant?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  previous_id?: Maybe<Scalars['Int']>;
  primary_language?: Maybe<Scalars['String']>;
  release_notes?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Polls_Poll_Min_Fields = {
  __typename?: 'polls_poll_min_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['timestamptz']>;
  date_modified?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  description_en?: Maybe<Scalars['String']>;
  description_es?: Maybe<Scalars['String']>;
  description_fr?: Maybe<Scalars['String']>;
  description_ja?: Maybe<Scalars['String']>;
  description_zh_hans?: Maybe<Scalars['String']>;
  description_zh_hant?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  previous_id?: Maybe<Scalars['Int']>;
  primary_language?: Maybe<Scalars['String']>;
  release_notes?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "polls_poll" */
export type Polls_Poll_Mutation_Response = {
  __typename?: 'polls_poll_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Poll>;
};

/** input type for inserting object relation for remote table "polls_poll" */
export type Polls_Poll_Obj_Rel_Insert_Input = {
  data: Polls_Poll_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Poll_On_Conflict>;
};

/** on_conflict condition type for table "polls_poll" */
export type Polls_Poll_On_Conflict = {
  constraint: Polls_Poll_Constraint;
  update_columns?: Array<Polls_Poll_Update_Column>;
  where?: InputMaybe<Polls_Poll_Bool_Exp>;
};

/** columns and relationships of "polls_poll_optional_entry_tag_groups" */
export type Polls_Poll_Optional_Entry_Tag_Groups = {
  __typename?: 'polls_poll_optional_entry_tag_groups';
  entrytaggroup_id: Scalars['Int'];
  id: Scalars['Int'];
  poll_id: Scalars['Int'];
};

/** aggregated selection of "polls_poll_optional_entry_tag_groups" */
export type Polls_Poll_Optional_Entry_Tag_Groups_Aggregate = {
  __typename?: 'polls_poll_optional_entry_tag_groups_aggregate';
  aggregate?: Maybe<Polls_Poll_Optional_Entry_Tag_Groups_Aggregate_Fields>;
  nodes: Array<Polls_Poll_Optional_Entry_Tag_Groups>;
};

/** aggregate fields of "polls_poll_optional_entry_tag_groups" */
export type Polls_Poll_Optional_Entry_Tag_Groups_Aggregate_Fields = {
  __typename?: 'polls_poll_optional_entry_tag_groups_aggregate_fields';
  avg?: Maybe<Polls_Poll_Optional_Entry_Tag_Groups_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Poll_Optional_Entry_Tag_Groups_Max_Fields>;
  min?: Maybe<Polls_Poll_Optional_Entry_Tag_Groups_Min_Fields>;
  stddev?: Maybe<Polls_Poll_Optional_Entry_Tag_Groups_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Poll_Optional_Entry_Tag_Groups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Poll_Optional_Entry_Tag_Groups_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Poll_Optional_Entry_Tag_Groups_Sum_Fields>;
  var_pop?: Maybe<Polls_Poll_Optional_Entry_Tag_Groups_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Poll_Optional_Entry_Tag_Groups_Var_Samp_Fields>;
  variance?: Maybe<Polls_Poll_Optional_Entry_Tag_Groups_Variance_Fields>;
};


/** aggregate fields of "polls_poll_optional_entry_tag_groups" */
export type Polls_Poll_Optional_Entry_Tag_Groups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Poll_Optional_Entry_Tag_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "polls_poll_optional_entry_tag_groups" */
export type Polls_Poll_Optional_Entry_Tag_Groups_Aggregate_Order_By = {
  avg?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_Max_Order_By>;
  min?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_Min_Order_By>;
  stddev?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_Sum_Order_By>;
  var_pop?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_Var_Samp_Order_By>;
  variance?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "polls_poll_optional_entry_tag_groups" */
export type Polls_Poll_Optional_Entry_Tag_Groups_Arr_Rel_Insert_Input = {
  data: Array<Polls_Poll_Optional_Entry_Tag_Groups_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_On_Conflict>;
};

/** aggregate avg on columns */
export type Polls_Poll_Optional_Entry_Tag_Groups_Avg_Fields = {
  __typename?: 'polls_poll_optional_entry_tag_groups_avg_fields';
  entrytaggroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "polls_poll_optional_entry_tag_groups" */
export type Polls_Poll_Optional_Entry_Tag_Groups_Avg_Order_By = {
  entrytaggroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "polls_poll_optional_entry_tag_groups". All fields are combined with a logical 'AND'. */
export type Polls_Poll_Optional_Entry_Tag_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Poll_Optional_Entry_Tag_Groups_Bool_Exp>>;
  _not?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Poll_Optional_Entry_Tag_Groups_Bool_Exp>>;
  entrytaggroup_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  poll_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_poll_optional_entry_tag_groups" */
export enum Polls_Poll_Optional_Entry_Tag_Groups_Constraint {
  /** unique or primary key constraint on columns "poll_id", "entrytaggroup_id" */
  PollsPollOptionalEntrPollIdEntrytaggroupIdF59111afUniq = 'polls_poll_optional_entr_poll_id_entrytaggroup_id_f59111af_uniq',
  /** unique or primary key constraint on columns "id" */
  PollsPollOptionalEntryTagGroupsPkey = 'polls_poll_optional_entry_tag_groups_pkey'
}

/** input type for incrementing numeric columns in table "polls_poll_optional_entry_tag_groups" */
export type Polls_Poll_Optional_Entry_Tag_Groups_Inc_Input = {
  entrytaggroup_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  poll_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_poll_optional_entry_tag_groups" */
export type Polls_Poll_Optional_Entry_Tag_Groups_Insert_Input = {
  entrytaggroup_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  poll_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Polls_Poll_Optional_Entry_Tag_Groups_Max_Fields = {
  __typename?: 'polls_poll_optional_entry_tag_groups_max_fields';
  entrytaggroup_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  poll_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "polls_poll_optional_entry_tag_groups" */
export type Polls_Poll_Optional_Entry_Tag_Groups_Max_Order_By = {
  entrytaggroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Polls_Poll_Optional_Entry_Tag_Groups_Min_Fields = {
  __typename?: 'polls_poll_optional_entry_tag_groups_min_fields';
  entrytaggroup_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  poll_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "polls_poll_optional_entry_tag_groups" */
export type Polls_Poll_Optional_Entry_Tag_Groups_Min_Order_By = {
  entrytaggroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "polls_poll_optional_entry_tag_groups" */
export type Polls_Poll_Optional_Entry_Tag_Groups_Mutation_Response = {
  __typename?: 'polls_poll_optional_entry_tag_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Poll_Optional_Entry_Tag_Groups>;
};

/** on_conflict condition type for table "polls_poll_optional_entry_tag_groups" */
export type Polls_Poll_Optional_Entry_Tag_Groups_On_Conflict = {
  constraint: Polls_Poll_Optional_Entry_Tag_Groups_Constraint;
  update_columns?: Array<Polls_Poll_Optional_Entry_Tag_Groups_Update_Column>;
  where?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_poll_optional_entry_tag_groups". */
export type Polls_Poll_Optional_Entry_Tag_Groups_Order_By = {
  entrytaggroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_poll_optional_entry_tag_groups */
export type Polls_Poll_Optional_Entry_Tag_Groups_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_poll_optional_entry_tag_groups" */
export enum Polls_Poll_Optional_Entry_Tag_Groups_Select_Column {
  /** column name */
  EntrytaggroupId = 'entrytaggroup_id',
  /** column name */
  Id = 'id',
  /** column name */
  PollId = 'poll_id'
}

/** input type for updating data in table "polls_poll_optional_entry_tag_groups" */
export type Polls_Poll_Optional_Entry_Tag_Groups_Set_Input = {
  entrytaggroup_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  poll_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Polls_Poll_Optional_Entry_Tag_Groups_Stddev_Fields = {
  __typename?: 'polls_poll_optional_entry_tag_groups_stddev_fields';
  entrytaggroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "polls_poll_optional_entry_tag_groups" */
export type Polls_Poll_Optional_Entry_Tag_Groups_Stddev_Order_By = {
  entrytaggroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Polls_Poll_Optional_Entry_Tag_Groups_Stddev_Pop_Fields = {
  __typename?: 'polls_poll_optional_entry_tag_groups_stddev_pop_fields';
  entrytaggroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "polls_poll_optional_entry_tag_groups" */
export type Polls_Poll_Optional_Entry_Tag_Groups_Stddev_Pop_Order_By = {
  entrytaggroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Polls_Poll_Optional_Entry_Tag_Groups_Stddev_Samp_Fields = {
  __typename?: 'polls_poll_optional_entry_tag_groups_stddev_samp_fields';
  entrytaggroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "polls_poll_optional_entry_tag_groups" */
export type Polls_Poll_Optional_Entry_Tag_Groups_Stddev_Samp_Order_By = {
  entrytaggroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Polls_Poll_Optional_Entry_Tag_Groups_Sum_Fields = {
  __typename?: 'polls_poll_optional_entry_tag_groups_sum_fields';
  entrytaggroup_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  poll_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "polls_poll_optional_entry_tag_groups" */
export type Polls_Poll_Optional_Entry_Tag_Groups_Sum_Order_By = {
  entrytaggroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
};

/** update columns of table "polls_poll_optional_entry_tag_groups" */
export enum Polls_Poll_Optional_Entry_Tag_Groups_Update_Column {
  /** column name */
  EntrytaggroupId = 'entrytaggroup_id',
  /** column name */
  Id = 'id',
  /** column name */
  PollId = 'poll_id'
}

/** aggregate var_pop on columns */
export type Polls_Poll_Optional_Entry_Tag_Groups_Var_Pop_Fields = {
  __typename?: 'polls_poll_optional_entry_tag_groups_var_pop_fields';
  entrytaggroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "polls_poll_optional_entry_tag_groups" */
export type Polls_Poll_Optional_Entry_Tag_Groups_Var_Pop_Order_By = {
  entrytaggroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Polls_Poll_Optional_Entry_Tag_Groups_Var_Samp_Fields = {
  __typename?: 'polls_poll_optional_entry_tag_groups_var_samp_fields';
  entrytaggroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "polls_poll_optional_entry_tag_groups" */
export type Polls_Poll_Optional_Entry_Tag_Groups_Var_Samp_Order_By = {
  entrytaggroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Polls_Poll_Optional_Entry_Tag_Groups_Variance_Fields = {
  __typename?: 'polls_poll_optional_entry_tag_groups_variance_fields';
  entrytaggroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "polls_poll_optional_entry_tag_groups" */
export type Polls_Poll_Optional_Entry_Tag_Groups_Variance_Order_By = {
  entrytaggroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "polls_poll". */
export type Polls_Poll_Order_By = {
  branching_questions_aggregate?: InputMaybe<Polls_Branchingquestion_Aggregate_Order_By>;
  categories_aggregate?: InputMaybe<Polls_Category_Aggregate_Order_By>;
  created_by?: InputMaybe<Auth_User_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  date_created?: InputMaybe<Order_By>;
  date_modified?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  description_en?: InputMaybe<Order_By>;
  description_es?: InputMaybe<Order_By>;
  description_fr?: InputMaybe<Order_By>;
  description_ja?: InputMaybe<Order_By>;
  description_zh_hans?: InputMaybe<Order_By>;
  description_zh_hant?: InputMaybe<Order_By>;
  entries_aggregate?: InputMaybe<Polls_Entity_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_disabled?: InputMaybe<Order_By>;
  is_external?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  next?: InputMaybe<Polls_Poll_Order_By>;
  next_draft?: InputMaybe<Poll_Drafts_Order_By>;
  optional_entry_tag_groups_aggregate?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_Aggregate_Order_By>;
  previous?: InputMaybe<Polls_Poll_Order_By>;
  previous_id?: InputMaybe<Order_By>;
  primary_language?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  release_notes?: InputMaybe<Order_By>;
  required_entry_tag_groups_aggregate?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_Aggregate_Order_By>;
  tooltip?: InputMaybe<Order_By>;
  tooltip_en?: InputMaybe<Order_By>;
  tooltip_es?: InputMaybe<Order_By>;
  tooltip_fr?: InputMaybe<Order_By>;
  tooltip_ja?: InputMaybe<Order_By>;
  tooltip_zh_hans?: InputMaybe<Order_By>;
  tooltip_zh_hant?: InputMaybe<Order_By>;
  translation_progress?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_poll */
export type Polls_Poll_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** columns and relationships of "polls_poll_required_entry_tag_groups" */
export type Polls_Poll_Required_Entry_Tag_Groups = {
  __typename?: 'polls_poll_required_entry_tag_groups';
  entrytaggroup_id: Scalars['Int'];
  id: Scalars['Int'];
  poll_id: Scalars['Int'];
};

/** aggregated selection of "polls_poll_required_entry_tag_groups" */
export type Polls_Poll_Required_Entry_Tag_Groups_Aggregate = {
  __typename?: 'polls_poll_required_entry_tag_groups_aggregate';
  aggregate?: Maybe<Polls_Poll_Required_Entry_Tag_Groups_Aggregate_Fields>;
  nodes: Array<Polls_Poll_Required_Entry_Tag_Groups>;
};

/** aggregate fields of "polls_poll_required_entry_tag_groups" */
export type Polls_Poll_Required_Entry_Tag_Groups_Aggregate_Fields = {
  __typename?: 'polls_poll_required_entry_tag_groups_aggregate_fields';
  avg?: Maybe<Polls_Poll_Required_Entry_Tag_Groups_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Poll_Required_Entry_Tag_Groups_Max_Fields>;
  min?: Maybe<Polls_Poll_Required_Entry_Tag_Groups_Min_Fields>;
  stddev?: Maybe<Polls_Poll_Required_Entry_Tag_Groups_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Poll_Required_Entry_Tag_Groups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Poll_Required_Entry_Tag_Groups_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Poll_Required_Entry_Tag_Groups_Sum_Fields>;
  var_pop?: Maybe<Polls_Poll_Required_Entry_Tag_Groups_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Poll_Required_Entry_Tag_Groups_Var_Samp_Fields>;
  variance?: Maybe<Polls_Poll_Required_Entry_Tag_Groups_Variance_Fields>;
};


/** aggregate fields of "polls_poll_required_entry_tag_groups" */
export type Polls_Poll_Required_Entry_Tag_Groups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Poll_Required_Entry_Tag_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "polls_poll_required_entry_tag_groups" */
export type Polls_Poll_Required_Entry_Tag_Groups_Aggregate_Order_By = {
  avg?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_Max_Order_By>;
  min?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_Min_Order_By>;
  stddev?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_Sum_Order_By>;
  var_pop?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_Var_Samp_Order_By>;
  variance?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "polls_poll_required_entry_tag_groups" */
export type Polls_Poll_Required_Entry_Tag_Groups_Arr_Rel_Insert_Input = {
  data: Array<Polls_Poll_Required_Entry_Tag_Groups_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_On_Conflict>;
};

/** aggregate avg on columns */
export type Polls_Poll_Required_Entry_Tag_Groups_Avg_Fields = {
  __typename?: 'polls_poll_required_entry_tag_groups_avg_fields';
  entrytaggroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "polls_poll_required_entry_tag_groups" */
export type Polls_Poll_Required_Entry_Tag_Groups_Avg_Order_By = {
  entrytaggroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "polls_poll_required_entry_tag_groups". All fields are combined with a logical 'AND'. */
export type Polls_Poll_Required_Entry_Tag_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Poll_Required_Entry_Tag_Groups_Bool_Exp>>;
  _not?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Poll_Required_Entry_Tag_Groups_Bool_Exp>>;
  entrytaggroup_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  poll_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_poll_required_entry_tag_groups" */
export enum Polls_Poll_Required_Entry_Tag_Groups_Constraint {
  /** unique or primary key constraint on columns "poll_id", "entrytaggroup_id" */
  PollsPollRequiredEntrPollIdEntrytaggroupId_575e8194Uniq = 'polls_poll_required_entr_poll_id_entrytaggroup_id_575e8194_uniq',
  /** unique or primary key constraint on columns "id" */
  PollsPollRequiredEntryTagGroupsPkey = 'polls_poll_required_entry_tag_groups_pkey'
}

/** input type for incrementing numeric columns in table "polls_poll_required_entry_tag_groups" */
export type Polls_Poll_Required_Entry_Tag_Groups_Inc_Input = {
  entrytaggroup_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  poll_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_poll_required_entry_tag_groups" */
export type Polls_Poll_Required_Entry_Tag_Groups_Insert_Input = {
  entrytaggroup_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  poll_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Polls_Poll_Required_Entry_Tag_Groups_Max_Fields = {
  __typename?: 'polls_poll_required_entry_tag_groups_max_fields';
  entrytaggroup_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  poll_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "polls_poll_required_entry_tag_groups" */
export type Polls_Poll_Required_Entry_Tag_Groups_Max_Order_By = {
  entrytaggroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Polls_Poll_Required_Entry_Tag_Groups_Min_Fields = {
  __typename?: 'polls_poll_required_entry_tag_groups_min_fields';
  entrytaggroup_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  poll_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "polls_poll_required_entry_tag_groups" */
export type Polls_Poll_Required_Entry_Tag_Groups_Min_Order_By = {
  entrytaggroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "polls_poll_required_entry_tag_groups" */
export type Polls_Poll_Required_Entry_Tag_Groups_Mutation_Response = {
  __typename?: 'polls_poll_required_entry_tag_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Poll_Required_Entry_Tag_Groups>;
};

/** on_conflict condition type for table "polls_poll_required_entry_tag_groups" */
export type Polls_Poll_Required_Entry_Tag_Groups_On_Conflict = {
  constraint: Polls_Poll_Required_Entry_Tag_Groups_Constraint;
  update_columns?: Array<Polls_Poll_Required_Entry_Tag_Groups_Update_Column>;
  where?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_poll_required_entry_tag_groups". */
export type Polls_Poll_Required_Entry_Tag_Groups_Order_By = {
  entrytaggroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_poll_required_entry_tag_groups */
export type Polls_Poll_Required_Entry_Tag_Groups_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_poll_required_entry_tag_groups" */
export enum Polls_Poll_Required_Entry_Tag_Groups_Select_Column {
  /** column name */
  EntrytaggroupId = 'entrytaggroup_id',
  /** column name */
  Id = 'id',
  /** column name */
  PollId = 'poll_id'
}

/** input type for updating data in table "polls_poll_required_entry_tag_groups" */
export type Polls_Poll_Required_Entry_Tag_Groups_Set_Input = {
  entrytaggroup_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  poll_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Polls_Poll_Required_Entry_Tag_Groups_Stddev_Fields = {
  __typename?: 'polls_poll_required_entry_tag_groups_stddev_fields';
  entrytaggroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "polls_poll_required_entry_tag_groups" */
export type Polls_Poll_Required_Entry_Tag_Groups_Stddev_Order_By = {
  entrytaggroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Polls_Poll_Required_Entry_Tag_Groups_Stddev_Pop_Fields = {
  __typename?: 'polls_poll_required_entry_tag_groups_stddev_pop_fields';
  entrytaggroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "polls_poll_required_entry_tag_groups" */
export type Polls_Poll_Required_Entry_Tag_Groups_Stddev_Pop_Order_By = {
  entrytaggroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Polls_Poll_Required_Entry_Tag_Groups_Stddev_Samp_Fields = {
  __typename?: 'polls_poll_required_entry_tag_groups_stddev_samp_fields';
  entrytaggroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "polls_poll_required_entry_tag_groups" */
export type Polls_Poll_Required_Entry_Tag_Groups_Stddev_Samp_Order_By = {
  entrytaggroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Polls_Poll_Required_Entry_Tag_Groups_Sum_Fields = {
  __typename?: 'polls_poll_required_entry_tag_groups_sum_fields';
  entrytaggroup_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  poll_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "polls_poll_required_entry_tag_groups" */
export type Polls_Poll_Required_Entry_Tag_Groups_Sum_Order_By = {
  entrytaggroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
};

/** update columns of table "polls_poll_required_entry_tag_groups" */
export enum Polls_Poll_Required_Entry_Tag_Groups_Update_Column {
  /** column name */
  EntrytaggroupId = 'entrytaggroup_id',
  /** column name */
  Id = 'id',
  /** column name */
  PollId = 'poll_id'
}

/** aggregate var_pop on columns */
export type Polls_Poll_Required_Entry_Tag_Groups_Var_Pop_Fields = {
  __typename?: 'polls_poll_required_entry_tag_groups_var_pop_fields';
  entrytaggroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "polls_poll_required_entry_tag_groups" */
export type Polls_Poll_Required_Entry_Tag_Groups_Var_Pop_Order_By = {
  entrytaggroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Polls_Poll_Required_Entry_Tag_Groups_Var_Samp_Fields = {
  __typename?: 'polls_poll_required_entry_tag_groups_var_samp_fields';
  entrytaggroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "polls_poll_required_entry_tag_groups" */
export type Polls_Poll_Required_Entry_Tag_Groups_Var_Samp_Order_By = {
  entrytaggroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Polls_Poll_Required_Entry_Tag_Groups_Variance_Fields = {
  __typename?: 'polls_poll_required_entry_tag_groups_variance_fields';
  entrytaggroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "polls_poll_required_entry_tag_groups" */
export type Polls_Poll_Required_Entry_Tag_Groups_Variance_Order_By = {
  entrytaggroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
};

/** select columns of table "polls_poll" */
export enum Polls_Poll_Select_Column {
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateModified = 'date_modified',
  /** column name */
  Description = 'description',
  /** column name */
  DescriptionEn = 'description_en',
  /** column name */
  DescriptionEs = 'description_es',
  /** column name */
  DescriptionFr = 'description_fr',
  /** column name */
  DescriptionJa = 'description_ja',
  /** column name */
  DescriptionZhHans = 'description_zh_hans',
  /** column name */
  DescriptionZhHant = 'description_zh_hant',
  /** column name */
  Id = 'id',
  /** column name */
  IsDisabled = 'is_disabled',
  /** column name */
  IsExternal = 'is_external',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  PrimaryLanguage = 'primary_language',
  /** column name */
  Published = 'published',
  /** column name */
  ReleaseNotes = 'release_notes',
  /** column name */
  Tooltip = 'tooltip',
  /** column name */
  TooltipEn = 'tooltip_en',
  /** column name */
  TooltipEs = 'tooltip_es',
  /** column name */
  TooltipFr = 'tooltip_fr',
  /** column name */
  TooltipJa = 'tooltip_ja',
  /** column name */
  TooltipZhHans = 'tooltip_zh_hans',
  /** column name */
  TooltipZhHant = 'tooltip_zh_hant',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "polls_poll" */
export type Polls_Poll_Set_Input = {
  created_by_id?: InputMaybe<Scalars['Int']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_modified?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  description_en?: InputMaybe<Scalars['String']>;
  description_es?: InputMaybe<Scalars['String']>;
  description_fr?: InputMaybe<Scalars['String']>;
  description_ja?: InputMaybe<Scalars['String']>;
  description_zh_hans?: InputMaybe<Scalars['String']>;
  description_zh_hant?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_disabled?: InputMaybe<Scalars['Boolean']>;
  is_external?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
  previous_id?: InputMaybe<Scalars['Int']>;
  primary_language?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  release_notes?: InputMaybe<Scalars['String']>;
  tooltip?: InputMaybe<Scalars['String']>;
  tooltip_en?: InputMaybe<Scalars['String']>;
  tooltip_es?: InputMaybe<Scalars['String']>;
  tooltip_fr?: InputMaybe<Scalars['String']>;
  tooltip_ja?: InputMaybe<Scalars['String']>;
  tooltip_zh_hans?: InputMaybe<Scalars['String']>;
  tooltip_zh_hant?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Polls_Poll_Stddev_Fields = {
  __typename?: 'polls_poll_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Polls_Poll_Stddev_Pop_Fields = {
  __typename?: 'polls_poll_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Polls_Poll_Stddev_Samp_Fields = {
  __typename?: 'polls_poll_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Polls_Poll_Sum_Fields = {
  __typename?: 'polls_poll_sum_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "polls_poll" */
export enum Polls_Poll_Update_Column {
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateModified = 'date_modified',
  /** column name */
  Description = 'description',
  /** column name */
  DescriptionEn = 'description_en',
  /** column name */
  DescriptionEs = 'description_es',
  /** column name */
  DescriptionFr = 'description_fr',
  /** column name */
  DescriptionJa = 'description_ja',
  /** column name */
  DescriptionZhHans = 'description_zh_hans',
  /** column name */
  DescriptionZhHant = 'description_zh_hant',
  /** column name */
  Id = 'id',
  /** column name */
  IsDisabled = 'is_disabled',
  /** column name */
  IsExternal = 'is_external',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  PrimaryLanguage = 'primary_language',
  /** column name */
  Published = 'published',
  /** column name */
  ReleaseNotes = 'release_notes',
  /** column name */
  Tooltip = 'tooltip',
  /** column name */
  TooltipEn = 'tooltip_en',
  /** column name */
  TooltipEs = 'tooltip_es',
  /** column name */
  TooltipFr = 'tooltip_fr',
  /** column name */
  TooltipJa = 'tooltip_ja',
  /** column name */
  TooltipZhHans = 'tooltip_zh_hans',
  /** column name */
  TooltipZhHant = 'tooltip_zh_hant',
  /** column name */
  Type = 'type'
}

/** aggregate var_pop on columns */
export type Polls_Poll_Var_Pop_Fields = {
  __typename?: 'polls_poll_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Polls_Poll_Var_Samp_Fields = {
  __typename?: 'polls_poll_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Polls_Poll_Variance_Fields = {
  __typename?: 'polls_poll_variance_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "polls_pollprogress" */
export type Polls_Pollprogress = {
  __typename?: 'polls_pollprogress';
  additional_answered: Scalars['Int'];
  additional_total: Scalars['Int'];
  answered: Scalars['Int'];
  /** An array relationship */
  category_progress: Array<Polls_Categoryprogress>;
  /** An aggregate relationship */
  category_progress_aggregate: Polls_Categoryprogress_Aggregate;
  /** An array relationship */
  considered_answer_sets: Array<Polls_Pollprogress_Considered_Answer_Sets>;
  /** An aggregate relationship */
  considered_answer_sets_aggregate: Polls_Pollprogress_Considered_Answer_Sets_Aggregate;
  draft: Scalars['Int'];
  /** An object relationship */
  entry: Polls_Entity;
  entry_id: Scalars['Int'];
  /** An object relationship */
  expert: Accounts_Expert;
  expert_id: Scalars['Int'];
  id: Scalars['Int'];
  poll_id: Scalars['Int'];
  published: Scalars['Int'];
  total: Scalars['Int'];
};


/** columns and relationships of "polls_pollprogress" */
export type Polls_PollprogressCategory_ProgressArgs = {
  distinct_on?: InputMaybe<Array<Polls_Categoryprogress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Categoryprogress_Order_By>>;
  where?: InputMaybe<Polls_Categoryprogress_Bool_Exp>;
};


/** columns and relationships of "polls_pollprogress" */
export type Polls_PollprogressCategory_Progress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Categoryprogress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Categoryprogress_Order_By>>;
  where?: InputMaybe<Polls_Categoryprogress_Bool_Exp>;
};


/** columns and relationships of "polls_pollprogress" */
export type Polls_PollprogressConsidered_Answer_SetsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Pollprogress_Considered_Answer_Sets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Pollprogress_Considered_Answer_Sets_Order_By>>;
  where?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_Bool_Exp>;
};


/** columns and relationships of "polls_pollprogress" */
export type Polls_PollprogressConsidered_Answer_Sets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Pollprogress_Considered_Answer_Sets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Pollprogress_Considered_Answer_Sets_Order_By>>;
  where?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_Bool_Exp>;
};

/** aggregated selection of "polls_pollprogress" */
export type Polls_Pollprogress_Aggregate = {
  __typename?: 'polls_pollprogress_aggregate';
  aggregate?: Maybe<Polls_Pollprogress_Aggregate_Fields>;
  nodes: Array<Polls_Pollprogress>;
};

/** aggregate fields of "polls_pollprogress" */
export type Polls_Pollprogress_Aggregate_Fields = {
  __typename?: 'polls_pollprogress_aggregate_fields';
  avg?: Maybe<Polls_Pollprogress_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Pollprogress_Max_Fields>;
  min?: Maybe<Polls_Pollprogress_Min_Fields>;
  stddev?: Maybe<Polls_Pollprogress_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Pollprogress_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Pollprogress_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Pollprogress_Sum_Fields>;
  var_pop?: Maybe<Polls_Pollprogress_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Pollprogress_Var_Samp_Fields>;
  variance?: Maybe<Polls_Pollprogress_Variance_Fields>;
};


/** aggregate fields of "polls_pollprogress" */
export type Polls_Pollprogress_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Pollprogress_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "polls_pollprogress" */
export type Polls_Pollprogress_Aggregate_Order_By = {
  avg?: InputMaybe<Polls_Pollprogress_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Polls_Pollprogress_Max_Order_By>;
  min?: InputMaybe<Polls_Pollprogress_Min_Order_By>;
  stddev?: InputMaybe<Polls_Pollprogress_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Polls_Pollprogress_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Polls_Pollprogress_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Polls_Pollprogress_Sum_Order_By>;
  var_pop?: InputMaybe<Polls_Pollprogress_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Polls_Pollprogress_Var_Samp_Order_By>;
  variance?: InputMaybe<Polls_Pollprogress_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "polls_pollprogress" */
export type Polls_Pollprogress_Arr_Rel_Insert_Input = {
  data: Array<Polls_Pollprogress_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Pollprogress_On_Conflict>;
};

/** aggregate avg on columns */
export type Polls_Pollprogress_Avg_Fields = {
  __typename?: 'polls_pollprogress_avg_fields';
  additional_answered?: Maybe<Scalars['Float']>;
  additional_total?: Maybe<Scalars['Float']>;
  answered?: Maybe<Scalars['Float']>;
  draft?: Maybe<Scalars['Float']>;
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  published?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "polls_pollprogress" */
export type Polls_Pollprogress_Avg_Order_By = {
  additional_answered?: InputMaybe<Order_By>;
  additional_total?: InputMaybe<Order_By>;
  answered?: InputMaybe<Order_By>;
  draft?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  expert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "polls_pollprogress". All fields are combined with a logical 'AND'. */
export type Polls_Pollprogress_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Pollprogress_Bool_Exp>>;
  _not?: InputMaybe<Polls_Pollprogress_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Pollprogress_Bool_Exp>>;
  additional_answered?: InputMaybe<Int_Comparison_Exp>;
  additional_total?: InputMaybe<Int_Comparison_Exp>;
  answered?: InputMaybe<Int_Comparison_Exp>;
  category_progress?: InputMaybe<Polls_Categoryprogress_Bool_Exp>;
  considered_answer_sets?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_Bool_Exp>;
  draft?: InputMaybe<Int_Comparison_Exp>;
  entry?: InputMaybe<Polls_Entity_Bool_Exp>;
  entry_id?: InputMaybe<Int_Comparison_Exp>;
  expert?: InputMaybe<Accounts_Expert_Bool_Exp>;
  expert_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  poll_id?: InputMaybe<Int_Comparison_Exp>;
  published?: InputMaybe<Int_Comparison_Exp>;
  total?: InputMaybe<Int_Comparison_Exp>;
};

/** columns and relationships of "polls_pollprogress_considered_answer_sets" */
export type Polls_Pollprogress_Considered_Answer_Sets = {
  __typename?: 'polls_pollprogress_considered_answer_sets';
  answerset_id: Scalars['Int'];
  /** An object relationship */
  base_answer_set?: Maybe<Polls_Baseanswerset>;
  id: Scalars['Int'];
  pollprogress_id: Scalars['Int'];
};

/** aggregated selection of "polls_pollprogress_considered_answer_sets" */
export type Polls_Pollprogress_Considered_Answer_Sets_Aggregate = {
  __typename?: 'polls_pollprogress_considered_answer_sets_aggregate';
  aggregate?: Maybe<Polls_Pollprogress_Considered_Answer_Sets_Aggregate_Fields>;
  nodes: Array<Polls_Pollprogress_Considered_Answer_Sets>;
};

/** aggregate fields of "polls_pollprogress_considered_answer_sets" */
export type Polls_Pollprogress_Considered_Answer_Sets_Aggregate_Fields = {
  __typename?: 'polls_pollprogress_considered_answer_sets_aggregate_fields';
  avg?: Maybe<Polls_Pollprogress_Considered_Answer_Sets_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Pollprogress_Considered_Answer_Sets_Max_Fields>;
  min?: Maybe<Polls_Pollprogress_Considered_Answer_Sets_Min_Fields>;
  stddev?: Maybe<Polls_Pollprogress_Considered_Answer_Sets_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Pollprogress_Considered_Answer_Sets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Pollprogress_Considered_Answer_Sets_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Pollprogress_Considered_Answer_Sets_Sum_Fields>;
  var_pop?: Maybe<Polls_Pollprogress_Considered_Answer_Sets_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Pollprogress_Considered_Answer_Sets_Var_Samp_Fields>;
  variance?: Maybe<Polls_Pollprogress_Considered_Answer_Sets_Variance_Fields>;
};


/** aggregate fields of "polls_pollprogress_considered_answer_sets" */
export type Polls_Pollprogress_Considered_Answer_Sets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Pollprogress_Considered_Answer_Sets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "polls_pollprogress_considered_answer_sets" */
export type Polls_Pollprogress_Considered_Answer_Sets_Aggregate_Order_By = {
  avg?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_Max_Order_By>;
  min?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_Min_Order_By>;
  stddev?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_Sum_Order_By>;
  var_pop?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_Var_Samp_Order_By>;
  variance?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "polls_pollprogress_considered_answer_sets" */
export type Polls_Pollprogress_Considered_Answer_Sets_Arr_Rel_Insert_Input = {
  data: Array<Polls_Pollprogress_Considered_Answer_Sets_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_On_Conflict>;
};

/** aggregate avg on columns */
export type Polls_Pollprogress_Considered_Answer_Sets_Avg_Fields = {
  __typename?: 'polls_pollprogress_considered_answer_sets_avg_fields';
  answerset_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pollprogress_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "polls_pollprogress_considered_answer_sets" */
export type Polls_Pollprogress_Considered_Answer_Sets_Avg_Order_By = {
  answerset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pollprogress_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "polls_pollprogress_considered_answer_sets". All fields are combined with a logical 'AND'. */
export type Polls_Pollprogress_Considered_Answer_Sets_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Pollprogress_Considered_Answer_Sets_Bool_Exp>>;
  _not?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Pollprogress_Considered_Answer_Sets_Bool_Exp>>;
  answerset_id?: InputMaybe<Int_Comparison_Exp>;
  base_answer_set?: InputMaybe<Polls_Baseanswerset_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  pollprogress_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_pollprogress_considered_answer_sets" */
export enum Polls_Pollprogress_Considered_Answer_Sets_Constraint {
  /** unique or primary key constraint on columns "answerset_id", "pollprogress_id" */
  PollsPollprogressConsideredPollprogressIdAnswersetIdKey = 'polls_pollprogress_considered__pollprogress_id_answerset_id_key',
  /** unique or primary key constraint on columns "id" */
  PollsPollprogressConsideredAnswerSetsPkey = 'polls_pollprogress_considered_answer_sets_pkey'
}

/** input type for incrementing numeric columns in table "polls_pollprogress_considered_answer_sets" */
export type Polls_Pollprogress_Considered_Answer_Sets_Inc_Input = {
  answerset_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  pollprogress_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_pollprogress_considered_answer_sets" */
export type Polls_Pollprogress_Considered_Answer_Sets_Insert_Input = {
  answerset_id?: InputMaybe<Scalars['Int']>;
  base_answer_set?: InputMaybe<Polls_Baseanswerset_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  pollprogress_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Polls_Pollprogress_Considered_Answer_Sets_Max_Fields = {
  __typename?: 'polls_pollprogress_considered_answer_sets_max_fields';
  answerset_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  pollprogress_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "polls_pollprogress_considered_answer_sets" */
export type Polls_Pollprogress_Considered_Answer_Sets_Max_Order_By = {
  answerset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pollprogress_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Polls_Pollprogress_Considered_Answer_Sets_Min_Fields = {
  __typename?: 'polls_pollprogress_considered_answer_sets_min_fields';
  answerset_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  pollprogress_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "polls_pollprogress_considered_answer_sets" */
export type Polls_Pollprogress_Considered_Answer_Sets_Min_Order_By = {
  answerset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pollprogress_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "polls_pollprogress_considered_answer_sets" */
export type Polls_Pollprogress_Considered_Answer_Sets_Mutation_Response = {
  __typename?: 'polls_pollprogress_considered_answer_sets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Pollprogress_Considered_Answer_Sets>;
};

/** on_conflict condition type for table "polls_pollprogress_considered_answer_sets" */
export type Polls_Pollprogress_Considered_Answer_Sets_On_Conflict = {
  constraint: Polls_Pollprogress_Considered_Answer_Sets_Constraint;
  update_columns?: Array<Polls_Pollprogress_Considered_Answer_Sets_Update_Column>;
  where?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_pollprogress_considered_answer_sets". */
export type Polls_Pollprogress_Considered_Answer_Sets_Order_By = {
  answerset_id?: InputMaybe<Order_By>;
  base_answer_set?: InputMaybe<Polls_Baseanswerset_Order_By>;
  id?: InputMaybe<Order_By>;
  pollprogress_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_pollprogress_considered_answer_sets */
export type Polls_Pollprogress_Considered_Answer_Sets_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_pollprogress_considered_answer_sets" */
export enum Polls_Pollprogress_Considered_Answer_Sets_Select_Column {
  /** column name */
  AnswersetId = 'answerset_id',
  /** column name */
  Id = 'id',
  /** column name */
  PollprogressId = 'pollprogress_id'
}

/** input type for updating data in table "polls_pollprogress_considered_answer_sets" */
export type Polls_Pollprogress_Considered_Answer_Sets_Set_Input = {
  answerset_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  pollprogress_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Polls_Pollprogress_Considered_Answer_Sets_Stddev_Fields = {
  __typename?: 'polls_pollprogress_considered_answer_sets_stddev_fields';
  answerset_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pollprogress_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "polls_pollprogress_considered_answer_sets" */
export type Polls_Pollprogress_Considered_Answer_Sets_Stddev_Order_By = {
  answerset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pollprogress_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Polls_Pollprogress_Considered_Answer_Sets_Stddev_Pop_Fields = {
  __typename?: 'polls_pollprogress_considered_answer_sets_stddev_pop_fields';
  answerset_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pollprogress_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "polls_pollprogress_considered_answer_sets" */
export type Polls_Pollprogress_Considered_Answer_Sets_Stddev_Pop_Order_By = {
  answerset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pollprogress_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Polls_Pollprogress_Considered_Answer_Sets_Stddev_Samp_Fields = {
  __typename?: 'polls_pollprogress_considered_answer_sets_stddev_samp_fields';
  answerset_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pollprogress_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "polls_pollprogress_considered_answer_sets" */
export type Polls_Pollprogress_Considered_Answer_Sets_Stddev_Samp_Order_By = {
  answerset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pollprogress_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Polls_Pollprogress_Considered_Answer_Sets_Sum_Fields = {
  __typename?: 'polls_pollprogress_considered_answer_sets_sum_fields';
  answerset_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  pollprogress_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "polls_pollprogress_considered_answer_sets" */
export type Polls_Pollprogress_Considered_Answer_Sets_Sum_Order_By = {
  answerset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pollprogress_id?: InputMaybe<Order_By>;
};

/** update columns of table "polls_pollprogress_considered_answer_sets" */
export enum Polls_Pollprogress_Considered_Answer_Sets_Update_Column {
  /** column name */
  AnswersetId = 'answerset_id',
  /** column name */
  Id = 'id',
  /** column name */
  PollprogressId = 'pollprogress_id'
}

/** aggregate var_pop on columns */
export type Polls_Pollprogress_Considered_Answer_Sets_Var_Pop_Fields = {
  __typename?: 'polls_pollprogress_considered_answer_sets_var_pop_fields';
  answerset_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pollprogress_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "polls_pollprogress_considered_answer_sets" */
export type Polls_Pollprogress_Considered_Answer_Sets_Var_Pop_Order_By = {
  answerset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pollprogress_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Polls_Pollprogress_Considered_Answer_Sets_Var_Samp_Fields = {
  __typename?: 'polls_pollprogress_considered_answer_sets_var_samp_fields';
  answerset_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pollprogress_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "polls_pollprogress_considered_answer_sets" */
export type Polls_Pollprogress_Considered_Answer_Sets_Var_Samp_Order_By = {
  answerset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pollprogress_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Polls_Pollprogress_Considered_Answer_Sets_Variance_Fields = {
  __typename?: 'polls_pollprogress_considered_answer_sets_variance_fields';
  answerset_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pollprogress_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "polls_pollprogress_considered_answer_sets" */
export type Polls_Pollprogress_Considered_Answer_Sets_Variance_Order_By = {
  answerset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pollprogress_id?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "polls_pollprogress" */
export enum Polls_Pollprogress_Constraint {
  /** unique or primary key constraint on columns "expert_id", "poll_id", "entry_id" */
  PollsPollprogressExpertId_10c760f55ae19855Uniq = 'polls_pollprogress_expert_id_10c760f55ae19855_uniq',
  /** unique or primary key constraint on columns "id" */
  PollsPollprogressPkey = 'polls_pollprogress_pkey'
}

/** input type for incrementing numeric columns in table "polls_pollprogress" */
export type Polls_Pollprogress_Inc_Input = {
  additional_answered?: InputMaybe<Scalars['Int']>;
  additional_total?: InputMaybe<Scalars['Int']>;
  answered?: InputMaybe<Scalars['Int']>;
  draft?: InputMaybe<Scalars['Int']>;
  entry_id?: InputMaybe<Scalars['Int']>;
  expert_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  poll_id?: InputMaybe<Scalars['Int']>;
  published?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_pollprogress" */
export type Polls_Pollprogress_Insert_Input = {
  additional_answered?: InputMaybe<Scalars['Int']>;
  additional_total?: InputMaybe<Scalars['Int']>;
  answered?: InputMaybe<Scalars['Int']>;
  category_progress?: InputMaybe<Polls_Categoryprogress_Arr_Rel_Insert_Input>;
  considered_answer_sets?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_Arr_Rel_Insert_Input>;
  draft?: InputMaybe<Scalars['Int']>;
  entry?: InputMaybe<Polls_Entity_Obj_Rel_Insert_Input>;
  entry_id?: InputMaybe<Scalars['Int']>;
  expert?: InputMaybe<Accounts_Expert_Obj_Rel_Insert_Input>;
  expert_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  poll_id?: InputMaybe<Scalars['Int']>;
  published?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Polls_Pollprogress_Max_Fields = {
  __typename?: 'polls_pollprogress_max_fields';
  additional_answered?: Maybe<Scalars['Int']>;
  additional_total?: Maybe<Scalars['Int']>;
  answered?: Maybe<Scalars['Int']>;
  draft?: Maybe<Scalars['Int']>;
  entry_id?: Maybe<Scalars['Int']>;
  expert_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  poll_id?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "polls_pollprogress" */
export type Polls_Pollprogress_Max_Order_By = {
  additional_answered?: InputMaybe<Order_By>;
  additional_total?: InputMaybe<Order_By>;
  answered?: InputMaybe<Order_By>;
  draft?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  expert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Polls_Pollprogress_Min_Fields = {
  __typename?: 'polls_pollprogress_min_fields';
  additional_answered?: Maybe<Scalars['Int']>;
  additional_total?: Maybe<Scalars['Int']>;
  answered?: Maybe<Scalars['Int']>;
  draft?: Maybe<Scalars['Int']>;
  entry_id?: Maybe<Scalars['Int']>;
  expert_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  poll_id?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "polls_pollprogress" */
export type Polls_Pollprogress_Min_Order_By = {
  additional_answered?: InputMaybe<Order_By>;
  additional_total?: InputMaybe<Order_By>;
  answered?: InputMaybe<Order_By>;
  draft?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  expert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "polls_pollprogress" */
export type Polls_Pollprogress_Mutation_Response = {
  __typename?: 'polls_pollprogress_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Pollprogress>;
};

/** on_conflict condition type for table "polls_pollprogress" */
export type Polls_Pollprogress_On_Conflict = {
  constraint: Polls_Pollprogress_Constraint;
  update_columns?: Array<Polls_Pollprogress_Update_Column>;
  where?: InputMaybe<Polls_Pollprogress_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_pollprogress". */
export type Polls_Pollprogress_Order_By = {
  additional_answered?: InputMaybe<Order_By>;
  additional_total?: InputMaybe<Order_By>;
  answered?: InputMaybe<Order_By>;
  category_progress_aggregate?: InputMaybe<Polls_Categoryprogress_Aggregate_Order_By>;
  considered_answer_sets_aggregate?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_Aggregate_Order_By>;
  draft?: InputMaybe<Order_By>;
  entry?: InputMaybe<Polls_Entity_Order_By>;
  entry_id?: InputMaybe<Order_By>;
  expert?: InputMaybe<Accounts_Expert_Order_By>;
  expert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_pollprogress */
export type Polls_Pollprogress_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_pollprogress" */
export enum Polls_Pollprogress_Select_Column {
  /** column name */
  AdditionalAnswered = 'additional_answered',
  /** column name */
  AdditionalTotal = 'additional_total',
  /** column name */
  Answered = 'answered',
  /** column name */
  Draft = 'draft',
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  ExpertId = 'expert_id',
  /** column name */
  Id = 'id',
  /** column name */
  PollId = 'poll_id',
  /** column name */
  Published = 'published',
  /** column name */
  Total = 'total'
}

/** input type for updating data in table "polls_pollprogress" */
export type Polls_Pollprogress_Set_Input = {
  additional_answered?: InputMaybe<Scalars['Int']>;
  additional_total?: InputMaybe<Scalars['Int']>;
  answered?: InputMaybe<Scalars['Int']>;
  draft?: InputMaybe<Scalars['Int']>;
  entry_id?: InputMaybe<Scalars['Int']>;
  expert_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  poll_id?: InputMaybe<Scalars['Int']>;
  published?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Polls_Pollprogress_Stddev_Fields = {
  __typename?: 'polls_pollprogress_stddev_fields';
  additional_answered?: Maybe<Scalars['Float']>;
  additional_total?: Maybe<Scalars['Float']>;
  answered?: Maybe<Scalars['Float']>;
  draft?: Maybe<Scalars['Float']>;
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  published?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "polls_pollprogress" */
export type Polls_Pollprogress_Stddev_Order_By = {
  additional_answered?: InputMaybe<Order_By>;
  additional_total?: InputMaybe<Order_By>;
  answered?: InputMaybe<Order_By>;
  draft?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  expert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Polls_Pollprogress_Stddev_Pop_Fields = {
  __typename?: 'polls_pollprogress_stddev_pop_fields';
  additional_answered?: Maybe<Scalars['Float']>;
  additional_total?: Maybe<Scalars['Float']>;
  answered?: Maybe<Scalars['Float']>;
  draft?: Maybe<Scalars['Float']>;
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  published?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "polls_pollprogress" */
export type Polls_Pollprogress_Stddev_Pop_Order_By = {
  additional_answered?: InputMaybe<Order_By>;
  additional_total?: InputMaybe<Order_By>;
  answered?: InputMaybe<Order_By>;
  draft?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  expert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Polls_Pollprogress_Stddev_Samp_Fields = {
  __typename?: 'polls_pollprogress_stddev_samp_fields';
  additional_answered?: Maybe<Scalars['Float']>;
  additional_total?: Maybe<Scalars['Float']>;
  answered?: Maybe<Scalars['Float']>;
  draft?: Maybe<Scalars['Float']>;
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  published?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "polls_pollprogress" */
export type Polls_Pollprogress_Stddev_Samp_Order_By = {
  additional_answered?: InputMaybe<Order_By>;
  additional_total?: InputMaybe<Order_By>;
  answered?: InputMaybe<Order_By>;
  draft?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  expert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Polls_Pollprogress_Sum_Fields = {
  __typename?: 'polls_pollprogress_sum_fields';
  additional_answered?: Maybe<Scalars['Int']>;
  additional_total?: Maybe<Scalars['Int']>;
  answered?: Maybe<Scalars['Int']>;
  draft?: Maybe<Scalars['Int']>;
  entry_id?: Maybe<Scalars['Int']>;
  expert_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  poll_id?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "polls_pollprogress" */
export type Polls_Pollprogress_Sum_Order_By = {
  additional_answered?: InputMaybe<Order_By>;
  additional_total?: InputMaybe<Order_By>;
  answered?: InputMaybe<Order_By>;
  draft?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  expert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** update columns of table "polls_pollprogress" */
export enum Polls_Pollprogress_Update_Column {
  /** column name */
  AdditionalAnswered = 'additional_answered',
  /** column name */
  AdditionalTotal = 'additional_total',
  /** column name */
  Answered = 'answered',
  /** column name */
  Draft = 'draft',
  /** column name */
  EntryId = 'entry_id',
  /** column name */
  ExpertId = 'expert_id',
  /** column name */
  Id = 'id',
  /** column name */
  PollId = 'poll_id',
  /** column name */
  Published = 'published',
  /** column name */
  Total = 'total'
}

/** aggregate var_pop on columns */
export type Polls_Pollprogress_Var_Pop_Fields = {
  __typename?: 'polls_pollprogress_var_pop_fields';
  additional_answered?: Maybe<Scalars['Float']>;
  additional_total?: Maybe<Scalars['Float']>;
  answered?: Maybe<Scalars['Float']>;
  draft?: Maybe<Scalars['Float']>;
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  published?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "polls_pollprogress" */
export type Polls_Pollprogress_Var_Pop_Order_By = {
  additional_answered?: InputMaybe<Order_By>;
  additional_total?: InputMaybe<Order_By>;
  answered?: InputMaybe<Order_By>;
  draft?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  expert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Polls_Pollprogress_Var_Samp_Fields = {
  __typename?: 'polls_pollprogress_var_samp_fields';
  additional_answered?: Maybe<Scalars['Float']>;
  additional_total?: Maybe<Scalars['Float']>;
  answered?: Maybe<Scalars['Float']>;
  draft?: Maybe<Scalars['Float']>;
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  published?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "polls_pollprogress" */
export type Polls_Pollprogress_Var_Samp_Order_By = {
  additional_answered?: InputMaybe<Order_By>;
  additional_total?: InputMaybe<Order_By>;
  answered?: InputMaybe<Order_By>;
  draft?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  expert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Polls_Pollprogress_Variance_Fields = {
  __typename?: 'polls_pollprogress_variance_fields';
  additional_answered?: Maybe<Scalars['Float']>;
  additional_total?: Maybe<Scalars['Float']>;
  answered?: Maybe<Scalars['Float']>;
  draft?: Maybe<Scalars['Float']>;
  entry_id?: Maybe<Scalars['Float']>;
  expert_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  published?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "polls_pollprogress" */
export type Polls_Pollprogress_Variance_Order_By = {
  additional_answered?: InputMaybe<Order_By>;
  additional_total?: InputMaybe<Order_By>;
  answered?: InputMaybe<Order_By>;
  draft?: InputMaybe<Order_By>;
  entry_id?: InputMaybe<Order_By>;
  expert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** columns and relationships of "polls_question" */
export type Polls_Question = {
  __typename?: 'polls_question';
  /** A computed field, executes function "get_question_ancestors" */
  ancestors?: Maybe<Array<Polls_Question>>;
  /** An array relationship */
  base_answer_sets: Array<Polls_Baseanswerset>;
  /** An aggregate relationship */
  base_answer_sets_aggregate: Polls_Baseanswerset_Aggregate;
  /** An object relationship */
  category: Polls_Category;
  category_id: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  description_en?: Maybe<Scalars['String']>;
  description_es?: Maybe<Scalars['String']>;
  description_fr?: Maybe<Scalars['String']>;
  description_ja?: Maybe<Scalars['String']>;
  description_zh_hans?: Maybe<Scalars['String']>;
  description_zh_hant?: Maybe<Scalars['String']>;
  /** An object relationship */
  group?: Maybe<Polls_Group>;
  group_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  is_priority: Scalars['Boolean'];
  multiple_answers_allowed: Scalars['Boolean'];
  name: Scalars['String'];
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  /** An object relationship */
  parent_question?: Maybe<Polls_Question>;
  parent_question_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  parent_template_answer?: Maybe<Polls_Templateanswer>;
  parent_template_answer_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  poll: Polls_Poll;
  poll_id: Scalars['Int'];
  /** An object relationship */
  previous?: Maybe<Polls_Question>;
  previous_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  related_question_ids_1: Array<Polls_Questionrelation>;
  /** An aggregate relationship */
  related_question_ids_1_aggregate: Polls_Questionrelation_Aggregate;
  /** An array relationship */
  related_question_ids_2: Array<Polls_Questionrelation>;
  /** An aggregate relationship */
  related_question_ids_2_aggregate: Polls_Questionrelation_Aggregate;
  /** An array relationship */
  sub_questions: Array<Polls_Question>;
  /** An aggregate relationship */
  sub_questions_aggregate: Polls_Question_Aggregate;
  /** An object relationship */
  template_answer_set: Polls_Templateanswerset;
  template_answer_set_id: Scalars['Int'];
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
  translated_description?: Maybe<Scalars['String']>;
  translated_name?: Maybe<Scalars['String']>;
  translation_progress?: Maybe<Scalars['json']>;
};


/** columns and relationships of "polls_question" */
export type Polls_QuestionAncestorsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Question_Order_By>>;
  where?: InputMaybe<Polls_Question_Bool_Exp>;
};


/** columns and relationships of "polls_question" */
export type Polls_QuestionBase_Answer_SetsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Baseanswerset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Baseanswerset_Order_By>>;
  where?: InputMaybe<Polls_Baseanswerset_Bool_Exp>;
};


/** columns and relationships of "polls_question" */
export type Polls_QuestionBase_Answer_Sets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Baseanswerset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Baseanswerset_Order_By>>;
  where?: InputMaybe<Polls_Baseanswerset_Bool_Exp>;
};


/** columns and relationships of "polls_question" */
export type Polls_QuestionRelated_Question_Ids_1Args = {
  distinct_on?: InputMaybe<Array<Polls_Questionrelation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Questionrelation_Order_By>>;
  where?: InputMaybe<Polls_Questionrelation_Bool_Exp>;
};


/** columns and relationships of "polls_question" */
export type Polls_QuestionRelated_Question_Ids_1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Questionrelation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Questionrelation_Order_By>>;
  where?: InputMaybe<Polls_Questionrelation_Bool_Exp>;
};


/** columns and relationships of "polls_question" */
export type Polls_QuestionRelated_Question_Ids_2Args = {
  distinct_on?: InputMaybe<Array<Polls_Questionrelation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Questionrelation_Order_By>>;
  where?: InputMaybe<Polls_Questionrelation_Bool_Exp>;
};


/** columns and relationships of "polls_question" */
export type Polls_QuestionRelated_Question_Ids_2_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Questionrelation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Questionrelation_Order_By>>;
  where?: InputMaybe<Polls_Questionrelation_Bool_Exp>;
};


/** columns and relationships of "polls_question" */
export type Polls_QuestionSub_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Question_Order_By>>;
  where?: InputMaybe<Polls_Question_Bool_Exp>;
};


/** columns and relationships of "polls_question" */
export type Polls_QuestionSub_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Question_Order_By>>;
  where?: InputMaybe<Polls_Question_Bool_Exp>;
};


/** columns and relationships of "polls_question" */
export type Polls_QuestionTranslated_DescriptionArgs = {
  args: Translated_Description_Polls_Question_Args;
};


/** columns and relationships of "polls_question" */
export type Polls_QuestionTranslated_NameArgs = {
  args: Translated_Name_Polls_Question_Args;
};


/** columns and relationships of "polls_question" */
export type Polls_QuestionTranslation_ProgressArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "polls_question" */
export type Polls_Question_Aggregate = {
  __typename?: 'polls_question_aggregate';
  aggregate?: Maybe<Polls_Question_Aggregate_Fields>;
  nodes: Array<Polls_Question>;
};

/** aggregate fields of "polls_question" */
export type Polls_Question_Aggregate_Fields = {
  __typename?: 'polls_question_aggregate_fields';
  avg?: Maybe<Polls_Question_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Question_Max_Fields>;
  min?: Maybe<Polls_Question_Min_Fields>;
  stddev?: Maybe<Polls_Question_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Question_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Question_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Question_Sum_Fields>;
  var_pop?: Maybe<Polls_Question_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Question_Var_Samp_Fields>;
  variance?: Maybe<Polls_Question_Variance_Fields>;
};


/** aggregate fields of "polls_question" */
export type Polls_Question_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Question_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "polls_question" */
export type Polls_Question_Aggregate_Order_By = {
  avg?: InputMaybe<Polls_Question_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Polls_Question_Max_Order_By>;
  min?: InputMaybe<Polls_Question_Min_Order_By>;
  stddev?: InputMaybe<Polls_Question_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Polls_Question_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Polls_Question_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Polls_Question_Sum_Order_By>;
  var_pop?: InputMaybe<Polls_Question_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Polls_Question_Var_Samp_Order_By>;
  variance?: InputMaybe<Polls_Question_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "polls_question" */
export type Polls_Question_Arr_Rel_Insert_Input = {
  data: Array<Polls_Question_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Question_On_Conflict>;
};

/** aggregate avg on columns */
export type Polls_Question_Avg_Fields = {
  __typename?: 'polls_question_avg_fields';
  category_id?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  parent_question_id?: Maybe<Scalars['Float']>;
  parent_template_answer_id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  template_answer_set_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "polls_question" */
export type Polls_Question_Avg_Order_By = {
  category_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_question_id?: InputMaybe<Order_By>;
  parent_template_answer_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_set_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "polls_question". All fields are combined with a logical 'AND'. */
export type Polls_Question_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Question_Bool_Exp>>;
  _not?: InputMaybe<Polls_Question_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Question_Bool_Exp>>;
  ancestors?: InputMaybe<Polls_Question_Bool_Exp>;
  base_answer_sets?: InputMaybe<Polls_Baseanswerset_Bool_Exp>;
  category?: InputMaybe<Polls_Category_Bool_Exp>;
  category_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  description_en?: InputMaybe<String_Comparison_Exp>;
  description_es?: InputMaybe<String_Comparison_Exp>;
  description_fr?: InputMaybe<String_Comparison_Exp>;
  description_ja?: InputMaybe<String_Comparison_Exp>;
  description_zh_hans?: InputMaybe<String_Comparison_Exp>;
  description_zh_hant?: InputMaybe<String_Comparison_Exp>;
  group?: InputMaybe<Polls_Group_Bool_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_priority?: InputMaybe<Boolean_Comparison_Exp>;
  multiple_answers_allowed?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  name_en?: InputMaybe<String_Comparison_Exp>;
  name_es?: InputMaybe<String_Comparison_Exp>;
  name_fr?: InputMaybe<String_Comparison_Exp>;
  name_ja?: InputMaybe<String_Comparison_Exp>;
  name_zh_hans?: InputMaybe<String_Comparison_Exp>;
  name_zh_hant?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  parent_question?: InputMaybe<Polls_Question_Bool_Exp>;
  parent_question_id?: InputMaybe<Int_Comparison_Exp>;
  parent_template_answer?: InputMaybe<Polls_Templateanswer_Bool_Exp>;
  parent_template_answer_id?: InputMaybe<Int_Comparison_Exp>;
  poll?: InputMaybe<Polls_Poll_Bool_Exp>;
  poll_id?: InputMaybe<Int_Comparison_Exp>;
  previous?: InputMaybe<Polls_Question_Bool_Exp>;
  previous_id?: InputMaybe<Int_Comparison_Exp>;
  related_question_ids_1?: InputMaybe<Polls_Questionrelation_Bool_Exp>;
  related_question_ids_2?: InputMaybe<Polls_Questionrelation_Bool_Exp>;
  sub_questions?: InputMaybe<Polls_Question_Bool_Exp>;
  template_answer_set?: InputMaybe<Polls_Templateanswerset_Bool_Exp>;
  template_answer_set_id?: InputMaybe<Int_Comparison_Exp>;
  tooltip?: InputMaybe<String_Comparison_Exp>;
  tooltip_en?: InputMaybe<String_Comparison_Exp>;
  tooltip_es?: InputMaybe<String_Comparison_Exp>;
  tooltip_fr?: InputMaybe<String_Comparison_Exp>;
  tooltip_ja?: InputMaybe<String_Comparison_Exp>;
  tooltip_zh_hans?: InputMaybe<String_Comparison_Exp>;
  tooltip_zh_hant?: InputMaybe<String_Comparison_Exp>;
  translation_progress?: InputMaybe<Json_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_question" */
export enum Polls_Question_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollsQuestionPkey = 'polls_question_pkey'
}

/** input type for incrementing numeric columns in table "polls_question" */
export type Polls_Question_Inc_Input = {
  category_id?: InputMaybe<Scalars['Int']>;
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  parent_question_id?: InputMaybe<Scalars['Int']>;
  parent_template_answer_id?: InputMaybe<Scalars['Int']>;
  poll_id?: InputMaybe<Scalars['Int']>;
  previous_id?: InputMaybe<Scalars['Int']>;
  template_answer_set_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_question" */
export type Polls_Question_Insert_Input = {
  base_answer_sets?: InputMaybe<Polls_Baseanswerset_Arr_Rel_Insert_Input>;
  category?: InputMaybe<Polls_Category_Obj_Rel_Insert_Input>;
  category_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  description_en?: InputMaybe<Scalars['String']>;
  description_es?: InputMaybe<Scalars['String']>;
  description_fr?: InputMaybe<Scalars['String']>;
  description_ja?: InputMaybe<Scalars['String']>;
  description_zh_hans?: InputMaybe<Scalars['String']>;
  description_zh_hant?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Polls_Group_Obj_Rel_Insert_Input>;
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_priority?: InputMaybe<Scalars['Boolean']>;
  multiple_answers_allowed?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parent_question?: InputMaybe<Polls_Question_Obj_Rel_Insert_Input>;
  parent_question_id?: InputMaybe<Scalars['Int']>;
  parent_template_answer?: InputMaybe<Polls_Templateanswer_Obj_Rel_Insert_Input>;
  parent_template_answer_id?: InputMaybe<Scalars['Int']>;
  poll?: InputMaybe<Polls_Poll_Obj_Rel_Insert_Input>;
  poll_id?: InputMaybe<Scalars['Int']>;
  previous?: InputMaybe<Polls_Question_Obj_Rel_Insert_Input>;
  previous_id?: InputMaybe<Scalars['Int']>;
  related_question_ids_1?: InputMaybe<Polls_Questionrelation_Arr_Rel_Insert_Input>;
  related_question_ids_2?: InputMaybe<Polls_Questionrelation_Arr_Rel_Insert_Input>;
  sub_questions?: InputMaybe<Polls_Question_Arr_Rel_Insert_Input>;
  template_answer_set?: InputMaybe<Polls_Templateanswerset_Obj_Rel_Insert_Input>;
  template_answer_set_id?: InputMaybe<Scalars['Int']>;
  tooltip?: InputMaybe<Scalars['String']>;
  tooltip_en?: InputMaybe<Scalars['String']>;
  tooltip_es?: InputMaybe<Scalars['String']>;
  tooltip_fr?: InputMaybe<Scalars['String']>;
  tooltip_ja?: InputMaybe<Scalars['String']>;
  tooltip_zh_hans?: InputMaybe<Scalars['String']>;
  tooltip_zh_hant?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Polls_Question_Max_Fields = {
  __typename?: 'polls_question_max_fields';
  category_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  description_en?: Maybe<Scalars['String']>;
  description_es?: Maybe<Scalars['String']>;
  description_fr?: Maybe<Scalars['String']>;
  description_ja?: Maybe<Scalars['String']>;
  description_zh_hans?: Maybe<Scalars['String']>;
  description_zh_hant?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  parent_question_id?: Maybe<Scalars['Int']>;
  parent_template_answer_id?: Maybe<Scalars['Int']>;
  poll_id?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
  template_answer_set_id?: Maybe<Scalars['Int']>;
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "polls_question" */
export type Polls_Question_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  description_en?: InputMaybe<Order_By>;
  description_es?: InputMaybe<Order_By>;
  description_fr?: InputMaybe<Order_By>;
  description_ja?: InputMaybe<Order_By>;
  description_zh_hans?: InputMaybe<Order_By>;
  description_zh_hant?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_question_id?: InputMaybe<Order_By>;
  parent_template_answer_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_set_id?: InputMaybe<Order_By>;
  tooltip?: InputMaybe<Order_By>;
  tooltip_en?: InputMaybe<Order_By>;
  tooltip_es?: InputMaybe<Order_By>;
  tooltip_fr?: InputMaybe<Order_By>;
  tooltip_ja?: InputMaybe<Order_By>;
  tooltip_zh_hans?: InputMaybe<Order_By>;
  tooltip_zh_hant?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Polls_Question_Min_Fields = {
  __typename?: 'polls_question_min_fields';
  category_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  description_en?: Maybe<Scalars['String']>;
  description_es?: Maybe<Scalars['String']>;
  description_fr?: Maybe<Scalars['String']>;
  description_ja?: Maybe<Scalars['String']>;
  description_zh_hans?: Maybe<Scalars['String']>;
  description_zh_hant?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  parent_question_id?: Maybe<Scalars['Int']>;
  parent_template_answer_id?: Maybe<Scalars['Int']>;
  poll_id?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
  template_answer_set_id?: Maybe<Scalars['Int']>;
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "polls_question" */
export type Polls_Question_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  description_en?: InputMaybe<Order_By>;
  description_es?: InputMaybe<Order_By>;
  description_fr?: InputMaybe<Order_By>;
  description_ja?: InputMaybe<Order_By>;
  description_zh_hans?: InputMaybe<Order_By>;
  description_zh_hant?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_question_id?: InputMaybe<Order_By>;
  parent_template_answer_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_set_id?: InputMaybe<Order_By>;
  tooltip?: InputMaybe<Order_By>;
  tooltip_en?: InputMaybe<Order_By>;
  tooltip_es?: InputMaybe<Order_By>;
  tooltip_fr?: InputMaybe<Order_By>;
  tooltip_ja?: InputMaybe<Order_By>;
  tooltip_zh_hans?: InputMaybe<Order_By>;
  tooltip_zh_hant?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "polls_question" */
export type Polls_Question_Mutation_Response = {
  __typename?: 'polls_question_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Question>;
};

/** input type for inserting object relation for remote table "polls_question" */
export type Polls_Question_Obj_Rel_Insert_Input = {
  data: Polls_Question_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Question_On_Conflict>;
};

/** on_conflict condition type for table "polls_question" */
export type Polls_Question_On_Conflict = {
  constraint: Polls_Question_Constraint;
  update_columns?: Array<Polls_Question_Update_Column>;
  where?: InputMaybe<Polls_Question_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_question". */
export type Polls_Question_Order_By = {
  ancestors_aggregate?: InputMaybe<Polls_Question_Aggregate_Order_By>;
  base_answer_sets_aggregate?: InputMaybe<Polls_Baseanswerset_Aggregate_Order_By>;
  category?: InputMaybe<Polls_Category_Order_By>;
  category_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  description_en?: InputMaybe<Order_By>;
  description_es?: InputMaybe<Order_By>;
  description_fr?: InputMaybe<Order_By>;
  description_ja?: InputMaybe<Order_By>;
  description_zh_hans?: InputMaybe<Order_By>;
  description_zh_hant?: InputMaybe<Order_By>;
  group?: InputMaybe<Polls_Group_Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_priority?: InputMaybe<Order_By>;
  multiple_answers_allowed?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_question?: InputMaybe<Polls_Question_Order_By>;
  parent_question_id?: InputMaybe<Order_By>;
  parent_template_answer?: InputMaybe<Polls_Templateanswer_Order_By>;
  parent_template_answer_id?: InputMaybe<Order_By>;
  poll?: InputMaybe<Polls_Poll_Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous?: InputMaybe<Polls_Question_Order_By>;
  previous_id?: InputMaybe<Order_By>;
  related_question_ids_1_aggregate?: InputMaybe<Polls_Questionrelation_Aggregate_Order_By>;
  related_question_ids_2_aggregate?: InputMaybe<Polls_Questionrelation_Aggregate_Order_By>;
  sub_questions_aggregate?: InputMaybe<Polls_Question_Aggregate_Order_By>;
  template_answer_set?: InputMaybe<Polls_Templateanswerset_Order_By>;
  template_answer_set_id?: InputMaybe<Order_By>;
  tooltip?: InputMaybe<Order_By>;
  tooltip_en?: InputMaybe<Order_By>;
  tooltip_es?: InputMaybe<Order_By>;
  tooltip_fr?: InputMaybe<Order_By>;
  tooltip_ja?: InputMaybe<Order_By>;
  tooltip_zh_hans?: InputMaybe<Order_By>;
  tooltip_zh_hant?: InputMaybe<Order_By>;
  translation_progress?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_question */
export type Polls_Question_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_question" */
export enum Polls_Question_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Description = 'description',
  /** column name */
  DescriptionEn = 'description_en',
  /** column name */
  DescriptionEs = 'description_es',
  /** column name */
  DescriptionFr = 'description_fr',
  /** column name */
  DescriptionJa = 'description_ja',
  /** column name */
  DescriptionZhHans = 'description_zh_hans',
  /** column name */
  DescriptionZhHant = 'description_zh_hant',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsPriority = 'is_priority',
  /** column name */
  MultipleAnswersAllowed = 'multiple_answers_allowed',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant',
  /** column name */
  Order = 'order',
  /** column name */
  ParentQuestionId = 'parent_question_id',
  /** column name */
  ParentTemplateAnswerId = 'parent_template_answer_id',
  /** column name */
  PollId = 'poll_id',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  TemplateAnswerSetId = 'template_answer_set_id',
  /** column name */
  Tooltip = 'tooltip',
  /** column name */
  TooltipEn = 'tooltip_en',
  /** column name */
  TooltipEs = 'tooltip_es',
  /** column name */
  TooltipFr = 'tooltip_fr',
  /** column name */
  TooltipJa = 'tooltip_ja',
  /** column name */
  TooltipZhHans = 'tooltip_zh_hans',
  /** column name */
  TooltipZhHant = 'tooltip_zh_hant'
}

/** input type for updating data in table "polls_question" */
export type Polls_Question_Set_Input = {
  category_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  description_en?: InputMaybe<Scalars['String']>;
  description_es?: InputMaybe<Scalars['String']>;
  description_fr?: InputMaybe<Scalars['String']>;
  description_ja?: InputMaybe<Scalars['String']>;
  description_zh_hans?: InputMaybe<Scalars['String']>;
  description_zh_hant?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_priority?: InputMaybe<Scalars['Boolean']>;
  multiple_answers_allowed?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parent_question_id?: InputMaybe<Scalars['Int']>;
  parent_template_answer_id?: InputMaybe<Scalars['Int']>;
  poll_id?: InputMaybe<Scalars['Int']>;
  previous_id?: InputMaybe<Scalars['Int']>;
  template_answer_set_id?: InputMaybe<Scalars['Int']>;
  tooltip?: InputMaybe<Scalars['String']>;
  tooltip_en?: InputMaybe<Scalars['String']>;
  tooltip_es?: InputMaybe<Scalars['String']>;
  tooltip_fr?: InputMaybe<Scalars['String']>;
  tooltip_ja?: InputMaybe<Scalars['String']>;
  tooltip_zh_hans?: InputMaybe<Scalars['String']>;
  tooltip_zh_hant?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Polls_Question_Stddev_Fields = {
  __typename?: 'polls_question_stddev_fields';
  category_id?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  parent_question_id?: Maybe<Scalars['Float']>;
  parent_template_answer_id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  template_answer_set_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "polls_question" */
export type Polls_Question_Stddev_Order_By = {
  category_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_question_id?: InputMaybe<Order_By>;
  parent_template_answer_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_set_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Polls_Question_Stddev_Pop_Fields = {
  __typename?: 'polls_question_stddev_pop_fields';
  category_id?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  parent_question_id?: Maybe<Scalars['Float']>;
  parent_template_answer_id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  template_answer_set_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "polls_question" */
export type Polls_Question_Stddev_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_question_id?: InputMaybe<Order_By>;
  parent_template_answer_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_set_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Polls_Question_Stddev_Samp_Fields = {
  __typename?: 'polls_question_stddev_samp_fields';
  category_id?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  parent_question_id?: Maybe<Scalars['Float']>;
  parent_template_answer_id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  template_answer_set_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "polls_question" */
export type Polls_Question_Stddev_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_question_id?: InputMaybe<Order_By>;
  parent_template_answer_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_set_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Polls_Question_Sum_Fields = {
  __typename?: 'polls_question_sum_fields';
  category_id?: Maybe<Scalars['Int']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  parent_question_id?: Maybe<Scalars['Int']>;
  parent_template_answer_id?: Maybe<Scalars['Int']>;
  poll_id?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
  template_answer_set_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "polls_question" */
export type Polls_Question_Sum_Order_By = {
  category_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_question_id?: InputMaybe<Order_By>;
  parent_template_answer_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_set_id?: InputMaybe<Order_By>;
};

/** update columns of table "polls_question" */
export enum Polls_Question_Update_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Description = 'description',
  /** column name */
  DescriptionEn = 'description_en',
  /** column name */
  DescriptionEs = 'description_es',
  /** column name */
  DescriptionFr = 'description_fr',
  /** column name */
  DescriptionJa = 'description_ja',
  /** column name */
  DescriptionZhHans = 'description_zh_hans',
  /** column name */
  DescriptionZhHant = 'description_zh_hant',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsPriority = 'is_priority',
  /** column name */
  MultipleAnswersAllowed = 'multiple_answers_allowed',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant',
  /** column name */
  Order = 'order',
  /** column name */
  ParentQuestionId = 'parent_question_id',
  /** column name */
  ParentTemplateAnswerId = 'parent_template_answer_id',
  /** column name */
  PollId = 'poll_id',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  TemplateAnswerSetId = 'template_answer_set_id',
  /** column name */
  Tooltip = 'tooltip',
  /** column name */
  TooltipEn = 'tooltip_en',
  /** column name */
  TooltipEs = 'tooltip_es',
  /** column name */
  TooltipFr = 'tooltip_fr',
  /** column name */
  TooltipJa = 'tooltip_ja',
  /** column name */
  TooltipZhHans = 'tooltip_zh_hans',
  /** column name */
  TooltipZhHant = 'tooltip_zh_hant'
}

/** aggregate var_pop on columns */
export type Polls_Question_Var_Pop_Fields = {
  __typename?: 'polls_question_var_pop_fields';
  category_id?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  parent_question_id?: Maybe<Scalars['Float']>;
  parent_template_answer_id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  template_answer_set_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "polls_question" */
export type Polls_Question_Var_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_question_id?: InputMaybe<Order_By>;
  parent_template_answer_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_set_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Polls_Question_Var_Samp_Fields = {
  __typename?: 'polls_question_var_samp_fields';
  category_id?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  parent_question_id?: Maybe<Scalars['Float']>;
  parent_template_answer_id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  template_answer_set_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "polls_question" */
export type Polls_Question_Var_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_question_id?: InputMaybe<Order_By>;
  parent_template_answer_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_set_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Polls_Question_Variance_Fields = {
  __typename?: 'polls_question_variance_fields';
  category_id?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  parent_question_id?: Maybe<Scalars['Float']>;
  parent_template_answer_id?: Maybe<Scalars['Float']>;
  poll_id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  template_answer_set_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "polls_question" */
export type Polls_Question_Variance_Order_By = {
  category_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent_question_id?: InputMaybe<Order_By>;
  parent_template_answer_id?: InputMaybe<Order_By>;
  poll_id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_set_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "polls_questionrelation" */
export type Polls_Questionrelation = {
  __typename?: 'polls_questionrelation';
  /** An object relationship */
  first_question: Polls_Question;
  first_question_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  second_question: Polls_Question;
  second_question_id: Scalars['Int'];
};

/** aggregated selection of "polls_questionrelation" */
export type Polls_Questionrelation_Aggregate = {
  __typename?: 'polls_questionrelation_aggregate';
  aggregate?: Maybe<Polls_Questionrelation_Aggregate_Fields>;
  nodes: Array<Polls_Questionrelation>;
};

/** aggregate fields of "polls_questionrelation" */
export type Polls_Questionrelation_Aggregate_Fields = {
  __typename?: 'polls_questionrelation_aggregate_fields';
  avg?: Maybe<Polls_Questionrelation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Questionrelation_Max_Fields>;
  min?: Maybe<Polls_Questionrelation_Min_Fields>;
  stddev?: Maybe<Polls_Questionrelation_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Questionrelation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Questionrelation_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Questionrelation_Sum_Fields>;
  var_pop?: Maybe<Polls_Questionrelation_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Questionrelation_Var_Samp_Fields>;
  variance?: Maybe<Polls_Questionrelation_Variance_Fields>;
};


/** aggregate fields of "polls_questionrelation" */
export type Polls_Questionrelation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Questionrelation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "polls_questionrelation" */
export type Polls_Questionrelation_Aggregate_Order_By = {
  avg?: InputMaybe<Polls_Questionrelation_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Polls_Questionrelation_Max_Order_By>;
  min?: InputMaybe<Polls_Questionrelation_Min_Order_By>;
  stddev?: InputMaybe<Polls_Questionrelation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Polls_Questionrelation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Polls_Questionrelation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Polls_Questionrelation_Sum_Order_By>;
  var_pop?: InputMaybe<Polls_Questionrelation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Polls_Questionrelation_Var_Samp_Order_By>;
  variance?: InputMaybe<Polls_Questionrelation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "polls_questionrelation" */
export type Polls_Questionrelation_Arr_Rel_Insert_Input = {
  data: Array<Polls_Questionrelation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Questionrelation_On_Conflict>;
};

/** aggregate avg on columns */
export type Polls_Questionrelation_Avg_Fields = {
  __typename?: 'polls_questionrelation_avg_fields';
  first_question_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  second_question_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "polls_questionrelation" */
export type Polls_Questionrelation_Avg_Order_By = {
  first_question_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  second_question_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "polls_questionrelation". All fields are combined with a logical 'AND'. */
export type Polls_Questionrelation_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Questionrelation_Bool_Exp>>;
  _not?: InputMaybe<Polls_Questionrelation_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Questionrelation_Bool_Exp>>;
  first_question?: InputMaybe<Polls_Question_Bool_Exp>;
  first_question_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  second_question?: InputMaybe<Polls_Question_Bool_Exp>;
  second_question_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_questionrelation" */
export enum Polls_Questionrelation_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollsQuestionrelationPkey = 'polls_questionrelation_pkey'
}

/** input type for incrementing numeric columns in table "polls_questionrelation" */
export type Polls_Questionrelation_Inc_Input = {
  first_question_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  second_question_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_questionrelation" */
export type Polls_Questionrelation_Insert_Input = {
  first_question?: InputMaybe<Polls_Question_Obj_Rel_Insert_Input>;
  first_question_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  second_question?: InputMaybe<Polls_Question_Obj_Rel_Insert_Input>;
  second_question_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Polls_Questionrelation_Max_Fields = {
  __typename?: 'polls_questionrelation_max_fields';
  first_question_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  second_question_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "polls_questionrelation" */
export type Polls_Questionrelation_Max_Order_By = {
  first_question_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  second_question_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Polls_Questionrelation_Min_Fields = {
  __typename?: 'polls_questionrelation_min_fields';
  first_question_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  second_question_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "polls_questionrelation" */
export type Polls_Questionrelation_Min_Order_By = {
  first_question_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  second_question_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "polls_questionrelation" */
export type Polls_Questionrelation_Mutation_Response = {
  __typename?: 'polls_questionrelation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Questionrelation>;
};

/** on_conflict condition type for table "polls_questionrelation" */
export type Polls_Questionrelation_On_Conflict = {
  constraint: Polls_Questionrelation_Constraint;
  update_columns?: Array<Polls_Questionrelation_Update_Column>;
  where?: InputMaybe<Polls_Questionrelation_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_questionrelation". */
export type Polls_Questionrelation_Order_By = {
  first_question?: InputMaybe<Polls_Question_Order_By>;
  first_question_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  second_question?: InputMaybe<Polls_Question_Order_By>;
  second_question_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_questionrelation */
export type Polls_Questionrelation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_questionrelation" */
export enum Polls_Questionrelation_Select_Column {
  /** column name */
  FirstQuestionId = 'first_question_id',
  /** column name */
  Id = 'id',
  /** column name */
  SecondQuestionId = 'second_question_id'
}

/** input type for updating data in table "polls_questionrelation" */
export type Polls_Questionrelation_Set_Input = {
  first_question_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  second_question_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Polls_Questionrelation_Stddev_Fields = {
  __typename?: 'polls_questionrelation_stddev_fields';
  first_question_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  second_question_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "polls_questionrelation" */
export type Polls_Questionrelation_Stddev_Order_By = {
  first_question_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  second_question_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Polls_Questionrelation_Stddev_Pop_Fields = {
  __typename?: 'polls_questionrelation_stddev_pop_fields';
  first_question_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  second_question_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "polls_questionrelation" */
export type Polls_Questionrelation_Stddev_Pop_Order_By = {
  first_question_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  second_question_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Polls_Questionrelation_Stddev_Samp_Fields = {
  __typename?: 'polls_questionrelation_stddev_samp_fields';
  first_question_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  second_question_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "polls_questionrelation" */
export type Polls_Questionrelation_Stddev_Samp_Order_By = {
  first_question_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  second_question_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Polls_Questionrelation_Sum_Fields = {
  __typename?: 'polls_questionrelation_sum_fields';
  first_question_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  second_question_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "polls_questionrelation" */
export type Polls_Questionrelation_Sum_Order_By = {
  first_question_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  second_question_id?: InputMaybe<Order_By>;
};

/** update columns of table "polls_questionrelation" */
export enum Polls_Questionrelation_Update_Column {
  /** column name */
  FirstQuestionId = 'first_question_id',
  /** column name */
  Id = 'id',
  /** column name */
  SecondQuestionId = 'second_question_id'
}

/** aggregate var_pop on columns */
export type Polls_Questionrelation_Var_Pop_Fields = {
  __typename?: 'polls_questionrelation_var_pop_fields';
  first_question_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  second_question_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "polls_questionrelation" */
export type Polls_Questionrelation_Var_Pop_Order_By = {
  first_question_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  second_question_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Polls_Questionrelation_Var_Samp_Fields = {
  __typename?: 'polls_questionrelation_var_samp_fields';
  first_question_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  second_question_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "polls_questionrelation" */
export type Polls_Questionrelation_Var_Samp_Order_By = {
  first_question_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  second_question_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Polls_Questionrelation_Variance_Fields = {
  __typename?: 'polls_questionrelation_variance_fields';
  first_question_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  second_question_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "polls_questionrelation" */
export type Polls_Questionrelation_Variance_Order_By = {
  first_question_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  second_question_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "polls_searchrequest" */
export type Polls_Searchrequest = {
  __typename?: 'polls_searchrequest';
  created_by_id?: Maybe<Scalars['Int']>;
  date_created: Scalars['timestamptz'];
  entries_negation: Scalars['Boolean'];
  entry_sources?: Maybe<Scalars['_int4']>;
  experts_negation: Scalars['Boolean'];
  full_text_exclude: Scalars['_varchar'];
  full_text_groups: Scalars['_varchar'];
  historic_answers_sets_count: Scalars['Int'];
  id: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  questions_negation: Scalars['Boolean'];
  region_area_id?: Maybe<Scalars['Int']>;
  regions_negation: Scalars['Boolean'];
  saved: Scalars['Boolean'];
  year_from?: Maybe<Scalars['Int']>;
  year_to?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "polls_searchrequest" */
export type Polls_Searchrequest_Aggregate = {
  __typename?: 'polls_searchrequest_aggregate';
  aggregate?: Maybe<Polls_Searchrequest_Aggregate_Fields>;
  nodes: Array<Polls_Searchrequest>;
};

/** aggregate fields of "polls_searchrequest" */
export type Polls_Searchrequest_Aggregate_Fields = {
  __typename?: 'polls_searchrequest_aggregate_fields';
  avg?: Maybe<Polls_Searchrequest_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Searchrequest_Max_Fields>;
  min?: Maybe<Polls_Searchrequest_Min_Fields>;
  stddev?: Maybe<Polls_Searchrequest_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Searchrequest_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Searchrequest_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Searchrequest_Sum_Fields>;
  var_pop?: Maybe<Polls_Searchrequest_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Searchrequest_Var_Samp_Fields>;
  variance?: Maybe<Polls_Searchrequest_Variance_Fields>;
};


/** aggregate fields of "polls_searchrequest" */
export type Polls_Searchrequest_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Searchrequest_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Polls_Searchrequest_Avg_Fields = {
  __typename?: 'polls_searchrequest_avg_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  historic_answers_sets_count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_area_id?: Maybe<Scalars['Float']>;
  year_from?: Maybe<Scalars['Float']>;
  year_to?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "polls_searchrequest". All fields are combined with a logical 'AND'. */
export type Polls_Searchrequest_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Searchrequest_Bool_Exp>>;
  _not?: InputMaybe<Polls_Searchrequest_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Searchrequest_Bool_Exp>>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  date_created?: InputMaybe<Timestamptz_Comparison_Exp>;
  entries_negation?: InputMaybe<Boolean_Comparison_Exp>;
  entry_sources?: InputMaybe<_Int4_Comparison_Exp>;
  experts_negation?: InputMaybe<Boolean_Comparison_Exp>;
  full_text_exclude?: InputMaybe<_Varchar_Comparison_Exp>;
  full_text_groups?: InputMaybe<_Varchar_Comparison_Exp>;
  historic_answers_sets_count?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  questions_negation?: InputMaybe<Boolean_Comparison_Exp>;
  region_area_id?: InputMaybe<Int_Comparison_Exp>;
  regions_negation?: InputMaybe<Boolean_Comparison_Exp>;
  saved?: InputMaybe<Boolean_Comparison_Exp>;
  year_from?: InputMaybe<Int_Comparison_Exp>;
  year_to?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_searchrequest" */
export enum Polls_Searchrequest_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollsSearchrequestPkey = 'polls_searchrequest_pkey'
}

/** input type for incrementing numeric columns in table "polls_searchrequest" */
export type Polls_Searchrequest_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['Int']>;
  historic_answers_sets_count?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  region_area_id?: InputMaybe<Scalars['Int']>;
  year_from?: InputMaybe<Scalars['Int']>;
  year_to?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_searchrequest" */
export type Polls_Searchrequest_Insert_Input = {
  created_by_id?: InputMaybe<Scalars['Int']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  entries_negation?: InputMaybe<Scalars['Boolean']>;
  entry_sources?: InputMaybe<Scalars['_int4']>;
  experts_negation?: InputMaybe<Scalars['Boolean']>;
  full_text_exclude?: InputMaybe<Scalars['_varchar']>;
  full_text_groups?: InputMaybe<Scalars['_varchar']>;
  historic_answers_sets_count?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  questions_negation?: InputMaybe<Scalars['Boolean']>;
  region_area_id?: InputMaybe<Scalars['Int']>;
  regions_negation?: InputMaybe<Scalars['Boolean']>;
  saved?: InputMaybe<Scalars['Boolean']>;
  year_from?: InputMaybe<Scalars['Int']>;
  year_to?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Polls_Searchrequest_Max_Fields = {
  __typename?: 'polls_searchrequest_max_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['timestamptz']>;
  historic_answers_sets_count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  region_area_id?: Maybe<Scalars['Int']>;
  year_from?: Maybe<Scalars['Int']>;
  year_to?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Polls_Searchrequest_Min_Fields = {
  __typename?: 'polls_searchrequest_min_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['timestamptz']>;
  historic_answers_sets_count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  region_area_id?: Maybe<Scalars['Int']>;
  year_from?: Maybe<Scalars['Int']>;
  year_to?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "polls_searchrequest" */
export type Polls_Searchrequest_Mutation_Response = {
  __typename?: 'polls_searchrequest_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Searchrequest>;
};

/** on_conflict condition type for table "polls_searchrequest" */
export type Polls_Searchrequest_On_Conflict = {
  constraint: Polls_Searchrequest_Constraint;
  update_columns?: Array<Polls_Searchrequest_Update_Column>;
  where?: InputMaybe<Polls_Searchrequest_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_searchrequest". */
export type Polls_Searchrequest_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  date_created?: InputMaybe<Order_By>;
  entries_negation?: InputMaybe<Order_By>;
  entry_sources?: InputMaybe<Order_By>;
  experts_negation?: InputMaybe<Order_By>;
  full_text_exclude?: InputMaybe<Order_By>;
  full_text_groups?: InputMaybe<Order_By>;
  historic_answers_sets_count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  questions_negation?: InputMaybe<Order_By>;
  region_area_id?: InputMaybe<Order_By>;
  regions_negation?: InputMaybe<Order_By>;
  saved?: InputMaybe<Order_By>;
  year_from?: InputMaybe<Order_By>;
  year_to?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_searchrequest */
export type Polls_Searchrequest_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_searchrequest" */
export enum Polls_Searchrequest_Select_Column {
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  EntriesNegation = 'entries_negation',
  /** column name */
  EntrySources = 'entry_sources',
  /** column name */
  ExpertsNegation = 'experts_negation',
  /** column name */
  FullTextExclude = 'full_text_exclude',
  /** column name */
  FullTextGroups = 'full_text_groups',
  /** column name */
  HistoricAnswersSetsCount = 'historic_answers_sets_count',
  /** column name */
  Id = 'id',
  /** column name */
  Note = 'note',
  /** column name */
  QuestionsNegation = 'questions_negation',
  /** column name */
  RegionAreaId = 'region_area_id',
  /** column name */
  RegionsNegation = 'regions_negation',
  /** column name */
  Saved = 'saved',
  /** column name */
  YearFrom = 'year_from',
  /** column name */
  YearTo = 'year_to'
}

/** input type for updating data in table "polls_searchrequest" */
export type Polls_Searchrequest_Set_Input = {
  created_by_id?: InputMaybe<Scalars['Int']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  entries_negation?: InputMaybe<Scalars['Boolean']>;
  entry_sources?: InputMaybe<Scalars['_int4']>;
  experts_negation?: InputMaybe<Scalars['Boolean']>;
  full_text_exclude?: InputMaybe<Scalars['_varchar']>;
  full_text_groups?: InputMaybe<Scalars['_varchar']>;
  historic_answers_sets_count?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  questions_negation?: InputMaybe<Scalars['Boolean']>;
  region_area_id?: InputMaybe<Scalars['Int']>;
  regions_negation?: InputMaybe<Scalars['Boolean']>;
  saved?: InputMaybe<Scalars['Boolean']>;
  year_from?: InputMaybe<Scalars['Int']>;
  year_to?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Polls_Searchrequest_Stddev_Fields = {
  __typename?: 'polls_searchrequest_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  historic_answers_sets_count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_area_id?: Maybe<Scalars['Float']>;
  year_from?: Maybe<Scalars['Float']>;
  year_to?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Polls_Searchrequest_Stddev_Pop_Fields = {
  __typename?: 'polls_searchrequest_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  historic_answers_sets_count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_area_id?: Maybe<Scalars['Float']>;
  year_from?: Maybe<Scalars['Float']>;
  year_to?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Polls_Searchrequest_Stddev_Samp_Fields = {
  __typename?: 'polls_searchrequest_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  historic_answers_sets_count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_area_id?: Maybe<Scalars['Float']>;
  year_from?: Maybe<Scalars['Float']>;
  year_to?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Polls_Searchrequest_Sum_Fields = {
  __typename?: 'polls_searchrequest_sum_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  historic_answers_sets_count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  region_area_id?: Maybe<Scalars['Int']>;
  year_from?: Maybe<Scalars['Int']>;
  year_to?: Maybe<Scalars['Int']>;
};

/** update columns of table "polls_searchrequest" */
export enum Polls_Searchrequest_Update_Column {
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  EntriesNegation = 'entries_negation',
  /** column name */
  EntrySources = 'entry_sources',
  /** column name */
  ExpertsNegation = 'experts_negation',
  /** column name */
  FullTextExclude = 'full_text_exclude',
  /** column name */
  FullTextGroups = 'full_text_groups',
  /** column name */
  HistoricAnswersSetsCount = 'historic_answers_sets_count',
  /** column name */
  Id = 'id',
  /** column name */
  Note = 'note',
  /** column name */
  QuestionsNegation = 'questions_negation',
  /** column name */
  RegionAreaId = 'region_area_id',
  /** column name */
  RegionsNegation = 'regions_negation',
  /** column name */
  Saved = 'saved',
  /** column name */
  YearFrom = 'year_from',
  /** column name */
  YearTo = 'year_to'
}

/** aggregate var_pop on columns */
export type Polls_Searchrequest_Var_Pop_Fields = {
  __typename?: 'polls_searchrequest_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  historic_answers_sets_count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_area_id?: Maybe<Scalars['Float']>;
  year_from?: Maybe<Scalars['Float']>;
  year_to?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Polls_Searchrequest_Var_Samp_Fields = {
  __typename?: 'polls_searchrequest_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  historic_answers_sets_count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_area_id?: Maybe<Scalars['Float']>;
  year_from?: Maybe<Scalars['Float']>;
  year_to?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Polls_Searchrequest_Variance_Fields = {
  __typename?: 'polls_searchrequest_variance_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  historic_answers_sets_count?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  region_area_id?: Maybe<Scalars['Float']>;
  year_from?: Maybe<Scalars['Float']>;
  year_to?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "polls_secondarysource" */
export type Polls_Secondarysource = {
  __typename?: 'polls_secondarysource';
  /** An array relationship */
  entities: Array<Polls_Entity>;
  /** An aggregate relationship */
  entities_aggregate: Polls_Entity_Aggregate;
  id: Scalars['Int'];
  title: Scalars['String'];
  title_en?: Maybe<Scalars['String']>;
  title_es?: Maybe<Scalars['String']>;
  title_fr?: Maybe<Scalars['String']>;
  title_ja?: Maybe<Scalars['String']>;
  title_zh_hans?: Maybe<Scalars['String']>;
  title_zh_hant?: Maybe<Scalars['String']>;
};


/** columns and relationships of "polls_secondarysource" */
export type Polls_SecondarysourceEntitiesArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Order_By>>;
  where?: InputMaybe<Polls_Entity_Bool_Exp>;
};


/** columns and relationships of "polls_secondarysource" */
export type Polls_SecondarysourceEntities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Order_By>>;
  where?: InputMaybe<Polls_Entity_Bool_Exp>;
};

/** aggregated selection of "polls_secondarysource" */
export type Polls_Secondarysource_Aggregate = {
  __typename?: 'polls_secondarysource_aggregate';
  aggregate?: Maybe<Polls_Secondarysource_Aggregate_Fields>;
  nodes: Array<Polls_Secondarysource>;
};

/** aggregate fields of "polls_secondarysource" */
export type Polls_Secondarysource_Aggregate_Fields = {
  __typename?: 'polls_secondarysource_aggregate_fields';
  avg?: Maybe<Polls_Secondarysource_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Secondarysource_Max_Fields>;
  min?: Maybe<Polls_Secondarysource_Min_Fields>;
  stddev?: Maybe<Polls_Secondarysource_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Secondarysource_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Secondarysource_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Secondarysource_Sum_Fields>;
  var_pop?: Maybe<Polls_Secondarysource_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Secondarysource_Var_Samp_Fields>;
  variance?: Maybe<Polls_Secondarysource_Variance_Fields>;
};


/** aggregate fields of "polls_secondarysource" */
export type Polls_Secondarysource_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Secondarysource_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Polls_Secondarysource_Avg_Fields = {
  __typename?: 'polls_secondarysource_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "polls_secondarysource". All fields are combined with a logical 'AND'. */
export type Polls_Secondarysource_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Secondarysource_Bool_Exp>>;
  _not?: InputMaybe<Polls_Secondarysource_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Secondarysource_Bool_Exp>>;
  entities?: InputMaybe<Polls_Entity_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  title_en?: InputMaybe<String_Comparison_Exp>;
  title_es?: InputMaybe<String_Comparison_Exp>;
  title_fr?: InputMaybe<String_Comparison_Exp>;
  title_ja?: InputMaybe<String_Comparison_Exp>;
  title_zh_hans?: InputMaybe<String_Comparison_Exp>;
  title_zh_hant?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_secondarysource" */
export enum Polls_Secondarysource_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollsSecondarysourcePkey = 'polls_secondarysource_pkey'
}

/** input type for incrementing numeric columns in table "polls_secondarysource" */
export type Polls_Secondarysource_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_secondarysource" */
export type Polls_Secondarysource_Insert_Input = {
  entities?: InputMaybe<Polls_Entity_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  title_en?: InputMaybe<Scalars['String']>;
  title_es?: InputMaybe<Scalars['String']>;
  title_fr?: InputMaybe<Scalars['String']>;
  title_ja?: InputMaybe<Scalars['String']>;
  title_zh_hans?: InputMaybe<Scalars['String']>;
  title_zh_hant?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Polls_Secondarysource_Max_Fields = {
  __typename?: 'polls_secondarysource_max_fields';
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  title_en?: Maybe<Scalars['String']>;
  title_es?: Maybe<Scalars['String']>;
  title_fr?: Maybe<Scalars['String']>;
  title_ja?: Maybe<Scalars['String']>;
  title_zh_hans?: Maybe<Scalars['String']>;
  title_zh_hant?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Polls_Secondarysource_Min_Fields = {
  __typename?: 'polls_secondarysource_min_fields';
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  title_en?: Maybe<Scalars['String']>;
  title_es?: Maybe<Scalars['String']>;
  title_fr?: Maybe<Scalars['String']>;
  title_ja?: Maybe<Scalars['String']>;
  title_zh_hans?: Maybe<Scalars['String']>;
  title_zh_hant?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "polls_secondarysource" */
export type Polls_Secondarysource_Mutation_Response = {
  __typename?: 'polls_secondarysource_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Secondarysource>;
};

/** input type for inserting object relation for remote table "polls_secondarysource" */
export type Polls_Secondarysource_Obj_Rel_Insert_Input = {
  data: Polls_Secondarysource_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Secondarysource_On_Conflict>;
};

/** on_conflict condition type for table "polls_secondarysource" */
export type Polls_Secondarysource_On_Conflict = {
  constraint: Polls_Secondarysource_Constraint;
  update_columns?: Array<Polls_Secondarysource_Update_Column>;
  where?: InputMaybe<Polls_Secondarysource_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_secondarysource". */
export type Polls_Secondarysource_Order_By = {
  entities_aggregate?: InputMaybe<Polls_Entity_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  title_en?: InputMaybe<Order_By>;
  title_es?: InputMaybe<Order_By>;
  title_fr?: InputMaybe<Order_By>;
  title_ja?: InputMaybe<Order_By>;
  title_zh_hans?: InputMaybe<Order_By>;
  title_zh_hant?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_secondarysource */
export type Polls_Secondarysource_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_secondarysource" */
export enum Polls_Secondarysource_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  TitleEn = 'title_en',
  /** column name */
  TitleEs = 'title_es',
  /** column name */
  TitleFr = 'title_fr',
  /** column name */
  TitleJa = 'title_ja',
  /** column name */
  TitleZhHans = 'title_zh_hans',
  /** column name */
  TitleZhHant = 'title_zh_hant'
}

/** input type for updating data in table "polls_secondarysource" */
export type Polls_Secondarysource_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  title_en?: InputMaybe<Scalars['String']>;
  title_es?: InputMaybe<Scalars['String']>;
  title_fr?: InputMaybe<Scalars['String']>;
  title_ja?: InputMaybe<Scalars['String']>;
  title_zh_hans?: InputMaybe<Scalars['String']>;
  title_zh_hant?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Polls_Secondarysource_Stddev_Fields = {
  __typename?: 'polls_secondarysource_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Polls_Secondarysource_Stddev_Pop_Fields = {
  __typename?: 'polls_secondarysource_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Polls_Secondarysource_Stddev_Samp_Fields = {
  __typename?: 'polls_secondarysource_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Polls_Secondarysource_Sum_Fields = {
  __typename?: 'polls_secondarysource_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "polls_secondarysource" */
export enum Polls_Secondarysource_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  TitleEn = 'title_en',
  /** column name */
  TitleEs = 'title_es',
  /** column name */
  TitleFr = 'title_fr',
  /** column name */
  TitleJa = 'title_ja',
  /** column name */
  TitleZhHans = 'title_zh_hans',
  /** column name */
  TitleZhHant = 'title_zh_hant'
}

/** aggregate var_pop on columns */
export type Polls_Secondarysource_Var_Pop_Fields = {
  __typename?: 'polls_secondarysource_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Polls_Secondarysource_Var_Samp_Fields = {
  __typename?: 'polls_secondarysource_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Polls_Secondarysource_Variance_Fields = {
  __typename?: 'polls_secondarysource_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "polls_templateanswer" */
export type Polls_Templateanswer = {
  __typename?: 'polls_templateanswer';
  id: Scalars['Int'];
  name: Scalars['String'];
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  /** An object relationship */
  previous?: Maybe<Polls_Templateanswer>;
  previous_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  template_answer_set?: Maybe<Polls_Templateanswerset>;
  template_answer_set_id?: Maybe<Scalars['Int']>;
  text_input_type?: Maybe<Scalars['smallint']>;
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
  translated_name?: Maybe<Scalars['String']>;
  value: Scalars['Int'];
};


/** columns and relationships of "polls_templateanswer" */
export type Polls_TemplateanswerTranslated_NameArgs = {
  args: Translated_Name_Polls_Templateanswer_Args;
};

/** aggregated selection of "polls_templateanswer" */
export type Polls_Templateanswer_Aggregate = {
  __typename?: 'polls_templateanswer_aggregate';
  aggregate?: Maybe<Polls_Templateanswer_Aggregate_Fields>;
  nodes: Array<Polls_Templateanswer>;
};

/** aggregate fields of "polls_templateanswer" */
export type Polls_Templateanswer_Aggregate_Fields = {
  __typename?: 'polls_templateanswer_aggregate_fields';
  avg?: Maybe<Polls_Templateanswer_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Templateanswer_Max_Fields>;
  min?: Maybe<Polls_Templateanswer_Min_Fields>;
  stddev?: Maybe<Polls_Templateanswer_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Templateanswer_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Templateanswer_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Templateanswer_Sum_Fields>;
  var_pop?: Maybe<Polls_Templateanswer_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Templateanswer_Var_Samp_Fields>;
  variance?: Maybe<Polls_Templateanswer_Variance_Fields>;
};


/** aggregate fields of "polls_templateanswer" */
export type Polls_Templateanswer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Templateanswer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "polls_templateanswer" */
export type Polls_Templateanswer_Aggregate_Order_By = {
  avg?: InputMaybe<Polls_Templateanswer_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Polls_Templateanswer_Max_Order_By>;
  min?: InputMaybe<Polls_Templateanswer_Min_Order_By>;
  stddev?: InputMaybe<Polls_Templateanswer_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Polls_Templateanswer_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Polls_Templateanswer_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Polls_Templateanswer_Sum_Order_By>;
  var_pop?: InputMaybe<Polls_Templateanswer_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Polls_Templateanswer_Var_Samp_Order_By>;
  variance?: InputMaybe<Polls_Templateanswer_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "polls_templateanswer" */
export type Polls_Templateanswer_Arr_Rel_Insert_Input = {
  data: Array<Polls_Templateanswer_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Templateanswer_On_Conflict>;
};

/** aggregate avg on columns */
export type Polls_Templateanswer_Avg_Fields = {
  __typename?: 'polls_templateanswer_avg_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  template_answer_set_id?: Maybe<Scalars['Float']>;
  text_input_type?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "polls_templateanswer" */
export type Polls_Templateanswer_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_set_id?: InputMaybe<Order_By>;
  text_input_type?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "polls_templateanswer". All fields are combined with a logical 'AND'. */
export type Polls_Templateanswer_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Templateanswer_Bool_Exp>>;
  _not?: InputMaybe<Polls_Templateanswer_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Templateanswer_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  name_en?: InputMaybe<String_Comparison_Exp>;
  name_es?: InputMaybe<String_Comparison_Exp>;
  name_fr?: InputMaybe<String_Comparison_Exp>;
  name_ja?: InputMaybe<String_Comparison_Exp>;
  name_zh_hans?: InputMaybe<String_Comparison_Exp>;
  name_zh_hant?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  previous?: InputMaybe<Polls_Templateanswer_Bool_Exp>;
  previous_id?: InputMaybe<Int_Comparison_Exp>;
  template_answer_set?: InputMaybe<Polls_Templateanswerset_Bool_Exp>;
  template_answer_set_id?: InputMaybe<Int_Comparison_Exp>;
  text_input_type?: InputMaybe<Smallint_Comparison_Exp>;
  tooltip?: InputMaybe<String_Comparison_Exp>;
  tooltip_en?: InputMaybe<String_Comparison_Exp>;
  tooltip_es?: InputMaybe<String_Comparison_Exp>;
  tooltip_fr?: InputMaybe<String_Comparison_Exp>;
  tooltip_ja?: InputMaybe<String_Comparison_Exp>;
  tooltip_zh_hans?: InputMaybe<String_Comparison_Exp>;
  tooltip_zh_hant?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "polls_templateanswer" */
export enum Polls_Templateanswer_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollsTemplateanswerPkey = 'polls_templateanswer_pkey'
}

/** input type for incrementing numeric columns in table "polls_templateanswer" */
export type Polls_Templateanswer_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  previous_id?: InputMaybe<Scalars['Int']>;
  template_answer_set_id?: InputMaybe<Scalars['Int']>;
  text_input_type?: InputMaybe<Scalars['smallint']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_templateanswer" */
export type Polls_Templateanswer_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  previous?: InputMaybe<Polls_Templateanswer_Obj_Rel_Insert_Input>;
  previous_id?: InputMaybe<Scalars['Int']>;
  template_answer_set?: InputMaybe<Polls_Templateanswerset_Obj_Rel_Insert_Input>;
  template_answer_set_id?: InputMaybe<Scalars['Int']>;
  text_input_type?: InputMaybe<Scalars['smallint']>;
  tooltip?: InputMaybe<Scalars['String']>;
  tooltip_en?: InputMaybe<Scalars['String']>;
  tooltip_es?: InputMaybe<Scalars['String']>;
  tooltip_fr?: InputMaybe<Scalars['String']>;
  tooltip_ja?: InputMaybe<Scalars['String']>;
  tooltip_zh_hans?: InputMaybe<Scalars['String']>;
  tooltip_zh_hant?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Polls_Templateanswer_Max_Fields = {
  __typename?: 'polls_templateanswer_max_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
  template_answer_set_id?: Maybe<Scalars['Int']>;
  text_input_type?: Maybe<Scalars['smallint']>;
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "polls_templateanswer" */
export type Polls_Templateanswer_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_set_id?: InputMaybe<Order_By>;
  text_input_type?: InputMaybe<Order_By>;
  tooltip?: InputMaybe<Order_By>;
  tooltip_en?: InputMaybe<Order_By>;
  tooltip_es?: InputMaybe<Order_By>;
  tooltip_fr?: InputMaybe<Order_By>;
  tooltip_ja?: InputMaybe<Order_By>;
  tooltip_zh_hans?: InputMaybe<Order_By>;
  tooltip_zh_hant?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Polls_Templateanswer_Min_Fields = {
  __typename?: 'polls_templateanswer_min_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  name_en?: Maybe<Scalars['String']>;
  name_es?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  name_ja?: Maybe<Scalars['String']>;
  name_zh_hans?: Maybe<Scalars['String']>;
  name_zh_hant?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
  template_answer_set_id?: Maybe<Scalars['Int']>;
  text_input_type?: Maybe<Scalars['smallint']>;
  tooltip?: Maybe<Scalars['String']>;
  tooltip_en?: Maybe<Scalars['String']>;
  tooltip_es?: Maybe<Scalars['String']>;
  tooltip_fr?: Maybe<Scalars['String']>;
  tooltip_ja?: Maybe<Scalars['String']>;
  tooltip_zh_hans?: Maybe<Scalars['String']>;
  tooltip_zh_hant?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "polls_templateanswer" */
export type Polls_Templateanswer_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_set_id?: InputMaybe<Order_By>;
  text_input_type?: InputMaybe<Order_By>;
  tooltip?: InputMaybe<Order_By>;
  tooltip_en?: InputMaybe<Order_By>;
  tooltip_es?: InputMaybe<Order_By>;
  tooltip_fr?: InputMaybe<Order_By>;
  tooltip_ja?: InputMaybe<Order_By>;
  tooltip_zh_hans?: InputMaybe<Order_By>;
  tooltip_zh_hant?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "polls_templateanswer" */
export type Polls_Templateanswer_Mutation_Response = {
  __typename?: 'polls_templateanswer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Templateanswer>;
};

/** input type for inserting object relation for remote table "polls_templateanswer" */
export type Polls_Templateanswer_Obj_Rel_Insert_Input = {
  data: Polls_Templateanswer_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Templateanswer_On_Conflict>;
};

/** on_conflict condition type for table "polls_templateanswer" */
export type Polls_Templateanswer_On_Conflict = {
  constraint: Polls_Templateanswer_Constraint;
  update_columns?: Array<Polls_Templateanswer_Update_Column>;
  where?: InputMaybe<Polls_Templateanswer_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_templateanswer". */
export type Polls_Templateanswer_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_es?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_ja?: InputMaybe<Order_By>;
  name_zh_hans?: InputMaybe<Order_By>;
  name_zh_hant?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous?: InputMaybe<Polls_Templateanswer_Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_set?: InputMaybe<Polls_Templateanswerset_Order_By>;
  template_answer_set_id?: InputMaybe<Order_By>;
  text_input_type?: InputMaybe<Order_By>;
  tooltip?: InputMaybe<Order_By>;
  tooltip_en?: InputMaybe<Order_By>;
  tooltip_es?: InputMaybe<Order_By>;
  tooltip_fr?: InputMaybe<Order_By>;
  tooltip_ja?: InputMaybe<Order_By>;
  tooltip_zh_hans?: InputMaybe<Order_By>;
  tooltip_zh_hant?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polls_templateanswer */
export type Polls_Templateanswer_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_templateanswer" */
export enum Polls_Templateanswer_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant',
  /** column name */
  Order = 'order',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  TemplateAnswerSetId = 'template_answer_set_id',
  /** column name */
  TextInputType = 'text_input_type',
  /** column name */
  Tooltip = 'tooltip',
  /** column name */
  TooltipEn = 'tooltip_en',
  /** column name */
  TooltipEs = 'tooltip_es',
  /** column name */
  TooltipFr = 'tooltip_fr',
  /** column name */
  TooltipJa = 'tooltip_ja',
  /** column name */
  TooltipZhHans = 'tooltip_zh_hans',
  /** column name */
  TooltipZhHant = 'tooltip_zh_hant',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "polls_templateanswer" */
export type Polls_Templateanswer_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_ja?: InputMaybe<Scalars['String']>;
  name_zh_hans?: InputMaybe<Scalars['String']>;
  name_zh_hant?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  previous_id?: InputMaybe<Scalars['Int']>;
  template_answer_set_id?: InputMaybe<Scalars['Int']>;
  text_input_type?: InputMaybe<Scalars['smallint']>;
  tooltip?: InputMaybe<Scalars['String']>;
  tooltip_en?: InputMaybe<Scalars['String']>;
  tooltip_es?: InputMaybe<Scalars['String']>;
  tooltip_fr?: InputMaybe<Scalars['String']>;
  tooltip_ja?: InputMaybe<Scalars['String']>;
  tooltip_zh_hans?: InputMaybe<Scalars['String']>;
  tooltip_zh_hant?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Polls_Templateanswer_Stddev_Fields = {
  __typename?: 'polls_templateanswer_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  template_answer_set_id?: Maybe<Scalars['Float']>;
  text_input_type?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "polls_templateanswer" */
export type Polls_Templateanswer_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_set_id?: InputMaybe<Order_By>;
  text_input_type?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Polls_Templateanswer_Stddev_Pop_Fields = {
  __typename?: 'polls_templateanswer_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  template_answer_set_id?: Maybe<Scalars['Float']>;
  text_input_type?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "polls_templateanswer" */
export type Polls_Templateanswer_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_set_id?: InputMaybe<Order_By>;
  text_input_type?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Polls_Templateanswer_Stddev_Samp_Fields = {
  __typename?: 'polls_templateanswer_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  template_answer_set_id?: Maybe<Scalars['Float']>;
  text_input_type?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "polls_templateanswer" */
export type Polls_Templateanswer_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_set_id?: InputMaybe<Order_By>;
  text_input_type?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Polls_Templateanswer_Sum_Fields = {
  __typename?: 'polls_templateanswer_sum_fields';
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
  template_answer_set_id?: Maybe<Scalars['Int']>;
  text_input_type?: Maybe<Scalars['smallint']>;
  value?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "polls_templateanswer" */
export type Polls_Templateanswer_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_set_id?: InputMaybe<Order_By>;
  text_input_type?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** update columns of table "polls_templateanswer" */
export enum Polls_Templateanswer_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameEs = 'name_es',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameJa = 'name_ja',
  /** column name */
  NameZhHans = 'name_zh_hans',
  /** column name */
  NameZhHant = 'name_zh_hant',
  /** column name */
  Order = 'order',
  /** column name */
  PreviousId = 'previous_id',
  /** column name */
  TemplateAnswerSetId = 'template_answer_set_id',
  /** column name */
  TextInputType = 'text_input_type',
  /** column name */
  Tooltip = 'tooltip',
  /** column name */
  TooltipEn = 'tooltip_en',
  /** column name */
  TooltipEs = 'tooltip_es',
  /** column name */
  TooltipFr = 'tooltip_fr',
  /** column name */
  TooltipJa = 'tooltip_ja',
  /** column name */
  TooltipZhHans = 'tooltip_zh_hans',
  /** column name */
  TooltipZhHant = 'tooltip_zh_hant',
  /** column name */
  Value = 'value'
}

/** aggregate var_pop on columns */
export type Polls_Templateanswer_Var_Pop_Fields = {
  __typename?: 'polls_templateanswer_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  template_answer_set_id?: Maybe<Scalars['Float']>;
  text_input_type?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "polls_templateanswer" */
export type Polls_Templateanswer_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_set_id?: InputMaybe<Order_By>;
  text_input_type?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Polls_Templateanswer_Var_Samp_Fields = {
  __typename?: 'polls_templateanswer_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  template_answer_set_id?: Maybe<Scalars['Float']>;
  text_input_type?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "polls_templateanswer" */
export type Polls_Templateanswer_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_set_id?: InputMaybe<Order_By>;
  text_input_type?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Polls_Templateanswer_Variance_Fields = {
  __typename?: 'polls_templateanswer_variance_fields';
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
  template_answer_set_id?: Maybe<Scalars['Float']>;
  text_input_type?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "polls_templateanswer" */
export type Polls_Templateanswer_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  template_answer_set_id?: InputMaybe<Order_By>;
  text_input_type?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "polls_templateanswerset" */
export type Polls_Templateanswerset = {
  __typename?: 'polls_templateanswerset';
  /** An array relationship */
  answers: Array<Polls_Templateanswer>;
  /** An aggregate relationship */
  answers_aggregate: Polls_Templateanswer_Aggregate;
  date_created: Scalars['timestamptz'];
  date_modified: Scalars['timestamptz'];
  id: Scalars['Int'];
  previous_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  questions: Array<Polls_Question>;
  /** An aggregate relationship */
  questions_aggregate: Polls_Question_Aggregate;
};


/** columns and relationships of "polls_templateanswerset" */
export type Polls_TemplateanswersetAnswersArgs = {
  distinct_on?: InputMaybe<Array<Polls_Templateanswer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Templateanswer_Order_By>>;
  where?: InputMaybe<Polls_Templateanswer_Bool_Exp>;
};


/** columns and relationships of "polls_templateanswerset" */
export type Polls_TemplateanswersetAnswers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Templateanswer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Templateanswer_Order_By>>;
  where?: InputMaybe<Polls_Templateanswer_Bool_Exp>;
};


/** columns and relationships of "polls_templateanswerset" */
export type Polls_TemplateanswersetQuestionsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Question_Order_By>>;
  where?: InputMaybe<Polls_Question_Bool_Exp>;
};


/** columns and relationships of "polls_templateanswerset" */
export type Polls_TemplateanswersetQuestions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Question_Order_By>>;
  where?: InputMaybe<Polls_Question_Bool_Exp>;
};

/** aggregated selection of "polls_templateanswerset" */
export type Polls_Templateanswerset_Aggregate = {
  __typename?: 'polls_templateanswerset_aggregate';
  aggregate?: Maybe<Polls_Templateanswerset_Aggregate_Fields>;
  nodes: Array<Polls_Templateanswerset>;
};

/** aggregate fields of "polls_templateanswerset" */
export type Polls_Templateanswerset_Aggregate_Fields = {
  __typename?: 'polls_templateanswerset_aggregate_fields';
  avg?: Maybe<Polls_Templateanswerset_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polls_Templateanswerset_Max_Fields>;
  min?: Maybe<Polls_Templateanswerset_Min_Fields>;
  stddev?: Maybe<Polls_Templateanswerset_Stddev_Fields>;
  stddev_pop?: Maybe<Polls_Templateanswerset_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polls_Templateanswerset_Stddev_Samp_Fields>;
  sum?: Maybe<Polls_Templateanswerset_Sum_Fields>;
  var_pop?: Maybe<Polls_Templateanswerset_Var_Pop_Fields>;
  var_samp?: Maybe<Polls_Templateanswerset_Var_Samp_Fields>;
  variance?: Maybe<Polls_Templateanswerset_Variance_Fields>;
};


/** aggregate fields of "polls_templateanswerset" */
export type Polls_Templateanswerset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polls_Templateanswerset_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Polls_Templateanswerset_Avg_Fields = {
  __typename?: 'polls_templateanswerset_avg_fields';
  id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "polls_templateanswerset". All fields are combined with a logical 'AND'. */
export type Polls_Templateanswerset_Bool_Exp = {
  _and?: InputMaybe<Array<Polls_Templateanswerset_Bool_Exp>>;
  _not?: InputMaybe<Polls_Templateanswerset_Bool_Exp>;
  _or?: InputMaybe<Array<Polls_Templateanswerset_Bool_Exp>>;
  answers?: InputMaybe<Polls_Templateanswer_Bool_Exp>;
  date_created?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_modified?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  previous_id?: InputMaybe<Int_Comparison_Exp>;
  questions?: InputMaybe<Polls_Question_Bool_Exp>;
};

/** unique or primary key constraints on table "polls_templateanswerset" */
export enum Polls_Templateanswerset_Constraint {
  /** unique or primary key constraint on columns "id" */
  PollsTemplateanswersetPkey = 'polls_templateanswerset_pkey'
}

/** input type for incrementing numeric columns in table "polls_templateanswerset" */
export type Polls_Templateanswerset_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  previous_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "polls_templateanswerset" */
export type Polls_Templateanswerset_Insert_Input = {
  answers?: InputMaybe<Polls_Templateanswer_Arr_Rel_Insert_Input>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_modified?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  previous_id?: InputMaybe<Scalars['Int']>;
  questions?: InputMaybe<Polls_Question_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Polls_Templateanswerset_Max_Fields = {
  __typename?: 'polls_templateanswerset_max_fields';
  date_created?: Maybe<Scalars['timestamptz']>;
  date_modified?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Polls_Templateanswerset_Min_Fields = {
  __typename?: 'polls_templateanswerset_min_fields';
  date_created?: Maybe<Scalars['timestamptz']>;
  date_modified?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "polls_templateanswerset" */
export type Polls_Templateanswerset_Mutation_Response = {
  __typename?: 'polls_templateanswerset_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polls_Templateanswerset>;
};

/** input type for inserting object relation for remote table "polls_templateanswerset" */
export type Polls_Templateanswerset_Obj_Rel_Insert_Input = {
  data: Polls_Templateanswerset_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Polls_Templateanswerset_On_Conflict>;
};

/** on_conflict condition type for table "polls_templateanswerset" */
export type Polls_Templateanswerset_On_Conflict = {
  constraint: Polls_Templateanswerset_Constraint;
  update_columns?: Array<Polls_Templateanswerset_Update_Column>;
  where?: InputMaybe<Polls_Templateanswerset_Bool_Exp>;
};

/** Ordering options when selecting data from "polls_templateanswerset". */
export type Polls_Templateanswerset_Order_By = {
  answers_aggregate?: InputMaybe<Polls_Templateanswer_Aggregate_Order_By>;
  date_created?: InputMaybe<Order_By>;
  date_modified?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  previous_id?: InputMaybe<Order_By>;
  questions_aggregate?: InputMaybe<Polls_Question_Aggregate_Order_By>;
};

/** primary key columns input for table: polls_templateanswerset */
export type Polls_Templateanswerset_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "polls_templateanswerset" */
export enum Polls_Templateanswerset_Select_Column {
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateModified = 'date_modified',
  /** column name */
  Id = 'id',
  /** column name */
  PreviousId = 'previous_id'
}

/** input type for updating data in table "polls_templateanswerset" */
export type Polls_Templateanswerset_Set_Input = {
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_modified?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  previous_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Polls_Templateanswerset_Stddev_Fields = {
  __typename?: 'polls_templateanswerset_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Polls_Templateanswerset_Stddev_Pop_Fields = {
  __typename?: 'polls_templateanswerset_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Polls_Templateanswerset_Stddev_Samp_Fields = {
  __typename?: 'polls_templateanswerset_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Polls_Templateanswerset_Sum_Fields = {
  __typename?: 'polls_templateanswerset_sum_fields';
  id?: Maybe<Scalars['Int']>;
  previous_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "polls_templateanswerset" */
export enum Polls_Templateanswerset_Update_Column {
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateModified = 'date_modified',
  /** column name */
  Id = 'id',
  /** column name */
  PreviousId = 'previous_id'
}

/** aggregate var_pop on columns */
export type Polls_Templateanswerset_Var_Pop_Fields = {
  __typename?: 'polls_templateanswerset_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Polls_Templateanswerset_Var_Samp_Fields = {
  __typename?: 'polls_templateanswerset_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Polls_Templateanswerset_Variance_Fields = {
  __typename?: 'polls_templateanswerset_variance_fields';
  id?: Maybe<Scalars['Float']>;
  previous_id?: Maybe<Scalars['Float']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "accounts_expert" */
  accounts_expert: Array<Accounts_Expert>;
  /** fetch aggregated fields from the table: "accounts_expert" */
  accounts_expert_aggregate: Accounts_Expert_Aggregate;
  /** fetch data from the table: "accounts_expert" using primary key columns */
  accounts_expert_by_pk?: Maybe<Accounts_Expert>;
  /** fetch data from the table: "accounts_expertentriessummary" */
  accounts_expertentriessummary: Array<Accounts_Expertentriessummary>;
  /** fetch aggregated fields from the table: "accounts_expertentriessummary" */
  accounts_expertentriessummary_aggregate: Accounts_Expertentriessummary_Aggregate;
  /** fetch data from the table: "accounts_managingeditor" */
  accounts_managingeditor: Array<Accounts_Managingeditor>;
  /** fetch aggregated fields from the table: "accounts_managingeditor" */
  accounts_managingeditor_aggregate: Accounts_Managingeditor_Aggregate;
  /** fetch data from the table: "accounts_managingeditor" using primary key columns */
  accounts_managingeditor_by_pk?: Maybe<Accounts_Managingeditor>;
  /** fetch data from the table: "accounts_profile" */
  accounts_profile: Array<Accounts_Profile>;
  /** fetch aggregated fields from the table: "accounts_profile" */
  accounts_profile_aggregate: Accounts_Profile_Aggregate;
  /** fetch data from the table: "accounts_profile" using primary key columns */
  accounts_profile_by_pk?: Maybe<Accounts_Profile>;
  /** fetch data from the table: "accounts_regionaleditor" */
  accounts_regionaleditor: Array<Accounts_Regionaleditor>;
  /** fetch aggregated fields from the table: "accounts_regionaleditor" */
  accounts_regionaleditor_aggregate: Accounts_Regionaleditor_Aggregate;
  /** fetch data from the table: "accounts_regionaleditor" using primary key columns */
  accounts_regionaleditor_by_pk?: Maybe<Accounts_Regionaleditor>;
  /** fetch data from the table: "accounts_regionaleditorcategory" */
  accounts_regionaleditorcategory: Array<Accounts_Regionaleditorcategory>;
  /** fetch aggregated fields from the table: "accounts_regionaleditorcategory" */
  accounts_regionaleditorcategory_aggregate: Accounts_Regionaleditorcategory_Aggregate;
  /** fetch data from the table: "accounts_regionaleditorcategory" using primary key columns */
  accounts_regionaleditorcategory_by_pk?: Maybe<Accounts_Regionaleditorcategory>;
  /** fetch data from the table: "accounts_regionaleditorcategory_editors" */
  accounts_regionaleditorcategory_editors: Array<Accounts_Regionaleditorcategory_Editors>;
  /** fetch aggregated fields from the table: "accounts_regionaleditorcategory_editors" */
  accounts_regionaleditorcategory_editors_aggregate: Accounts_Regionaleditorcategory_Editors_Aggregate;
  /** fetch data from the table: "accounts_regionaleditorcategory_editors" using primary key columns */
  accounts_regionaleditorcategory_editors_by_pk?: Maybe<Accounts_Regionaleditorcategory_Editors>;
  /** fetch data from the table: "accounts_translator" */
  accounts_translator: Array<Accounts_Translator>;
  /** fetch aggregated fields from the table: "accounts_translator" */
  accounts_translator_aggregate: Accounts_Translator_Aggregate;
  /** fetch data from the table: "accounts_translator" using primary key columns */
  accounts_translator_by_pk?: Maybe<Accounts_Translator>;
  /** fetch data from the table: "analyze_user_query" */
  analyze_user_query: Array<Analyze_User_Query>;
  /** fetch aggregated fields from the table: "analyze_user_query" */
  analyze_user_query_aggregate: Analyze_User_Query_Aggregate;
  /** fetch data from the table: "analyze_user_query" using primary key columns */
  analyze_user_query_by_pk?: Maybe<Analyze_User_Query>;
  /** fetch data from the table: "auth_user" */
  auth_user: Array<Auth_User>;
  /** fetch aggregated fields from the table: "auth_user" */
  auth_user_aggregate: Auth_User_Aggregate;
  /** fetch data from the table: "auth_user" using primary key columns */
  auth_user_by_pk?: Maybe<Auth_User>;
  avatar?: Maybe<Avatar>;
  crossref_search_connection?: Maybe<CrossrefReferencesConnection>;
  entry_search?: Maybe<EntrySearchResult>;
  entry_search_connection?: Maybe<EntryConnection>;
  /** fetch data from the table: "gis_regions_gis_region" */
  gis_regions_gis_region: Array<Gis_Regions_Gis_Region>;
  /** fetch aggregated fields from the table: "gis_regions_gis_region" */
  gis_regions_gis_region_aggregate: Gis_Regions_Gis_Region_Aggregate;
  /** fetch data from the table: "gis_regions_gis_region" using primary key columns */
  gis_regions_gis_region_by_pk?: Maybe<Gis_Regions_Gis_Region>;
  /** fetch data from the table: "gis_regions_gis_region_tags" */
  gis_regions_gis_region_tags: Array<Gis_Regions_Gis_Region_Tags>;
  /** fetch aggregated fields from the table: "gis_regions_gis_region_tags" */
  gis_regions_gis_region_tags_aggregate: Gis_Regions_Gis_Region_Tags_Aggregate;
  /** fetch data from the table: "gis_regions_gis_region_tags" using primary key columns */
  gis_regions_gis_region_tags_by_pk?: Maybe<Gis_Regions_Gis_Region_Tags>;
  /** fetch data from the table: "gis_regions_gis_tag" */
  gis_regions_gis_tag: Array<Gis_Regions_Gis_Tag>;
  /** fetch aggregated fields from the table: "gis_regions_gis_tag" */
  gis_regions_gis_tag_aggregate: Gis_Regions_Gis_Tag_Aggregate;
  /** fetch data from the table: "gis_regions_gis_tag" using primary key columns */
  gis_regions_gis_tag_by_pk?: Maybe<Gis_Regions_Gis_Tag>;
  poll_diff?: Maybe<PollDiff>;
  poll_draft?: Maybe<PollDraft>;
  /** fetch data from the table: "poll_drafts" */
  poll_drafts: Array<Poll_Drafts>;
  /** fetch aggregated fields from the table: "poll_drafts" */
  poll_drafts_aggregate: Poll_Drafts_Aggregate;
  /** fetch data from the table: "poll_drafts" using primary key columns */
  poll_drafts_by_pk?: Maybe<Poll_Drafts>;
  /** fetch data from the table: "polls_answer" */
  polls_answer: Array<Polls_Answer>;
  /** fetch aggregated fields from the table: "polls_answer" */
  polls_answer_aggregate: Polls_Answer_Aggregate;
  /** fetch data from the table: "polls_answer" using primary key columns */
  polls_answer_by_pk?: Maybe<Polls_Answer>;
  /** fetch data from the table: "polls_answer_set_attachment" */
  polls_answer_set_attachment: Array<Polls_Answer_Set_Attachment>;
  /** fetch aggregated fields from the table: "polls_answer_set_attachment" */
  polls_answer_set_attachment_aggregate: Polls_Answer_Set_Attachment_Aggregate;
  /** fetch data from the table: "polls_answer_set_attachment" using primary key columns */
  polls_answer_set_attachment_by_pk?: Maybe<Polls_Answer_Set_Attachment>;
  /** fetch data from the table: "polls_answerset" */
  polls_answerset: Array<Polls_Answerset>;
  /** fetch aggregated fields from the table: "polls_answerset" */
  polls_answerset_aggregate: Polls_Answerset_Aggregate;
  /** fetch data from the table: "polls_answerset" using primary key columns */
  polls_answerset_by_pk?: Maybe<Polls_Answerset>;
  /** fetch data from the table: "polls_answersetattachment" */
  polls_answersetattachment: Array<Polls_Answersetattachment>;
  /** fetch aggregated fields from the table: "polls_answersetattachment" */
  polls_answersetattachment_aggregate: Polls_Answersetattachment_Aggregate;
  /** fetch data from the table: "polls_answersetattachment" using primary key columns */
  polls_answersetattachment_by_pk?: Maybe<Polls_Answersetattachment>;
  /** fetch data from the table: "polls_baseanswerset" */
  polls_baseanswerset: Array<Polls_Baseanswerset>;
  /** fetch aggregated fields from the table: "polls_baseanswerset" */
  polls_baseanswerset_aggregate: Polls_Baseanswerset_Aggregate;
  /** fetch data from the table: "polls_baseanswerset_branches" */
  polls_baseanswerset_branches: Array<Polls_Baseanswerset_Branches>;
  /** fetch aggregated fields from the table: "polls_baseanswerset_branches" */
  polls_baseanswerset_branches_aggregate: Polls_Baseanswerset_Branches_Aggregate;
  /** fetch data from the table: "polls_baseanswerset_branches" using primary key columns */
  polls_baseanswerset_branches_by_pk?: Maybe<Polls_Baseanswerset_Branches>;
  /** fetch data from the table: "polls_baseanswerset" using primary key columns */
  polls_baseanswerset_by_pk?: Maybe<Polls_Baseanswerset>;
  /** fetch data from the table: "polls_basesource" */
  polls_basesource: Array<Polls_Basesource>;
  /** fetch aggregated fields from the table: "polls_basesource" */
  polls_basesource_aggregate: Polls_Basesource_Aggregate;
  /** fetch data from the table: "polls_basesource" using primary key columns */
  polls_basesource_by_pk?: Maybe<Polls_Basesource>;
  /** fetch data from the table: "polls_branch" */
  polls_branch: Array<Polls_Branch>;
  /** fetch aggregated fields from the table: "polls_branch" */
  polls_branch_aggregate: Polls_Branch_Aggregate;
  /** fetch data from the table: "polls_branch" using primary key columns */
  polls_branch_by_pk?: Maybe<Polls_Branch>;
  /** fetch data from the table: "polls_branchingquestion" */
  polls_branchingquestion: Array<Polls_Branchingquestion>;
  /** fetch aggregated fields from the table: "polls_branchingquestion" */
  polls_branchingquestion_aggregate: Polls_Branchingquestion_Aggregate;
  /** fetch data from the table: "polls_branchingquestion" using primary key columns */
  polls_branchingquestion_by_pk?: Maybe<Polls_Branchingquestion>;
  /** fetch data from the table: "polls_category" */
  polls_category: Array<Polls_Category>;
  /** fetch aggregated fields from the table: "polls_category" */
  polls_category_aggregate: Polls_Category_Aggregate;
  /** fetch data from the table: "polls_category" using primary key columns */
  polls_category_by_pk?: Maybe<Polls_Category>;
  /** fetch data from the table: "polls_categoryprogress" */
  polls_categoryprogress: Array<Polls_Categoryprogress>;
  /** fetch aggregated fields from the table: "polls_categoryprogress" */
  polls_categoryprogress_aggregate: Polls_Categoryprogress_Aggregate;
  /** fetch data from the table: "polls_categoryprogress" using primary key columns */
  polls_categoryprogress_by_pk?: Maybe<Polls_Categoryprogress>;
  /** fetch data from the table: "polls_comment" */
  polls_comment: Array<Polls_Comment>;
  /** fetch aggregated fields from the table: "polls_comment" */
  polls_comment_aggregate: Polls_Comment_Aggregate;
  /** fetch data from the table: "polls_comment" using primary key columns */
  polls_comment_by_pk?: Maybe<Polls_Comment>;
  /** fetch data from the table: "polls_datasource" */
  polls_datasource: Array<Polls_Datasource>;
  /** fetch aggregated fields from the table: "polls_datasource" */
  polls_datasource_aggregate: Polls_Datasource_Aggregate;
  /** fetch data from the table: "polls_datasource" using primary key columns */
  polls_datasource_by_pk?: Maybe<Polls_Datasource>;
  /** fetch data from the table: "polls_entity" */
  polls_entity: Array<Polls_Entity>;
  /** fetch aggregated fields from the table: "polls_entity" */
  polls_entity_aggregate: Polls_Entity_Aggregate;
  /** fetch data from the table: "polls_entity_alt_names" */
  polls_entity_alt_names: Array<Polls_Entity_Alt_Names>;
  /** fetch aggregated fields from the table: "polls_entity_alt_names" */
  polls_entity_alt_names_aggregate: Polls_Entity_Alt_Names_Aggregate;
  /** fetch data from the table: "polls_entity_alt_names" using primary key columns */
  polls_entity_alt_names_by_pk?: Maybe<Polls_Entity_Alt_Names>;
  /** fetch data from the table: "polls_entity" using primary key columns */
  polls_entity_by_pk?: Maybe<Polls_Entity>;
  /** fetch data from the table: "polls_entity_tags" */
  polls_entity_tags: Array<Polls_Entity_Tags>;
  /** fetch aggregated fields from the table: "polls_entity_tags" */
  polls_entity_tags_aggregate: Polls_Entity_Tags_Aggregate;
  /** fetch data from the table: "polls_entity_tags" using primary key columns */
  polls_entity_tags_by_pk?: Maybe<Polls_Entity_Tags>;
  /** fetch data from the table: "polls_entityname" */
  polls_entityname: Array<Polls_Entityname>;
  /** fetch aggregated fields from the table: "polls_entityname" */
  polls_entityname_aggregate: Polls_Entityname_Aggregate;
  /** fetch data from the table: "polls_entityname" using primary key columns */
  polls_entityname_by_pk?: Maybe<Polls_Entityname>;
  /** fetch data from the table: "polls_entitytag" */
  polls_entitytag: Array<Polls_Entitytag>;
  /** fetch aggregated fields from the table: "polls_entitytag" */
  polls_entitytag_aggregate: Polls_Entitytag_Aggregate;
  /** fetch data from the table: "polls_entitytag" using primary key columns */
  polls_entitytag_by_pk?: Maybe<Polls_Entitytag>;
  /** fetch data from the table: "polls_entry_attachment" */
  polls_entry_attachment: Array<Polls_Entry_Attachment>;
  /** fetch aggregated fields from the table: "polls_entry_attachment" */
  polls_entry_attachment_aggregate: Polls_Entry_Attachment_Aggregate;
  /** fetch data from the table: "polls_entry_attachment" using primary key columns */
  polls_entry_attachment_by_pk?: Maybe<Polls_Entry_Attachment>;
  /** fetch data from the table: "polls_entryattachment" */
  polls_entryattachment: Array<Polls_Entryattachment>;
  /** fetch aggregated fields from the table: "polls_entryattachment" */
  polls_entryattachment_aggregate: Polls_Entryattachment_Aggregate;
  /** fetch data from the table: "polls_entryattachment" using primary key columns */
  polls_entryattachment_by_pk?: Maybe<Polls_Entryattachment>;
  /** fetch data from the table: "polls_entryreference" */
  polls_entryreference: Array<Polls_Entryreference>;
  /** fetch aggregated fields from the table: "polls_entryreference" */
  polls_entryreference_aggregate: Polls_Entryreference_Aggregate;
  /** fetch data from the table: "polls_entryreference" using primary key columns */
  polls_entryreference_by_pk?: Maybe<Polls_Entryreference>;
  /** fetch data from the table: "polls_entrytaggroup" */
  polls_entrytaggroup: Array<Polls_Entrytaggroup>;
  /** fetch aggregated fields from the table: "polls_entrytaggroup" */
  polls_entrytaggroup_aggregate: Polls_Entrytaggroup_Aggregate;
  /** fetch data from the table: "polls_entrytaggroup" using primary key columns */
  polls_entrytaggroup_by_pk?: Maybe<Polls_Entrytaggroup>;
  /** fetch data from the table: "polls_group" */
  polls_group: Array<Polls_Group>;
  /** fetch aggregated fields from the table: "polls_group" */
  polls_group_aggregate: Polls_Group_Aggregate;
  /** fetch data from the table: "polls_group" using primary key columns */
  polls_group_by_pk?: Maybe<Polls_Group>;
  /** fetch data from the table: "polls_poll" */
  polls_poll: Array<Polls_Poll>;
  /** fetch aggregated fields from the table: "polls_poll" */
  polls_poll_aggregate: Polls_Poll_Aggregate;
  /** fetch data from the table: "polls_poll" using primary key columns */
  polls_poll_by_pk?: Maybe<Polls_Poll>;
  /** fetch data from the table: "polls_poll_optional_entry_tag_groups" */
  polls_poll_optional_entry_tag_groups: Array<Polls_Poll_Optional_Entry_Tag_Groups>;
  /** fetch aggregated fields from the table: "polls_poll_optional_entry_tag_groups" */
  polls_poll_optional_entry_tag_groups_aggregate: Polls_Poll_Optional_Entry_Tag_Groups_Aggregate;
  /** fetch data from the table: "polls_poll_optional_entry_tag_groups" using primary key columns */
  polls_poll_optional_entry_tag_groups_by_pk?: Maybe<Polls_Poll_Optional_Entry_Tag_Groups>;
  /** fetch data from the table: "polls_poll_required_entry_tag_groups" */
  polls_poll_required_entry_tag_groups: Array<Polls_Poll_Required_Entry_Tag_Groups>;
  /** fetch aggregated fields from the table: "polls_poll_required_entry_tag_groups" */
  polls_poll_required_entry_tag_groups_aggregate: Polls_Poll_Required_Entry_Tag_Groups_Aggregate;
  /** fetch data from the table: "polls_poll_required_entry_tag_groups" using primary key columns */
  polls_poll_required_entry_tag_groups_by_pk?: Maybe<Polls_Poll_Required_Entry_Tag_Groups>;
  /** fetch data from the table: "polls_pollprogress" */
  polls_pollprogress: Array<Polls_Pollprogress>;
  /** fetch aggregated fields from the table: "polls_pollprogress" */
  polls_pollprogress_aggregate: Polls_Pollprogress_Aggregate;
  /** fetch data from the table: "polls_pollprogress" using primary key columns */
  polls_pollprogress_by_pk?: Maybe<Polls_Pollprogress>;
  /** fetch data from the table: "polls_pollprogress_considered_answer_sets" */
  polls_pollprogress_considered_answer_sets: Array<Polls_Pollprogress_Considered_Answer_Sets>;
  /** fetch aggregated fields from the table: "polls_pollprogress_considered_answer_sets" */
  polls_pollprogress_considered_answer_sets_aggregate: Polls_Pollprogress_Considered_Answer_Sets_Aggregate;
  /** fetch data from the table: "polls_pollprogress_considered_answer_sets" using primary key columns */
  polls_pollprogress_considered_answer_sets_by_pk?: Maybe<Polls_Pollprogress_Considered_Answer_Sets>;
  /** fetch data from the table: "polls_question" */
  polls_question: Array<Polls_Question>;
  /** fetch aggregated fields from the table: "polls_question" */
  polls_question_aggregate: Polls_Question_Aggregate;
  /** fetch data from the table: "polls_question" using primary key columns */
  polls_question_by_pk?: Maybe<Polls_Question>;
  /** fetch data from the table: "polls_questionrelation" */
  polls_questionrelation: Array<Polls_Questionrelation>;
  /** fetch aggregated fields from the table: "polls_questionrelation" */
  polls_questionrelation_aggregate: Polls_Questionrelation_Aggregate;
  /** fetch data from the table: "polls_questionrelation" using primary key columns */
  polls_questionrelation_by_pk?: Maybe<Polls_Questionrelation>;
  /** fetch data from the table: "polls_searchrequest" */
  polls_searchrequest: Array<Polls_Searchrequest>;
  /** fetch aggregated fields from the table: "polls_searchrequest" */
  polls_searchrequest_aggregate: Polls_Searchrequest_Aggregate;
  /** fetch data from the table: "polls_searchrequest" using primary key columns */
  polls_searchrequest_by_pk?: Maybe<Polls_Searchrequest>;
  /** fetch data from the table: "polls_secondarysource" */
  polls_secondarysource: Array<Polls_Secondarysource>;
  /** fetch aggregated fields from the table: "polls_secondarysource" */
  polls_secondarysource_aggregate: Polls_Secondarysource_Aggregate;
  /** fetch data from the table: "polls_secondarysource" using primary key columns */
  polls_secondarysource_by_pk?: Maybe<Polls_Secondarysource>;
  /** fetch data from the table: "polls_templateanswer" */
  polls_templateanswer: Array<Polls_Templateanswer>;
  /** fetch aggregated fields from the table: "polls_templateanswer" */
  polls_templateanswer_aggregate: Polls_Templateanswer_Aggregate;
  /** fetch data from the table: "polls_templateanswer" using primary key columns */
  polls_templateanswer_by_pk?: Maybe<Polls_Templateanswer>;
  /** fetch data from the table: "polls_templateanswerset" */
  polls_templateanswerset: Array<Polls_Templateanswerset>;
  /** fetch aggregated fields from the table: "polls_templateanswerset" */
  polls_templateanswerset_aggregate: Polls_Templateanswerset_Aggregate;
  /** fetch data from the table: "polls_templateanswerset" using primary key columns */
  polls_templateanswerset_by_pk?: Maybe<Polls_Templateanswerset>;
  question_search?: Maybe<QuestionSearchResult>;
  reference_search_connection?: Maybe<ReferencesConnection>;
  region_geometries_search?: Maybe<RegionSearchResult>;
  region_geometries_search_connection?: Maybe<RegionConnection>;
  region_search?: Maybe<RegionSearchResult>;
  region_search_connection?: Maybe<RegionConnection>;
  /** execute function "search_area_answers" which returns "polls_answer" */
  search_area_answers: Array<Polls_Answer>;
  /** execute function "search_area_answers" and query aggregates on result of table type "polls_answer" */
  search_area_answers_aggregate: Polls_Answer_Aggregate;
  /** execute function "search_region_answers" which returns "polls_answer" */
  search_region_answers: Array<Polls_Answer>;
  /** execute function "search_region_answers" and query aggregates on result of table type "polls_answer" */
  search_region_answers_aggregate: Polls_Answer_Aggregate;
  /** fetch data from the table: "user_file" */
  user_file: Array<User_File>;
  /** fetch aggregated fields from the table: "user_file" */
  user_file_aggregate: User_File_Aggregate;
  /** fetch data from the table: "user_file" using primary key columns */
  user_file_by_pk?: Maybe<User_File>;
};


export type Query_RootAccounts_ExpertArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Expert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Expert_Order_By>>;
  where?: InputMaybe<Accounts_Expert_Bool_Exp>;
};


export type Query_RootAccounts_Expert_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Expert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Expert_Order_By>>;
  where?: InputMaybe<Accounts_Expert_Bool_Exp>;
};


export type Query_RootAccounts_Expert_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAccounts_ExpertentriessummaryArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Expertentriessummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Expertentriessummary_Order_By>>;
  where?: InputMaybe<Accounts_Expertentriessummary_Bool_Exp>;
};


export type Query_RootAccounts_Expertentriessummary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Expertentriessummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Expertentriessummary_Order_By>>;
  where?: InputMaybe<Accounts_Expertentriessummary_Bool_Exp>;
};


export type Query_RootAccounts_ManagingeditorArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Managingeditor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Managingeditor_Order_By>>;
  where?: InputMaybe<Accounts_Managingeditor_Bool_Exp>;
};


export type Query_RootAccounts_Managingeditor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Managingeditor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Managingeditor_Order_By>>;
  where?: InputMaybe<Accounts_Managingeditor_Bool_Exp>;
};


export type Query_RootAccounts_Managingeditor_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAccounts_ProfileArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Profile_Order_By>>;
  where?: InputMaybe<Accounts_Profile_Bool_Exp>;
};


export type Query_RootAccounts_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Profile_Order_By>>;
  where?: InputMaybe<Accounts_Profile_Bool_Exp>;
};


export type Query_RootAccounts_Profile_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAccounts_RegionaleditorArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Regionaleditor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Regionaleditor_Order_By>>;
  where?: InputMaybe<Accounts_Regionaleditor_Bool_Exp>;
};


export type Query_RootAccounts_Regionaleditor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Regionaleditor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Regionaleditor_Order_By>>;
  where?: InputMaybe<Accounts_Regionaleditor_Bool_Exp>;
};


export type Query_RootAccounts_Regionaleditor_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAccounts_RegionaleditorcategoryArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Regionaleditorcategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Regionaleditorcategory_Order_By>>;
  where?: InputMaybe<Accounts_Regionaleditorcategory_Bool_Exp>;
};


export type Query_RootAccounts_Regionaleditorcategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Regionaleditorcategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Regionaleditorcategory_Order_By>>;
  where?: InputMaybe<Accounts_Regionaleditorcategory_Bool_Exp>;
};


export type Query_RootAccounts_Regionaleditorcategory_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAccounts_Regionaleditorcategory_EditorsArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Regionaleditorcategory_Editors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Regionaleditorcategory_Editors_Order_By>>;
  where?: InputMaybe<Accounts_Regionaleditorcategory_Editors_Bool_Exp>;
};


export type Query_RootAccounts_Regionaleditorcategory_Editors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Regionaleditorcategory_Editors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Regionaleditorcategory_Editors_Order_By>>;
  where?: InputMaybe<Accounts_Regionaleditorcategory_Editors_Bool_Exp>;
};


export type Query_RootAccounts_Regionaleditorcategory_Editors_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAccounts_TranslatorArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Translator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Translator_Order_By>>;
  where?: InputMaybe<Accounts_Translator_Bool_Exp>;
};


export type Query_RootAccounts_Translator_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Translator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Translator_Order_By>>;
  where?: InputMaybe<Accounts_Translator_Bool_Exp>;
};


export type Query_RootAccounts_Translator_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAnalyze_User_QueryArgs = {
  distinct_on?: InputMaybe<Array<Analyze_User_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Analyze_User_Query_Order_By>>;
  where?: InputMaybe<Analyze_User_Query_Bool_Exp>;
};


export type Query_RootAnalyze_User_Query_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Analyze_User_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Analyze_User_Query_Order_By>>;
  where?: InputMaybe<Analyze_User_Query_Bool_Exp>;
};


export type Query_RootAnalyze_User_Query_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAuth_UserArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_User_Order_By>>;
  where?: InputMaybe<Auth_User_Bool_Exp>;
};


export type Query_RootAuth_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_User_Order_By>>;
  where?: InputMaybe<Auth_User_Bool_Exp>;
};


export type Query_RootAuth_User_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAvatarArgs = {
  size?: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
};


export type Query_RootCrossref_Search_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type Query_RootEntry_SearchArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  query: Scalars['String'];
};


export type Query_RootEntry_Search_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
  sort?: InputMaybe<Scalars['String']>;
};


export type Query_RootGis_Regions_Gis_RegionArgs = {
  distinct_on?: InputMaybe<Array<Gis_Regions_Gis_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gis_Regions_Gis_Region_Order_By>>;
  where?: InputMaybe<Gis_Regions_Gis_Region_Bool_Exp>;
};


export type Query_RootGis_Regions_Gis_Region_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gis_Regions_Gis_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gis_Regions_Gis_Region_Order_By>>;
  where?: InputMaybe<Gis_Regions_Gis_Region_Bool_Exp>;
};


export type Query_RootGis_Regions_Gis_Region_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootGis_Regions_Gis_Region_TagsArgs = {
  distinct_on?: InputMaybe<Array<Gis_Regions_Gis_Region_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gis_Regions_Gis_Region_Tags_Order_By>>;
  where?: InputMaybe<Gis_Regions_Gis_Region_Tags_Bool_Exp>;
};


export type Query_RootGis_Regions_Gis_Region_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gis_Regions_Gis_Region_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gis_Regions_Gis_Region_Tags_Order_By>>;
  where?: InputMaybe<Gis_Regions_Gis_Region_Tags_Bool_Exp>;
};


export type Query_RootGis_Regions_Gis_Region_Tags_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootGis_Regions_Gis_TagArgs = {
  distinct_on?: InputMaybe<Array<Gis_Regions_Gis_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gis_Regions_Gis_Tag_Order_By>>;
  where?: InputMaybe<Gis_Regions_Gis_Tag_Bool_Exp>;
};


export type Query_RootGis_Regions_Gis_Tag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gis_Regions_Gis_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gis_Regions_Gis_Tag_Order_By>>;
  where?: InputMaybe<Gis_Regions_Gis_Tag_Bool_Exp>;
};


export type Query_RootGis_Regions_Gis_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPoll_DiffArgs = {
  pollId: Scalars['Int'];
};


export type Query_RootPoll_DraftsArgs = {
  distinct_on?: InputMaybe<Array<Poll_Drafts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Poll_Drafts_Order_By>>;
  where?: InputMaybe<Poll_Drafts_Bool_Exp>;
};


export type Query_RootPoll_Drafts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Poll_Drafts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Poll_Drafts_Order_By>>;
  where?: InputMaybe<Poll_Drafts_Bool_Exp>;
};


export type Query_RootPoll_Drafts_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_AnswerArgs = {
  distinct_on?: InputMaybe<Array<Polls_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answer_Order_By>>;
  where?: InputMaybe<Polls_Answer_Bool_Exp>;
};


export type Query_RootPolls_Answer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answer_Order_By>>;
  where?: InputMaybe<Polls_Answer_Bool_Exp>;
};


export type Query_RootPolls_Answer_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_Answer_Set_AttachmentArgs = {
  distinct_on?: InputMaybe<Array<Polls_Answer_Set_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answer_Set_Attachment_Order_By>>;
  where?: InputMaybe<Polls_Answer_Set_Attachment_Bool_Exp>;
};


export type Query_RootPolls_Answer_Set_Attachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Answer_Set_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answer_Set_Attachment_Order_By>>;
  where?: InputMaybe<Polls_Answer_Set_Attachment_Bool_Exp>;
};


export type Query_RootPolls_Answer_Set_Attachment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_AnswersetArgs = {
  distinct_on?: InputMaybe<Array<Polls_Answerset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answerset_Order_By>>;
  where?: InputMaybe<Polls_Answerset_Bool_Exp>;
};


export type Query_RootPolls_Answerset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Answerset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answerset_Order_By>>;
  where?: InputMaybe<Polls_Answerset_Bool_Exp>;
};


export type Query_RootPolls_Answerset_By_PkArgs = {
  baseanswerset_ptr_id: Scalars['Int'];
};


export type Query_RootPolls_AnswersetattachmentArgs = {
  distinct_on?: InputMaybe<Array<Polls_Answersetattachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answersetattachment_Order_By>>;
  where?: InputMaybe<Polls_Answersetattachment_Bool_Exp>;
};


export type Query_RootPolls_Answersetattachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Answersetattachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answersetattachment_Order_By>>;
  where?: InputMaybe<Polls_Answersetattachment_Bool_Exp>;
};


export type Query_RootPolls_Answersetattachment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_BaseanswersetArgs = {
  distinct_on?: InputMaybe<Array<Polls_Baseanswerset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Baseanswerset_Order_By>>;
  where?: InputMaybe<Polls_Baseanswerset_Bool_Exp>;
};


export type Query_RootPolls_Baseanswerset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Baseanswerset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Baseanswerset_Order_By>>;
  where?: InputMaybe<Polls_Baseanswerset_Bool_Exp>;
};


export type Query_RootPolls_Baseanswerset_BranchesArgs = {
  distinct_on?: InputMaybe<Array<Polls_Baseanswerset_Branches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Baseanswerset_Branches_Order_By>>;
  where?: InputMaybe<Polls_Baseanswerset_Branches_Bool_Exp>;
};


export type Query_RootPolls_Baseanswerset_Branches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Baseanswerset_Branches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Baseanswerset_Branches_Order_By>>;
  where?: InputMaybe<Polls_Baseanswerset_Branches_Bool_Exp>;
};


export type Query_RootPolls_Baseanswerset_Branches_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_Baseanswerset_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_BasesourceArgs = {
  distinct_on?: InputMaybe<Array<Polls_Basesource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Basesource_Order_By>>;
  where?: InputMaybe<Polls_Basesource_Bool_Exp>;
};


export type Query_RootPolls_Basesource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Basesource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Basesource_Order_By>>;
  where?: InputMaybe<Polls_Basesource_Bool_Exp>;
};


export type Query_RootPolls_Basesource_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_BranchArgs = {
  distinct_on?: InputMaybe<Array<Polls_Branch_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Branch_Order_By>>;
  where?: InputMaybe<Polls_Branch_Bool_Exp>;
};


export type Query_RootPolls_Branch_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Branch_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Branch_Order_By>>;
  where?: InputMaybe<Polls_Branch_Bool_Exp>;
};


export type Query_RootPolls_Branch_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_BranchingquestionArgs = {
  distinct_on?: InputMaybe<Array<Polls_Branchingquestion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Branchingquestion_Order_By>>;
  where?: InputMaybe<Polls_Branchingquestion_Bool_Exp>;
};


export type Query_RootPolls_Branchingquestion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Branchingquestion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Branchingquestion_Order_By>>;
  where?: InputMaybe<Polls_Branchingquestion_Bool_Exp>;
};


export type Query_RootPolls_Branchingquestion_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Polls_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Category_Order_By>>;
  where?: InputMaybe<Polls_Category_Bool_Exp>;
};


export type Query_RootPolls_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Category_Order_By>>;
  where?: InputMaybe<Polls_Category_Bool_Exp>;
};


export type Query_RootPolls_Category_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_CategoryprogressArgs = {
  distinct_on?: InputMaybe<Array<Polls_Categoryprogress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Categoryprogress_Order_By>>;
  where?: InputMaybe<Polls_Categoryprogress_Bool_Exp>;
};


export type Query_RootPolls_Categoryprogress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Categoryprogress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Categoryprogress_Order_By>>;
  where?: InputMaybe<Polls_Categoryprogress_Bool_Exp>;
};


export type Query_RootPolls_Categoryprogress_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_CommentArgs = {
  distinct_on?: InputMaybe<Array<Polls_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Comment_Order_By>>;
  where?: InputMaybe<Polls_Comment_Bool_Exp>;
};


export type Query_RootPolls_Comment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Comment_Order_By>>;
  where?: InputMaybe<Polls_Comment_Bool_Exp>;
};


export type Query_RootPolls_Comment_By_PkArgs = {
  baseanswerset_ptr_id: Scalars['Int'];
};


export type Query_RootPolls_DatasourceArgs = {
  distinct_on?: InputMaybe<Array<Polls_Datasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Datasource_Order_By>>;
  where?: InputMaybe<Polls_Datasource_Bool_Exp>;
};


export type Query_RootPolls_Datasource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Datasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Datasource_Order_By>>;
  where?: InputMaybe<Polls_Datasource_Bool_Exp>;
};


export type Query_RootPolls_Datasource_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_EntityArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Order_By>>;
  where?: InputMaybe<Polls_Entity_Bool_Exp>;
};


export type Query_RootPolls_Entity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Order_By>>;
  where?: InputMaybe<Polls_Entity_Bool_Exp>;
};


export type Query_RootPolls_Entity_Alt_NamesArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Alt_Names_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Alt_Names_Order_By>>;
  where?: InputMaybe<Polls_Entity_Alt_Names_Bool_Exp>;
};


export type Query_RootPolls_Entity_Alt_Names_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Alt_Names_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Alt_Names_Order_By>>;
  where?: InputMaybe<Polls_Entity_Alt_Names_Bool_Exp>;
};


export type Query_RootPolls_Entity_Alt_Names_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_Entity_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_Entity_TagsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Tags_Order_By>>;
  where?: InputMaybe<Polls_Entity_Tags_Bool_Exp>;
};


export type Query_RootPolls_Entity_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Tags_Order_By>>;
  where?: InputMaybe<Polls_Entity_Tags_Bool_Exp>;
};


export type Query_RootPolls_Entity_Tags_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_EntitynameArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entityname_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entityname_Order_By>>;
  where?: InputMaybe<Polls_Entityname_Bool_Exp>;
};


export type Query_RootPolls_Entityname_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entityname_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entityname_Order_By>>;
  where?: InputMaybe<Polls_Entityname_Bool_Exp>;
};


export type Query_RootPolls_Entityname_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_EntitytagArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entitytag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entitytag_Order_By>>;
  where?: InputMaybe<Polls_Entitytag_Bool_Exp>;
};


export type Query_RootPolls_Entitytag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entitytag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entitytag_Order_By>>;
  where?: InputMaybe<Polls_Entitytag_Bool_Exp>;
};


export type Query_RootPolls_Entitytag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_Entry_AttachmentArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entry_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entry_Attachment_Order_By>>;
  where?: InputMaybe<Polls_Entry_Attachment_Bool_Exp>;
};


export type Query_RootPolls_Entry_Attachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entry_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entry_Attachment_Order_By>>;
  where?: InputMaybe<Polls_Entry_Attachment_Bool_Exp>;
};


export type Query_RootPolls_Entry_Attachment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_EntryattachmentArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entryattachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entryattachment_Order_By>>;
  where?: InputMaybe<Polls_Entryattachment_Bool_Exp>;
};


export type Query_RootPolls_Entryattachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entryattachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entryattachment_Order_By>>;
  where?: InputMaybe<Polls_Entryattachment_Bool_Exp>;
};


export type Query_RootPolls_Entryattachment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_EntryreferenceArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entryreference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entryreference_Order_By>>;
  where?: InputMaybe<Polls_Entryreference_Bool_Exp>;
};


export type Query_RootPolls_Entryreference_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entryreference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entryreference_Order_By>>;
  where?: InputMaybe<Polls_Entryreference_Bool_Exp>;
};


export type Query_RootPolls_Entryreference_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_EntrytaggroupArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entrytaggroup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entrytaggroup_Order_By>>;
  where?: InputMaybe<Polls_Entrytaggroup_Bool_Exp>;
};


export type Query_RootPolls_Entrytaggroup_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entrytaggroup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entrytaggroup_Order_By>>;
  where?: InputMaybe<Polls_Entrytaggroup_Bool_Exp>;
};


export type Query_RootPolls_Entrytaggroup_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_GroupArgs = {
  distinct_on?: InputMaybe<Array<Polls_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Group_Order_By>>;
  where?: InputMaybe<Polls_Group_Bool_Exp>;
};


export type Query_RootPolls_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Group_Order_By>>;
  where?: InputMaybe<Polls_Group_Bool_Exp>;
};


export type Query_RootPolls_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_PollArgs = {
  distinct_on?: InputMaybe<Array<Polls_Poll_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Poll_Order_By>>;
  where?: InputMaybe<Polls_Poll_Bool_Exp>;
};


export type Query_RootPolls_Poll_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Poll_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Poll_Order_By>>;
  where?: InputMaybe<Polls_Poll_Bool_Exp>;
};


export type Query_RootPolls_Poll_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_Poll_Optional_Entry_Tag_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Poll_Optional_Entry_Tag_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Poll_Optional_Entry_Tag_Groups_Order_By>>;
  where?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_Bool_Exp>;
};


export type Query_RootPolls_Poll_Optional_Entry_Tag_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Poll_Optional_Entry_Tag_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Poll_Optional_Entry_Tag_Groups_Order_By>>;
  where?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_Bool_Exp>;
};


export type Query_RootPolls_Poll_Optional_Entry_Tag_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_Poll_Required_Entry_Tag_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Poll_Required_Entry_Tag_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Poll_Required_Entry_Tag_Groups_Order_By>>;
  where?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_Bool_Exp>;
};


export type Query_RootPolls_Poll_Required_Entry_Tag_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Poll_Required_Entry_Tag_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Poll_Required_Entry_Tag_Groups_Order_By>>;
  where?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_Bool_Exp>;
};


export type Query_RootPolls_Poll_Required_Entry_Tag_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_PollprogressArgs = {
  distinct_on?: InputMaybe<Array<Polls_Pollprogress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Pollprogress_Order_By>>;
  where?: InputMaybe<Polls_Pollprogress_Bool_Exp>;
};


export type Query_RootPolls_Pollprogress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Pollprogress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Pollprogress_Order_By>>;
  where?: InputMaybe<Polls_Pollprogress_Bool_Exp>;
};


export type Query_RootPolls_Pollprogress_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_Pollprogress_Considered_Answer_SetsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Pollprogress_Considered_Answer_Sets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Pollprogress_Considered_Answer_Sets_Order_By>>;
  where?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_Bool_Exp>;
};


export type Query_RootPolls_Pollprogress_Considered_Answer_Sets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Pollprogress_Considered_Answer_Sets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Pollprogress_Considered_Answer_Sets_Order_By>>;
  where?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_Bool_Exp>;
};


export type Query_RootPolls_Pollprogress_Considered_Answer_Sets_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_QuestionArgs = {
  distinct_on?: InputMaybe<Array<Polls_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Question_Order_By>>;
  where?: InputMaybe<Polls_Question_Bool_Exp>;
};


export type Query_RootPolls_Question_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Question_Order_By>>;
  where?: InputMaybe<Polls_Question_Bool_Exp>;
};


export type Query_RootPolls_Question_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_QuestionrelationArgs = {
  distinct_on?: InputMaybe<Array<Polls_Questionrelation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Questionrelation_Order_By>>;
  where?: InputMaybe<Polls_Questionrelation_Bool_Exp>;
};


export type Query_RootPolls_Questionrelation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Questionrelation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Questionrelation_Order_By>>;
  where?: InputMaybe<Polls_Questionrelation_Bool_Exp>;
};


export type Query_RootPolls_Questionrelation_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_SearchrequestArgs = {
  distinct_on?: InputMaybe<Array<Polls_Searchrequest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Searchrequest_Order_By>>;
  where?: InputMaybe<Polls_Searchrequest_Bool_Exp>;
};


export type Query_RootPolls_Searchrequest_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Searchrequest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Searchrequest_Order_By>>;
  where?: InputMaybe<Polls_Searchrequest_Bool_Exp>;
};


export type Query_RootPolls_Searchrequest_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_SecondarysourceArgs = {
  distinct_on?: InputMaybe<Array<Polls_Secondarysource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Secondarysource_Order_By>>;
  where?: InputMaybe<Polls_Secondarysource_Bool_Exp>;
};


export type Query_RootPolls_Secondarysource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Secondarysource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Secondarysource_Order_By>>;
  where?: InputMaybe<Polls_Secondarysource_Bool_Exp>;
};


export type Query_RootPolls_Secondarysource_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_TemplateanswerArgs = {
  distinct_on?: InputMaybe<Array<Polls_Templateanswer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Templateanswer_Order_By>>;
  where?: InputMaybe<Polls_Templateanswer_Bool_Exp>;
};


export type Query_RootPolls_Templateanswer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Templateanswer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Templateanswer_Order_By>>;
  where?: InputMaybe<Polls_Templateanswer_Bool_Exp>;
};


export type Query_RootPolls_Templateanswer_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPolls_TemplateanswersetArgs = {
  distinct_on?: InputMaybe<Array<Polls_Templateanswerset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Templateanswerset_Order_By>>;
  where?: InputMaybe<Polls_Templateanswerset_Bool_Exp>;
};


export type Query_RootPolls_Templateanswerset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Templateanswerset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Templateanswerset_Order_By>>;
  where?: InputMaybe<Polls_Templateanswerset_Bool_Exp>;
};


export type Query_RootPolls_Templateanswerset_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootQuestion_SearchArgs = {
  query: Scalars['String'];
};


export type Query_RootReference_Search_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type Query_RootRegion_Geometries_SearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  geometries: Array<GeoJsonInput>;
};


export type Query_RootRegion_Geometries_Search_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  geometries: Array<GeoJsonInput>;
};


export type Query_RootRegion_SearchArgs = {
  query: Scalars['String'];
};


export type Query_RootRegion_Search_ConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type Query_RootSearch_Area_AnswersArgs = {
  args: Search_Area_Answers_Args;
  distinct_on?: InputMaybe<Array<Polls_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answer_Order_By>>;
  where?: InputMaybe<Polls_Answer_Bool_Exp>;
};


export type Query_RootSearch_Area_Answers_AggregateArgs = {
  args: Search_Area_Answers_Args;
  distinct_on?: InputMaybe<Array<Polls_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answer_Order_By>>;
  where?: InputMaybe<Polls_Answer_Bool_Exp>;
};


export type Query_RootSearch_Region_AnswersArgs = {
  args: Search_Region_Answers_Args;
  distinct_on?: InputMaybe<Array<Polls_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answer_Order_By>>;
  where?: InputMaybe<Polls_Answer_Bool_Exp>;
};


export type Query_RootSearch_Region_Answers_AggregateArgs = {
  args: Search_Region_Answers_Args;
  distinct_on?: InputMaybe<Array<Polls_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answer_Order_By>>;
  where?: InputMaybe<Polls_Answer_Bool_Exp>;
};


export type Query_RootUser_FileArgs = {
  distinct_on?: InputMaybe<Array<User_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_File_Order_By>>;
  where?: InputMaybe<User_File_Bool_Exp>;
};


export type Query_RootUser_File_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_File_Order_By>>;
  where?: InputMaybe<User_File_Bool_Exp>;
};


export type Query_RootUser_File_By_PkArgs = {
  id: Scalars['uuid'];
};

export type Search_Area_Answers_Args = {
  query_geom?: InputMaybe<Scalars['geometry']>;
  query_question_id?: InputMaybe<Scalars['Int']>;
};

export type Search_Region_Answers_Args = {
  query_question_id?: InputMaybe<Scalars['Int']>;
  region_ids?: InputMaybe<Scalars['_int4']>;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['smallint']>;
  _gt?: InputMaybe<Scalars['smallint']>;
  _gte?: InputMaybe<Scalars['smallint']>;
  _in?: InputMaybe<Array<Scalars['smallint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['smallint']>;
  _lte?: InputMaybe<Scalars['smallint']>;
  _neq?: InputMaybe<Scalars['smallint']>;
  _nin?: InputMaybe<Array<Scalars['smallint']>>;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float'];
  from: Scalars['geography'];
  use_spheroid?: InputMaybe<Scalars['Boolean']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float'];
  from: Scalars['geometry'];
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "accounts_expert" */
  accounts_expert: Array<Accounts_Expert>;
  /** fetch aggregated fields from the table: "accounts_expert" */
  accounts_expert_aggregate: Accounts_Expert_Aggregate;
  /** fetch data from the table: "accounts_expert" using primary key columns */
  accounts_expert_by_pk?: Maybe<Accounts_Expert>;
  /** fetch data from the table: "accounts_expertentriessummary" */
  accounts_expertentriessummary: Array<Accounts_Expertentriessummary>;
  /** fetch aggregated fields from the table: "accounts_expertentriessummary" */
  accounts_expertentriessummary_aggregate: Accounts_Expertentriessummary_Aggregate;
  /** fetch data from the table: "accounts_managingeditor" */
  accounts_managingeditor: Array<Accounts_Managingeditor>;
  /** fetch aggregated fields from the table: "accounts_managingeditor" */
  accounts_managingeditor_aggregate: Accounts_Managingeditor_Aggregate;
  /** fetch data from the table: "accounts_managingeditor" using primary key columns */
  accounts_managingeditor_by_pk?: Maybe<Accounts_Managingeditor>;
  /** fetch data from the table: "accounts_profile" */
  accounts_profile: Array<Accounts_Profile>;
  /** fetch aggregated fields from the table: "accounts_profile" */
  accounts_profile_aggregate: Accounts_Profile_Aggregate;
  /** fetch data from the table: "accounts_profile" using primary key columns */
  accounts_profile_by_pk?: Maybe<Accounts_Profile>;
  /** fetch data from the table: "accounts_regionaleditor" */
  accounts_regionaleditor: Array<Accounts_Regionaleditor>;
  /** fetch aggregated fields from the table: "accounts_regionaleditor" */
  accounts_regionaleditor_aggregate: Accounts_Regionaleditor_Aggregate;
  /** fetch data from the table: "accounts_regionaleditor" using primary key columns */
  accounts_regionaleditor_by_pk?: Maybe<Accounts_Regionaleditor>;
  /** fetch data from the table: "accounts_regionaleditorcategory" */
  accounts_regionaleditorcategory: Array<Accounts_Regionaleditorcategory>;
  /** fetch aggregated fields from the table: "accounts_regionaleditorcategory" */
  accounts_regionaleditorcategory_aggregate: Accounts_Regionaleditorcategory_Aggregate;
  /** fetch data from the table: "accounts_regionaleditorcategory" using primary key columns */
  accounts_regionaleditorcategory_by_pk?: Maybe<Accounts_Regionaleditorcategory>;
  /** fetch data from the table: "accounts_regionaleditorcategory_editors" */
  accounts_regionaleditorcategory_editors: Array<Accounts_Regionaleditorcategory_Editors>;
  /** fetch aggregated fields from the table: "accounts_regionaleditorcategory_editors" */
  accounts_regionaleditorcategory_editors_aggregate: Accounts_Regionaleditorcategory_Editors_Aggregate;
  /** fetch data from the table: "accounts_regionaleditorcategory_editors" using primary key columns */
  accounts_regionaleditorcategory_editors_by_pk?: Maybe<Accounts_Regionaleditorcategory_Editors>;
  /** fetch data from the table: "accounts_translator" */
  accounts_translator: Array<Accounts_Translator>;
  /** fetch aggregated fields from the table: "accounts_translator" */
  accounts_translator_aggregate: Accounts_Translator_Aggregate;
  /** fetch data from the table: "accounts_translator" using primary key columns */
  accounts_translator_by_pk?: Maybe<Accounts_Translator>;
  /** fetch data from the table: "analyze_user_query" */
  analyze_user_query: Array<Analyze_User_Query>;
  /** fetch aggregated fields from the table: "analyze_user_query" */
  analyze_user_query_aggregate: Analyze_User_Query_Aggregate;
  /** fetch data from the table: "analyze_user_query" using primary key columns */
  analyze_user_query_by_pk?: Maybe<Analyze_User_Query>;
  /** fetch data from the table: "auth_user" */
  auth_user: Array<Auth_User>;
  /** fetch aggregated fields from the table: "auth_user" */
  auth_user_aggregate: Auth_User_Aggregate;
  /** fetch data from the table: "auth_user" using primary key columns */
  auth_user_by_pk?: Maybe<Auth_User>;
  /** fetch data from the table: "gis_regions_gis_region" */
  gis_regions_gis_region: Array<Gis_Regions_Gis_Region>;
  /** fetch aggregated fields from the table: "gis_regions_gis_region" */
  gis_regions_gis_region_aggregate: Gis_Regions_Gis_Region_Aggregate;
  /** fetch data from the table: "gis_regions_gis_region" using primary key columns */
  gis_regions_gis_region_by_pk?: Maybe<Gis_Regions_Gis_Region>;
  /** fetch data from the table: "gis_regions_gis_region_tags" */
  gis_regions_gis_region_tags: Array<Gis_Regions_Gis_Region_Tags>;
  /** fetch aggregated fields from the table: "gis_regions_gis_region_tags" */
  gis_regions_gis_region_tags_aggregate: Gis_Regions_Gis_Region_Tags_Aggregate;
  /** fetch data from the table: "gis_regions_gis_region_tags" using primary key columns */
  gis_regions_gis_region_tags_by_pk?: Maybe<Gis_Regions_Gis_Region_Tags>;
  /** fetch data from the table: "gis_regions_gis_tag" */
  gis_regions_gis_tag: Array<Gis_Regions_Gis_Tag>;
  /** fetch aggregated fields from the table: "gis_regions_gis_tag" */
  gis_regions_gis_tag_aggregate: Gis_Regions_Gis_Tag_Aggregate;
  /** fetch data from the table: "gis_regions_gis_tag" using primary key columns */
  gis_regions_gis_tag_by_pk?: Maybe<Gis_Regions_Gis_Tag>;
  /** fetch data from the table: "poll_drafts" */
  poll_drafts: Array<Poll_Drafts>;
  /** fetch aggregated fields from the table: "poll_drafts" */
  poll_drafts_aggregate: Poll_Drafts_Aggregate;
  /** fetch data from the table: "poll_drafts" using primary key columns */
  poll_drafts_by_pk?: Maybe<Poll_Drafts>;
  /** fetch data from the table: "polls_answer" */
  polls_answer: Array<Polls_Answer>;
  /** fetch aggregated fields from the table: "polls_answer" */
  polls_answer_aggregate: Polls_Answer_Aggregate;
  /** fetch data from the table: "polls_answer" using primary key columns */
  polls_answer_by_pk?: Maybe<Polls_Answer>;
  /** fetch data from the table: "polls_answer_set_attachment" */
  polls_answer_set_attachment: Array<Polls_Answer_Set_Attachment>;
  /** fetch aggregated fields from the table: "polls_answer_set_attachment" */
  polls_answer_set_attachment_aggregate: Polls_Answer_Set_Attachment_Aggregate;
  /** fetch data from the table: "polls_answer_set_attachment" using primary key columns */
  polls_answer_set_attachment_by_pk?: Maybe<Polls_Answer_Set_Attachment>;
  /** fetch data from the table: "polls_answerset" */
  polls_answerset: Array<Polls_Answerset>;
  /** fetch aggregated fields from the table: "polls_answerset" */
  polls_answerset_aggregate: Polls_Answerset_Aggregate;
  /** fetch data from the table: "polls_answerset" using primary key columns */
  polls_answerset_by_pk?: Maybe<Polls_Answerset>;
  /** fetch data from the table: "polls_answersetattachment" */
  polls_answersetattachment: Array<Polls_Answersetattachment>;
  /** fetch aggregated fields from the table: "polls_answersetattachment" */
  polls_answersetattachment_aggregate: Polls_Answersetattachment_Aggregate;
  /** fetch data from the table: "polls_answersetattachment" using primary key columns */
  polls_answersetattachment_by_pk?: Maybe<Polls_Answersetattachment>;
  /** fetch data from the table: "polls_baseanswerset" */
  polls_baseanswerset: Array<Polls_Baseanswerset>;
  /** fetch aggregated fields from the table: "polls_baseanswerset" */
  polls_baseanswerset_aggregate: Polls_Baseanswerset_Aggregate;
  /** fetch data from the table: "polls_baseanswerset_branches" */
  polls_baseanswerset_branches: Array<Polls_Baseanswerset_Branches>;
  /** fetch aggregated fields from the table: "polls_baseanswerset_branches" */
  polls_baseanswerset_branches_aggregate: Polls_Baseanswerset_Branches_Aggregate;
  /** fetch data from the table: "polls_baseanswerset_branches" using primary key columns */
  polls_baseanswerset_branches_by_pk?: Maybe<Polls_Baseanswerset_Branches>;
  /** fetch data from the table: "polls_baseanswerset" using primary key columns */
  polls_baseanswerset_by_pk?: Maybe<Polls_Baseanswerset>;
  /** fetch data from the table: "polls_basesource" */
  polls_basesource: Array<Polls_Basesource>;
  /** fetch aggregated fields from the table: "polls_basesource" */
  polls_basesource_aggregate: Polls_Basesource_Aggregate;
  /** fetch data from the table: "polls_basesource" using primary key columns */
  polls_basesource_by_pk?: Maybe<Polls_Basesource>;
  /** fetch data from the table: "polls_branch" */
  polls_branch: Array<Polls_Branch>;
  /** fetch aggregated fields from the table: "polls_branch" */
  polls_branch_aggregate: Polls_Branch_Aggregate;
  /** fetch data from the table: "polls_branch" using primary key columns */
  polls_branch_by_pk?: Maybe<Polls_Branch>;
  /** fetch data from the table: "polls_branchingquestion" */
  polls_branchingquestion: Array<Polls_Branchingquestion>;
  /** fetch aggregated fields from the table: "polls_branchingquestion" */
  polls_branchingquestion_aggregate: Polls_Branchingquestion_Aggregate;
  /** fetch data from the table: "polls_branchingquestion" using primary key columns */
  polls_branchingquestion_by_pk?: Maybe<Polls_Branchingquestion>;
  /** fetch data from the table: "polls_category" */
  polls_category: Array<Polls_Category>;
  /** fetch aggregated fields from the table: "polls_category" */
  polls_category_aggregate: Polls_Category_Aggregate;
  /** fetch data from the table: "polls_category" using primary key columns */
  polls_category_by_pk?: Maybe<Polls_Category>;
  /** fetch data from the table: "polls_categoryprogress" */
  polls_categoryprogress: Array<Polls_Categoryprogress>;
  /** fetch aggregated fields from the table: "polls_categoryprogress" */
  polls_categoryprogress_aggregate: Polls_Categoryprogress_Aggregate;
  /** fetch data from the table: "polls_categoryprogress" using primary key columns */
  polls_categoryprogress_by_pk?: Maybe<Polls_Categoryprogress>;
  /** fetch data from the table: "polls_comment" */
  polls_comment: Array<Polls_Comment>;
  /** fetch aggregated fields from the table: "polls_comment" */
  polls_comment_aggregate: Polls_Comment_Aggregate;
  /** fetch data from the table: "polls_comment" using primary key columns */
  polls_comment_by_pk?: Maybe<Polls_Comment>;
  /** fetch data from the table: "polls_datasource" */
  polls_datasource: Array<Polls_Datasource>;
  /** fetch aggregated fields from the table: "polls_datasource" */
  polls_datasource_aggregate: Polls_Datasource_Aggregate;
  /** fetch data from the table: "polls_datasource" using primary key columns */
  polls_datasource_by_pk?: Maybe<Polls_Datasource>;
  /** fetch data from the table: "polls_entity" */
  polls_entity: Array<Polls_Entity>;
  /** fetch aggregated fields from the table: "polls_entity" */
  polls_entity_aggregate: Polls_Entity_Aggregate;
  /** fetch data from the table: "polls_entity_alt_names" */
  polls_entity_alt_names: Array<Polls_Entity_Alt_Names>;
  /** fetch aggregated fields from the table: "polls_entity_alt_names" */
  polls_entity_alt_names_aggregate: Polls_Entity_Alt_Names_Aggregate;
  /** fetch data from the table: "polls_entity_alt_names" using primary key columns */
  polls_entity_alt_names_by_pk?: Maybe<Polls_Entity_Alt_Names>;
  /** fetch data from the table: "polls_entity" using primary key columns */
  polls_entity_by_pk?: Maybe<Polls_Entity>;
  /** fetch data from the table: "polls_entity_tags" */
  polls_entity_tags: Array<Polls_Entity_Tags>;
  /** fetch aggregated fields from the table: "polls_entity_tags" */
  polls_entity_tags_aggregate: Polls_Entity_Tags_Aggregate;
  /** fetch data from the table: "polls_entity_tags" using primary key columns */
  polls_entity_tags_by_pk?: Maybe<Polls_Entity_Tags>;
  /** fetch data from the table: "polls_entityname" */
  polls_entityname: Array<Polls_Entityname>;
  /** fetch aggregated fields from the table: "polls_entityname" */
  polls_entityname_aggregate: Polls_Entityname_Aggregate;
  /** fetch data from the table: "polls_entityname" using primary key columns */
  polls_entityname_by_pk?: Maybe<Polls_Entityname>;
  /** fetch data from the table: "polls_entitytag" */
  polls_entitytag: Array<Polls_Entitytag>;
  /** fetch aggregated fields from the table: "polls_entitytag" */
  polls_entitytag_aggregate: Polls_Entitytag_Aggregate;
  /** fetch data from the table: "polls_entitytag" using primary key columns */
  polls_entitytag_by_pk?: Maybe<Polls_Entitytag>;
  /** fetch data from the table: "polls_entry_attachment" */
  polls_entry_attachment: Array<Polls_Entry_Attachment>;
  /** fetch aggregated fields from the table: "polls_entry_attachment" */
  polls_entry_attachment_aggregate: Polls_Entry_Attachment_Aggregate;
  /** fetch data from the table: "polls_entry_attachment" using primary key columns */
  polls_entry_attachment_by_pk?: Maybe<Polls_Entry_Attachment>;
  /** fetch data from the table: "polls_entryattachment" */
  polls_entryattachment: Array<Polls_Entryattachment>;
  /** fetch aggregated fields from the table: "polls_entryattachment" */
  polls_entryattachment_aggregate: Polls_Entryattachment_Aggregate;
  /** fetch data from the table: "polls_entryattachment" using primary key columns */
  polls_entryattachment_by_pk?: Maybe<Polls_Entryattachment>;
  /** fetch data from the table: "polls_entryreference" */
  polls_entryreference: Array<Polls_Entryreference>;
  /** fetch aggregated fields from the table: "polls_entryreference" */
  polls_entryreference_aggregate: Polls_Entryreference_Aggregate;
  /** fetch data from the table: "polls_entryreference" using primary key columns */
  polls_entryreference_by_pk?: Maybe<Polls_Entryreference>;
  /** fetch data from the table: "polls_entrytaggroup" */
  polls_entrytaggroup: Array<Polls_Entrytaggroup>;
  /** fetch aggregated fields from the table: "polls_entrytaggroup" */
  polls_entrytaggroup_aggregate: Polls_Entrytaggroup_Aggregate;
  /** fetch data from the table: "polls_entrytaggroup" using primary key columns */
  polls_entrytaggroup_by_pk?: Maybe<Polls_Entrytaggroup>;
  /** fetch data from the table: "polls_group" */
  polls_group: Array<Polls_Group>;
  /** fetch aggregated fields from the table: "polls_group" */
  polls_group_aggregate: Polls_Group_Aggregate;
  /** fetch data from the table: "polls_group" using primary key columns */
  polls_group_by_pk?: Maybe<Polls_Group>;
  /** fetch data from the table: "polls_poll" */
  polls_poll: Array<Polls_Poll>;
  /** fetch aggregated fields from the table: "polls_poll" */
  polls_poll_aggregate: Polls_Poll_Aggregate;
  /** fetch data from the table: "polls_poll" using primary key columns */
  polls_poll_by_pk?: Maybe<Polls_Poll>;
  /** fetch data from the table: "polls_poll_optional_entry_tag_groups" */
  polls_poll_optional_entry_tag_groups: Array<Polls_Poll_Optional_Entry_Tag_Groups>;
  /** fetch aggregated fields from the table: "polls_poll_optional_entry_tag_groups" */
  polls_poll_optional_entry_tag_groups_aggregate: Polls_Poll_Optional_Entry_Tag_Groups_Aggregate;
  /** fetch data from the table: "polls_poll_optional_entry_tag_groups" using primary key columns */
  polls_poll_optional_entry_tag_groups_by_pk?: Maybe<Polls_Poll_Optional_Entry_Tag_Groups>;
  /** fetch data from the table: "polls_poll_required_entry_tag_groups" */
  polls_poll_required_entry_tag_groups: Array<Polls_Poll_Required_Entry_Tag_Groups>;
  /** fetch aggregated fields from the table: "polls_poll_required_entry_tag_groups" */
  polls_poll_required_entry_tag_groups_aggregate: Polls_Poll_Required_Entry_Tag_Groups_Aggregate;
  /** fetch data from the table: "polls_poll_required_entry_tag_groups" using primary key columns */
  polls_poll_required_entry_tag_groups_by_pk?: Maybe<Polls_Poll_Required_Entry_Tag_Groups>;
  /** fetch data from the table: "polls_pollprogress" */
  polls_pollprogress: Array<Polls_Pollprogress>;
  /** fetch aggregated fields from the table: "polls_pollprogress" */
  polls_pollprogress_aggregate: Polls_Pollprogress_Aggregate;
  /** fetch data from the table: "polls_pollprogress" using primary key columns */
  polls_pollprogress_by_pk?: Maybe<Polls_Pollprogress>;
  /** fetch data from the table: "polls_pollprogress_considered_answer_sets" */
  polls_pollprogress_considered_answer_sets: Array<Polls_Pollprogress_Considered_Answer_Sets>;
  /** fetch aggregated fields from the table: "polls_pollprogress_considered_answer_sets" */
  polls_pollprogress_considered_answer_sets_aggregate: Polls_Pollprogress_Considered_Answer_Sets_Aggregate;
  /** fetch data from the table: "polls_pollprogress_considered_answer_sets" using primary key columns */
  polls_pollprogress_considered_answer_sets_by_pk?: Maybe<Polls_Pollprogress_Considered_Answer_Sets>;
  /** fetch data from the table: "polls_question" */
  polls_question: Array<Polls_Question>;
  /** fetch aggregated fields from the table: "polls_question" */
  polls_question_aggregate: Polls_Question_Aggregate;
  /** fetch data from the table: "polls_question" using primary key columns */
  polls_question_by_pk?: Maybe<Polls_Question>;
  /** fetch data from the table: "polls_questionrelation" */
  polls_questionrelation: Array<Polls_Questionrelation>;
  /** fetch aggregated fields from the table: "polls_questionrelation" */
  polls_questionrelation_aggregate: Polls_Questionrelation_Aggregate;
  /** fetch data from the table: "polls_questionrelation" using primary key columns */
  polls_questionrelation_by_pk?: Maybe<Polls_Questionrelation>;
  /** fetch data from the table: "polls_searchrequest" */
  polls_searchrequest: Array<Polls_Searchrequest>;
  /** fetch aggregated fields from the table: "polls_searchrequest" */
  polls_searchrequest_aggregate: Polls_Searchrequest_Aggregate;
  /** fetch data from the table: "polls_searchrequest" using primary key columns */
  polls_searchrequest_by_pk?: Maybe<Polls_Searchrequest>;
  /** fetch data from the table: "polls_secondarysource" */
  polls_secondarysource: Array<Polls_Secondarysource>;
  /** fetch aggregated fields from the table: "polls_secondarysource" */
  polls_secondarysource_aggregate: Polls_Secondarysource_Aggregate;
  /** fetch data from the table: "polls_secondarysource" using primary key columns */
  polls_secondarysource_by_pk?: Maybe<Polls_Secondarysource>;
  /** fetch data from the table: "polls_templateanswer" */
  polls_templateanswer: Array<Polls_Templateanswer>;
  /** fetch aggregated fields from the table: "polls_templateanswer" */
  polls_templateanswer_aggregate: Polls_Templateanswer_Aggregate;
  /** fetch data from the table: "polls_templateanswer" using primary key columns */
  polls_templateanswer_by_pk?: Maybe<Polls_Templateanswer>;
  /** fetch data from the table: "polls_templateanswerset" */
  polls_templateanswerset: Array<Polls_Templateanswerset>;
  /** fetch aggregated fields from the table: "polls_templateanswerset" */
  polls_templateanswerset_aggregate: Polls_Templateanswerset_Aggregate;
  /** fetch data from the table: "polls_templateanswerset" using primary key columns */
  polls_templateanswerset_by_pk?: Maybe<Polls_Templateanswerset>;
  /** execute function "search_area_answers" which returns "polls_answer" */
  search_area_answers: Array<Polls_Answer>;
  /** execute function "search_area_answers" and query aggregates on result of table type "polls_answer" */
  search_area_answers_aggregate: Polls_Answer_Aggregate;
  /** execute function "search_region_answers" which returns "polls_answer" */
  search_region_answers: Array<Polls_Answer>;
  /** execute function "search_region_answers" and query aggregates on result of table type "polls_answer" */
  search_region_answers_aggregate: Polls_Answer_Aggregate;
  /** fetch data from the table: "user_file" */
  user_file: Array<User_File>;
  /** fetch aggregated fields from the table: "user_file" */
  user_file_aggregate: User_File_Aggregate;
  /** fetch data from the table: "user_file" using primary key columns */
  user_file_by_pk?: Maybe<User_File>;
};


export type Subscription_RootAccounts_ExpertArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Expert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Expert_Order_By>>;
  where?: InputMaybe<Accounts_Expert_Bool_Exp>;
};


export type Subscription_RootAccounts_Expert_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Expert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Expert_Order_By>>;
  where?: InputMaybe<Accounts_Expert_Bool_Exp>;
};


export type Subscription_RootAccounts_Expert_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAccounts_ExpertentriessummaryArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Expertentriessummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Expertentriessummary_Order_By>>;
  where?: InputMaybe<Accounts_Expertentriessummary_Bool_Exp>;
};


export type Subscription_RootAccounts_Expertentriessummary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Expertentriessummary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Expertentriessummary_Order_By>>;
  where?: InputMaybe<Accounts_Expertentriessummary_Bool_Exp>;
};


export type Subscription_RootAccounts_ManagingeditorArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Managingeditor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Managingeditor_Order_By>>;
  where?: InputMaybe<Accounts_Managingeditor_Bool_Exp>;
};


export type Subscription_RootAccounts_Managingeditor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Managingeditor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Managingeditor_Order_By>>;
  where?: InputMaybe<Accounts_Managingeditor_Bool_Exp>;
};


export type Subscription_RootAccounts_Managingeditor_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAccounts_ProfileArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Profile_Order_By>>;
  where?: InputMaybe<Accounts_Profile_Bool_Exp>;
};


export type Subscription_RootAccounts_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Profile_Order_By>>;
  where?: InputMaybe<Accounts_Profile_Bool_Exp>;
};


export type Subscription_RootAccounts_Profile_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAccounts_RegionaleditorArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Regionaleditor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Regionaleditor_Order_By>>;
  where?: InputMaybe<Accounts_Regionaleditor_Bool_Exp>;
};


export type Subscription_RootAccounts_Regionaleditor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Regionaleditor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Regionaleditor_Order_By>>;
  where?: InputMaybe<Accounts_Regionaleditor_Bool_Exp>;
};


export type Subscription_RootAccounts_Regionaleditor_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAccounts_RegionaleditorcategoryArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Regionaleditorcategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Regionaleditorcategory_Order_By>>;
  where?: InputMaybe<Accounts_Regionaleditorcategory_Bool_Exp>;
};


export type Subscription_RootAccounts_Regionaleditorcategory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Regionaleditorcategory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Regionaleditorcategory_Order_By>>;
  where?: InputMaybe<Accounts_Regionaleditorcategory_Bool_Exp>;
};


export type Subscription_RootAccounts_Regionaleditorcategory_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAccounts_Regionaleditorcategory_EditorsArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Regionaleditorcategory_Editors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Regionaleditorcategory_Editors_Order_By>>;
  where?: InputMaybe<Accounts_Regionaleditorcategory_Editors_Bool_Exp>;
};


export type Subscription_RootAccounts_Regionaleditorcategory_Editors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Regionaleditorcategory_Editors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Regionaleditorcategory_Editors_Order_By>>;
  where?: InputMaybe<Accounts_Regionaleditorcategory_Editors_Bool_Exp>;
};


export type Subscription_RootAccounts_Regionaleditorcategory_Editors_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAccounts_TranslatorArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Translator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Translator_Order_By>>;
  where?: InputMaybe<Accounts_Translator_Bool_Exp>;
};


export type Subscription_RootAccounts_Translator_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accounts_Translator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accounts_Translator_Order_By>>;
  where?: InputMaybe<Accounts_Translator_Bool_Exp>;
};


export type Subscription_RootAccounts_Translator_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAnalyze_User_QueryArgs = {
  distinct_on?: InputMaybe<Array<Analyze_User_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Analyze_User_Query_Order_By>>;
  where?: InputMaybe<Analyze_User_Query_Bool_Exp>;
};


export type Subscription_RootAnalyze_User_Query_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Analyze_User_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Analyze_User_Query_Order_By>>;
  where?: InputMaybe<Analyze_User_Query_Bool_Exp>;
};


export type Subscription_RootAnalyze_User_Query_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAuth_UserArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_User_Order_By>>;
  where?: InputMaybe<Auth_User_Bool_Exp>;
};


export type Subscription_RootAuth_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_User_Order_By>>;
  where?: InputMaybe<Auth_User_Bool_Exp>;
};


export type Subscription_RootAuth_User_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootGis_Regions_Gis_RegionArgs = {
  distinct_on?: InputMaybe<Array<Gis_Regions_Gis_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gis_Regions_Gis_Region_Order_By>>;
  where?: InputMaybe<Gis_Regions_Gis_Region_Bool_Exp>;
};


export type Subscription_RootGis_Regions_Gis_Region_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gis_Regions_Gis_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gis_Regions_Gis_Region_Order_By>>;
  where?: InputMaybe<Gis_Regions_Gis_Region_Bool_Exp>;
};


export type Subscription_RootGis_Regions_Gis_Region_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootGis_Regions_Gis_Region_TagsArgs = {
  distinct_on?: InputMaybe<Array<Gis_Regions_Gis_Region_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gis_Regions_Gis_Region_Tags_Order_By>>;
  where?: InputMaybe<Gis_Regions_Gis_Region_Tags_Bool_Exp>;
};


export type Subscription_RootGis_Regions_Gis_Region_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gis_Regions_Gis_Region_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gis_Regions_Gis_Region_Tags_Order_By>>;
  where?: InputMaybe<Gis_Regions_Gis_Region_Tags_Bool_Exp>;
};


export type Subscription_RootGis_Regions_Gis_Region_Tags_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootGis_Regions_Gis_TagArgs = {
  distinct_on?: InputMaybe<Array<Gis_Regions_Gis_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gis_Regions_Gis_Tag_Order_By>>;
  where?: InputMaybe<Gis_Regions_Gis_Tag_Bool_Exp>;
};


export type Subscription_RootGis_Regions_Gis_Tag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gis_Regions_Gis_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gis_Regions_Gis_Tag_Order_By>>;
  where?: InputMaybe<Gis_Regions_Gis_Tag_Bool_Exp>;
};


export type Subscription_RootGis_Regions_Gis_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPoll_DraftsArgs = {
  distinct_on?: InputMaybe<Array<Poll_Drafts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Poll_Drafts_Order_By>>;
  where?: InputMaybe<Poll_Drafts_Bool_Exp>;
};


export type Subscription_RootPoll_Drafts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Poll_Drafts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Poll_Drafts_Order_By>>;
  where?: InputMaybe<Poll_Drafts_Bool_Exp>;
};


export type Subscription_RootPoll_Drafts_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_AnswerArgs = {
  distinct_on?: InputMaybe<Array<Polls_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answer_Order_By>>;
  where?: InputMaybe<Polls_Answer_Bool_Exp>;
};


export type Subscription_RootPolls_Answer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answer_Order_By>>;
  where?: InputMaybe<Polls_Answer_Bool_Exp>;
};


export type Subscription_RootPolls_Answer_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_Answer_Set_AttachmentArgs = {
  distinct_on?: InputMaybe<Array<Polls_Answer_Set_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answer_Set_Attachment_Order_By>>;
  where?: InputMaybe<Polls_Answer_Set_Attachment_Bool_Exp>;
};


export type Subscription_RootPolls_Answer_Set_Attachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Answer_Set_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answer_Set_Attachment_Order_By>>;
  where?: InputMaybe<Polls_Answer_Set_Attachment_Bool_Exp>;
};


export type Subscription_RootPolls_Answer_Set_Attachment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_AnswersetArgs = {
  distinct_on?: InputMaybe<Array<Polls_Answerset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answerset_Order_By>>;
  where?: InputMaybe<Polls_Answerset_Bool_Exp>;
};


export type Subscription_RootPolls_Answerset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Answerset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answerset_Order_By>>;
  where?: InputMaybe<Polls_Answerset_Bool_Exp>;
};


export type Subscription_RootPolls_Answerset_By_PkArgs = {
  baseanswerset_ptr_id: Scalars['Int'];
};


export type Subscription_RootPolls_AnswersetattachmentArgs = {
  distinct_on?: InputMaybe<Array<Polls_Answersetattachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answersetattachment_Order_By>>;
  where?: InputMaybe<Polls_Answersetattachment_Bool_Exp>;
};


export type Subscription_RootPolls_Answersetattachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Answersetattachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answersetattachment_Order_By>>;
  where?: InputMaybe<Polls_Answersetattachment_Bool_Exp>;
};


export type Subscription_RootPolls_Answersetattachment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_BaseanswersetArgs = {
  distinct_on?: InputMaybe<Array<Polls_Baseanswerset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Baseanswerset_Order_By>>;
  where?: InputMaybe<Polls_Baseanswerset_Bool_Exp>;
};


export type Subscription_RootPolls_Baseanswerset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Baseanswerset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Baseanswerset_Order_By>>;
  where?: InputMaybe<Polls_Baseanswerset_Bool_Exp>;
};


export type Subscription_RootPolls_Baseanswerset_BranchesArgs = {
  distinct_on?: InputMaybe<Array<Polls_Baseanswerset_Branches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Baseanswerset_Branches_Order_By>>;
  where?: InputMaybe<Polls_Baseanswerset_Branches_Bool_Exp>;
};


export type Subscription_RootPolls_Baseanswerset_Branches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Baseanswerset_Branches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Baseanswerset_Branches_Order_By>>;
  where?: InputMaybe<Polls_Baseanswerset_Branches_Bool_Exp>;
};


export type Subscription_RootPolls_Baseanswerset_Branches_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_Baseanswerset_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_BasesourceArgs = {
  distinct_on?: InputMaybe<Array<Polls_Basesource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Basesource_Order_By>>;
  where?: InputMaybe<Polls_Basesource_Bool_Exp>;
};


export type Subscription_RootPolls_Basesource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Basesource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Basesource_Order_By>>;
  where?: InputMaybe<Polls_Basesource_Bool_Exp>;
};


export type Subscription_RootPolls_Basesource_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_BranchArgs = {
  distinct_on?: InputMaybe<Array<Polls_Branch_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Branch_Order_By>>;
  where?: InputMaybe<Polls_Branch_Bool_Exp>;
};


export type Subscription_RootPolls_Branch_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Branch_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Branch_Order_By>>;
  where?: InputMaybe<Polls_Branch_Bool_Exp>;
};


export type Subscription_RootPolls_Branch_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_BranchingquestionArgs = {
  distinct_on?: InputMaybe<Array<Polls_Branchingquestion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Branchingquestion_Order_By>>;
  where?: InputMaybe<Polls_Branchingquestion_Bool_Exp>;
};


export type Subscription_RootPolls_Branchingquestion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Branchingquestion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Branchingquestion_Order_By>>;
  where?: InputMaybe<Polls_Branchingquestion_Bool_Exp>;
};


export type Subscription_RootPolls_Branchingquestion_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Polls_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Category_Order_By>>;
  where?: InputMaybe<Polls_Category_Bool_Exp>;
};


export type Subscription_RootPolls_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Category_Order_By>>;
  where?: InputMaybe<Polls_Category_Bool_Exp>;
};


export type Subscription_RootPolls_Category_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_CategoryprogressArgs = {
  distinct_on?: InputMaybe<Array<Polls_Categoryprogress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Categoryprogress_Order_By>>;
  where?: InputMaybe<Polls_Categoryprogress_Bool_Exp>;
};


export type Subscription_RootPolls_Categoryprogress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Categoryprogress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Categoryprogress_Order_By>>;
  where?: InputMaybe<Polls_Categoryprogress_Bool_Exp>;
};


export type Subscription_RootPolls_Categoryprogress_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_CommentArgs = {
  distinct_on?: InputMaybe<Array<Polls_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Comment_Order_By>>;
  where?: InputMaybe<Polls_Comment_Bool_Exp>;
};


export type Subscription_RootPolls_Comment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Comment_Order_By>>;
  where?: InputMaybe<Polls_Comment_Bool_Exp>;
};


export type Subscription_RootPolls_Comment_By_PkArgs = {
  baseanswerset_ptr_id: Scalars['Int'];
};


export type Subscription_RootPolls_DatasourceArgs = {
  distinct_on?: InputMaybe<Array<Polls_Datasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Datasource_Order_By>>;
  where?: InputMaybe<Polls_Datasource_Bool_Exp>;
};


export type Subscription_RootPolls_Datasource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Datasource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Datasource_Order_By>>;
  where?: InputMaybe<Polls_Datasource_Bool_Exp>;
};


export type Subscription_RootPolls_Datasource_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_EntityArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Order_By>>;
  where?: InputMaybe<Polls_Entity_Bool_Exp>;
};


export type Subscription_RootPolls_Entity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Order_By>>;
  where?: InputMaybe<Polls_Entity_Bool_Exp>;
};


export type Subscription_RootPolls_Entity_Alt_NamesArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Alt_Names_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Alt_Names_Order_By>>;
  where?: InputMaybe<Polls_Entity_Alt_Names_Bool_Exp>;
};


export type Subscription_RootPolls_Entity_Alt_Names_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Alt_Names_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Alt_Names_Order_By>>;
  where?: InputMaybe<Polls_Entity_Alt_Names_Bool_Exp>;
};


export type Subscription_RootPolls_Entity_Alt_Names_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_Entity_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_Entity_TagsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Tags_Order_By>>;
  where?: InputMaybe<Polls_Entity_Tags_Bool_Exp>;
};


export type Subscription_RootPolls_Entity_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Tags_Order_By>>;
  where?: InputMaybe<Polls_Entity_Tags_Bool_Exp>;
};


export type Subscription_RootPolls_Entity_Tags_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_EntitynameArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entityname_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entityname_Order_By>>;
  where?: InputMaybe<Polls_Entityname_Bool_Exp>;
};


export type Subscription_RootPolls_Entityname_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entityname_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entityname_Order_By>>;
  where?: InputMaybe<Polls_Entityname_Bool_Exp>;
};


export type Subscription_RootPolls_Entityname_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_EntitytagArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entitytag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entitytag_Order_By>>;
  where?: InputMaybe<Polls_Entitytag_Bool_Exp>;
};


export type Subscription_RootPolls_Entitytag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entitytag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entitytag_Order_By>>;
  where?: InputMaybe<Polls_Entitytag_Bool_Exp>;
};


export type Subscription_RootPolls_Entitytag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_Entry_AttachmentArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entry_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entry_Attachment_Order_By>>;
  where?: InputMaybe<Polls_Entry_Attachment_Bool_Exp>;
};


export type Subscription_RootPolls_Entry_Attachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entry_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entry_Attachment_Order_By>>;
  where?: InputMaybe<Polls_Entry_Attachment_Bool_Exp>;
};


export type Subscription_RootPolls_Entry_Attachment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_EntryattachmentArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entryattachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entryattachment_Order_By>>;
  where?: InputMaybe<Polls_Entryattachment_Bool_Exp>;
};


export type Subscription_RootPolls_Entryattachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entryattachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entryattachment_Order_By>>;
  where?: InputMaybe<Polls_Entryattachment_Bool_Exp>;
};


export type Subscription_RootPolls_Entryattachment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_EntryreferenceArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entryreference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entryreference_Order_By>>;
  where?: InputMaybe<Polls_Entryreference_Bool_Exp>;
};


export type Subscription_RootPolls_Entryreference_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entryreference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entryreference_Order_By>>;
  where?: InputMaybe<Polls_Entryreference_Bool_Exp>;
};


export type Subscription_RootPolls_Entryreference_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_EntrytaggroupArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entrytaggroup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entrytaggroup_Order_By>>;
  where?: InputMaybe<Polls_Entrytaggroup_Bool_Exp>;
};


export type Subscription_RootPolls_Entrytaggroup_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entrytaggroup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entrytaggroup_Order_By>>;
  where?: InputMaybe<Polls_Entrytaggroup_Bool_Exp>;
};


export type Subscription_RootPolls_Entrytaggroup_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_GroupArgs = {
  distinct_on?: InputMaybe<Array<Polls_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Group_Order_By>>;
  where?: InputMaybe<Polls_Group_Bool_Exp>;
};


export type Subscription_RootPolls_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Group_Order_By>>;
  where?: InputMaybe<Polls_Group_Bool_Exp>;
};


export type Subscription_RootPolls_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_PollArgs = {
  distinct_on?: InputMaybe<Array<Polls_Poll_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Poll_Order_By>>;
  where?: InputMaybe<Polls_Poll_Bool_Exp>;
};


export type Subscription_RootPolls_Poll_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Poll_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Poll_Order_By>>;
  where?: InputMaybe<Polls_Poll_Bool_Exp>;
};


export type Subscription_RootPolls_Poll_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_Poll_Optional_Entry_Tag_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Poll_Optional_Entry_Tag_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Poll_Optional_Entry_Tag_Groups_Order_By>>;
  where?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_Bool_Exp>;
};


export type Subscription_RootPolls_Poll_Optional_Entry_Tag_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Poll_Optional_Entry_Tag_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Poll_Optional_Entry_Tag_Groups_Order_By>>;
  where?: InputMaybe<Polls_Poll_Optional_Entry_Tag_Groups_Bool_Exp>;
};


export type Subscription_RootPolls_Poll_Optional_Entry_Tag_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_Poll_Required_Entry_Tag_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Poll_Required_Entry_Tag_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Poll_Required_Entry_Tag_Groups_Order_By>>;
  where?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_Bool_Exp>;
};


export type Subscription_RootPolls_Poll_Required_Entry_Tag_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Poll_Required_Entry_Tag_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Poll_Required_Entry_Tag_Groups_Order_By>>;
  where?: InputMaybe<Polls_Poll_Required_Entry_Tag_Groups_Bool_Exp>;
};


export type Subscription_RootPolls_Poll_Required_Entry_Tag_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_PollprogressArgs = {
  distinct_on?: InputMaybe<Array<Polls_Pollprogress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Pollprogress_Order_By>>;
  where?: InputMaybe<Polls_Pollprogress_Bool_Exp>;
};


export type Subscription_RootPolls_Pollprogress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Pollprogress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Pollprogress_Order_By>>;
  where?: InputMaybe<Polls_Pollprogress_Bool_Exp>;
};


export type Subscription_RootPolls_Pollprogress_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_Pollprogress_Considered_Answer_SetsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Pollprogress_Considered_Answer_Sets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Pollprogress_Considered_Answer_Sets_Order_By>>;
  where?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_Bool_Exp>;
};


export type Subscription_RootPolls_Pollprogress_Considered_Answer_Sets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Pollprogress_Considered_Answer_Sets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Pollprogress_Considered_Answer_Sets_Order_By>>;
  where?: InputMaybe<Polls_Pollprogress_Considered_Answer_Sets_Bool_Exp>;
};


export type Subscription_RootPolls_Pollprogress_Considered_Answer_Sets_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_QuestionArgs = {
  distinct_on?: InputMaybe<Array<Polls_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Question_Order_By>>;
  where?: InputMaybe<Polls_Question_Bool_Exp>;
};


export type Subscription_RootPolls_Question_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Question_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Question_Order_By>>;
  where?: InputMaybe<Polls_Question_Bool_Exp>;
};


export type Subscription_RootPolls_Question_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_QuestionrelationArgs = {
  distinct_on?: InputMaybe<Array<Polls_Questionrelation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Questionrelation_Order_By>>;
  where?: InputMaybe<Polls_Questionrelation_Bool_Exp>;
};


export type Subscription_RootPolls_Questionrelation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Questionrelation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Questionrelation_Order_By>>;
  where?: InputMaybe<Polls_Questionrelation_Bool_Exp>;
};


export type Subscription_RootPolls_Questionrelation_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_SearchrequestArgs = {
  distinct_on?: InputMaybe<Array<Polls_Searchrequest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Searchrequest_Order_By>>;
  where?: InputMaybe<Polls_Searchrequest_Bool_Exp>;
};


export type Subscription_RootPolls_Searchrequest_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Searchrequest_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Searchrequest_Order_By>>;
  where?: InputMaybe<Polls_Searchrequest_Bool_Exp>;
};


export type Subscription_RootPolls_Searchrequest_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_SecondarysourceArgs = {
  distinct_on?: InputMaybe<Array<Polls_Secondarysource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Secondarysource_Order_By>>;
  where?: InputMaybe<Polls_Secondarysource_Bool_Exp>;
};


export type Subscription_RootPolls_Secondarysource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Secondarysource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Secondarysource_Order_By>>;
  where?: InputMaybe<Polls_Secondarysource_Bool_Exp>;
};


export type Subscription_RootPolls_Secondarysource_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_TemplateanswerArgs = {
  distinct_on?: InputMaybe<Array<Polls_Templateanswer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Templateanswer_Order_By>>;
  where?: InputMaybe<Polls_Templateanswer_Bool_Exp>;
};


export type Subscription_RootPolls_Templateanswer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Templateanswer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Templateanswer_Order_By>>;
  where?: InputMaybe<Polls_Templateanswer_Bool_Exp>;
};


export type Subscription_RootPolls_Templateanswer_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPolls_TemplateanswersetArgs = {
  distinct_on?: InputMaybe<Array<Polls_Templateanswerset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Templateanswerset_Order_By>>;
  where?: InputMaybe<Polls_Templateanswerset_Bool_Exp>;
};


export type Subscription_RootPolls_Templateanswerset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Templateanswerset_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Templateanswerset_Order_By>>;
  where?: InputMaybe<Polls_Templateanswerset_Bool_Exp>;
};


export type Subscription_RootPolls_Templateanswerset_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSearch_Area_AnswersArgs = {
  args: Search_Area_Answers_Args;
  distinct_on?: InputMaybe<Array<Polls_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answer_Order_By>>;
  where?: InputMaybe<Polls_Answer_Bool_Exp>;
};


export type Subscription_RootSearch_Area_Answers_AggregateArgs = {
  args: Search_Area_Answers_Args;
  distinct_on?: InputMaybe<Array<Polls_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answer_Order_By>>;
  where?: InputMaybe<Polls_Answer_Bool_Exp>;
};


export type Subscription_RootSearch_Region_AnswersArgs = {
  args: Search_Region_Answers_Args;
  distinct_on?: InputMaybe<Array<Polls_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answer_Order_By>>;
  where?: InputMaybe<Polls_Answer_Bool_Exp>;
};


export type Subscription_RootSearch_Region_Answers_AggregateArgs = {
  args: Search_Region_Answers_Args;
  distinct_on?: InputMaybe<Array<Polls_Answer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answer_Order_By>>;
  where?: InputMaybe<Polls_Answer_Bool_Exp>;
};


export type Subscription_RootUser_FileArgs = {
  distinct_on?: InputMaybe<Array<User_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_File_Order_By>>;
  where?: InputMaybe<User_File_Bool_Exp>;
};


export type Subscription_RootUser_File_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_File_Order_By>>;
  where?: InputMaybe<User_File_Bool_Exp>;
};


export type Subscription_RootUser_File_By_PkArgs = {
  id: Scalars['uuid'];
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

export type Translated_Description_Polls_Poll_Args = {
  lang?: InputMaybe<Scalars['String']>;
};

export type Translated_Description_Polls_Question_Args = {
  lang?: InputMaybe<Scalars['String']>;
};

export type Translated_Name_Polls_Branch_Args = {
  lang?: InputMaybe<Scalars['String']>;
};

export type Translated_Name_Polls_Branchingquestion_Args = {
  lang?: InputMaybe<Scalars['String']>;
};

export type Translated_Name_Polls_Category_Args = {
  lang?: InputMaybe<Scalars['String']>;
};

export type Translated_Name_Polls_Group_Args = {
  lang?: InputMaybe<Scalars['String']>;
};

export type Translated_Name_Polls_Poll_Args = {
  lang?: InputMaybe<Scalars['String']>;
};

export type Translated_Name_Polls_Question_Args = {
  lang?: InputMaybe<Scalars['String']>;
};

export type Translated_Name_Polls_Templateanswer_Args = {
  lang?: InputMaybe<Scalars['String']>;
};

export type Translated_Tooltip_Polls_Branch_Args = {
  lang?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "user_file" */
export type User_File = {
  __typename?: 'user_file';
  /** An array relationship */
  answer_set_attachments: Array<Polls_Answer_Set_Attachment>;
  /** An aggregate relationship */
  answer_set_attachments_aggregate: Polls_Answer_Set_Attachment_Aggregate;
  content_type: Scalars['String'];
  date_created: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  /** A computed field, executes function "get_user_file_entries" */
  entries?: Maybe<Array<Polls_Entity>>;
  /** An array relationship */
  entry_attachments: Array<Polls_Entry_Attachment>;
  /** An aggregate relationship */
  entry_attachments_aggregate: Polls_Entry_Attachment_Aggregate;
  id: Scalars['uuid'];
  name: Scalars['String'];
  size: Scalars['Int'];
  thumbnail?: Maybe<Scalars['jsonb']>;
  title?: Maybe<Scalars['String']>;
  /** An object relationship */
  user: Auth_User;
  user_id: Scalars['Int'];
};


/** columns and relationships of "user_file" */
export type User_FileAnswer_Set_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Answer_Set_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answer_Set_Attachment_Order_By>>;
  where?: InputMaybe<Polls_Answer_Set_Attachment_Bool_Exp>;
};


/** columns and relationships of "user_file" */
export type User_FileAnswer_Set_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Answer_Set_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Answer_Set_Attachment_Order_By>>;
  where?: InputMaybe<Polls_Answer_Set_Attachment_Bool_Exp>;
};


/** columns and relationships of "user_file" */
export type User_FileEntriesArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entity_Order_By>>;
  where?: InputMaybe<Polls_Entity_Bool_Exp>;
};


/** columns and relationships of "user_file" */
export type User_FileEntry_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entry_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entry_Attachment_Order_By>>;
  where?: InputMaybe<Polls_Entry_Attachment_Bool_Exp>;
};


/** columns and relationships of "user_file" */
export type User_FileEntry_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polls_Entry_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polls_Entry_Attachment_Order_By>>;
  where?: InputMaybe<Polls_Entry_Attachment_Bool_Exp>;
};


/** columns and relationships of "user_file" */
export type User_FileThumbnailArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "user_file" */
export type User_File_Aggregate = {
  __typename?: 'user_file_aggregate';
  aggregate?: Maybe<User_File_Aggregate_Fields>;
  nodes: Array<User_File>;
};

/** aggregate fields of "user_file" */
export type User_File_Aggregate_Fields = {
  __typename?: 'user_file_aggregate_fields';
  avg?: Maybe<User_File_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_File_Max_Fields>;
  min?: Maybe<User_File_Min_Fields>;
  stddev?: Maybe<User_File_Stddev_Fields>;
  stddev_pop?: Maybe<User_File_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_File_Stddev_Samp_Fields>;
  sum?: Maybe<User_File_Sum_Fields>;
  var_pop?: Maybe<User_File_Var_Pop_Fields>;
  var_samp?: Maybe<User_File_Var_Samp_Fields>;
  variance?: Maybe<User_File_Variance_Fields>;
};


/** aggregate fields of "user_file" */
export type User_File_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_File_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_File_Append_Input = {
  thumbnail?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type User_File_Avg_Fields = {
  __typename?: 'user_file_avg_fields';
  size?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_file". All fields are combined with a logical 'AND'. */
export type User_File_Bool_Exp = {
  _and?: InputMaybe<Array<User_File_Bool_Exp>>;
  _not?: InputMaybe<User_File_Bool_Exp>;
  _or?: InputMaybe<Array<User_File_Bool_Exp>>;
  answer_set_attachments?: InputMaybe<Polls_Answer_Set_Attachment_Bool_Exp>;
  content_type?: InputMaybe<String_Comparison_Exp>;
  date_created?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  entries?: InputMaybe<Polls_Entity_Bool_Exp>;
  entry_attachments?: InputMaybe<Polls_Entry_Attachment_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  thumbnail?: InputMaybe<Jsonb_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Auth_User_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_file" */
export enum User_File_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserFilePkey = 'user_file_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_File_Delete_At_Path_Input = {
  thumbnail?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_File_Delete_Elem_Input = {
  thumbnail?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_File_Delete_Key_Input = {
  thumbnail?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "user_file" */
export type User_File_Inc_Input = {
  size?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_file" */
export type User_File_Insert_Input = {
  answer_set_attachments?: InputMaybe<Polls_Answer_Set_Attachment_Arr_Rel_Insert_Input>;
  content_type?: InputMaybe<Scalars['String']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  entry_attachments?: InputMaybe<Polls_Entry_Attachment_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  thumbnail?: InputMaybe<Scalars['jsonb']>;
  title?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Auth_User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type User_File_Max_Fields = {
  __typename?: 'user_file_max_fields';
  content_type?: Maybe<Scalars['String']>;
  date_created?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type User_File_Min_Fields = {
  __typename?: 'user_file_min_fields';
  content_type?: Maybe<Scalars['String']>;
  date_created?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "user_file" */
export type User_File_Mutation_Response = {
  __typename?: 'user_file_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_File>;
};

/** input type for inserting object relation for remote table "user_file" */
export type User_File_Obj_Rel_Insert_Input = {
  data: User_File_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_File_On_Conflict>;
};

/** on_conflict condition type for table "user_file" */
export type User_File_On_Conflict = {
  constraint: User_File_Constraint;
  update_columns?: Array<User_File_Update_Column>;
  where?: InputMaybe<User_File_Bool_Exp>;
};

/** Ordering options when selecting data from "user_file". */
export type User_File_Order_By = {
  answer_set_attachments_aggregate?: InputMaybe<Polls_Answer_Set_Attachment_Aggregate_Order_By>;
  content_type?: InputMaybe<Order_By>;
  date_created?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  entries_aggregate?: InputMaybe<Polls_Entity_Aggregate_Order_By>;
  entry_attachments_aggregate?: InputMaybe<Polls_Entry_Attachment_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  thumbnail?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  user?: InputMaybe<Auth_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_file */
export type User_File_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_File_Prepend_Input = {
  thumbnail?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "user_file" */
export enum User_File_Select_Column {
  /** column name */
  ContentType = 'content_type',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  Thumbnail = 'thumbnail',
  /** column name */
  Title = 'title',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_file" */
export type User_File_Set_Input = {
  content_type?: InputMaybe<Scalars['String']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  thumbnail?: InputMaybe<Scalars['jsonb']>;
  title?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_File_Stddev_Fields = {
  __typename?: 'user_file_stddev_fields';
  size?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_File_Stddev_Pop_Fields = {
  __typename?: 'user_file_stddev_pop_fields';
  size?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_File_Stddev_Samp_Fields = {
  __typename?: 'user_file_stddev_samp_fields';
  size?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type User_File_Sum_Fields = {
  __typename?: 'user_file_sum_fields';
  size?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "user_file" */
export enum User_File_Update_Column {
  /** column name */
  ContentType = 'content_type',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  Thumbnail = 'thumbnail',
  /** column name */
  Title = 'title',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type User_File_Var_Pop_Fields = {
  __typename?: 'user_file_var_pop_fields';
  size?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_File_Var_Samp_Fields = {
  __typename?: 'user_file_var_samp_fields';
  size?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_File_Variance_Fields = {
  __typename?: 'user_file_variance_fields';
  size?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

export type AcceptTermsOfUseMutationVariables = Exact<{
  expertId: Scalars['Int'];
}>;


export type AcceptTermsOfUseMutation = { __typename?: 'mutation_root', update_accounts_expert_by_pk?: { __typename?: 'accounts_expert', confirmed_agreement: boolean } | null };

export type Analyze_AnswerFragment = { __typename?: 'polls_answer', id: number, value: number, text_input_type?: any | null, text_input?: string | null, template_answer: { __typename?: 'polls_templateanswer', id: number, translated_name?: string | null }, base_answer_set: { __typename?: 'polls_baseanswerset', region_id: number, year_from?: number | null, year_to?: number | null, notes?: string | null, entry: { __typename?: 'polls_entity', id: number, name: { __typename?: 'polls_entityname', name: string } }, question: { __typename?: 'polls_question', id: number, translated_name?: string | null, translated_description?: string | null }, poll: { __typename?: 'polls_poll', id: number, translated_name?: string | null }, branches: Array<{ __typename?: 'polls_baseanswerset_branches', branch_id: number }> } } & { ' $fragmentName'?: 'Analyze_AnswerFragment' };

export type Analyze_BarChart_FirstVariable_AnswersQueryFragment = { __typename?: 'query_root', first_variable_answers: Array<(
    { __typename?: 'polls_answer' }
    & { ' $fragmentRefs'?: { 'Analyze_AnswerFragment': Analyze_AnswerFragment } }
  )> } & { ' $fragmentName'?: 'Analyze_BarChart_FirstVariable_AnswersQueryFragment' };

export type Analyze_BarChart_SecondVariable_AnswersQueryFragment = { __typename?: 'query_root', second_variable_answers: Array<(
    { __typename?: 'polls_answer' }
    & { ' $fragmentRefs'?: { 'Analyze_AnswerFragment': Analyze_AnswerFragment } }
  )> } & { ' $fragmentName'?: 'Analyze_BarChart_SecondVariable_AnswersQueryFragment' };

export type Analyze_BarChart_ThirdVariable_AnswersQueryFragment = { __typename?: 'query_root', third_variable_answers: Array<(
    { __typename?: 'polls_answer' }
    & { ' $fragmentRefs'?: { 'Analyze_AnswerFragment': Analyze_AnswerFragment } }
  )> } & { ' $fragmentName'?: 'Analyze_BarChart_ThirdVariable_AnswersQueryFragment' };

export type Analyze_BarChart_FourthVariable_AnswersQueryFragment = { __typename?: 'query_root', fourth_variable_answers: Array<(
    { __typename?: 'polls_answer' }
    & { ' $fragmentRefs'?: { 'Analyze_AnswerFragment': Analyze_AnswerFragment } }
  )> } & { ' $fragmentName'?: 'Analyze_BarChart_FourthVariable_AnswersQueryFragment' };

export type Analyze_BarChart_FifthVariable_AnswersQueryFragment = { __typename?: 'query_root', fifth_variable_answers: Array<(
    { __typename?: 'polls_answer' }
    & { ' $fragmentRefs'?: { 'Analyze_AnswerFragment': Analyze_AnswerFragment } }
  )> } & { ' $fragmentName'?: 'Analyze_BarChart_FifthVariable_AnswersQueryFragment' };

export type Analyze_BarChart_AnswersQueryVariables = Exact<{
  lang: Scalars['String'];
  includeSecondVariable: Scalars['Boolean'];
  includeThirdVariable: Scalars['Boolean'];
  includeFourthVariable: Scalars['Boolean'];
  includeFifthVariable: Scalars['Boolean'];
  firstVariableBoolExp: Polls_Answer_Bool_Exp;
  secondVariableBoolExp: Polls_Answer_Bool_Exp;
  thirdVariableBoolExp: Polls_Answer_Bool_Exp;
  fourthVariableBoolExp: Polls_Answer_Bool_Exp;
  fifthVariableBoolExp: Polls_Answer_Bool_Exp;
}>;


export type Analyze_BarChart_AnswersQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'Analyze_BarChart_FirstVariable_AnswersQueryFragment': Analyze_BarChart_FirstVariable_AnswersQueryFragment;'Analyze_BarChart_SecondVariable_AnswersQueryFragment': Analyze_BarChart_SecondVariable_AnswersQueryFragment;'Analyze_BarChart_ThirdVariable_AnswersQueryFragment': Analyze_BarChart_ThirdVariable_AnswersQueryFragment;'Analyze_BarChart_FourthVariable_AnswersQueryFragment': Analyze_BarChart_FourthVariable_AnswersQueryFragment;'Analyze_BarChart_FifthVariable_AnswersQueryFragment': Analyze_BarChart_FifthVariable_AnswersQueryFragment } }
);

export type Analyze_CsvExportTool_DatumFragment = { __typename?: 'polls_answer', id: number, value?: number, text_input?: string | null, text_input_type?: any | null, base_answer_set: { __typename?: 'polls_baseanswerset', notes?: string | null, year_from?: number | null, year_to?: number | null, region_id?: number, expert_id?: number, poll: { __typename?: 'polls_poll', id?: number, translated_name?: string | null, branching_questions: Array<{ __typename?: 'polls_branchingquestion', translated_name?: string | null }> }, entry: { __typename?: 'polls_entity', id?: number, description?: string | null, name: { __typename?: 'polls_entityname', name?: string }, data_source: { __typename?: 'polls_datasource', name?: string }, tags: Array<{ __typename?: 'polls_entity_tags', tag: { __typename?: 'polls_entitytag', name?: string } }> }, question: { __typename?: 'polls_question', id?: number, translated_name?: string | null, translated_description?: string | null, parent_question_id?: number | null, parent_question?: { __typename?: 'polls_question', translated_name?: string | null } | null, parent_template_answer?: { __typename?: 'polls_templateanswer', translated_name?: string | null, value?: number } | null }, branches: Array<{ __typename?: 'polls_baseanswerset_branches', branch: { __typename?: 'polls_branch', translated_name?: string | null } }>, region: { __typename?: 'gis_regions_gis_region', name?: string | null, description?: string | null, tags: Array<{ __typename?: 'gis_regions_gis_region_tags', tag: { __typename?: 'gis_regions_gis_tag', name?: string } }> }, expert: { __typename?: 'accounts_expert', user: { __typename?: 'auth_user', first_name?: string, last_name?: string, username?: string } } }, template_answer: { __typename?: 'polls_templateanswer', translated_name?: string | null } } & { ' $fragmentName'?: 'Analyze_CsvExportTool_DatumFragment' };

export type Analyze_CsvExportTool_FirstVariableFragment = { __typename?: 'query_root', firstVariable: Array<(
    { __typename?: 'polls_answer' }
    & { ' $fragmentRefs'?: { 'Analyze_CsvExportTool_DatumFragment': Analyze_CsvExportTool_DatumFragment } }
  )> } & { ' $fragmentName'?: 'Analyze_CsvExportTool_FirstVariableFragment' };

export type Analyze_CsvExportTool_SecondVariableFragment = { __typename?: 'query_root', secondVariable: Array<(
    { __typename?: 'polls_answer' }
    & { ' $fragmentRefs'?: { 'Analyze_CsvExportTool_DatumFragment': Analyze_CsvExportTool_DatumFragment } }
  )> } & { ' $fragmentName'?: 'Analyze_CsvExportTool_SecondVariableFragment' };

export type Analyze_CsvExportTool_ThirdVariableFragment = { __typename?: 'query_root', thirdVariable: Array<(
    { __typename?: 'polls_answer' }
    & { ' $fragmentRefs'?: { 'Analyze_CsvExportTool_DatumFragment': Analyze_CsvExportTool_DatumFragment } }
  )> } & { ' $fragmentName'?: 'Analyze_CsvExportTool_ThirdVariableFragment' };

export type Analyze_CsvExportTool_FourthVariableFragment = { __typename?: 'query_root', fourthVariable: Array<(
    { __typename?: 'polls_answer' }
    & { ' $fragmentRefs'?: { 'Analyze_CsvExportTool_DatumFragment': Analyze_CsvExportTool_DatumFragment } }
  )> } & { ' $fragmentName'?: 'Analyze_CsvExportTool_FourthVariableFragment' };

export type Analyze_CsvExportTool_FifthVariableFragment = { __typename?: 'query_root', fifthVariable: Array<(
    { __typename?: 'polls_answer' }
    & { ' $fragmentRefs'?: { 'Analyze_CsvExportTool_DatumFragment': Analyze_CsvExportTool_DatumFragment } }
  )> } & { ' $fragmentName'?: 'Analyze_CsvExportTool_FifthVariableFragment' };

export type Analyze_CsvExportTool_DataQueryVariables = Exact<{
  lang: Scalars['String'];
  includeSecondVariable: Scalars['Boolean'];
  includeThirdVariable: Scalars['Boolean'];
  includeFourthVariable: Scalars['Boolean'];
  includeFifthVariable: Scalars['Boolean'];
  firstVariableBoolExp: Polls_Answer_Bool_Exp;
  secondVariableBoolExp?: InputMaybe<Polls_Answer_Bool_Exp>;
  thirdVariableBoolExp?: InputMaybe<Polls_Answer_Bool_Exp>;
  fourthVariableBoolExp?: InputMaybe<Polls_Answer_Bool_Exp>;
  fifthVariableBoolExp?: InputMaybe<Polls_Answer_Bool_Exp>;
  dataOrderExp?: InputMaybe<Array<Polls_Answer_Order_By> | Polls_Answer_Order_By>;
  includePollId: Scalars['Boolean'];
  includePollName: Scalars['Boolean'];
  includeEntryId: Scalars['Boolean'];
  includeEntryName: Scalars['Boolean'];
  includeEntryDataSource: Scalars['Boolean'];
  includeEntryDescription: Scalars['Boolean'];
  includeEntryTags: Scalars['Boolean'];
  includeQuestionId: Scalars['Boolean'];
  includeQuestionText: Scalars['Boolean'];
  includeQuestionDescription: Scalars['Boolean'];
  includeParentQuestionId: Scalars['Boolean'];
  includeParentQuestionText: Scalars['Boolean'];
  includeAnswerText: Scalars['Boolean'];
  includeAnswerValue: Scalars['Boolean'];
  includeAnswerData: Scalars['Boolean'];
  includeParentAnswerText: Scalars['Boolean'];
  includeParentAnswerValue: Scalars['Boolean'];
  includeNotes: Scalars['Boolean'];
  includeBranchingQuestion: Scalars['Boolean'];
  includeYearRange: Scalars['Boolean'];
  includeRegionId: Scalars['Boolean'];
  includeRegionName: Scalars['Boolean'];
  includeRegionDescription: Scalars['Boolean'];
  includeRegionTags: Scalars['Boolean'];
  includeExpertId: Scalars['Boolean'];
  includeExpertName: Scalars['Boolean'];
}>;


export type Analyze_CsvExportTool_DataQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'Analyze_CsvExportTool_FirstVariableFragment': Analyze_CsvExportTool_FirstVariableFragment;'Analyze_CsvExportTool_SecondVariableFragment': Analyze_CsvExportTool_SecondVariableFragment;'Analyze_CsvExportTool_ThirdVariableFragment': Analyze_CsvExportTool_ThirdVariableFragment;'Analyze_CsvExportTool_FourthVariableFragment': Analyze_CsvExportTool_FourthVariableFragment;'Analyze_CsvExportTool_FifthVariableFragment': Analyze_CsvExportTool_FifthVariableFragment } }
);

export type Analyze_EntrySearchQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type Analyze_EntrySearchQuery = { __typename?: 'query_root', entry_search?: { __typename?: 'EntrySearchResult', hits?: Array<{ __typename?: 'EntrySearchHit', id: number, highlight: any, entry?: (
        { __typename?: 'polls_entity' }
        & { ' $fragmentRefs'?: { 'Analyze_EntryFragment': Analyze_EntryFragment } }
      ) | null }> | null } | null };

export type Analyze_EntryAnswersComparison_QuestionsQueryVariables = Exact<{
  lang: Scalars['String'];
  baseAnswerSetBoolExp: Polls_Baseanswerset_Bool_Exp;
}>;


export type Analyze_EntryAnswersComparison_QuestionsQuery = { __typename?: 'query_root', polls_question: Array<{ __typename?: 'polls_question', id: number, name: string, translated_name?: string | null, multiple_answers_allowed: boolean, base_answer_sets: Array<{ __typename?: 'polls_baseanswerset', entry_id: number, answers: Array<{ __typename?: 'polls_answer', name: string, order: number, text_input?: string | null, template_answer: { __typename?: 'polls_templateanswer', name: string, translated_name?: string | null } }> }>, template_answer_set: { __typename?: 'polls_templateanswerset', answers: Array<{ __typename?: 'polls_templateanswer', name: string }> }, related_question_ids_1: Array<{ __typename?: 'polls_questionrelation', second_question_id: number }>, related_question_ids_2: Array<{ __typename?: 'polls_questionrelation', first_question_id: number }> }> };

export type Analyze_EntryFragment = { __typename?: 'polls_entity', id: number, year_from: number, year_to: number, name: { __typename?: 'polls_entityname', name: string }, poll: { __typename?: 'polls_poll', id: number, name: string } } & { ' $fragmentName'?: 'Analyze_EntryFragment' };

export type Analyze_QuestionAnswersComparison_EntriesQueryVariables = Exact<{
  lang: Scalars['String'];
  baseAnswerSetBoolExp: Polls_Baseanswerset_Bool_Exp;
}>;


export type Analyze_QuestionAnswersComparison_EntriesQuery = { __typename?: 'query_root', polls_entity: Array<{ __typename?: 'polls_entity', id: number, year_from: number, year_to: number, name: { __typename?: 'polls_entityname', name: string }, base_answer_sets: Array<{ __typename?: 'polls_baseanswerset', question_id: number, answers: Array<{ __typename?: 'polls_answer', id: number, name: string, order: number, text_input?: string | null, template_answer: { __typename?: 'polls_templateanswer', translated_name?: string | null } }> }> }> };

export type Analyze_QuestionPicker_PollsQueryVariables = Exact<{ [key: string]: never; }>;


export type Analyze_QuestionPicker_PollsQuery = { __typename?: 'query_root', polls_poll: Array<{ __typename?: 'polls_poll', id: number, name: string }> };

export type Analyze_QuestionPicker_QuestionList_AnswerFragment = { __typename?: 'polls_templateanswer', id: number, name: string, text_input_type?: any | null } & { ' $fragmentName'?: 'Analyze_QuestionPicker_QuestionList_AnswerFragment' };

export type Analyze_QuestionPicker_QuestionList_CategoryFragment = { __typename?: 'polls_category', id: number, name: string, groups: Array<(
    { __typename?: 'polls_group', id: number }
    & { ' $fragmentRefs'?: { 'Analyze_QuestionPicker_QuestionList_GroupFragment': Analyze_QuestionPicker_QuestionList_GroupFragment } }
  )>, questions: Array<(
    { __typename?: 'polls_question', id: number }
    & { ' $fragmentRefs'?: { 'Analyze_QuestionPicker_QuestionList_QuestionFragment': Analyze_QuestionPicker_QuestionList_QuestionFragment } }
  )> } & { ' $fragmentName'?: 'Analyze_QuestionPicker_QuestionList_CategoryFragment' };

export type Analyze_QuestionPicker_QuestionList_GroupFragment = { __typename?: 'polls_group', id: number, name: string, subGroups: Array<{ __typename?: 'polls_group', id: number }>, questions: Array<(
    { __typename?: 'polls_question', id: number }
    & { ' $fragmentRefs'?: { 'Analyze_QuestionPicker_QuestionList_QuestionFragment': Analyze_QuestionPicker_QuestionList_QuestionFragment } }
  )> } & { ' $fragmentName'?: 'Analyze_QuestionPicker_QuestionList_GroupFragment' };

export type Analyze_QuestionPicker_QuestionList_SubGroupQueryVariables = Exact<{
  lang: Scalars['String'];
  parentId: Scalars['Int'];
}>;


export type Analyze_QuestionPicker_QuestionList_SubGroupQuery = { __typename?: 'query_root', subGroups: Array<(
    { __typename?: 'polls_group', id: number }
    & { ' $fragmentRefs'?: { 'Analyze_QuestionPicker_QuestionList_GroupFragment': Analyze_QuestionPicker_QuestionList_GroupFragment } }
  )> };

export type Analyze_QuestionPicker_QuestionList_QuestionDetailsFragment = (
  { __typename?: 'polls_question', multiple_answers_allowed: boolean, answer_options_with_details: { __typename?: 'polls_templateanswerset', answers: Array<(
      { __typename?: 'polls_templateanswer', id: number }
      & { ' $fragmentRefs'?: { 'Analyze_QuestionPicker_QuestionList_AnswerFragment': Analyze_QuestionPicker_QuestionList_AnswerFragment } }
    )> } }
  & { ' $fragmentRefs'?: { 'Analyze_QuestionFragment': Analyze_QuestionFragment } }
) & { ' $fragmentName'?: 'Analyze_QuestionPicker_QuestionList_QuestionDetailsFragment' };

export type Analyze_QuestionPicker_QuestionListQueryVariables = Exact<{
  lang: Scalars['String'];
  pollId: Scalars['Int'];
}>;


export type Analyze_QuestionPicker_QuestionListQuery = { __typename?: 'query_root', poll?: { __typename?: 'polls_poll', categories: Array<(
      { __typename?: 'polls_category', id: number }
      & { ' $fragmentRefs'?: { 'Analyze_QuestionPicker_QuestionList_CategoryFragment': Analyze_QuestionPicker_QuestionList_CategoryFragment } }
    )> } | null };

export type Analyze_QuestionPicker_QuestionList_QuestionFragment = (
  { __typename?: 'polls_question', subQuestions: Array<{ __typename?: 'polls_question', id: number, parentAnswerId?: number | null }> }
  & { ' $fragmentRefs'?: { 'Analyze_QuestionPicker_QuestionList_QuestionDetailsFragment': Analyze_QuestionPicker_QuestionList_QuestionDetailsFragment } }
) & { ' $fragmentName'?: 'Analyze_QuestionPicker_QuestionList_QuestionFragment' };

export type Analyze_QuestionPicker_SubQuestionsQueryVariables = Exact<{
  lang: Scalars['String'];
  questionIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type Analyze_QuestionPicker_SubQuestionsQuery = { __typename?: 'query_root', subQuestions: Array<(
    { __typename?: 'polls_question', id: number }
    & { ' $fragmentRefs'?: { 'Analyze_QuestionPicker_QuestionList_QuestionFragment': Analyze_QuestionPicker_QuestionList_QuestionFragment } }
  )> };

export type Analyze_QuestionSearchQueryVariables = Exact<{
  lang: Scalars['String'];
  query: Scalars['String'];
}>;


export type Analyze_QuestionSearchQuery = { __typename?: 'query_root', question_search?: { __typename?: 'QuestionSearchResult', hits?: Array<{ __typename?: 'QuestionSearchHit', id: number, highlight: any, question?: (
        { __typename?: 'polls_question' }
        & { ' $fragmentRefs'?: { 'Analyze_QuestionFragment': Analyze_QuestionFragment } }
      ) | null }> | null } | null };

export type Analyze_Question_QuestionAnswerOptionFragment = { __typename?: 'polls_templateanswer', id: number, translated_name?: string | null, order: number, text_input_type?: any | null } & { ' $fragmentName'?: 'Analyze_Question_QuestionAnswerOptionFragment' };

export type Analyze_Question_QuestionAnswerOptionListFragment = { __typename?: 'polls_question', template_answer_set: { __typename?: 'polls_templateanswerset', answers: Array<(
      { __typename?: 'polls_templateanswer' }
      & { ' $fragmentRefs'?: { 'Analyze_Question_QuestionAnswerOptionFragment': Analyze_Question_QuestionAnswerOptionFragment } }
    )> } } & { ' $fragmentName'?: 'Analyze_Question_QuestionAnswerOptionListFragment' };

export type Analyze_Question_PollFragment = { __typename?: 'polls_question', poll: { __typename?: 'polls_poll', id: number, translated_name?: string | null } } & { ' $fragmentName'?: 'Analyze_Question_PollFragment' };

export type Analyze_Question_RelatedQuestionFragment = (
  { __typename?: 'polls_question', id: number, translated_name?: string | null }
  & { ' $fragmentRefs'?: { 'Analyze_Question_PollFragment': Analyze_Question_PollFragment;'Analyze_Question_QuestionAnswerOptionListFragment': Analyze_Question_QuestionAnswerOptionListFragment } }
) & { ' $fragmentName'?: 'Analyze_Question_RelatedQuestionFragment' };

export type Analyze_Question_ListOfRelatedQuestionsFragment = { __typename?: 'polls_question', related_question_ids_1: Array<{ __typename?: 'polls_questionrelation', second_question: (
      { __typename?: 'polls_question' }
      & { ' $fragmentRefs'?: { 'Analyze_Question_RelatedQuestionFragment': Analyze_Question_RelatedQuestionFragment } }
    ) }>, related_question_ids_2: Array<{ __typename?: 'polls_questionrelation', first_question: (
      { __typename?: 'polls_question' }
      & { ' $fragmentRefs'?: { 'Analyze_Question_RelatedQuestionFragment': Analyze_Question_RelatedQuestionFragment } }
    ) }> } & { ' $fragmentName'?: 'Analyze_Question_ListOfRelatedQuestionsFragment' };

export type Analyze_QuestionFragment = (
  { __typename?: 'polls_question', id: number, translated_name?: string | null, translated_description?: string | null }
  & { ' $fragmentRefs'?: { 'Analyze_Question_PollFragment': Analyze_Question_PollFragment;'Analyze_Question_QuestionAnswerOptionListFragment': Analyze_Question_QuestionAnswerOptionListFragment;'Analyze_Question_ListOfRelatedQuestionsFragment': Analyze_Question_ListOfRelatedQuestionsFragment } }
) & { ' $fragmentName'?: 'Analyze_QuestionFragment' };

export type Analyze_RegionSearchQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type Analyze_RegionSearchQuery = { __typename?: 'query_root', region_search?: { __typename?: 'RegionSearchResult', hits?: Array<{ __typename?: 'RegionSearchHit', id: number, name: string, description?: string | null, geometry?: any | null, highlight: any, tags?: Array<{ __typename?: 'Tag', id: number, name: string } | null> | null }> | null } | null };

export type Analyze_RegionFragment = { __typename?: 'gis_regions_gis_region', id: number, name?: string | null, geom?: any | null, tags: Array<{ __typename?: 'gis_regions_gis_region_tags', tag: { __typename?: 'gis_regions_gis_tag', id: number, name: string } }> } & { ' $fragmentName'?: 'Analyze_RegionFragment' };

export type Analyze_DeleteSavedQueryMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type Analyze_DeleteSavedQueryMutation = { __typename?: 'mutation_root', delete_analyze_user_query_by_pk?: { __typename?: 'analyze_user_query', name: string } | null };

export type Analyze_PublishSavedQueryMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type Analyze_PublishSavedQueryMutation = { __typename?: 'mutation_root', update_analyze_user_query_by_pk?: { __typename?: 'analyze_user_query', name: string } | null };

export type Analyze_SaveQueryMutationVariables = Exact<{
  userId: Scalars['Int'];
  name: Scalars['String'];
  payload: Scalars['jsonb'];
}>;


export type Analyze_SaveQueryMutation = { __typename?: 'mutation_root', insert_analyze_user_query_one?: { __typename?: 'analyze_user_query', id: number, name: string } | null };

export type Analyze_SavedQueryDataQueryVariables = Exact<{
  questionIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  entryIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  regionIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  lang: Scalars['String'];
}>;


export type Analyze_SavedQueryDataQuery = { __typename?: 'query_root', questions: Array<(
    { __typename?: 'polls_question' }
    & { ' $fragmentRefs'?: { 'Analyze_QuestionFragment': Analyze_QuestionFragment } }
  )>, entries: Array<(
    { __typename?: 'polls_entity' }
    & { ' $fragmentRefs'?: { 'Analyze_EntryFragment': Analyze_EntryFragment } }
  )>, regions: Array<(
    { __typename?: 'gis_regions_gis_region' }
    & { ' $fragmentRefs'?: { 'Analyze_RegionFragment': Analyze_RegionFragment } }
  )> };

export type Analyze_SavedQueriesQueryVariables = Exact<{ [key: string]: never; }>;


export type Analyze_SavedQueriesQuery = { __typename?: 'query_root', analyze_user_query: Array<(
    { __typename?: 'analyze_user_query' }
    & { ' $fragmentRefs'?: { 'Analyze_SavedQueryFragment': Analyze_SavedQueryFragment } }
  )> };

export type Analyze_SavedQueryQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type Analyze_SavedQueryQuery = { __typename?: 'query_root', analyze_user_query_by_pk?: (
    { __typename?: 'analyze_user_query' }
    & { ' $fragmentRefs'?: { 'Analyze_SavedQueryFragment': Analyze_SavedQueryFragment } }
  ) | null };

export type Analyze_SavedQueryFragment = { __typename?: 'analyze_user_query', id: number, name: string, created_at?: any | null, target_timestamp: any, published?: boolean | null, user_id: number, payload: any } & { ' $fragmentName'?: 'Analyze_SavedQueryFragment' };

export type Analyze_UpdateSavedQueryMutationVariables = Exact<{
  id: Scalars['Int'];
  name: Scalars['String'];
  payload: Scalars['jsonb'];
}>;


export type Analyze_UpdateSavedQueryMutation = { __typename?: 'mutation_root', update_analyze_user_query_by_pk?: { __typename?: 'analyze_user_query', name: string } | null };

export type Analyze_ScatterPlot_SingleVariableChartDataQueryVariables = Exact<{
  lang: Scalars['String'];
  variableBoolExp: Polls_Answer_Bool_Exp;
}>;


export type Analyze_ScatterPlot_SingleVariableChartDataQuery = { __typename?: 'query_root', polls_answer: Array<(
    { __typename?: 'polls_answer' }
    & { ' $fragmentRefs'?: { 'Analyze_AnswerFragment': Analyze_AnswerFragment } }
  )> };

export type Analyze_ScatterPlot_TwoVariablesChartDataQueryVariables = Exact<{
  lang: Scalars['String'];
  dependentVariableBoolExp: Polls_Answer_Bool_Exp;
  independentVariableBoolExp: Polls_Answer_Bool_Exp;
}>;


export type Analyze_ScatterPlot_TwoVariablesChartDataQuery = { __typename?: 'query_root', dependentVariable: Array<(
    { __typename?: 'polls_answer' }
    & { ' $fragmentRefs'?: { 'Analyze_AnswerFragment': Analyze_AnswerFragment } }
  )>, independentVariable: Array<(
    { __typename?: 'polls_answer' }
    & { ' $fragmentRefs'?: { 'Analyze_AnswerFragment': Analyze_AnswerFragment } }
  )> };

export type Analyze_Timeline_AnswersQueryVariables = Exact<{
  lang: Scalars['String'];
  variableBoolExp: Polls_Answer_Bool_Exp;
}>;


export type Analyze_Timeline_AnswersQuery = { __typename?: 'query_root', polls_answer: Array<(
    { __typename?: 'polls_answer' }
    & { ' $fragmentRefs'?: { 'Analyze_AnswerFragment': Analyze_AnswerFragment } }
  )> };

export type PollIdQueryQueryVariables = Exact<{
  entryId: Scalars['Int'];
}>;


export type PollIdQueryQuery = { __typename?: 'query_root', entry?: { __typename?: 'polls_entity', next?: { __typename?: 'polls_entity', id: number } | null, poll: { __typename?: 'polls_poll', id: number }, previous?: { __typename?: 'polls_entity', id: number } | null } | null };

export type UserLastLoginQueryQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type UserLastLoginQueryQuery = { __typename?: 'query_root', user?: { __typename?: 'auth_user', last_login?: any | null } | null };

export type EntryFilter_PollsQueryVariables = Exact<{ [key: string]: never; }>;


export type EntryFilter_PollsQuery = { __typename?: 'query_root', polls_poll: Array<{ __typename?: 'polls_poll', id: number, name: string, is_external: boolean }> };

export type EntryAlternativeNamesFragment = { __typename?: 'polls_entity', id: number, alt_names: Array<{ __typename?: 'polls_entity_alt_names', name: (
      { __typename?: 'polls_entityname', id: number }
      & { ' $fragmentRefs'?: { 'EntryNameLinkFragment': EntryNameLinkFragment } }
    ) }> } & { ' $fragmentName'?: 'EntryAlternativeNamesFragment' };

export type EntryContributorsFragment = { __typename?: 'polls_entity', entry_source: number, user: (
    { __typename?: 'auth_user', id: number }
    & { ' $fragmentRefs'?: { 'ExpertLinkFragment': ExpertLinkFragment } }
  ), progress: Array<{ __typename?: 'polls_pollprogress', expert: { __typename?: 'accounts_expert', user: (
        { __typename?: 'auth_user', id: number }
        & { ' $fragmentRefs'?: { 'ExpertLinkFragment': ExpertLinkFragment } }
      ) } }> } & { ' $fragmentName'?: 'EntryContributorsFragment' };

export type EntryDataSourceFragment = { __typename?: 'polls_entity', external_url?: string | null, data_source: { __typename?: 'polls_datasource', is_external: boolean, name: string, icon_small?: string | null, tooltip?: string | null } } & { ' $fragmentName'?: 'EntryDataSourceFragment' };

export type EntryNameLinkFragment = { __typename?: 'polls_entityname', name: string } & { ' $fragmentName'?: 'EntryNameLinkFragment' };

export type EntryPeriodFragment = { __typename?: 'polls_entity', year_from: number, year_to: number } & { ' $fragmentName'?: 'EntryPeriodFragment' };

export type EntryPollTypeFragment = { __typename?: 'polls_entity', poll: { __typename?: 'polls_poll', type: string } } & { ' $fragmentName'?: 'EntryPollTypeFragment' };

export type EntryPublicationDateFragment = { __typename?: 'polls_entity', date_modified: any } & { ' $fragmentName'?: 'EntryPublicationDateFragment' };

export type EntryRegionTagsFragment = { __typename?: 'polls_entity', region: { __typename?: 'gis_regions_gis_region', tags: Array<{ __typename?: 'gis_regions_gis_region_tags', tag: { __typename?: 'gis_regions_gis_tag', id: number, name: string } }> } } & { ' $fragmentName'?: 'EntryRegionTagsFragment' };

export type EntrySourceFragment = (
  { __typename?: 'polls_entity', entry_source: number, secondary_source?: { __typename?: 'polls_secondarysource', title: string } | null, expert_source?: { __typename?: 'accounts_expert', user: (
      { __typename?: 'auth_user' }
      & { ' $fragmentRefs'?: { 'ExpertLinkFragment': ExpertLinkFragment } }
    ) } | null, supervisor?: { __typename?: 'accounts_expert', user: (
      { __typename?: 'auth_user' }
      & { ' $fragmentRefs'?: { 'ExpertLinkFragment': ExpertLinkFragment } }
    ) } | null }
  & { ' $fragmentRefs'?: { 'EntryContributorsFragment': EntryContributorsFragment } }
) & { ' $fragmentName'?: 'EntrySourceFragment' };

export type EntryTagsFragment = { __typename?: 'polls_entity', tags: Array<{ __typename?: 'polls_entity_tags', tag: { __typename?: 'polls_entitytag', id: number, name: string, level: number } }> } & { ' $fragmentName'?: 'EntryTagsFragment' };

export type ExpertLinkFragment = { __typename?: 'auth_user', first_name: string, last_name: string, username: string } & { ' $fragmentName'?: 'ExpertLinkFragment' };

export type EntriesByAuthor_AuthorEntriesFragment = { __typename?: 'auth_user', entries: Array<(
    { __typename?: 'polls_entity', id: number, name: (
      { __typename?: 'polls_entityname' }
      & { ' $fragmentRefs'?: { 'EntryNameLinkFragment': EntryNameLinkFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'EntrySourceFragment': EntrySourceFragment;'EntryDataSourceFragment': EntryDataSourceFragment } }
  )>, expert?: { __typename?: 'accounts_expert', entries_sourced: Array<(
      { __typename?: 'polls_entity', id: number, name: (
        { __typename?: 'polls_entityname' }
        & { ' $fragmentRefs'?: { 'EntryNameLinkFragment': EntryNameLinkFragment } }
      ) }
      & { ' $fragmentRefs'?: { 'EntrySourceFragment': EntrySourceFragment;'EntryDataSourceFragment': EntryDataSourceFragment } }
    )> } | null } & { ' $fragmentName'?: 'EntriesByAuthor_AuthorEntriesFragment' };

export type EntriesByAuthors_AuthorFragment = (
  { __typename?: 'auth_user', profile?: { __typename?: 'accounts_profile', institution?: string | null } | null }
  & { ' $fragmentRefs'?: { 'ExpertLinkFragment': ExpertLinkFragment;'EntriesByAuthor_AuthorEntriesFragment': EntriesByAuthor_AuthorEntriesFragment } }
) & { ' $fragmentName'?: 'EntriesByAuthors_AuthorFragment' };

export type Browse_ExpertsWithEntriesQueryVariables = Exact<{ [key: string]: never; }>;


export type Browse_ExpertsWithEntriesQuery = { __typename?: 'query_root', accounts_expert: Array<{ __typename?: 'accounts_expert', entries_sourced_aggregate: { __typename?: 'polls_entity_aggregate', aggregate?: { __typename?: 'polls_entity_aggregate_fields', count: number } | null }, user: (
      { __typename?: 'auth_user', username: string, last_name: string, entries_aggregate: { __typename?: 'polls_entity_aggregate', aggregate?: { __typename?: 'polls_entity_aggregate_fields', count: number } | null } }
      & { ' $fragmentRefs'?: { 'EntriesByAuthors_AuthorFragment': EntriesByAuthors_AuthorFragment } }
    ) }> };

export type ListEntriesByPublicationDateFragment = { __typename?: 'query_root', entries_by_publication_date: Array<(
    { __typename?: 'polls_entity', id: number, date_modified: any, name: (
      { __typename?: 'polls_entityname' }
      & { ' $fragmentRefs'?: { 'EntryNameLinkFragment': EntryNameLinkFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'EntryPollTypeFragment': EntryPollTypeFragment;'EntryAlternativeNamesFragment': EntryAlternativeNamesFragment;'EntryContributorsFragment': EntryContributorsFragment;'EntryPublicationDateFragment': EntryPublicationDateFragment;'EntrySourceFragment': EntrySourceFragment;'EntryDataSourceFragment': EntryDataSourceFragment;'EntryPeriodFragment': EntryPeriodFragment;'EntryRegionTagsFragment': EntryRegionTagsFragment;'EntryTagsFragment': EntryTagsFragment } }
  )> } & { ' $fragmentName'?: 'ListEntriesByPublicationDateFragment' };

export type EntryPublicationDatesFragment = { __typename?: 'query_root', publication_dates: Array<{ __typename?: 'polls_entity', date_modified: any }> } & { ' $fragmentName'?: 'EntryPublicationDatesFragment' };

export type Browse_EntriesByPublicationDateQueryVariables = Exact<{ [key: string]: never; }>;


export type Browse_EntriesByPublicationDateQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'EntryPublicationDatesFragment': EntryPublicationDatesFragment;'ListEntriesByPublicationDateFragment': ListEntriesByPublicationDateFragment } }
);

export type Browse_EntriesByRegionQueryVariables = Exact<{
  orderBy: Polls_Entity_Order_By;
  filter: Polls_Entity_Bool_Exp;
}>;


export type Browse_EntriesByRegionQuery = { __typename?: 'query_root', polls_entity: Array<(
    { __typename?: 'polls_entity', id: number, region: { __typename?: 'gis_regions_gis_region', tags: Array<{ __typename?: 'gis_regions_gis_region_tags', tag: { __typename?: 'gis_regions_gis_tag', id: number, name: string, parent_tag_id?: number | null, parent?: { __typename?: 'gis_regions_gis_tag', id: number, name: string } | null } }> } }
    & { ' $fragmentRefs'?: { 'EntriesByRegion_RegionEntryFragment': EntriesByRegion_RegionEntryFragment } }
  )> };

export type EntriesByRegion_RegionEntryFragment = (
  { __typename?: 'polls_entity', id: number, name: (
    { __typename?: 'polls_entityname' }
    & { ' $fragmentRefs'?: { 'EntryNameLinkFragment': EntryNameLinkFragment } }
  ) }
  & { ' $fragmentRefs'?: { 'EntryPollTypeFragment': EntryPollTypeFragment;'EntryAlternativeNamesFragment': EntryAlternativeNamesFragment;'EntryContributorsFragment': EntryContributorsFragment;'EntrySourceFragment': EntrySourceFragment;'EntryDataSourceFragment': EntryDataSourceFragment;'EntryPeriodFragment': EntryPeriodFragment;'EntryTagsFragment': EntryTagsFragment } }
) & { ' $fragmentName'?: 'EntriesByRegion_RegionEntryFragment' };

export type Browse_EntriesByTagsGroupQueryVariables = Exact<{
  groupId: Scalars['Int'];
  orderBy: Polls_Entity_Order_By;
  filter: Polls_Entity_Bool_Exp;
}>;


export type Browse_EntriesByTagsGroupQuery = (
  { __typename?: 'query_root', polls_entity: Array<(
    { __typename?: 'polls_entity', id: number, tags: Array<{ __typename?: 'polls_entity_tags', tag: { __typename?: 'polls_entitytag', id: number, name: string, level: number } }>, name: { __typename?: 'polls_entityname', name: string } }
    & { ' $fragmentRefs'?: { 'EntriesByTagsGroup_TagEntryFragment': EntriesByTagsGroup_TagEntryFragment } }
  )> }
  & { ' $fragmentRefs'?: { 'EntriesByTagsGroup_TagsFragment': EntriesByTagsGroup_TagsFragment } }
);

export type EntriesByTagsGroup_TagEntryFragment = (
  { __typename?: 'polls_entity', id: number, name: (
    { __typename?: 'polls_entityname' }
    & { ' $fragmentRefs'?: { 'EntryNameLinkFragment': EntryNameLinkFragment } }
  ) }
  & { ' $fragmentRefs'?: { 'EntryPollTypeFragment': EntryPollTypeFragment;'EntryAlternativeNamesFragment': EntryAlternativeNamesFragment;'EntryContributorsFragment': EntryContributorsFragment;'EntrySourceFragment': EntrySourceFragment;'EntryDataSourceFragment': EntryDataSourceFragment;'EntryPeriodFragment': EntryPeriodFragment;'EntryRegionTagsFragment': EntryRegionTagsFragment } }
) & { ' $fragmentName'?: 'EntriesByTagsGroup_TagEntryFragment' };

export type EntriesByTagsGroup_TagsFragment = { __typename?: 'query_root', tags: Array<{ __typename?: 'polls_entitytag', id: number, name: string }> } & { ' $fragmentName'?: 'EntriesByTagsGroup_TagsFragment' };

export type EntrySearch_Entry_AlternativeNamesFragment = { __typename?: 'Entry', entryId: string, alternative_names?: Array<{ __typename?: 'AlternativeName', id: number, name?: string | null } | null> | null } & { ' $fragmentName'?: 'EntrySearch_Entry_AlternativeNamesFragment' };

export type EntrySearch_Entry_ContributorsFragment = { __typename?: 'Entry', entry_source?: number | null, contributors?: Array<(
    { __typename?: 'User', id: string }
    & { ' $fragmentRefs'?: { 'EntrySearch_Entry_ExpertLinkFragment': EntrySearch_Entry_ExpertLinkFragment } }
  ) | null> | null } & { ' $fragmentName'?: 'EntrySearch_Entry_ContributorsFragment' };

export type EntrySearch_Entry_DataSourceFragment = { __typename?: 'Entry', external_url?: string | null, data_source?: { __typename?: 'DataSource', is_external?: boolean | null, name: string, icon_small?: string | null, tooltip?: string | null } | null } & { ' $fragmentName'?: 'EntrySearch_Entry_DataSourceFragment' };

export type EntrySearch_Entry_DescriptionFragment = { __typename?: 'Entry', description?: string | null } & { ' $fragmentName'?: 'EntrySearch_Entry_DescriptionFragment' };

export type EntrySearch_Entry_PeriodFragment = { __typename?: 'Entry', year_from?: number | null, year_to?: number | null } & { ' $fragmentName'?: 'EntrySearch_Entry_PeriodFragment' };

export type EntrySearch_Entry_PollTypeFragment = { __typename?: 'Entry', poll_type: string } & { ' $fragmentName'?: 'EntrySearch_Entry_PollTypeFragment' };

export type EntrySearch_Entry_RegionFragment = { __typename?: 'Entry', region?: { __typename?: 'Region', geometry?: { __typename?: 'GeoJSON', type: GeoJsonGeometryType, coordinates: any } | null } | null } & { ' $fragmentName'?: 'EntrySearch_Entry_RegionFragment' };

export type EntrySearch_Entry_SourceFragment = { __typename?: 'Entry', entry_source?: number | null, secondary_source?: string | null, expert_source?: (
    { __typename?: 'User' }
    & { ' $fragmentRefs'?: { 'EntrySearch_Entry_ExpertLinkFragment': EntrySearch_Entry_ExpertLinkFragment } }
  ) | null, supervised_by?: (
    { __typename?: 'User' }
    & { ' $fragmentRefs'?: { 'EntrySearch_Entry_ExpertLinkFragment': EntrySearch_Entry_ExpertLinkFragment } }
  ) | null } & { ' $fragmentName'?: 'EntrySearch_Entry_SourceFragment' };

export type EntrySearch_Entry_TagsFragment = { __typename?: 'Entry', tags?: Array<{ __typename?: 'Tag', id: number, name: string } | null> | null } & { ' $fragmentName'?: 'EntrySearch_Entry_TagsFragment' };

export type EntrySearch_EntryFragment = (
  { __typename: 'Entry', name?: string | null, entryId: string }
  & { ' $fragmentRefs'?: { 'EntrySearch_Entry_PollTypeFragment': EntrySearch_Entry_PollTypeFragment;'EntrySearch_Entry_AlternativeNamesFragment': EntrySearch_Entry_AlternativeNamesFragment;'EntrySearch_Entry_ContributorsFragment': EntrySearch_Entry_ContributorsFragment;'EntrySearch_Entry_DataSourceFragment': EntrySearch_Entry_DataSourceFragment;'EntrySearch_Entry_DescriptionFragment': EntrySearch_Entry_DescriptionFragment;'EntrySearch_Entry_PeriodFragment': EntrySearch_Entry_PeriodFragment;'EntrySearch_Entry_RegionFragment': EntrySearch_Entry_RegionFragment;'EntrySearch_Entry_SourceFragment': EntrySearch_Entry_SourceFragment;'EntrySearch_Entry_TagsFragment': EntrySearch_Entry_TagsFragment } }
) & { ' $fragmentName'?: 'EntrySearch_EntryFragment' };

export type EntrySearch_Entry_ExpertLinkFragment = { __typename?: 'User', username: string, name?: string | null } & { ' $fragmentName'?: 'EntrySearch_Entry_ExpertLinkFragment' };

export type EntrySearchQueryVariables = Exact<{
  query: Scalars['String'];
  size: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type EntrySearchQuery = { __typename?: 'query_root', entry_search_connection?: { __typename?: 'EntryConnection', count: number, edges?: Array<{ __typename?: 'EntryEdge', node?: (
        { __typename?: 'Entry', id: string }
        & { ' $fragmentRefs'?: { 'EntrySearch_EntryFragment': EntrySearch_EntryFragment } }
      ) | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type EntryTagGroupQueryVariables = Exact<{ [key: string]: never; }>;


export type EntryTagGroupQuery = { __typename?: 'query_root', polls_entrytaggroup: Array<{ __typename?: 'polls_entrytaggroup', id: number, name: string }> };

export type CommentedEntriesQueryVariables = Exact<{
  expertId: Scalars['Int'];
}>;


export type CommentedEntriesQuery = { __typename?: 'query_root', polls_entity: Array<{ __typename?: 'polls_entity', id: number, date_modified: any, name: { __typename?: 'polls_entityname', name: string }, affirmations: { __typename?: 'polls_baseanswerset_aggregate', aggregate?: { __typename?: 'polls_baseanswerset_aggregate_fields', count: number } | null }, challenges: { __typename?: 'polls_baseanswerset_aggregate', aggregate?: { __typename?: 'polls_baseanswerset_aggregate_fields', count: number } | null }, neutral: { __typename?: 'polls_baseanswerset_aggregate', aggregate?: { __typename?: 'polls_baseanswerset_aggregate_fields', count: number } | null } }> };

export type EntriesProgressQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type EntriesProgressQuery = { __typename?: 'query_root', polls_entity: Array<(
    { __typename?: 'polls_entity', id: number, poll: { __typename?: 'polls_poll', next?: { __typename?: 'polls_poll', id: number } | null } }
    & { ' $fragmentRefs'?: { 'EntryProgressFragment': EntryProgressFragment } }
  )> };

export type ProfileInterestsQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type ProfileInterestsQuery = { __typename?: 'query_root', user?: { __typename?: 'auth_user', profile?: { __typename?: 'accounts_profile', interests?: any | null } | null } | null };

export type SuggestedPollsQueryVariables = Exact<{
  tagsQuery: Polls_Entity_Tags_Bool_Exp;
}>;


export type SuggestedPollsQuery = { __typename?: 'query_root', polls_entity: Array<{ __typename?: 'polls_entity', id: number, date_modified: any, created_by_id: number, name: { __typename?: 'polls_entityname', name: string }, progress: Array<{ __typename?: 'polls_pollprogress', expert: { __typename?: 'accounts_expert', user: { __typename?: 'auth_user', id: number, first_name: string, last_name: string, username: string } } }> }> };

export type AssignedEditorQueryVariables = Exact<{
  expertId: Scalars['Int'];
}>;


export type AssignedEditorQuery = { __typename?: 'query_root', accounts_expert_by_pk?: { __typename?: 'accounts_expert', regionaleditor?: { __typename?: 'accounts_regionaleditor', editor_email?: string | null, user: { __typename?: 'auth_user', first_name: string, last_name: string } } | null, managingeditor?: { __typename?: 'accounts_managingeditor', editor_email?: string | null, user: { __typename?: 'auth_user', first_name: string, last_name: string } } | null } | null };

export type EditorConsole_LogInAsEditor_EditorUserFragment = { __typename?: 'auth_user', id: number, first_name: string, last_name: string, username: string } & { ' $fragmentName'?: 'EditorConsole_LogInAsEditor_EditorUserFragment' };

export type EditorConsole_LogInAsEditor_EditorsQueryVariables = Exact<{ [key: string]: never; }>;


export type EditorConsole_LogInAsEditor_EditorsQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'EditorConsole_LogInAsEditor_ManagingEditorListFragment': EditorConsole_LogInAsEditor_ManagingEditorListFragment;'EditorConsole_LogInAsEditor_RegionalEditorListFragment': EditorConsole_LogInAsEditor_RegionalEditorListFragment } }
);

export type EditorConsole_LogInAsEditor_ManagingEditorListFragment = { __typename?: 'query_root', managing_editors: Array<(
    { __typename?: 'accounts_managingeditor', id: number }
    & { ' $fragmentRefs'?: { 'EditorConsole_LogInAsEditor_ManagingEditorFragment': EditorConsole_LogInAsEditor_ManagingEditorFragment } }
  )> } & { ' $fragmentName'?: 'EditorConsole_LogInAsEditor_ManagingEditorListFragment' };

export type EditorConsole_LogInAsEditor_ManagingEditorFragment = { __typename?: 'accounts_managingeditor', user: (
    { __typename?: 'auth_user' }
    & { ' $fragmentRefs'?: { 'EditorConsole_LogInAsEditor_EditorUserFragment': EditorConsole_LogInAsEditor_EditorUserFragment } }
  ) } & { ' $fragmentName'?: 'EditorConsole_LogInAsEditor_ManagingEditorFragment' };

export type EditorConsole_LogInAsEditor_RegionalEditorListFragment = { __typename?: 'query_root', regional_editors: Array<(
    { __typename?: 'accounts_regionaleditor', id: number }
    & { ' $fragmentRefs'?: { 'EditorConsole_LogInAsEditor_RegionalEditorFragment': EditorConsole_LogInAsEditor_RegionalEditorFragment } }
  )> } & { ' $fragmentName'?: 'EditorConsole_LogInAsEditor_RegionalEditorListFragment' };

export type EditorConsole_LogInAsEditor_RegionalEditorFragment = { __typename?: 'accounts_regionaleditor', title?: string | null, user: (
    { __typename?: 'auth_user' }
    & { ' $fragmentRefs'?: { 'EditorConsole_LogInAsEditor_EditorUserFragment': EditorConsole_LogInAsEditor_EditorUserFragment } }
  ) } & { ' $fragmentName'?: 'EditorConsole_LogInAsEditor_RegionalEditorFragment' };

export type EntryForUpgradeQueryQueryVariables = Exact<{
  entryId: Scalars['Int'];
}>;


export type EntryForUpgradeQueryQuery = { __typename?: 'query_root', polls_entity_by_pk?: { __typename?: 'polls_entity', id: number, name: { __typename?: 'polls_entityname', name: string }, poll: { __typename?: 'polls_poll', next?: { __typename?: 'polls_poll', id: number } | null } } | null };

export type PollDiff_NewQuestionFragment = { __typename?: 'PollDiffQuestionWithPath', id: number, name: string, description?: string | null, path?: Array<{ __typename?: 'PollDiffQuestionPathSegment', type: string, id: number, name: string }> | null } & { ' $fragmentName'?: 'PollDiff_NewQuestionFragment' };

export type PollDiffInfoFragment = { __typename?: 'PollDiff', poll: { __typename?: 'PollDiffPoll', name: string }, prev_poll: { __typename?: 'PollDiffPoll', name: string }, new_questions?: Array<{ __typename?: 'PollDiffQuestionWithPath', id: number }> | null, updated_questions?: Array<{ __typename?: 'PollDiffUpdatedQuestion', id: number }> | null } & { ' $fragmentName'?: 'PollDiffInfoFragment' };

export type PollDiffQueryQueryVariables = Exact<{
  pollId: Scalars['Int'];
}>;


export type PollDiffQueryQuery = { __typename?: 'query_root', poll_diff?: (
    { __typename?: 'PollDiff', new_questions?: Array<(
      { __typename?: 'PollDiffQuestionWithPath', id: number }
      & { ' $fragmentRefs'?: { 'PollDiff_NewQuestionFragment': PollDiff_NewQuestionFragment } }
    )> | null, updated_questions?: Array<(
      { __typename?: 'PollDiffUpdatedQuestion', id: number }
      & { ' $fragmentRefs'?: { 'PollDiff_UpdatedQuestionFragment': PollDiff_UpdatedQuestionFragment } }
    )> | null }
    & { ' $fragmentRefs'?: { 'PollDiffInfoFragment': PollDiffInfoFragment } }
  ) | null };

export type PollDiff_UpdatedQuestionFragment = { __typename?: 'PollDiffUpdatedQuestion', id: number, name: string, description?: string | null, previous: { __typename?: 'PollDiffPlainQuestion', name: string, description?: string | null }, path?: Array<{ __typename?: 'PollDiffQuestionPathSegment', type: string, id: number, name: string }> | null } & { ' $fragmentName'?: 'PollDiff_UpdatedQuestionFragment' };

export type UpgradeEntryPollMutationVariables = Exact<{
  entryId: Scalars['Int'];
}>;


export type UpgradeEntryPollMutation = { __typename?: 'mutation_root', upgrade_entry_poll: { __typename?: 'UpgradeEntryPollSuccessResponse', next_entry_id: number } };

export type OverviewOfPollsQueryVariables = Exact<{ [key: string]: never; }>;


export type OverviewOfPollsQuery = { __typename?: 'query_root', polls_entrytaggroup: Array<{ __typename?: 'polls_entrytaggroup', id: number, name: string }>, polls_poll: Array<{ __typename?: 'polls_poll', id: number, type: string, name: string, description?: string | null, is_external: boolean, date_modified: any, entries_aggregate: { __typename?: 'polls_entity_aggregate', aggregate?: { __typename?: 'polls_entity_aggregate_fields', count: number } | null }, required_entry_tag_groups: Array<{ __typename?: 'polls_poll_required_entry_tag_groups', entrytaggroup_id: number }>, optional_entry_tag_groups: Array<{ __typename?: 'polls_poll_optional_entry_tag_groups', entrytaggroup_id: number }> }> };

export type LandingPollCategoryFragment = { __typename?: 'polls_category', id: number, name: string, groups: Array<(
    { __typename?: 'polls_group', groups: Array<(
      { __typename?: 'polls_group' }
      & { ' $fragmentRefs'?: { 'LandingPollGroupFragment': LandingPollGroupFragment } }
    )> }
    & { ' $fragmentRefs'?: { 'LandingPollGroupFragment': LandingPollGroupFragment } }
  )>, questions: Array<(
    { __typename?: 'polls_question' }
    & { ' $fragmentRefs'?: { 'LandingPollQuestionFragment': LandingPollQuestionFragment } }
  )> } & { ' $fragmentName'?: 'LandingPollCategoryFragment' };

export type LandingPollGroupFragment = { __typename?: 'polls_group', id: number, name: string, questions: Array<(
    { __typename?: 'polls_question' }
    & { ' $fragmentRefs'?: { 'LandingPollQuestionFragment': LandingPollQuestionFragment } }
  )> } & { ' $fragmentName'?: 'LandingPollGroupFragment' };

export type LandingPollQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LandingPollQuery = { __typename?: 'query_root', polls_poll_by_pk?: { __typename?: 'polls_poll', name: string, date_modified: any, entries_aggregate: { __typename?: 'polls_entity_aggregate', aggregate?: { __typename?: 'polls_entity_aggregate_fields', count: number } | null }, required_entry_tag_groups: Array<{ __typename?: 'polls_poll_required_entry_tag_groups', entrytaggroup_id: number }>, optional_entry_tag_groups: Array<{ __typename?: 'polls_poll_optional_entry_tag_groups', entrytaggroup_id: number }>, categories: Array<(
      { __typename?: 'polls_category' }
      & { ' $fragmentRefs'?: { 'LandingPollCategoryFragment': LandingPollCategoryFragment } }
    )> } | null };

export type LandingPollQuestionDetailsFragment = { __typename?: 'polls_question', id: number, name: string, multiple_answers_allowed: boolean, template_answer_set: { __typename?: 'polls_templateanswerset', answers: Array<(
      { __typename?: 'polls_templateanswer', id: number, name: string }
      & { ' $fragmentRefs'?: { 'AnswerInputFragment': AnswerInputFragment } }
    )> } } & { ' $fragmentName'?: 'LandingPollQuestionDetailsFragment' };

export type LandingPollQuestionFragment = (
  { __typename?: 'polls_question', sub_questions: Array<(
    { __typename?: 'polls_question', parent_template_answer_id?: number | null, sub_questions: Array<(
      { __typename?: 'polls_question', parent_template_answer_id?: number | null }
      & { ' $fragmentRefs'?: { 'LandingPollQuestionDetailsFragment': LandingPollQuestionDetailsFragment } }
    )> }
    & { ' $fragmentRefs'?: { 'LandingPollQuestionDetailsFragment': LandingPollQuestionDetailsFragment } }
  )> }
  & { ' $fragmentRefs'?: { 'LandingPollQuestionDetailsFragment': LandingPollQuestionDetailsFragment } }
) & { ' $fragmentName'?: 'LandingPollQuestionFragment' };

export type EntryTagGroupsWithEntryTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type EntryTagGroupsWithEntryTagsQuery = { __typename?: 'query_root', polls_entrytaggroup: Array<{ __typename?: 'polls_entrytaggroup', id: number, name: string, tags: Array<{ __typename?: 'polls_entitytag', name: string, level: number, parent_tag_id?: number | null, id: number }> }> };

export type MediaLibrary_Entities_Attachment_AnswerAttachmentFragment = { __typename?: 'polls_answer_set_attachment', id: number, title?: string | null, description?: string | null, date_created: any, file: (
    { __typename?: 'user_file', id: any, user: (
      { __typename?: 'auth_user' }
      & { ' $fragmentRefs'?: { 'MediaLibrary_Entities_Attachment_AttachmentOwnerFragment': MediaLibrary_Entities_Attachment_AttachmentOwnerFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'MediaLibrary_Shared_MediaObjectFragment': MediaLibrary_Shared_MediaObjectFragment } }
  ) } & { ' $fragmentName'?: 'MediaLibrary_Entities_Attachment_AnswerAttachmentFragment' };

export type MediaLibrary_Entities_Attachment_LiveAnswerAttachmentsSubscriptionVariables = Exact<{
  answerSetId: Scalars['Int'];
}>;


export type MediaLibrary_Entities_Attachment_LiveAnswerAttachmentsSubscription = { __typename?: 'subscription_root', polls_answer_set_attachment: Array<(
    { __typename?: 'polls_answer_set_attachment' }
    & { ' $fragmentRefs'?: { 'MediaLibrary_Entities_Attachment_AnswerAttachmentFragment': MediaLibrary_Entities_Attachment_AnswerAttachmentFragment } }
  )> };

export type MediaLibrary_Entities_Attachment_AnswerAttachmentsQueryVariables = Exact<{
  answerSetId: Scalars['Int'];
}>;


export type MediaLibrary_Entities_Attachment_AnswerAttachmentsQuery = { __typename?: 'query_root', polls_answer_set_attachment: Array<(
    { __typename?: 'polls_answer_set_attachment' }
    & { ' $fragmentRefs'?: { 'MediaLibrary_Entities_Attachment_AnswerAttachmentFragment': MediaLibrary_Entities_Attachment_AnswerAttachmentFragment } }
  )> };

export type MediaLibrary_Widgets_AttachmentManager_MediaSubscriptionVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type MediaLibrary_Widgets_AttachmentManager_MediaSubscription = { __typename?: 'subscription_root', user_file: Array<(
    { __typename?: 'user_file', id: any }
    & { ' $fragmentRefs'?: { 'MediaLibrary_Shared_MediaObjectFragment': MediaLibrary_Shared_MediaObjectFragment } }
  )> };

export type MediaLibrary_Entities_Attachment_AttachmentOwnerFragment = { __typename?: 'auth_user', id: number, first_name: string, last_name: string, username: string } & { ' $fragmentName'?: 'MediaLibrary_Entities_Attachment_AttachmentOwnerFragment' };

export type MediaLibrary_Entities_Attachment_GeneralEntryAttachmentFragment = { __typename?: 'polls_entry_attachment', id: number, title?: string | null, description?: string | null, date_created: any, file: (
    { __typename?: 'user_file', id: any, user: (
      { __typename?: 'auth_user' }
      & { ' $fragmentRefs'?: { 'MediaLibrary_Entities_Attachment_AttachmentOwnerFragment': MediaLibrary_Entities_Attachment_AttachmentOwnerFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'MediaLibrary_Shared_MediaObjectFragment': MediaLibrary_Shared_MediaObjectFragment } }
  ) } & { ' $fragmentName'?: 'MediaLibrary_Entities_Attachment_GeneralEntryAttachmentFragment' };

export type MediaLibrary_Entities_Attachment_LiveEntryAttachmentsSubscriptionVariables = Exact<{
  entryId: Scalars['Int'];
  userFilter: Auth_User_Bool_Exp;
}>;


export type MediaLibrary_Entities_Attachment_LiveEntryAttachmentsSubscription = { __typename?: 'subscription_root', polls_entry_attachment: Array<(
    { __typename?: 'polls_entry_attachment', id: number }
    & { ' $fragmentRefs'?: { 'MediaLibrary_Entities_Attachment_GeneralEntryAttachmentFragment': MediaLibrary_Entities_Attachment_GeneralEntryAttachmentFragment } }
  )> };

export type MediaLibrary_Entities_Attachment_GeneralEntryAttachmentsQueryVariables = Exact<{
  entryId: Scalars['Int'];
  userFilter: Auth_User_Bool_Exp;
}>;


export type MediaLibrary_Entities_Attachment_GeneralEntryAttachmentsQuery = { __typename?: 'query_root', polls_entry_attachment: Array<(
    { __typename?: 'polls_entry_attachment', id: number }
    & { ' $fragmentRefs'?: { 'MediaLibrary_Entities_Attachment_GeneralEntryAttachmentFragment': MediaLibrary_Entities_Attachment_GeneralEntryAttachmentFragment } }
  )> };

export type MediaLibrary_Media_DeleteMediaMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type MediaLibrary_Media_DeleteMediaMutation = { __typename?: 'mutation_root', delete_user_file_by_pk?: { __typename?: 'user_file', name: string } | null };

export type MediaLibrary_Media_UpdateMediaMutationVariables = Exact<{
  id: Scalars['uuid'];
  title?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
}>;


export type MediaLibrary_Media_UpdateMediaMutation = { __typename?: 'mutation_root', update_user_file_by_pk?: { __typename?: 'user_file', title?: string | null } | null };

export type MediaLibrary_Features_AttachMedia_AttachMediaToAnswerMutationVariables = Exact<{
  files: Array<Polls_Answer_Set_Attachment_Insert_Input> | Polls_Answer_Set_Attachment_Insert_Input;
}>;


export type MediaLibrary_Features_AttachMedia_AttachMediaToAnswerMutation = { __typename?: 'mutation_root', insert_polls_answer_set_attachment?: { __typename?: 'polls_answer_set_attachment_mutation_response', affected_rows: number } | null };

export type MediaLibrary_Features_AttachMedia_AttachMediaToEntryMutationVariables = Exact<{
  files: Array<Polls_Entry_Attachment_Insert_Input> | Polls_Entry_Attachment_Insert_Input;
}>;


export type MediaLibrary_Features_AttachMedia_AttachMediaToEntryMutation = { __typename?: 'mutation_root', insert_polls_entry_attachment?: { __typename?: 'polls_entry_attachment_mutation_response', affected_rows: number } | null };

export type MediaLibrary_Features_DetachMedia_DetachMediaFromEntryMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type MediaLibrary_Features_DetachMedia_DetachMediaFromEntryMutation = { __typename?: 'mutation_root', delete_polls_entry_attachment_by_pk?: { __typename?: 'polls_entry_attachment', title?: string | null, file: { __typename?: 'user_file', name: string, title?: string | null } } | null };

export type MediaLibrary_Features_DetachMedia_DetachMediaFromAnswerMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type MediaLibrary_Features_DetachMedia_DetachMediaFromAnswerMutation = { __typename?: 'mutation_root', delete_polls_answer_set_attachment_by_pk?: { __typename?: 'polls_answer_set_attachment', title?: string | null, file: { __typename?: 'user_file', name: string, title?: string | null } } | null };

export type MediaLibrary_Features_EditAttachment_UpdateAnswerAttachmentMutationVariables = Exact<{
  id: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
}>;


export type MediaLibrary_Features_EditAttachment_UpdateAnswerAttachmentMutation = { __typename?: 'mutation_root', update_polls_answer_set_attachment_by_pk?: { __typename?: 'polls_answer_set_attachment', title?: string | null } | null };

export type MediaLibrary_Features_EditAttachment_UpdateEntryAttachmentMutationVariables = Exact<{
  id: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
}>;


export type MediaLibrary_Features_EditAttachment_UpdateEntryAttachmentMutation = { __typename?: 'mutation_root', update_polls_entry_attachment_by_pk?: { __typename?: 'polls_entry_attachment', title?: string | null } | null };

export type MediaLibrary_Features_UploadFile_AcceptAttachmentConditionsMutationVariables = Exact<{
  profileId: Scalars['Int'];
}>;


export type MediaLibrary_Features_UploadFile_AcceptAttachmentConditionsMutation = { __typename?: 'mutation_root', profile?: { __typename?: 'accounts_profile', approved_attachments_conditions: boolean } | null };

export type MediaLibrary_Shared_MediaObjectFragment = { __typename?: 'user_file', id: any, user_id: number, content_type: string, name: string, size: number, title?: string | null, description?: string | null, date_created: any, thumbnail?: any | null } & { ' $fragmentName'?: 'MediaLibrary_Shared_MediaObjectFragment' };

export type MediaLibrary_Widgets_AttachmentManager_AllEntryAttachmentsQueryVariables = Exact<{
  entryId: Scalars['Int'];
  lang: Scalars['String'];
}>;


export type MediaLibrary_Widgets_AttachmentManager_AllEntryAttachmentsQuery = { __typename?: 'query_root', polls_entry_attachment: Array<(
    { __typename?: 'polls_entry_attachment' }
    & { ' $fragmentRefs'?: { 'MediaLibrary_Entities_Attachment_GeneralEntryAttachmentFragment': MediaLibrary_Entities_Attachment_GeneralEntryAttachmentFragment } }
  )>, polls_question: Array<(
    { __typename?: 'polls_question' }
    & { ' $fragmentRefs'?: { 'MediaLibrary_Widgets_AttachmentManager_QuestionWithAttachmentsFragment': MediaLibrary_Widgets_AttachmentManager_QuestionWithAttachmentsFragment } }
  )> };

export type MediaLibrary_Widgets_AttachmentManager_QuestionWithAttachmentsFragment = { __typename?: 'polls_question', id: number, name: string, translated_name?: string | null, category: { __typename?: 'polls_category', id: number, order: number }, group?: { __typename?: 'polls_group', id: number, order: number, ancestors?: Array<{ __typename?: 'polls_group', id: number }> | null } | null, ancestors?: Array<{ __typename?: 'polls_question', id: number, base_answer_sets: Array<{ __typename?: 'polls_baseanswerset', id: number }> }> | null, base_answer_sets: Array<{ __typename?: 'polls_baseanswerset', id: number, answer_sets: Array<{ __typename?: 'polls_answerset', attachments: Array<(
        { __typename?: 'polls_answer_set_attachment', id: number }
        & { ' $fragmentRefs'?: { 'MediaLibrary_Entities_Attachment_AnswerAttachmentFragment': MediaLibrary_Entities_Attachment_AnswerAttachmentFragment } }
      )> }> }> } & { ' $fragmentName'?: 'MediaLibrary_Widgets_AttachmentManager_QuestionWithAttachmentsFragment' };

export type MediaLibrary_Widgets_MediaLibraryManager_MediaListSubscriptionVariables = Exact<{
  userId: Scalars['Int'];
  lang: Scalars['String'];
}>;


export type MediaLibrary_Widgets_MediaLibraryManager_MediaListSubscription = { __typename?: 'subscription_root', user_file: Array<(
    { __typename?: 'user_file', id: any, entries?: Array<{ __typename?: 'polls_entity', id: number, name: { __typename?: 'polls_entityname', name: string }, poll: { __typename?: 'polls_poll', id: number, name: string, translated_name?: string | null } }> | null }
    & { ' $fragmentRefs'?: { 'MediaLibrary_Shared_MediaObjectFragment': MediaLibrary_Shared_MediaObjectFragment } }
  )> };

export type AnswerInputFragment = { __typename?: 'polls_templateanswer', text_input_type?: any | null } & { ' $fragmentName'?: 'AnswerInputFragment' };

export type EntryTagGroupsFragment = { __typename?: 'query_root', entry_tag_groups: Array<{ __typename: 'polls_entrytaggroup', id: number, name: string }> } & { ' $fragmentName'?: 'EntryTagGroupsFragment' };

export type CreateDraftMutationVariables = Exact<{
  payload?: InputMaybe<Scalars['jsonb']>;
  previousPollId?: InputMaybe<Scalars['Int']>;
}>;


export type CreateDraftMutation = { __typename?: 'mutation_root', insert_poll_drafts_one?: { __typename?: 'poll_drafts', id: number } | null };

export type DataForNewDraftQueryVariables = Exact<{ [key: string]: never; }>;


export type DataForNewDraftQuery = (
  { __typename?: 'query_root', polls_poll: Array<{ __typename?: 'polls_poll', name: string }> }
  & { ' $fragmentRefs'?: { 'EntryTagGroupsFragment': EntryTagGroupsFragment } }
);

export type PollNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type PollNamesQuery = { __typename?: 'query_root', polls_poll: Array<{ __typename?: 'polls_poll', name: string }> };

export type DeleteDraftMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteDraftMutation = { __typename?: 'mutation_root', delete_poll_drafts_by_pk?: { __typename?: 'poll_drafts', id: number } | null };

export type RelatedQuestionQueryVariables = Exact<{
  questionId: Scalars['Int'];
}>;


export type RelatedQuestionQuery = { __typename?: 'query_root', polls_question_by_pk?: (
    { __typename?: 'polls_question' }
    & { ' $fragmentRefs'?: { 'RelatedQuestionFragment': RelatedQuestionFragment } }
  ) | null };

export type QuestionSearchQueryVariables = Exact<{
  query: Scalars['String'];
  usedQuestionIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type QuestionSearchQuery = { __typename?: 'query_root', polls_question: Array<(
    { __typename?: 'polls_question' }
    & { ' $fragmentRefs'?: { 'RelatedQuestionFragment': RelatedQuestionFragment } }
  )> };

export type RelatedQuestionFragment = (
  { __typename?: 'polls_question', related_question_ids_1: Array<{ __typename?: 'polls_questionrelation', second_question: (
      { __typename?: 'polls_question' }
      & { ' $fragmentRefs'?: { 'RelatedQuestionBaseFragment': RelatedQuestionBaseFragment } }
    ) }>, related_question_ids_2: Array<{ __typename?: 'polls_questionrelation', first_question: (
      { __typename?: 'polls_question' }
      & { ' $fragmentRefs'?: { 'RelatedQuestionBaseFragment': RelatedQuestionBaseFragment } }
    ) }> }
  & { ' $fragmentRefs'?: { 'RelatedQuestionBaseFragment': RelatedQuestionBaseFragment } }
) & { ' $fragmentName'?: 'RelatedQuestionFragment' };

export type RelatedQuestionBaseFragment = { __typename?: 'polls_question', id: number, name: string, poll: { __typename?: 'polls_poll', name: string }, parent_question?: { __typename?: 'polls_question', name: string } | null } & { ' $fragmentName'?: 'RelatedQuestionBaseFragment' };

export type PublishDraftMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type PublishDraftMutation = { __typename?: 'mutation_root', publish_poll_draft: number };

export type DraftQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DraftQuery = (
  { __typename?: 'query_root', poll_drafts_by_pk?: { __typename?: 'poll_drafts', id: number, payload?: any | null, created_at?: any | null, updated_at?: any | null, user: { __typename?: 'auth_user', first_name: string, last_name: string }, previous_poll?: { __typename?: 'polls_poll', name: string } | null } | null }
  & { ' $fragmentRefs'?: { 'EntryTagGroupsFragment': EntryTagGroupsFragment } }
);

export type UpdateDraftMutationVariables = Exact<{
  id: Scalars['Int'];
  payload?: InputMaybe<Scalars['jsonb']>;
}>;


export type UpdateDraftMutation = { __typename?: 'mutation_root', update_poll_drafts_by_pk?: { __typename?: 'poll_drafts', id: number } | null };

export type DraftsQueryVariables = Exact<{ [key: string]: never; }>;


export type DraftsQuery = { __typename?: 'query_root', poll_drafts: Array<{ __typename?: 'poll_drafts', id: number, created_at?: any | null, updated_at?: any | null, payload?: any | null, user: { __typename?: 'auth_user', first_name: string, last_name: string }, previous_poll?: { __typename?: 'polls_poll', id: number, name: string } | null }> };

export type TranslateAnswerClassificationNameMutationVariables = Exact<{
  id: Scalars['Int'];
  newValue?: InputMaybe<Polls_Branchingquestion_Set_Input>;
  lang?: InputMaybe<Scalars['String']>;
}>;


export type TranslateAnswerClassificationNameMutation = { __typename?: 'mutation_root', update_polls_branchingquestion_by_pk?: { __typename?: 'polls_branchingquestion', translated_name?: string | null } | null };

export type TranslateAnswerClassificationClassNameMutationVariables = Exact<{
  id: Scalars['Int'];
  newValue?: InputMaybe<Polls_Branch_Set_Input>;
  lang?: InputMaybe<Scalars['String']>;
}>;


export type TranslateAnswerClassificationClassNameMutation = { __typename?: 'mutation_root', update_polls_branch_by_pk?: { __typename?: 'polls_branch', translated_name?: string | null } | null };

export type TranslateAnswerClassificationClassDescriptionMutationVariables = Exact<{
  id: Scalars['Int'];
  newValue?: InputMaybe<Polls_Branch_Set_Input>;
  lang?: InputMaybe<Scalars['String']>;
}>;


export type TranslateAnswerClassificationClassDescriptionMutation = { __typename?: 'mutation_root', update_polls_branch_by_pk?: { __typename?: 'polls_branch', translated_tooltip?: string | null } | null };

export type TranslateAnswerTextMutationVariables = Exact<{
  id: Scalars['Int'];
  newValue?: InputMaybe<Polls_Templateanswer_Set_Input>;
  lang?: InputMaybe<Scalars['String']>;
}>;


export type TranslateAnswerTextMutation = { __typename?: 'mutation_root', update_polls_templateanswer_by_pk?: { __typename?: 'polls_templateanswer', translated_name?: string | null } | null };

export type TranslateCategoryNameMutationVariables = Exact<{
  id: Scalars['Int'];
  newValue?: InputMaybe<Polls_Category_Set_Input>;
  lang?: InputMaybe<Scalars['String']>;
}>;


export type TranslateCategoryNameMutation = { __typename?: 'mutation_root', update_polls_category_by_pk?: { __typename?: 'polls_category', translated_name?: string | null } | null };

export type CategoryTranslationProgressSubscriptionVariables = Exact<{
  id: Scalars['Int'];
  lang: Scalars['String'];
}>;


export type CategoryTranslationProgressSubscription = { __typename?: 'subscription_root', polls_category_by_pk?: { __typename?: 'polls_category', translation_progress?: any | null } | null };

export type TranslatedPollQueryVariables = Exact<{
  id: Scalars['Int'];
  lang?: InputMaybe<Scalars['String']>;
}>;


export type TranslatedPollQuery = { __typename?: 'query_root', polls_poll_by_pk?: { __typename?: 'polls_poll', name: string, translated_name?: string | null, description?: string | null, translated_description?: string | null, previous?: { __typename?: 'polls_poll', name: string, translated_name?: string | null, description?: string | null, translated_description?: string | null } | null, branching_questions: Array<{ __typename?: 'polls_branchingquestion', id: number, name: string, translated_name?: string | null, previous?: { __typename?: 'polls_branchingquestion', name: string, translated_name?: string | null } | null, branches: Array<{ __typename?: 'polls_branch', id: number, name: string, translated_name?: string | null, tooltip?: string | null, translated_tooltip?: string | null, previous?: { __typename?: 'polls_branch', name: string, translated_name?: string | null, tooltip?: string | null, translated_tooltip?: string | null } | null }> }>, categories: Array<{ __typename?: 'polls_category', id: number, name: string, translated_name?: string | null, previous?: { __typename?: 'polls_category', name: string, translated_name?: string | null } | null, groups: Array<{ __typename?: 'polls_group', id: number, name: string, translated_name?: string | null, previous?: { __typename?: 'polls_group', name: string, translated_name?: string | null } | null, groups: Array<{ __typename?: 'polls_group', id: number, name: string, translated_name?: string | null, previous?: { __typename?: 'polls_group', name: string, translated_name?: string | null } | null, questions: Array<{ __typename?: 'polls_question', id: number }> }>, questions: Array<{ __typename?: 'polls_question', id: number }> }>, questions: Array<{ __typename?: 'polls_question', id: number }> }> } | null, polls_question: Array<{ __typename?: 'polls_question', id: number, name: string, translated_name?: string | null, description?: string | null, translated_description?: string | null, template_answer_set_id: number, multiple_answers_allowed: boolean, parent_template_answer_id?: number | null, previous?: { __typename?: 'polls_question', name: string, translated_name?: string | null, description?: string | null, translated_description?: string | null } | null, sub_questions: Array<{ __typename?: 'polls_question', id: number }> }>, polls_templateanswerset: Array<{ __typename?: 'polls_templateanswerset', id: number, answers: Array<{ __typename?: 'polls_templateanswer', id: number, name: string, translated_name?: string | null, previous?: { __typename?: 'polls_templateanswer', name: string, translated_name?: string | null } | null }> }> };

export type TranslateGroupNameMutationVariables = Exact<{
  id: Scalars['Int'];
  newValue?: InputMaybe<Polls_Group_Set_Input>;
  lang?: InputMaybe<Scalars['String']>;
}>;


export type TranslateGroupNameMutation = { __typename?: 'mutation_root', update_polls_group_by_pk?: { __typename?: 'polls_group', translated_name?: string | null } | null };

export type GroupTranslationProgressSubscriptionVariables = Exact<{
  id: Scalars['Int'];
  lang: Scalars['String'];
}>;


export type GroupTranslationProgressSubscription = { __typename?: 'subscription_root', polls_group_by_pk?: { __typename?: 'polls_group', translation_progress?: any | null } | null };

export type TranslatePollNameMutationVariables = Exact<{
  id: Scalars['Int'];
  newValue?: InputMaybe<Polls_Poll_Set_Input>;
  lang?: InputMaybe<Scalars['String']>;
}>;


export type TranslatePollNameMutation = { __typename?: 'mutation_root', update_polls_poll_by_pk?: { __typename?: 'polls_poll', translated_name?: string | null } | null };

export type TranslatePollDescriptionMutationVariables = Exact<{
  id: Scalars['Int'];
  newValue?: InputMaybe<Polls_Poll_Set_Input>;
  lang?: InputMaybe<Scalars['String']>;
}>;


export type TranslatePollDescriptionMutation = { __typename?: 'mutation_root', update_polls_poll_by_pk?: { __typename?: 'polls_poll', translated_description?: string | null } | null };

export type PollTranslationProgressSubscriptionVariables = Exact<{
  id: Scalars['Int'];
  lang: Scalars['String'];
}>;


export type PollTranslationProgressSubscription = { __typename?: 'subscription_root', polls_poll_by_pk?: { __typename?: 'polls_poll', translation_progress?: any | null } | null };

export type TranslateQuestionTextMutationVariables = Exact<{
  id: Scalars['Int'];
  newValue?: InputMaybe<Polls_Question_Set_Input>;
  lang?: InputMaybe<Scalars['String']>;
}>;


export type TranslateQuestionTextMutation = { __typename?: 'mutation_root', update_polls_question_by_pk?: { __typename?: 'polls_question', translated_name?: string | null } | null };

export type TranslateQuestionDescriptionMutationVariables = Exact<{
  id: Scalars['Int'];
  newValue?: InputMaybe<Polls_Question_Set_Input>;
  lang?: InputMaybe<Scalars['String']>;
}>;


export type TranslateQuestionDescriptionMutation = { __typename?: 'mutation_root', update_polls_question_by_pk?: { __typename?: 'polls_question', translated_description?: string | null } | null };

export type QuestionTranslationProgressSubscriptionVariables = Exact<{
  id: Scalars['Int'];
  lang: Scalars['String'];
}>;


export type QuestionTranslationProgressSubscription = { __typename?: 'subscription_root', polls_question_by_pk?: { __typename?: 'polls_question', translation_progress?: any | null } | null };

export type PollQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type PollQuery = (
  { __typename?: 'query_root', polls_poll_by_pk?: { __typename?: 'polls_poll', name: string, description?: string | null, release_notes?: string | null, required_entry_tag_groups: Array<{ __typename?: 'polls_poll_required_entry_tag_groups', entrytaggroup_id: number }>, optional_entry_tag_groups: Array<{ __typename?: 'polls_poll_optional_entry_tag_groups', entrytaggroup_id: number }>, branching_questions: Array<{ __typename?: 'polls_branchingquestion', name: string, branches: Array<{ __typename?: 'polls_branch', id: number, name: string, tooltip?: string | null }> }>, categories: Array<{ __typename?: 'polls_category', id: number, name: string, groups: Array<{ __typename?: 'polls_group', id: number, name: string, groups: Array<{ __typename?: 'polls_group', id: number, name: string, questions: Array<(
            { __typename?: 'polls_question' }
            & { ' $fragmentRefs'?: { 'QuestionFragment': QuestionFragment } }
          )> }>, questions: Array<(
          { __typename?: 'polls_question' }
          & { ' $fragmentRefs'?: { 'QuestionFragment': QuestionFragment } }
        )> }>, questions: Array<(
        { __typename?: 'polls_question' }
        & { ' $fragmentRefs'?: { 'QuestionFragment': QuestionFragment } }
      )> }> } | null }
  & { ' $fragmentRefs'?: { 'EntryTagGroupsFragment': EntryTagGroupsFragment } }
);

export type QuestionFragment = (
  { __typename?: 'polls_question', sub_questions: Array<(
    { __typename?: 'polls_question', parent_template_answer_id?: number | null, sub_questions: Array<(
      { __typename?: 'polls_question', parent_template_answer_id?: number | null }
      & { ' $fragmentRefs'?: { 'QuestionDetailsFragment': QuestionDetailsFragment } }
    )> }
    & { ' $fragmentRefs'?: { 'QuestionDetailsFragment': QuestionDetailsFragment } }
  )> }
  & { ' $fragmentRefs'?: { 'QuestionDetailsFragment': QuestionDetailsFragment } }
) & { ' $fragmentName'?: 'QuestionFragment' };

export type QuestionDetailsFragment = { __typename?: 'polls_question', id: number, name: string, multiple_answers_allowed: boolean, template_answer_set: { __typename?: 'polls_templateanswerset', answers: Array<(
      { __typename?: 'polls_templateanswer', id: number, name: string }
      & { ' $fragmentRefs'?: { 'AnswerInputFragment': AnswerInputFragment } }
    )> } } & { ' $fragmentName'?: 'QuestionDetailsFragment' };

export type PollDuplicateQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type PollDuplicateQuery = { __typename?: 'query_root', polls_poll_by_pk?: { __typename?: 'polls_poll', name: string, description?: string | null, release_notes?: string | null, required_entry_tag_groups: Array<{ __typename?: 'polls_poll_required_entry_tag_groups', entrytaggroup_id: number }>, optional_entry_tag_groups: Array<{ __typename?: 'polls_poll_optional_entry_tag_groups', entrytaggroup_id: number }>, branching_questions: Array<{ __typename?: 'polls_branchingquestion', id: number, name: string, branches: Array<{ __typename?: 'polls_branch', id: number, name: string, tooltip?: string | null }> }>, categories: Array<{ __typename?: 'polls_category', id: number, name: string, groups: Array<{ __typename?: 'polls_group', id: number, name: string, groups: Array<{ __typename?: 'polls_group', id: number, name: string, questions: Array<(
            { __typename?: 'polls_question' }
            & { ' $fragmentRefs'?: { 'QuestionDuplicateFragment': QuestionDuplicateFragment } }
          )> }>, questions: Array<(
          { __typename?: 'polls_question' }
          & { ' $fragmentRefs'?: { 'QuestionDuplicateFragment': QuestionDuplicateFragment } }
        )> }>, questions: Array<(
        { __typename?: 'polls_question' }
        & { ' $fragmentRefs'?: { 'QuestionDuplicateFragment': QuestionDuplicateFragment } }
      )> }> } | null, polls_question: Array<{ __typename?: 'polls_question', id: number }>, polls_templateanswerset: Array<{ __typename?: 'polls_templateanswerset', id: number, answers: Array<(
      { __typename?: 'polls_templateanswer', id: number, name: string, value: number }
      & { ' $fragmentRefs'?: { 'AnswerInputFragment': AnswerInputFragment } }
    )> }> };

export type QuestionDuplicateFragment = (
  { __typename?: 'polls_question', sub_questions: Array<(
    { __typename?: 'polls_question', parent_template_answer_id?: number | null, sub_questions: Array<(
      { __typename?: 'polls_question', parent_template_answer_id?: number | null }
      & { ' $fragmentRefs'?: { 'QuestionDetailsDuplicateFragment': QuestionDetailsDuplicateFragment } }
    )> }
    & { ' $fragmentRefs'?: { 'QuestionDetailsDuplicateFragment': QuestionDetailsDuplicateFragment } }
  )> }
  & { ' $fragmentRefs'?: { 'QuestionDetailsDuplicateFragment': QuestionDetailsDuplicateFragment } }
) & { ' $fragmentName'?: 'QuestionDuplicateFragment' };

export type QuestionDetailsDuplicateFragment = { __typename?: 'polls_question', id: number, name: string, description?: string | null, multiple_answers_allowed: boolean, is_priority: boolean, template_answer_set_id: number } & { ' $fragmentName'?: 'QuestionDetailsDuplicateFragment' };

export type PollManager_PollsQueryVariables = Exact<{ [key: string]: never; }>;


export type PollManager_PollsQuery = { __typename?: 'query_root', polls_poll: Array<(
    { __typename?: 'polls_poll', id: number }
    & { ' $fragmentRefs'?: { 'PollManager_Polls_PollFragment': PollManager_Polls_PollFragment } }
  )> };

export type PollManager_Polls_PollFragment = { __typename?: 'polls_poll', id: number, name: string, type: string, is_disabled: boolean, date_created: any, translation_progress?: any | null, created_by: { __typename?: 'auth_user', first_name: string, last_name: string, username: string }, entries_aggregate: { __typename?: 'polls_entity_aggregate', aggregate?: { __typename?: 'polls_entity_aggregate_fields', count: number } | null }, next?: { __typename?: 'polls_poll', id: number } | null, next_draft?: { __typename?: 'poll_drafts', id: number } | null } & { ' $fragmentName'?: 'PollManager_Polls_PollFragment' };

export type PollManager_Poll_EnablePollMutationVariables = Exact<{
  pollId: Scalars['Int'];
}>;


export type PollManager_Poll_EnablePollMutation = { __typename?: 'mutation_root', enable_poll: boolean };

export type PollManager_Poll_DisablePollMutationVariables = Exact<{
  pollId: Scalars['Int'];
}>;


export type PollManager_Poll_DisablePollMutation = { __typename?: 'mutation_root', disable_poll: boolean };

export type PublicProfile_ContributionsFragment = { __typename?: 'auth_user', entries: Array<(
    { __typename?: 'polls_entity', id: number }
    & { ' $fragmentRefs'?: { 'PublicProfile_Contributions_EntryFragment': PublicProfile_Contributions_EntryFragment } }
  )> } & { ' $fragmentName'?: 'PublicProfile_ContributionsFragment' };

export type PublicProfile_Contributions_EntryFragment = (
  { __typename?: 'polls_entity' }
  & { ' $fragmentRefs'?: { 'EntryProgressFragment': EntryProgressFragment } }
) & { ' $fragmentName'?: 'PublicProfile_Contributions_EntryFragment' };

export type UserIdByUsernameQueryQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type UserIdByUsernameQueryQuery = { __typename?: 'query_root', auth_user: Array<{ __typename?: 'auth_user', id: number }> };

export type PublicProfile_Profile_InterestsFragment = { __typename?: 'accounts_profile', interests?: any | null } & { ' $fragmentName'?: 'PublicProfile_Profile_InterestsFragment' };

export type PublicProfile_ProfileFragment = (
  { __typename?: 'auth_user', id: number, first_name: string, last_name: string, username: string, email?: string, profile?: (
    { __typename?: 'accounts_profile', occupation?: string | null, institution?: string | null, department?: string | null, area_of_research?: string | null, position?: string | null, websites?: any | null, location?: string | null, biography?: string | null }
    & { ' $fragmentRefs'?: { 'PublicProfile_Profile_InterestsFragment': PublicProfile_Profile_InterestsFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'PublicProfile_Profile_RoleFragment': PublicProfile_Profile_RoleFragment } }
) & { ' $fragmentName'?: 'PublicProfile_ProfileFragment' };

export type PublicProfile_Profile_RoleFragment = { __typename?: 'auth_user', managing_editor?: { __typename?: 'accounts_managingeditor', id: number } | null, regional_editor?: { __typename?: 'accounts_regionaleditor', title?: string | null } | null } & { ' $fragmentName'?: 'PublicProfile_Profile_RoleFragment' };

export type PublicProfileQueryQueryVariables = Exact<{
  userId: Scalars['Int'];
  withEmail: Scalars['Boolean'];
}>;


export type PublicProfileQueryQuery = { __typename?: 'query_root', user?: (
    { __typename?: 'auth_user' }
    & { ' $fragmentRefs'?: { 'PublicProfile_ProfileFragment': PublicProfile_ProfileFragment;'PublicProfile_ContributionsFragment': PublicProfile_ContributionsFragment } }
  ) | null };

export type Settings_AccountSettings_SetProfileLanguageMutationMutationVariables = Exact<{
  profileId: Scalars['Int'];
  language: Scalars['String'];
}>;


export type Settings_AccountSettings_SetProfileLanguageMutationMutation = { __typename?: 'mutation_root', update_accounts_profile_by_pk?: { __typename?: 'accounts_profile', language: string } | null };

export type Settings_ProfileQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type Settings_ProfileQuery = { __typename?: 'query_root', auth_user_by_pk?: { __typename?: 'auth_user', first_name: string, last_name: string, profile?: { __typename?: 'accounts_profile', occupation?: string | null, institution?: string | null, department?: string | null, area_of_research?: string | null, position?: string | null, location?: string | null, biography?: string | null, websites?: any | null, interests?: any | null } | null } | null };

export type Settings_Profile_MutationMutationVariables = Exact<{
  userId: Scalars['Int'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  occupation: Scalars['String'];
  institution: Scalars['String'];
  department: Scalars['String'];
  areaOfResearch: Scalars['String'];
  position: Scalars['String'];
  location: Scalars['String'];
  biography: Scalars['String'];
  interests?: InputMaybe<Scalars['_varchar']>;
  websites: Scalars['jsonb'];
}>;


export type Settings_Profile_MutationMutation = { __typename?: 'mutation_root', update_auth_user_by_pk?: { __typename?: 'auth_user', id: number } | null, update_accounts_profile?: { __typename?: 'accounts_profile_mutation_response', returning: Array<{ __typename?: 'accounts_profile', id: number }> } | null };

export type SignUp_EditorSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type SignUp_EditorSelectQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'SignUp_SignUpForm_EditorList_RegionalEditorListFragment': SignUp_SignUpForm_EditorList_RegionalEditorListFragment;'SignUp_SignUpForm_EditorList_ExternalEditorListFragment': SignUp_SignUpForm_EditorList_ExternalEditorListFragment;'SignUp_SignUpForm_EditorList_ManagingEditorListFragment': SignUp_SignUpForm_EditorList_ManagingEditorListFragment } }
);

export type SignUp_SignUpForm_EditorSelect_EditorUserFragment = { __typename?: 'auth_user', id: number, first_name: string, last_name: string, username: string, profile?: { __typename?: 'accounts_profile', institution?: string | null } | null } & { ' $fragmentName'?: 'SignUp_SignUpForm_EditorSelect_EditorUserFragment' };

export type SignUp_SignUpForm_EditorList_ExternalEditorListFragment = { __typename?: 'query_root', external_editor_categories: Array<{ __typename?: 'accounts_regionaleditorcategory', id: number, regional_editors: Array<(
      { __typename?: 'accounts_regionaleditorcategory_editors', id: number }
      & { ' $fragmentRefs'?: { 'SignUp_SignUpForm_EditorSelect_RegionalEditorFragment': SignUp_SignUpForm_EditorSelect_RegionalEditorFragment } }
    )> }> } & { ' $fragmentName'?: 'SignUp_SignUpForm_EditorList_ExternalEditorListFragment' };

export type SignUp_SignUpForm_EditorSelect_ManagingEditorFragment = { __typename?: 'accounts_managingeditor', id: number, user: (
    { __typename?: 'auth_user' }
    & { ' $fragmentRefs'?: { 'SignUp_SignUpForm_EditorSelect_EditorUserFragment': SignUp_SignUpForm_EditorSelect_EditorUserFragment } }
  ) } & { ' $fragmentName'?: 'SignUp_SignUpForm_EditorSelect_ManagingEditorFragment' };

export type SignUp_SignUpForm_EditorList_ManagingEditorListFragment = { __typename?: 'query_root', accounts_managingeditor: Array<(
    { __typename?: 'accounts_managingeditor', id: number }
    & { ' $fragmentRefs'?: { 'SignUp_SignUpForm_EditorSelect_ManagingEditorFragment': SignUp_SignUpForm_EditorSelect_ManagingEditorFragment } }
  )> } & { ' $fragmentName'?: 'SignUp_SignUpForm_EditorList_ManagingEditorListFragment' };

export type SignUp_SignUpForm_EditorSelect_RegionalEditorFragment = { __typename?: 'accounts_regionaleditorcategory_editors', regional_editor: { __typename?: 'accounts_regionaleditor', id: number, title?: string | null, region: { __typename?: 'gis_regions_gis_region', name?: string | null }, user: (
      { __typename?: 'auth_user' }
      & { ' $fragmentRefs'?: { 'SignUp_SignUpForm_EditorSelect_EditorUserFragment': SignUp_SignUpForm_EditorSelect_EditorUserFragment } }
    ) } } & { ' $fragmentName'?: 'SignUp_SignUpForm_EditorSelect_RegionalEditorFragment' };

export type SignUp_SignUpForm_EditorList_RegionalEditorListFragment = { __typename?: 'query_root', regional_editor_categories: Array<{ __typename?: 'accounts_regionaleditorcategory', id: number, title?: string | null, regional_editors: Array<(
      { __typename?: 'accounts_regionaleditorcategory_editors', id: number }
      & { ' $fragmentRefs'?: { 'SignUp_SignUpForm_EditorSelect_RegionalEditorFragment': SignUp_SignUpForm_EditorSelect_RegionalEditorFragment } }
    )> }> } & { ' $fragmentName'?: 'SignUp_SignUpForm_EditorList_RegionalEditorListFragment' };

export type YearFromQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type YearFromQueryQuery = { __typename?: 'query_root', polls_baseanswerset_aggregate: { __typename?: 'polls_baseanswerset_aggregate', aggregate?: { __typename?: 'polls_baseanswerset_aggregate_fields', min?: { __typename?: 'polls_baseanswerset_min_fields', year_from?: number | null } | null } | null } };

export type YearFromAndSearchQueryIdQueryQueryVariables = Exact<{
  searchQueryId: Scalars['Int'];
}>;


export type YearFromAndSearchQueryIdQueryQuery = { __typename?: 'query_root', polls_baseanswerset_aggregate: { __typename?: 'polls_baseanswerset_aggregate', aggregate?: { __typename?: 'polls_baseanswerset_aggregate_fields', min?: { __typename?: 'polls_baseanswerset_min_fields', year_from?: number | null } | null } | null }, polls_searchrequest_by_pk?: { __typename?: 'polls_searchrequest', id: number } | null };

export type OverallCoverage_EntryListQueryVariables = Exact<{
  regionId: Scalars['Int'];
  lang: Scalars['String'];
}>;


export type OverallCoverage_EntryListQuery = { __typename?: 'query_root', gis_regions_gis_region_by_pk?: { __typename?: 'gis_regions_gis_region', name?: string | null, entries: Array<{ __typename?: 'polls_entity', id: number, date_modified: any, year_from: number, year_to: number, name: { __typename?: 'polls_entityname', name: string }, user: { __typename?: 'auth_user', first_name: string, last_name: string, username: string }, poll: { __typename?: 'polls_poll', name: string, translated_name?: string | null } }> } | null };

export type OverallCoverage_DataSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type OverallCoverage_DataSourcesQuery = { __typename?: 'query_root', polls_datasource: Array<{ __typename?: 'polls_datasource', id: number, name: string }> };

export type OverallCoverage_PollsQueryVariables = Exact<{
  lang: Scalars['String'];
}>;


export type OverallCoverage_PollsQuery = { __typename?: 'query_root', polls_poll: Array<{ __typename?: 'polls_poll', id: number, name: string, translated_name?: string | null }> };

export type OverallCoverage_GisRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type OverallCoverage_GisRegionsQuery = { __typename?: 'query_root', regions: Array<{ __typename?: 'gis_regions_gis_region', id: number, geom?: any | null, answer_count: { __typename?: 'polls_baseanswerset_aggregate', aggregate?: { __typename?: 'polls_baseanswerset_aggregate_fields', count: number } | null }, year_range: { __typename?: 'polls_entity_aggregate', aggregate?: { __typename?: 'polls_entity_aggregate_fields', min?: { __typename?: 'polls_entity_min_fields', year_from?: number | null } | null, max?: { __typename?: 'polls_entity_max_fields', year_to?: number | null } | null } | null }, poll_ids: { __typename?: 'polls_entity_aggregate', nodes: Array<{ __typename?: 'polls_entity', poll_id: number }> }, entry_source_ids: { __typename?: 'polls_entity_aggregate', nodes: Array<{ __typename?: 'polls_entity', entry_source: number }> }, data_source_ids: { __typename?: 'polls_entity_aggregate', nodes: Array<{ __typename?: 'polls_entity', data_source_id: number }> } }>, min_year_from: { __typename?: 'polls_entity_aggregate', aggregate?: { __typename?: 'polls_entity_aggregate_fields', min?: { __typename?: 'polls_entity_min_fields', year_from?: number | null } | null } | null } };

export type CurrentUserQueryQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type CurrentUserQueryQuery = { __typename?: 'query_root', user?: { __typename?: 'auth_user', username: string, first_name: string, last_name: string, email: string, profile?: { __typename?: 'accounts_profile', id: number, language: string, approved_attachments_conditions: boolean } | null, expert?: { __typename?: 'accounts_expert', approved: boolean, confirmed_agreement: boolean } | null } | null };

export type AvatarQueryVariables = Exact<{
  userId: Scalars['Int'];
  size?: InputMaybe<Scalars['Int']>;
}>;


export type AvatarQuery = { __typename?: 'query_root', avatar?: { __typename?: 'Avatar', url?: string | null } | null };

export type EntryProgressFragment = { __typename?: 'polls_entity', id: number, created_by_id: number, date_modified: any, name: { __typename?: 'polls_entityname', name: string }, progress: Array<{ __typename?: 'polls_pollprogress', total: number, answered: number, additional_total: number, additional_answered: number, published: number, draft: number, category_progress: Array<{ __typename?: 'polls_categoryprogress', total: number, answered: number, additional_total: number, additional_answered: number, category: { __typename?: 'polls_category', name: string } }>, considered_answer_sets: Array<{ __typename?: 'polls_pollprogress_considered_answer_sets', base_answer_set?: { __typename?: 'polls_baseanswerset', answer_sets: Array<{ __typename?: 'polls_answerset', date_published?: any | null }> } | null }> }> } & { ' $fragmentName'?: 'EntryProgressFragment' };

export type SearchReferencesQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type SearchReferencesQuery = { __typename?: 'query_root', reference_search_connection?: { __typename?: 'ReferencesConnection', edges?: Array<{ __typename?: 'ReferencesEdge', node?: { __typename?: 'References', csl_json?: any | null, highlight?: any | null } | null } | null> | null } | null, crossref_search_connection?: { __typename?: 'CrossrefReferencesConnection', edges?: Array<{ __typename?: 'CrossrefReferencesEdge', node?: { __typename?: 'CrossrefReferences', csl_json?: any | null } | null } | null> | null } | null };

export const Analyze_AnswerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Analyze_Answer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_answer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"template_answer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"text_input_type"}},{"kind":"Field","name":{"kind":"Name","value":"text_input"}},{"kind":"Field","name":{"kind":"Name","value":"base_answer_set"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"translated_description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"poll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"region_id"}},{"kind":"Field","name":{"kind":"Name","value":"branches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"branch_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"year_from"}},{"kind":"Field","name":{"kind":"Name","value":"year_to"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]}}]} as unknown as DocumentNode<Analyze_AnswerFragment, unknown>;
export const Analyze_BarChart_FirstVariable_AnswersQueryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Analyze_BarChart_FirstVariable_AnswersQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"first_variable_answers"},"name":{"kind":"Name","value":"polls_answer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstVariableBoolExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_Answer"}}]}}]}}]} as unknown as DocumentNode<Analyze_BarChart_FirstVariable_AnswersQueryFragment, unknown>;
export const Analyze_BarChart_SecondVariable_AnswersQueryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Analyze_BarChart_SecondVariable_AnswersQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"second_variable_answers"},"name":{"kind":"Name","value":"polls_answer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"secondVariableBoolExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_Answer"}}]}}]}}]} as unknown as DocumentNode<Analyze_BarChart_SecondVariable_AnswersQueryFragment, unknown>;
export const Analyze_BarChart_ThirdVariable_AnswersQueryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Analyze_BarChart_ThirdVariable_AnswersQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"third_variable_answers"},"name":{"kind":"Name","value":"polls_answer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thirdVariableBoolExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_Answer"}}]}}]}}]} as unknown as DocumentNode<Analyze_BarChart_ThirdVariable_AnswersQueryFragment, unknown>;
export const Analyze_BarChart_FourthVariable_AnswersQueryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Analyze_BarChart_FourthVariable_AnswersQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"fourth_variable_answers"},"name":{"kind":"Name","value":"polls_answer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fourthVariableBoolExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_Answer"}}]}}]}}]} as unknown as DocumentNode<Analyze_BarChart_FourthVariable_AnswersQueryFragment, unknown>;
export const Analyze_BarChart_FifthVariable_AnswersQueryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Analyze_BarChart_FifthVariable_AnswersQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"fifth_variable_answers"},"name":{"kind":"Name","value":"polls_answer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fifthVariableBoolExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_Answer"}}]}}]}}]} as unknown as DocumentNode<Analyze_BarChart_FifthVariable_AnswersQueryFragment, unknown>;
export const Analyze_CsvExportTool_DatumFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Analyze_CsvExportTool_Datum"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_answer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"base_answer_set"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"poll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includePollId"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includePollName"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"branching_questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeBranchingQuestion"}}}]}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeEntryId"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeEntryName"}}}]}]}]}},{"kind":"Field","name":{"kind":"Name","value":"data_source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeEntryDataSource"}}}]}]}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeEntryDescription"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeEntryTags"}}}]}]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeQuestionId"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeQuestionText"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"translated_description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeQuestionDescription"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"parent_question_id"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeParentQuestionId"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"parent_question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeParentQuestionText"}}}]}]}]}},{"kind":"Field","name":{"kind":"Name","value":"parent_template_answer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeParentAnswerText"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"value"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeParentAnswerValue"}}}]}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeNotes"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"branches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"branch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeBranchingQuestion"}}}]}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"year_from"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeYearRange"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"year_to"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeYearRange"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"region_id"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeRegionId"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeRegionName"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"description"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeRegionDescription"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeRegionTags"}}}]}]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"expert_id"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeExpertId"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"expert"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeExpertName"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"last_name"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeExpertName"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"username"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeExpertName"}}}]}]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"template_answer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeAnswerText"}}}]}]}]}},{"kind":"Field","name":{"kind":"Name","value":"value"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeAnswerValue"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"text_input"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeAnswerData"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"text_input_type"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeAnswerData"}}}]}]}]}}]} as unknown as DocumentNode<Analyze_CsvExportTool_DatumFragment, unknown>;
export const Analyze_CsvExportTool_FirstVariableFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Analyze_CsvExportTool_FirstVariable"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"firstVariable"},"name":{"kind":"Name","value":"polls_answer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstVariableBoolExp"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataOrderExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_CsvExportTool_Datum"}}]}}]}}]} as unknown as DocumentNode<Analyze_CsvExportTool_FirstVariableFragment, unknown>;
export const Analyze_CsvExportTool_SecondVariableFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Analyze_CsvExportTool_SecondVariable"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"secondVariable"},"name":{"kind":"Name","value":"polls_answer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"secondVariableBoolExp"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataOrderExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_CsvExportTool_Datum"}}]}}]}}]} as unknown as DocumentNode<Analyze_CsvExportTool_SecondVariableFragment, unknown>;
export const Analyze_CsvExportTool_ThirdVariableFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Analyze_CsvExportTool_ThirdVariable"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"thirdVariable"},"name":{"kind":"Name","value":"polls_answer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"thirdVariableBoolExp"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataOrderExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_CsvExportTool_Datum"}}]}}]}}]} as unknown as DocumentNode<Analyze_CsvExportTool_ThirdVariableFragment, unknown>;
export const Analyze_CsvExportTool_FourthVariableFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Analyze_CsvExportTool_FourthVariable"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"fourthVariable"},"name":{"kind":"Name","value":"polls_answer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fourthVariableBoolExp"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataOrderExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_CsvExportTool_Datum"}}]}}]}}]} as unknown as DocumentNode<Analyze_CsvExportTool_FourthVariableFragment, unknown>;
export const Analyze_CsvExportTool_FifthVariableFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Analyze_CsvExportTool_FifthVariable"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"fifthVariable"},"name":{"kind":"Name","value":"polls_answer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fifthVariableBoolExp"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataOrderExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_CsvExportTool_Datum"}}]}}]}}]} as unknown as DocumentNode<Analyze_CsvExportTool_FifthVariableFragment, unknown>;
export const Analyze_EntryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Analyze_Entry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_entity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"year_from"}},{"kind":"Field","name":{"kind":"Name","value":"year_to"}},{"kind":"Field","name":{"kind":"Name","value":"poll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Analyze_EntryFragment, unknown>;
export const Analyze_Question_PollFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Analyze_Question_Poll"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_question"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"poll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}}]}}]} as unknown as DocumentNode<Analyze_Question_PollFragment, unknown>;
export const Analyze_Question_QuestionAnswerOptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Analyze_Question_QuestionAnswerOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_templateanswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"text_input_type"}}]}}]} as unknown as DocumentNode<Analyze_Question_QuestionAnswerOptionFragment, unknown>;
export const Analyze_Question_QuestionAnswerOptionListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Analyze_Question_QuestionAnswerOptionList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_question"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template_answer_set"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_Question_QuestionAnswerOption"}}]}}]}}]}}]} as unknown as DocumentNode<Analyze_Question_QuestionAnswerOptionListFragment, unknown>;
export const Analyze_Question_RelatedQuestionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Analyze_Question_RelatedQuestion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_question"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_Question_Poll"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_Question_QuestionAnswerOptionList"}}]}}]} as unknown as DocumentNode<Analyze_Question_RelatedQuestionFragment, unknown>;
export const Analyze_Question_ListOfRelatedQuestionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Analyze_Question_ListOfRelatedQuestions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_question"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"related_question_ids_1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"second_question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_Question_RelatedQuestion"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"related_question_ids_2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_Question_RelatedQuestion"}}]}}]}}]}}]} as unknown as DocumentNode<Analyze_Question_ListOfRelatedQuestionsFragment, unknown>;
export const Analyze_QuestionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Analyze_Question"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_question"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"translated_description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_Question_Poll"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_Question_QuestionAnswerOptionList"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_Question_ListOfRelatedQuestions"}}]}}]} as unknown as DocumentNode<Analyze_QuestionFragment, unknown>;
export const Analyze_QuestionPicker_QuestionList_AnswerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Analyze_QuestionPicker_QuestionList_Answer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_templateanswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"text_input_type"}}]}}]} as unknown as DocumentNode<Analyze_QuestionPicker_QuestionList_AnswerFragment, unknown>;
export const Analyze_QuestionPicker_QuestionList_QuestionDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Analyze_QuestionPicker_QuestionList_QuestionDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_question"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_Question"}},{"kind":"Field","name":{"kind":"Name","value":"multiple_answers_allowed"}},{"kind":"Field","alias":{"kind":"Name","value":"answer_options_with_details"},"name":{"kind":"Name","value":"template_answer_set"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_QuestionPicker_QuestionList_Answer"}}]}}]}}]}}]} as unknown as DocumentNode<Analyze_QuestionPicker_QuestionList_QuestionDetailsFragment, unknown>;
export const Analyze_QuestionPicker_QuestionList_QuestionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Analyze_QuestionPicker_QuestionList_Question"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_question"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_QuestionPicker_QuestionList_QuestionDetails"}},{"kind":"Field","alias":{"kind":"Name","value":"subQuestions"},"name":{"kind":"Name","value":"sub_questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"parentAnswerId"},"name":{"kind":"Name","value":"parent_template_answer_id"}}]}}]}}]} as unknown as DocumentNode<Analyze_QuestionPicker_QuestionList_QuestionFragment, unknown>;
export const Analyze_QuestionPicker_QuestionList_GroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Analyze_QuestionPicker_QuestionList_Group"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"subGroups"},"name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parent_question_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_QuestionPicker_QuestionList_Question"}}]}}]}}]} as unknown as DocumentNode<Analyze_QuestionPicker_QuestionList_GroupFragment, unknown>;
export const Analyze_QuestionPicker_QuestionList_CategoryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Analyze_QuestionPicker_QuestionList_Category"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parent_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_QuestionPicker_QuestionList_Group"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_QuestionPicker_QuestionList_Question"}}]}}]}}]} as unknown as DocumentNode<Analyze_QuestionPicker_QuestionList_CategoryFragment, unknown>;
export const Analyze_RegionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Analyze_Region"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"gis_regions_gis_region"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"geom"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<Analyze_RegionFragment, unknown>;
export const Analyze_SavedQueryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Analyze_SavedQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"analyze_user_query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"target_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}}]}}]} as unknown as DocumentNode<Analyze_SavedQueryFragment, unknown>;
export const ExpertLinkFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExpertLink"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"auth_user"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]} as unknown as DocumentNode<ExpertLinkFragment, unknown>;
export const EntryNameLinkFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryNameLink"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_entityname"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<EntryNameLinkFragment, unknown>;
export const EntryContributorsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryContributors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_entity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entry_source"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExpertLink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"progress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"expert_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expert"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExpertLink"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EntryContributorsFragment, unknown>;
export const EntrySourceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntrySource"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_entity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryContributors"}},{"kind":"Field","name":{"kind":"Name","value":"entry_source"}},{"kind":"Field","name":{"kind":"Name","value":"secondary_source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expert_source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExpertLink"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supervisor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExpertLink"}}]}}]}}]}}]} as unknown as DocumentNode<EntrySourceFragment, unknown>;
export const EntryDataSourceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryDataSource"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_entity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"external_url"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_external"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"icon_small"}},{"kind":"Field","name":{"kind":"Name","value":"tooltip"}}]}}]}}]} as unknown as DocumentNode<EntryDataSourceFragment, unknown>;
export const EntriesByAuthor_AuthorEntriesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntriesByAuthor_AuthorEntries"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"auth_user"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entry_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"IntValue","value":"2"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"progress"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryNameLink"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntrySource"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryDataSource"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expert"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries_sourced"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"progress"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryNameLink"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntrySource"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryDataSource"}}]}}]}}]}}]} as unknown as DocumentNode<EntriesByAuthor_AuthorEntriesFragment, unknown>;
export const EntriesByAuthors_AuthorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntriesByAuthors_Author"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"auth_user"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExpertLink"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntriesByAuthor_AuthorEntries"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"institution"}}]}}]}}]} as unknown as DocumentNode<EntriesByAuthors_AuthorFragment, unknown>;
export const EntryPollTypeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryPollType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_entity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"poll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<EntryPollTypeFragment, unknown>;
export const EntryAlternativeNamesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryAlternativeNames"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_entity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"alt_names"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryNameLink"}}]}}]}}]}}]} as unknown as DocumentNode<EntryAlternativeNamesFragment, unknown>;
export const EntryPublicationDateFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryPublicationDate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_entity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date_modified"}}]}}]} as unknown as DocumentNode<EntryPublicationDateFragment, unknown>;
export const EntryPeriodFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryPeriod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_entity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year_from"}},{"kind":"Field","name":{"kind":"Name","value":"year_to"}}]}}]} as unknown as DocumentNode<EntryPeriodFragment, unknown>;
export const EntryRegionTagsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryRegionTags"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_entity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tag"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"level"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"approved"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tag"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EntryRegionTagsFragment, unknown>;
export const EntryTagsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryTags"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_entity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tag"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"level"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"IntValue","value":"2"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"approved"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tag"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"level"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"level"}}]}}]}}]}}]} as unknown as DocumentNode<EntryTagsFragment, unknown>;
export const ListEntriesByPublicationDateFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListEntriesByPublicationDate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entries_by_publication_date"},"name":{"kind":"Name","value":"polls_entity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date_modified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"progress"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date_modified"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryNameLink"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryPollType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryAlternativeNames"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryContributors"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryPublicationDate"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntrySource"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryDataSource"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryPeriod"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryRegionTags"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryTags"}}]}}]}}]} as unknown as DocumentNode<ListEntriesByPublicationDateFragment, unknown>;
export const EntryPublicationDatesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryPublicationDates"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"publication_dates"},"name":{"kind":"Name","value":"polls_entity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"date_modified"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date_modified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"progress"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date_modified"}}]}}]}}]} as unknown as DocumentNode<EntryPublicationDatesFragment, unknown>;
export const EntriesByRegion_RegionEntryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntriesByRegion_RegionEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_entity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryNameLink"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryPollType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryAlternativeNames"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryContributors"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntrySource"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryDataSource"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryPeriod"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryTags"}}]}}]} as unknown as DocumentNode<EntriesByRegion_RegionEntryFragment, unknown>;
export const EntriesByTagsGroup_TagEntryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntriesByTagsGroup_TagEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_entity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryNameLink"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryPollType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryAlternativeNames"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryContributors"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntrySource"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryDataSource"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryPeriod"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryRegionTags"}}]}}]} as unknown as DocumentNode<EntriesByTagsGroup_TagEntryFragment, unknown>;
export const EntriesByTagsGroup_TagsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntriesByTagsGroup_Tags"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tags"},"name":{"kind":"Name","value":"polls_entitytag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"level"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tag_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entries"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entry"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"progress"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}}]}}]},{"kind":"Variable","name":{"kind":"Name","value":"filter"}}]}}]}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<EntriesByTagsGroup_TagsFragment, unknown>;
export const EntrySearch_Entry_PollTypeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntrySearch_Entry_PollType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"poll_type"}}]}}]} as unknown as DocumentNode<EntrySearch_Entry_PollTypeFragment, unknown>;
export const EntrySearch_Entry_AlternativeNamesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntrySearch_Entry_AlternativeNames"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entryId"},"name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"alternative_names"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<EntrySearch_Entry_AlternativeNamesFragment, unknown>;
export const EntrySearch_Entry_ExpertLinkFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntrySearch_Entry_ExpertLink"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<EntrySearch_Entry_ExpertLinkFragment, unknown>;
export const EntrySearch_Entry_ContributorsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntrySearch_Entry_Contributors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entry_source"}},{"kind":"Field","name":{"kind":"Name","value":"contributors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntrySearch_Entry_ExpertLink"}}]}}]}}]} as unknown as DocumentNode<EntrySearch_Entry_ContributorsFragment, unknown>;
export const EntrySearch_Entry_DataSourceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntrySearch_Entry_DataSource"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"external_url"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_external"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"icon_small"}},{"kind":"Field","name":{"kind":"Name","value":"tooltip"}}]}}]}}]} as unknown as DocumentNode<EntrySearch_Entry_DataSourceFragment, unknown>;
export const EntrySearch_Entry_DescriptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntrySearch_Entry_Description"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<EntrySearch_Entry_DescriptionFragment, unknown>;
export const EntrySearch_Entry_PeriodFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntrySearch_Entry_Period"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year_from"}},{"kind":"Field","name":{"kind":"Name","value":"year_to"}}]}}]} as unknown as DocumentNode<EntrySearch_Entry_PeriodFragment, unknown>;
export const EntrySearch_Entry_RegionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntrySearch_Entry_Region"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geometry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"coordinates"}}]}}]}}]}}]} as unknown as DocumentNode<EntrySearch_Entry_RegionFragment, unknown>;
export const EntrySearch_Entry_SourceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntrySearch_Entry_Source"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entry_source"}},{"kind":"Field","name":{"kind":"Name","value":"secondary_source"}},{"kind":"Field","name":{"kind":"Name","value":"expert_source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntrySearch_Entry_ExpertLink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supervised_by"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntrySearch_Entry_ExpertLink"}}]}}]}}]} as unknown as DocumentNode<EntrySearch_Entry_SourceFragment, unknown>;
export const EntrySearch_Entry_TagsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntrySearch_Entry_Tags"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<EntrySearch_Entry_TagsFragment, unknown>;
export const EntrySearch_EntryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntrySearch_Entry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","alias":{"kind":"Name","value":"entryId"},"name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntrySearch_Entry_PollType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntrySearch_Entry_AlternativeNames"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntrySearch_Entry_Contributors"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntrySearch_Entry_DataSource"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntrySearch_Entry_Description"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntrySearch_Entry_Period"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntrySearch_Entry_Region"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntrySearch_Entry_Source"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntrySearch_Entry_Tags"}}]}}]} as unknown as DocumentNode<EntrySearch_EntryFragment, unknown>;
export const EditorConsole_LogInAsEditor_EditorUserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditorConsole_LogInAsEditor_EditorUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"auth_user"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]} as unknown as DocumentNode<EditorConsole_LogInAsEditor_EditorUserFragment, unknown>;
export const EditorConsole_LogInAsEditor_ManagingEditorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditorConsole_LogInAsEditor_ManagingEditor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"accounts_managingeditor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditorConsole_LogInAsEditor_EditorUser"}}]}}]}}]} as unknown as DocumentNode<EditorConsole_LogInAsEditor_ManagingEditorFragment, unknown>;
export const EditorConsole_LogInAsEditor_ManagingEditorListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditorConsole_LogInAsEditor_ManagingEditorList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"managing_editors"},"name":{"kind":"Name","value":"accounts_managingeditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditorConsole_LogInAsEditor_ManagingEditor"}}]}}]}}]} as unknown as DocumentNode<EditorConsole_LogInAsEditor_ManagingEditorListFragment, unknown>;
export const EditorConsole_LogInAsEditor_RegionalEditorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditorConsole_LogInAsEditor_RegionalEditor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"accounts_regionaleditor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditorConsole_LogInAsEditor_EditorUser"}}]}}]}}]} as unknown as DocumentNode<EditorConsole_LogInAsEditor_RegionalEditorFragment, unknown>;
export const EditorConsole_LogInAsEditor_RegionalEditorListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditorConsole_LogInAsEditor_RegionalEditorList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"regional_editors"},"name":{"kind":"Name","value":"accounts_regionaleditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditorConsole_LogInAsEditor_RegionalEditor"}}]}}]}}]} as unknown as DocumentNode<EditorConsole_LogInAsEditor_RegionalEditorListFragment, unknown>;
export const PollDiff_NewQuestionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PollDiff_NewQuestion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PollDiffQuestionWithPath"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"path"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<PollDiff_NewQuestionFragment, unknown>;
export const PollDiffInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PollDiffInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PollDiff"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"poll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prev_poll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"new_questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated_questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PollDiffInfoFragment, unknown>;
export const PollDiff_UpdatedQuestionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PollDiff_UpdatedQuestion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PollDiffUpdatedQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"previous"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"path"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<PollDiff_UpdatedQuestionFragment, unknown>;
export const AnswerInputFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AnswerInput"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_templateanswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text_input_type"}}]}}]} as unknown as DocumentNode<AnswerInputFragment, unknown>;
export const LandingPollQuestionDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LandingPollQuestionDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_question"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"multiple_answers_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"template_answer_set"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnswerInput"}}]}}]}}]}}]} as unknown as DocumentNode<LandingPollQuestionDetailsFragment, unknown>;
export const LandingPollQuestionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LandingPollQuestion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_question"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LandingPollQuestionDetails"}},{"kind":"Field","name":{"kind":"Name","value":"sub_questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LandingPollQuestionDetails"}},{"kind":"Field","name":{"kind":"Name","value":"parent_template_answer_id"}},{"kind":"Field","name":{"kind":"Name","value":"sub_questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LandingPollQuestionDetails"}},{"kind":"Field","name":{"kind":"Name","value":"parent_template_answer_id"}}]}}]}}]}}]} as unknown as DocumentNode<LandingPollQuestionFragment, unknown>;
export const LandingPollGroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LandingPollGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parent_question_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LandingPollQuestion"}}]}}]}}]} as unknown as DocumentNode<LandingPollGroupFragment, unknown>;
export const LandingPollCategoryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LandingPollCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parent_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LandingPollGroup"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LandingPollGroup"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LandingPollQuestion"}}]}}]}}]} as unknown as DocumentNode<LandingPollCategoryFragment, unknown>;
export const MediaLibrary_Shared_MediaObjectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MediaLibrary_Shared_MediaObject"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"user_file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"date_created"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}}]}}]} as unknown as DocumentNode<MediaLibrary_Shared_MediaObjectFragment, unknown>;
export const MediaLibrary_Entities_Attachment_AttachmentOwnerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MediaLibrary_Entities_Attachment_AttachmentOwner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"auth_user"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]} as unknown as DocumentNode<MediaLibrary_Entities_Attachment_AttachmentOwnerFragment, unknown>;
export const MediaLibrary_Entities_Attachment_GeneralEntryAttachmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MediaLibrary_Entities_Attachment_GeneralEntryAttachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_entry_attachment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"date_created"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MediaLibrary_Shared_MediaObject"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MediaLibrary_Entities_Attachment_AttachmentOwner"}}]}}]}}]}}]} as unknown as DocumentNode<MediaLibrary_Entities_Attachment_GeneralEntryAttachmentFragment, unknown>;
export const MediaLibrary_Entities_Attachment_AnswerAttachmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MediaLibrary_Entities_Attachment_AnswerAttachment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_answer_set_attachment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"date_created"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MediaLibrary_Shared_MediaObject"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MediaLibrary_Entities_Attachment_AttachmentOwner"}}]}}]}}]}}]} as unknown as DocumentNode<MediaLibrary_Entities_Attachment_AnswerAttachmentFragment, unknown>;
export const MediaLibrary_Widgets_AttachmentManager_QuestionWithAttachmentsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MediaLibrary_Widgets_AttachmentManager_QuestionWithAttachments"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_question"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ancestors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"base_answer_sets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entry_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entryId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"base_answer_sets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entry_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entryId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attachments"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"answer_sets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attachments"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date_created"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MediaLibrary_Entities_Attachment_AnswerAttachment"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MediaLibrary_Widgets_AttachmentManager_QuestionWithAttachmentsFragment, unknown>;
export const EntryTagGroupsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryTagGroups"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entry_tag_groups"},"name":{"kind":"Name","value":"polls_entrytaggroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<EntryTagGroupsFragment, unknown>;
export const RelatedQuestionBaseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelatedQuestionBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_question"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"poll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent_question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<RelatedQuestionBaseFragment, unknown>;
export const RelatedQuestionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelatedQuestion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_question"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelatedQuestionBase"}},{"kind":"Field","name":{"kind":"Name","value":"related_question_ids_1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"second_question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelatedQuestionBase"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"related_question_ids_2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelatedQuestionBase"}}]}}]}}]}}]} as unknown as DocumentNode<RelatedQuestionFragment, unknown>;
export const QuestionDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"questionDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_question"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"multiple_answers_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"template_answer_set"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnswerInput"}}]}}]}}]}}]} as unknown as DocumentNode<QuestionDetailsFragment, unknown>;
export const QuestionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"question"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_question"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"questionDetails"}},{"kind":"Field","name":{"kind":"Name","value":"sub_questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"questionDetails"}},{"kind":"Field","name":{"kind":"Name","value":"parent_template_answer_id"}},{"kind":"Field","name":{"kind":"Name","value":"sub_questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"questionDetails"}},{"kind":"Field","name":{"kind":"Name","value":"parent_template_answer_id"}}]}}]}}]}}]} as unknown as DocumentNode<QuestionFragment, unknown>;
export const QuestionDetailsDuplicateFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"questionDetailsDuplicate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_question"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"multiple_answers_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"is_priority"}},{"kind":"Field","name":{"kind":"Name","value":"template_answer_set_id"}}]}}]} as unknown as DocumentNode<QuestionDetailsDuplicateFragment, unknown>;
export const QuestionDuplicateFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"questionDuplicate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_question"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"questionDetailsDuplicate"}},{"kind":"Field","name":{"kind":"Name","value":"sub_questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"questionDetailsDuplicate"}},{"kind":"Field","name":{"kind":"Name","value":"parent_template_answer_id"}},{"kind":"Field","name":{"kind":"Name","value":"sub_questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"questionDetailsDuplicate"}},{"kind":"Field","name":{"kind":"Name","value":"parent_template_answer_id"}}]}}]}}]}}]} as unknown as DocumentNode<QuestionDuplicateFragment, unknown>;
export const PollManager_Polls_PollFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PollManager_Polls_Poll"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_poll"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"is_disabled"}},{"kind":"Field","name":{"kind":"Name","value":"date_created"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"entries_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translation_progress"}},{"kind":"Field","name":{"kind":"Name","value":"next"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"next_draft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PollManager_Polls_PollFragment, unknown>;
export const EntryProgressFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryProgress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_entity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_id"}},{"kind":"Field","name":{"kind":"Name","value":"date_modified"}},{"kind":"Field","name":{"kind":"Name","value":"progress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expert"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"answered"}},{"kind":"Field","name":{"kind":"Name","value":"additional_total"}},{"kind":"Field","name":{"kind":"Name","value":"additional_answered"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"draft"}},{"kind":"Field","name":{"kind":"Name","value":"category_progress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"category"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"answered"}},{"kind":"Field","name":{"kind":"Name","value":"additional_total"}},{"kind":"Field","name":{"kind":"Name","value":"additional_answered"}}]}},{"kind":"Field","name":{"kind":"Name","value":"considered_answer_sets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"answer_sets_aggregate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"max"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date_published"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"base_answer_set"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answer_sets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date_published"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EntryProgressFragment, unknown>;
export const PublicProfile_Contributions_EntryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicProfile_Contributions_Entry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"polls_entity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryProgress"}}]}}]} as unknown as DocumentNode<PublicProfile_Contributions_EntryFragment, unknown>;
export const PublicProfile_ContributionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicProfile_Contributions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"auth_user"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"progress"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicProfile_Contributions_Entry"}}]}}]}}]} as unknown as DocumentNode<PublicProfile_ContributionsFragment, unknown>;
export const PublicProfile_Profile_InterestsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicProfile_Profile_Interests"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"accounts_profile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interests"}}]}}]} as unknown as DocumentNode<PublicProfile_Profile_InterestsFragment, unknown>;
export const PublicProfile_Profile_RoleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicProfile_Profile_Role"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"auth_user"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"managing_editor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"regional_editor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<PublicProfile_Profile_RoleFragment, unknown>;
export const PublicProfile_ProfileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicProfile_Profile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"auth_user"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withEmail"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"occupation"}},{"kind":"Field","name":{"kind":"Name","value":"institution"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"area_of_research"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"websites"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"biography"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicProfile_Profile_Interests"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicProfile_Profile_Role"}}]}}]} as unknown as DocumentNode<PublicProfile_ProfileFragment, unknown>;
export const SignUp_SignUpForm_EditorSelect_EditorUserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SignUp_SignUpForm_EditorSelect_EditorUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"auth_user"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"institution"}}]}}]}}]} as unknown as DocumentNode<SignUp_SignUpForm_EditorSelect_EditorUserFragment, unknown>;
export const SignUp_SignUpForm_EditorSelect_RegionalEditorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SignUp_SignUpForm_EditorSelect_RegionalEditor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"accounts_regionaleditorcategory_editors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regional_editor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SignUp_SignUpForm_EditorSelect_EditorUser"}}]}}]}}]}}]} as unknown as DocumentNode<SignUp_SignUpForm_EditorSelect_RegionalEditorFragment, unknown>;
export const SignUp_SignUpForm_EditorList_ExternalEditorListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SignUp_SignUpForm_EditorList_ExternalEditorList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"external_editor_categories"},"name":{"kind":"Name","value":"accounts_regionaleditorcategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"regional_editors"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"regional_editor"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_external"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"regional_editors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_value"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SignUp_SignUpForm_EditorSelect_RegionalEditor"}}]}}]}}]}}]} as unknown as DocumentNode<SignUp_SignUpForm_EditorList_ExternalEditorListFragment, unknown>;
export const SignUp_SignUpForm_EditorSelect_ManagingEditorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SignUp_SignUpForm_EditorSelect_ManagingEditor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"accounts_managingeditor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SignUp_SignUpForm_EditorSelect_EditorUser"}}]}}]}}]} as unknown as DocumentNode<SignUp_SignUpForm_EditorSelect_ManagingEditorFragment, unknown>;
export const SignUp_SignUpForm_EditorList_ManagingEditorListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SignUp_SignUpForm_EditorList_ManagingEditorList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts_managingeditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SignUp_SignUpForm_EditorSelect_ManagingEditor"}}]}}]}}]} as unknown as DocumentNode<SignUp_SignUpForm_EditorList_ManagingEditorListFragment, unknown>;
export const SignUp_SignUpForm_EditorList_RegionalEditorListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SignUp_SignUpForm_EditorList_RegionalEditorList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"regional_editor_categories"},"name":{"kind":"Name","value":"accounts_regionaleditorcategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"regional_editors"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"regional_editor"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_external"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"regional_editors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_value"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SignUp_SignUpForm_EditorSelect_RegionalEditor"}}]}}]}}]}}]} as unknown as DocumentNode<SignUp_SignUpForm_EditorList_RegionalEditorListFragment, unknown>;
export const AcceptTermsOfUseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcceptTermsOfUse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expertId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_accounts_expert_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expertId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"confirmed_agreement"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmed_agreement"}}]}}]}}]} as unknown as DocumentNode<AcceptTermsOfUseMutation, AcceptTermsOfUseMutationVariables>;
export const Analyze_BarChart_AnswersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Analyze_BarChart_Answers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeSecondVariable"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeThirdVariable"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeFourthVariable"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeFifthVariable"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstVariableBoolExp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_answer_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"secondVariableBoolExp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_answer_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thirdVariableBoolExp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_answer_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fourthVariableBoolExp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_answer_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fifthVariableBoolExp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_answer_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_BarChart_FirstVariable_AnswersQuery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_BarChart_SecondVariable_AnswersQuery"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeSecondVariable"}}}]}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_BarChart_ThirdVariable_AnswersQuery"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeThirdVariable"}}}]}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_BarChart_FourthVariable_AnswersQuery"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeFourthVariable"}}}]}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_BarChart_FifthVariable_AnswersQuery"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeFifthVariable"}}}]}]}]}},...Analyze_BarChart_FirstVariable_AnswersQueryFragmentDoc.definitions,...Analyze_AnswerFragmentDoc.definitions,...Analyze_BarChart_SecondVariable_AnswersQueryFragmentDoc.definitions,...Analyze_BarChart_ThirdVariable_AnswersQueryFragmentDoc.definitions,...Analyze_BarChart_FourthVariable_AnswersQueryFragmentDoc.definitions,...Analyze_BarChart_FifthVariable_AnswersQueryFragmentDoc.definitions]} as unknown as DocumentNode<Analyze_BarChart_AnswersQuery, Analyze_BarChart_AnswersQueryVariables>;
export const Analyze_CsvExportTool_DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Analyze_CsvExportTool_Data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeSecondVariable"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeThirdVariable"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeFourthVariable"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeFifthVariable"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstVariableBoolExp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_answer_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"secondVariableBoolExp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_answer_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"thirdVariableBoolExp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_answer_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fourthVariableBoolExp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_answer_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fifthVariableBoolExp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_answer_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataOrderExp"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_answer_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includePollId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includePollName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeEntryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeEntryName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeEntryDataSource"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeEntryDescription"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeEntryTags"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeQuestionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeQuestionText"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeQuestionDescription"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeParentQuestionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeParentQuestionText"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeAnswerText"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeAnswerValue"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeAnswerData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeParentAnswerText"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeParentAnswerValue"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeNotes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeBranchingQuestion"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeYearRange"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeRegionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeRegionName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeRegionDescription"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeRegionTags"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeExpertId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeExpertName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_CsvExportTool_FirstVariable"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_CsvExportTool_SecondVariable"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeSecondVariable"}}}]}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_CsvExportTool_ThirdVariable"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeThirdVariable"}}}]}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_CsvExportTool_FourthVariable"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeFourthVariable"}}}]}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_CsvExportTool_FifthVariable"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeFifthVariable"}}}]}]}]}},...Analyze_CsvExportTool_FirstVariableFragmentDoc.definitions,...Analyze_CsvExportTool_DatumFragmentDoc.definitions,...Analyze_CsvExportTool_SecondVariableFragmentDoc.definitions,...Analyze_CsvExportTool_ThirdVariableFragmentDoc.definitions,...Analyze_CsvExportTool_FourthVariableFragmentDoc.definitions,...Analyze_CsvExportTool_FifthVariableFragmentDoc.definitions]} as unknown as DocumentNode<Analyze_CsvExportTool_DataQuery, Analyze_CsvExportTool_DataQueryVariables>;
export const Analyze_EntrySearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Analyze_EntrySearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entry_search"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"highlight"}},{"kind":"Field","name":{"kind":"Name","value":"entry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_Entry"}}]}}]}}]}}]}},...Analyze_EntryFragmentDoc.definitions]} as unknown as DocumentNode<Analyze_EntrySearchQuery, Analyze_EntrySearchQueryVariables>;
export const Analyze_EntryAnswersComparison_QuestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Analyze_EntryAnswersComparison_Questions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"baseAnswerSetBoolExp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_baseanswerset_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_question"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_sets"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseAnswerSetBoolExp"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"base_answer_sets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseAnswerSetBoolExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entry_id"}},{"kind":"Field","name":{"kind":"Name","value":"answers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"template_answer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"text_input"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"template_answer_set"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"multiple_answers_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"related_question_ids_1"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"second_question"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_sets"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseAnswerSetBoolExp"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"second_question_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"related_question_ids_2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first_question"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_sets"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseAnswerSetBoolExp"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_question_id"}}]}}]}}]}}]} as unknown as DocumentNode<Analyze_EntryAnswersComparison_QuestionsQuery, Analyze_EntryAnswersComparison_QuestionsQueryVariables>;
export const Analyze_QuestionAnswersComparison_EntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Analyze_QuestionAnswersComparison_Entries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"baseAnswerSetBoolExp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_baseanswerset_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_entity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_sets"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseAnswerSetBoolExp"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"year_from"}},{"kind":"Field","name":{"kind":"Name","value":"year_to"}},{"kind":"Field","name":{"kind":"Name","value":"base_answer_sets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseAnswerSetBoolExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question_id"}},{"kind":"Field","name":{"kind":"Name","value":"answers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"template_answer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"text_input"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Analyze_QuestionAnswersComparison_EntriesQuery, Analyze_QuestionAnswersComparison_EntriesQueryVariables>;
export const Analyze_QuestionPicker_PollsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Analyze_QuestionPicker_Polls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_poll"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entries"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"progress"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date_created"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Analyze_QuestionPicker_PollsQuery, Analyze_QuestionPicker_PollsQueryVariables>;
export const Analyze_QuestionPicker_QuestionList_SubGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Analyze_QuestionPicker_QuestionList_SubGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"subGroups"},"name":{"kind":"Name","value":"polls_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parent_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_QuestionPicker_QuestionList_Group"}}]}}]}},...Analyze_QuestionPicker_QuestionList_GroupFragmentDoc.definitions,...Analyze_QuestionPicker_QuestionList_QuestionFragmentDoc.definitions,...Analyze_QuestionPicker_QuestionList_QuestionDetailsFragmentDoc.definitions,...Analyze_QuestionFragmentDoc.definitions,...Analyze_Question_PollFragmentDoc.definitions,...Analyze_Question_QuestionAnswerOptionListFragmentDoc.definitions,...Analyze_Question_QuestionAnswerOptionFragmentDoc.definitions,...Analyze_Question_ListOfRelatedQuestionsFragmentDoc.definitions,...Analyze_Question_RelatedQuestionFragmentDoc.definitions,...Analyze_QuestionPicker_QuestionList_AnswerFragmentDoc.definitions]} as unknown as DocumentNode<Analyze_QuestionPicker_QuestionList_SubGroupQuery, Analyze_QuestionPicker_QuestionList_SubGroupQueryVariables>;
export const Analyze_QuestionPicker_QuestionListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Analyze_QuestionPicker_QuestionList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pollId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"poll"},"name":{"kind":"Name","value":"polls_poll_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pollId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_QuestionPicker_QuestionList_Category"}}]}}]}}]}},...Analyze_QuestionPicker_QuestionList_CategoryFragmentDoc.definitions,...Analyze_QuestionPicker_QuestionList_GroupFragmentDoc.definitions,...Analyze_QuestionPicker_QuestionList_QuestionFragmentDoc.definitions,...Analyze_QuestionPicker_QuestionList_QuestionDetailsFragmentDoc.definitions,...Analyze_QuestionFragmentDoc.definitions,...Analyze_Question_PollFragmentDoc.definitions,...Analyze_Question_QuestionAnswerOptionListFragmentDoc.definitions,...Analyze_Question_QuestionAnswerOptionFragmentDoc.definitions,...Analyze_Question_ListOfRelatedQuestionsFragmentDoc.definitions,...Analyze_Question_RelatedQuestionFragmentDoc.definitions,...Analyze_QuestionPicker_QuestionList_AnswerFragmentDoc.definitions]} as unknown as DocumentNode<Analyze_QuestionPicker_QuestionListQuery, Analyze_QuestionPicker_QuestionListQueryVariables>;
export const Analyze_QuestionPicker_SubQuestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Analyze_QuestionPicker_SubQuestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"questionIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"subQuestions"},"name":{"kind":"Name","value":"polls_question"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"questionIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_QuestionPicker_QuestionList_Question"}}]}}]}},...Analyze_QuestionPicker_QuestionList_QuestionFragmentDoc.definitions,...Analyze_QuestionPicker_QuestionList_QuestionDetailsFragmentDoc.definitions,...Analyze_QuestionFragmentDoc.definitions,...Analyze_Question_PollFragmentDoc.definitions,...Analyze_Question_QuestionAnswerOptionListFragmentDoc.definitions,...Analyze_Question_QuestionAnswerOptionFragmentDoc.definitions,...Analyze_Question_ListOfRelatedQuestionsFragmentDoc.definitions,...Analyze_Question_RelatedQuestionFragmentDoc.definitions,...Analyze_QuestionPicker_QuestionList_AnswerFragmentDoc.definitions]} as unknown as DocumentNode<Analyze_QuestionPicker_SubQuestionsQuery, Analyze_QuestionPicker_SubQuestionsQueryVariables>;
export const Analyze_QuestionSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Analyze_QuestionSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question_search"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"highlight"}},{"kind":"Field","name":{"kind":"Name","value":"question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_Question"}}]}}]}}]}}]}},...Analyze_QuestionFragmentDoc.definitions,...Analyze_Question_PollFragmentDoc.definitions,...Analyze_Question_QuestionAnswerOptionListFragmentDoc.definitions,...Analyze_Question_QuestionAnswerOptionFragmentDoc.definitions,...Analyze_Question_ListOfRelatedQuestionsFragmentDoc.definitions,...Analyze_Question_RelatedQuestionFragmentDoc.definitions]} as unknown as DocumentNode<Analyze_QuestionSearchQuery, Analyze_QuestionSearchQueryVariables>;
export const Analyze_RegionSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Analyze_RegionSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"region_search"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"highlight"}}]}}]}}]}}]} as unknown as DocumentNode<Analyze_RegionSearchQuery, Analyze_RegionSearchQueryVariables>;
export const Analyze_DeleteSavedQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Analyze_DeleteSavedQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_analyze_user_query_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Analyze_DeleteSavedQueryMutation, Analyze_DeleteSavedQueryMutationVariables>;
export const Analyze_PublishSavedQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Analyze_PublishSavedQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_analyze_user_query_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Analyze_PublishSavedQueryMutation, Analyze_PublishSavedQueryMutationVariables>;
export const Analyze_SaveQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Analyze_SaveQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_analyze_user_query_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"target_timestamp"},"value":{"kind":"StringValue","value":"now()","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"payload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payload"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Analyze_SaveQueryMutation, Analyze_SaveQueryMutationVariables>;
export const Analyze_SavedQueryDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Analyze_SavedQueryData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"questionIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entryIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"regionIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"questions"},"name":{"kind":"Name","value":"polls_question"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"questionIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_Question"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"entries"},"name":{"kind":"Name","value":"polls_entity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entryIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_Entry"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"regions"},"name":{"kind":"Name","value":"gis_regions_gis_region"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"regionIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_Region"}}]}}]}},...Analyze_QuestionFragmentDoc.definitions,...Analyze_Question_PollFragmentDoc.definitions,...Analyze_Question_QuestionAnswerOptionListFragmentDoc.definitions,...Analyze_Question_QuestionAnswerOptionFragmentDoc.definitions,...Analyze_Question_ListOfRelatedQuestionsFragmentDoc.definitions,...Analyze_Question_RelatedQuestionFragmentDoc.definitions,...Analyze_EntryFragmentDoc.definitions,...Analyze_RegionFragmentDoc.definitions]} as unknown as DocumentNode<Analyze_SavedQueryDataQuery, Analyze_SavedQueryDataQueryVariables>;
export const Analyze_SavedQueriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Analyze_SavedQueries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"analyze_user_query"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_SavedQuery"}}]}}]}},...Analyze_SavedQueryFragmentDoc.definitions]} as unknown as DocumentNode<Analyze_SavedQueriesQuery, Analyze_SavedQueriesQueryVariables>;
export const Analyze_SavedQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Analyze_SavedQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"analyze_user_query_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_SavedQuery"}}]}}]}},...Analyze_SavedQueryFragmentDoc.definitions]} as unknown as DocumentNode<Analyze_SavedQueryQuery, Analyze_SavedQueryQueryVariables>;
export const Analyze_UpdateSavedQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Analyze_UpdateSavedQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_analyze_user_query_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"payload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payload"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"StringValue","value":"now()","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"target_timestamp"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Analyze_UpdateSavedQueryMutation, Analyze_UpdateSavedQueryMutationVariables>;
export const Analyze_ScatterPlot_SingleVariableChartDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Analyze_ScatterPlot_SingleVariableChartData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variableBoolExp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_answer_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_answer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variableBoolExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_Answer"}}]}}]}},...Analyze_AnswerFragmentDoc.definitions]} as unknown as DocumentNode<Analyze_ScatterPlot_SingleVariableChartDataQuery, Analyze_ScatterPlot_SingleVariableChartDataQueryVariables>;
export const Analyze_ScatterPlot_TwoVariablesChartDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Analyze_ScatterPlot_TwoVariablesChartData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dependentVariableBoolExp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_answer_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"independentVariableBoolExp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_answer_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"dependentVariable"},"name":{"kind":"Name","value":"polls_answer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dependentVariableBoolExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_Answer"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"independentVariable"},"name":{"kind":"Name","value":"polls_answer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"independentVariableBoolExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_Answer"}}]}}]}},...Analyze_AnswerFragmentDoc.definitions]} as unknown as DocumentNode<Analyze_ScatterPlot_TwoVariablesChartDataQuery, Analyze_ScatterPlot_TwoVariablesChartDataQueryVariables>;
export const Analyze_Timeline_AnswersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Analyze_Timeline_Answers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variableBoolExp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_answer_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_answer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variableBoolExp"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"year_from"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Analyze_Answer"}}]}}]}},...Analyze_AnswerFragmentDoc.definitions]} as unknown as DocumentNode<Analyze_Timeline_AnswersQuery, Analyze_Timeline_AnswersQueryVariables>;
export const PollIdQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PollIdQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entry"},"name":{"kind":"Name","value":"polls_entity_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entryId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"next"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"poll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previous"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<PollIdQueryQuery, PollIdQueryQueryVariables>;
export const UserLastLoginQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserLastLoginQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"user"},"name":{"kind":"Name","value":"auth_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"last_login"}}]}}]}}]} as unknown as DocumentNode<UserLastLoginQueryQuery, UserLastLoginQueryQueryVariables>;
export const EntryFilter_PollsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EntryFilter_Polls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_poll"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entries"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"progress"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}}]}}]}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"is_external"}}]}}]}}]} as unknown as DocumentNode<EntryFilter_PollsQuery, EntryFilter_PollsQueryVariables>;
export const Browse_ExpertsWithEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Browse_ExpertsWithEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts_expert"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"last_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entry_summary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"related_entries_count"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entries"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"progress"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}}]}}]}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entries_sourced"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"progress"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}}]}}]}]}}]}}]}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries_sourced_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"progress"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entry_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"IntValue","value":"2"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"progress"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntriesByAuthors_Author"}}]}}]}}]}},...EntriesByAuthors_AuthorFragmentDoc.definitions,...ExpertLinkFragmentDoc.definitions,...EntriesByAuthor_AuthorEntriesFragmentDoc.definitions,...EntryNameLinkFragmentDoc.definitions,...EntrySourceFragmentDoc.definitions,...EntryContributorsFragmentDoc.definitions,...EntryDataSourceFragmentDoc.definitions]} as unknown as DocumentNode<Browse_ExpertsWithEntriesQuery, Browse_ExpertsWithEntriesQueryVariables>;
export const Browse_EntriesByPublicationDateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Browse_EntriesByPublicationDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryPublicationDates"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListEntriesByPublicationDate"}}]}},...EntryPublicationDatesFragmentDoc.definitions,...ListEntriesByPublicationDateFragmentDoc.definitions,...EntryNameLinkFragmentDoc.definitions,...EntryPollTypeFragmentDoc.definitions,...EntryAlternativeNamesFragmentDoc.definitions,...EntryContributorsFragmentDoc.definitions,...ExpertLinkFragmentDoc.definitions,...EntryPublicationDateFragmentDoc.definitions,...EntrySourceFragmentDoc.definitions,...EntryDataSourceFragmentDoc.definitions,...EntryPeriodFragmentDoc.definitions,...EntryRegionTagsFragmentDoc.definitions,...EntryTagsFragmentDoc.definitions]} as unknown as DocumentNode<Browse_EntriesByPublicationDateQuery, Browse_EntriesByPublicationDateQueryVariables>;
export const Browse_EntriesByRegionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Browse_EntriesByRegion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_entity_order_by"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_entity_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_entity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"progress"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}}]}}]},{"kind":"Variable","name":{"kind":"Name","value":"filter"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tag"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"approved"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"level"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"1"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"level"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}}]}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parent_tag_id"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntriesByRegion_RegionEntry"}}]}}]}},...EntriesByRegion_RegionEntryFragmentDoc.definitions,...EntryNameLinkFragmentDoc.definitions,...EntryPollTypeFragmentDoc.definitions,...EntryAlternativeNamesFragmentDoc.definitions,...EntryContributorsFragmentDoc.definitions,...ExpertLinkFragmentDoc.definitions,...EntrySourceFragmentDoc.definitions,...EntryDataSourceFragmentDoc.definitions,...EntryPeriodFragmentDoc.definitions,...EntryTagsFragmentDoc.definitions]} as unknown as DocumentNode<Browse_EntriesByRegionQuery, Browse_EntriesByRegionQueryVariables>;
export const Browse_EntriesByTagsGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Browse_EntriesByTagsGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_entity_order_by"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_entity_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntriesByTagsGroup_Tags"}},{"kind":"Field","name":{"kind":"Name","value":"polls_entity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tags"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tag"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tag_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"level"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}}]}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"progress"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}}]}}]},{"kind":"Variable","name":{"kind":"Name","value":"filter"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntriesByTagsGroup_TagEntry"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tag"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"level"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tag_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}]}}]}}]}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"level"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},...EntriesByTagsGroup_TagsFragmentDoc.definitions,...EntriesByTagsGroup_TagEntryFragmentDoc.definitions,...EntryNameLinkFragmentDoc.definitions,...EntryPollTypeFragmentDoc.definitions,...EntryAlternativeNamesFragmentDoc.definitions,...EntryContributorsFragmentDoc.definitions,...ExpertLinkFragmentDoc.definitions,...EntrySourceFragmentDoc.definitions,...EntryDataSourceFragmentDoc.definitions,...EntryPeriodFragmentDoc.definitions,...EntryRegionTagsFragmentDoc.definitions]} as unknown as DocumentNode<Browse_EntriesByTagsGroupQuery, Browse_EntriesByTagsGroupQueryVariables>;
export const EntrySearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EntrySearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"size"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entry_search_connection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"size"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntrySearch_Entry"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}},...EntrySearch_EntryFragmentDoc.definitions,...EntrySearch_Entry_PollTypeFragmentDoc.definitions,...EntrySearch_Entry_AlternativeNamesFragmentDoc.definitions,...EntrySearch_Entry_ContributorsFragmentDoc.definitions,...EntrySearch_Entry_ExpertLinkFragmentDoc.definitions,...EntrySearch_Entry_DataSourceFragmentDoc.definitions,...EntrySearch_Entry_DescriptionFragmentDoc.definitions,...EntrySearch_Entry_PeriodFragmentDoc.definitions,...EntrySearch_Entry_RegionFragmentDoc.definitions,...EntrySearch_Entry_SourceFragmentDoc.definitions,...EntrySearch_Entry_TagsFragmentDoc.definitions]} as unknown as DocumentNode<EntrySearchQuery, EntrySearchQueryVariables>;
export const EntryTagGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EntryTagGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_entrytaggroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tags"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"level"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entries"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entry"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"progress"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}}]}}]}]}}]}}]}}]}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<EntryTagGroupQuery, EntryTagGroupQueryVariables>;
export const CommentedEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CommentedEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expertId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_entity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"comment"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expert_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expertId"}}}]}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date_modified"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date_modified"}},{"kind":"Field","alias":{"kind":"Name","value":"affirmations"},"name":{"kind":"Name","value":"base_answer_sets_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"comment"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expert_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expertId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"comment_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"1"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"challenges"},"name":{"kind":"Name","value":"base_answer_sets_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"comment"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expert_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expertId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"comment_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"neutral"},"name":{"kind":"Name","value":"base_answer_sets_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"comment"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expert_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expertId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"comment_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"3"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CommentedEntriesQuery, CommentedEntriesQueryVariables>;
export const EntriesProgressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EntriesProgress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_entity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_by_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"progress"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expert"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"answered"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date_modified"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryProgress"}},{"kind":"Field","name":{"kind":"Name","value":"poll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"next"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},...EntryProgressFragmentDoc.definitions]} as unknown as DocumentNode<EntriesProgressQuery, EntriesProgressQueryVariables>;
export const ProfileInterestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfileInterests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"user"},"name":{"kind":"Name","value":"auth_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interests"}}]}}]}}]}}]} as unknown as DocumentNode<ProfileInterestsQuery, ProfileInterestsQueryVariables>;
export const SuggestedPollsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SuggestedPolls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tagsQuery"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_entity_tags_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_entity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tags"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagsQuery"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date_modified"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date_modified"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_id"}},{"kind":"Field","name":{"kind":"Name","value":"progress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expert"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SuggestedPollsQuery, SuggestedPollsQueryVariables>;
export const AssignedEditorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AssignedEditor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expertId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts_expert_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expertId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regionaleditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editor_email"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"managingeditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editor_email"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AssignedEditorQuery, AssignedEditorQueryVariables>;
export const EditorConsole_LogInAsEditor_EditorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EditorConsole_LogInAsEditor_Editors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditorConsole_LogInAsEditor_ManagingEditorList"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditorConsole_LogInAsEditor_RegionalEditorList"}}]}},...EditorConsole_LogInAsEditor_ManagingEditorListFragmentDoc.definitions,...EditorConsole_LogInAsEditor_ManagingEditorFragmentDoc.definitions,...EditorConsole_LogInAsEditor_EditorUserFragmentDoc.definitions,...EditorConsole_LogInAsEditor_RegionalEditorListFragmentDoc.definitions,...EditorConsole_LogInAsEditor_RegionalEditorFragmentDoc.definitions]} as unknown as DocumentNode<EditorConsole_LogInAsEditor_EditorsQuery, EditorConsole_LogInAsEditor_EditorsQueryVariables>;
export const EntryForUpgradeQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EntryForUpgradeQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_entity_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entryId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"poll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"next"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EntryForUpgradeQueryQuery, EntryForUpgradeQueryQueryVariables>;
export const PollDiffQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PollDiffQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pollId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"poll_diff"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pollId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pollId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PollDiffInfo"}},{"kind":"Field","name":{"kind":"Name","value":"new_questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PollDiff_NewQuestion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated_questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PollDiff_UpdatedQuestion"}}]}}]}}]}},...PollDiffInfoFragmentDoc.definitions,...PollDiff_NewQuestionFragmentDoc.definitions,...PollDiff_UpdatedQuestionFragmentDoc.definitions]} as unknown as DocumentNode<PollDiffQueryQuery, PollDiffQueryQueryVariables>;
export const UpgradeEntryPollDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpgradeEntryPoll"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upgrade_entry_poll"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entry_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entryId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"next_entry_id"}}]}}]}}]} as unknown as DocumentNode<UpgradeEntryPollMutation, UpgradeEntryPollMutationVariables>;
export const OverviewOfPollsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OverviewOfPolls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_entrytaggroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"polls_poll"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date_modified"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"is_external"}},{"kind":"Field","name":{"kind":"Name","value":"entries_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"required_entry_tag_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entrytaggroup_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"optional_entry_tag_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entrytaggroup_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date_modified"}}]}}]}}]} as unknown as DocumentNode<OverviewOfPollsQuery, OverviewOfPollsQueryVariables>;
export const LandingPollDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LandingPoll"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_poll_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"date_modified"}},{"kind":"Field","name":{"kind":"Name","value":"entries_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"required_entry_tag_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entrytaggroup_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"optional_entry_tag_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entrytaggroup_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LandingPollCategory"}}]}}]}}]}},...LandingPollCategoryFragmentDoc.definitions,...LandingPollGroupFragmentDoc.definitions,...LandingPollQuestionFragmentDoc.definitions,...LandingPollQuestionDetailsFragmentDoc.definitions,...AnswerInputFragmentDoc.definitions]} as unknown as DocumentNode<LandingPollQuery, LandingPollQueryVariables>;
export const EntryTagGroupsWithEntryTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EntryTagGroupsWithEntryTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_entrytaggroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"approved"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"parent_tag_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<EntryTagGroupsWithEntryTagsQuery, EntryTagGroupsWithEntryTagsQueryVariables>;
export const MediaLibrary_Entities_Attachment_LiveAnswerAttachmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"MediaLibrary_Entities_Attachment_LiveAnswerAttachments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"answerSetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_answer_set_attachment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"answer_set_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"answerSetId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date_created"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MediaLibrary_Entities_Attachment_AnswerAttachment"}}]}}]}},...MediaLibrary_Entities_Attachment_AnswerAttachmentFragmentDoc.definitions,...MediaLibrary_Shared_MediaObjectFragmentDoc.definitions,...MediaLibrary_Entities_Attachment_AttachmentOwnerFragmentDoc.definitions]} as unknown as DocumentNode<MediaLibrary_Entities_Attachment_LiveAnswerAttachmentsSubscription, MediaLibrary_Entities_Attachment_LiveAnswerAttachmentsSubscriptionVariables>;
export const MediaLibrary_Entities_Attachment_AnswerAttachmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MediaLibrary_Entities_Attachment_AnswerAttachments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"answerSetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_answer_set_attachment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"answer_set_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"answerSetId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date_created"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MediaLibrary_Entities_Attachment_AnswerAttachment"}}]}}]}},...MediaLibrary_Entities_Attachment_AnswerAttachmentFragmentDoc.definitions,...MediaLibrary_Shared_MediaObjectFragmentDoc.definitions,...MediaLibrary_Entities_Attachment_AttachmentOwnerFragmentDoc.definitions]} as unknown as DocumentNode<MediaLibrary_Entities_Attachment_AnswerAttachmentsQuery, MediaLibrary_Entities_Attachment_AnswerAttachmentsQueryVariables>;
export const MediaLibrary_Widgets_AttachmentManager_MediaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"MediaLibrary_Widgets_AttachmentManager_Media"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date_created"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MediaLibrary_Shared_MediaObject"}}]}}]}},...MediaLibrary_Shared_MediaObjectFragmentDoc.definitions]} as unknown as DocumentNode<MediaLibrary_Widgets_AttachmentManager_MediaSubscription, MediaLibrary_Widgets_AttachmentManager_MediaSubscriptionVariables>;
export const MediaLibrary_Entities_Attachment_LiveEntryAttachmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"MediaLibrary_Entities_Attachment_LiveEntryAttachments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"auth_user_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_entry_attachment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entry_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entryId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"file"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userFilter"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date_created"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MediaLibrary_Entities_Attachment_GeneralEntryAttachment"}}]}}]}},...MediaLibrary_Entities_Attachment_GeneralEntryAttachmentFragmentDoc.definitions,...MediaLibrary_Shared_MediaObjectFragmentDoc.definitions,...MediaLibrary_Entities_Attachment_AttachmentOwnerFragmentDoc.definitions]} as unknown as DocumentNode<MediaLibrary_Entities_Attachment_LiveEntryAttachmentsSubscription, MediaLibrary_Entities_Attachment_LiveEntryAttachmentsSubscriptionVariables>;
export const MediaLibrary_Entities_Attachment_GeneralEntryAttachmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MediaLibrary_Entities_Attachment_GeneralEntryAttachments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"auth_user_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_entry_attachment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entry_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entryId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"file"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userFilter"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date_created"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MediaLibrary_Entities_Attachment_GeneralEntryAttachment"}}]}}]}},...MediaLibrary_Entities_Attachment_GeneralEntryAttachmentFragmentDoc.definitions,...MediaLibrary_Shared_MediaObjectFragmentDoc.definitions,...MediaLibrary_Entities_Attachment_AttachmentOwnerFragmentDoc.definitions]} as unknown as DocumentNode<MediaLibrary_Entities_Attachment_GeneralEntryAttachmentsQuery, MediaLibrary_Entities_Attachment_GeneralEntryAttachmentsQueryVariables>;
export const MediaLibrary_Media_DeleteMediaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MediaLibrary_Media_DeleteMedia"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_user_file_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<MediaLibrary_Media_DeleteMediaMutation, MediaLibrary_Media_DeleteMediaMutationVariables>;
export const MediaLibrary_Media_UpdateMediaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MediaLibrary_Media_UpdateMedia"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_user_file_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<MediaLibrary_Media_UpdateMediaMutation, MediaLibrary_Media_UpdateMediaMutationVariables>;
export const MediaLibrary_Features_AttachMedia_AttachMediaToAnswerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MediaLibrary_Features_AttachMedia_AttachMediaToAnswer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"files"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_answer_set_attachment_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_polls_answer_set_attachment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"files"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<MediaLibrary_Features_AttachMedia_AttachMediaToAnswerMutation, MediaLibrary_Features_AttachMedia_AttachMediaToAnswerMutationVariables>;
export const MediaLibrary_Features_AttachMedia_AttachMediaToEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MediaLibrary_Features_AttachMedia_AttachMediaToEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"files"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_entry_attachment_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_polls_entry_attachment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"files"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<MediaLibrary_Features_AttachMedia_AttachMediaToEntryMutation, MediaLibrary_Features_AttachMedia_AttachMediaToEntryMutationVariables>;
export const MediaLibrary_Features_DetachMedia_DetachMediaFromEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MediaLibrary_Features_DetachMedia_DetachMediaFromEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_polls_entry_attachment_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<MediaLibrary_Features_DetachMedia_DetachMediaFromEntryMutation, MediaLibrary_Features_DetachMedia_DetachMediaFromEntryMutationVariables>;
export const MediaLibrary_Features_DetachMedia_DetachMediaFromAnswerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MediaLibrary_Features_DetachMedia_DetachMediaFromAnswer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_polls_answer_set_attachment_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<MediaLibrary_Features_DetachMedia_DetachMediaFromAnswerMutation, MediaLibrary_Features_DetachMedia_DetachMediaFromAnswerMutationVariables>;
export const MediaLibrary_Features_EditAttachment_UpdateAnswerAttachmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MediaLibrary_Features_EditAttachment_UpdateAnswerAttachment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_polls_answer_set_attachment_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<MediaLibrary_Features_EditAttachment_UpdateAnswerAttachmentMutation, MediaLibrary_Features_EditAttachment_UpdateAnswerAttachmentMutationVariables>;
export const MediaLibrary_Features_EditAttachment_UpdateEntryAttachmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MediaLibrary_Features_EditAttachment_UpdateEntryAttachment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_polls_entry_attachment_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<MediaLibrary_Features_EditAttachment_UpdateEntryAttachmentMutation, MediaLibrary_Features_EditAttachment_UpdateEntryAttachmentMutationVariables>;
export const MediaLibrary_Features_UploadFile_AcceptAttachmentConditionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MediaLibrary_Features_UploadFile_AcceptAttachmentConditions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"profile"},"name":{"kind":"Name","value":"update_accounts_profile_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"approved_attachments_conditions"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved_attachments_conditions"}}]}}]}}]} as unknown as DocumentNode<MediaLibrary_Features_UploadFile_AcceptAttachmentConditionsMutation, MediaLibrary_Features_UploadFile_AcceptAttachmentConditionsMutationVariables>;
export const MediaLibrary_Widgets_AttachmentManager_AllEntryAttachmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MediaLibrary_Widgets_AttachmentManager_AllEntryAttachments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_entry_attachment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entry_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entryId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date_created"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MediaLibrary_Entities_Attachment_GeneralEntryAttachment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"polls_question"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entry_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entryId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attachments"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]}}]}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"category"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MediaLibrary_Widgets_AttachmentManager_QuestionWithAttachments"}}]}}]}},...MediaLibrary_Entities_Attachment_GeneralEntryAttachmentFragmentDoc.definitions,...MediaLibrary_Shared_MediaObjectFragmentDoc.definitions,...MediaLibrary_Entities_Attachment_AttachmentOwnerFragmentDoc.definitions,...MediaLibrary_Widgets_AttachmentManager_QuestionWithAttachmentsFragmentDoc.definitions,...MediaLibrary_Entities_Attachment_AnswerAttachmentFragmentDoc.definitions]} as unknown as DocumentNode<MediaLibrary_Widgets_AttachmentManager_AllEntryAttachmentsQuery, MediaLibrary_Widgets_AttachmentManager_AllEntryAttachmentsQueryVariables>;
export const MediaLibrary_Widgets_MediaLibraryManager_MediaListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"MediaLibrary_Widgets_MediaLibraryManager_MediaList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date_created"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MediaLibrary_Shared_MediaObject"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"poll"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date_created"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"poll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}}]}}]}}]}},...MediaLibrary_Shared_MediaObjectFragmentDoc.definitions]} as unknown as DocumentNode<MediaLibrary_Widgets_MediaLibraryManager_MediaListSubscription, MediaLibrary_Widgets_MediaLibraryManager_MediaListSubscriptionVariables>;
export const CreateDraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payload"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"previousPollId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_poll_drafts_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"payload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payload"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"previous_poll_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"previousPollId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateDraftMutation, CreateDraftMutationVariables>;
export const DataForNewDraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DataForNewDraft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_poll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryTagGroups"}}]}},...EntryTagGroupsFragmentDoc.definitions]} as unknown as DocumentNode<DataForNewDraftQuery, DataForNewDraftQueryVariables>;
export const PollNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PollNames"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_poll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<PollNamesQuery, PollNamesQueryVariables>;
export const DeleteDraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_poll_drafts_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteDraftMutation, DeleteDraftMutationVariables>;
export const RelatedQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RelatedQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"questionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_question_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"questionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelatedQuestion"}}]}}]}},...RelatedQuestionFragmentDoc.definitions,...RelatedQuestionBaseFragmentDoc.definitions]} as unknown as DocumentNode<RelatedQuestionQuery, RelatedQuestionQueryVariables>;
export const QuestionSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QuestionSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"usedQuestionIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_question"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_iregex"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usedQuestionIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelatedQuestion"}}]}}]}},...RelatedQuestionFragmentDoc.definitions,...RelatedQuestionBaseFragmentDoc.definitions]} as unknown as DocumentNode<QuestionSearchQuery, QuestionSearchQueryVariables>;
export const PublishDraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PublishDraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publish_poll_draft"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"draft_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<PublishDraftMutation, PublishDraftMutationVariables>;
export const DraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Draft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"poll_drafts_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previous_poll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryTagGroups"}}]}},...EntryTagGroupsFragmentDoc.definitions]} as unknown as DocumentNode<DraftQuery, DraftQueryVariables>;
export const UpdateDraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payload"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_poll_drafts_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"payload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payload"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateDraftMutation, UpdateDraftMutationVariables>;
export const DraftsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Drafts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"poll_drafts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previous_poll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<DraftsQuery, DraftsQueryVariables>;
export const TranslateAnswerClassificationNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TranslateAnswerClassificationName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newValue"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_branchingquestion_set_input"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_polls_branchingquestion_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newValue"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}}]}}]} as unknown as DocumentNode<TranslateAnswerClassificationNameMutation, TranslateAnswerClassificationNameMutationVariables>;
export const TranslateAnswerClassificationClassNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TranslateAnswerClassificationClassName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newValue"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_branch_set_input"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_polls_branch_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newValue"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}}]}}]} as unknown as DocumentNode<TranslateAnswerClassificationClassNameMutation, TranslateAnswerClassificationClassNameMutationVariables>;
export const TranslateAnswerClassificationClassDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TranslateAnswerClassificationClassDescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newValue"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_branch_set_input"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_polls_branch_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newValue"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translated_tooltip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}}]}}]} as unknown as DocumentNode<TranslateAnswerClassificationClassDescriptionMutation, TranslateAnswerClassificationClassDescriptionMutationVariables>;
export const TranslateAnswerTextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TranslateAnswerText"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newValue"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_templateanswer_set_input"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_polls_templateanswer_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newValue"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}}]}}]} as unknown as DocumentNode<TranslateAnswerTextMutation, TranslateAnswerTextMutationVariables>;
export const TranslateCategoryNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TranslateCategoryName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newValue"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_category_set_input"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_polls_category_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newValue"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}}]}}]} as unknown as DocumentNode<TranslateCategoryNameMutation, TranslateCategoryNameMutationVariables>;
export const CategoryTranslationProgressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"CategoryTranslationProgress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_category_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translation_progress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}]}}]}}]} as unknown as DocumentNode<CategoryTranslationProgressSubscription, CategoryTranslationProgressSubscriptionVariables>;
export const TranslatedPollDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TranslatedPoll"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_poll_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"translated_description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"previous"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"translated_description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"branching_questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"previous"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"branches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"tooltip"}},{"kind":"Field","name":{"kind":"Name","value":"translated_tooltip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"previous"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"tooltip"}},{"kind":"Field","name":{"kind":"Name","value":"translated_tooltip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"previous"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parent_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"previous"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"previous"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parent_question_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parent_question_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"polls_question"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"poll_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"translated_description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"previous"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"translated_description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"template_answer_set_id"}},{"kind":"Field","name":{"kind":"Name","value":"multiple_answers_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"sub_questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent_template_answer_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"polls_templateanswerset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"questions"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"poll_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"answers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"previous"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}}]}}]}}]}}]} as unknown as DocumentNode<TranslatedPollQuery, TranslatedPollQueryVariables>;
export const TranslateGroupNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TranslateGroupName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newValue"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_group_set_input"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_polls_group_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newValue"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}}]}}]} as unknown as DocumentNode<TranslateGroupNameMutation, TranslateGroupNameMutationVariables>;
export const GroupTranslationProgressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"GroupTranslationProgress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_group_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translation_progress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}]}}]}}]} as unknown as DocumentNode<GroupTranslationProgressSubscription, GroupTranslationProgressSubscriptionVariables>;
export const TranslatePollNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TranslatePollName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newValue"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_poll_set_input"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_polls_poll_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newValue"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}}]}}]} as unknown as DocumentNode<TranslatePollNameMutation, TranslatePollNameMutationVariables>;
export const TranslatePollDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TranslatePollDescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newValue"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_poll_set_input"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_polls_poll_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newValue"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translated_description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}}]}}]} as unknown as DocumentNode<TranslatePollDescriptionMutation, TranslatePollDescriptionMutationVariables>;
export const PollTranslationProgressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"PollTranslationProgress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_poll_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translation_progress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}]}}]}}]} as unknown as DocumentNode<PollTranslationProgressSubscription, PollTranslationProgressSubscriptionVariables>;
export const TranslateQuestionTextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TranslateQuestionText"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newValue"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_question_set_input"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_polls_question_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newValue"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}}]}}]} as unknown as DocumentNode<TranslateQuestionTextMutation, TranslateQuestionTextMutationVariables>;
export const TranslateQuestionDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TranslateQuestionDescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newValue"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"polls_question_set_input"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_polls_question_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newValue"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translated_description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}}]}}]} as unknown as DocumentNode<TranslateQuestionDescriptionMutation, TranslateQuestionDescriptionMutationVariables>;
export const QuestionTranslationProgressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"QuestionTranslationProgress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_question_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translation_progress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}]}}]}}]} as unknown as DocumentNode<QuestionTranslationProgressSubscription, QuestionTranslationProgressSubscriptionVariables>;
export const PollDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Poll"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_poll_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"release_notes"}},{"kind":"Field","name":{"kind":"Name","value":"required_entry_tag_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entrytaggroup_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"optional_entry_tag_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entrytaggroup_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"branching_questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"branches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tooltip"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parent_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parent_question_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"question"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parent_question_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"question"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"parent_question_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"question"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryTagGroups"}}]}},...QuestionFragmentDoc.definitions,...QuestionDetailsFragmentDoc.definitions,...AnswerInputFragmentDoc.definitions,...EntryTagGroupsFragmentDoc.definitions]} as unknown as DocumentNode<PollQuery, PollQueryVariables>;
export const PollDuplicateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PollDuplicate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_poll_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"release_notes"}},{"kind":"Field","name":{"kind":"Name","value":"required_entry_tag_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entrytaggroup_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"optional_entry_tag_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entrytaggroup_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"branching_questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"branches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tooltip"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parent_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parent_question_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"questionDuplicate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parent_question_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"questionDuplicate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"parent_question_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"questionDuplicate"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"polls_question"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"poll_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"polls_templateanswerset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"questions"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"poll_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"answers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AnswerInput"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},...QuestionDuplicateFragmentDoc.definitions,...QuestionDetailsDuplicateFragmentDoc.definitions,...AnswerInputFragmentDoc.definitions]} as unknown as DocumentNode<PollDuplicateQuery, PollDuplicateQueryVariables>;
export const PollManager_PollsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PollManager_Polls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_poll"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date_created"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PollManager_Polls_Poll"}}]}}]}},...PollManager_Polls_PollFragmentDoc.definitions]} as unknown as DocumentNode<PollManager_PollsQuery, PollManager_PollsQueryVariables>;
export const PollManager_Poll_EnablePollDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PollManager_Poll_EnablePoll"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pollId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enable_poll"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"poll_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pollId"}}}]}]}}]} as unknown as DocumentNode<PollManager_Poll_EnablePollMutation, PollManager_Poll_EnablePollMutationVariables>;
export const PollManager_Poll_DisablePollDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PollManager_Poll_DisablePoll"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pollId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disable_poll"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"poll_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pollId"}}}]}]}}]} as unknown as DocumentNode<PollManager_Poll_DisablePollMutation, PollManager_Poll_DisablePollMutationVariables>;
export const UserIdByUsernameQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserIdByUsernameQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auth_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"username"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UserIdByUsernameQueryQuery, UserIdByUsernameQueryQueryVariables>;
export const PublicProfileQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PublicProfileQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"user"},"name":{"kind":"Name","value":"auth_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicProfile_Profile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicProfile_Contributions"}}]}}]}},...PublicProfile_ProfileFragmentDoc.definitions,...PublicProfile_Profile_InterestsFragmentDoc.definitions,...PublicProfile_Profile_RoleFragmentDoc.definitions,...PublicProfile_ContributionsFragmentDoc.definitions,...PublicProfile_Contributions_EntryFragmentDoc.definitions,...EntryProgressFragmentDoc.definitions]} as unknown as DocumentNode<PublicProfileQueryQuery, PublicProfileQueryQueryVariables>;
export const Settings_AccountSettings_SetProfileLanguageMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Settings_AccountSettings_SetProfileLanguageMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_accounts_profile_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]} as unknown as DocumentNode<Settings_AccountSettings_SetProfileLanguageMutationMutation, Settings_AccountSettings_SetProfileLanguageMutationMutationVariables>;
export const Settings_ProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Settings_Profile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auth_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"occupation"}},{"kind":"Field","name":{"kind":"Name","value":"institution"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"area_of_research"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"biography"}},{"kind":"Field","name":{"kind":"Name","value":"websites"}},{"kind":"Field","name":{"kind":"Name","value":"interests"}}]}}]}}]}}]} as unknown as DocumentNode<Settings_ProfileQuery, Settings_ProfileQueryVariables>;
export const Settings_Profile_MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Settings_Profile_Mutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"occupation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"institution"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"department"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"areaOfResearch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"position"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"biography"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interests"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"_varchar"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"websites"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_auth_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"last_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_accounts_profile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occupation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"occupation"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"institution"},"value":{"kind":"Variable","name":{"kind":"Name","value":"institution"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"Variable","name":{"kind":"Name","value":"department"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"area_of_research"},"value":{"kind":"Variable","name":{"kind":"Name","value":"areaOfResearch"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"position"},"value":{"kind":"Variable","name":{"kind":"Name","value":"position"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"location"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"biography"},"value":{"kind":"Variable","name":{"kind":"Name","value":"biography"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"interests"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interests"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"websites"},"value":{"kind":"Variable","name":{"kind":"Name","value":"websites"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Settings_Profile_MutationMutation, Settings_Profile_MutationMutationVariables>;
export const SignUp_EditorSelectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SignUp_EditorSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SignUp_SignUpForm_EditorList_RegionalEditorList"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SignUp_SignUpForm_EditorList_ExternalEditorList"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SignUp_SignUpForm_EditorList_ManagingEditorList"}}]}},...SignUp_SignUpForm_EditorList_RegionalEditorListFragmentDoc.definitions,...SignUp_SignUpForm_EditorSelect_RegionalEditorFragmentDoc.definitions,...SignUp_SignUpForm_EditorSelect_EditorUserFragmentDoc.definitions,...SignUp_SignUpForm_EditorList_ExternalEditorListFragmentDoc.definitions,...SignUp_SignUpForm_EditorList_ManagingEditorListFragmentDoc.definitions,...SignUp_SignUpForm_EditorSelect_ManagingEditorFragmentDoc.definitions]} as unknown as DocumentNode<SignUp_EditorSelectQuery, SignUp_EditorSelectQueryVariables>;
export const YearFromQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"YearFromQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_baseanswerset_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year_from"}}]}}]}}]}}]}}]} as unknown as DocumentNode<YearFromQueryQuery, YearFromQueryQueryVariables>;
export const YearFromAndSearchQueryIdQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"YearFromAndSearchQueryIdQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchQueryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_baseanswerset_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year_from"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"polls_searchrequest_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchQueryId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<YearFromAndSearchQueryIdQueryQuery, YearFromAndSearchQueryIdQueryQueryVariables>;
export const OverallCoverage_EntryListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OverallCoverage_EntryList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"regionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gis_regions_gis_region_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"regionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date_modified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"progress"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date_modified"}},{"kind":"Field","name":{"kind":"Name","value":"poll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"year_from"}},{"kind":"Field","name":{"kind":"Name","value":"year_to"}}]}}]}}]}}]} as unknown as DocumentNode<OverallCoverage_EntryListQuery, OverallCoverage_EntryListQueryVariables>;
export const OverallCoverage_DataSourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OverallCoverage_DataSources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_datasource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entities"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"progress"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<OverallCoverage_DataSourcesQuery, OverallCoverage_DataSourcesQueryVariables>;
export const OverallCoverage_PollsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OverallCoverage_Polls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"polls_poll"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entries"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"progress"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translated_name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}]}}]}}]} as unknown as DocumentNode<OverallCoverage_PollsQuery, OverallCoverage_PollsQueryVariables>;
export const OverallCoverage_GisRegionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OverallCoverage_GisRegions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"regions"},"name":{"kind":"Name","value":"gis_regions_gis_region"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entries"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"progress"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"base_answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"answer_count"},"name":{"kind":"Name","value":"base_answer_sets_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"answer_sets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"year_range"},"name":{"kind":"Name","value":"entries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"progress"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year_from"}}]}},{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year_to"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"poll_ids"},"name":{"kind":"Name","value":"entries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"progress"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"poll_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"poll_id"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"entry_source_ids"},"name":{"kind":"Name","value":"entries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"progress"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"entry_source"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entry_source"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"data_source_ids"},"name":{"kind":"Name","value":"entries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"progress"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"data_source_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data_source_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"geom"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"min_year_from"},"name":{"kind":"Name","value":"polls_entity_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"progress"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year_from"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OverallCoverage_GisRegionsQuery, OverallCoverage_GisRegionsQueryVariables>;
export const CurrentUserQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentUserQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"user"},"name":{"kind":"Name","value":"auth_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"approved_attachments_conditions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expert"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approved"}},{"kind":"Field","name":{"kind":"Name","value":"confirmed_agreement"}}]}}]}}]}}]} as unknown as DocumentNode<CurrentUserQueryQuery, CurrentUserQueryQueryVariables>;
export const AvatarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Avatar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"size"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatar"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"size"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<AvatarQuery, AvatarQueryVariables>;
export const SearchReferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchReferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference_search_connection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csl_json"}},{"kind":"Field","name":{"kind":"Name","value":"highlight"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"crossref_search_connection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csl_json"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchReferencesQuery, SearchReferencesQueryVariables>;